import Gt, { useState as ua, useEffect as Da, useId as th, useRef as Do, createElement as m1, Component as T1, forwardRef as p1, createContext as S1, useImperativeHandle as x1, useCallback as Ds } from "react";
import jg from "react-dom";
function em(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
var ig = { exports: {} }, kf = {};
var Iy;
function E1() {
  if (Iy) return kf;
  Iy = 1;
  var a = Symbol.for("react.transitional.element"), o = Symbol.for("react.fragment");
  function f(v, y, T) {
    var w = null;
    if (T !== void 0 && (w = "" + T), y.key !== void 0 && (w = "" + y.key), "key" in y) {
      T = {};
      for (var O in y)
        O !== "key" && (T[O] = y[O]);
    } else T = y;
    return y = T.ref, {
      $$typeof: a,
      type: v,
      key: w,
      ref: y !== void 0 ? y : null,
      props: T
    };
  }
  return kf.Fragment = o, kf.jsx = f, kf.jsxs = f, kf;
}
var Zy;
function w1() {
  return Zy || (Zy = 1, ig.exports = E1()), ig.exports;
}
var A = w1(), rg = { exports: {} }, ug, Vy;
function A1() {
  if (Vy) return ug;
  Vy = 1;
  var a = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ug = a, ug;
}
var cg, Qy;
function O1() {
  if (Qy) return cg;
  Qy = 1;
  var a = /* @__PURE__ */ A1();
  function o() {
  }
  function f() {
  }
  return f.resetWarningCache = o, cg = function() {
    function v(w, O, _, z, H, Z) {
      if (Z !== a) {
        var Y = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw Y.name = "Invariant Violation", Y;
      }
    }
    v.isRequired = v;
    function y() {
      return v;
    }
    var T = {
      array: v,
      bigint: v,
      bool: v,
      func: v,
      number: v,
      object: v,
      string: v,
      symbol: v,
      any: v,
      arrayOf: y,
      element: v,
      elementType: v,
      instanceOf: y,
      node: v,
      objectOf: y,
      oneOf: y,
      oneOfType: y,
      shape: y,
      exact: y,
      checkPropTypes: f,
      resetWarningCache: o
    };
    return T.PropTypes = T, T;
  }, cg;
}
var Wy;
function C1() {
  return Wy || (Wy = 1, rg.exports = /* @__PURE__ */ O1()()), rg.exports;
}
var R1 = /* @__PURE__ */ C1();
const E = /* @__PURE__ */ em(R1), _1 = () => {
  const [a, o] = ua(null), [f, v] = ua(!1), [y, T] = ua(null), [w, O] = ua("");
  return Da(() => {
    if (!w) return;
    (() => {
      T(null), v(!0);
      try {
        fetch(w).then((z) => z.json()).then((z) => {
          o(z), v(!1);
        }).catch((z) => {
          T(z), v(!1);
        });
      } catch (z) {
        T(z);
      }
    })();
  }, [w]), [{ data: a, loading: f, error: y }, O];
};
function N1(a) {
  const [o, f] = ua(!1);
  return Da(() => {
    const v = window.matchMedia(a);
    v.matches !== o && f(v.matches);
    const y = () => {
      f(v.matches);
    };
    return v.addEventListener("change", y), () => v.removeEventListener("change", y);
  }, [o, a]), o;
}
const Py = (a, o, f) => a ? o : f, Ud = (a) => (a || []).join(" ");
function Jy(a, o) {
  (o == null || o > a.length) && (o = a.length);
  for (var f = 0, v = Array(o); f < o; f++) v[f] = a[f];
  return v;
}
function M1(a) {
  if (Array.isArray(a)) return a;
}
function z1(a, o) {
  var f = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (f != null) {
    var v, y, T, w, O = [], _ = !0, z = !1;
    try {
      if (T = (f = f.call(a)).next, o !== 0) for (; !(_ = (v = T.call(f)).done) && (O.push(v.value), O.length !== o); _ = !0) ;
    } catch (H) {
      z = !0, y = H;
    } finally {
      try {
        if (!_ && f.return != null && (w = f.return(), Object(w) !== w)) return;
      } finally {
        if (z) throw y;
      }
    }
    return O;
  }
}
function D1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function k1(a, o) {
  return M1(a) || z1(a, o) || L1(a, o) || D1();
}
function L1(a, o) {
  if (a) {
    if (typeof a == "string") return Jy(a, o);
    var f = {}.toString.call(a).slice(8, -1);
    return f === "Object" && a.constructor && (f = a.constructor.name), f === "Map" || f === "Set" ? Array.from(a) : f === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(f) ? Jy(a, o) : void 0;
  }
}
const tm = Object.entries, Ky = Object.setPrototypeOf, B1 = Object.isFrozen, H1 = Object.getPrototypeOf, U1 = Object.getOwnPropertyDescriptor;
let La = Object.freeze, ji = Object.seal, zs = Object.create, nm = typeof Reflect < "u" && Reflect, Cg = nm.apply, Rg = nm.construct;
La || (La = function(o) {
  return o;
});
ji || (ji = function(o) {
  return o;
});
Cg || (Cg = function(o, f) {
  for (var v = arguments.length, y = new Array(v > 2 ? v - 2 : 0), T = 2; T < v; T++)
    y[T - 2] = arguments[T];
  return o.apply(f, y);
});
Rg || (Rg = function(o) {
  for (var f = arguments.length, v = new Array(f > 1 ? f - 1 : 0), y = 1; y < f; y++)
    v[y - 1] = arguments[y];
  return new o(...v);
});
const Cs = vl(Array.prototype.forEach), F1 = vl(Array.prototype.lastIndexOf), jy = vl(Array.prototype.pop), Rs = vl(Array.prototype.push), Y1 = vl(Array.prototype.splice), za = Array.isArray, Ff = vl(String.prototype.toLowerCase), og = vl(String.prototype.toString), qy = vl(String.prototype.match), _s = vl(String.prototype.replace), $y = vl(String.prototype.indexOf), G1 = vl(String.prototype.trim), X1 = vl(Number.prototype.toString), I1 = vl(Boolean.prototype.toString), eb = typeof BigInt > "u" ? null : vl(BigInt.prototype.toString), tb = typeof Symbol > "u" ? null : vl(Symbol.prototype.toString), Jn = vl(Object.prototype.hasOwnProperty), Lf = vl(Object.prototype.toString), ia = vl(RegExp.prototype.test), Nd = Z1(TypeError);
function vl(a) {
  return function(o) {
    o instanceof RegExp && (o.lastIndex = 0);
    for (var f = arguments.length, v = new Array(f > 1 ? f - 1 : 0), y = 1; y < f; y++)
      v[y - 1] = arguments[y];
    return Cg(a, o, v);
  };
}
function Z1(a) {
  return function() {
    for (var o = arguments.length, f = new Array(o), v = 0; v < o; v++)
      f[v] = arguments[v];
    return Rg(a, f);
  };
}
function rt(a, o) {
  let f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ff;
  if (Ky && Ky(a, null), !za(o))
    return a;
  let v = o.length;
  for (; v--; ) {
    let y = o[v];
    if (typeof y == "string") {
      const T = f(y);
      T !== y && (B1(o) || (o[v] = T), y = T);
    }
    a[y] = !0;
  }
  return a;
}
function V1(a) {
  for (let o = 0; o < a.length; o++)
    Jn(a, o) || (a[o] = null);
  return a;
}
function ii(a) {
  const o = zs(null);
  for (const v of tm(a)) {
    var f = k1(v, 2);
    const y = f[0], T = f[1];
    Jn(a, y) && (za(T) ? o[y] = V1(T) : T && typeof T == "object" && T.constructor === Object ? o[y] = ii(T) : o[y] = T);
  }
  return o;
}
function Q1(a) {
  switch (typeof a) {
    case "string":
      return a;
    case "number":
      return X1(a);
    case "boolean":
      return I1(a);
    case "bigint":
      return eb ? eb(a) : "0";
    case "symbol":
      return tb ? tb(a) : "Symbol()";
    case "undefined":
      return Lf(a);
    case "function":
    case "object": {
      if (a === null)
        return Lf(a);
      const o = a, f = Ro(o, "toString");
      if (typeof f == "function") {
        const v = f(o);
        return typeof v == "string" ? v : Lf(v);
      }
      return Lf(a);
    }
    default:
      return Lf(a);
  }
}
function Ro(a, o) {
  for (; a !== null; ) {
    const v = U1(a, o);
    if (v) {
      if (v.get)
        return vl(v.get);
      if (typeof v.value == "function")
        return vl(v.value);
    }
    a = H1(a);
  }
  function f() {
    return null;
  }
  return f;
}
function W1(a) {
  try {
    return ia(a, ""), !0;
  } catch {
    return !1;
  }
}
const nb = La(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), sg = La(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), fg = La(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), P1 = La(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), dg = La(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), J1 = La(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), lb = La(["#text"]), ab = La(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), hg = La(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), ib = La(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Md = La(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), K1 = ji(/{{[\w\W]*|^[\w\W]*}}/g), j1 = ji(/<%[\w\W]*|^[\w\W]*%>/g), q1 = ji(/\${[\w\W]*/g), $1 = ji(/^data-[\-\w.\u00B7-\uFFFF]+$/), eT = ji(/^aria-[\-\w]+$/), rb = ji(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), tT = ji(/^(?:\w+script|data):/i), nT = ji(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), lT = ji(/^html$/i), aT = ji(/^[a-z][.\w]*(-[.\w]+)+$/i), Ns = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, iT = function() {
  return typeof window > "u" ? null : window;
}, rT = function(o, f) {
  if (typeof o != "object" || typeof o.createPolicy != "function")
    return null;
  let v = null;
  const y = "data-tt-policy-suffix";
  f && f.hasAttribute(y) && (v = f.getAttribute(y));
  const T = "dompurify" + (v ? "#" + v : "");
  try {
    return o.createPolicy(T, {
      createHTML(w) {
        return w;
      },
      createScriptURL(w) {
        return w;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + T + " could not be created."), null;
  }
}, ub = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function lm() {
  let a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : iT();
  const o = (Re) => lm(Re);
  if (o.version = "3.4.5", o.removed = [], !a || !a.document || a.document.nodeType !== Ns.document || !a.Element)
    return o.isSupported = !1, o;
  let f = a.document;
  const v = f, y = v.currentScript, T = a.DocumentFragment, w = a.HTMLTemplateElement, O = a.Node, _ = a.Element, z = a.NodeFilter, H = a.NamedNodeMap, Z = H === void 0 ? a.NamedNodeMap || a.MozNamedAttrMap : H, Y = a.HTMLFormElement, ce = a.DOMParser, le = a.trustedTypes, K = _.prototype, he = Ro(K, "cloneNode"), ye = Ro(K, "remove"), de = Ro(K, "nextSibling"), ze = Ro(K, "childNodes"), ke = Ro(K, "parentNode"), pe = O && O.prototype ? Ro(O.prototype, "nodeType") : null;
  if (typeof w == "function") {
    const Re = f.createElement("template");
    Re.content && Re.content.ownerDocument && (f = Re.content.ownerDocument);
  }
  let xe, we = "";
  const Ce = f, Le = Ce.implementation, Ht = Ce.createNodeIterator, Et = Ce.createDocumentFragment, Xt = Ce.getElementsByTagName, Ee = v.importNode;
  let Ne = ub();
  o.isSupported = typeof tm == "function" && typeof ke == "function" && Le && Le.createHTMLDocument !== void 0;
  const lt = K1, U = j1, Q = q1, Se = $1, et = eT, re = tT, j = nT, ut = aT;
  let qe = rb, be = null;
  const Oe = rt({}, [...nb, ...sg, ...fg, ...dg, ...lb]);
  let $e = null;
  const Wt = rt({}, [...ab, ...hg, ...ib, ...Md]);
  let bt = Object.seal(zs(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Gn = null, An = null;
  const Dt = Object.seal(zs(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let wi = !0, Ye = !0, $i = !1, Il = !0, Zl = !1, _l = !0, nl = !1, rn = !1, Ai = !1, On = !1, Cn = !1, ca = !1, eu = !0, Ge = !1;
  const ll = "user-content-";
  let Er = !0, Ba = !1, Ut = {}, Nl = null;
  const Oi = rt({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let ri = null;
  const er = rt({}, ["audio", "video", "img", "source", "image", "track"]);
  let Ml = null;
  const Xn = rt({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), al = "http://www.w3.org/1998/Math/MathML", vn = "http://www.w3.org/2000/svg", zl = "http://www.w3.org/1999/xhtml";
  let wt = zl, yn = !1, Ha = null;
  const Vl = rt({}, [al, vn, zl], og);
  let Ua = rt({}, ["mi", "mo", "mn", "ms", "mtext"]), Dl = rt({}, ["annotation-xml"]);
  const Fa = rt({}, ["title", "style", "font", "a", "script"]);
  let bn = null;
  const Vu = ["application/xhtml+xml", "text/html"], tu = "text/html";
  let ln = null, Ql = null;
  const tr = f.createElement("form"), ui = function(k) {
    return k instanceof RegExp || k instanceof Function;
  }, un = function() {
    let k = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (Ql && Ql === k)
      return;
    (!k || typeof k != "object") && (k = {}), k = ii(k), bn = // eslint-disable-next-line unicorn/prefer-includes
    Vu.indexOf(k.PARSER_MEDIA_TYPE) === -1 ? tu : k.PARSER_MEDIA_TYPE, ln = bn === "application/xhtml+xml" ? og : Ff, be = Jn(k, "ALLOWED_TAGS") && za(k.ALLOWED_TAGS) ? rt({}, k.ALLOWED_TAGS, ln) : Oe, $e = Jn(k, "ALLOWED_ATTR") && za(k.ALLOWED_ATTR) ? rt({}, k.ALLOWED_ATTR, ln) : Wt, Ha = Jn(k, "ALLOWED_NAMESPACES") && za(k.ALLOWED_NAMESPACES) ? rt({}, k.ALLOWED_NAMESPACES, og) : Vl, Ml = Jn(k, "ADD_URI_SAFE_ATTR") && za(k.ADD_URI_SAFE_ATTR) ? rt(ii(Xn), k.ADD_URI_SAFE_ATTR, ln) : Xn, ri = Jn(k, "ADD_DATA_URI_TAGS") && za(k.ADD_DATA_URI_TAGS) ? rt(ii(er), k.ADD_DATA_URI_TAGS, ln) : er, Nl = Jn(k, "FORBID_CONTENTS") && za(k.FORBID_CONTENTS) ? rt({}, k.FORBID_CONTENTS, ln) : Oi, Gn = Jn(k, "FORBID_TAGS") && za(k.FORBID_TAGS) ? rt({}, k.FORBID_TAGS, ln) : ii({}), An = Jn(k, "FORBID_ATTR") && za(k.FORBID_ATTR) ? rt({}, k.FORBID_ATTR, ln) : ii({}), Ut = Jn(k, "USE_PROFILES") ? k.USE_PROFILES && typeof k.USE_PROFILES == "object" ? ii(k.USE_PROFILES) : k.USE_PROFILES : !1, wi = k.ALLOW_ARIA_ATTR !== !1, Ye = k.ALLOW_DATA_ATTR !== !1, $i = k.ALLOW_UNKNOWN_PROTOCOLS || !1, Il = k.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Zl = k.SAFE_FOR_TEMPLATES || !1, _l = k.SAFE_FOR_XML !== !1, nl = k.WHOLE_DOCUMENT || !1, On = k.RETURN_DOM || !1, Cn = k.RETURN_DOM_FRAGMENT || !1, ca = k.RETURN_TRUSTED_TYPE || !1, Ai = k.FORCE_BODY || !1, eu = k.SANITIZE_DOM !== !1, Ge = k.SANITIZE_NAMED_PROPS || !1, Er = k.KEEP_CONTENT !== !1, Ba = k.IN_PLACE || !1, qe = W1(k.ALLOWED_URI_REGEXP) ? k.ALLOWED_URI_REGEXP : rb, wt = typeof k.NAMESPACE == "string" ? k.NAMESPACE : zl, Ua = Jn(k, "MATHML_TEXT_INTEGRATION_POINTS") && k.MATHML_TEXT_INTEGRATION_POINTS && typeof k.MATHML_TEXT_INTEGRATION_POINTS == "object" ? ii(k.MATHML_TEXT_INTEGRATION_POINTS) : rt({}, ["mi", "mo", "mn", "ms", "mtext"]), Dl = Jn(k, "HTML_INTEGRATION_POINTS") && k.HTML_INTEGRATION_POINTS && typeof k.HTML_INTEGRATION_POINTS == "object" ? ii(k.HTML_INTEGRATION_POINTS) : rt({}, ["annotation-xml"]);
    const ue = Jn(k, "CUSTOM_ELEMENT_HANDLING") && k.CUSTOM_ELEMENT_HANDLING && typeof k.CUSTOM_ELEMENT_HANDLING == "object" ? ii(k.CUSTOM_ELEMENT_HANDLING) : zs(null);
    if (bt = zs(null), Jn(ue, "tagNameCheck") && ui(ue.tagNameCheck) && (bt.tagNameCheck = ue.tagNameCheck), Jn(ue, "attributeNameCheck") && ui(ue.attributeNameCheck) && (bt.attributeNameCheck = ue.attributeNameCheck), Jn(ue, "allowCustomizedBuiltInElements") && typeof ue.allowCustomizedBuiltInElements == "boolean" && (bt.allowCustomizedBuiltInElements = ue.allowCustomizedBuiltInElements), Zl && (Ye = !1), Cn && (On = !0), Ut && (be = rt({}, lb), $e = zs(null), Ut.html === !0 && (rt(be, nb), rt($e, ab)), Ut.svg === !0 && (rt(be, sg), rt($e, hg), rt($e, Md)), Ut.svgFilters === !0 && (rt(be, fg), rt($e, hg), rt($e, Md)), Ut.mathMl === !0 && (rt(be, dg), rt($e, ib), rt($e, Md))), Dt.tagCheck = null, Dt.attributeCheck = null, Jn(k, "ADD_TAGS") && (typeof k.ADD_TAGS == "function" ? Dt.tagCheck = k.ADD_TAGS : za(k.ADD_TAGS) && (be === Oe && (be = ii(be)), rt(be, k.ADD_TAGS, ln))), Jn(k, "ADD_ATTR") && (typeof k.ADD_ATTR == "function" ? Dt.attributeCheck = k.ADD_ATTR : za(k.ADD_ATTR) && ($e === Wt && ($e = ii($e)), rt($e, k.ADD_ATTR, ln))), Jn(k, "ADD_URI_SAFE_ATTR") && za(k.ADD_URI_SAFE_ATTR) && rt(Ml, k.ADD_URI_SAFE_ATTR, ln), Jn(k, "FORBID_CONTENTS") && za(k.FORBID_CONTENTS) && (Nl === Oi && (Nl = ii(Nl)), rt(Nl, k.FORBID_CONTENTS, ln)), Jn(k, "ADD_FORBID_CONTENTS") && za(k.ADD_FORBID_CONTENTS) && (Nl === Oi && (Nl = ii(Nl)), rt(Nl, k.ADD_FORBID_CONTENTS, ln)), Er && (be["#text"] = !0), nl && rt(be, ["html", "head", "body"]), be.table && (rt(be, ["tbody"]), delete Gn.tbody), k.TRUSTED_TYPES_POLICY) {
      if (typeof k.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw Nd('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof k.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw Nd('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      xe = k.TRUSTED_TYPES_POLICY, we = xe.createHTML("");
    } else
      xe === void 0 && (xe = rT(le, y)), xe !== null && typeof we == "string" && (we = xe.createHTML(""));
    La && La(k), Ql = k;
  }, il = rt({}, [...sg, ...fg, ...P1]), kt = rt({}, [...dg, ...J1]), Ci = function(k) {
    let ue = ke(k);
    (!ue || !ue.tagName) && (ue = {
      namespaceURI: wt,
      tagName: "template"
    });
    const ge = Ff(k.tagName), Fe = Ff(ue.tagName);
    return Ha[k.namespaceURI] ? k.namespaceURI === vn ? ue.namespaceURI === zl ? ge === "svg" : ue.namespaceURI === al ? ge === "svg" && (Fe === "annotation-xml" || Ua[Fe]) : !!il[ge] : k.namespaceURI === al ? ue.namespaceURI === zl ? ge === "math" : ue.namespaceURI === vn ? ge === "math" && Dl[Fe] : !!kt[ge] : k.namespaceURI === zl ? ue.namespaceURI === vn && !Dl[Fe] || ue.namespaceURI === al && !Ua[Fe] ? !1 : !kt[ge] && (Fa[ge] || !il[ge]) : !!(bn === "application/xhtml+xml" && Ha[k.namespaceURI]) : !1;
  }, It = function(k) {
    Rs(o.removed, {
      element: k
    });
    try {
      ke(k).removeChild(k);
    } catch {
      ye(k);
    }
  }, mt = function(k, ue) {
    try {
      Rs(o.removed, {
        attribute: ue.getAttributeNode(k),
        from: ue
      });
    } catch {
      Rs(o.removed, {
        attribute: null,
        from: ue
      });
    }
    if (ue.removeAttribute(k), k === "is")
      if (On || Cn)
        try {
          It(ue);
        } catch {
        }
      else
        try {
          ue.setAttribute(k, "");
        } catch {
        }
  }, oa = function(k) {
    let ue = null, ge = null;
    if (Ai)
      k = "<remove></remove>" + k;
    else {
      const Nt = qy(k, /^[\r\n\t ]+/);
      ge = Nt && Nt[0];
    }
    bn === "application/xhtml+xml" && wt === zl && (k = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + k + "</body></html>");
    const Fe = xe ? xe.createHTML(k) : k;
    if (wt === zl)
      try {
        ue = new ce().parseFromString(Fe, bn);
      } catch {
      }
    if (!ue || !ue.documentElement) {
      ue = Le.createDocument(wt, "template", null);
      try {
        ue.documentElement.innerHTML = yn ? we : Fe;
      } catch {
      }
    }
    const At = ue.body || ue.documentElement;
    return k && ge && At.insertBefore(f.createTextNode(ge), At.childNodes[0] || null), wt === zl ? Xt.call(ue, nl ? "html" : "body")[0] : nl ? ue.documentElement : At;
  }, mn = function(k) {
    return Ht.call(
      k.ownerDocument || k,
      k,
      // eslint-disable-next-line no-bitwise
      z.SHOW_ELEMENT | z.SHOW_COMMENT | z.SHOW_TEXT | z.SHOW_PROCESSING_INSTRUCTION | z.SHOW_CDATA_SECTION,
      null
    );
  }, zn = function(k) {
    k.normalize();
    const ue = Ht.call(
      k.ownerDocument || k,
      k,
      // eslint-disable-next-line no-bitwise
      z.SHOW_TEXT | z.SHOW_COMMENT | z.SHOW_CDATA_SECTION | z.SHOW_PROCESSING_INSTRUCTION,
      null
    );
    let ge = ue.nextNode();
    for (; ge; ) {
      let Fe = ge.data;
      Cs([lt, U, Q], (At) => {
        Fe = _s(Fe, At, " ");
      }), ge.data = Fe, ge = ue.nextNode();
    }
  }, Ta = function(k) {
    return k instanceof Y && (typeof k.nodeName != "string" || typeof k.textContent != "string" || typeof k.removeChild != "function" || !(k.attributes instanceof Z) || typeof k.removeAttribute != "function" || typeof k.setAttribute != "function" || typeof k.namespaceURI != "string" || typeof k.insertBefore != "function" || typeof k.hasChildNodes != "function");
  }, sa = function(k) {
    if (!pe || typeof k != "object" || k === null)
      return !1;
    try {
      return typeof pe(k) == "number";
    } catch {
      return !1;
    }
  };
  function fa(Re, k, ue) {
    Cs(Re, (ge) => {
      ge.call(o, k, ue, Ql);
    });
  }
  const Tt = function(k) {
    let ue = null;
    if (fa(Ne.beforeSanitizeElements, k, null), Ta(k))
      return It(k), !0;
    const ge = ln(k.nodeName);
    if (fa(Ne.uponSanitizeElement, k, {
      tagName: ge,
      allowedTags: be
    }), _l && k.hasChildNodes() && !sa(k.firstElementChild) && ia(/<[/\w!]/g, k.innerHTML) && ia(/<[/\w!]/g, k.textContent) || _l && k.namespaceURI === zl && ge === "style" && sa(k.firstElementChild) || k.nodeType === Ns.progressingInstruction || _l && k.nodeType === Ns.comment && ia(/<[/\w]/g, k.data))
      return It(k), !0;
    if (Gn[ge] || !(Dt.tagCheck instanceof Function && Dt.tagCheck(ge)) && !be[ge]) {
      if (!Gn[ge] && In(ge) && (bt.tagNameCheck instanceof RegExp && ia(bt.tagNameCheck, ge) || bt.tagNameCheck instanceof Function && bt.tagNameCheck(ge)))
        return !1;
      if (Er && !Nl[ge]) {
        const Fe = ke(k) || k.parentNode, At = ze(k) || k.childNodes;
        if (At && Fe) {
          const Nt = At.length;
          for (let Rn = Nt - 1; Rn >= 0; --Rn) {
            const xa = he(At[Rn], !0);
            Fe.insertBefore(xa, de(k));
          }
        }
      }
      return It(k), !0;
    }
    return k instanceof _ && !Ci(k) || (ge === "noscript" || ge === "noembed" || ge === "noframes") && ia(/<\/no(script|embed|frames)/i, k.innerHTML) ? (It(k), !0) : (Zl && k.nodeType === Ns.text && (ue = k.textContent, Cs([lt, U, Q], (Fe) => {
      ue = _s(ue, Fe, " ");
    }), k.textContent !== ue && (Rs(o.removed, {
      element: k.cloneNode()
    }), k.textContent = ue)), fa(Ne.afterSanitizeElements, k, null), !1);
  }, _t = function(k, ue, ge) {
    if (An[ue] || eu && (ue === "id" || ue === "name") && (ge in f || ge in tr))
      return !1;
    const Fe = $e[ue] || Dt.attributeCheck instanceof Function && Dt.attributeCheck(ue, k);
    if (!(Ye && !An[ue] && ia(Se, ue))) {
      if (!(wi && ia(et, ue))) {
        if (!Fe || An[ue]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(In(k) && (bt.tagNameCheck instanceof RegExp && ia(bt.tagNameCheck, k) || bt.tagNameCheck instanceof Function && bt.tagNameCheck(k)) && (bt.attributeNameCheck instanceof RegExp && ia(bt.attributeNameCheck, ue) || bt.attributeNameCheck instanceof Function && bt.attributeNameCheck(ue, k)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            ue === "is" && bt.allowCustomizedBuiltInElements && (bt.tagNameCheck instanceof RegExp && ia(bt.tagNameCheck, ge) || bt.tagNameCheck instanceof Function && bt.tagNameCheck(ge)))
          ) return !1;
        } else if (!Ml[ue]) {
          if (!ia(qe, _s(ge, j, ""))) {
            if (!((ue === "src" || ue === "xlink:href" || ue === "href") && k !== "script" && $y(ge, "data:") === 0 && ri[k])) {
              if (!($i && !ia(re, _s(ge, j, "")))) {
                if (ge)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, pa = rt({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), In = function(k) {
    return !pa[Ff(k)] && ia(ut, k);
  }, ci = function(k) {
    fa(Ne.beforeSanitizeAttributes, k, null);
    const ue = k.attributes;
    if (!ue || Ta(k))
      return;
    const ge = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: $e,
      forceKeepAttr: void 0
    };
    let Fe = ue.length;
    for (; Fe--; ) {
      const At = ue[Fe], Nt = At.name, Rn = At.namespaceURI, xa = At.value, Ea = ln(Nt), Wl = xa;
      let Zt = Nt === "value" ? Wl : G1(Wl);
      if (ge.attrName = Ea, ge.attrValue = Zt, ge.keepAttr = !0, ge.forceKeepAttr = void 0, fa(Ne.uponSanitizeAttribute, k, ge), Zt = ge.attrValue, Ge && (Ea === "id" || Ea === "name") && $y(Zt, ll) !== 0 && (mt(Nt, k), Zt = ll + Zt), _l && ia(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, Zt)) {
        mt(Nt, k);
        continue;
      }
      if (Ea === "attributename" && qy(Zt, "href")) {
        mt(Nt, k);
        continue;
      }
      if (ge.forceKeepAttr)
        continue;
      if (!ge.keepAttr) {
        mt(Nt, k);
        continue;
      }
      if (!Il && ia(/\/>/i, Zt)) {
        mt(Nt, k);
        continue;
      }
      Zl && Cs([lt, U, Q], (cn) => {
        Zt = _s(Zt, cn, " ");
      });
      const bl = ln(k.nodeName);
      if (!_t(bl, Ea, Zt)) {
        mt(Nt, k);
        continue;
      }
      if (xe && typeof le == "object" && typeof le.getAttributeType == "function" && !Rn)
        switch (le.getAttributeType(bl, Ea)) {
          case "TrustedHTML": {
            Zt = xe.createHTML(Zt);
            break;
          }
          case "TrustedScriptURL": {
            Zt = xe.createScriptURL(Zt);
            break;
          }
        }
      if (Zt !== Wl)
        try {
          Rn ? k.setAttributeNS(Rn, Nt, Zt) : k.setAttribute(Nt, Zt), Ta(k) ? It(k) : jy(o.removed);
        } catch {
          mt(Nt, k);
        }
    }
    fa(Ne.afterSanitizeAttributes, k, null);
  }, da = function(k) {
    let ue = null;
    const ge = mn(k);
    for (fa(Ne.beforeSanitizeShadowDOM, k, null); ue = ge.nextNode(); )
      fa(Ne.uponSanitizeShadowNode, ue, null), Tt(ue), ci(ue), ue.content instanceof T && da(ue.content);
    fa(Ne.afterSanitizeShadowDOM, k, null);
  }, Sa = function(k) {
    if (k.nodeType === Ns.element && k.shadowRoot instanceof T) {
      const Fe = k.shadowRoot;
      Sa(Fe), da(Fe);
    }
    const ue = k.childNodes;
    if (!ue)
      return;
    const ge = [];
    Cs(ue, (Fe) => {
      Rs(ge, Fe);
    });
    for (const Fe of ge)
      Sa(Fe);
  };
  return o.sanitize = function(Re) {
    let k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ue = null, ge = null, Fe = null, At = null;
    if (yn = !Re, yn && (Re = "<!-->"), typeof Re != "string" && !sa(Re) && (Re = Q1(Re), typeof Re != "string"))
      throw Nd("dirty is not a string, aborting");
    if (!o.isSupported)
      return Re;
    if (rn || un(k), o.removed = [], typeof Re == "string" && (Ba = !1), Ba) {
      const xa = Re.nodeName;
      if (typeof xa == "string") {
        const Ea = ln(xa);
        if (!be[Ea] || Gn[Ea])
          throw Nd("root node is forbidden and cannot be sanitized in-place");
      }
      Sa(Re);
    } else if (sa(Re))
      ue = oa("<!---->"), ge = ue.ownerDocument.importNode(Re, !0), ge.nodeType === Ns.element && ge.nodeName === "BODY" || ge.nodeName === "HTML" ? ue = ge : ue.appendChild(ge), Sa(ge);
    else {
      if (!On && !Zl && !nl && // eslint-disable-next-line unicorn/prefer-includes
      Re.indexOf("<") === -1)
        return xe && ca ? xe.createHTML(Re) : Re;
      if (ue = oa(Re), !ue)
        return On ? null : ca ? we : "";
    }
    ue && Ai && It(ue.firstChild);
    const Nt = mn(Ba ? Re : ue);
    for (; Fe = Nt.nextNode(); )
      Tt(Fe), ci(Fe), Fe.content instanceof T && da(Fe.content);
    if (Ba)
      return Zl && zn(Re), Re;
    if (On) {
      if (Zl && zn(ue), Cn)
        for (At = Et.call(ue.ownerDocument); ue.firstChild; )
          At.appendChild(ue.firstChild);
      else
        At = ue;
      return ($e.shadowroot || $e.shadowrootmode) && (At = Ee.call(v, At, !0)), At;
    }
    let Rn = nl ? ue.outerHTML : ue.innerHTML;
    return nl && be["!doctype"] && ue.ownerDocument && ue.ownerDocument.doctype && ue.ownerDocument.doctype.name && ia(lT, ue.ownerDocument.doctype.name) && (Rn = "<!DOCTYPE " + ue.ownerDocument.doctype.name + `>
` + Rn), Zl && Cs([lt, U, Q], (xa) => {
      Rn = _s(Rn, xa, " ");
    }), xe && ca ? xe.createHTML(Rn) : Rn;
  }, o.setConfig = function() {
    let Re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    un(Re), rn = !0;
  }, o.clearConfig = function() {
    Ql = null, rn = !1;
  }, o.isValidAttribute = function(Re, k, ue) {
    Ql || un({});
    const ge = ln(Re), Fe = ln(k);
    return _t(ge, Fe, ue);
  }, o.addHook = function(Re, k) {
    typeof k == "function" && Rs(Ne[Re], k);
  }, o.removeHook = function(Re, k) {
    if (k !== void 0) {
      const ue = F1(Ne[Re], k);
      return ue === -1 ? void 0 : Y1(Ne[Re], ue, 1)[0];
    }
    return jy(Ne[Re]);
  }, o.removeHooks = function(Re) {
    Ne[Re] = [];
  }, o.removeAllHooks = function() {
    Ne = ub();
  }, o;
}
var cb = lm();
let zd = null;
function uT() {
  return zd || (typeof window < "u" ? zd = cb(window) : zd = cb), zd;
}
function cT(a) {
  const o = a ? document.querySelector(a) : document;
  return o ? o.querySelector(
    'button, [href], input, select, textarea, [tabIndex]:not([tabIndex="-1"])'
  ) : null;
}
const ka = (a) => ({ __html: uT().sanitize(a) }), ob = (a, o, f) => {
  let v = a;
  const y = [];
  for (; v < o; )
    v > 0 && v <= f && y.push(v), v += 1;
  return y;
};
let gg = !1;
const _g = (a, o) => {
  gg || (gg = !0, setTimeout(() => {
    a(), gg = !1;
  }, o));
};
let sb;
const Ng = (a, o) => {
  window.clearTimeout(sb), sb = window.setTimeout(a, o);
};
function oT(a) {
  if (a && typeof a.getBoundingClientRect == "function") {
    const { bottom: o, top: f } = a.getBoundingClientRect(), { offsetTop: v } = a;
    if (f < 0 && o > 0) {
      const y = a.style;
      a.style = `${y};transition: height 0s !important; overflow:hidden; height:${o}px!important;max-height:${o}px!important`, window.scrollTo({ behavior: "instant", top: v }), setTimeout(() => {
        a.style = y, window.scrollTo({
          behavior: "smooth",
          top: a.offsetTop - o / 2
        });
      }, 50);
    }
  }
}
E.shape({
  event: E.string,
  action: E.string,
  name: E.string,
  region: E.string,
  section: E.string,
  component: E.string,
  type: E.string,
  text: E.string
});
const am = ({
  event: a = "",
  action: o = "",
  name: f = "",
  type: v = "",
  section: y = "",
  text: T = "",
  region: w = "",
  component: O = ""
}) => {
  const { dataLayer: _ } = window, z = {
    event: a.toLowerCase(),
    action: o.toLowerCase(),
    name: f.toLowerCase(),
    type: v.toLowerCase(),
    region: w.toLowerCase(),
    section: y.toLowerCase(),
    text: T.toLowerCase(),
    component: O.toLowerCase()
  };
  _ && _.push(z);
}, Qf = ({ children: a }) => /* @__PURE__ */ A.jsx(A.Fragment, { children: a });
Qf.propTypes = {
  children: E.oneOfType([
    E.arrayOf(E.node),
    E.node,
    E.string
  ])
};
var vg = { exports: {} };
var fb;
function sT() {
  return fb || (fb = 1, (function(a) {
    (function() {
      var o = {}.hasOwnProperty;
      function f() {
        for (var T = "", w = 0; w < arguments.length; w++) {
          var O = arguments[w];
          O && (T = y(T, v(O)));
        }
        return T;
      }
      function v(T) {
        if (typeof T == "string" || typeof T == "number")
          return T;
        if (typeof T != "object")
          return "";
        if (Array.isArray(T))
          return f.apply(null, T);
        if (T.toString !== Object.prototype.toString && !T.toString.toString().includes("[native code]"))
          return T.toString();
        var w = "";
        for (var O in T)
          o.call(T, O) && T[O] && (w = y(w, O));
        return w;
      }
      function y(T, w) {
        return w ? T ? T + " " + w : T + w : T;
      }
      a.exports ? (f.default = f, a.exports = f) : window.classNames = f;
    })();
  })(vg)), vg.exports;
}
var fT = sT();
const Rt = /* @__PURE__ */ em(fT);
({
  ...Qf.propTypes
});
const im = ({ children: a, className: o = "container", ...f }) => /* @__PURE__ */ A.jsx("div", { className: o, ...f, children: /* @__PURE__ */ A.jsx("div", { className: "row", children: a }) });
im.propTypes = {
  children: Qf.propTypes.children
};
({
  ...im.propTypes
});
Qf.propTypes.children, E.oneOf(["0", "3", "4", "6", "8", "9", "12"]);
Qf.propTypes.children;
const dT = E.shape({
  url: E.string,
  altText: E.string,
  cssClass: E.arrayOf(E.string),
  size: E.oneOf(["small", "medium", "large"])
}), yg = E.shape({
  text: E.string,
  maxWidth: E.string,
  cssClass: E.arrayOf(E.string),
  highlightColor: E.oneOf(["gold", "black"])
}), rm = E.shape({
  color: E.oneOf(["gold", "maroon", "gray", "dark"]),
  content: E.shape({
    icon: E.arrayOf(E.string),
    header: E.string,
    body: E.string
  })
}), qg = E.shape({
  text: E.string,
  name: E.string,
  event: E.string,
  action: E.string,
  type: E.string,
  region: E.string,
  section: E.string,
  component: E.string
});
var Oo = {}, Bf = {};
var db;
function hT() {
  if (db) return Bf;
  db = 1;
  var a = Gt, o = jg;
  function f(r) {
    var c = "https://react.dev/errors/" + r;
    if (1 < arguments.length) {
      c += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var g = 2; g < arguments.length; g++)
        c += "&args[]=" + encodeURIComponent(arguments[g]);
    }
    return "Minified React error #" + r + "; visit " + c + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var v = Symbol.for("react.transitional.element"), y = Symbol.for("react.portal"), T = Symbol.for("react.fragment"), w = Symbol.for("react.strict_mode"), O = Symbol.for("react.profiler"), _ = Symbol.for("react.consumer"), z = Symbol.for("react.context"), H = Symbol.for("react.forward_ref"), Z = Symbol.for("react.suspense"), Y = Symbol.for("react.suspense_list"), ce = Symbol.for("react.memo"), le = Symbol.for("react.lazy"), K = Symbol.for("react.scope"), he = Symbol.for("react.activity"), ye = Symbol.for("react.legacy_hidden"), de = Symbol.for("react.memo_cache_sentinel"), ze = Symbol.for("react.view_transition"), ke = Symbol.iterator;
  function pe(r) {
    return r === null || typeof r != "object" ? null : (r = ke && r[ke] || r["@@iterator"], typeof r == "function" ? r : null);
  }
  var xe = Array.isArray;
  function we(r, c) {
    var g = r.length & 3, m = r.length - g, x = c;
    for (c = 0; c < m; ) {
      var N = r.charCodeAt(c) & 255 | (r.charCodeAt(++c) & 255) << 8 | (r.charCodeAt(++c) & 255) << 16 | (r.charCodeAt(++c) & 255) << 24;
      ++c, N = 3432918353 * (N & 65535) + ((3432918353 * (N >>> 16) & 65535) << 16) & 4294967295, N = N << 15 | N >>> 17, N = 461845907 * (N & 65535) + ((461845907 * (N >>> 16) & 65535) << 16) & 4294967295, x ^= N, x = x << 13 | x >>> 19, x = 5 * (x & 65535) + ((5 * (x >>> 16) & 65535) << 16) & 4294967295, x = (x & 65535) + 27492 + (((x >>> 16) + 58964 & 65535) << 16);
    }
    switch (N = 0, g) {
      case 3:
        N ^= (r.charCodeAt(c + 2) & 255) << 16;
      case 2:
        N ^= (r.charCodeAt(c + 1) & 255) << 8;
      case 1:
        N ^= r.charCodeAt(c) & 255, N = 3432918353 * (N & 65535) + ((3432918353 * (N >>> 16) & 65535) << 16) & 4294967295, N = N << 15 | N >>> 17, x ^= 461845907 * (N & 65535) + ((461845907 * (N >>> 16) & 65535) << 16) & 4294967295;
    }
    return x ^= r.length, x ^= x >>> 16, x = 2246822507 * (x & 65535) + ((2246822507 * (x >>> 16) & 65535) << 16) & 4294967295, x ^= x >>> 13, x = 3266489909 * (x & 65535) + ((3266489909 * (x >>> 16) & 65535) << 16) & 4294967295, (x ^ x >>> 16) >>> 0;
  }
  var Ce = Object.assign, Le = Object.prototype.hasOwnProperty, Ht = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), Et = {}, Xt = {};
  function Ee(r) {
    return Le.call(Xt, r) ? !0 : Le.call(Et, r) ? !1 : Ht.test(r) ? Xt[r] = !0 : (Et[r] = !0, !1);
  }
  var Ne = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  ), lt = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), U = /["'&<>]/;
  function Q(r) {
    if (typeof r == "boolean" || typeof r == "number" || typeof r == "bigint")
      return "" + r;
    r = "" + r;
    var c = U.exec(r);
    if (c) {
      var g = "", m, x = 0;
      for (m = c.index; m < r.length; m++) {
        switch (r.charCodeAt(m)) {
          case 34:
            c = "&quot;";
            break;
          case 38:
            c = "&amp;";
            break;
          case 39:
            c = "&#x27;";
            break;
          case 60:
            c = "&lt;";
            break;
          case 62:
            c = "&gt;";
            break;
          default:
            continue;
        }
        x !== m && (g += r.slice(x, m)), x = m + 1, g += c;
      }
      r = x !== m ? g + r.slice(x, m) : g;
    }
    return r;
  }
  var Se = /([A-Z])/g, et = /^ms-/, re = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function j(r) {
    return re.test("" + r) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : r;
  }
  var ut = a.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, qe = o.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, be = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, Oe = qe.d;
  qe.d = {
    f: Oe.f,
    r: Oe.r,
    D: pa,
    C: In,
    L: ci,
    m: da,
    X: Re,
    S: Sa,
    M: k
  };
  var $e = [], Wt = null, bt = /(<\/|<)(s)(cript)/gi;
  function Gn(r, c, g, m) {
    return "" + c + (g === "s" ? "\\u0073" : "\\u0053") + m;
  }
  function An(r, c, g, m, x) {
    return {
      idPrefix: r === void 0 ? "" : r,
      nextFormID: 0,
      streamingFormat: 0,
      bootstrapScriptContent: g,
      bootstrapScripts: m,
      bootstrapModules: x,
      instructions: 0,
      hasBody: !1,
      hasHtml: !1,
      unknownResources: {},
      dnsResources: {},
      connectResources: { default: {}, anonymous: {}, credentials: {} },
      imageResources: {},
      styleResources: {},
      scriptResources: {},
      moduleUnknownResources: {},
      moduleScriptResources: {}
    };
  }
  function Dt(r, c, g, m) {
    return {
      insertionMode: r,
      selectedValue: c,
      tagScope: g,
      viewTransition: m
    };
  }
  function wi(r, c, g) {
    var m = r.tagScope & -25;
    switch (c) {
      case "noscript":
        return Dt(2, null, m | 1, null);
      case "select":
        return Dt(
          2,
          g.value != null ? g.value : g.defaultValue,
          m,
          null
        );
      case "svg":
        return Dt(4, null, m, null);
      case "picture":
        return Dt(2, null, m | 2, null);
      case "math":
        return Dt(5, null, m, null);
      case "foreignObject":
        return Dt(2, null, m, null);
      case "table":
        return Dt(6, null, m, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return Dt(7, null, m, null);
      case "colgroup":
        return Dt(9, null, m, null);
      case "tr":
        return Dt(8, null, m, null);
      case "head":
        if (2 > r.insertionMode)
          return Dt(3, null, m, null);
        break;
      case "html":
        if (r.insertionMode === 0)
          return Dt(1, null, m, null);
    }
    return 6 <= r.insertionMode || 2 > r.insertionMode ? Dt(2, null, m, null) : r.tagScope !== m ? Dt(
      r.insertionMode,
      r.selectedValue,
      m,
      null
    ) : r;
  }
  function Ye(r) {
    return r === null ? null : {
      update: r.update,
      enter: "none",
      exit: "none",
      share: r.update,
      name: r.autoName,
      autoName: r.autoName,
      nameIdx: 0
    };
  }
  function $i(r, c) {
    return c.tagScope & 32 && (r.instructions |= 128), Dt(
      c.insertionMode,
      c.selectedValue,
      c.tagScope | 12,
      Ye(c.viewTransition)
    );
  }
  function Il(r, c) {
    r = Ye(c.viewTransition);
    var g = c.tagScope | 16;
    return r !== null && r.share !== "none" && (g |= 64), Dt(
      c.insertionMode,
      c.selectedValue,
      g,
      r
    );
  }
  var Zl = /* @__PURE__ */ new Map();
  function _l(r, c) {
    if (typeof c != "object") throw Error(f(62));
    var g = !0, m;
    for (m in c)
      if (Le.call(c, m)) {
        var x = c[m];
        if (x != null && typeof x != "boolean" && x !== "") {
          if (m.indexOf("--") === 0) {
            var N = Q(m);
            x = Q(("" + x).trim());
          } else
            N = Zl.get(m), N === void 0 && (N = Q(
              m.replace(Se, "-$1").toLowerCase().replace(et, "-ms-")
            ), Zl.set(m, N)), x = typeof x == "number" ? x === 0 || Ne.has(m) ? "" + x : x + "px" : Q(("" + x).trim());
          g ? (g = !1, r.push(' style="', N, ":", x)) : r.push(";", N, ":", x);
        }
      }
    g || r.push('"');
  }
  function nl(r, c, g) {
    g && typeof g != "function" && typeof g != "symbol" && r.push(" ", c, '=""');
  }
  function rn(r, c, g) {
    typeof g != "function" && typeof g != "symbol" && typeof g != "boolean" && r.push(" ", c, '="', Q(g), '"');
  }
  var Ai = Q(
    "javascript:throw new Error('React form unexpectedly submitted.')"
  );
  function On(r, c) {
    this.push('<input type="hidden"'), Cn(r), rn(this, "name", c), rn(this, "value", r), this.push("/>");
  }
  function Cn(r) {
    if (typeof r != "string") throw Error(f(480));
  }
  function ca(r, c) {
    if (typeof c.$$FORM_ACTION == "function") {
      var g = r.nextFormID++;
      r = r.idPrefix + g;
      try {
        var m = c.$$FORM_ACTION(r);
        if (m) {
          var x = m.data;
          x != null && x.forEach(Cn);
        }
        return m;
      } catch (N) {
        if (typeof N == "object" && N !== null && typeof N.then == "function")
          throw N;
      }
    }
    return null;
  }
  function eu(r, c, g, m, x, N, D, $) {
    var F = null;
    if (typeof m == "function") {
      var ee = ca(c, m);
      ee !== null ? ($ = ee.name, m = ee.action || "", x = ee.encType, N = ee.method, D = ee.target, F = ee.data) : (r.push(" ", "formAction", '="', Ai, '"'), D = N = x = m = $ = null, Ba(c, g));
    }
    return $ != null && Ge(r, "name", $), m != null && Ge(r, "formAction", m), x != null && Ge(r, "formEncType", x), N != null && Ge(r, "formMethod", N), D != null && Ge(r, "formTarget", D), F;
  }
  function Ge(r, c, g) {
    switch (c) {
      case "className":
        rn(r, "class", g);
        break;
      case "tabIndex":
        rn(r, "tabindex", g);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        rn(r, c, g);
        break;
      case "style":
        _l(r, g);
        break;
      case "src":
      case "href":
        if (g === "") break;
      case "action":
      case "formAction":
        if (g == null || typeof g == "function" || typeof g == "symbol" || typeof g == "boolean")
          break;
        g = j("" + g), r.push(" ", c, '="', Q(g), '"');
        break;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "ref":
        break;
      case "autoFocus":
      case "multiple":
      case "muted":
        nl(r, c.toLowerCase(), g);
        break;
      case "xlinkHref":
        if (typeof g == "function" || typeof g == "symbol" || typeof g == "boolean")
          break;
        g = j("" + g), r.push(" ", "xlink:href", '="', Q(g), '"');
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        typeof g != "function" && typeof g != "symbol" && r.push(" ", c, '="', Q(g), '"');
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        g && typeof g != "function" && typeof g != "symbol" && r.push(" ", c, '=""');
        break;
      case "capture":
      case "download":
        g === !0 ? r.push(" ", c, '=""') : g !== !1 && typeof g != "function" && typeof g != "symbol" && r.push(" ", c, '="', Q(g), '"');
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        typeof g != "function" && typeof g != "symbol" && !isNaN(g) && 1 <= g && r.push(" ", c, '="', Q(g), '"');
        break;
      case "rowSpan":
      case "start":
        typeof g == "function" || typeof g == "symbol" || isNaN(g) || r.push(" ", c, '="', Q(g), '"');
        break;
      case "xlinkActuate":
        rn(r, "xlink:actuate", g);
        break;
      case "xlinkArcrole":
        rn(r, "xlink:arcrole", g);
        break;
      case "xlinkRole":
        rn(r, "xlink:role", g);
        break;
      case "xlinkShow":
        rn(r, "xlink:show", g);
        break;
      case "xlinkTitle":
        rn(r, "xlink:title", g);
        break;
      case "xlinkType":
        rn(r, "xlink:type", g);
        break;
      case "xmlBase":
        rn(r, "xml:base", g);
        break;
      case "xmlLang":
        rn(r, "xml:lang", g);
        break;
      case "xmlSpace":
        rn(r, "xml:space", g);
        break;
      default:
        if ((!(2 < c.length) || c[0] !== "o" && c[0] !== "O" || c[1] !== "n" && c[1] !== "N") && (c = lt.get(c) || c, Ee(c))) {
          switch (typeof g) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              var m = c.toLowerCase().slice(0, 5);
              if (m !== "data-" && m !== "aria-") return;
          }
          r.push(" ", c, '="', Q(g), '"');
        }
    }
  }
  function ll(r, c, g) {
    if (c != null) {
      if (g != null) throw Error(f(60));
      if (typeof c != "object" || !("__html" in c))
        throw Error(f(61));
      c = c.__html, c != null && r.push("" + c);
    }
  }
  function Er(r) {
    var c = "";
    return a.Children.forEach(r, function(g) {
      g != null && (c += g);
    }), c;
  }
  function Ba(r, c) {
    if ((r.instructions & 16) === 0) {
      r.instructions |= 16;
      var g = c.preamble, m = c.bootstrapChunks;
      (g.htmlChunks || g.headChunks) && m.length === 0 ? (m.push(c.startInlineScript), sa(m, r), m.push(
        ">",
        `addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error('React form unexpectedly submitted.')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});`,
        "<\/script>"
      )) : m.unshift(
        c.startInlineScript,
        ">",
        `addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error('React form unexpectedly submitted.')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});`,
        "<\/script>"
      );
    }
  }
  function Ut(r, c) {
    r.push(wt("link"));
    for (var g in c)
      if (Le.call(c, g)) {
        var m = c[g];
        if (m != null)
          switch (g) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(f(399, "link"));
            default:
              Ge(r, g, m);
          }
      }
    return r.push("/>"), null;
  }
  var Nl = /(<\/|<)(s)(tyle)/gi;
  function Oi(r, c, g, m) {
    return "" + c + (g === "s" ? "\\73 " : "\\53 ") + m;
  }
  function ri(r, c, g) {
    r.push(wt(g));
    for (var m in c)
      if (Le.call(c, m)) {
        var x = c[m];
        if (x != null)
          switch (m) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(f(399, g));
            default:
              Ge(r, m, x);
          }
      }
    return r.push("/>"), null;
  }
  function er(r, c) {
    r.push(wt("title"));
    var g = null, m = null, x;
    for (x in c)
      if (Le.call(c, x)) {
        var N = c[x];
        if (N != null)
          switch (x) {
            case "children":
              g = N;
              break;
            case "dangerouslySetInnerHTML":
              m = N;
              break;
            default:
              Ge(r, x, N);
          }
      }
    return r.push(">"), c = Array.isArray(g) ? 2 > g.length ? g[0] : null : g, typeof c != "function" && typeof c != "symbol" && c !== null && c !== void 0 && r.push(Q("" + c)), ll(r, m, g), r.push(Vl("title")), null;
  }
  function Ml(r, c) {
    r.push(wt("script"));
    var g = null, m = null, x;
    for (x in c)
      if (Le.call(c, x)) {
        var N = c[x];
        if (N != null)
          switch (x) {
            case "children":
              g = N;
              break;
            case "dangerouslySetInnerHTML":
              m = N;
              break;
            default:
              Ge(r, x, N);
          }
      }
    return r.push(">"), ll(r, m, g), typeof g == "string" && r.push(("" + g).replace(bt, Gn)), r.push(Vl("script")), null;
  }
  function Xn(r, c, g) {
    r.push(wt(g));
    var m = g = null, x;
    for (x in c)
      if (Le.call(c, x)) {
        var N = c[x];
        if (N != null)
          switch (x) {
            case "children":
              g = N;
              break;
            case "dangerouslySetInnerHTML":
              m = N;
              break;
            default:
              Ge(r, x, N);
          }
      }
    return r.push(">"), ll(r, m, g), g;
  }
  function al(r, c, g) {
    r.push(wt(g));
    var m = g = null, x;
    for (x in c)
      if (Le.call(c, x)) {
        var N = c[x];
        if (N != null)
          switch (x) {
            case "children":
              g = N;
              break;
            case "dangerouslySetInnerHTML":
              m = N;
              break;
            default:
              Ge(r, x, N);
          }
      }
    return r.push(">"), ll(r, m, g), typeof g == "string" ? (r.push(Q(g)), null) : g;
  }
  var vn = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, zl = /* @__PURE__ */ new Map();
  function wt(r) {
    var c = zl.get(r);
    if (c === void 0) {
      if (!vn.test(r))
        throw Error(f(65, r));
      c = "<" + r, zl.set(r, c);
    }
    return c;
  }
  function yn(r, c, g, m, x, N, D, $, F) {
    switch (c) {
      case "div":
      case "span":
      case "svg":
      case "path":
        break;
      case "a":
        r.push(wt("a"));
        var ee = null, se = null, ae;
        for (ae in g)
          if (Le.call(g, ae)) {
            var ve = g[ae];
            if (ve != null)
              switch (ae) {
                case "children":
                  ee = ve;
                  break;
                case "dangerouslySetInnerHTML":
                  se = ve;
                  break;
                case "href":
                  ve === "" ? rn(r, "href", "") : Ge(r, ae, ve);
                  break;
                default:
                  Ge(r, ae, ve);
              }
          }
        if (r.push(">"), ll(r, se, ee), typeof ee == "string") {
          r.push(Q(ee));
          var Be = null;
        } else Be = ee;
        return Be;
      case "g":
      case "p":
      case "li":
        break;
      case "select":
        r.push(wt("select"));
        var Ie = null, Ze = null, Ke;
        for (Ke in g)
          if (Le.call(g, Ke)) {
            var Qe = g[Ke];
            if (Qe != null)
              switch (Ke) {
                case "children":
                  Ie = Qe;
                  break;
                case "dangerouslySetInnerHTML":
                  Ze = Qe;
                  break;
                case "defaultValue":
                case "value":
                  break;
                default:
                  Ge(
                    r,
                    Ke,
                    Qe
                  );
              }
          }
        return r.push(">"), ll(r, Ze, Ie), Ie;
      case "option":
        var je = $.selectedValue;
        r.push(wt("option"));
        var Vt = null, Mt = null, st = null, ft = null, tt;
        for (tt in g)
          if (Le.call(g, tt)) {
            var Bl = g[tt];
            if (Bl != null)
              switch (tt) {
                case "children":
                  Vt = Bl;
                  break;
                case "selected":
                  st = Bl;
                  break;
                case "dangerouslySetInnerHTML":
                  ft = Bl;
                  break;
                case "value":
                  Mt = Bl;
                default:
                  Ge(
                    r,
                    tt,
                    Bl
                  );
              }
          }
        if (je != null) {
          var We = Mt !== null ? "" + Mt : Er(Vt);
          if (xe(je)) {
            for (var Tl = 0; Tl < je.length; Tl++)
              if ("" + je[Tl] === We) {
                r.push(' selected=""');
                break;
              }
          } else
            "" + je === We && r.push(' selected=""');
        } else st && r.push(' selected=""');
        return r.push(">"), ll(r, ft, Vt), Vt;
      case "textarea":
        r.push(wt("textarea"));
        var at = null, pn = null, sn = null, Ct;
        for (Ct in g)
          if (Le.call(g, Ct)) {
            var jn = g[Ct];
            if (jn != null)
              switch (Ct) {
                case "children":
                  sn = jn;
                  break;
                case "value":
                  at = jn;
                  break;
                case "defaultValue":
                  pn = jn;
                  break;
                case "dangerouslySetInnerHTML":
                  throw Error(f(91));
                default:
                  Ge(
                    r,
                    Ct,
                    jn
                  );
              }
          }
        if (at === null && pn !== null && (at = pn), r.push(">"), sn != null) {
          if (at != null) throw Error(f(92));
          if (xe(sn)) {
            if (1 < sn.length)
              throw Error(f(93));
            at = "" + sn[0];
          }
          at = "" + sn;
        }
        return typeof at == "string" && at[0] === `
` && r.push(`
`), at !== null && r.push(Q("" + at)), null;
      case "input":
        r.push(wt("input"));
        var Ii = null, pl = null, Mr = null, qn = null, Sn = null, $n = null, Hl = null, Sl = null, _n = null, Ln;
        for (Ln in g)
          if (Le.call(g, Ln)) {
            var Pt = g[Ln];
            if (Pt != null)
              switch (Ln) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(f(399, "input"));
                case "name":
                  Ii = Pt;
                  break;
                case "formAction":
                  pl = Pt;
                  break;
                case "formEncType":
                  Mr = Pt;
                  break;
                case "formMethod":
                  qn = Pt;
                  break;
                case "formTarget":
                  Sn = Pt;
                  break;
                case "defaultChecked":
                  _n = Pt;
                  break;
                case "defaultValue":
                  Hl = Pt;
                  break;
                case "checked":
                  Sl = Pt;
                  break;
                case "value":
                  $n = Pt;
                  break;
                default:
                  Ge(
                    r,
                    Ln,
                    Pt
                  );
              }
          }
        var ul = eu(
          r,
          m,
          x,
          pl,
          Mr,
          qn,
          Sn,
          Ii
        );
        return Sl !== null ? nl(r, "checked", Sl) : _n !== null && nl(r, "checked", _n), $n !== null ? Ge(r, "value", $n) : Hl !== null && Ge(r, "value", Hl), r.push("/>"), ul != null && ul.forEach(On, r), null;
      case "button":
        r.push(wt("button"));
        var Ul = null, Oa = null, gc = null, vc = null, gu = null, zr = null, Vn = null, xt;
        for (xt in g)
          if (Le.call(g, xt)) {
            var Pe = g[xt];
            if (Pe != null)
              switch (xt) {
                case "children":
                  Ul = Pe;
                  break;
                case "dangerouslySetInnerHTML":
                  Oa = Pe;
                  break;
                case "name":
                  gc = Pe;
                  break;
                case "formAction":
                  vc = Pe;
                  break;
                case "formEncType":
                  gu = Pe;
                  break;
                case "formMethod":
                  zr = Pe;
                  break;
                case "formTarget":
                  Vn = Pe;
                  break;
                default:
                  Ge(
                    r,
                    xt,
                    Pe
                  );
              }
          }
        var Fl = eu(
          r,
          m,
          x,
          vc,
          gu,
          zr,
          Vn,
          gc
        );
        if (r.push(">"), Fl != null && Fl.forEach(On, r), ll(r, Oa, Ul), typeof Ul == "string") {
          r.push(Q(Ul));
          var xl = null;
        } else xl = Ul;
        return xl;
      case "form":
        r.push(wt("form"));
        var Qa = null, Wa = null, Kl = null, Dr = null, Ca = null, ba = null, or;
        for (or in g)
          if (Le.call(g, or)) {
            var jl = g[or];
            if (jl != null)
              switch (or) {
                case "children":
                  Qa = jl;
                  break;
                case "dangerouslySetInnerHTML":
                  Wa = jl;
                  break;
                case "action":
                  Kl = jl;
                  break;
                case "encType":
                  Dr = jl;
                  break;
                case "method":
                  Ca = jl;
                  break;
                case "target":
                  ba = jl;
                  break;
                default:
                  Ge(
                    r,
                    or,
                    jl
                  );
              }
          }
        var vu = null, Jt = null;
        if (typeof Kl == "function") {
          var cl = ca(
            m,
            Kl
          );
          cl !== null ? (Kl = cl.action || "", Dr = cl.encType, Ca = cl.method, ba = cl.target, vu = cl.data, Jt = cl.name) : (r.push(
            " ",
            "action",
            '="',
            Ai,
            '"'
          ), ba = Ca = Dr = Kl = null, Ba(m, x));
        }
        if (Kl != null && Ge(r, "action", Kl), Dr != null && Ge(r, "encType", Dr), Ca != null && Ge(r, "method", Ca), ba != null && Ge(r, "target", ba), r.push(">"), Jt !== null && (r.push('<input type="hidden"'), rn(r, "name", Jt), r.push("/>"), vu != null && vu.forEach(On, r)), ll(r, Wa, Qa), typeof Qa == "string") {
          r.push(Q(Qa));
          var ql = null;
        } else ql = Qa;
        return ql;
      case "menuitem":
        r.push(wt("menuitem"));
        for (var ol in g)
          if (Le.call(g, ol)) {
            var kr = g[ol];
            if (kr != null)
              switch (ol) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(f(400));
                default:
                  Ge(
                    r,
                    ol,
                    kr
                  );
              }
          }
        return r.push(">"), null;
      case "object":
        r.push(wt("object"));
        var Yl = null, $l = null, Pa;
        for (Pa in g)
          if (Le.call(g, Pa)) {
            var Qn = g[Pa];
            if (Qn != null)
              switch (Pa) {
                case "children":
                  Yl = Qn;
                  break;
                case "dangerouslySetInnerHTML":
                  $l = Qn;
                  break;
                case "data":
                  var dt = j("" + Qn);
                  if (dt === "") break;
                  r.push(
                    " ",
                    "data",
                    '="',
                    Q(dt),
                    '"'
                  );
                  break;
                default:
                  Ge(
                    r,
                    Pa,
                    Qn
                  );
              }
          }
        if (r.push(">"), ll(r, $l, Yl), typeof Yl == "string") {
          r.push(Q(Yl));
          var vi = null;
        } else vi = Yl;
        return vi;
      case "title":
        var el = $.tagScope & 1, go = $.tagScope & 4;
        if ($.insertionMode === 4 || el || g.itemProp != null)
          var yu = er(
            r,
            g
          );
        else
          go ? yu = null : (er(x.hoistableChunks, g), yu = void 0);
        return yu;
      case "link":
        var bu = $.tagScope & 1, xn = $.tagScope & 4, yc = g.rel, ea = g.href, Ra = g.precedence;
        if ($.insertionMode === 4 || bu || g.itemProp != null || typeof yc != "string" || typeof ea != "string" || ea === "") {
          Ut(r, g);
          var Ja = null;
        } else if (g.rel === "stylesheet")
          if (typeof Ra != "string" || g.disabled != null || g.onLoad || g.onError)
            Ja = Ut(
              r,
              g
            );
          else {
            var fn = x.styles.get(Ra), _a = m.styleResources.hasOwnProperty(ea) ? m.styleResources[ea] : void 0;
            if (_a !== null) {
              m.styleResources[ea] = null, fn || (fn = {
                precedence: Q(Ra),
                rules: [],
                hrefs: [],
                sheets: /* @__PURE__ */ new Map()
              }, x.styles.set(Ra, fn));
              var Lr = {
                state: 0,
                props: Ce({}, g, {
                  "data-precedence": g.precedence,
                  precedence: null
                })
              };
              if (_a) {
                _a.length === 2 && ue(Lr.props, _a);
                var mu = x.preloads.stylesheets.get(ea);
                mu && 0 < mu.length ? mu.length = 0 : Lr.state = 1;
              }
              fn.sheets.set(ea, Lr), D && D.stylesheets.add(Lr);
            } else if (fn) {
              var bc = fn.sheets.get(ea);
              bc && D && D.stylesheets.add(bc);
            }
            F && r.push("<!-- -->"), Ja = null;
          }
        else
          g.onLoad || g.onError ? Ja = Ut(
            r,
            g
          ) : (F && r.push("<!-- -->"), Ja = xn ? null : Ut(x.hoistableChunks, g));
        return Ja;
      case "script":
        var mc = $.tagScope & 1, Ka = g.async;
        if (typeof g.src != "string" || !g.src || !Ka || typeof Ka == "function" || typeof Ka == "symbol" || g.onLoad || g.onError || $.insertionMode === 4 || mc || g.itemProp != null)
          var Tu = Ml(
            r,
            g
          );
        else {
          var $t = g.src;
          if (g.type === "module")
            var pu = m.moduleScriptResources, Na = x.preloads.moduleScripts;
          else
            pu = m.scriptResources, Na = x.preloads.scripts;
          var Zi = pu.hasOwnProperty($t) ? pu[$t] : void 0;
          if (Zi !== null) {
            pu[$t] = null;
            var Vi = g;
            if (Zi) {
              Zi.length === 2 && (Vi = Ce({}, g), ue(Vi, Zi));
              var sr = Na.get($t);
              sr && (sr.length = 0);
            }
            var Br = [];
            x.scripts.add(Br), Ml(Br, Vi);
          }
          F && r.push("<!-- -->"), Tu = null;
        }
        return Tu;
      case "style":
        var Hr = $.tagScope & 1, El = g.precedence, Bn = g.href, Tc = g.nonce;
        if ($.insertionMode === 4 || Hr || g.itemProp != null || typeof El != "string" || typeof Bn != "string" || Bn === "") {
          r.push(wt("style"));
          var yi = null, Qi = null, ta;
          for (ta in g)
            if (Le.call(g, ta)) {
              var ja = g[ta];
              if (ja != null)
                switch (ta) {
                  case "children":
                    yi = ja;
                    break;
                  case "dangerouslySetInnerHTML":
                    Qi = ja;
                    break;
                  default:
                    Ge(
                      r,
                      ta,
                      ja
                    );
                }
            }
          r.push(">");
          var na = Array.isArray(yi) ? 2 > yi.length ? yi[0] : null : yi;
          typeof na != "function" && typeof na != "symbol" && na !== null && na !== void 0 && r.push(("" + na).replace(Nl, Oi)), ll(r, Qi, yi), r.push(Vl("style"));
          var bi = null;
        } else {
          var qa = x.styles.get(El);
          if ((m.styleResources.hasOwnProperty(Bn) ? m.styleResources[Bn] : void 0) !== null) {
            m.styleResources[Bn] = null, qa || (qa = {
              precedence: Q(El),
              rules: [],
              hrefs: [],
              sheets: /* @__PURE__ */ new Map()
            }, x.styles.set(El, qa));
            var mi = x.nonce.style;
            if (!mi || mi === Tc) {
              qa.hrefs.push(Q(Bn));
              var pc = qa.rules, sl = null, fr = null, Ti;
              for (Ti in g)
                if (Le.call(g, Ti)) {
                  var fl = g[Ti];
                  if (fl != null)
                    switch (Ti) {
                      case "children":
                        sl = fl;
                        break;
                      case "dangerouslySetInnerHTML":
                        fr = fl;
                    }
                }
              var wl = Array.isArray(sl) ? 2 > sl.length ? sl[0] : null : sl;
              typeof wl != "function" && typeof wl != "symbol" && wl !== null && wl !== void 0 && pc.push(
                ("" + wl).replace(Nl, Oi)
              ), ll(pc, fr, sl);
            }
          }
          qa && D && D.styles.add(qa), F && r.push("<!-- -->"), bi = void 0;
        }
        return bi;
      case "meta":
        var dl = $.tagScope & 1, Ur = $.tagScope & 4;
        if ($.insertionMode === 4 || dl || g.itemProp != null)
          var Su = ri(
            r,
            g,
            "meta"
          );
        else
          F && r.push("<!-- -->"), Su = Ur ? null : typeof g.charSet == "string" ? ri(x.charsetChunks, g, "meta") : g.name === "viewport" ? ri(x.viewportChunks, g, "meta") : ri(x.hoistableChunks, g, "meta");
        return Su;
      case "listing":
      case "pre":
        r.push(wt(c));
        var $a = null, i = null, u;
        for (u in g)
          if (Le.call(g, u)) {
            var h = g[u];
            if (h != null)
              switch (u) {
                case "children":
                  $a = h;
                  break;
                case "dangerouslySetInnerHTML":
                  i = h;
                  break;
                default:
                  Ge(
                    r,
                    u,
                    h
                  );
              }
          }
        if (r.push(">"), i != null) {
          if ($a != null) throw Error(f(60));
          if (typeof i != "object" || !("__html" in i))
            throw Error(f(61));
          var b = i.__html;
          b != null && (typeof b == "string" && 0 < b.length && b[0] === `
` ? r.push(`
`, b) : r.push("" + b));
        }
        return typeof $a == "string" && $a[0] === `
` && r.push(`
`), $a;
      case "img":
        var p = $.tagScope & 3, C = g.src, M = g.srcSet;
        if (!(g.loading === "lazy" || !C && !M || typeof C != "string" && C != null || typeof M != "string" && M != null || g.fetchPriority === "low" || p) && (typeof C != "string" || C[4] !== ":" || C[0] !== "d" && C[0] !== "D" || C[1] !== "a" && C[1] !== "A" || C[2] !== "t" && C[2] !== "T" || C[3] !== "a" && C[3] !== "A") && (typeof M != "string" || M[4] !== ":" || M[0] !== "d" && M[0] !== "D" || M[1] !== "a" && M[1] !== "A" || M[2] !== "t" && M[2] !== "T" || M[3] !== "a" && M[3] !== "A")) {
          D !== null && $.tagScope & 64 && (D.suspenseyImages = !0);
          var I = typeof g.sizes == "string" ? g.sizes : void 0, L = M ? M + `
` + (I || "") : C, X = x.preloads.images, W = X.get(L);
          if (W)
            (g.fetchPriority === "high" || 10 > x.highImagePreloads.size) && (X.delete(L), x.highImagePreloads.add(W));
          else if (!m.imageResources.hasOwnProperty(L)) {
            m.imageResources[L] = $e;
            var te = g.crossOrigin, me = typeof te == "string" ? te === "use-credentials" ? te : "" : void 0, Te = x.headers, Ve;
            Te && 0 < Te.remainingCapacity && typeof g.srcSet != "string" && (g.fetchPriority === "high" || 500 > Te.highImagePreloads.length) && (Ve = ge(C, "image", {
              imageSrcSet: g.srcSet,
              imageSizes: g.sizes,
              crossOrigin: me,
              integrity: g.integrity,
              nonce: g.nonce,
              type: g.type,
              fetchPriority: g.fetchPriority,
              referrerPolicy: g.refererPolicy
            }), 0 <= (Te.remainingCapacity -= Ve.length + 2)) ? (x.resets.image[L] = $e, Te.highImagePreloads && (Te.highImagePreloads += ", "), Te.highImagePreloads += Ve) : (W = [], Ut(W, {
              rel: "preload",
              as: "image",
              href: M ? void 0 : C,
              imageSrcSet: M,
              imageSizes: I,
              crossOrigin: me,
              integrity: g.integrity,
              type: g.type,
              fetchPriority: g.fetchPriority,
              referrerPolicy: g.referrerPolicy
            }), g.fetchPriority === "high" || 10 > x.highImagePreloads.size ? x.highImagePreloads.add(W) : (x.bulkPreloads.add(W), X.set(L, W)));
          }
        }
        return ri(r, g, "img");
      case "base":
      case "area":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "param":
      case "source":
      case "track":
      case "wbr":
        return ri(r, g, c);
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        break;
      case "head":
        if (2 > $.insertionMode) {
          var Me = N || x.preamble;
          if (Me.headChunks)
            throw Error(f(545, "`<head>`"));
          N !== null && r.push("<!--head-->"), Me.headChunks = [];
          var nt = Xn(
            Me.headChunks,
            g,
            "head"
          );
        } else
          nt = al(
            r,
            g,
            "head"
          );
        return nt;
      case "body":
        if (2 > $.insertionMode) {
          var ht = N || x.preamble;
          if (ht.bodyChunks)
            throw Error(f(545, "`<body>`"));
          N !== null && r.push("<!--body-->"), ht.bodyChunks = [];
          var Ae = Xn(
            ht.bodyChunks,
            g,
            "body"
          );
        } else
          Ae = al(
            r,
            g,
            "body"
          );
        return Ae;
      case "html":
        if ($.insertionMode === 0) {
          var Je = N || x.preamble;
          if (Je.htmlChunks)
            throw Error(f(545, "`<html>`"));
          N !== null && r.push("<!--html-->"), Je.htmlChunks = [""];
          var gt = Xn(
            Je.htmlChunks,
            g,
            "html"
          );
        } else
          gt = al(
            r,
            g,
            "html"
          );
        return gt;
      default:
        if (c.indexOf("-") !== -1) {
          r.push(wt(c));
          var Al = null, Ue = null, dn;
          for (dn in g)
            if (Le.call(g, dn)) {
              var Kt = g[dn];
              if (Kt != null) {
                var Hn = dn;
                switch (dn) {
                  case "children":
                    Al = Kt;
                    break;
                  case "dangerouslySetInnerHTML":
                    Ue = Kt;
                    break;
                  case "style":
                    _l(r, Kt);
                    break;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "ref":
                    break;
                  case "className":
                    Hn = "class";
                  default:
                    if (Ee(dn) && typeof Kt != "function" && typeof Kt != "symbol" && Kt !== !1) {
                      if (Kt === !0) Kt = "";
                      else if (typeof Kt == "object") continue;
                      r.push(
                        " ",
                        Hn,
                        '="',
                        Q(Kt),
                        '"'
                      );
                    }
                }
              }
            }
          return r.push(">"), ll(r, Ue, Al), Al;
        }
    }
    return al(r, g, c);
  }
  var Ha = /* @__PURE__ */ new Map();
  function Vl(r) {
    var c = Ha.get(r);
    return c === void 0 && (c = "</" + r + ">", Ha.set(r, c)), c;
  }
  function Ua(r, c) {
    r = r.preamble, r.htmlChunks === null && c.htmlChunks && (r.htmlChunks = c.htmlChunks), r.headChunks === null && c.headChunks && (r.headChunks = c.headChunks), r.bodyChunks === null && c.bodyChunks && (r.bodyChunks = c.bodyChunks);
  }
  function Dl(r, c) {
    c = c.bootstrapChunks;
    for (var g = 0; g < c.length - 1; g++)
      r.push(c[g]);
    return g < c.length ? (g = c[g], c.length = 0, r.push(g)) : !0;
  }
  function Fa(r, c, g) {
    if (r.push('<!--$?--><template id="'), g === null) throw Error(f(395));
    return r.push(c.boundaryPrefix), c = g.toString(16), r.push(c), r.push('"></template>');
  }
  function bn(r, c, g, m) {
    switch (g.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return r.push('<div hidden id="'), r.push(c.segmentPrefix), c = m.toString(16), r.push(c), r.push('">');
      case 4:
        return r.push('<svg aria-hidden="true" style="display:none" id="'), r.push(c.segmentPrefix), c = m.toString(16), r.push(c), r.push('">');
      case 5:
        return r.push('<math aria-hidden="true" style="display:none" id="'), r.push(c.segmentPrefix), c = m.toString(16), r.push(c), r.push('">');
      case 6:
        return r.push('<table hidden id="'), r.push(c.segmentPrefix), c = m.toString(16), r.push(c), r.push('">');
      case 7:
        return r.push('<table hidden><tbody id="'), r.push(c.segmentPrefix), c = m.toString(16), r.push(c), r.push('">');
      case 8:
        return r.push('<table hidden><tr id="'), r.push(c.segmentPrefix), c = m.toString(16), r.push(c), r.push('">');
      case 9:
        return r.push('<table hidden><colgroup id="'), r.push(c.segmentPrefix), c = m.toString(16), r.push(c), r.push('">');
      default:
        throw Error(f(397));
    }
  }
  function Vu(r, c) {
    switch (c.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return r.push("</div>");
      case 4:
        return r.push("</svg>");
      case 5:
        return r.push("</math>");
      case 6:
        return r.push("</table>");
      case 7:
        return r.push("</tbody></table>");
      case 8:
        return r.push("</tr></table>");
      case 9:
        return r.push("</colgroup></table>");
      default:
        throw Error(f(397));
    }
  }
  var tu = /[<\u2028\u2029]/g;
  function ln(r) {
    return JSON.stringify(r).replace(
      tu,
      function(c) {
        switch (c) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw Error(
              "escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
            );
        }
      }
    );
  }
  var Ql = /[&><\u2028\u2029]/g;
  function tr(r) {
    return JSON.stringify(r).replace(
      Ql,
      function(c) {
        switch (c) {
          case "&":
            return "\\u0026";
          case ">":
            return "\\u003e";
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw Error(
              "escapeJSObjectForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
            );
        }
      }
    );
  }
  var ui = !1, un = !0;
  function il(r) {
    var c = r.rules, g = r.hrefs, m = 0;
    if (g.length) {
      for (this.push(Wt.startInlineStyle), this.push(' media="not all" data-precedence="'), this.push(r.precedence), this.push('" data-href="'); m < g.length - 1; m++)
        this.push(g[m]), this.push(" ");
      for (this.push(g[m]), this.push('">'), m = 0; m < c.length; m++) this.push(c[m]);
      un = this.push("</style>"), ui = !0, c.length = 0, g.length = 0;
    }
  }
  function kt(r) {
    return r.state !== 2 ? ui = !0 : !1;
  }
  function Ci(r, c, g) {
    return ui = !1, un = !0, Wt = g, c.styles.forEach(il, r), Wt = null, c.stylesheets.forEach(kt), ui && (g.stylesToHoist = !0), un;
  }
  function It(r) {
    for (var c = 0; c < r.length; c++) this.push(r[c]);
    r.length = 0;
  }
  var mt = [];
  function oa(r) {
    Ut(mt, r.props);
    for (var c = 0; c < mt.length; c++)
      this.push(mt[c]);
    mt.length = 0, r.state = 2;
  }
  function mn(r) {
    var c = 0 < r.sheets.size;
    r.sheets.forEach(oa, this), r.sheets.clear();
    var g = r.rules, m = r.hrefs;
    if (!c || m.length) {
      if (this.push(Wt.startInlineStyle), this.push(' data-precedence="'), this.push(r.precedence), r = 0, m.length) {
        for (this.push('" data-href="'); r < m.length - 1; r++)
          this.push(m[r]), this.push(" ");
        this.push(m[r]);
      }
      for (this.push('">'), r = 0; r < g.length; r++)
        this.push(g[r]);
      this.push("</style>"), g.length = 0, m.length = 0;
    }
  }
  function zn(r) {
    if (r.state === 0) {
      r.state = 1;
      var c = r.props;
      for (Ut(mt, {
        rel: "preload",
        as: "style",
        href: r.props.href,
        crossOrigin: c.crossOrigin,
        fetchPriority: c.fetchPriority,
        integrity: c.integrity,
        media: c.media,
        hrefLang: c.hrefLang,
        referrerPolicy: c.referrerPolicy
      }), r = 0; r < mt.length; r++)
        this.push(mt[r]);
      mt.length = 0;
    }
  }
  function Ta(r) {
    r.sheets.forEach(zn, this), r.sheets.clear();
  }
  function sa(r, c) {
    (c.instructions & 32) === 0 && (c.instructions |= 32, r.push(
      ' id="',
      Q("_" + c.idPrefix + "R_"),
      '"'
    ));
  }
  function fa(r, c) {
    r.push("[");
    var g = "[";
    c.stylesheets.forEach(function(m) {
      if (m.state !== 2)
        if (m.state === 3)
          r.push(g), m = tr(
            "" + m.props.href
          ), r.push(m), r.push("]"), g = ",[";
        else {
          r.push(g);
          var x = m.props["data-precedence"], N = m.props, D = j("" + m.props.href);
          D = tr(D), r.push(D), x = "" + x, r.push(","), x = tr(x), r.push(x);
          for (var $ in N)
            if (Le.call(N, $) && (x = N[$], x != null))
              switch ($) {
                case "href":
                case "rel":
                case "precedence":
                case "data-precedence":
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(f(399, "link"));
                default:
                  Tt(
                    r,
                    $,
                    x
                  );
              }
          r.push("]"), g = ",[", m.state = 3;
        }
    }), r.push("]");
  }
  function Tt(r, c, g) {
    var m = c.toLowerCase();
    switch (typeof g) {
      case "function":
      case "symbol":
        return;
    }
    switch (c) {
      case "innerHTML":
      case "dangerouslySetInnerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "style":
      case "ref":
        return;
      case "className":
        m = "class", c = "" + g;
        break;
      case "hidden":
        if (g === !1) return;
        c = "";
        break;
      case "src":
      case "href":
        g = j(g), c = "" + g;
        break;
      default:
        if (2 < c.length && (c[0] === "o" || c[0] === "O") && (c[1] === "n" || c[1] === "N") || !Ee(c))
          return;
        c = "" + g;
    }
    r.push(","), m = tr(m), r.push(m), r.push(","), m = tr(c), r.push(m);
  }
  function _t() {
    return { styles: /* @__PURE__ */ new Set(), stylesheets: /* @__PURE__ */ new Set(), suspenseyImages: !1 };
  }
  function pa(r) {
    var c = Zn || null;
    if (c) {
      var g = c.resumableState, m = c.renderState;
      if (typeof r == "string" && r) {
        if (!g.dnsResources.hasOwnProperty(r)) {
          g.dnsResources[r] = null, g = m.headers;
          var x, N;
          (N = g && 0 < g.remainingCapacity) && (N = (x = "<" + ("" + r).replace(
            Fe,
            At
          ) + ">; rel=dns-prefetch", 0 <= (g.remainingCapacity -= x.length + 2))), N ? (m.resets.dns[r] = null, g.preconnects && (g.preconnects += ", "), g.preconnects += x) : (x = [], Ut(x, { href: r, rel: "dns-prefetch" }), m.preconnects.add(x));
        }
        gi(c);
      }
    } else Oe.D(r);
  }
  function In(r, c) {
    var g = Zn || null;
    if (g) {
      var m = g.resumableState, x = g.renderState;
      if (typeof r == "string" && r) {
        var N = c === "use-credentials" ? "credentials" : typeof c == "string" ? "anonymous" : "default";
        if (!m.connectResources[N].hasOwnProperty(r)) {
          m.connectResources[N][r] = null, m = x.headers;
          var D, $;
          if ($ = m && 0 < m.remainingCapacity) {
            if ($ = "<" + ("" + r).replace(
              Fe,
              At
            ) + ">; rel=preconnect", typeof c == "string") {
              var F = ("" + c).replace(
                Nt,
                Rn
              );
              $ += '; crossorigin="' + F + '"';
            }
            $ = (D = $, 0 <= (m.remainingCapacity -= D.length + 2));
          }
          $ ? (x.resets.connect[N][r] = null, m.preconnects && (m.preconnects += ", "), m.preconnects += D) : (N = [], Ut(N, {
            rel: "preconnect",
            href: r,
            crossOrigin: c
          }), x.preconnects.add(N));
        }
        gi(g);
      }
    } else Oe.C(r, c);
  }
  function ci(r, c, g) {
    var m = Zn || null;
    if (m) {
      var x = m.resumableState, N = m.renderState;
      if (c && r) {
        switch (c) {
          case "image":
            if (g)
              var D = g.imageSrcSet, $ = g.imageSizes, F = g.fetchPriority;
            var ee = D ? D + `
` + ($ || "") : r;
            if (x.imageResources.hasOwnProperty(ee)) return;
            x.imageResources[ee] = $e, x = N.headers;
            var se;
            x && 0 < x.remainingCapacity && typeof D != "string" && F === "high" && (se = ge(r, c, g), 0 <= (x.remainingCapacity -= se.length + 2)) ? (N.resets.image[ee] = $e, x.highImagePreloads && (x.highImagePreloads += ", "), x.highImagePreloads += se) : (x = [], Ut(
              x,
              Ce(
                { rel: "preload", href: D ? void 0 : r, as: c },
                g
              )
            ), F === "high" ? N.highImagePreloads.add(x) : (N.bulkPreloads.add(x), N.preloads.images.set(ee, x)));
            break;
          case "style":
            if (x.styleResources.hasOwnProperty(r)) return;
            D = [], Ut(
              D,
              Ce({ rel: "preload", href: r, as: c }, g)
            ), x.styleResources[r] = !g || typeof g.crossOrigin != "string" && typeof g.integrity != "string" ? $e : [g.crossOrigin, g.integrity], N.preloads.stylesheets.set(r, D), N.bulkPreloads.add(D);
            break;
          case "script":
            if (x.scriptResources.hasOwnProperty(r)) return;
            D = [], N.preloads.scripts.set(r, D), N.bulkPreloads.add(D), Ut(
              D,
              Ce({ rel: "preload", href: r, as: c }, g)
            ), x.scriptResources[r] = !g || typeof g.crossOrigin != "string" && typeof g.integrity != "string" ? $e : [g.crossOrigin, g.integrity];
            break;
          default:
            if (x.unknownResources.hasOwnProperty(c)) {
              if (D = x.unknownResources[c], D.hasOwnProperty(r))
                return;
            } else
              D = {}, x.unknownResources[c] = D;
            if (D[r] = $e, (x = N.headers) && 0 < x.remainingCapacity && c === "font" && (ee = ge(r, c, g), 0 <= (x.remainingCapacity -= ee.length + 2)))
              N.resets.font[r] = $e, x.fontPreloads && (x.fontPreloads += ", "), x.fontPreloads += ee;
            else
              switch (x = [], r = Ce({ rel: "preload", href: r, as: c }, g), Ut(x, r), c) {
                case "font":
                  N.fontPreloads.add(x);
                  break;
                default:
                  N.bulkPreloads.add(x);
              }
        }
        gi(m);
      }
    } else Oe.L(r, c, g);
  }
  function da(r, c) {
    var g = Zn || null;
    if (g) {
      var m = g.resumableState, x = g.renderState;
      if (r) {
        var N = c && typeof c.as == "string" ? c.as : "script";
        switch (N) {
          case "script":
            if (m.moduleScriptResources.hasOwnProperty(r)) return;
            N = [], m.moduleScriptResources[r] = !c || typeof c.crossOrigin != "string" && typeof c.integrity != "string" ? $e : [c.crossOrigin, c.integrity], x.preloads.moduleScripts.set(r, N);
            break;
          default:
            if (m.moduleUnknownResources.hasOwnProperty(N)) {
              var D = m.unknownResources[N];
              if (D.hasOwnProperty(r)) return;
            } else
              D = {}, m.moduleUnknownResources[N] = D;
            N = [], D[r] = $e;
        }
        Ut(N, Ce({ rel: "modulepreload", href: r }, c)), x.bulkPreloads.add(N), gi(g);
      }
    } else Oe.m(r, c);
  }
  function Sa(r, c, g) {
    var m = Zn || null;
    if (m) {
      var x = m.resumableState, N = m.renderState;
      if (r) {
        c = c || "default";
        var D = N.styles.get(c), $ = x.styleResources.hasOwnProperty(r) ? x.styleResources[r] : void 0;
        $ !== null && (x.styleResources[r] = null, D || (D = {
          precedence: Q(c),
          rules: [],
          hrefs: [],
          sheets: /* @__PURE__ */ new Map()
        }, N.styles.set(c, D)), c = {
          state: 0,
          props: Ce(
            { rel: "stylesheet", href: r, "data-precedence": c },
            g
          )
        }, $ && ($.length === 2 && ue(c.props, $), (N = N.preloads.stylesheets.get(r)) && 0 < N.length ? N.length = 0 : c.state = 1), D.sheets.set(r, c), gi(m));
      }
    } else Oe.S(r, c, g);
  }
  function Re(r, c) {
    var g = Zn || null;
    if (g) {
      var m = g.resumableState, x = g.renderState;
      if (r) {
        var N = m.scriptResources.hasOwnProperty(r) ? m.scriptResources[r] : void 0;
        N !== null && (m.scriptResources[r] = null, c = Ce({ src: r, async: !0 }, c), N && (N.length === 2 && ue(c, N), r = x.preloads.scripts.get(r)) && (r.length = 0), r = [], x.scripts.add(r), Ml(r, c), gi(g));
      }
    } else Oe.X(r, c);
  }
  function k(r, c) {
    var g = Zn || null;
    if (g) {
      var m = g.resumableState, x = g.renderState;
      if (r) {
        var N = m.moduleScriptResources.hasOwnProperty(
          r
        ) ? m.moduleScriptResources[r] : void 0;
        N !== null && (m.moduleScriptResources[r] = null, c = Ce({ src: r, type: "module", async: !0 }, c), N && (N.length === 2 && ue(c, N), r = x.preloads.moduleScripts.get(r)) && (r.length = 0), r = [], x.scripts.add(r), Ml(r, c), gi(g));
      }
    } else Oe.M(r, c);
  }
  function ue(r, c) {
    r.crossOrigin == null && (r.crossOrigin = c[0]), r.integrity == null && (r.integrity = c[1]);
  }
  function ge(r, c, g) {
    r = ("" + r).replace(
      Fe,
      At
    ), c = ("" + c).replace(
      Nt,
      Rn
    ), c = "<" + r + '>; rel=preload; as="' + c + '"';
    for (var m in g)
      Le.call(g, m) && (r = g[m], typeof r == "string" && (c += "; " + m.toLowerCase() + '="' + ("" + r).replace(
        Nt,
        Rn
      ) + '"'));
    return c;
  }
  var Fe = /[<>\r\n]/g;
  function At(r) {
    switch (r) {
      case "<":
        return "%3C";
      case ">":
        return "%3E";
      case `
`:
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error(
          "escapeLinkHrefForHeaderContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
        );
    }
  }
  var Nt = /["';,\r\n]/g;
  function Rn(r) {
    switch (r) {
      case '"':
        return "%22";
      case "'":
        return "%27";
      case ";":
        return "%3B";
      case ",":
        return "%2C";
      case `
`:
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error(
          "escapeStringForLinkHeaderQuotedParamValueContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
        );
    }
  }
  function xa(r) {
    this.styles.add(r);
  }
  function Ea(r) {
    this.stylesheets.add(r);
  }
  function Wl(r, c) {
    c.styles.forEach(xa, r), c.stylesheets.forEach(Ea, r), c.suspenseyImages && (r.suspenseyImages = !0);
  }
  function Zt(r, c) {
    var g = r.idPrefix, m = [], x = r.bootstrapScriptContent, N = r.bootstrapScripts, D = r.bootstrapModules;
    x !== void 0 && (m.push("<script"), sa(m, r), m.push(
      ">",
      ("" + x).replace(bt, Gn),
      "<\/script>"
    )), x = g + "P:";
    var $ = g + "S:";
    g += "B:";
    var F = /* @__PURE__ */ new Set(), ee = /* @__PURE__ */ new Set(), se = /* @__PURE__ */ new Set(), ae = /* @__PURE__ */ new Map(), ve = /* @__PURE__ */ new Set(), Be = /* @__PURE__ */ new Set(), Ie = /* @__PURE__ */ new Set(), Ze = {
      images: /* @__PURE__ */ new Map(),
      stylesheets: /* @__PURE__ */ new Map(),
      scripts: /* @__PURE__ */ new Map(),
      moduleScripts: /* @__PURE__ */ new Map()
    };
    if (N !== void 0)
      for (var Ke = 0; Ke < N.length; Ke++) {
        var Qe = N[Ke], je, Vt = void 0, Mt = void 0, st = {
          rel: "preload",
          as: "script",
          fetchPriority: "low",
          nonce: void 0
        };
        typeof Qe == "string" ? st.href = je = Qe : (st.href = je = Qe.src, st.integrity = Mt = typeof Qe.integrity == "string" ? Qe.integrity : void 0, st.crossOrigin = Vt = typeof Qe == "string" || Qe.crossOrigin == null ? void 0 : Qe.crossOrigin === "use-credentials" ? "use-credentials" : ""), Qe = r;
        var ft = je;
        Qe.scriptResources[ft] = null, Qe.moduleScriptResources[ft] = null, Qe = [], Ut(Qe, st), ve.add(Qe), m.push('<script src="', Q(je), '"'), typeof Mt == "string" && m.push(
          ' integrity="',
          Q(Mt),
          '"'
        ), typeof Vt == "string" && m.push(
          ' crossorigin="',
          Q(Vt),
          '"'
        ), sa(m, r), m.push(' async=""><\/script>');
      }
    if (D !== void 0)
      for (N = 0; N < D.length; N++)
        st = D[N], Vt = je = void 0, Mt = {
          rel: "modulepreload",
          fetchPriority: "low",
          nonce: void 0
        }, typeof st == "string" ? Mt.href = Ke = st : (Mt.href = Ke = st.src, Mt.integrity = Vt = typeof st.integrity == "string" ? st.integrity : void 0, Mt.crossOrigin = je = typeof st == "string" || st.crossOrigin == null ? void 0 : st.crossOrigin === "use-credentials" ? "use-credentials" : ""), st = r, Qe = Ke, st.scriptResources[Qe] = null, st.moduleScriptResources[Qe] = null, st = [], Ut(st, Mt), ve.add(st), m.push(
          '<script type="module" src="',
          Q(Ke),
          '"'
        ), typeof Vt == "string" && m.push(
          ' integrity="',
          Q(Vt),
          '"'
        ), typeof je == "string" && m.push(
          ' crossorigin="',
          Q(je),
          '"'
        ), sa(m, r), m.push(' async=""><\/script>');
    return {
      placeholderPrefix: x,
      segmentPrefix: $,
      boundaryPrefix: g,
      startInlineScript: "<script",
      startInlineStyle: "<style",
      preamble: { htmlChunks: null, headChunks: null, bodyChunks: null },
      externalRuntimeScript: null,
      bootstrapChunks: m,
      importMapChunks: [],
      onHeaders: void 0,
      headers: null,
      resets: {
        font: {},
        dns: {},
        connect: { default: {}, anonymous: {}, credentials: {} },
        image: {},
        style: {}
      },
      charsetChunks: [],
      viewportChunks: [],
      hoistableChunks: [],
      preconnects: F,
      fontPreloads: ee,
      highImagePreloads: se,
      styles: ae,
      bootstrapScripts: ve,
      scripts: Be,
      bulkPreloads: Ie,
      preloads: Ze,
      nonce: { script: void 0, style: void 0 },
      stylesToHoist: !1,
      generateStaticMarkup: c
    };
  }
  function bl(r, c, g, m) {
    return g.generateStaticMarkup ? (r.push(Q(c)), !1) : (c === "" ? r = m : (m && r.push("<!-- -->"), r.push(Q(c)), r = !0), r);
  }
  function cn(r, c, g, m) {
    c.generateStaticMarkup || g && m && r.push("<!-- -->");
  }
  var Qu = Function.prototype.bind, Fs = Symbol.for("react.client.reference");
  function nr(r) {
    if (r == null) return null;
    if (typeof r == "function")
      return r.$$typeof === Fs ? null : r.displayName || r.name || null;
    if (typeof r == "string") return r;
    switch (r) {
      case T:
        return "Fragment";
      case O:
        return "Profiler";
      case w:
        return "StrictMode";
      case Z:
        return "Suspense";
      case Y:
        return "SuspenseList";
      case he:
        return "Activity";
    }
    if (typeof r == "object")
      switch (r.$$typeof) {
        case y:
          return "Portal";
        case z:
          return r.displayName || "Context";
        case _:
          return (r._context.displayName || "Context") + ".Consumer";
        case H:
          var c = r.render;
          return r = r.displayName, r || (r = c.displayName || c.name || "", r = r !== "" ? "ForwardRef(" + r + ")" : "ForwardRef"), r;
        case ce:
          return c = r.displayName || null, c !== null ? c : nr(r.type) || "Memo";
        case le:
          c = r._payload, r = r._init;
          try {
            return nr(r(c));
          } catch {
          }
      }
    return null;
  }
  var Tn = {}, Ya = null;
  function Wu(r, c) {
    if (r !== c) {
      r.context._currentValue2 = r.parentValue, r = r.parent;
      var g = c.parent;
      if (r === null) {
        if (g !== null) throw Error(f(401));
      } else {
        if (g === null) throw Error(f(401));
        Wu(r, g);
      }
      c.context._currentValue2 = c.value;
    }
  }
  function kl(r) {
    r.context._currentValue2 = r.parentValue, r = r.parent, r !== null && kl(r);
  }
  function Ga(r) {
    var c = r.parent;
    c !== null && Ga(c), r.context._currentValue2 = r.value;
  }
  function Pu(r, c) {
    if (r.context._currentValue2 = r.parentValue, r = r.parent, r === null) throw Error(f(402));
    r.depth === c.depth ? Wu(r, c) : Pu(r, c);
  }
  function nu(r, c) {
    var g = c.parent;
    if (g === null) throw Error(f(402));
    r.depth === g.depth ? Wu(r, g) : nu(r, g), c.context._currentValue2 = c.value;
  }
  function Pl(r) {
    var c = Ya;
    c !== r && (c === null ? Ga(r) : r === null ? kl(c) : c.depth === r.depth ? Wu(c, r) : c.depth > r.depth ? Pu(c, r) : nu(c, r), Ya = r);
  }
  var to = {
    enqueueSetState: function(r, c) {
      r = r._reactInternals, r.queue !== null && r.queue.push(c);
    },
    enqueueReplaceState: function(r, c) {
      r = r._reactInternals, r.replace = !0, r.queue = [c];
    },
    enqueueForceUpdate: function() {
    }
  }, Fo = { id: 1, overflow: "" };
  function ha(r, c, g) {
    var m = r.id;
    r = r.overflow;
    var x = 32 - Ju(m) - 1;
    m &= ~(1 << x), g += 1;
    var N = 32 - Ju(c) + x;
    if (30 < N) {
      var D = x - x % 5;
      return N = (m & (1 << D) - 1).toString(32), m >>= D, x -= D, {
        id: 1 << 32 - Ju(c) + x | g << x | m,
        overflow: N + r
      };
    }
    return {
      id: 1 << N | g << x | m,
      overflow: r
    };
  }
  var Ju = Math.clz32 ? Math.clz32 : no, Yo = Math.log, Go = Math.LN2;
  function no(r) {
    return r >>>= 0, r === 0 ? 32 : 31 - (Yo(r) / Go | 0) | 0;
  }
  function ml() {
  }
  var Jl = Error(f(460));
  function Ku(r, c, g) {
    switch (g = r[g], g === void 0 ? r.push(c) : g !== c && (c.then(ml, ml), c = g), c.status) {
      case "fulfilled":
        return c.value;
      case "rejected":
        throw c.reason;
      default:
        switch (typeof c.status == "string" ? c.then(ml, ml) : (r = c, r.status = "pending", r.then(
          function(m) {
            if (c.status === "pending") {
              var x = c;
              x.status = "fulfilled", x.value = m;
            }
          },
          function(m) {
            if (c.status === "pending") {
              var x = c;
              x.status = "rejected", x.reason = m;
            }
          }
        )), c.status) {
          case "fulfilled":
            return c.value;
          case "rejected":
            throw c.reason;
        }
        throw ga = c, Jl;
    }
  }
  var ga = null;
  function wr() {
    if (ga === null) throw Error(f(459));
    var r = ga;
    return ga = null, r;
  }
  function lo(r, c) {
    return r === c && (r !== 0 || 1 / r === 1 / c) || r !== r && c !== c;
  }
  var lr = typeof Object.is == "function" ? Object.is : lo, Ll = null, ju = null, lu = null, qu = null, Ri = null, ot = null, ar = !1, _i = !1, va = 0, ir = 0, Ni = -1, au = 0, oi = null, wa = null, iu = 0;
  function on() {
    if (Ll === null)
      throw Error(f(321));
    return Ll;
  }
  function Mi() {
    if (0 < iu) throw Error(f(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function Ar() {
    return ot === null ? Ri === null ? (ar = !1, Ri = ot = Mi()) : (ar = !0, ot = Ri) : ot.next === null ? (ar = !1, ot = ot.next = Mi()) : (ar = !0, ot = ot.next), ot;
  }
  function Xa() {
    var r = oi;
    return oi = null, r;
  }
  function ru() {
    qu = lu = ju = Ll = null, _i = !1, Ri = null, iu = 0, ot = wa = null;
  }
  function $u(r, c) {
    return typeof c == "function" ? c(r) : c;
  }
  function ec(r, c, g) {
    if (Ll = on(), ot = Ar(), ar) {
      var m = ot.queue;
      if (c = m.dispatch, wa !== null && (g = wa.get(m), g !== void 0)) {
        wa.delete(m), m = ot.memoizedState;
        do
          m = r(m, g.action), g = g.next;
        while (g !== null);
        return ot.memoizedState = m, [m, c];
      }
      return [ot.memoizedState, c];
    }
    return r = r === $u ? typeof c == "function" ? c() : c : g !== void 0 ? g(c) : c, ot.memoizedState = r, r = ot.queue = { last: null, dispatch: null }, r = r.dispatch = tc.bind(
      null,
      Ll,
      r
    ), [ot.memoizedState, r];
  }
  function Or(r, c) {
    if (Ll = on(), ot = Ar(), c = c === void 0 ? null : c, ot !== null) {
      var g = ot.memoizedState;
      if (g !== null && c !== null) {
        var m = g[1];
        e: if (m === null) m = !1;
        else {
          for (var x = 0; x < m.length && x < c.length; x++)
            if (!lr(c[x], m[x])) {
              m = !1;
              break e;
            }
          m = !0;
        }
        if (m) return g[0];
      }
    }
    return r = r(), ot.memoizedState = [r, c], r;
  }
  function tc(r, c, g) {
    if (25 <= iu) throw Error(f(301));
    if (r === Ll)
      if (_i = !0, r = { action: g, next: null }, wa === null && (wa = /* @__PURE__ */ new Map()), g = wa.get(c), g === void 0)
        wa.set(c, r);
      else {
        for (c = g; c.next !== null; ) c = c.next;
        c.next = r;
      }
  }
  function Xo() {
    throw Error(f(440));
  }
  function Ys() {
    throw Error(f(394));
  }
  function Gs() {
    throw Error(f(479));
  }
  function ao(r, c, g) {
    on();
    var m = ir++, x = lu;
    if (typeof r.$$FORM_ACTION == "function") {
      var N = null, D = qu;
      x = x.formState;
      var $ = r.$$IS_SIGNATURE_EQUAL;
      if (x !== null && typeof $ == "function") {
        var F = x[1];
        $.call(r, x[2], x[3]) && (N = g !== void 0 ? "p" + g : "k" + we(
          JSON.stringify([D, null, m]),
          0
        ), F === N && (Ni = m, c = x[0]));
      }
      var ee = r.bind(null, c);
      return r = function(ae) {
        ee(ae);
      }, typeof ee.$$FORM_ACTION == "function" && (r.$$FORM_ACTION = function(ae) {
        ae = ee.$$FORM_ACTION(ae), g !== void 0 && (g += "", ae.action = g);
        var ve = ae.data;
        return ve && (N === null && (N = g !== void 0 ? "p" + g : "k" + we(
          JSON.stringify([
            D,
            null,
            m
          ]),
          0
        )), ve.append("$ACTION_KEY", N)), ae;
      }), [c, r, !1];
    }
    var se = r.bind(null, c);
    return [
      c,
      function(ae) {
        se(ae);
      },
      !1
    ];
  }
  function nc(r) {
    var c = au;
    return au += 1, oi === null && (oi = []), Ku(oi, r, c);
  }
  function Xs() {
    throw Error(f(393));
  }
  var Io = {
    readContext: function(r) {
      return r._currentValue2;
    },
    use: function(r) {
      if (r !== null && typeof r == "object") {
        if (typeof r.then == "function") return nc(r);
        if (r.$$typeof === z)
          return r._currentValue2;
      }
      throw Error(f(438, String(r)));
    },
    useContext: function(r) {
      return on(), r._currentValue2;
    },
    useMemo: Or,
    useReducer: ec,
    useRef: function(r) {
      Ll = on(), ot = Ar();
      var c = ot.memoizedState;
      return c === null ? (r = { current: r }, ot.memoizedState = r) : c;
    },
    useState: function(r) {
      return ec($u, r);
    },
    useInsertionEffect: ml,
    useLayoutEffect: ml,
    useCallback: function(r, c) {
      return Or(function() {
        return r;
      }, c);
    },
    useImperativeHandle: ml,
    useEffect: ml,
    useDebugValue: ml,
    useDeferredValue: function(r, c) {
      return on(), c !== void 0 ? c : r;
    },
    useTransition: function() {
      return on(), [!1, Ys];
    },
    useId: function() {
      var r = ju.treeContext, c = r.overflow;
      r = r.id, r = (r & ~(1 << 32 - Ju(r) - 1)).toString(32) + c;
      var g = lc;
      if (g === null) throw Error(f(404));
      return c = va++, r = "_" + g.idPrefix + "R_" + r, 0 < c && (r += "H" + c.toString(32)), r + "_";
    },
    useSyncExternalStore: function(r, c, g) {
      if (g === void 0)
        throw Error(f(407));
      return g();
    },
    useOptimistic: function(r) {
      return on(), [r, Gs];
    },
    useActionState: ao,
    useFormState: ao,
    useHostTransitionStatus: function() {
      return on(), be;
    },
    useMemoCache: function(r) {
      for (var c = Array(r), g = 0; g < r; g++)
        c[g] = de;
      return c;
    },
    useCacheRefresh: function() {
      return Xs;
    },
    useEffectEvent: function() {
      return Xo;
    }
  }, lc = null, Is = {
    getCacheForType: function() {
      throw Error(f(248));
    },
    cacheSignal: function() {
      throw Error(f(248));
    }
  }, io, ro;
  function Cr(r) {
    if (io === void 0)
      try {
        throw Error();
      } catch (g) {
        var c = g.stack.trim().match(/\n( *(at )?)/);
        io = c && c[1] || "", ro = -1 < g.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < g.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + io + r + ro;
  }
  var uo = !1;
  function ac(r, c) {
    if (!r || uo) return "";
    uo = !0;
    var g = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var m = {
        DetermineComponentFrameRoot: function() {
          try {
            if (c) {
              var ae = function() {
                throw Error();
              };
              if (Object.defineProperty(ae.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(ae, []);
                } catch (Be) {
                  var ve = Be;
                }
                Reflect.construct(r, [], ae);
              } else {
                try {
                  ae.call();
                } catch (Be) {
                  ve = Be;
                }
                r.call(ae.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (Be) {
                ve = Be;
              }
              (ae = r()) && typeof ae.catch == "function" && ae.catch(function() {
              });
            }
          } catch (Be) {
            if (Be && ve && typeof Be.stack == "string")
              return [Be.stack, ve.stack];
          }
          return [null, null];
        }
      };
      m.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var x = Object.getOwnPropertyDescriptor(
        m.DetermineComponentFrameRoot,
        "name"
      );
      x && x.configurable && Object.defineProperty(
        m.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var N = m.DetermineComponentFrameRoot(), D = N[0], $ = N[1];
      if (D && $) {
        var F = D.split(`
`), ee = $.split(`
`);
        for (x = m = 0; m < F.length && !F[m].includes("DetermineComponentFrameRoot"); )
          m++;
        for (; x < ee.length && !ee[x].includes(
          "DetermineComponentFrameRoot"
        ); )
          x++;
        if (m === F.length || x === ee.length)
          for (m = F.length - 1, x = ee.length - 1; 1 <= m && 0 <= x && F[m] !== ee[x]; )
            x--;
        for (; 1 <= m && 0 <= x; m--, x--)
          if (F[m] !== ee[x]) {
            if (m !== 1 || x !== 1)
              do
                if (m--, x--, 0 > x || F[m] !== ee[x]) {
                  var se = `
` + F[m].replace(" at new ", " at ");
                  return r.displayName && se.includes("<anonymous>") && (se = se.replace("<anonymous>", r.displayName)), se;
                }
              while (1 <= m && 0 <= x);
            break;
          }
      }
    } finally {
      uo = !1, Error.prepareStackTrace = g;
    }
    return (g = r ? r.displayName || r.name : "") ? Cr(g) : "";
  }
  function Zo(r) {
    if (typeof r == "string") return Cr(r);
    if (typeof r == "function")
      return r.prototype && r.prototype.isReactComponent ? ac(r, !0) : ac(r, !1);
    if (typeof r == "object" && r !== null) {
      switch (r.$$typeof) {
        case H:
          return ac(r.render, !1);
        case ce:
          return ac(r.type, !1);
        case le:
          var c = r, g = c._payload;
          c = c._init;
          try {
            r = c(g);
          } catch {
            return Cr("Lazy");
          }
          return Zo(r);
      }
      if (typeof r.name == "string") {
        e: {
          g = r.name, c = r.env;
          var m = r.debugLocation;
          if (m != null && (r = Error.prepareStackTrace, Error.prepareStackTrace = void 0, m = m.stack, Error.prepareStackTrace = r, m.startsWith(`Error: react-stack-top-frame
`) && (m = m.slice(29)), r = m.indexOf(`
`), r !== -1 && (m = m.slice(r + 1)), r = m.indexOf("react_stack_bottom_frame"), r !== -1 && (r = m.lastIndexOf(`
`, r)), r = r !== -1 ? m = m.slice(0, r) : "", m = r.lastIndexOf(`
`), r = m === -1 ? r : r.slice(m + 1), r.indexOf(g) !== -1)) {
            g = `
` + r;
            break e;
          }
          g = Cr(
            g + (c ? " [" + c + "]" : "")
          );
        }
        return g;
      }
    }
    switch (r) {
      case Y:
        return Cr("SuspenseList");
      case Z:
        return Cr("Suspense");
    }
    return "";
  }
  function zi(r, c) {
    return (500 < c.byteSize || !1) && c.contentPreamble === null;
  }
  function Zs(r) {
    if (typeof r == "object" && r !== null && typeof r.environmentName == "string") {
      var c = r.environmentName;
      r = [r].slice(0), typeof r[0] == "string" ? r.splice(
        0,
        1,
        "[%s] " + r[0],
        " " + c + " "
      ) : r.splice(0, 0, "[%s]", " " + c + " "), r.unshift(console), c = Qu.apply(console.error, r), c();
    } else console.error(r);
    return null;
  }
  function Vs(r, c, g, m, x, N, D, $, F, ee, se) {
    var ae = /* @__PURE__ */ new Set();
    this.destination = null, this.flushScheduled = !1, this.resumableState = r, this.renderState = c, this.rootFormatContext = g, this.progressiveChunkSize = m === void 0 ? 12800 : m, this.status = 10, this.fatalError = null, this.pendingRootTasks = this.allPendingTasks = this.nextSegmentId = 0, this.completedPreambleSegments = this.completedRootSegment = null, this.byteSize = 0, this.abortableTasks = ae, this.pingedTasks = [], this.clientRenderedBoundaries = [], this.completedBoundaries = [], this.partialBoundaries = [], this.trackedPostpones = null, this.onError = x === void 0 ? Zs : x, this.onPostpone = ee === void 0 ? ml : ee, this.onAllReady = N === void 0 ? ml : N, this.onShellReady = D === void 0 ? ml : D, this.onShellError = $ === void 0 ? ml : $, this.onFatalError = F === void 0 ? ml : F, this.formState = se === void 0 ? null : se;
  }
  function Qs(r, c, g, m, x, N, D, $, F, ee, se, ae) {
    return c = new Vs(
      c,
      g,
      m,
      x,
      N,
      D,
      $,
      F,
      ee,
      se,
      ae
    ), g = rr(
      c,
      0,
      null,
      m,
      !1,
      !1
    ), g.parentFlushed = !0, r = ic(
      c,
      null,
      r,
      -1,
      null,
      g,
      null,
      null,
      c.abortableTasks,
      null,
      m,
      null,
      Fo,
      null,
      null
    ), Di(r), c.pingedTasks.push(r), c;
  }
  var Zn = null;
  function Rr(r, c) {
    r.pingedTasks.push(c), r.pingedTasks.length === 1 && (r.flushScheduled = r.destination !== null, Wo(r));
  }
  function co(r, c, g, m, x) {
    return g = {
      status: 0,
      rootSegmentID: -1,
      parentFlushed: !1,
      pendingTasks: 0,
      row: c,
      completedSegments: [],
      byteSize: 0,
      fallbackAbortableTasks: g,
      errorDigest: null,
      contentState: _t(),
      fallbackState: _t(),
      contentPreamble: m,
      fallbackPreamble: x,
      trackedContentKeyPath: null,
      trackedFallbackNode: null
    }, c !== null && (c.pendingTasks++, m = c.boundaries, m !== null && (r.allPendingTasks++, g.pendingTasks++, m.push(g)), r = c.inheritedHoistables, r !== null && Wl(g.contentState, r)), g;
  }
  function ic(r, c, g, m, x, N, D, $, F, ee, se, ae, ve, Be, Ie) {
    r.allPendingTasks++, x === null ? r.pendingRootTasks++ : x.pendingTasks++, Be !== null && Be.pendingTasks++;
    var Ze = {
      replay: null,
      node: g,
      childIndex: m,
      ping: function() {
        return Rr(r, Ze);
      },
      blockedBoundary: x,
      blockedSegment: N,
      blockedPreamble: D,
      hoistableState: $,
      abortSet: F,
      keyPath: ee,
      formatContext: se,
      context: ae,
      treeContext: ve,
      row: Be,
      componentStack: Ie,
      thenableState: c
    };
    return F.add(Ze), Ze;
  }
  function Vo(r, c, g, m, x, N, D, $, F, ee, se, ae, ve, Be) {
    r.allPendingTasks++, N === null ? r.pendingRootTasks++ : N.pendingTasks++, ve !== null && ve.pendingTasks++, g.pendingTasks++;
    var Ie = {
      replay: g,
      node: m,
      childIndex: x,
      ping: function() {
        return Rr(r, Ie);
      },
      blockedBoundary: N,
      blockedSegment: null,
      blockedPreamble: null,
      hoistableState: D,
      abortSet: $,
      keyPath: F,
      formatContext: ee,
      context: se,
      treeContext: ae,
      row: ve,
      componentStack: Be,
      thenableState: c
    };
    return $.add(Ie), Ie;
  }
  function rr(r, c, g, m, x, N) {
    return {
      status: 0,
      parentFlushed: !1,
      id: -1,
      index: c,
      chunks: [],
      children: [],
      preambleChildren: [],
      parentFormatContext: m,
      boundary: g,
      lastPushedText: x,
      textEmbedded: N
    };
  }
  function Di(r) {
    var c = r.node;
    if (typeof c == "object" && c !== null)
      switch (c.$$typeof) {
        case v:
          r.componentStack = { parent: r.componentStack, type: c.type };
      }
  }
  function uu(r) {
    return r === null ? null : { parent: r.parent, type: "Suspense Fallback" };
  }
  function ki(r) {
    var c = {};
    return r && Object.defineProperty(c, "componentStack", {
      configurable: !0,
      enumerable: !0,
      get: function() {
        try {
          var g = "", m = r;
          do
            g += Zo(m.type), m = m.parent;
          while (m);
          var x = g;
        } catch (N) {
          x = `
Error generating stack: ` + N.message + `
` + N.stack;
        }
        return Object.defineProperty(c, "componentStack", {
          value: x
        }), x;
      }
    }), c;
  }
  function rl(r, c, g) {
    if (r = r.onError, c = r(c, g), c == null || typeof c == "string") return c;
  }
  function Li(r, c) {
    var g = r.onShellError, m = r.onFatalError;
    g(c), m(c), r.destination !== null ? (r.status = 14, r.destination.destroy(c)) : (r.status = 13, r.fatalError = c);
  }
  function Ot(r, c) {
    Ia(r, c.next, c.hoistables);
  }
  function Ia(r, c, g) {
    for (; c !== null; ) {
      g !== null && (Wl(c.hoistables, g), c.inheritedHoistables = g);
      var m = c.boundaries;
      if (m !== null) {
        c.boundaries = null;
        for (var x = 0; x < m.length; x++) {
          var N = m[x];
          g !== null && Wl(N.contentState, g), Ui(r, N, null, null);
        }
      }
      if (c.pendingTasks--, 0 < c.pendingTasks) break;
      g = c.hoistables, c = c.next;
    }
  }
  function rc(r, c) {
    var g = c.boundaries;
    if (g !== null && c.pendingTasks === g.length) {
      for (var m = !0, x = 0; x < g.length; x++) {
        var N = g[x];
        if (N.pendingTasks !== 1 || N.parentFlushed || zi(r, N)) {
          m = !1;
          break;
        }
      }
      m && Ia(r, c, c.hoistables);
    }
  }
  function _r(r) {
    var c = {
      pendingTasks: 1,
      boundaries: null,
      hoistables: _t(),
      inheritedHoistables: null,
      together: !1,
      next: null
    };
    return r !== null && 0 < r.pendingTasks && (c.pendingTasks++, c.boundaries = [], r.next = c), c;
  }
  function oo(r, c, g, m, x) {
    var N = c.keyPath, D = c.treeContext, $ = c.row;
    c.keyPath = g, g = m.length;
    var F = null;
    if (c.replay !== null) {
      var ee = c.replay.slots;
      if (ee !== null && typeof ee == "object")
        for (var se = 0; se < g; se++) {
          var ae = x !== "backwards" && x !== "unstable_legacy-backwards" ? se : g - 1 - se, ve = m[ae];
          c.row = F = _r(
            F
          ), c.treeContext = ha(D, g, ae);
          var Be = ee[ae];
          typeof Be == "number" ? (cc(r, c, Be, ve, ae), delete ee[ae]) : Dn(r, c, ve, ae), --F.pendingTasks === 0 && Ot(r, F);
        }
      else
        for (ee = 0; ee < g; ee++)
          se = x !== "backwards" && x !== "unstable_legacy-backwards" ? ee : g - 1 - ee, ae = m[se], c.row = F = _r(F), c.treeContext = ha(D, g, se), Dn(r, c, ae, se), --F.pendingTasks === 0 && Ot(r, F);
    } else if (x !== "backwards" && x !== "unstable_legacy-backwards")
      for (x = 0; x < g; x++)
        ee = m[x], c.row = F = _r(F), c.treeContext = ha(
          D,
          g,
          x
        ), Dn(r, c, ee, x), --F.pendingTasks === 0 && Ot(r, F);
    else {
      for (x = c.blockedSegment, ee = x.children.length, se = x.chunks.length, ae = g - 1; 0 <= ae; ae--) {
        ve = m[ae], c.row = F = _r(
          F
        ), c.treeContext = ha(D, g, ae), Be = rr(
          r,
          se,
          null,
          c.formatContext,
          ae === 0 ? x.lastPushedText : !0,
          !0
        ), x.children.splice(ee, 0, Be), c.blockedSegment = Be;
        try {
          Dn(r, c, ve, ae), cn(
            Be.chunks,
            r.renderState,
            Be.lastPushedText,
            Be.textEmbedded
          ), Be.status = 1, --F.pendingTasks === 0 && Ot(r, F);
        } catch (Ie) {
          throw Be.status = r.status === 12 ? 3 : 4, Ie;
        }
      }
      c.blockedSegment = x, x.lastPushedText = !1;
    }
    $ !== null && F !== null && 0 < F.pendingTasks && ($.pendingTasks++, F.next = $), c.treeContext = D, c.row = $, c.keyPath = N;
  }
  function uc(r, c, g, m, x, N) {
    var D = c.thenableState;
    for (c.thenableState = null, Ll = {}, ju = c, lu = r, qu = g, ir = va = 0, Ni = -1, au = 0, oi = D, r = m(x, N); _i; )
      _i = !1, ir = va = 0, Ni = -1, au = 0, iu += 1, ot = null, r = m(x, N);
    return ru(), r;
  }
  function so(r, c, g, m, x, N, D) {
    var $ = !1;
    if (N !== 0 && r.formState !== null) {
      var F = c.blockedSegment;
      if (F !== null) {
        $ = !0, F = F.chunks;
        for (var ee = 0; ee < N; ee++)
          ee === D ? F.push("<!--F!-->") : F.push("<!--F-->");
      }
    }
    N = c.keyPath, c.keyPath = g, x ? (g = c.treeContext, c.treeContext = ha(g, 1, 0), Dn(r, c, m, -1), c.treeContext = g) : $ ? Dn(r, c, m, -1) : ya(r, c, m, -1), c.keyPath = N;
  }
  function si(r, c, g, m, x, N) {
    if (typeof m == "function")
      if (m.prototype && m.prototype.isReactComponent) {
        var D = x;
        if ("ref" in x) {
          D = {};
          for (var $ in x)
            $ !== "ref" && (D[$] = x[$]);
        }
        var F = m.defaultProps;
        if (F) {
          D === x && (D = Ce({}, D, x));
          for (var ee in F)
            D[ee] === void 0 && (D[ee] = F[ee]);
        }
        x = D, D = Tn, F = m.contextType, typeof F == "object" && F !== null && (D = F._currentValue2), D = new m(x, D);
        var se = D.state !== void 0 ? D.state : null;
        if (D.updater = to, D.props = x, D.state = se, F = { queue: [], replace: !1 }, D._reactInternals = F, N = m.contextType, D.context = typeof N == "object" && N !== null ? N._currentValue2 : Tn, N = m.getDerivedStateFromProps, typeof N == "function" && (N = N(x, se), se = N == null ? se : Ce({}, se, N), D.state = se), typeof m.getDerivedStateFromProps != "function" && typeof D.getSnapshotBeforeUpdate != "function" && (typeof D.UNSAFE_componentWillMount == "function" || typeof D.componentWillMount == "function"))
          if (m = D.state, typeof D.componentWillMount == "function" && D.componentWillMount(), typeof D.UNSAFE_componentWillMount == "function" && D.UNSAFE_componentWillMount(), m !== D.state && to.enqueueReplaceState(
            D,
            D.state,
            null
          ), F.queue !== null && 0 < F.queue.length)
            if (m = F.queue, N = F.replace, F.queue = null, F.replace = !1, N && m.length === 1)
              D.state = m[0];
            else {
              for (F = N ? m[0] : D.state, se = !0, N = N ? 1 : 0; N < m.length; N++)
                ee = m[N], ee = typeof ee == "function" ? ee.call(D, F, x, void 0) : ee, ee != null && (se ? (se = !1, F = Ce({}, F, ee)) : Ce(F, ee));
              D.state = F;
            }
          else F.queue = null;
        if (m = D.render(), r.status === 12) throw null;
        x = c.keyPath, c.keyPath = g, ya(r, c, m, -1), c.keyPath = x;
      } else {
        if (m = uc(r, c, g, m, x, void 0), r.status === 12) throw null;
        so(
          r,
          c,
          g,
          m,
          va !== 0,
          ir,
          Ni
        );
      }
    else if (typeof m == "string")
      if (D = c.blockedSegment, D === null)
        D = x.children, F = c.formatContext, se = c.keyPath, c.formatContext = wi(F, m, x), c.keyPath = g, Dn(r, c, D, -1), c.formatContext = F, c.keyPath = se;
      else {
        if (se = yn(
          D.chunks,
          m,
          x,
          r.resumableState,
          r.renderState,
          c.blockedPreamble,
          c.hoistableState,
          c.formatContext,
          D.lastPushedText
        ), D.lastPushedText = !1, F = c.formatContext, N = c.keyPath, c.keyPath = g, (c.formatContext = wi(F, m, x)).insertionMode === 3) {
          g = rr(
            r,
            0,
            null,
            c.formatContext,
            !1,
            !1
          ), D.preambleChildren.push(g), c.blockedSegment = g;
          try {
            g.status = 6, Dn(r, c, se, -1), cn(
              g.chunks,
              r.renderState,
              g.lastPushedText,
              g.textEmbedded
            ), g.status = 1;
          } finally {
            c.blockedSegment = D;
          }
        } else Dn(r, c, se, -1);
        c.formatContext = F, c.keyPath = N;
        e: {
          switch (c = D.chunks, r = r.resumableState, m) {
            case "title":
            case "style":
            case "script":
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
              break e;
            case "body":
              if (1 >= F.insertionMode) {
                r.hasBody = !0;
                break e;
              }
              break;
            case "html":
              if (F.insertionMode === 0) {
                r.hasHtml = !0;
                break e;
              }
              break;
            case "head":
              if (1 >= F.insertionMode) break e;
          }
          c.push(Vl(m));
        }
        D.lastPushedText = !1;
      }
    else {
      switch (m) {
        case ye:
        case w:
        case O:
        case T:
          m = c.keyPath, c.keyPath = g, ya(r, c, x.children, -1), c.keyPath = m;
          return;
        case he:
          m = c.blockedSegment, m === null ? x.mode !== "hidden" && (m = c.keyPath, c.keyPath = g, Dn(r, c, x.children, -1), c.keyPath = m) : x.mode !== "hidden" && (r.renderState.generateStaticMarkup || m.chunks.push("<!--&-->"), m.lastPushedText = !1, D = c.keyPath, c.keyPath = g, Dn(r, c, x.children, -1), c.keyPath = D, r.renderState.generateStaticMarkup || m.chunks.push("<!--/&-->"), m.lastPushedText = !1);
          return;
        case Y:
          e: {
            if (m = x.children, x = x.revealOrder, x === "forwards" || x === "backwards" || x === "unstable_legacy-backwards") {
              if (xe(m)) {
                oo(r, c, g, m, x);
                break e;
              }
              if ((D = pe(m)) && (D = D.call(m))) {
                if (F = D.next(), !F.done) {
                  do
                    F = D.next();
                  while (!F.done);
                  oo(r, c, g, m, x);
                }
                break e;
              }
            }
            x === "together" ? (x = c.keyPath, D = c.row, F = c.row = _r(null), F.boundaries = [], F.together = !0, c.keyPath = g, ya(r, c, m, -1), --F.pendingTasks === 0 && Ot(r, F), c.keyPath = x, c.row = D, D !== null && 0 < F.pendingTasks && (D.pendingTasks++, F.next = D)) : (x = c.keyPath, c.keyPath = g, ya(r, c, m, -1), c.keyPath = x);
          }
          return;
        case ze:
        case K:
          throw Error(f(343));
        case Z:
          e: if (c.replay !== null) {
            m = c.keyPath, D = c.formatContext, F = c.row, c.keyPath = g, c.formatContext = Il(
              r.resumableState,
              D
            ), c.row = null, g = x.children;
            try {
              Dn(r, c, g, -1);
            } finally {
              c.keyPath = m, c.formatContext = D, c.row = F;
            }
          } else {
            m = c.keyPath, N = c.formatContext;
            var ae = c.row, ve = c.blockedBoundary;
            ee = c.blockedPreamble;
            var Be = c.hoistableState;
            $ = c.blockedSegment;
            var Ie = x.fallback;
            x = x.children;
            var Ze = /* @__PURE__ */ new Set(), Ke = co(
              r,
              c.row,
              Ze,
              null,
              null
            );
            r.trackedPostpones !== null && (Ke.trackedContentKeyPath = g);
            var Qe = rr(
              r,
              $.chunks.length,
              Ke,
              c.formatContext,
              !1,
              !1
            );
            $.children.push(Qe), $.lastPushedText = !1;
            var je = rr(
              r,
              0,
              null,
              c.formatContext,
              !1,
              !1
            );
            if (je.parentFlushed = !0, r.trackedPostpones !== null) {
              D = c.componentStack, F = [g[0], "Suspense Fallback", g[2]], se = [F[1], F[2], [], null], r.trackedPostpones.workingMap.set(F, se), Ke.trackedFallbackNode = se, c.blockedSegment = Qe, c.blockedPreamble = Ke.fallbackPreamble, c.keyPath = F, c.formatContext = $i(
                r.resumableState,
                N
              ), c.componentStack = uu(D), Qe.status = 6;
              try {
                Dn(r, c, Ie, -1), cn(
                  Qe.chunks,
                  r.renderState,
                  Qe.lastPushedText,
                  Qe.textEmbedded
                ), Qe.status = 1;
              } catch (Vt) {
                throw Qe.status = r.status === 12 ? 3 : 4, Vt;
              } finally {
                c.blockedSegment = $, c.blockedPreamble = ee, c.keyPath = m, c.formatContext = N;
              }
              c = ic(
                r,
                null,
                x,
                -1,
                Ke,
                je,
                Ke.contentPreamble,
                Ke.contentState,
                c.abortSet,
                g,
                Il(
                  r.resumableState,
                  c.formatContext
                ),
                c.context,
                c.treeContext,
                null,
                D
              ), Di(c), r.pingedTasks.push(c);
            } else {
              c.blockedBoundary = Ke, c.blockedPreamble = Ke.contentPreamble, c.hoistableState = Ke.contentState, c.blockedSegment = je, c.keyPath = g, c.formatContext = Il(
                r.resumableState,
                N
              ), c.row = null, je.status = 6;
              try {
                if (Dn(r, c, x, -1), cn(
                  je.chunks,
                  r.renderState,
                  je.lastPushedText,
                  je.textEmbedded
                ), je.status = 1, fu(Ke, je), Ke.pendingTasks === 0 && Ke.status === 0) {
                  if (Ke.status = 1, !zi(r, Ke)) {
                    ae !== null && --ae.pendingTasks === 0 && Ot(r, ae), r.pendingRootTasks === 0 && c.blockedPreamble && kn(r);
                    break e;
                  }
                } else
                  ae !== null && ae.together && rc(r, ae);
              } catch (Vt) {
                Ke.status = 4, r.status === 12 ? (je.status = 3, D = r.fatalError) : (je.status = 4, D = Vt), F = ki(c.componentStack), se = rl(
                  r,
                  D,
                  F
                ), Ke.errorDigest = se, Hi(r, Ke);
              } finally {
                c.blockedBoundary = ve, c.blockedPreamble = ee, c.hoistableState = Be, c.blockedSegment = $, c.keyPath = m, c.formatContext = N, c.row = ae;
              }
              c = ic(
                r,
                null,
                Ie,
                -1,
                ve,
                Qe,
                Ke.fallbackPreamble,
                Ke.fallbackState,
                Ze,
                [g[0], "Suspense Fallback", g[2]],
                $i(
                  r.resumableState,
                  c.formatContext
                ),
                c.context,
                c.treeContext,
                c.row,
                uu(
                  c.componentStack
                )
              ), Di(c), r.pingedTasks.push(c);
            }
          }
          return;
      }
      if (typeof m == "object" && m !== null)
        switch (m.$$typeof) {
          case H:
            if ("ref" in x)
              for (Ie in D = {}, x)
                Ie !== "ref" && (D[Ie] = x[Ie]);
            else D = x;
            m = uc(
              r,
              c,
              g,
              m.render,
              D,
              N
            ), so(
              r,
              c,
              g,
              m,
              va !== 0,
              ir,
              Ni
            );
            return;
          case ce:
            si(r, c, g, m.type, x, N);
            return;
          case z:
            if (F = x.children, D = c.keyPath, x = x.value, se = m._currentValue2, m._currentValue2 = x, N = Ya, Ya = m = {
              parent: N,
              depth: N === null ? 0 : N.depth + 1,
              context: m,
              parentValue: se,
              value: x
            }, c.context = m, c.keyPath = g, ya(r, c, F, -1), r = Ya, r === null) throw Error(f(403));
            r.context._currentValue2 = r.parentValue, r = Ya = r.parent, c.context = r, c.keyPath = D;
            return;
          case _:
            x = x.children, m = x(m._context._currentValue2), x = c.keyPath, c.keyPath = g, ya(r, c, m, -1), c.keyPath = x;
            return;
          case le:
            if (D = m._init, m = D(m._payload), r.status === 12) throw null;
            si(r, c, g, m, x, N);
            return;
        }
      throw Error(
        f(130, m == null ? m : typeof m, "")
      );
    }
  }
  function cc(r, c, g, m, x) {
    var N = c.replay, D = c.blockedBoundary, $ = rr(
      r,
      0,
      null,
      c.formatContext,
      !1,
      !1
    );
    $.id = g, $.parentFlushed = !0;
    try {
      c.replay = null, c.blockedSegment = $, Dn(r, c, m, x), $.status = 1, D === null ? r.completedRootSegment = $ : (fu(D, $), D.parentFlushed && r.partialBoundaries.push(D));
    } finally {
      c.replay = N, c.blockedSegment = null;
    }
  }
  function ya(r, c, g, m) {
    c.replay !== null && typeof c.replay.slots == "number" ? cc(r, c, c.replay.slots, g, m) : (c.node = g, c.childIndex = m, g = c.componentStack, Di(c), fo(r, c), c.componentStack = g);
  }
  function fo(r, c) {
    var g = c.node, m = c.childIndex;
    if (g !== null) {
      if (typeof g == "object") {
        switch (g.$$typeof) {
          case v:
            var x = g.type, N = g.key, D = g.props;
            g = D.ref;
            var $ = g !== void 0 ? g : null, F = nr(x), ee = N ?? (m === -1 ? 0 : m);
            if (N = [c.keyPath, F, ee], c.replay !== null)
              e: {
                var se = c.replay;
                for (m = se.nodes, g = 0; g < m.length; g++) {
                  var ae = m[g];
                  if (ee === ae[1]) {
                    if (ae.length === 4) {
                      if (F !== null && F !== ae[0])
                        throw Error(
                          f(490, ae[0], F)
                        );
                      var ve = ae[2];
                      F = ae[3], ee = c.node, c.replay = {
                        nodes: ve,
                        slots: F,
                        pendingTasks: 1
                      };
                      try {
                        if (si(r, c, N, x, D, $), c.replay.pendingTasks === 1 && 0 < c.replay.nodes.length)
                          throw Error(f(488));
                        c.replay.pendingTasks--;
                      } catch (ft) {
                        if (typeof ft == "object" && ft !== null && (ft === Jl || typeof ft.then == "function"))
                          throw c.node === ee ? c.replay = se : m.splice(g, 1), ft;
                        c.replay.pendingTasks--, D = ki(c.componentStack), N = r, r = c.blockedBoundary, x = ft, D = rl(N, x, D), fi(
                          N,
                          r,
                          ve,
                          F,
                          x,
                          D
                        );
                      }
                      c.replay = se;
                    } else {
                      if (x !== Z)
                        throw Error(
                          f(
                            490,
                            "Suspense",
                            nr(x) || "Unknown"
                          )
                        );
                      t: {
                        se = void 0, x = ae[5], $ = ae[2], F = ae[3], ee = ae[4] === null ? [] : ae[4][2], ae = ae[4] === null ? null : ae[4][3];
                        var Be = c.keyPath, Ie = c.formatContext, Ze = c.row, Ke = c.replay, Qe = c.blockedBoundary, je = c.hoistableState, Vt = D.children, Mt = D.fallback, st = /* @__PURE__ */ new Set();
                        D = co(
                          r,
                          c.row,
                          st,
                          null,
                          null
                        ), D.parentFlushed = !0, D.rootSegmentID = x, c.blockedBoundary = D, c.hoistableState = D.contentState, c.keyPath = N, c.formatContext = Il(
                          r.resumableState,
                          Ie
                        ), c.row = null, c.replay = {
                          nodes: $,
                          slots: F,
                          pendingTasks: 1
                        };
                        try {
                          if (Dn(r, c, Vt, -1), c.replay.pendingTasks === 1 && 0 < c.replay.nodes.length)
                            throw Error(f(488));
                          if (c.replay.pendingTasks--, D.pendingTasks === 0 && D.status === 0) {
                            D.status = 1, r.completedBoundaries.push(D);
                            break t;
                          }
                        } catch (ft) {
                          D.status = 4, ve = ki(c.componentStack), se = rl(
                            r,
                            ft,
                            ve
                          ), D.errorDigest = se, c.replay.pendingTasks--, r.clientRenderedBoundaries.push(D);
                        } finally {
                          c.blockedBoundary = Qe, c.hoistableState = je, c.replay = Ke, c.keyPath = Be, c.formatContext = Ie, c.row = Ze;
                        }
                        ve = Vo(
                          r,
                          null,
                          {
                            nodes: ee,
                            slots: ae,
                            pendingTasks: 0
                          },
                          Mt,
                          -1,
                          Qe,
                          D.fallbackState,
                          st,
                          [N[0], "Suspense Fallback", N[2]],
                          $i(
                            r.resumableState,
                            c.formatContext
                          ),
                          c.context,
                          c.treeContext,
                          c.row,
                          uu(
                            c.componentStack
                          )
                        ), Di(ve), r.pingedTasks.push(ve);
                      }
                    }
                    m.splice(g, 1);
                    break e;
                  }
                }
              }
            else si(r, c, N, x, D, $);
            return;
          case y:
            throw Error(f(257));
          case le:
            if (ve = g._init, g = ve(g._payload), r.status === 12) throw null;
            ya(r, c, g, m);
            return;
        }
        if (xe(g)) {
          cu(r, c, g, m);
          return;
        }
        if ((ve = pe(g)) && (ve = ve.call(g))) {
          if (g = ve.next(), !g.done) {
            D = [];
            do
              D.push(g.value), g = ve.next();
            while (!g.done);
            cu(r, c, D, m);
          }
          return;
        }
        if (typeof g.then == "function")
          return c.thenableState = null, ya(r, c, nc(g), m);
        if (g.$$typeof === z)
          return ya(
            r,
            c,
            g._currentValue2,
            m
          );
        throw m = Object.prototype.toString.call(g), Error(
          f(
            31,
            m === "[object Object]" ? "object with keys {" + Object.keys(g).join(", ") + "}" : m
          )
        );
      }
      typeof g == "string" ? (m = c.blockedSegment, m !== null && (m.lastPushedText = bl(
        m.chunks,
        g,
        r.renderState,
        m.lastPushedText
      ))) : (typeof g == "number" || typeof g == "bigint") && (m = c.blockedSegment, m !== null && (m.lastPushedText = bl(
        m.chunks,
        "" + g,
        r.renderState,
        m.lastPushedText
      )));
    }
  }
  function cu(r, c, g, m) {
    var x = c.keyPath;
    if (m !== -1 && (c.keyPath = [c.keyPath, "Fragment", m], c.replay !== null)) {
      for (var N = c.replay, D = N.nodes, $ = 0; $ < D.length; $++) {
        var F = D[$];
        if (F[1] === m) {
          m = F[2], F = F[3], c.replay = { nodes: m, slots: F, pendingTasks: 1 };
          try {
            if (cu(r, c, g, -1), c.replay.pendingTasks === 1 && 0 < c.replay.nodes.length)
              throw Error(f(488));
            c.replay.pendingTasks--;
          } catch (ae) {
            if (typeof ae == "object" && ae !== null && (ae === Jl || typeof ae.then == "function"))
              throw ae;
            c.replay.pendingTasks--, g = ki(c.componentStack);
            var ee = c.blockedBoundary, se = ae;
            g = rl(r, se, g), fi(
              r,
              ee,
              m,
              F,
              se,
              g
            );
          }
          c.replay = N, D.splice($, 1);
          break;
        }
      }
      c.keyPath = x;
      return;
    }
    if (N = c.treeContext, D = g.length, c.replay !== null && ($ = c.replay.slots, $ !== null && typeof $ == "object")) {
      for (m = 0; m < D; m++)
        F = g[m], c.treeContext = ha(N, D, m), ee = $[m], typeof ee == "number" ? (cc(r, c, ee, F, m), delete $[m]) : Dn(r, c, F, m);
      c.treeContext = N, c.keyPath = x;
      return;
    }
    for ($ = 0; $ < D; $++)
      m = g[$], c.treeContext = ha(N, D, $), Dn(r, c, m, $);
    c.treeContext = N, c.keyPath = x;
  }
  function Nr(r, c, g) {
    if (g.status = 5, g.rootSegmentID = r.nextSegmentId++, r = g.trackedContentKeyPath, r === null) throw Error(f(486));
    var m = g.trackedFallbackNode, x = [], N = c.workingMap.get(r);
    return N === void 0 ? (g = [
      r[1],
      r[2],
      x,
      null,
      m,
      g.rootSegmentID
    ], c.workingMap.set(r, g), Aa(g, r[0], c), g) : (N[4] = m, N[5] = g.rootSegmentID, N);
  }
  function Bi(r, c, g, m) {
    m.status = 5;
    var x = g.keyPath, N = g.blockedBoundary;
    if (N === null)
      m.id = r.nextSegmentId++, c.rootSlots = m.id, r.completedRootSegment !== null && (r.completedRootSegment.status = 5);
    else {
      if (N !== null && N.status === 0) {
        var D = Nr(
          r,
          c,
          N
        );
        if (N.trackedContentKeyPath === x && g.childIndex === -1) {
          m.id === -1 && (m.id = m.parentFlushed ? N.rootSegmentID : r.nextSegmentId++), D[3] = m.id;
          return;
        }
      }
      if (m.id === -1 && (m.id = m.parentFlushed && N !== null ? N.rootSegmentID : r.nextSegmentId++), g.childIndex === -1)
        x === null ? c.rootSlots = m.id : (g = c.workingMap.get(x), g === void 0 ? (g = [x[1], x[2], [], m.id], Aa(g, x[0], c)) : g[3] = m.id);
      else {
        if (x === null) {
          if (r = c.rootSlots, r === null)
            r = c.rootSlots = {};
          else if (typeof r == "number")
            throw Error(f(491));
        } else if (N = c.workingMap, D = N.get(x), D === void 0)
          r = {}, D = [x[1], x[2], [], r], N.set(x, D), Aa(D, x[0], c);
        else if (r = D[3], r === null)
          r = D[3] = {};
        else if (typeof r == "number")
          throw Error(f(491));
        r[g.childIndex] = m.id;
      }
    }
  }
  function Hi(r, c) {
    r = r.trackedPostpones, r !== null && (c = c.trackedContentKeyPath, c !== null && (c = r.workingMap.get(c), c !== void 0 && (c.length = 4, c[2] = [], c[3] = null)));
  }
  function oc(r, c, g) {
    return Vo(
      r,
      g,
      c.replay,
      c.node,
      c.childIndex,
      c.blockedBoundary,
      c.hoistableState,
      c.abortSet,
      c.keyPath,
      c.formatContext,
      c.context,
      c.treeContext,
      c.row,
      c.componentStack
    );
  }
  function ur(r, c, g) {
    var m = c.blockedSegment, x = rr(
      r,
      m.chunks.length,
      null,
      c.formatContext,
      m.lastPushedText,
      !0
    );
    return m.children.push(x), m.lastPushedText = !1, ic(
      r,
      g,
      c.node,
      c.childIndex,
      c.blockedBoundary,
      x,
      c.blockedPreamble,
      c.hoistableState,
      c.abortSet,
      c.keyPath,
      c.formatContext,
      c.context,
      c.treeContext,
      c.row,
      c.componentStack
    );
  }
  function Dn(r, c, g, m) {
    var x = c.formatContext, N = c.context, D = c.keyPath, $ = c.treeContext, F = c.componentStack, ee = c.blockedSegment;
    if (ee === null) {
      ee = c.replay;
      try {
        return ya(r, c, g, m);
      } catch (ve) {
        if (ru(), g = ve === Jl ? wr() : ve, r.status !== 12 && typeof g == "object" && g !== null) {
          if (typeof g.then == "function") {
            m = ve === Jl ? Xa() : null, r = oc(r, c, m).ping, g.then(r, r), c.formatContext = x, c.context = N, c.keyPath = D, c.treeContext = $, c.componentStack = F, c.replay = ee, Pl(N);
            return;
          }
          if (g.message === "Maximum call stack size exceeded") {
            g = ve === Jl ? Xa() : null, g = oc(r, c, g), r.pingedTasks.push(g), c.formatContext = x, c.context = N, c.keyPath = D, c.treeContext = $, c.componentStack = F, c.replay = ee, Pl(N);
            return;
          }
        }
      }
    } else {
      var se = ee.children.length, ae = ee.chunks.length;
      try {
        return ya(r, c, g, m);
      } catch (ve) {
        if (ru(), ee.children.length = se, ee.chunks.length = ae, g = ve === Jl ? wr() : ve, r.status !== 12 && typeof g == "object" && g !== null) {
          if (typeof g.then == "function") {
            ee = g, g = ve === Jl ? Xa() : null, r = ur(r, c, g).ping, ee.then(r, r), c.formatContext = x, c.context = N, c.keyPath = D, c.treeContext = $, c.componentStack = F, Pl(N);
            return;
          }
          if (g.message === "Maximum call stack size exceeded") {
            ee = ve === Jl ? Xa() : null, ee = ur(r, c, ee), r.pingedTasks.push(ee), c.formatContext = x, c.context = N, c.keyPath = D, c.treeContext = $, c.componentStack = F, Pl(N);
            return;
          }
        }
      }
    }
    throw c.formatContext = x, c.context = N, c.keyPath = D, c.treeContext = $, Pl(N), g;
  }
  function Qo(r) {
    var c = r.blockedBoundary, g = r.blockedSegment;
    g !== null && (g.status = 3, Ui(this, c, r.row, g));
  }
  function fi(r, c, g, m, x, N) {
    for (var D = 0; D < g.length; D++) {
      var $ = g[D];
      if ($.length === 4)
        fi(
          r,
          c,
          $[2],
          $[3],
          x,
          N
        );
      else {
        $ = $[5];
        var F = r, ee = N, se = co(
          F,
          null,
          /* @__PURE__ */ new Set(),
          null,
          null
        );
        se.parentFlushed = !0, se.rootSegmentID = $, se.status = 4, se.errorDigest = ee, se.parentFlushed && F.clientRenderedBoundaries.push(se);
      }
    }
    if (g.length = 0, m !== null) {
      if (c === null) throw Error(f(487));
      if (c.status !== 4 && (c.status = 4, c.errorDigest = N, c.parentFlushed && r.clientRenderedBoundaries.push(c)), typeof m == "object") for (var ae in m) delete m[ae];
    }
  }
  function ou(r, c, g) {
    var m = r.blockedBoundary, x = r.blockedSegment;
    if (x !== null) {
      if (x.status === 6) return;
      x.status = 3;
    }
    var N = ki(r.componentStack);
    if (m === null) {
      if (c.status !== 13 && c.status !== 14) {
        if (m = r.replay, m === null) {
          c.trackedPostpones !== null && x !== null ? (m = c.trackedPostpones, rl(c, g, N), Bi(c, m, r, x), Ui(c, null, r.row, x)) : (rl(c, g, N), Li(c, g));
          return;
        }
        m.pendingTasks--, m.pendingTasks === 0 && 0 < m.nodes.length && (x = rl(c, g, N), fi(
          c,
          null,
          m.nodes,
          m.slots,
          g,
          x
        )), c.pendingRootTasks--, c.pendingRootTasks === 0 && fc(c);
      }
    } else {
      var D = c.trackedPostpones;
      if (m.status !== 4) {
        if (D !== null && x !== null)
          return rl(c, g, N), Bi(c, D, r, x), m.fallbackAbortableTasks.forEach(function($) {
            return ou($, c, g);
          }), m.fallbackAbortableTasks.clear(), Ui(c, m, r.row, x);
        m.status = 4, x = rl(c, g, N), m.status = 4, m.errorDigest = x, Hi(c, m), m.parentFlushed && c.clientRenderedBoundaries.push(m);
      }
      m.pendingTasks--, x = m.row, x !== null && --x.pendingTasks === 0 && Ot(c, x), m.fallbackAbortableTasks.forEach(function($) {
        return ou($, c, g);
      }), m.fallbackAbortableTasks.clear();
    }
    r = r.row, r !== null && --r.pendingTasks === 0 && Ot(c, r), c.allPendingTasks--, c.allPendingTasks === 0 && su(c);
  }
  function sc(r, c) {
    try {
      var g = r.renderState, m = g.onHeaders;
      if (m) {
        var x = g.headers;
        if (x) {
          g.headers = null;
          var N = x.preconnects;
          if (x.fontPreloads && (N && (N += ", "), N += x.fontPreloads), x.highImagePreloads && (N && (N += ", "), N += x.highImagePreloads), !c) {
            var D = g.styles.values(), $ = D.next();
            e: for (; 0 < x.remainingCapacity && !$.done; $ = D.next())
              for (var F = $.value.sheets.values(), ee = F.next(); 0 < x.remainingCapacity && !ee.done; ee = F.next()) {
                var se = ee.value, ae = se.props, ve = ae.href, Be = se.props, Ie = ge(Be.href, "style", {
                  crossOrigin: Be.crossOrigin,
                  integrity: Be.integrity,
                  nonce: Be.nonce,
                  type: Be.type,
                  fetchPriority: Be.fetchPriority,
                  referrerPolicy: Be.referrerPolicy,
                  media: Be.media
                });
                if (0 <= (x.remainingCapacity -= Ie.length + 2))
                  g.resets.style[ve] = $e, N && (N += ", "), N += Ie, g.resets.style[ve] = typeof ae.crossOrigin == "string" || typeof ae.integrity == "string" ? [ae.crossOrigin, ae.integrity] : $e;
                else break e;
              }
          }
          m(N ? { Link: N } : {});
        }
      }
    } catch (Ze) {
      rl(r, Ze, {});
    }
  }
  function fc(r) {
    r.trackedPostpones === null && sc(r, !0), r.trackedPostpones === null && kn(r), r.onShellError = ml, r = r.onShellReady, r();
  }
  function su(r) {
    sc(
      r,
      r.trackedPostpones === null ? !0 : r.completedRootSegment === null || r.completedRootSegment.status !== 5
    ), kn(r), r = r.onAllReady, r();
  }
  function fu(r, c) {
    if (c.chunks.length === 0 && c.children.length === 1 && c.children[0].boundary === null && c.children[0].id === -1) {
      var g = c.children[0];
      g.id = c.id, g.parentFlushed = !0, g.status !== 1 && g.status !== 3 && g.status !== 4 || fu(r, g);
    } else r.completedSegments.push(c);
  }
  function Ui(r, c, g, m) {
    if (g !== null && (--g.pendingTasks === 0 ? Ot(r, g) : g.together && rc(r, g)), r.allPendingTasks--, c === null) {
      if (m !== null && m.parentFlushed) {
        if (r.completedRootSegment !== null)
          throw Error(f(389));
        r.completedRootSegment = m;
      }
      r.pendingRootTasks--, r.pendingRootTasks === 0 && fc(r);
    } else if (c.pendingTasks--, c.status !== 4)
      if (c.pendingTasks === 0) {
        if (c.status === 0 && (c.status = 1), m !== null && m.parentFlushed && (m.status === 1 || m.status === 3) && fu(c, m), c.parentFlushed && r.completedBoundaries.push(c), c.status === 1)
          g = c.row, g !== null && Wl(g.hoistables, c.contentState), zi(r, c) || (c.fallbackAbortableTasks.forEach(Qo, r), c.fallbackAbortableTasks.clear(), g !== null && --g.pendingTasks === 0 && Ot(r, g)), r.pendingRootTasks === 0 && r.trackedPostpones === null && c.contentPreamble !== null && kn(r);
        else if (c.status === 5 && (c = c.row, c !== null)) {
          if (r.trackedPostpones !== null) {
            g = r.trackedPostpones;
            var x = c.next;
            if (x !== null && (m = x.boundaries, m !== null))
              for (x.boundaries = null, x = 0; x < m.length; x++) {
                var N = m[x];
                Nr(r, g, N), Ui(r, N, null, null);
              }
          }
          --c.pendingTasks === 0 && Ot(r, c);
        }
      } else
        m === null || !m.parentFlushed || m.status !== 1 && m.status !== 3 || (fu(c, m), c.completedSegments.length === 1 && c.parentFlushed && r.partialBoundaries.push(c)), c = c.row, c !== null && c.together && rc(r, c);
    r.allPendingTasks === 0 && su(r);
  }
  function Wo(r) {
    if (r.status !== 14 && r.status !== 13) {
      var c = Ya, g = ut.H;
      ut.H = Io;
      var m = ut.A;
      ut.A = Is;
      var x = Zn;
      Zn = r;
      var N = lc;
      lc = r.resumableState;
      try {
        var D = r.pingedTasks, $;
        for ($ = 0; $ < D.length; $++) {
          var F = D[$], ee = r, se = F.blockedSegment;
          if (se === null) {
            var ae = ee;
            if (F.replay.pendingTasks !== 0) {
              Pl(F.context);
              try {
                if (typeof F.replay.slots == "number" ? cc(
                  ae,
                  F,
                  F.replay.slots,
                  F.node,
                  F.childIndex
                ) : fo(ae, F), F.replay.pendingTasks === 1 && 0 < F.replay.nodes.length)
                  throw Error(f(488));
                F.replay.pendingTasks--, F.abortSet.delete(F), Ui(
                  ae,
                  F.blockedBoundary,
                  F.row,
                  null
                );
              } catch (Ct) {
                ru();
                var ve = Ct === Jl ? wr() : Ct;
                if (typeof ve == "object" && ve !== null && typeof ve.then == "function") {
                  var Be = F.ping;
                  ve.then(Be, Be), F.thenableState = Ct === Jl ? Xa() : null;
                } else {
                  F.replay.pendingTasks--, F.abortSet.delete(F);
                  var Ie = ki(F.componentStack);
                  ee = void 0;
                  var Ze = ae, Ke = F.blockedBoundary, Qe = ae.status === 12 ? ae.fatalError : ve, je = F.replay.nodes, Vt = F.replay.slots;
                  ee = rl(
                    Ze,
                    Qe,
                    Ie
                  ), fi(
                    Ze,
                    Ke,
                    je,
                    Vt,
                    Qe,
                    ee
                  ), ae.pendingRootTasks--, ae.pendingRootTasks === 0 && fc(ae), ae.allPendingTasks--, ae.allPendingTasks === 0 && su(ae);
                }
              } finally {
              }
            }
          } else if (ae = void 0, Ze = se, Ze.status === 0) {
            Ze.status = 6, Pl(F.context);
            var Mt = Ze.children.length, st = Ze.chunks.length;
            try {
              fo(ee, F), cn(
                Ze.chunks,
                ee.renderState,
                Ze.lastPushedText,
                Ze.textEmbedded
              ), F.abortSet.delete(F), Ze.status = 1, Ui(
                ee,
                F.blockedBoundary,
                F.row,
                Ze
              );
            } catch (Ct) {
              ru(), Ze.children.length = Mt, Ze.chunks.length = st;
              var ft = Ct === Jl ? wr() : ee.status === 12 ? ee.fatalError : Ct;
              if (ee.status === 12 && ee.trackedPostpones !== null) {
                var tt = ee.trackedPostpones, Bl = ki(F.componentStack);
                F.abortSet.delete(F), rl(ee, ft, Bl), Bi(ee, tt, F, Ze), Ui(
                  ee,
                  F.blockedBoundary,
                  F.row,
                  Ze
                );
              } else if (typeof ft == "object" && ft !== null && typeof ft.then == "function") {
                Ze.status = 0, F.thenableState = Ct === Jl ? Xa() : null;
                var We = F.ping;
                ft.then(We, We);
              } else {
                var Tl = ki(F.componentStack);
                F.abortSet.delete(F), Ze.status = 4;
                var at = F.blockedBoundary, pn = F.row;
                if (pn !== null && --pn.pendingTasks === 0 && Ot(ee, pn), ee.allPendingTasks--, ae = rl(
                  ee,
                  ft,
                  Tl
                ), at === null) Li(ee, ft);
                else if (at.pendingTasks--, at.status !== 4) {
                  at.status = 4, at.errorDigest = ae, Hi(ee, at);
                  var sn = at.row;
                  sn !== null && --sn.pendingTasks === 0 && Ot(ee, sn), at.parentFlushed && ee.clientRenderedBoundaries.push(at), ee.pendingRootTasks === 0 && ee.trackedPostpones === null && at.contentPreamble !== null && kn(ee);
                }
                ee.allPendingTasks === 0 && su(ee);
              }
            } finally {
            }
          }
        }
        D.splice(0, $), r.destination !== null && hi(r, r.destination);
      } catch (Ct) {
        rl(r, Ct, {}), Li(r, Ct);
      } finally {
        lc = N, ut.H = g, ut.A = m, g === Io && Pl(c), Zn = x;
      }
    }
  }
  function cr(r, c, g) {
    c.preambleChildren.length && g.push(c.preambleChildren);
    for (var m = !1, x = 0; x < c.children.length; x++)
      m = du(
        r,
        c.children[x],
        g
      ) || m;
    return m;
  }
  function du(r, c, g) {
    var m = c.boundary;
    if (m === null)
      return cr(
        r,
        c,
        g
      );
    var x = m.contentPreamble, N = m.fallbackPreamble;
    if (x === null || N === null) return !1;
    switch (m.status) {
      case 1:
        if (Ua(r.renderState, x), r.byteSize += m.byteSize, c = m.completedSegments[0], !c) throw Error(f(391));
        return cr(
          r,
          c,
          g
        );
      case 5:
        if (r.trackedPostpones !== null) return !0;
      case 4:
        if (c.status === 1)
          return Ua(r.renderState, N), cr(
            r,
            c,
            g
          );
      default:
        return !0;
    }
  }
  function kn(r) {
    if (r.completedRootSegment && r.completedPreambleSegments === null) {
      var c = [], g = r.byteSize, m = du(
        r,
        r.completedRootSegment,
        c
      ), x = r.renderState.preamble;
      m === !1 || x.headChunks && x.bodyChunks ? r.completedPreambleSegments = c : r.byteSize = g;
    }
  }
  function Za(r, c, g, m) {
    switch (g.parentFlushed = !0, g.status) {
      case 0:
        g.id = r.nextSegmentId++;
      case 5:
        return m = g.id, g.lastPushedText = !1, g.textEmbedded = !1, r = r.renderState, c.push('<template id="'), c.push(r.placeholderPrefix), r = m.toString(16), c.push(r), c.push('"></template>');
      case 1:
        g.status = 2;
        var x = !0, N = g.chunks, D = 0;
        g = g.children;
        for (var $ = 0; $ < g.length; $++) {
          for (x = g[$]; D < x.index; D++)
            c.push(N[D]);
          x = Yi(r, c, x, m);
        }
        for (; D < N.length - 1; D++)
          c.push(N[D]);
        return D < N.length && (x = c.push(N[D])), x;
      case 3:
        return !0;
      default:
        throw Error(f(390));
    }
  }
  var Fi = 0;
  function Yi(r, c, g, m) {
    var x = g.boundary;
    if (x === null)
      return Za(r, c, g, m);
    if (x.parentFlushed = !0, x.status === 4) {
      var N = x.row;
      return N !== null && --N.pendingTasks === 0 && Ot(r, N), r.renderState.generateStaticMarkup || (x = x.errorDigest, c.push("<!--$!-->"), c.push("<template"), x && (c.push(' data-dgst="'), x = Q(x), c.push(x), c.push('"')), c.push("></template>")), Za(r, c, g, m), r = r.renderState.generateStaticMarkup ? !0 : c.push("<!--/$-->"), r;
    }
    if (x.status !== 1)
      return x.status === 0 && (x.rootSegmentID = r.nextSegmentId++), 0 < x.completedSegments.length && r.partialBoundaries.push(x), Fa(
        c,
        r.renderState,
        x.rootSegmentID
      ), m && Wl(m, x.fallbackState), Za(r, c, g, m), c.push("<!--/$-->");
    if (!hu && zi(r, x) && Fi + x.byteSize > r.progressiveChunkSize)
      return x.rootSegmentID = r.nextSegmentId++, r.completedBoundaries.push(x), Fa(
        c,
        r.renderState,
        x.rootSegmentID
      ), Za(r, c, g, m), c.push("<!--/$-->");
    if (Fi += x.byteSize, m && Wl(m, x.contentState), g = x.row, g !== null && zi(r, x) && --g.pendingTasks === 0 && Ot(r, g), r.renderState.generateStaticMarkup || c.push("<!--$-->"), g = x.completedSegments, g.length !== 1) throw Error(f(391));
    return Yi(r, c, g[0], m), r = r.renderState.generateStaticMarkup ? !0 : c.push("<!--/$-->"), r;
  }
  function dc(r, c, g, m) {
    return bn(
      c,
      r.renderState,
      g.parentFormatContext,
      g.id
    ), Yi(r, c, g, m), Vu(c, g.parentFormatContext);
  }
  function ho(r, c, g) {
    Fi = g.byteSize;
    for (var m = g.completedSegments, x = 0; x < m.length; x++)
      di(
        r,
        c,
        g,
        m[x]
      );
    m.length = 0, m = g.row, m !== null && zi(r, g) && --m.pendingTasks === 0 && Ot(r, m), Ci(
      c,
      g.contentState,
      r.renderState
    ), m = r.resumableState, r = r.renderState, x = g.rootSegmentID, g = g.contentState;
    var N = r.stylesToHoist;
    return r.stylesToHoist = !1, c.push(r.startInlineScript), c.push(">"), N ? ((m.instructions & 4) === 0 && (m.instructions |= 4, c.push(
      '$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};'
    )), (m.instructions & 2) === 0 && (m.instructions |= 2, c.push(
      `$RB=[];$RV=function(a){$RT=performance.now();for(var b=0;b<a.length;b+=2){var c=a[b],e=a[b+1];null!==e.parentNode&&e.parentNode.removeChild(e);var f=c.parentNode;if(f){var g=c.previousSibling,h=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d||"/&"===d)if(0===h)break;else h--;else"$"!==d&&"$?"!==d&&"$~"!==d&&"$!"!==d&&"&"!==d||h++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;e.firstChild;)f.insertBefore(e.firstChild,c);g.data="$";g._reactRetry&&requestAnimationFrame(g._reactRetry)}}a.length=0};
$RC=function(a,b){if(b=document.getElementById(b))(a=document.getElementById(a))?(a.previousSibling.data="$~",$RB.push(a,b),2===$RB.length&&("number"!==typeof $RT?requestAnimationFrame($RV.bind(null,$RB)):(a=performance.now(),setTimeout($RV.bind(null,$RB),2300>a&&2E3<a?2300-a:$RT+300-a)))):b.parentNode.removeChild(b)};`
    )), (m.instructions & 8) === 0 ? (m.instructions |= 8, c.push(
      `$RM=new Map;$RR=function(n,w,p){function u(q){this._p=null;q()}for(var r=new Map,t=document,h,b,e=t.querySelectorAll("link[data-precedence],style[data-precedence]"),v=[],k=0;b=e[k++];)"not all"===b.getAttribute("media")?v.push(b):("LINK"===b.tagName&&$RM.set(b.getAttribute("href"),b),r.set(b.dataset.precedence,h=b));e=0;b=[];var l,a;for(k=!0;;){if(k){var f=p[e++];if(!f){k=!1;e=0;continue}var c=!1,m=0;var d=f[m++];if(a=$RM.get(d)){var g=a._p;c=!0}else{a=t.createElement("link");a.href=d;a.rel=
"stylesheet";for(a.dataset.precedence=l=f[m++];g=f[m++];)a.setAttribute(g,f[m++]);g=a._p=new Promise(function(q,x){a.onload=u.bind(a,q);a.onerror=u.bind(a,x)});$RM.set(d,a)}d=a.getAttribute("media");!g||d&&!matchMedia(d).matches||b.push(g);if(c)continue}else{a=v[e++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=r.get(l)||h;c===h&&(h=a);r.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=t.head,c.insertBefore(a,c.firstChild))}if(p=document.getElementById(n))p.previousSibling.data=
"$~";Promise.all(b).then($RC.bind(null,n,w),$RX.bind(null,n,"CSS failed to load"))};$RR("`
    )) : c.push('$RR("')) : ((m.instructions & 2) === 0 && (m.instructions |= 2, c.push(
      `$RB=[];$RV=function(a){$RT=performance.now();for(var b=0;b<a.length;b+=2){var c=a[b],e=a[b+1];null!==e.parentNode&&e.parentNode.removeChild(e);var f=c.parentNode;if(f){var g=c.previousSibling,h=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d||"/&"===d)if(0===h)break;else h--;else"$"!==d&&"$?"!==d&&"$~"!==d&&"$!"!==d&&"&"!==d||h++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;e.firstChild;)f.insertBefore(e.firstChild,c);g.data="$";g._reactRetry&&requestAnimationFrame(g._reactRetry)}}a.length=0};
$RC=function(a,b){if(b=document.getElementById(b))(a=document.getElementById(a))?(a.previousSibling.data="$~",$RB.push(a,b),2===$RB.length&&("number"!==typeof $RT?requestAnimationFrame($RV.bind(null,$RB)):(a=performance.now(),setTimeout($RV.bind(null,$RB),2300>a&&2E3<a?2300-a:$RT+300-a)))):b.parentNode.removeChild(b)};`
    )), c.push('$RC("')), m = x.toString(16), c.push(r.boundaryPrefix), c.push(m), c.push('","'), c.push(r.segmentPrefix), c.push(m), N ? (c.push('",'), fa(c, g)) : c.push('"'), g = c.push(")<\/script>"), Dl(c, r) && g;
  }
  function di(r, c, g, m) {
    if (m.status === 2) return !0;
    var x = g.contentState, N = m.id;
    if (N === -1) {
      if ((m.id = g.rootSegmentID) === -1)
        throw Error(f(392));
      return dc(r, c, m, x);
    }
    return N === g.rootSegmentID ? dc(r, c, m, x) : (dc(r, c, m, x), g = r.resumableState, r = r.renderState, c.push(r.startInlineScript), c.push(">"), (g.instructions & 1) === 0 ? (g.instructions |= 1, c.push(
      '$RS=function(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'
    )) : c.push('$RS("'), c.push(r.segmentPrefix), N = N.toString(16), c.push(N), c.push('","'), c.push(r.placeholderPrefix), c.push(N), c = c.push('")<\/script>'), c);
  }
  var hu = !1;
  function hi(r, c) {
    try {
      if (!(0 < r.pendingRootTasks)) {
        var g, m = r.completedRootSegment;
        if (m !== null) {
          if (m.status === 5) return;
          var x = r.completedPreambleSegments;
          if (x === null) return;
          Fi = r.byteSize;
          var N = r.resumableState, D = r.renderState, $ = D.preamble, F = $.htmlChunks, ee = $.headChunks, se;
          if (F) {
            for (se = 0; se < F.length; se++)
              c.push(F[se]);
            if (ee)
              for (se = 0; se < ee.length; se++)
                c.push(ee[se]);
            else {
              var ae = wt("head");
              c.push(ae), c.push(">");
            }
          } else if (ee)
            for (se = 0; se < ee.length; se++)
              c.push(ee[se]);
          var ve = D.charsetChunks;
          for (se = 0; se < ve.length; se++)
            c.push(ve[se]);
          ve.length = 0, D.preconnects.forEach(It, c), D.preconnects.clear();
          var Be = D.viewportChunks;
          for (se = 0; se < Be.length; se++)
            c.push(Be[se]);
          Be.length = 0, D.fontPreloads.forEach(It, c), D.fontPreloads.clear(), D.highImagePreloads.forEach(It, c), D.highImagePreloads.clear(), Wt = D, D.styles.forEach(mn, c), Wt = null;
          var Ie = D.importMapChunks;
          for (se = 0; se < Ie.length; se++)
            c.push(Ie[se]);
          Ie.length = 0, D.bootstrapScripts.forEach(It, c), D.scripts.forEach(It, c), D.scripts.clear(), D.bulkPreloads.forEach(It, c), D.bulkPreloads.clear(), N.instructions |= 32;
          var Ze = D.hoistableChunks;
          for (se = 0; se < Ze.length; se++)
            c.push(Ze[se]);
          for (N = Ze.length = 0; N < x.length; N++) {
            var Ke = x[N];
            for (D = 0; D < Ke.length; D++)
              Yi(r, c, Ke[D], null);
          }
          var Qe = r.renderState.preamble, je = Qe.headChunks;
          if (Qe.htmlChunks || je) {
            var Vt = Vl("head");
            c.push(Vt);
          }
          var Mt = Qe.bodyChunks;
          if (Mt)
            for (x = 0; x < Mt.length; x++)
              c.push(Mt[x]);
          Yi(r, c, m, null), r.completedRootSegment = null;
          var st = r.renderState;
          if (r.allPendingTasks !== 0 || r.clientRenderedBoundaries.length !== 0 || r.completedBoundaries.length !== 0 || r.trackedPostpones !== null && (r.trackedPostpones.rootNodes.length !== 0 || r.trackedPostpones.rootSlots !== null)) {
            var ft = r.resumableState;
            if ((ft.instructions & 64) === 0) {
              if (ft.instructions |= 64, c.push(st.startInlineScript), (ft.instructions & 32) === 0) {
                ft.instructions |= 32;
                var tt = "_" + ft.idPrefix + "R_";
                c.push(' id="');
                var Bl = Q(tt);
                c.push(Bl), c.push('"');
              }
              c.push(">"), c.push(
                "requestAnimationFrame(function(){$RT=performance.now()});"
              ), c.push("<\/script>");
            }
          }
          Dl(c, st);
        }
        var We = r.renderState;
        m = 0;
        var Tl = We.viewportChunks;
        for (m = 0; m < Tl.length; m++)
          c.push(Tl[m]);
        Tl.length = 0, We.preconnects.forEach(It, c), We.preconnects.clear(), We.fontPreloads.forEach(It, c), We.fontPreloads.clear(), We.highImagePreloads.forEach(
          It,
          c
        ), We.highImagePreloads.clear(), We.styles.forEach(Ta, c), We.scripts.forEach(It, c), We.scripts.clear(), We.bulkPreloads.forEach(It, c), We.bulkPreloads.clear();
        var at = We.hoistableChunks;
        for (m = 0; m < at.length; m++)
          c.push(at[m]);
        at.length = 0;
        var pn = r.clientRenderedBoundaries;
        for (g = 0; g < pn.length; g++) {
          var sn = pn[g];
          We = c;
          var Ct = r.resumableState, jn = r.renderState, Ii = sn.rootSegmentID, pl = sn.errorDigest;
          We.push(jn.startInlineScript), We.push(">"), (Ct.instructions & 4) === 0 ? (Ct.instructions |= 4, We.push(
            '$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};;$RX("'
          )) : We.push('$RX("'), We.push(jn.boundaryPrefix);
          var Mr = Ii.toString(16);
          if (We.push(Mr), We.push('"'), pl) {
            We.push(",");
            var qn = ln(
              pl || ""
            );
            We.push(qn);
          }
          var Sn = We.push(")<\/script>");
          if (!Sn) {
            r.destination = null, g++, pn.splice(0, g);
            return;
          }
        }
        pn.splice(0, g);
        var $n = r.completedBoundaries;
        for (g = 0; g < $n.length; g++)
          if (!ho(r, c, $n[g])) {
            r.destination = null, g++, $n.splice(0, g);
            return;
          }
        $n.splice(0, g), hu = !0;
        var Hl = r.partialBoundaries;
        for (g = 0; g < Hl.length; g++) {
          var Sl = Hl[g];
          e: {
            pn = r, sn = c, Fi = Sl.byteSize;
            var _n = Sl.completedSegments;
            for (Sn = 0; Sn < _n.length; Sn++)
              if (!di(
                pn,
                sn,
                Sl,
                _n[Sn]
              )) {
                Sn++, _n.splice(0, Sn);
                var Ln = !1;
                break e;
              }
            _n.splice(0, Sn);
            var Pt = Sl.row;
            Pt !== null && Pt.together && Sl.pendingTasks === 1 && (Pt.pendingTasks === 1 ? Ia(
              pn,
              Pt,
              Pt.hoistables
            ) : Pt.pendingTasks--), Ln = Ci(
              sn,
              Sl.contentState,
              pn.renderState
            );
          }
          if (!Ln) {
            r.destination = null, g++, Hl.splice(0, g);
            return;
          }
        }
        Hl.splice(0, g), hu = !1;
        var ul = r.completedBoundaries;
        for (g = 0; g < ul.length; g++)
          if (!ho(r, c, ul[g])) {
            r.destination = null, g++, ul.splice(0, g);
            return;
          }
        ul.splice(0, g);
      }
    } finally {
      hu = !1, r.allPendingTasks === 0 && r.clientRenderedBoundaries.length === 0 && r.completedBoundaries.length === 0 && (r.flushScheduled = !1, g = r.resumableState, g.hasBody && (Hl = Vl("body"), c.push(Hl)), g.hasHtml && (g = Vl("html"), c.push(g)), r.status = 14, c.push(null), r.destination = null);
    }
  }
  function gi(r) {
    if (r.flushScheduled === !1 && r.pingedTasks.length === 0 && r.destination !== null) {
      r.flushScheduled = !0;
      var c = r.destination;
      c ? hi(r, c) : r.flushScheduled = !1;
    }
  }
  function Gi(r, c) {
    if (r.status === 13)
      r.status = 14, c.destroy(r.fatalError);
    else if (r.status !== 14 && r.destination === null) {
      r.destination = c;
      try {
        hi(r, c);
      } catch (g) {
        rl(r, g, {}), Li(r, g);
      }
    }
  }
  function hc(r, c) {
    (r.status === 11 || r.status === 10) && (r.status = 12);
    try {
      var g = r.abortableTasks;
      if (0 < g.size) {
        var m = c === void 0 ? Error(f(432)) : typeof c == "object" && c !== null && typeof c.then == "function" ? Error(f(530)) : c;
        r.fatalError = m, g.forEach(function(x) {
          return ou(x, r, m);
        }), g.clear();
      }
      r.destination !== null && hi(r, r.destination);
    } catch (x) {
      rl(r, x, {}), Li(r, x);
    }
  }
  function Aa(r, c, g) {
    if (c === null) g.rootNodes.push(r);
    else {
      var m = g.workingMap, x = m.get(c);
      x === void 0 && (x = [c[1], c[2], [], null], m.set(c, x), Aa(x, c[0], g)), x[2].push(r);
    }
  }
  function Va() {
  }
  function Xi(r, c, g, m) {
    var x = !1, N = null, D = "", $ = !1;
    if (c = An(c ? c.identifierPrefix : void 0), r = Qs(
      r,
      c,
      Zt(c, g),
      Dt(0, null, 0, null),
      1 / 0,
      Va,
      void 0,
      function() {
        $ = !0;
      },
      void 0,
      void 0,
      void 0
    ), r.flushScheduled = r.destination !== null, Wo(r), r.status === 10 && (r.status = 11), r.trackedPostpones === null && sc(r, r.pendingRootTasks === 0), hc(r, m), Gi(r, {
      push: function(F) {
        return F !== null && (D += F), !0;
      },
      destroy: function(F) {
        x = !0, N = F;
      }
    }), x && N !== m) throw N;
    if (!$) throw Error(f(426));
    return D;
  }
  return Bf.renderToStaticMarkup = function(r, c) {
    return Xi(
      r,
      c,
      !0,
      'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server'
    );
  }, Bf.renderToString = function(r, c) {
    return Xi(
      r,
      c,
      !1,
      'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server'
    );
  }, Bf.version = "19.2.6", Bf;
}
var Co = {};
var hb;
function gT() {
  if (hb) return Co;
  hb = 1;
  var a = Gt, o = jg;
  function f(i) {
    var u = "https://react.dev/errors/" + i;
    if (1 < arguments.length) {
      u += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var h = 2; h < arguments.length; h++)
        u += "&args[]=" + encodeURIComponent(arguments[h]);
    }
    return "Minified React error #" + i + "; visit " + u + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var v = Symbol.for("react.transitional.element"), y = Symbol.for("react.portal"), T = Symbol.for("react.fragment"), w = Symbol.for("react.strict_mode"), O = Symbol.for("react.profiler"), _ = Symbol.for("react.consumer"), z = Symbol.for("react.context"), H = Symbol.for("react.forward_ref"), Z = Symbol.for("react.suspense"), Y = Symbol.for("react.suspense_list"), ce = Symbol.for("react.memo"), le = Symbol.for("react.lazy"), K = Symbol.for("react.scope"), he = Symbol.for("react.activity"), ye = Symbol.for("react.legacy_hidden"), de = Symbol.for("react.memo_cache_sentinel"), ze = Symbol.for("react.view_transition"), ke = Symbol.iterator;
  function pe(i) {
    return i === null || typeof i != "object" ? null : (i = ke && i[ke] || i["@@iterator"], typeof i == "function" ? i : null);
  }
  var xe = Array.isArray;
  function we(i, u) {
    var h = i.length & 3, b = i.length - h, p = u;
    for (u = 0; u < b; ) {
      var C = i.charCodeAt(u) & 255 | (i.charCodeAt(++u) & 255) << 8 | (i.charCodeAt(++u) & 255) << 16 | (i.charCodeAt(++u) & 255) << 24;
      ++u, C = 3432918353 * (C & 65535) + ((3432918353 * (C >>> 16) & 65535) << 16) & 4294967295, C = C << 15 | C >>> 17, C = 461845907 * (C & 65535) + ((461845907 * (C >>> 16) & 65535) << 16) & 4294967295, p ^= C, p = p << 13 | p >>> 19, p = 5 * (p & 65535) + ((5 * (p >>> 16) & 65535) << 16) & 4294967295, p = (p & 65535) + 27492 + (((p >>> 16) + 58964 & 65535) << 16);
    }
    switch (C = 0, h) {
      case 3:
        C ^= (i.charCodeAt(u + 2) & 255) << 16;
      case 2:
        C ^= (i.charCodeAt(u + 1) & 255) << 8;
      case 1:
        C ^= i.charCodeAt(u) & 255, C = 3432918353 * (C & 65535) + ((3432918353 * (C >>> 16) & 65535) << 16) & 4294967295, C = C << 15 | C >>> 17, p ^= 461845907 * (C & 65535) + ((461845907 * (C >>> 16) & 65535) << 16) & 4294967295;
    }
    return p ^= i.length, p ^= p >>> 16, p = 2246822507 * (p & 65535) + ((2246822507 * (p >>> 16) & 65535) << 16) & 4294967295, p ^= p >>> 13, p = 3266489909 * (p & 65535) + ((3266489909 * (p >>> 16) & 65535) << 16) & 4294967295, (p ^ p >>> 16) >>> 0;
  }
  var Ce = new MessageChannel(), Le = [];
  Ce.port1.onmessage = function() {
    var i = Le.shift();
    i && i();
  };
  function Ht(i) {
    Le.push(i), Ce.port2.postMessage(null);
  }
  function Et(i) {
    setTimeout(function() {
      throw i;
    });
  }
  var Xt = Promise, Ee = typeof queueMicrotask == "function" ? queueMicrotask : function(i) {
    Xt.resolve(null).then(i).catch(Et);
  }, Ne = null, lt = 0;
  function U(i, u) {
    if (u.byteLength !== 0)
      if (2048 < u.byteLength)
        0 < lt && (i.enqueue(
          new Uint8Array(Ne.buffer, 0, lt)
        ), Ne = new Uint8Array(2048), lt = 0), i.enqueue(u);
      else {
        var h = Ne.length - lt;
        h < u.byteLength && (h === 0 ? i.enqueue(Ne) : (Ne.set(u.subarray(0, h), lt), i.enqueue(Ne), u = u.subarray(h)), Ne = new Uint8Array(2048), lt = 0), Ne.set(u, lt), lt += u.byteLength;
      }
  }
  function Q(i, u) {
    return U(i, u), !0;
  }
  function Se(i) {
    Ne && 0 < lt && (i.enqueue(new Uint8Array(Ne.buffer, 0, lt)), Ne = null, lt = 0);
  }
  var et = new TextEncoder();
  function re(i) {
    return et.encode(i);
  }
  function j(i) {
    return et.encode(i);
  }
  function ut(i) {
    return i.byteLength;
  }
  function qe(i, u) {
    typeof i.error == "function" ? i.error(u) : i.close();
  }
  var be = Object.assign, Oe = Object.prototype.hasOwnProperty, $e = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), Wt = {}, bt = {};
  function Gn(i) {
    return Oe.call(bt, i) ? !0 : Oe.call(Wt, i) ? !1 : $e.test(i) ? bt[i] = !0 : (Wt[i] = !0, !1);
  }
  var An = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  ), Dt = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), wi = /["'&<>]/;
  function Ye(i) {
    if (typeof i == "boolean" || typeof i == "number" || typeof i == "bigint")
      return "" + i;
    i = "" + i;
    var u = wi.exec(i);
    if (u) {
      var h = "", b, p = 0;
      for (b = u.index; b < i.length; b++) {
        switch (i.charCodeAt(b)) {
          case 34:
            u = "&quot;";
            break;
          case 38:
            u = "&amp;";
            break;
          case 39:
            u = "&#x27;";
            break;
          case 60:
            u = "&lt;";
            break;
          case 62:
            u = "&gt;";
            break;
          default:
            continue;
        }
        p !== b && (h += i.slice(p, b)), p = b + 1, h += u;
      }
      i = p !== b ? h + i.slice(p, b) : h;
    }
    return i;
  }
  var $i = /([A-Z])/g, Il = /^ms-/, Zl = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function _l(i) {
    return Zl.test("" + i) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : i;
  }
  var nl = a.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, rn = o.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Ai = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, On = rn.d;
  rn.d = {
    f: On.f,
    r: On.r,
    D: ou,
    C: sc,
    L: fc,
    m: su,
    X: Ui,
    S: fu,
    M: Wo
  };
  var Cn = [], ca = null;
  j('"></template>');
  var eu = j("<script"), Ge = j("<\/script>"), ll = j('<script src="'), Er = j('<script type="module" src="'), Ba = j(' nonce="'), Ut = j(' integrity="'), Nl = j(' crossorigin="'), Oi = j(' async=""><\/script>'), ri = j("<style"), er = /(<\/|<)(s)(cript)/gi;
  function Ml(i, u, h, b) {
    return "" + u + (h === "s" ? "\\u0073" : "\\u0053") + b;
  }
  var Xn = j(
    '<script type="importmap">'
  ), al = j("<\/script>");
  function vn(i, u, h, b, p, C) {
    h = typeof u == "string" ? u : u && u.script;
    var M = h === void 0 ? eu : j(
      '<script nonce="' + Ye(h) + '"'
    ), I = typeof u == "string" ? void 0 : u && u.style, L = I === void 0 ? ri : j(
      '<style nonce="' + Ye(I) + '"'
    ), X = i.idPrefix, W = [], te = i.bootstrapScriptContent, me = i.bootstrapScripts, Te = i.bootstrapModules;
    if (te !== void 0 && (W.push(M), Nr(W, i), W.push(
      _t,
      re(
        ("" + te).replace(er, Ml)
      ),
      Ge
    )), te = [], b !== void 0 && (te.push(Xn), te.push(
      re(
        ("" + JSON.stringify(b)).replace(er, Ml)
      )
    ), te.push(al)), b = p ? {
      preconnects: "",
      fontPreloads: "",
      highImagePreloads: "",
      remainingCapacity: 2 + (typeof C == "number" ? C : 2e3)
    } : null, p = {
      placeholderPrefix: j(X + "P:"),
      segmentPrefix: j(X + "S:"),
      boundaryPrefix: j(X + "B:"),
      startInlineScript: M,
      startInlineStyle: L,
      preamble: wt(),
      externalRuntimeScript: null,
      bootstrapChunks: W,
      importMapChunks: te,
      onHeaders: p,
      headers: b,
      resets: {
        font: {},
        dns: {},
        connect: { default: {}, anonymous: {}, credentials: {} },
        image: {},
        style: {}
      },
      charsetChunks: [],
      viewportChunks: [],
      hoistableChunks: [],
      preconnects: /* @__PURE__ */ new Set(),
      fontPreloads: /* @__PURE__ */ new Set(),
      highImagePreloads: /* @__PURE__ */ new Set(),
      styles: /* @__PURE__ */ new Map(),
      bootstrapScripts: /* @__PURE__ */ new Set(),
      scripts: /* @__PURE__ */ new Set(),
      bulkPreloads: /* @__PURE__ */ new Set(),
      preloads: {
        images: /* @__PURE__ */ new Map(),
        stylesheets: /* @__PURE__ */ new Map(),
        scripts: /* @__PURE__ */ new Map(),
        moduleScripts: /* @__PURE__ */ new Map()
      },
      nonce: { script: h, style: I },
      hoistableState: null,
      stylesToHoist: !1
    }, me !== void 0)
      for (b = 0; b < me.length; b++)
        X = me[b], I = M = void 0, L = {
          rel: "preload",
          as: "script",
          fetchPriority: "low",
          nonce: u
        }, typeof X == "string" ? L.href = C = X : (L.href = C = X.src, L.integrity = I = typeof X.integrity == "string" ? X.integrity : void 0, L.crossOrigin = M = typeof X == "string" || X.crossOrigin == null ? void 0 : X.crossOrigin === "use-credentials" ? "use-credentials" : ""), X = i, te = C, X.scriptResources[te] = null, X.moduleScriptResources[te] = null, X = [], ge(X, L), p.bootstrapScripts.add(X), W.push(
          ll,
          re(Ye(C)),
          kt
        ), h && W.push(
          Ba,
          re(Ye(h)),
          kt
        ), typeof I == "string" && W.push(
          Ut,
          re(Ye(I)),
          kt
        ), typeof M == "string" && W.push(
          Nl,
          re(Ye(M)),
          kt
        ), Nr(W, i), W.push(Oi);
    if (Te !== void 0)
      for (u = 0; u < Te.length; u++)
        I = Te[u], C = b = void 0, M = {
          rel: "modulepreload",
          fetchPriority: "low",
          nonce: h
        }, typeof I == "string" ? M.href = me = I : (M.href = me = I.src, M.integrity = C = typeof I.integrity == "string" ? I.integrity : void 0, M.crossOrigin = b = typeof I == "string" || I.crossOrigin == null ? void 0 : I.crossOrigin === "use-credentials" ? "use-credentials" : ""), I = i, L = me, I.scriptResources[L] = null, I.moduleScriptResources[L] = null, I = [], ge(I, M), p.bootstrapScripts.add(I), W.push(
          Er,
          re(Ye(me)),
          kt
        ), h && W.push(
          Ba,
          re(Ye(h)),
          kt
        ), typeof C == "string" && W.push(
          Ut,
          re(Ye(C)),
          kt
        ), typeof b == "string" && W.push(
          Nl,
          re(Ye(b)),
          kt
        ), Nr(W, i), W.push(Oi);
    return p;
  }
  function zl(i, u, h, b, p) {
    return {
      idPrefix: i === void 0 ? "" : i,
      nextFormID: 0,
      streamingFormat: 0,
      bootstrapScriptContent: h,
      bootstrapScripts: b,
      bootstrapModules: p,
      instructions: 0,
      hasBody: !1,
      hasHtml: !1,
      unknownResources: {},
      dnsResources: {},
      connectResources: { default: {}, anonymous: {}, credentials: {} },
      imageResources: {},
      styleResources: {},
      scriptResources: {},
      moduleUnknownResources: {},
      moduleScriptResources: {}
    };
  }
  function wt() {
    return { htmlChunks: null, headChunks: null, bodyChunks: null };
  }
  function yn(i, u, h, b) {
    return {
      insertionMode: i,
      selectedValue: u,
      tagScope: h,
      viewTransition: b
    };
  }
  function Ha(i) {
    return yn(
      i === "http://www.w3.org/2000/svg" ? 4 : i === "http://www.w3.org/1998/Math/MathML" ? 5 : 0,
      null,
      0,
      null
    );
  }
  function Vl(i, u, h) {
    var b = i.tagScope & -25;
    switch (u) {
      case "noscript":
        return yn(2, null, b | 1, null);
      case "select":
        return yn(
          2,
          h.value != null ? h.value : h.defaultValue,
          b,
          null
        );
      case "svg":
        return yn(4, null, b, null);
      case "picture":
        return yn(2, null, b | 2, null);
      case "math":
        return yn(5, null, b, null);
      case "foreignObject":
        return yn(2, null, b, null);
      case "table":
        return yn(6, null, b, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return yn(7, null, b, null);
      case "colgroup":
        return yn(9, null, b, null);
      case "tr":
        return yn(8, null, b, null);
      case "head":
        if (2 > i.insertionMode)
          return yn(3, null, b, null);
        break;
      case "html":
        if (i.insertionMode === 0)
          return yn(1, null, b, null);
    }
    return 6 <= i.insertionMode || 2 > i.insertionMode ? yn(2, null, b, null) : i.tagScope !== b ? yn(
      i.insertionMode,
      i.selectedValue,
      b,
      null
    ) : i;
  }
  function Ua(i) {
    return i === null ? null : {
      update: i.update,
      enter: "none",
      exit: "none",
      share: i.update,
      name: i.autoName,
      autoName: i.autoName,
      nameIdx: 0
    };
  }
  function Dl(i, u) {
    return u.tagScope & 32 && (i.instructions |= 128), yn(
      u.insertionMode,
      u.selectedValue,
      u.tagScope | 12,
      Ua(u.viewTransition)
    );
  }
  function Fa(i, u) {
    i = Ua(u.viewTransition);
    var h = u.tagScope | 16;
    return i !== null && i.share !== "none" && (h |= 64), yn(
      u.insertionMode,
      u.selectedValue,
      h,
      i
    );
  }
  var bn = j("<!-- -->");
  function Vu(i, u, h, b) {
    return u === "" ? b : (b && i.push(bn), i.push(re(Ye(u))), !0);
  }
  var tu = /* @__PURE__ */ new Map(), ln = j(' style="'), Ql = j(":"), tr = j(";");
  function ui(i, u) {
    if (typeof u != "object") throw Error(f(62));
    var h = !0, b;
    for (b in u)
      if (Oe.call(u, b)) {
        var p = u[b];
        if (p != null && typeof p != "boolean" && p !== "") {
          if (b.indexOf("--") === 0) {
            var C = re(Ye(b));
            p = re(
              Ye(("" + p).trim())
            );
          } else
            C = tu.get(b), C === void 0 && (C = j(
              Ye(
                b.replace($i, "-$1").toLowerCase().replace(Il, "-ms-")
              )
            ), tu.set(b, C)), p = typeof p == "number" ? p === 0 || An.has(b) ? re("" + p) : re(p + "px") : re(
              Ye(("" + p).trim())
            );
          h ? (h = !1, i.push(
            ln,
            C,
            Ql,
            p
          )) : i.push(tr, C, Ql, p);
        }
      }
    h || i.push(kt);
  }
  var un = j(" "), il = j('="'), kt = j('"'), Ci = j('=""');
  function It(i, u, h) {
    h && typeof h != "function" && typeof h != "symbol" && i.push(un, re(u), Ci);
  }
  function mt(i, u, h) {
    typeof h != "function" && typeof h != "symbol" && typeof h != "boolean" && i.push(
      un,
      re(u),
      il,
      re(Ye(h)),
      kt
    );
  }
  var oa = j(
    Ye(
      "javascript:throw new Error('React form unexpectedly submitted.')"
    )
  ), mn = j('<input type="hidden"');
  function zn(i, u) {
    this.push(mn), Ta(i), mt(this, "name", u), mt(this, "value", i), this.push(pa);
  }
  function Ta(i) {
    if (typeof i != "string") throw Error(f(480));
  }
  function sa(i, u) {
    if (typeof u.$$FORM_ACTION == "function") {
      var h = i.nextFormID++;
      i = i.idPrefix + h;
      try {
        var b = u.$$FORM_ACTION(i);
        if (b) {
          var p = b.data;
          p != null && p.forEach(Ta);
        }
        return b;
      } catch (C) {
        if (typeof C == "object" && C !== null && typeof C.then == "function")
          throw C;
      }
    }
    return null;
  }
  function fa(i, u, h, b, p, C, M, I) {
    var L = null;
    if (typeof b == "function") {
      var X = sa(u, b);
      X !== null ? (I = X.name, b = X.action || "", p = X.encType, C = X.method, M = X.target, L = X.data) : (i.push(
        un,
        re("formAction"),
        il,
        oa,
        kt
      ), M = C = p = b = I = null, Re(u, h));
    }
    return I != null && Tt(i, "name", I), b != null && Tt(i, "formAction", b), p != null && Tt(i, "formEncType", p), C != null && Tt(i, "formMethod", C), M != null && Tt(i, "formTarget", M), L;
  }
  function Tt(i, u, h) {
    switch (u) {
      case "className":
        mt(i, "class", h);
        break;
      case "tabIndex":
        mt(i, "tabindex", h);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        mt(i, u, h);
        break;
      case "style":
        ui(i, h);
        break;
      case "src":
      case "href":
        if (h === "") break;
      case "action":
      case "formAction":
        if (h == null || typeof h == "function" || typeof h == "symbol" || typeof h == "boolean")
          break;
        h = _l("" + h), i.push(
          un,
          re(u),
          il,
          re(Ye(h)),
          kt
        );
        break;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "ref":
        break;
      case "autoFocus":
      case "multiple":
      case "muted":
        It(i, u.toLowerCase(), h);
        break;
      case "xlinkHref":
        if (typeof h == "function" || typeof h == "symbol" || typeof h == "boolean")
          break;
        h = _l("" + h), i.push(
          un,
          re("xlink:href"),
          il,
          re(Ye(h)),
          kt
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        typeof h != "function" && typeof h != "symbol" && i.push(
          un,
          re(u),
          il,
          re(Ye(h)),
          kt
        );
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        h && typeof h != "function" && typeof h != "symbol" && i.push(
          un,
          re(u),
          Ci
        );
        break;
      case "capture":
      case "download":
        h === !0 ? i.push(
          un,
          re(u),
          Ci
        ) : h !== !1 && typeof h != "function" && typeof h != "symbol" && i.push(
          un,
          re(u),
          il,
          re(Ye(h)),
          kt
        );
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        typeof h != "function" && typeof h != "symbol" && !isNaN(h) && 1 <= h && i.push(
          un,
          re(u),
          il,
          re(Ye(h)),
          kt
        );
        break;
      case "rowSpan":
      case "start":
        typeof h == "function" || typeof h == "symbol" || isNaN(h) || i.push(
          un,
          re(u),
          il,
          re(Ye(h)),
          kt
        );
        break;
      case "xlinkActuate":
        mt(i, "xlink:actuate", h);
        break;
      case "xlinkArcrole":
        mt(i, "xlink:arcrole", h);
        break;
      case "xlinkRole":
        mt(i, "xlink:role", h);
        break;
      case "xlinkShow":
        mt(i, "xlink:show", h);
        break;
      case "xlinkTitle":
        mt(i, "xlink:title", h);
        break;
      case "xlinkType":
        mt(i, "xlink:type", h);
        break;
      case "xmlBase":
        mt(i, "xml:base", h);
        break;
      case "xmlLang":
        mt(i, "xml:lang", h);
        break;
      case "xmlSpace":
        mt(i, "xml:space", h);
        break;
      default:
        if ((!(2 < u.length) || u[0] !== "o" && u[0] !== "O" || u[1] !== "n" && u[1] !== "N") && (u = Dt.get(u) || u, Gn(u))) {
          switch (typeof h) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              var b = u.toLowerCase().slice(0, 5);
              if (b !== "data-" && b !== "aria-") return;
          }
          i.push(
            un,
            re(u),
            il,
            re(Ye(h)),
            kt
          );
        }
    }
  }
  var _t = j(">"), pa = j("/>");
  function In(i, u, h) {
    if (u != null) {
      if (h != null) throw Error(f(60));
      if (typeof u != "object" || !("__html" in u))
        throw Error(f(61));
      u = u.__html, u != null && i.push(re("" + u));
    }
  }
  function ci(i) {
    var u = "";
    return a.Children.forEach(i, function(h) {
      h != null && (u += h);
    }), u;
  }
  var da = j(' selected=""'), Sa = j(
    `addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error('React form unexpectedly submitted.')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});`
  );
  function Re(i, u) {
    if ((i.instructions & 16) === 0) {
      i.instructions |= 16;
      var h = u.preamble, b = u.bootstrapChunks;
      (h.htmlChunks || h.headChunks) && b.length === 0 ? (b.push(u.startInlineScript), Nr(b, i), b.push(
        _t,
        Sa,
        Ge
      )) : b.unshift(
        u.startInlineScript,
        _t,
        Sa,
        Ge
      );
    }
  }
  var k = j("<!--F!-->"), ue = j("<!--F-->");
  function ge(i, u) {
    i.push(Tn("link"));
    for (var h in u)
      if (Oe.call(u, h)) {
        var b = u[h];
        if (b != null)
          switch (h) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(f(399, "link"));
            default:
              Tt(i, h, b);
          }
      }
    return i.push(pa), null;
  }
  var Fe = /(<\/|<)(s)(tyle)/gi;
  function At(i, u, h, b) {
    return "" + u + (h === "s" ? "\\73 " : "\\53 ") + b;
  }
  function Nt(i, u, h) {
    i.push(Tn(h));
    for (var b in u)
      if (Oe.call(u, b)) {
        var p = u[b];
        if (p != null)
          switch (b) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(f(399, h));
            default:
              Tt(i, b, p);
          }
      }
    return i.push(pa), null;
  }
  function Rn(i, u) {
    i.push(Tn("title"));
    var h = null, b = null, p;
    for (p in u)
      if (Oe.call(u, p)) {
        var C = u[p];
        if (C != null)
          switch (p) {
            case "children":
              h = C;
              break;
            case "dangerouslySetInnerHTML":
              b = C;
              break;
            default:
              Tt(i, p, C);
          }
      }
    return i.push(_t), u = Array.isArray(h) ? 2 > h.length ? h[0] : null : h, typeof u != "function" && typeof u != "symbol" && u !== null && u !== void 0 && i.push(re(Ye("" + u))), In(i, b, h), i.push(Ga("title")), null;
  }
  var xa = j("<!--head-->"), Ea = j("<!--body-->"), Wl = j("<!--html-->");
  function Zt(i, u) {
    i.push(Tn("script"));
    var h = null, b = null, p;
    for (p in u)
      if (Oe.call(u, p)) {
        var C = u[p];
        if (C != null)
          switch (p) {
            case "children":
              h = C;
              break;
            case "dangerouslySetInnerHTML":
              b = C;
              break;
            default:
              Tt(i, p, C);
          }
      }
    return i.push(_t), In(i, b, h), typeof h == "string" && i.push(
      re(("" + h).replace(er, Ml))
    ), i.push(Ga("script")), null;
  }
  function bl(i, u, h) {
    i.push(Tn(h));
    var b = h = null, p;
    for (p in u)
      if (Oe.call(u, p)) {
        var C = u[p];
        if (C != null)
          switch (p) {
            case "children":
              h = C;
              break;
            case "dangerouslySetInnerHTML":
              b = C;
              break;
            default:
              Tt(i, p, C);
          }
      }
    return i.push(_t), In(i, b, h), h;
  }
  function cn(i, u, h) {
    i.push(Tn(h));
    var b = h = null, p;
    for (p in u)
      if (Oe.call(u, p)) {
        var C = u[p];
        if (C != null)
          switch (p) {
            case "children":
              h = C;
              break;
            case "dangerouslySetInnerHTML":
              b = C;
              break;
            default:
              Tt(i, p, C);
          }
      }
    return i.push(_t), In(i, b, h), typeof h == "string" ? (i.push(re(Ye(h))), null) : h;
  }
  var Qu = j(`
`), Fs = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, nr = /* @__PURE__ */ new Map();
  function Tn(i) {
    var u = nr.get(i);
    if (u === void 0) {
      if (!Fs.test(i))
        throw Error(f(65, i));
      u = j("<" + i), nr.set(i, u);
    }
    return u;
  }
  var Ya = j("<!DOCTYPE html>");
  function Wu(i, u, h, b, p, C, M, I, L) {
    switch (u) {
      case "div":
      case "span":
      case "svg":
      case "path":
        break;
      case "a":
        i.push(Tn("a"));
        var X = null, W = null, te;
        for (te in h)
          if (Oe.call(h, te)) {
            var me = h[te];
            if (me != null)
              switch (te) {
                case "children":
                  X = me;
                  break;
                case "dangerouslySetInnerHTML":
                  W = me;
                  break;
                case "href":
                  me === "" ? mt(i, "href", "") : Tt(i, te, me);
                  break;
                default:
                  Tt(i, te, me);
              }
          }
        if (i.push(_t), In(i, W, X), typeof X == "string") {
          i.push(re(Ye(X)));
          var Te = null;
        } else Te = X;
        return Te;
      case "g":
      case "p":
      case "li":
        break;
      case "select":
        i.push(Tn("select"));
        var Ve = null, Me = null, nt;
        for (nt in h)
          if (Oe.call(h, nt)) {
            var ht = h[nt];
            if (ht != null)
              switch (nt) {
                case "children":
                  Ve = ht;
                  break;
                case "dangerouslySetInnerHTML":
                  Me = ht;
                  break;
                case "defaultValue":
                case "value":
                  break;
                default:
                  Tt(
                    i,
                    nt,
                    ht
                  );
              }
          }
        return i.push(_t), In(i, Me, Ve), Ve;
      case "option":
        var Ae = I.selectedValue;
        i.push(Tn("option"));
        var Je = null, gt = null, Al = null, Ue = null, dn;
        for (dn in h)
          if (Oe.call(h, dn)) {
            var Kt = h[dn];
            if (Kt != null)
              switch (dn) {
                case "children":
                  Je = Kt;
                  break;
                case "selected":
                  Al = Kt;
                  break;
                case "dangerouslySetInnerHTML":
                  Ue = Kt;
                  break;
                case "value":
                  gt = Kt;
                default:
                  Tt(
                    i,
                    dn,
                    Kt
                  );
              }
          }
        if (Ae != null) {
          var Hn = gt !== null ? "" + gt : ci(Je);
          if (xe(Ae)) {
            for (var Gl = 0; Gl < Ae.length; Gl++)
              if ("" + Ae[Gl] === Hn) {
                i.push(da);
                break;
              }
          } else
            "" + Ae === Hn && i.push(da);
        } else Al && i.push(da);
        return i.push(_t), In(i, Ue, Je), Je;
      case "textarea":
        i.push(Tn("textarea"));
        var hn = null, zt = null, ma = null, Un;
        for (Un in h)
          if (Oe.call(h, Un)) {
            var la = h[Un];
            if (la != null)
              switch (Un) {
                case "children":
                  ma = la;
                  break;
                case "value":
                  hn = la;
                  break;
                case "defaultValue":
                  zt = la;
                  break;
                case "dangerouslySetInnerHTML":
                  throw Error(f(91));
                default:
                  Tt(
                    i,
                    Un,
                    la
                  );
              }
          }
        if (hn === null && zt !== null && (hn = zt), i.push(_t), ma != null) {
          if (hn != null) throw Error(f(92));
          if (xe(ma)) {
            if (1 < ma.length)
              throw Error(f(93));
            hn = "" + ma[0];
          }
          hn = "" + ma;
        }
        return typeof hn == "string" && hn[0] === `
` && i.push(Qu), hn !== null && i.push(
          re(Ye("" + hn))
        ), null;
      case "input":
        i.push(Tn("input"));
        var Fr = null, xu = null, pi = null, dr = null, Eu = null, gn = null, Qt = null, Sc = null, wu = null, Yr;
        for (Yr in h)
          if (Oe.call(h, Yr)) {
            var Ma = h[Yr];
            if (Ma != null)
              switch (Yr) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(f(399, "input"));
                case "name":
                  Fr = Ma;
                  break;
                case "formAction":
                  xu = Ma;
                  break;
                case "formEncType":
                  pi = Ma;
                  break;
                case "formMethod":
                  dr = Ma;
                  break;
                case "formTarget":
                  Eu = Ma;
                  break;
                case "defaultChecked":
                  wu = Ma;
                  break;
                case "defaultValue":
                  Qt = Ma;
                  break;
                case "checked":
                  Sc = Ma;
                  break;
                case "value":
                  gn = Ma;
                  break;
                default:
                  Tt(
                    i,
                    Yr,
                    Ma
                  );
              }
          }
        var Wi = fa(
          i,
          b,
          p,
          xu,
          pi,
          dr,
          Eu,
          Fr
        );
        return Sc !== null ? It(i, "checked", Sc) : wu !== null && It(i, "checked", wu), gn !== null ? Tt(i, "value", gn) : Qt !== null && Tt(i, "value", Qt), i.push(pa), Wi != null && Wi.forEach(zn, i), null;
      case "button":
        i.push(Tn("button"));
        var Gr = null, Po = null, Jo = null, Ws = null, Ps = null, Js = null, Ks = null, xc;
        for (xc in h)
          if (Oe.call(h, xc)) {
            var Pi = h[xc];
            if (Pi != null)
              switch (xc) {
                case "children":
                  Gr = Pi;
                  break;
                case "dangerouslySetInnerHTML":
                  Po = Pi;
                  break;
                case "name":
                  Jo = Pi;
                  break;
                case "formAction":
                  Ws = Pi;
                  break;
                case "formEncType":
                  Ps = Pi;
                  break;
                case "formMethod":
                  Js = Pi;
                  break;
                case "formTarget":
                  Ks = Pi;
                  break;
                default:
                  Tt(
                    i,
                    xc,
                    Pi
                  );
              }
          }
        var Ko = fa(
          i,
          b,
          p,
          Ws,
          Ps,
          Js,
          Ks,
          Jo
        );
        if (i.push(_t), Ko != null && Ko.forEach(zn, i), In(i, Po, Gr), typeof Gr == "string") {
          i.push(
            re(Ye(Gr))
          );
          var js = null;
        } else js = Gr;
        return js;
      case "form":
        i.push(Tn("form"));
        var vo = null, qs = null, Xr = null, Ec = null, Au = null, wc = null, Ac;
        for (Ac in h)
          if (Oe.call(h, Ac)) {
            var hr = h[Ac];
            if (hr != null)
              switch (Ac) {
                case "children":
                  vo = hr;
                  break;
                case "dangerouslySetInnerHTML":
                  qs = hr;
                  break;
                case "action":
                  Xr = hr;
                  break;
                case "encType":
                  Ec = hr;
                  break;
                case "method":
                  Au = hr;
                  break;
                case "target":
                  wc = hr;
                  break;
                default:
                  Tt(
                    i,
                    Ac,
                    hr
                  );
              }
          }
        var jo = null, qo = null;
        if (typeof Xr == "function") {
          var Ou = sa(
            b,
            Xr
          );
          Ou !== null ? (Xr = Ou.action || "", Ec = Ou.encType, Au = Ou.method, wc = Ou.target, jo = Ou.data, qo = Ou.name) : (i.push(
            un,
            re("action"),
            il,
            oa,
            kt
          ), wc = Au = Ec = Xr = null, Re(b, p));
        }
        if (Xr != null && Tt(i, "action", Xr), Ec != null && Tt(i, "encType", Ec), Au != null && Tt(i, "method", Au), wc != null && Tt(i, "target", wc), i.push(_t), qo !== null && (i.push(mn), mt(i, "name", qo), i.push(pa), jo != null && jo.forEach(zn, i)), In(i, qs, vo), typeof vo == "string") {
          i.push(
            re(Ye(vo))
          );
          var $s = null;
        } else $s = vo;
        return $s;
      case "menuitem":
        i.push(Tn("menuitem"));
        for (var gr in h)
          if (Oe.call(h, gr)) {
            var ef = h[gr];
            if (ef != null)
              switch (gr) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(f(400));
                default:
                  Tt(
                    i,
                    gr,
                    ef
                  );
              }
          }
        return i.push(_t), null;
      case "object":
        i.push(Tn("object"));
        var Ir = null, yo = null, Oc;
        for (Oc in h)
          if (Oe.call(h, Oc)) {
            var Cu = h[Oc];
            if (Cu != null)
              switch (Oc) {
                case "children":
                  Ir = Cu;
                  break;
                case "dangerouslySetInnerHTML":
                  yo = Cu;
                  break;
                case "data":
                  var Jf = _l("" + Cu);
                  if (Jf === "") break;
                  i.push(
                    un,
                    re("data"),
                    il,
                    re(Ye(Jf)),
                    kt
                  );
                  break;
                default:
                  Tt(
                    i,
                    Oc,
                    Cu
                  );
              }
          }
        if (i.push(_t), In(i, yo, Ir), typeof Ir == "string") {
          i.push(
            re(Ye(Ir))
          );
          var tf = null;
        } else tf = Ir;
        return tf;
      case "title":
        var Kf = I.tagScope & 1, jf = I.tagScope & 4;
        if (I.insertionMode === 4 || Kf || h.itemProp != null)
          var $o = Rn(
            i,
            h
          );
        else
          jf ? $o = null : (Rn(p.hoistableChunks, h), $o = void 0);
        return $o;
      case "link":
        var qf = I.tagScope & 1, nf = I.tagScope & 4, $f = h.rel, vr = h.href, Cc = h.precedence;
        if (I.insertionMode === 4 || qf || h.itemProp != null || typeof $f != "string" || typeof vr != "string" || vr === "") {
          ge(i, h);
          var Rc = null;
        } else if (h.rel === "stylesheet")
          if (typeof Cc != "string" || h.disabled != null || h.onLoad || h.onError)
            Rc = ge(
              i,
              h
            );
          else {
            var Ru = p.styles.get(Cc), es = b.styleResources.hasOwnProperty(vr) ? b.styleResources[vr] : void 0;
            if (es !== null) {
              b.styleResources[vr] = null, Ru || (Ru = {
                precedence: re(Ye(Cc)),
                rules: [],
                hrefs: [],
                sheets: /* @__PURE__ */ new Map()
              }, p.styles.set(Cc, Ru));
              var _c = {
                state: 0,
                props: be({}, h, {
                  "data-precedence": h.precedence,
                  precedence: null
                })
              };
              if (es) {
                es.length === 2 && cr(_c.props, es);
                var ts = p.preloads.stylesheets.get(vr);
                ts && 0 < ts.length ? ts.length = 0 : _c.state = 1;
              }
              Ru.sheets.set(vr, _c), M && M.stylesheets.add(_c);
            } else if (Ru) {
              var lf = Ru.sheets.get(vr);
              lf && M && M.stylesheets.add(lf);
            }
            L && i.push(bn), Rc = null;
          }
        else
          h.onLoad || h.onError ? Rc = ge(
            i,
            h
          ) : (L && i.push(bn), Rc = nf ? null : ge(p.hoistableChunks, h));
        return Rc;
      case "script":
        var af = I.tagScope & 1, ns = h.async;
        if (typeof h.src != "string" || !h.src || !ns || typeof ns == "function" || typeof ns == "symbol" || h.onLoad || h.onError || I.insertionMode === 4 || af || h.itemProp != null)
          var rf = Zt(
            i,
            h
          );
        else {
          var ls = h.src;
          if (h.type === "module")
            var as = b.moduleScriptResources, uf = p.preloads.moduleScripts;
          else
            as = b.scriptResources, uf = p.preloads.scripts;
          var Zr = as.hasOwnProperty(ls) ? as[ls] : void 0;
          if (Zr !== null) {
            as[ls] = null;
            var bo = h;
            if (Zr) {
              Zr.length === 2 && (bo = be({}, h), cr(bo, Zr));
              var mo = uf.get(ls);
              mo && (mo.length = 0);
            }
            var cf = [];
            p.scripts.add(cf), Zt(cf, bo);
          }
          L && i.push(bn), rf = null;
        }
        return rf;
      case "style":
        var ed = I.tagScope & 1, Vr = h.precedence, _u = h.href, of = h.nonce;
        if (I.insertionMode === 4 || ed || h.itemProp != null || typeof Vr != "string" || typeof _u != "string" || _u === "") {
          i.push(Tn("style"));
          var Nu = null, is = null, Mu;
          for (Mu in h)
            if (Oe.call(h, Mu)) {
              var To = h[Mu];
              if (To != null)
                switch (Mu) {
                  case "children":
                    Nu = To;
                    break;
                  case "dangerouslySetInnerHTML":
                    is = To;
                    break;
                  default:
                    Tt(
                      i,
                      Mu,
                      To
                    );
                }
            }
          i.push(_t);
          var Nc = Array.isArray(Nu) ? 2 > Nu.length ? Nu[0] : null : Nu;
          typeof Nc != "function" && typeof Nc != "symbol" && Nc !== null && Nc !== void 0 && i.push(
            re(("" + Nc).replace(Fe, At))
          ), In(i, is, Nu), i.push(Ga("style"));
          var Qr = null;
        } else {
          var Wr = p.styles.get(Vr);
          if ((b.styleResources.hasOwnProperty(_u) ? b.styleResources[_u] : void 0) !== null) {
            b.styleResources[_u] = null, Wr || (Wr = {
              precedence: re(
                Ye(Vr)
              ),
              rules: [],
              hrefs: [],
              sheets: /* @__PURE__ */ new Map()
            }, p.styles.set(Vr, Wr));
            var sf = p.nonce.style;
            if (!sf || sf === of) {
              Wr.hrefs.push(
                re(Ye(_u))
              );
              var ff = Wr.rules, yr = null, df = null, Mc;
              for (Mc in h)
                if (Oe.call(h, Mc)) {
                  var rs = h[Mc];
                  if (rs != null)
                    switch (Mc) {
                      case "children":
                        yr = rs;
                        break;
                      case "dangerouslySetInnerHTML":
                        df = rs;
                    }
                }
              var zc = Array.isArray(yr) ? 2 > yr.length ? yr[0] : null : yr;
              typeof zc != "function" && typeof zc != "symbol" && zc !== null && zc !== void 0 && ff.push(
                re(
                  ("" + zc).replace(Fe, At)
                )
              ), In(ff, df, yr);
            }
          }
          Wr && M && M.styles.add(Wr), L && i.push(bn), Qr = void 0;
        }
        return Qr;
      case "meta":
        var yh = I.tagScope & 1, hf = I.tagScope & 4;
        if (I.insertionMode === 4 || yh || h.itemProp != null)
          var Fn = Nt(
            i,
            h,
            "meta"
          );
        else
          L && i.push(bn), Fn = hf ? null : typeof h.charSet == "string" ? Nt(p.charsetChunks, h, "meta") : h.name === "viewport" ? Nt(p.viewportChunks, h, "meta") : Nt(p.hoistableChunks, h, "meta");
        return Fn;
      case "listing":
      case "pre":
        i.push(Tn(u));
        var Yn = null, Dc = null, kc;
        for (kc in h)
          if (Oe.call(h, kc)) {
            var po = h[kc];
            if (po != null)
              switch (kc) {
                case "children":
                  Yn = po;
                  break;
                case "dangerouslySetInnerHTML":
                  Dc = po;
                  break;
                default:
                  Tt(
                    i,
                    kc,
                    po
                  );
              }
          }
        if (i.push(_t), Dc != null) {
          if (Yn != null) throw Error(f(60));
          if (typeof Dc != "object" || !("__html" in Dc))
            throw Error(f(61));
          var Pr = Dc.__html;
          Pr != null && (typeof Pr == "string" && 0 < Pr.length && Pr[0] === `
` ? i.push(Qu, re(Pr)) : i.push(re("" + Pr)));
        }
        return typeof Yn == "string" && Yn[0] === `
` && i.push(Qu), Yn;
      case "img":
        var So = I.tagScope & 3, Ol = h.src, Wn = h.srcSet;
        if (!(h.loading === "lazy" || !Ol && !Wn || typeof Ol != "string" && Ol != null || typeof Wn != "string" && Wn != null || h.fetchPriority === "low" || So) && (typeof Ol != "string" || Ol[4] !== ":" || Ol[0] !== "d" && Ol[0] !== "D" || Ol[1] !== "a" && Ol[1] !== "A" || Ol[2] !== "t" && Ol[2] !== "T" || Ol[3] !== "a" && Ol[3] !== "A") && (typeof Wn != "string" || Wn[4] !== ":" || Wn[0] !== "d" && Wn[0] !== "D" || Wn[1] !== "a" && Wn[1] !== "A" || Wn[2] !== "t" && Wn[2] !== "T" || Wn[3] !== "a" && Wn[3] !== "A")) {
          M !== null && I.tagScope & 64 && (M.suspenseyImages = !0);
          var gf = typeof h.sizes == "string" ? h.sizes : void 0, Lc = Wn ? Wn + `
` + (gf || "") : Ol, Bc = p.preloads.images, br = Bc.get(Lc);
          if (br)
            (h.fetchPriority === "high" || 10 > p.highImagePreloads.size) && (Bc.delete(Lc), p.highImagePreloads.add(br));
          else if (!b.imageResources.hasOwnProperty(Lc)) {
            b.imageResources[Lc] = Cn;
            var us = h.crossOrigin, vf = typeof us == "string" ? us === "use-credentials" ? us : "" : void 0, Jr = p.headers, xo;
            Jr && 0 < Jr.remainingCapacity && typeof h.srcSet != "string" && (h.fetchPriority === "high" || 500 > Jr.highImagePreloads.length) && (xo = du(Ol, "image", {
              imageSrcSet: h.srcSet,
              imageSizes: h.sizes,
              crossOrigin: vf,
              integrity: h.integrity,
              nonce: h.nonce,
              type: h.type,
              fetchPriority: h.fetchPriority,
              referrerPolicy: h.refererPolicy
            }), 0 <= (Jr.remainingCapacity -= xo.length + 2)) ? (p.resets.image[Lc] = Cn, Jr.highImagePreloads && (Jr.highImagePreloads += ", "), Jr.highImagePreloads += xo) : (br = [], ge(br, {
              rel: "preload",
              as: "image",
              href: Wn ? void 0 : Ol,
              imageSrcSet: Wn,
              imageSizes: gf,
              crossOrigin: vf,
              integrity: h.integrity,
              type: h.type,
              fetchPriority: h.fetchPriority,
              referrerPolicy: h.referrerPolicy
            }), h.fetchPriority === "high" || 10 > p.highImagePreloads.size ? p.highImagePreloads.add(br) : (p.bulkPreloads.add(br), Bc.set(Lc, br)));
          }
        }
        return Nt(i, h, "img");
      case "base":
      case "area":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "param":
      case "source":
      case "track":
      case "wbr":
        return Nt(i, h, u);
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        break;
      case "head":
        if (2 > I.insertionMode) {
          var Eo = C || p.preamble;
          if (Eo.headChunks)
            throw Error(f(545, "`<head>`"));
          C !== null && i.push(xa), Eo.headChunks = [];
          var cs = bl(
            Eo.headChunks,
            h,
            "head"
          );
        } else
          cs = cn(
            i,
            h,
            "head"
          );
        return cs;
      case "body":
        if (2 > I.insertionMode) {
          var os = C || p.preamble;
          if (os.bodyChunks)
            throw Error(f(545, "`<body>`"));
          C !== null && i.push(Ea), os.bodyChunks = [];
          var ss = bl(
            os.bodyChunks,
            h,
            "body"
          );
        } else
          ss = cn(
            i,
            h,
            "body"
          );
        return ss;
      case "html":
        if (I.insertionMode === 0) {
          var Hc = C || p.preamble;
          if (Hc.htmlChunks)
            throw Error(f(545, "`<html>`"));
          C !== null && i.push(Wl), Hc.htmlChunks = [Ya];
          var fs = bl(
            Hc.htmlChunks,
            h,
            "html"
          );
        } else
          fs = cn(
            i,
            h,
            "html"
          );
        return fs;
      default:
        if (u.indexOf("-") !== -1) {
          i.push(Tn(u));
          var ds = null, hs = null, zu;
          for (zu in h)
            if (Oe.call(h, zu)) {
              var tl = h[zu];
              if (tl != null) {
                var gs = zu;
                switch (zu) {
                  case "children":
                    ds = tl;
                    break;
                  case "dangerouslySetInnerHTML":
                    hs = tl;
                    break;
                  case "style":
                    ui(i, tl);
                    break;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "ref":
                    break;
                  case "className":
                    gs = "class";
                  default:
                    if (Gn(zu) && typeof tl != "function" && typeof tl != "symbol" && tl !== !1) {
                      if (tl === !0) tl = "";
                      else if (typeof tl == "object") continue;
                      i.push(
                        un,
                        re(gs),
                        il,
                        re(Ye(tl)),
                        kt
                      );
                    }
                }
              }
            }
          return i.push(_t), In(i, hs, ds), ds;
        }
    }
    return cn(i, h, u);
  }
  var kl = /* @__PURE__ */ new Map();
  function Ga(i) {
    var u = kl.get(i);
    return u === void 0 && (u = j("</" + i + ">"), kl.set(i, u)), u;
  }
  function Pu(i, u) {
    i = i.preamble, i.htmlChunks === null && u.htmlChunks && (i.htmlChunks = u.htmlChunks), i.headChunks === null && u.headChunks && (i.headChunks = u.headChunks), i.bodyChunks === null && u.bodyChunks && (i.bodyChunks = u.bodyChunks);
  }
  function nu(i, u) {
    u = u.bootstrapChunks;
    for (var h = 0; h < u.length - 1; h++)
      U(i, u[h]);
    return h < u.length ? (h = u[h], u.length = 0, Q(i, h)) : !0;
  }
  var Pl = j(
    "requestAnimationFrame(function(){$RT=performance.now()});"
  ), to = j('<template id="'), Fo = j('"></template>'), ha = j("<!--&-->"), Ju = j("<!--/&-->"), Yo = j("<!--$-->"), Go = j(
    '<!--$?--><template id="'
  ), no = j('"></template>'), ml = j("<!--$!-->"), Jl = j("<!--/$-->"), Ku = j("<template"), ga = j('"'), wr = j(' data-dgst="');
  j(' data-msg="'), j(' data-stck="'), j(' data-cstck="');
  var lo = j("></template>");
  function lr(i, u, h) {
    if (U(i, Go), h === null) throw Error(f(395));
    return U(i, u.boundaryPrefix), U(i, re(h.toString(16))), Q(i, no);
  }
  var Ll = j('<div hidden id="'), ju = j('">'), lu = j("</div>"), qu = j(
    '<svg aria-hidden="true" style="display:none" id="'
  ), Ri = j('">'), ot = j("</svg>"), ar = j(
    '<math aria-hidden="true" style="display:none" id="'
  ), _i = j('">'), va = j("</math>"), ir = j('<table hidden id="'), Ni = j('">'), au = j("</table>"), oi = j('<table hidden><tbody id="'), wa = j('">'), iu = j("</tbody></table>"), on = j('<table hidden><tr id="'), Mi = j('">'), Ar = j("</tr></table>"), Xa = j(
    '<table hidden><colgroup id="'
  ), ru = j('">'), $u = j("</colgroup></table>");
  function ec(i, u, h, b) {
    switch (h.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return U(i, Ll), U(i, u.segmentPrefix), U(i, re(b.toString(16))), Q(i, ju);
      case 4:
        return U(i, qu), U(i, u.segmentPrefix), U(i, re(b.toString(16))), Q(i, Ri);
      case 5:
        return U(i, ar), U(i, u.segmentPrefix), U(i, re(b.toString(16))), Q(i, _i);
      case 6:
        return U(i, ir), U(i, u.segmentPrefix), U(i, re(b.toString(16))), Q(i, Ni);
      case 7:
        return U(i, oi), U(i, u.segmentPrefix), U(i, re(b.toString(16))), Q(i, wa);
      case 8:
        return U(i, on), U(i, u.segmentPrefix), U(i, re(b.toString(16))), Q(i, Mi);
      case 9:
        return U(i, Xa), U(i, u.segmentPrefix), U(i, re(b.toString(16))), Q(i, ru);
      default:
        throw Error(f(397));
    }
  }
  function Or(i, u) {
    switch (u.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return Q(i, lu);
      case 4:
        return Q(i, ot);
      case 5:
        return Q(i, va);
      case 6:
        return Q(i, au);
      case 7:
        return Q(i, iu);
      case 8:
        return Q(i, Ar);
      case 9:
        return Q(i, $u);
      default:
        throw Error(f(397));
    }
  }
  var tc = j(
    '$RS=function(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'
  ), Xo = j('$RS("'), Ys = j('","'), Gs = j('")<\/script>');
  j('<template data-rsi="" data-sid="'), j('" data-pid="');
  var ao = j(
    `$RB=[];$RV=function(a){$RT=performance.now();for(var b=0;b<a.length;b+=2){var c=a[b],e=a[b+1];null!==e.parentNode&&e.parentNode.removeChild(e);var f=c.parentNode;if(f){var g=c.previousSibling,h=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d||"/&"===d)if(0===h)break;else h--;else"$"!==d&&"$?"!==d&&"$~"!==d&&"$!"!==d&&"&"!==d||h++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;e.firstChild;)f.insertBefore(e.firstChild,c);g.data="$";g._reactRetry&&requestAnimationFrame(g._reactRetry)}}a.length=0};
$RC=function(a,b){if(b=document.getElementById(b))(a=document.getElementById(a))?(a.previousSibling.data="$~",$RB.push(a,b),2===$RB.length&&("number"!==typeof $RT?requestAnimationFrame($RV.bind(null,$RB)):(a=performance.now(),setTimeout($RV.bind(null,$RB),2300>a&&2E3<a?2300-a:$RT+300-a)))):b.parentNode.removeChild(b)};`
  );
  re(
    `$RV=function(A,g){function k(a,b){var e=a.getAttribute(b);e&&(b=a.style,l.push(a,b.viewTransitionName,b.viewTransitionClass),"auto"!==e&&(b.viewTransitionClass=e),(a=a.getAttribute("vt-name"))||(a="_T_"+K++ +"_"),b.viewTransitionName=a,B=!0)}var B=!1,K=0,l=[];try{var f=document.__reactViewTransition;if(f){f.finished.finally($RV.bind(null,g));return}var m=new Map;for(f=1;f<g.length;f+=2)for(var h=g[f].querySelectorAll("[vt-share]"),d=0;d<h.length;d++){var c=h[d];m.set(c.getAttribute("vt-name"),c)}var u=[];for(h=0;h<g.length;h+=2){var C=g[h],x=C.parentNode;if(x){var v=x.getBoundingClientRect();if(v.left||v.top||v.width||v.height){c=C;for(f=0;c;){if(8===c.nodeType){var r=c.data;if("/$"===r)if(0===f)break;else f--;else"$"!==r&&"$?"!==r&&"$~"!==r&&"$!"!==r||f++}else if(1===c.nodeType){d=c;var D=d.getAttribute("vt-name"),y=m.get(D);k(d,y?"vt-share":"vt-exit");y&&(k(y,"vt-share"),m.set(D,null));var E=d.querySelectorAll("[vt-share]");for(d=0;d<E.length;d++){var F=E[d],G=F.getAttribute("vt-name"),
H=m.get(G);H&&(k(F,"vt-share"),k(H,"vt-share"),m.set(G,null))}}c=c.nextSibling}for(var I=g[h+1],t=I.firstElementChild;t;)null!==m.get(t.getAttribute("vt-name"))&&k(t,"vt-enter"),t=t.nextElementSibling;c=x;do for(var n=c.firstElementChild;n;){var J=n.getAttribute("vt-update");J&&"none"!==J&&!l.includes(n)&&k(n,"vt-update");n=n.nextElementSibling}while((c=c.parentNode)&&1===c.nodeType&&"none"!==c.getAttribute("vt-update"));u.push.apply(u,I.querySelectorAll('img[src]:not([loading="lazy"])'))}}}if(B){var z=
document.__reactViewTransition=document.startViewTransition({update:function(){A(g);for(var a=[document.documentElement.clientHeight,document.fonts.ready],b={},e=0;e<u.length;b={g:b.g},e++)if(b.g=u[e],!b.g.complete){var p=b.g.getBoundingClientRect();0<p.bottom&&0<p.right&&p.top<window.innerHeight&&p.left<window.innerWidth&&(p=new Promise(function(w){return function(q){w.g.addEventListener("load",q);w.g.addEventListener("error",q)}}(b)),a.push(p))}return Promise.race([Promise.all(a),new Promise(function(w){var q=
performance.now();setTimeout(w,2300>q&&2E3<q?2300-q:500)})])},types:[]});z.ready.finally(function(){for(var a=l.length-3;0<=a;a-=3){var b=l[a],e=b.style;e.viewTransitionName=l[a+1];e.viewTransitionClass=l[a+1];""===b.getAttribute("style")&&b.removeAttribute("style")}});z.finished.finally(function(){document.__reactViewTransition===z&&(document.__reactViewTransition=null)});$RB=[];return}}catch(a){}A(g)}.bind(null,$RV);`
  );
  var nc = j('$RC("'), Xs = j(
    `$RM=new Map;$RR=function(n,w,p){function u(q){this._p=null;q()}for(var r=new Map,t=document,h,b,e=t.querySelectorAll("link[data-precedence],style[data-precedence]"),v=[],k=0;b=e[k++];)"not all"===b.getAttribute("media")?v.push(b):("LINK"===b.tagName&&$RM.set(b.getAttribute("href"),b),r.set(b.dataset.precedence,h=b));e=0;b=[];var l,a;for(k=!0;;){if(k){var f=p[e++];if(!f){k=!1;e=0;continue}var c=!1,m=0;var d=f[m++];if(a=$RM.get(d)){var g=a._p;c=!0}else{a=t.createElement("link");a.href=d;a.rel=
"stylesheet";for(a.dataset.precedence=l=f[m++];g=f[m++];)a.setAttribute(g,f[m++]);g=a._p=new Promise(function(q,x){a.onload=u.bind(a,q);a.onerror=u.bind(a,x)});$RM.set(d,a)}d=a.getAttribute("media");!g||d&&!matchMedia(d).matches||b.push(g);if(c)continue}else{a=v[e++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=r.get(l)||h;c===h&&(h=a);r.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=t.head,c.insertBefore(a,c.firstChild))}if(p=document.getElementById(n))p.previousSibling.data=
"$~";Promise.all(b).then($RC.bind(null,n,w),$RX.bind(null,n,"CSS failed to load"))};$RR("`
  ), Io = j('$RR("'), lc = j('","'), Is = j('",'), io = j('"'), ro = j(")<\/script>");
  j('<template data-rci="" data-bid="'), j('<template data-rri="" data-bid="'), j('" data-sid="'), j('" data-sty="');
  var Cr = j(
    '$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};'
  ), uo = j(
    '$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};;$RX("'
  ), ac = j('$RX("'), Zo = j('"'), zi = j(","), Zs = j(")<\/script>");
  j('<template data-rxi="" data-bid="'), j('" data-dgst="'), j('" data-msg="'), j('" data-stck="'), j('" data-cstck="');
  var Vs = /[<\u2028\u2029]/g;
  function Qs(i) {
    return JSON.stringify(i).replace(
      Vs,
      function(u) {
        switch (u) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw Error(
              "escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
            );
        }
      }
    );
  }
  var Zn = /[&><\u2028\u2029]/g;
  function Rr(i) {
    return JSON.stringify(i).replace(
      Zn,
      function(u) {
        switch (u) {
          case "&":
            return "\\u0026";
          case ">":
            return "\\u003e";
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw Error(
              "escapeJSObjectForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
            );
        }
      }
    );
  }
  var co = j(
    ' media="not all" data-precedence="'
  ), ic = j('" data-href="'), Vo = j('">'), rr = j("</style>"), Di = !1, uu = !0;
  function ki(i) {
    var u = i.rules, h = i.hrefs, b = 0;
    if (h.length) {
      for (U(this, ca.startInlineStyle), U(this, co), U(this, i.precedence), U(this, ic); b < h.length - 1; b++)
        U(this, h[b]), U(this, uc);
      for (U(this, h[b]), U(this, Vo), b = 0; b < u.length; b++) U(this, u[b]);
      uu = Q(
        this,
        rr
      ), Di = !0, u.length = 0, h.length = 0;
    }
  }
  function rl(i) {
    return i.state !== 2 ? Di = !0 : !1;
  }
  function Li(i, u, h) {
    return Di = !1, uu = !0, ca = h, u.styles.forEach(ki, i), ca = null, u.stylesheets.forEach(rl), Di && (h.stylesToHoist = !0), uu;
  }
  function Ot(i) {
    for (var u = 0; u < i.length; u++) U(this, i[u]);
    i.length = 0;
  }
  var Ia = [];
  function rc(i) {
    ge(Ia, i.props);
    for (var u = 0; u < Ia.length; u++)
      U(this, Ia[u]);
    Ia.length = 0, i.state = 2;
  }
  var _r = j(' data-precedence="'), oo = j('" data-href="'), uc = j(" "), so = j('">'), si = j("</style>");
  function cc(i) {
    var u = 0 < i.sheets.size;
    i.sheets.forEach(rc, this), i.sheets.clear();
    var h = i.rules, b = i.hrefs;
    if (!u || b.length) {
      if (U(this, ca.startInlineStyle), U(this, _r), U(this, i.precedence), i = 0, b.length) {
        for (U(this, oo); i < b.length - 1; i++)
          U(this, b[i]), U(this, uc);
        U(this, b[i]);
      }
      for (U(this, so), i = 0; i < h.length; i++)
        U(this, h[i]);
      U(this, si), h.length = 0, b.length = 0;
    }
  }
  function ya(i) {
    if (i.state === 0) {
      i.state = 1;
      var u = i.props;
      for (ge(Ia, {
        rel: "preload",
        as: "style",
        href: i.props.href,
        crossOrigin: u.crossOrigin,
        fetchPriority: u.fetchPriority,
        integrity: u.integrity,
        media: u.media,
        hrefLang: u.hrefLang,
        referrerPolicy: u.referrerPolicy
      }), i = 0; i < Ia.length; i++)
        U(this, Ia[i]);
      Ia.length = 0;
    }
  }
  function fo(i) {
    i.sheets.forEach(ya, this), i.sheets.clear();
  }
  j('<link rel="expect" href="#'), j('" blocking="render"/>');
  var cu = j(' id="');
  function Nr(i, u) {
    (u.instructions & 32) === 0 && (u.instructions |= 32, i.push(
      cu,
      re(Ye("_" + u.idPrefix + "R_")),
      kt
    ));
  }
  var Bi = j("["), Hi = j(",["), oc = j(","), ur = j("]");
  function Dn(i, u) {
    U(i, Bi);
    var h = Bi;
    u.stylesheets.forEach(function(b) {
      if (b.state !== 2)
        if (b.state === 3)
          U(i, h), U(
            i,
            re(
              Rr("" + b.props.href)
            )
          ), U(i, ur), h = Hi;
        else {
          U(i, h);
          var p = b.props["data-precedence"], C = b.props, M = _l("" + b.props.href);
          U(
            i,
            re(Rr(M))
          ), p = "" + p, U(i, oc), U(
            i,
            re(Rr(p))
          );
          for (var I in C)
            if (Oe.call(C, I) && (p = C[I], p != null))
              switch (I) {
                case "href":
                case "rel":
                case "precedence":
                case "data-precedence":
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(f(399, "link"));
                default:
                  Qo(
                    i,
                    I,
                    p
                  );
              }
          U(i, ur), h = Hi, b.state = 3;
        }
    }), U(i, ur);
  }
  function Qo(i, u, h) {
    var b = u.toLowerCase();
    switch (typeof h) {
      case "function":
      case "symbol":
        return;
    }
    switch (u) {
      case "innerHTML":
      case "dangerouslySetInnerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "style":
      case "ref":
        return;
      case "className":
        b = "class", u = "" + h;
        break;
      case "hidden":
        if (h === !1) return;
        u = "";
        break;
      case "src":
      case "href":
        h = _l(h), u = "" + h;
        break;
      default:
        if (2 < u.length && (u[0] === "o" || u[0] === "O") && (u[1] === "n" || u[1] === "N") || !Gn(u))
          return;
        u = "" + h;
    }
    U(i, oc), U(
      i,
      re(Rr(b))
    ), U(i, oc), U(
      i,
      re(Rr(u))
    );
  }
  function fi() {
    return { styles: /* @__PURE__ */ new Set(), stylesheets: /* @__PURE__ */ new Set(), suspenseyImages: !1 };
  }
  function ou(i) {
    var u = Jt || null;
    if (u) {
      var h = u.resumableState, b = u.renderState;
      if (typeof i == "string" && i) {
        if (!h.dnsResources.hasOwnProperty(i)) {
          h.dnsResources[i] = null, h = b.headers;
          var p, C;
          (C = h && 0 < h.remainingCapacity) && (C = (p = "<" + ("" + i).replace(
            kn,
            Za
          ) + ">; rel=dns-prefetch", 0 <= (h.remainingCapacity -= p.length + 2))), C ? (b.resets.dns[i] = null, h.preconnects && (h.preconnects += ", "), h.preconnects += p) : (p = [], ge(p, { href: i, rel: "dns-prefetch" }), b.preconnects.add(p));
        }
        fl(u);
      }
    } else On.D(i);
  }
  function sc(i, u) {
    var h = Jt || null;
    if (h) {
      var b = h.resumableState, p = h.renderState;
      if (typeof i == "string" && i) {
        var C = u === "use-credentials" ? "credentials" : typeof u == "string" ? "anonymous" : "default";
        if (!b.connectResources[C].hasOwnProperty(i)) {
          b.connectResources[C][i] = null, b = p.headers;
          var M, I;
          if (I = b && 0 < b.remainingCapacity) {
            if (I = "<" + ("" + i).replace(
              kn,
              Za
            ) + ">; rel=preconnect", typeof u == "string") {
              var L = ("" + u).replace(
                Fi,
                Yi
              );
              I += '; crossorigin="' + L + '"';
            }
            I = (M = I, 0 <= (b.remainingCapacity -= M.length + 2));
          }
          I ? (p.resets.connect[C][i] = null, b.preconnects && (b.preconnects += ", "), b.preconnects += M) : (C = [], ge(C, {
            rel: "preconnect",
            href: i,
            crossOrigin: u
          }), p.preconnects.add(C));
        }
        fl(h);
      }
    } else On.C(i, u);
  }
  function fc(i, u, h) {
    var b = Jt || null;
    if (b) {
      var p = b.resumableState, C = b.renderState;
      if (u && i) {
        switch (u) {
          case "image":
            if (h)
              var M = h.imageSrcSet, I = h.imageSizes, L = h.fetchPriority;
            var X = M ? M + `
` + (I || "") : i;
            if (p.imageResources.hasOwnProperty(X)) return;
            p.imageResources[X] = Cn, p = C.headers;
            var W;
            p && 0 < p.remainingCapacity && typeof M != "string" && L === "high" && (W = du(i, u, h), 0 <= (p.remainingCapacity -= W.length + 2)) ? (C.resets.image[X] = Cn, p.highImagePreloads && (p.highImagePreloads += ", "), p.highImagePreloads += W) : (p = [], ge(
              p,
              be(
                { rel: "preload", href: M ? void 0 : i, as: u },
                h
              )
            ), L === "high" ? C.highImagePreloads.add(p) : (C.bulkPreloads.add(p), C.preloads.images.set(X, p)));
            break;
          case "style":
            if (p.styleResources.hasOwnProperty(i)) return;
            M = [], ge(
              M,
              be({ rel: "preload", href: i, as: u }, h)
            ), p.styleResources[i] = !h || typeof h.crossOrigin != "string" && typeof h.integrity != "string" ? Cn : [h.crossOrigin, h.integrity], C.preloads.stylesheets.set(i, M), C.bulkPreloads.add(M);
            break;
          case "script":
            if (p.scriptResources.hasOwnProperty(i)) return;
            M = [], C.preloads.scripts.set(i, M), C.bulkPreloads.add(M), ge(
              M,
              be({ rel: "preload", href: i, as: u }, h)
            ), p.scriptResources[i] = !h || typeof h.crossOrigin != "string" && typeof h.integrity != "string" ? Cn : [h.crossOrigin, h.integrity];
            break;
          default:
            if (p.unknownResources.hasOwnProperty(u)) {
              if (M = p.unknownResources[u], M.hasOwnProperty(i))
                return;
            } else
              M = {}, p.unknownResources[u] = M;
            if (M[i] = Cn, (p = C.headers) && 0 < p.remainingCapacity && u === "font" && (X = du(i, u, h), 0 <= (p.remainingCapacity -= X.length + 2)))
              C.resets.font[i] = Cn, p.fontPreloads && (p.fontPreloads += ", "), p.fontPreloads += X;
            else
              switch (p = [], i = be({ rel: "preload", href: i, as: u }, h), ge(p, i), u) {
                case "font":
                  C.fontPreloads.add(p);
                  break;
                default:
                  C.bulkPreloads.add(p);
              }
        }
        fl(b);
      }
    } else On.L(i, u, h);
  }
  function su(i, u) {
    var h = Jt || null;
    if (h) {
      var b = h.resumableState, p = h.renderState;
      if (i) {
        var C = u && typeof u.as == "string" ? u.as : "script";
        switch (C) {
          case "script":
            if (b.moduleScriptResources.hasOwnProperty(i)) return;
            C = [], b.moduleScriptResources[i] = !u || typeof u.crossOrigin != "string" && typeof u.integrity != "string" ? Cn : [u.crossOrigin, u.integrity], p.preloads.moduleScripts.set(i, C);
            break;
          default:
            if (b.moduleUnknownResources.hasOwnProperty(C)) {
              var M = b.unknownResources[C];
              if (M.hasOwnProperty(i)) return;
            } else
              M = {}, b.moduleUnknownResources[C] = M;
            C = [], M[i] = Cn;
        }
        ge(C, be({ rel: "modulepreload", href: i }, u)), p.bulkPreloads.add(C), fl(h);
      }
    } else On.m(i, u);
  }
  function fu(i, u, h) {
    var b = Jt || null;
    if (b) {
      var p = b.resumableState, C = b.renderState;
      if (i) {
        u = u || "default";
        var M = C.styles.get(u), I = p.styleResources.hasOwnProperty(i) ? p.styleResources[i] : void 0;
        I !== null && (p.styleResources[i] = null, M || (M = {
          precedence: re(Ye(u)),
          rules: [],
          hrefs: [],
          sheets: /* @__PURE__ */ new Map()
        }, C.styles.set(u, M)), u = {
          state: 0,
          props: be(
            { rel: "stylesheet", href: i, "data-precedence": u },
            h
          )
        }, I && (I.length === 2 && cr(u.props, I), (C = C.preloads.stylesheets.get(i)) && 0 < C.length ? C.length = 0 : u.state = 1), M.sheets.set(i, u), fl(b));
      }
    } else On.S(i, u, h);
  }
  function Ui(i, u) {
    var h = Jt || null;
    if (h) {
      var b = h.resumableState, p = h.renderState;
      if (i) {
        var C = b.scriptResources.hasOwnProperty(i) ? b.scriptResources[i] : void 0;
        C !== null && (b.scriptResources[i] = null, u = be({ src: i, async: !0 }, u), C && (C.length === 2 && cr(u, C), i = p.preloads.scripts.get(i)) && (i.length = 0), i = [], p.scripts.add(i), Zt(i, u), fl(h));
      }
    } else On.X(i, u);
  }
  function Wo(i, u) {
    var h = Jt || null;
    if (h) {
      var b = h.resumableState, p = h.renderState;
      if (i) {
        var C = b.moduleScriptResources.hasOwnProperty(
          i
        ) ? b.moduleScriptResources[i] : void 0;
        C !== null && (b.moduleScriptResources[i] = null, u = be({ src: i, type: "module", async: !0 }, u), C && (C.length === 2 && cr(u, C), i = p.preloads.moduleScripts.get(i)) && (i.length = 0), i = [], p.scripts.add(i), Zt(i, u), fl(h));
      }
    } else On.M(i, u);
  }
  function cr(i, u) {
    i.crossOrigin == null && (i.crossOrigin = u[0]), i.integrity == null && (i.integrity = u[1]);
  }
  function du(i, u, h) {
    i = ("" + i).replace(
      kn,
      Za
    ), u = ("" + u).replace(
      Fi,
      Yi
    ), u = "<" + i + '>; rel=preload; as="' + u + '"';
    for (var b in h)
      Oe.call(h, b) && (i = h[b], typeof i == "string" && (u += "; " + b.toLowerCase() + '="' + ("" + i).replace(
        Fi,
        Yi
      ) + '"'));
    return u;
  }
  var kn = /[<>\r\n]/g;
  function Za(i) {
    switch (i) {
      case "<":
        return "%3C";
      case ">":
        return "%3E";
      case `
`:
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error(
          "escapeLinkHrefForHeaderContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
        );
    }
  }
  var Fi = /["';,\r\n]/g;
  function Yi(i) {
    switch (i) {
      case '"':
        return "%22";
      case "'":
        return "%27";
      case ";":
        return "%3B";
      case ",":
        return "%2C";
      case `
`:
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error(
          "escapeStringForLinkHeaderQuotedParamValueContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
        );
    }
  }
  function dc(i) {
    this.styles.add(i);
  }
  function ho(i) {
    this.stylesheets.add(i);
  }
  function di(i, u) {
    u.styles.forEach(dc, i), u.stylesheets.forEach(ho, i), u.suspenseyImages && (i.suspenseyImages = !0);
  }
  function hu(i) {
    return 0 < i.stylesheets.size || i.suspenseyImages;
  }
  var hi = Function.prototype.bind, gi = Symbol.for("react.client.reference");
  function Gi(i) {
    if (i == null) return null;
    if (typeof i == "function")
      return i.$$typeof === gi ? null : i.displayName || i.name || null;
    if (typeof i == "string") return i;
    switch (i) {
      case T:
        return "Fragment";
      case O:
        return "Profiler";
      case w:
        return "StrictMode";
      case Z:
        return "Suspense";
      case Y:
        return "SuspenseList";
      case he:
        return "Activity";
    }
    if (typeof i == "object")
      switch (i.$$typeof) {
        case y:
          return "Portal";
        case z:
          return i.displayName || "Context";
        case _:
          return (i._context.displayName || "Context") + ".Consumer";
        case H:
          var u = i.render;
          return i = i.displayName, i || (i = u.displayName || u.name || "", i = i !== "" ? "ForwardRef(" + i + ")" : "ForwardRef"), i;
        case ce:
          return u = i.displayName || null, u !== null ? u : Gi(i.type) || "Memo";
        case le:
          u = i._payload, i = i._init;
          try {
            return Gi(i(u));
          } catch {
          }
      }
    return null;
  }
  var hc = {}, Aa = null;
  function Va(i, u) {
    if (i !== u) {
      i.context._currentValue = i.parentValue, i = i.parent;
      var h = u.parent;
      if (i === null) {
        if (h !== null) throw Error(f(401));
      } else {
        if (h === null) throw Error(f(401));
        Va(i, h);
      }
      u.context._currentValue = u.value;
    }
  }
  function Xi(i) {
    i.context._currentValue = i.parentValue, i = i.parent, i !== null && Xi(i);
  }
  function r(i) {
    var u = i.parent;
    u !== null && r(u), i.context._currentValue = i.value;
  }
  function c(i, u) {
    if (i.context._currentValue = i.parentValue, i = i.parent, i === null) throw Error(f(402));
    i.depth === u.depth ? Va(i, u) : c(i, u);
  }
  function g(i, u) {
    var h = u.parent;
    if (h === null) throw Error(f(402));
    i.depth === h.depth ? Va(i, h) : g(i, h), u.context._currentValue = u.value;
  }
  function m(i) {
    var u = Aa;
    u !== i && (u === null ? r(i) : i === null ? Xi(u) : u.depth === i.depth ? Va(u, i) : u.depth > i.depth ? c(u, i) : g(u, i), Aa = i);
  }
  var x = {
    enqueueSetState: function(i, u) {
      i = i._reactInternals, i.queue !== null && i.queue.push(u);
    },
    enqueueReplaceState: function(i, u) {
      i = i._reactInternals, i.replace = !0, i.queue = [u];
    },
    enqueueForceUpdate: function() {
    }
  }, N = { id: 1, overflow: "" };
  function D(i, u, h) {
    var b = i.id;
    i = i.overflow;
    var p = 32 - $(b) - 1;
    b &= ~(1 << p), h += 1;
    var C = 32 - $(u) + p;
    if (30 < C) {
      var M = p - p % 5;
      return C = (b & (1 << M) - 1).toString(32), b >>= M, p -= M, {
        id: 1 << 32 - $(u) + p | h << p | b,
        overflow: C + i
      };
    }
    return {
      id: 1 << C | h << p | b,
      overflow: i
    };
  }
  var $ = Math.clz32 ? Math.clz32 : se, F = Math.log, ee = Math.LN2;
  function se(i) {
    return i >>>= 0, i === 0 ? 32 : 31 - (F(i) / ee | 0) | 0;
  }
  function ae() {
  }
  var ve = Error(f(460));
  function Be(i, u, h) {
    switch (h = i[h], h === void 0 ? i.push(u) : h !== u && (u.then(ae, ae), u = h), u.status) {
      case "fulfilled":
        return u.value;
      case "rejected":
        throw u.reason;
      default:
        switch (typeof u.status == "string" ? u.then(ae, ae) : (i = u, i.status = "pending", i.then(
          function(b) {
            if (u.status === "pending") {
              var p = u;
              p.status = "fulfilled", p.value = b;
            }
          },
          function(b) {
            if (u.status === "pending") {
              var p = u;
              p.status = "rejected", p.reason = b;
            }
          }
        )), u.status) {
          case "fulfilled":
            return u.value;
          case "rejected":
            throw u.reason;
        }
        throw Ie = u, ve;
    }
  }
  var Ie = null;
  function Ze() {
    if (Ie === null) throw Error(f(459));
    var i = Ie;
    return Ie = null, i;
  }
  function Ke(i, u) {
    return i === u && (i !== 0 || 1 / i === 1 / u) || i !== i && u !== u;
  }
  var Qe = typeof Object.is == "function" ? Object.is : Ke, je = null, Vt = null, Mt = null, st = null, ft = null, tt = null, Bl = !1, We = !1, Tl = 0, at = 0, pn = -1, sn = 0, Ct = null, jn = null, Ii = 0;
  function pl() {
    if (je === null)
      throw Error(f(321));
    return je;
  }
  function Mr() {
    if (0 < Ii) throw Error(f(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function qn() {
    return tt === null ? ft === null ? (Bl = !1, ft = tt = Mr()) : (Bl = !0, tt = ft) : tt.next === null ? (Bl = !1, tt = tt.next = Mr()) : (Bl = !0, tt = tt.next), tt;
  }
  function Sn() {
    var i = Ct;
    return Ct = null, i;
  }
  function $n() {
    st = Mt = Vt = je = null, We = !1, ft = null, Ii = 0, tt = jn = null;
  }
  function Hl(i, u) {
    return typeof u == "function" ? u(i) : u;
  }
  function Sl(i, u, h) {
    if (je = pl(), tt = qn(), Bl) {
      var b = tt.queue;
      if (u = b.dispatch, jn !== null && (h = jn.get(b), h !== void 0)) {
        jn.delete(b), b = tt.memoizedState;
        do
          b = i(b, h.action), h = h.next;
        while (h !== null);
        return tt.memoizedState = b, [b, u];
      }
      return [tt.memoizedState, u];
    }
    return i = i === Hl ? typeof u == "function" ? u() : u : h !== void 0 ? h(u) : u, tt.memoizedState = i, i = tt.queue = { last: null, dispatch: null }, i = i.dispatch = Ln.bind(
      null,
      je,
      i
    ), [tt.memoizedState, i];
  }
  function _n(i, u) {
    if (je = pl(), tt = qn(), u = u === void 0 ? null : u, tt !== null) {
      var h = tt.memoizedState;
      if (h !== null && u !== null) {
        var b = h[1];
        e: if (b === null) b = !1;
        else {
          for (var p = 0; p < b.length && p < u.length; p++)
            if (!Qe(u[p], b[p])) {
              b = !1;
              break e;
            }
          b = !0;
        }
        if (b) return h[0];
      }
    }
    return i = i(), tt.memoizedState = [i, u], i;
  }
  function Ln(i, u, h) {
    if (25 <= Ii) throw Error(f(301));
    if (i === je)
      if (We = !0, i = { action: h, next: null }, jn === null && (jn = /* @__PURE__ */ new Map()), h = jn.get(u), h === void 0)
        jn.set(u, i);
      else {
        for (u = h; u.next !== null; ) u = u.next;
        u.next = i;
      }
  }
  function Pt() {
    throw Error(f(440));
  }
  function ul() {
    throw Error(f(394));
  }
  function Ul() {
    throw Error(f(479));
  }
  function Oa(i, u, h) {
    pl();
    var b = at++, p = Mt;
    if (typeof i.$$FORM_ACTION == "function") {
      var C = null, M = st;
      p = p.formState;
      var I = i.$$IS_SIGNATURE_EQUAL;
      if (p !== null && typeof I == "function") {
        var L = p[1];
        I.call(i, p[2], p[3]) && (C = h !== void 0 ? "p" + h : "k" + we(
          JSON.stringify([M, null, b]),
          0
        ), L === C && (pn = b, u = p[0]));
      }
      var X = i.bind(null, u);
      return i = function(te) {
        X(te);
      }, typeof X.$$FORM_ACTION == "function" && (i.$$FORM_ACTION = function(te) {
        te = X.$$FORM_ACTION(te), h !== void 0 && (h += "", te.action = h);
        var me = te.data;
        return me && (C === null && (C = h !== void 0 ? "p" + h : "k" + we(
          JSON.stringify([
            M,
            null,
            b
          ]),
          0
        )), me.append("$ACTION_KEY", C)), te;
      }), [u, i, !1];
    }
    var W = i.bind(null, u);
    return [
      u,
      function(te) {
        W(te);
      },
      !1
    ];
  }
  function gc(i) {
    var u = sn;
    return sn += 1, Ct === null && (Ct = []), Be(Ct, i, u);
  }
  function vc() {
    throw Error(f(393));
  }
  var gu = {
    readContext: function(i) {
      return i._currentValue;
    },
    use: function(i) {
      if (i !== null && typeof i == "object") {
        if (typeof i.then == "function") return gc(i);
        if (i.$$typeof === z) return i._currentValue;
      }
      throw Error(f(438, String(i)));
    },
    useContext: function(i) {
      return pl(), i._currentValue;
    },
    useMemo: _n,
    useReducer: Sl,
    useRef: function(i) {
      je = pl(), tt = qn();
      var u = tt.memoizedState;
      return u === null ? (i = { current: i }, tt.memoizedState = i) : u;
    },
    useState: function(i) {
      return Sl(Hl, i);
    },
    useInsertionEffect: ae,
    useLayoutEffect: ae,
    useCallback: function(i, u) {
      return _n(function() {
        return i;
      }, u);
    },
    useImperativeHandle: ae,
    useEffect: ae,
    useDebugValue: ae,
    useDeferredValue: function(i, u) {
      return pl(), u !== void 0 ? u : i;
    },
    useTransition: function() {
      return pl(), [!1, ul];
    },
    useId: function() {
      var i = Vt.treeContext, u = i.overflow;
      i = i.id, i = (i & ~(1 << 32 - $(i) - 1)).toString(32) + u;
      var h = zr;
      if (h === null) throw Error(f(404));
      return u = Tl++, i = "_" + h.idPrefix + "R_" + i, 0 < u && (i += "H" + u.toString(32)), i + "_";
    },
    useSyncExternalStore: function(i, u, h) {
      if (h === void 0)
        throw Error(f(407));
      return h();
    },
    useOptimistic: function(i) {
      return pl(), [i, Ul];
    },
    useActionState: Oa,
    useFormState: Oa,
    useHostTransitionStatus: function() {
      return pl(), Ai;
    },
    useMemoCache: function(i) {
      for (var u = Array(i), h = 0; h < i; h++)
        u[h] = de;
      return u;
    },
    useCacheRefresh: function() {
      return vc;
    },
    useEffectEvent: function() {
      return Pt;
    }
  }, zr = null, Vn = {
    getCacheForType: function() {
      throw Error(f(248));
    },
    cacheSignal: function() {
      throw Error(f(248));
    }
  }, xt, Pe;
  function Fl(i) {
    if (xt === void 0)
      try {
        throw Error();
      } catch (h) {
        var u = h.stack.trim().match(/\n( *(at )?)/);
        xt = u && u[1] || "", Pe = -1 < h.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < h.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + xt + i + Pe;
  }
  var xl = !1;
  function Qa(i, u) {
    if (!i || xl) return "";
    xl = !0;
    var h = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var b = {
        DetermineComponentFrameRoot: function() {
          try {
            if (u) {
              var te = function() {
                throw Error();
              };
              if (Object.defineProperty(te.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(te, []);
                } catch (Te) {
                  var me = Te;
                }
                Reflect.construct(i, [], te);
              } else {
                try {
                  te.call();
                } catch (Te) {
                  me = Te;
                }
                i.call(te.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (Te) {
                me = Te;
              }
              (te = i()) && typeof te.catch == "function" && te.catch(function() {
              });
            }
          } catch (Te) {
            if (Te && me && typeof Te.stack == "string")
              return [Te.stack, me.stack];
          }
          return [null, null];
        }
      };
      b.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var p = Object.getOwnPropertyDescriptor(
        b.DetermineComponentFrameRoot,
        "name"
      );
      p && p.configurable && Object.defineProperty(
        b.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var C = b.DetermineComponentFrameRoot(), M = C[0], I = C[1];
      if (M && I) {
        var L = M.split(`
`), X = I.split(`
`);
        for (p = b = 0; b < L.length && !L[b].includes("DetermineComponentFrameRoot"); )
          b++;
        for (; p < X.length && !X[p].includes(
          "DetermineComponentFrameRoot"
        ); )
          p++;
        if (b === L.length || p === X.length)
          for (b = L.length - 1, p = X.length - 1; 1 <= b && 0 <= p && L[b] !== X[p]; )
            p--;
        for (; 1 <= b && 0 <= p; b--, p--)
          if (L[b] !== X[p]) {
            if (b !== 1 || p !== 1)
              do
                if (b--, p--, 0 > p || L[b] !== X[p]) {
                  var W = `
` + L[b].replace(" at new ", " at ");
                  return i.displayName && W.includes("<anonymous>") && (W = W.replace("<anonymous>", i.displayName)), W;
                }
              while (1 <= b && 0 <= p);
            break;
          }
      }
    } finally {
      xl = !1, Error.prepareStackTrace = h;
    }
    return (h = i ? i.displayName || i.name : "") ? Fl(h) : "";
  }
  function Wa(i) {
    if (typeof i == "string") return Fl(i);
    if (typeof i == "function")
      return i.prototype && i.prototype.isReactComponent ? Qa(i, !0) : Qa(i, !1);
    if (typeof i == "object" && i !== null) {
      switch (i.$$typeof) {
        case H:
          return Qa(i.render, !1);
        case ce:
          return Qa(i.type, !1);
        case le:
          var u = i, h = u._payload;
          u = u._init;
          try {
            i = u(h);
          } catch {
            return Fl("Lazy");
          }
          return Wa(i);
      }
      if (typeof i.name == "string") {
        e: {
          h = i.name, u = i.env;
          var b = i.debugLocation;
          if (b != null && (i = Error.prepareStackTrace, Error.prepareStackTrace = void 0, b = b.stack, Error.prepareStackTrace = i, b.startsWith(`Error: react-stack-top-frame
`) && (b = b.slice(29)), i = b.indexOf(`
`), i !== -1 && (b = b.slice(i + 1)), i = b.indexOf("react_stack_bottom_frame"), i !== -1 && (i = b.lastIndexOf(`
`, i)), i = i !== -1 ? b = b.slice(0, i) : "", b = i.lastIndexOf(`
`), i = b === -1 ? i : i.slice(b + 1), i.indexOf(h) !== -1)) {
            h = `
` + i;
            break e;
          }
          h = Fl(
            h + (u ? " [" + u + "]" : "")
          );
        }
        return h;
      }
    }
    switch (i) {
      case Y:
        return Fl("SuspenseList");
      case Z:
        return Fl("Suspense");
    }
    return "";
  }
  function Kl(i, u) {
    return (500 < u.byteSize || hu(u.contentState)) && u.contentPreamble === null;
  }
  function Dr(i) {
    if (typeof i == "object" && i !== null && typeof i.environmentName == "string") {
      var u = i.environmentName;
      i = [i].slice(0), typeof i[0] == "string" ? i.splice(
        0,
        1,
        "%c%s%c " + i[0],
        "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px",
        " " + u + " ",
        ""
      ) : i.splice(
        0,
        0,
        "%c%s%c",
        "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px",
        " " + u + " ",
        ""
      ), i.unshift(console), u = hi.apply(console.error, i), u();
    } else console.error(i);
    return null;
  }
  function Ca(i, u, h, b, p, C, M, I, L, X, W) {
    var te = /* @__PURE__ */ new Set();
    this.destination = null, this.flushScheduled = !1, this.resumableState = i, this.renderState = u, this.rootFormatContext = h, this.progressiveChunkSize = b === void 0 ? 12800 : b, this.status = 10, this.fatalError = null, this.pendingRootTasks = this.allPendingTasks = this.nextSegmentId = 0, this.completedPreambleSegments = this.completedRootSegment = null, this.byteSize = 0, this.abortableTasks = te, this.pingedTasks = [], this.clientRenderedBoundaries = [], this.completedBoundaries = [], this.partialBoundaries = [], this.trackedPostpones = null, this.onError = p === void 0 ? Dr : p, this.onPostpone = X === void 0 ? ae : X, this.onAllReady = C === void 0 ? ae : C, this.onShellReady = M === void 0 ? ae : M, this.onShellError = I === void 0 ? ae : I, this.onFatalError = L === void 0 ? ae : L, this.formState = W === void 0 ? null : W;
  }
  function ba(i, u, h, b, p, C, M, I, L, X, W, te) {
    return u = new Ca(
      u,
      h,
      b,
      p,
      C,
      M,
      I,
      L,
      X,
      W,
      te
    ), h = Yl(
      u,
      0,
      null,
      b,
      !1,
      !1
    ), h.parentFlushed = !0, i = ol(
      u,
      null,
      i,
      -1,
      null,
      h,
      null,
      null,
      u.abortableTasks,
      null,
      b,
      null,
      N,
      null,
      null
    ), $l(i), u.pingedTasks.push(i), u;
  }
  function or(i, u, h, b, p, C, M, I, L, X, W) {
    return i = ba(
      i,
      u,
      h,
      b,
      p,
      C,
      M,
      I,
      L,
      X,
      W,
      void 0
    ), i.trackedPostpones = {
      workingMap: /* @__PURE__ */ new Map(),
      rootNodes: [],
      rootSlots: null
    }, i;
  }
  function jl(i, u, h, b, p, C, M, I, L) {
    return h = new Ca(
      u.resumableState,
      h,
      u.rootFormatContext,
      u.progressiveChunkSize,
      b,
      p,
      C,
      M,
      I,
      L,
      null
    ), h.nextSegmentId = u.nextSegmentId, typeof u.replaySlots == "number" ? (b = Yl(
      h,
      0,
      null,
      u.rootFormatContext,
      !1,
      !1
    ), b.parentFlushed = !0, i = ol(
      h,
      null,
      i,
      -1,
      null,
      b,
      null,
      null,
      h.abortableTasks,
      null,
      u.rootFormatContext,
      null,
      N,
      null,
      null
    ), $l(i), h.pingedTasks.push(i), h) : (i = kr(
      h,
      null,
      {
        nodes: u.replayNodes,
        slots: u.replaySlots,
        pendingTasks: 0
      },
      i,
      -1,
      null,
      null,
      h.abortableTasks,
      null,
      u.rootFormatContext,
      null,
      N,
      null,
      null
    ), $l(i), h.pingedTasks.push(i), h);
  }
  function vu(i, u, h, b, p, C, M, I, L) {
    return i = jl(
      i,
      u,
      h,
      b,
      p,
      C,
      M,
      I,
      L
    ), i.trackedPostpones = {
      workingMap: /* @__PURE__ */ new Map(),
      rootNodes: [],
      rootSlots: null
    }, i;
  }
  var Jt = null;
  function cl(i, u) {
    i.pingedTasks.push(u), i.pingedTasks.length === 1 && (i.flushScheduled = i.destination !== null, i.trackedPostpones !== null || i.status === 10 ? Ee(function() {
      return Tc(i);
    }) : Ht(function() {
      return Tc(i);
    }));
  }
  function ql(i, u, h, b, p) {
    return h = {
      status: 0,
      rootSegmentID: -1,
      parentFlushed: !1,
      pendingTasks: 0,
      row: u,
      completedSegments: [],
      byteSize: 0,
      fallbackAbortableTasks: h,
      errorDigest: null,
      contentState: fi(),
      fallbackState: fi(),
      contentPreamble: b,
      fallbackPreamble: p,
      trackedContentKeyPath: null,
      trackedFallbackNode: null
    }, u !== null && (u.pendingTasks++, b = u.boundaries, b !== null && (i.allPendingTasks++, h.pendingTasks++, b.push(h)), i = u.inheritedHoistables, i !== null && di(h.contentState, i)), h;
  }
  function ol(i, u, h, b, p, C, M, I, L, X, W, te, me, Te, Ve) {
    i.allPendingTasks++, p === null ? i.pendingRootTasks++ : p.pendingTasks++, Te !== null && Te.pendingTasks++;
    var Me = {
      replay: null,
      node: h,
      childIndex: b,
      ping: function() {
        return cl(i, Me);
      },
      blockedBoundary: p,
      blockedSegment: C,
      blockedPreamble: M,
      hoistableState: I,
      abortSet: L,
      keyPath: X,
      formatContext: W,
      context: te,
      treeContext: me,
      row: Te,
      componentStack: Ve,
      thenableState: u
    };
    return L.add(Me), Me;
  }
  function kr(i, u, h, b, p, C, M, I, L, X, W, te, me, Te) {
    i.allPendingTasks++, C === null ? i.pendingRootTasks++ : C.pendingTasks++, me !== null && me.pendingTasks++, h.pendingTasks++;
    var Ve = {
      replay: h,
      node: b,
      childIndex: p,
      ping: function() {
        return cl(i, Ve);
      },
      blockedBoundary: C,
      blockedSegment: null,
      blockedPreamble: null,
      hoistableState: M,
      abortSet: I,
      keyPath: L,
      formatContext: X,
      context: W,
      treeContext: te,
      row: me,
      componentStack: Te,
      thenableState: u
    };
    return I.add(Ve), Ve;
  }
  function Yl(i, u, h, b, p, C) {
    return {
      status: 0,
      parentFlushed: !1,
      id: -1,
      index: u,
      chunks: [],
      children: [],
      preambleChildren: [],
      parentFormatContext: b,
      boundary: h,
      lastPushedText: p,
      textEmbedded: C
    };
  }
  function $l(i) {
    var u = i.node;
    if (typeof u == "object" && u !== null)
      switch (u.$$typeof) {
        case v:
          i.componentStack = { parent: i.componentStack, type: u.type };
      }
  }
  function Pa(i) {
    return i === null ? null : { parent: i.parent, type: "Suspense Fallback" };
  }
  function Qn(i) {
    var u = {};
    return i && Object.defineProperty(u, "componentStack", {
      configurable: !0,
      enumerable: !0,
      get: function() {
        try {
          var h = "", b = i;
          do
            h += Wa(b.type), b = b.parent;
          while (b);
          var p = h;
        } catch (C) {
          p = `
Error generating stack: ` + C.message + `
` + C.stack;
        }
        return Object.defineProperty(u, "componentStack", {
          value: p
        }), p;
      }
    }), u;
  }
  function dt(i, u, h) {
    if (i = i.onError, u = i(u, h), u == null || typeof u == "string") return u;
  }
  function vi(i, u) {
    var h = i.onShellError, b = i.onFatalError;
    h(u), b(u), i.destination !== null ? (i.status = 14, qe(i.destination, u)) : (i.status = 13, i.fatalError = u);
  }
  function el(i, u) {
    go(i, u.next, u.hoistables);
  }
  function go(i, u, h) {
    for (; u !== null; ) {
      h !== null && (di(u.hoistables, h), u.inheritedHoistables = h);
      var b = u.boundaries;
      if (b !== null) {
        u.boundaries = null;
        for (var p = 0; p < b.length; p++) {
          var C = b[p];
          h !== null && di(C.contentState, h), Bn(i, C, null, null);
        }
      }
      if (u.pendingTasks--, 0 < u.pendingTasks) break;
      h = u.hoistables, u = u.next;
    }
  }
  function yu(i, u) {
    var h = u.boundaries;
    if (h !== null && u.pendingTasks === h.length) {
      for (var b = !0, p = 0; p < h.length; p++) {
        var C = h[p];
        if (C.pendingTasks !== 1 || C.parentFlushed || Kl(i, C)) {
          b = !1;
          break;
        }
      }
      b && go(i, u, u.hoistables);
    }
  }
  function bu(i) {
    var u = {
      pendingTasks: 1,
      boundaries: null,
      hoistables: fi(),
      inheritedHoistables: null,
      together: !1,
      next: null
    };
    return i !== null && 0 < i.pendingTasks && (u.pendingTasks++, u.boundaries = [], i.next = u), u;
  }
  function xn(i, u, h, b, p) {
    var C = u.keyPath, M = u.treeContext, I = u.row;
    u.keyPath = h, h = b.length;
    var L = null;
    if (u.replay !== null) {
      var X = u.replay.slots;
      if (X !== null && typeof X == "object")
        for (var W = 0; W < h; W++) {
          var te = p !== "backwards" && p !== "unstable_legacy-backwards" ? W : h - 1 - W, me = b[te];
          u.row = L = bu(
            L
          ), u.treeContext = D(M, h, te);
          var Te = X[te];
          typeof Te == "number" ? (Ja(i, u, Te, me, te), delete X[te]) : $t(i, u, me, te), --L.pendingTasks === 0 && el(i, L);
        }
      else
        for (X = 0; X < h; X++)
          W = p !== "backwards" && p !== "unstable_legacy-backwards" ? X : h - 1 - X, te = b[W], u.row = L = bu(L), u.treeContext = D(M, h, W), $t(i, u, te, W), --L.pendingTasks === 0 && el(i, L);
    } else if (p !== "backwards" && p !== "unstable_legacy-backwards")
      for (p = 0; p < h; p++)
        X = b[p], u.row = L = bu(L), u.treeContext = D(
          M,
          h,
          p
        ), $t(i, u, X, p), --L.pendingTasks === 0 && el(i, L);
    else {
      for (p = u.blockedSegment, X = p.children.length, W = p.chunks.length, te = h - 1; 0 <= te; te--) {
        me = b[te], u.row = L = bu(
          L
        ), u.treeContext = D(M, h, te), Te = Yl(
          i,
          W,
          null,
          u.formatContext,
          te === 0 ? p.lastPushedText : !0,
          !0
        ), p.children.splice(X, 0, Te), u.blockedSegment = Te;
        try {
          $t(i, u, me, te), Te.lastPushedText && Te.textEmbedded && Te.chunks.push(bn), Te.status = 1, El(i, u.blockedBoundary, Te), --L.pendingTasks === 0 && el(i, L);
        } catch (Ve) {
          throw Te.status = i.status === 12 ? 3 : 4, Ve;
        }
      }
      u.blockedSegment = p, p.lastPushedText = !1;
    }
    I !== null && L !== null && 0 < L.pendingTasks && (I.pendingTasks++, L.next = I), u.treeContext = M, u.row = I, u.keyPath = C;
  }
  function yc(i, u, h, b, p, C) {
    var M = u.thenableState;
    for (u.thenableState = null, je = {}, Vt = u, Mt = i, st = h, at = Tl = 0, pn = -1, sn = 0, Ct = M, i = b(p, C); We; )
      We = !1, at = Tl = 0, pn = -1, sn = 0, Ii += 1, tt = null, i = b(p, C);
    return $n(), i;
  }
  function ea(i, u, h, b, p, C, M) {
    var I = !1;
    if (C !== 0 && i.formState !== null) {
      var L = u.blockedSegment;
      if (L !== null) {
        I = !0, L = L.chunks;
        for (var X = 0; X < C; X++)
          X === M ? L.push(k) : L.push(ue);
      }
    }
    C = u.keyPath, u.keyPath = h, p ? (h = u.treeContext, u.treeContext = D(h, 1, 0), $t(i, u, b, -1), u.treeContext = h) : I ? $t(i, u, b, -1) : fn(i, u, b, -1), u.keyPath = C;
  }
  function Ra(i, u, h, b, p, C) {
    if (typeof b == "function")
      if (b.prototype && b.prototype.isReactComponent) {
        var M = p;
        if ("ref" in p) {
          M = {};
          for (var I in p)
            I !== "ref" && (M[I] = p[I]);
        }
        var L = b.defaultProps;
        if (L) {
          M === p && (M = be({}, M, p));
          for (var X in L)
            M[X] === void 0 && (M[X] = L[X]);
        }
        p = M, M = hc, L = b.contextType, typeof L == "object" && L !== null && (M = L._currentValue), M = new b(p, M);
        var W = M.state !== void 0 ? M.state : null;
        if (M.updater = x, M.props = p, M.state = W, L = { queue: [], replace: !1 }, M._reactInternals = L, C = b.contextType, M.context = typeof C == "object" && C !== null ? C._currentValue : hc, C = b.getDerivedStateFromProps, typeof C == "function" && (C = C(p, W), W = C == null ? W : be({}, W, C), M.state = W), typeof b.getDerivedStateFromProps != "function" && typeof M.getSnapshotBeforeUpdate != "function" && (typeof M.UNSAFE_componentWillMount == "function" || typeof M.componentWillMount == "function"))
          if (b = M.state, typeof M.componentWillMount == "function" && M.componentWillMount(), typeof M.UNSAFE_componentWillMount == "function" && M.UNSAFE_componentWillMount(), b !== M.state && x.enqueueReplaceState(
            M,
            M.state,
            null
          ), L.queue !== null && 0 < L.queue.length)
            if (b = L.queue, C = L.replace, L.queue = null, L.replace = !1, C && b.length === 1)
              M.state = b[0];
            else {
              for (L = C ? b[0] : M.state, W = !0, C = C ? 1 : 0; C < b.length; C++)
                X = b[C], X = typeof X == "function" ? X.call(M, L, p, void 0) : X, X != null && (W ? (W = !1, L = be({}, L, X)) : be(L, X));
              M.state = L;
            }
          else L.queue = null;
        if (b = M.render(), i.status === 12) throw null;
        p = u.keyPath, u.keyPath = h, fn(i, u, b, -1), u.keyPath = p;
      } else {
        if (b = yc(i, u, h, b, p, void 0), i.status === 12) throw null;
        ea(
          i,
          u,
          h,
          b,
          Tl !== 0,
          at,
          pn
        );
      }
    else if (typeof b == "string")
      if (M = u.blockedSegment, M === null)
        M = p.children, L = u.formatContext, W = u.keyPath, u.formatContext = Vl(L, b, p), u.keyPath = h, $t(i, u, M, -1), u.formatContext = L, u.keyPath = W;
      else {
        if (W = Wu(
          M.chunks,
          b,
          p,
          i.resumableState,
          i.renderState,
          u.blockedPreamble,
          u.hoistableState,
          u.formatContext,
          M.lastPushedText
        ), M.lastPushedText = !1, L = u.formatContext, C = u.keyPath, u.keyPath = h, (u.formatContext = Vl(L, b, p)).insertionMode === 3) {
          h = Yl(
            i,
            0,
            null,
            u.formatContext,
            !1,
            !1
          ), M.preambleChildren.push(h), u.blockedSegment = h;
          try {
            h.status = 6, $t(i, u, W, -1), h.lastPushedText && h.textEmbedded && h.chunks.push(bn), h.status = 1, El(i, u.blockedBoundary, h);
          } finally {
            u.blockedSegment = M;
          }
        } else $t(i, u, W, -1);
        u.formatContext = L, u.keyPath = C;
        e: {
          switch (u = M.chunks, i = i.resumableState, b) {
            case "title":
            case "style":
            case "script":
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
              break e;
            case "body":
              if (1 >= L.insertionMode) {
                i.hasBody = !0;
                break e;
              }
              break;
            case "html":
              if (L.insertionMode === 0) {
                i.hasHtml = !0;
                break e;
              }
              break;
            case "head":
              if (1 >= L.insertionMode) break e;
          }
          u.push(Ga(b));
        }
        M.lastPushedText = !1;
      }
    else {
      switch (b) {
        case ye:
        case w:
        case O:
        case T:
          b = u.keyPath, u.keyPath = h, fn(i, u, p.children, -1), u.keyPath = b;
          return;
        case he:
          b = u.blockedSegment, b === null ? p.mode !== "hidden" && (b = u.keyPath, u.keyPath = h, $t(i, u, p.children, -1), u.keyPath = b) : p.mode !== "hidden" && (b.chunks.push(ha), b.lastPushedText = !1, M = u.keyPath, u.keyPath = h, $t(i, u, p.children, -1), u.keyPath = M, b.chunks.push(Ju), b.lastPushedText = !1);
          return;
        case Y:
          e: {
            if (b = p.children, p = p.revealOrder, p === "forwards" || p === "backwards" || p === "unstable_legacy-backwards") {
              if (xe(b)) {
                xn(i, u, h, b, p);
                break e;
              }
              if ((M = pe(b)) && (M = M.call(b))) {
                if (L = M.next(), !L.done) {
                  do
                    L = M.next();
                  while (!L.done);
                  xn(i, u, h, b, p);
                }
                break e;
              }
            }
            p === "together" ? (p = u.keyPath, M = u.row, L = u.row = bu(null), L.boundaries = [], L.together = !0, u.keyPath = h, fn(i, u, b, -1), --L.pendingTasks === 0 && el(i, L), u.keyPath = p, u.row = M, M !== null && 0 < L.pendingTasks && (M.pendingTasks++, L.next = M)) : (p = u.keyPath, u.keyPath = h, fn(i, u, b, -1), u.keyPath = p);
          }
          return;
        case ze:
        case K:
          throw Error(f(343));
        case Z:
          e: if (u.replay !== null) {
            b = u.keyPath, M = u.formatContext, L = u.row, u.keyPath = h, u.formatContext = Fa(
              i.resumableState,
              M
            ), u.row = null, h = p.children;
            try {
              $t(i, u, h, -1);
            } finally {
              u.keyPath = b, u.formatContext = M, u.row = L;
            }
          } else {
            b = u.keyPath, C = u.formatContext;
            var te = u.row;
            X = u.blockedBoundary, I = u.blockedPreamble;
            var me = u.hoistableState, Te = u.blockedSegment, Ve = p.fallback;
            p = p.children;
            var Me = /* @__PURE__ */ new Set(), nt = 2 > u.formatContext.insertionMode ? ql(
              i,
              u.row,
              Me,
              wt(),
              wt()
            ) : ql(
              i,
              u.row,
              Me,
              null,
              null
            );
            i.trackedPostpones !== null && (nt.trackedContentKeyPath = h);
            var ht = Yl(
              i,
              Te.chunks.length,
              nt,
              u.formatContext,
              !1,
              !1
            );
            Te.children.push(ht), Te.lastPushedText = !1;
            var Ae = Yl(
              i,
              0,
              null,
              u.formatContext,
              !1,
              !1
            );
            if (Ae.parentFlushed = !0, i.trackedPostpones !== null) {
              M = u.componentStack, L = [h[0], "Suspense Fallback", h[2]], W = [L[1], L[2], [], null], i.trackedPostpones.workingMap.set(L, W), nt.trackedFallbackNode = W, u.blockedSegment = ht, u.blockedPreamble = nt.fallbackPreamble, u.keyPath = L, u.formatContext = Dl(
                i.resumableState,
                C
              ), u.componentStack = Pa(M), ht.status = 6;
              try {
                $t(i, u, Ve, -1), ht.lastPushedText && ht.textEmbedded && ht.chunks.push(bn), ht.status = 1, El(i, X, ht);
              } catch (Je) {
                throw ht.status = i.status === 12 ? 3 : 4, Je;
              } finally {
                u.blockedSegment = Te, u.blockedPreamble = I, u.keyPath = b, u.formatContext = C;
              }
              u = ol(
                i,
                null,
                p,
                -1,
                nt,
                Ae,
                nt.contentPreamble,
                nt.contentState,
                u.abortSet,
                h,
                Fa(
                  i.resumableState,
                  u.formatContext
                ),
                u.context,
                u.treeContext,
                null,
                M
              ), $l(u), i.pingedTasks.push(u);
            } else {
              u.blockedBoundary = nt, u.blockedPreamble = nt.contentPreamble, u.hoistableState = nt.contentState, u.blockedSegment = Ae, u.keyPath = h, u.formatContext = Fa(
                i.resumableState,
                C
              ), u.row = null, Ae.status = 6;
              try {
                if ($t(i, u, p, -1), Ae.lastPushedText && Ae.textEmbedded && Ae.chunks.push(bn), Ae.status = 1, El(i, nt, Ae), Hr(nt, Ae), nt.pendingTasks === 0 && nt.status === 0) {
                  if (nt.status = 1, !Kl(i, nt)) {
                    te !== null && --te.pendingTasks === 0 && el(i, te), i.pendingRootTasks === 0 && u.blockedPreamble && ta(i);
                    break e;
                  }
                } else
                  te !== null && te.together && yu(i, te);
              } catch (Je) {
                nt.status = 4, i.status === 12 ? (Ae.status = 3, M = i.fatalError) : (Ae.status = 4, M = Je), L = Qn(u.componentStack), W = dt(
                  i,
                  M,
                  L
                ), nt.errorDigest = W, mc(i, nt);
              } finally {
                u.blockedBoundary = X, u.blockedPreamble = I, u.hoistableState = me, u.blockedSegment = Te, u.keyPath = b, u.formatContext = C, u.row = te;
              }
              u = ol(
                i,
                null,
                Ve,
                -1,
                X,
                ht,
                nt.fallbackPreamble,
                nt.fallbackState,
                Me,
                [h[0], "Suspense Fallback", h[2]],
                Dl(
                  i.resumableState,
                  u.formatContext
                ),
                u.context,
                u.treeContext,
                u.row,
                Pa(
                  u.componentStack
                )
              ), $l(u), i.pingedTasks.push(u);
            }
          }
          return;
      }
      if (typeof b == "object" && b !== null)
        switch (b.$$typeof) {
          case H:
            if ("ref" in p)
              for (Te in M = {}, p)
                Te !== "ref" && (M[Te] = p[Te]);
            else M = p;
            b = yc(
              i,
              u,
              h,
              b.render,
              M,
              C
            ), ea(
              i,
              u,
              h,
              b,
              Tl !== 0,
              at,
              pn
            );
            return;
          case ce:
            Ra(i, u, h, b.type, p, C);
            return;
          case z:
            if (L = p.children, M = u.keyPath, p = p.value, W = b._currentValue, b._currentValue = p, C = Aa, Aa = b = {
              parent: C,
              depth: C === null ? 0 : C.depth + 1,
              context: b,
              parentValue: W,
              value: p
            }, u.context = b, u.keyPath = h, fn(i, u, L, -1), i = Aa, i === null) throw Error(f(403));
            i.context._currentValue = i.parentValue, i = Aa = i.parent, u.context = i, u.keyPath = M;
            return;
          case _:
            p = p.children, b = p(b._context._currentValue), p = u.keyPath, u.keyPath = h, fn(i, u, b, -1), u.keyPath = p;
            return;
          case le:
            if (M = b._init, b = M(b._payload), i.status === 12) throw null;
            Ra(i, u, h, b, p, C);
            return;
        }
      throw Error(
        f(130, b == null ? b : typeof b, "")
      );
    }
  }
  function Ja(i, u, h, b, p) {
    var C = u.replay, M = u.blockedBoundary, I = Yl(
      i,
      0,
      null,
      u.formatContext,
      !1,
      !1
    );
    I.id = h, I.parentFlushed = !0;
    try {
      u.replay = null, u.blockedSegment = I, $t(i, u, b, p), I.status = 1, El(i, M, I), M === null ? i.completedRootSegment = I : (Hr(M, I), M.parentFlushed && i.partialBoundaries.push(M));
    } finally {
      u.replay = C, u.blockedSegment = null;
    }
  }
  function fn(i, u, h, b) {
    u.replay !== null && typeof u.replay.slots == "number" ? Ja(i, u, u.replay.slots, h, b) : (u.node = h, u.childIndex = b, h = u.componentStack, $l(u), _a(i, u), u.componentStack = h);
  }
  function _a(i, u) {
    var h = u.node, b = u.childIndex;
    if (h !== null) {
      if (typeof h == "object") {
        switch (h.$$typeof) {
          case v:
            var p = h.type, C = h.key, M = h.props;
            h = M.ref;
            var I = h !== void 0 ? h : null, L = Gi(p), X = C ?? (b === -1 ? 0 : b);
            if (C = [u.keyPath, L, X], u.replay !== null)
              e: {
                var W = u.replay;
                for (b = W.nodes, h = 0; h < b.length; h++) {
                  var te = b[h];
                  if (X === te[1]) {
                    if (te.length === 4) {
                      if (L !== null && L !== te[0])
                        throw Error(
                          f(490, te[0], L)
                        );
                      var me = te[2];
                      L = te[3], X = u.node, u.replay = {
                        nodes: me,
                        slots: L,
                        pendingTasks: 1
                      };
                      try {
                        if (Ra(i, u, C, p, M, I), u.replay.pendingTasks === 1 && 0 < u.replay.nodes.length)
                          throw Error(f(488));
                        u.replay.pendingTasks--;
                      } catch (Ue) {
                        if (typeof Ue == "object" && Ue !== null && (Ue === ve || typeof Ue.then == "function"))
                          throw u.node === X ? u.replay = W : b.splice(h, 1), Ue;
                        u.replay.pendingTasks--, M = Qn(u.componentStack), C = i, i = u.blockedBoundary, p = Ue, M = dt(C, p, M), Na(
                          C,
                          i,
                          me,
                          L,
                          p,
                          M
                        );
                      }
                      u.replay = W;
                    } else {
                      if (p !== Z)
                        throw Error(
                          f(
                            490,
                            "Suspense",
                            Gi(p) || "Unknown"
                          )
                        );
                      t: {
                        W = void 0, p = te[5], I = te[2], L = te[3], X = te[4] === null ? [] : te[4][2], te = te[4] === null ? null : te[4][3];
                        var Te = u.keyPath, Ve = u.formatContext, Me = u.row, nt = u.replay, ht = u.blockedBoundary, Ae = u.hoistableState, Je = M.children, gt = M.fallback, Al = /* @__PURE__ */ new Set();
                        M = 2 > u.formatContext.insertionMode ? ql(
                          i,
                          u.row,
                          Al,
                          wt(),
                          wt()
                        ) : ql(
                          i,
                          u.row,
                          Al,
                          null,
                          null
                        ), M.parentFlushed = !0, M.rootSegmentID = p, u.blockedBoundary = M, u.hoistableState = M.contentState, u.keyPath = C, u.formatContext = Fa(
                          i.resumableState,
                          Ve
                        ), u.row = null, u.replay = {
                          nodes: I,
                          slots: L,
                          pendingTasks: 1
                        };
                        try {
                          if ($t(i, u, Je, -1), u.replay.pendingTasks === 1 && 0 < u.replay.nodes.length)
                            throw Error(f(488));
                          if (u.replay.pendingTasks--, M.pendingTasks === 0 && M.status === 0) {
                            M.status = 1, i.completedBoundaries.push(M);
                            break t;
                          }
                        } catch (Ue) {
                          M.status = 4, me = Qn(u.componentStack), W = dt(
                            i,
                            Ue,
                            me
                          ), M.errorDigest = W, u.replay.pendingTasks--, i.clientRenderedBoundaries.push(M);
                        } finally {
                          u.blockedBoundary = ht, u.hoistableState = Ae, u.replay = nt, u.keyPath = Te, u.formatContext = Ve, u.row = Me;
                        }
                        me = kr(
                          i,
                          null,
                          {
                            nodes: X,
                            slots: te,
                            pendingTasks: 0
                          },
                          gt,
                          -1,
                          ht,
                          M.fallbackState,
                          Al,
                          [C[0], "Suspense Fallback", C[2]],
                          Dl(
                            i.resumableState,
                            u.formatContext
                          ),
                          u.context,
                          u.treeContext,
                          u.row,
                          Pa(
                            u.componentStack
                          )
                        ), $l(me), i.pingedTasks.push(me);
                      }
                    }
                    b.splice(h, 1);
                    break e;
                  }
                }
              }
            else Ra(i, u, C, p, M, I);
            return;
          case y:
            throw Error(f(257));
          case le:
            if (me = h._init, h = me(h._payload), i.status === 12) throw null;
            fn(i, u, h, b);
            return;
        }
        if (xe(h)) {
          Lr(i, u, h, b);
          return;
        }
        if ((me = pe(h)) && (me = me.call(h))) {
          if (h = me.next(), !h.done) {
            M = [];
            do
              M.push(h.value), h = me.next();
            while (!h.done);
            Lr(i, u, M, b);
          }
          return;
        }
        if (typeof h.then == "function")
          return u.thenableState = null, fn(i, u, gc(h), b);
        if (h.$$typeof === z)
          return fn(
            i,
            u,
            h._currentValue,
            b
          );
        throw b = Object.prototype.toString.call(h), Error(
          f(
            31,
            b === "[object Object]" ? "object with keys {" + Object.keys(h).join(", ") + "}" : b
          )
        );
      }
      typeof h == "string" ? (b = u.blockedSegment, b !== null && (b.lastPushedText = Vu(
        b.chunks,
        h,
        i.renderState,
        b.lastPushedText
      ))) : (typeof h == "number" || typeof h == "bigint") && (b = u.blockedSegment, b !== null && (b.lastPushedText = Vu(
        b.chunks,
        "" + h,
        i.renderState,
        b.lastPushedText
      )));
    }
  }
  function Lr(i, u, h, b) {
    var p = u.keyPath;
    if (b !== -1 && (u.keyPath = [u.keyPath, "Fragment", b], u.replay !== null)) {
      for (var C = u.replay, M = C.nodes, I = 0; I < M.length; I++) {
        var L = M[I];
        if (L[1] === b) {
          b = L[2], L = L[3], u.replay = { nodes: b, slots: L, pendingTasks: 1 };
          try {
            if (Lr(i, u, h, -1), u.replay.pendingTasks === 1 && 0 < u.replay.nodes.length)
              throw Error(f(488));
            u.replay.pendingTasks--;
          } catch (te) {
            if (typeof te == "object" && te !== null && (te === ve || typeof te.then == "function"))
              throw te;
            u.replay.pendingTasks--, h = Qn(u.componentStack);
            var X = u.blockedBoundary, W = te;
            h = dt(i, W, h), Na(
              i,
              X,
              b,
              L,
              W,
              h
            );
          }
          u.replay = C, M.splice(I, 1);
          break;
        }
      }
      u.keyPath = p;
      return;
    }
    if (C = u.treeContext, M = h.length, u.replay !== null && (I = u.replay.slots, I !== null && typeof I == "object")) {
      for (b = 0; b < M; b++)
        L = h[b], u.treeContext = D(C, M, b), X = I[b], typeof X == "number" ? (Ja(i, u, X, L, b), delete I[b]) : $t(i, u, L, b);
      u.treeContext = C, u.keyPath = p;
      return;
    }
    for (I = 0; I < M; I++)
      b = h[I], u.treeContext = D(C, M, I), $t(i, u, b, I);
    u.treeContext = C, u.keyPath = p;
  }
  function mu(i, u, h) {
    if (h.status = 5, h.rootSegmentID = i.nextSegmentId++, i = h.trackedContentKeyPath, i === null) throw Error(f(486));
    var b = h.trackedFallbackNode, p = [], C = u.workingMap.get(i);
    return C === void 0 ? (h = [
      i[1],
      i[2],
      p,
      null,
      b,
      h.rootSegmentID
    ], u.workingMap.set(i, h), Ur(h, i[0], u), h) : (C[4] = b, C[5] = h.rootSegmentID, C);
  }
  function bc(i, u, h, b) {
    b.status = 5;
    var p = h.keyPath, C = h.blockedBoundary;
    if (C === null)
      b.id = i.nextSegmentId++, u.rootSlots = b.id, i.completedRootSegment !== null && (i.completedRootSegment.status = 5);
    else {
      if (C !== null && C.status === 0) {
        var M = mu(
          i,
          u,
          C
        );
        if (C.trackedContentKeyPath === p && h.childIndex === -1) {
          b.id === -1 && (b.id = b.parentFlushed ? C.rootSegmentID : i.nextSegmentId++), M[3] = b.id;
          return;
        }
      }
      if (b.id === -1 && (b.id = b.parentFlushed && C !== null ? C.rootSegmentID : i.nextSegmentId++), h.childIndex === -1)
        p === null ? u.rootSlots = b.id : (h = u.workingMap.get(p), h === void 0 ? (h = [p[1], p[2], [], b.id], Ur(h, p[0], u)) : h[3] = b.id);
      else {
        if (p === null) {
          if (i = u.rootSlots, i === null)
            i = u.rootSlots = {};
          else if (typeof i == "number")
            throw Error(f(491));
        } else if (C = u.workingMap, M = C.get(p), M === void 0)
          i = {}, M = [p[1], p[2], [], i], C.set(p, M), Ur(M, p[0], u);
        else if (i = M[3], i === null)
          i = M[3] = {};
        else if (typeof i == "number")
          throw Error(f(491));
        i[h.childIndex] = b.id;
      }
    }
  }
  function mc(i, u) {
    i = i.trackedPostpones, i !== null && (u = u.trackedContentKeyPath, u !== null && (u = i.workingMap.get(u), u !== void 0 && (u.length = 4, u[2] = [], u[3] = null)));
  }
  function Ka(i, u, h) {
    return kr(
      i,
      h,
      u.replay,
      u.node,
      u.childIndex,
      u.blockedBoundary,
      u.hoistableState,
      u.abortSet,
      u.keyPath,
      u.formatContext,
      u.context,
      u.treeContext,
      u.row,
      u.componentStack
    );
  }
  function Tu(i, u, h) {
    var b = u.blockedSegment, p = Yl(
      i,
      b.chunks.length,
      null,
      u.formatContext,
      b.lastPushedText,
      !0
    );
    return b.children.push(p), b.lastPushedText = !1, ol(
      i,
      h,
      u.node,
      u.childIndex,
      u.blockedBoundary,
      p,
      u.blockedPreamble,
      u.hoistableState,
      u.abortSet,
      u.keyPath,
      u.formatContext,
      u.context,
      u.treeContext,
      u.row,
      u.componentStack
    );
  }
  function $t(i, u, h, b) {
    var p = u.formatContext, C = u.context, M = u.keyPath, I = u.treeContext, L = u.componentStack, X = u.blockedSegment;
    if (X === null) {
      X = u.replay;
      try {
        return fn(i, u, h, b);
      } catch (me) {
        if ($n(), h = me === ve ? Ze() : me, i.status !== 12 && typeof h == "object" && h !== null) {
          if (typeof h.then == "function") {
            b = me === ve ? Sn() : null, i = Ka(i, u, b).ping, h.then(i, i), u.formatContext = p, u.context = C, u.keyPath = M, u.treeContext = I, u.componentStack = L, u.replay = X, m(C);
            return;
          }
          if (h.message === "Maximum call stack size exceeded") {
            h = me === ve ? Sn() : null, h = Ka(i, u, h), i.pingedTasks.push(h), u.formatContext = p, u.context = C, u.keyPath = M, u.treeContext = I, u.componentStack = L, u.replay = X, m(C);
            return;
          }
        }
      }
    } else {
      var W = X.children.length, te = X.chunks.length;
      try {
        return fn(i, u, h, b);
      } catch (me) {
        if ($n(), X.children.length = W, X.chunks.length = te, h = me === ve ? Ze() : me, i.status !== 12 && typeof h == "object" && h !== null) {
          if (typeof h.then == "function") {
            X = h, h = me === ve ? Sn() : null, i = Tu(i, u, h).ping, X.then(i, i), u.formatContext = p, u.context = C, u.keyPath = M, u.treeContext = I, u.componentStack = L, m(C);
            return;
          }
          if (h.message === "Maximum call stack size exceeded") {
            X = me === ve ? Sn() : null, X = Tu(i, u, X), i.pingedTasks.push(X), u.formatContext = p, u.context = C, u.keyPath = M, u.treeContext = I, u.componentStack = L, m(C);
            return;
          }
        }
      }
    }
    throw u.formatContext = p, u.context = C, u.keyPath = M, u.treeContext = I, m(C), h;
  }
  function pu(i) {
    var u = i.blockedBoundary, h = i.blockedSegment;
    h !== null && (h.status = 3, Bn(this, u, i.row, h));
  }
  function Na(i, u, h, b, p, C) {
    for (var M = 0; M < h.length; M++) {
      var I = h[M];
      if (I.length === 4)
        Na(
          i,
          u,
          I[2],
          I[3],
          p,
          C
        );
      else {
        I = I[5];
        var L = i, X = C, W = ql(
          L,
          null,
          /* @__PURE__ */ new Set(),
          null,
          null
        );
        W.parentFlushed = !0, W.rootSegmentID = I, W.status = 4, W.errorDigest = X, W.parentFlushed && L.clientRenderedBoundaries.push(W);
      }
    }
    if (h.length = 0, b !== null) {
      if (u === null) throw Error(f(487));
      if (u.status !== 4 && (u.status = 4, u.errorDigest = C, u.parentFlushed && i.clientRenderedBoundaries.push(u)), typeof b == "object") for (var te in b) delete b[te];
    }
  }
  function Zi(i, u, h) {
    var b = i.blockedBoundary, p = i.blockedSegment;
    if (p !== null) {
      if (p.status === 6) return;
      p.status = 3;
    }
    var C = Qn(i.componentStack);
    if (b === null) {
      if (u.status !== 13 && u.status !== 14) {
        if (b = i.replay, b === null) {
          u.trackedPostpones !== null && p !== null ? (b = u.trackedPostpones, dt(u, h, C), bc(u, b, i, p), Bn(u, null, i.row, p)) : (dt(u, h, C), vi(u, h));
          return;
        }
        b.pendingTasks--, b.pendingTasks === 0 && 0 < b.nodes.length && (p = dt(u, h, C), Na(
          u,
          null,
          b.nodes,
          b.slots,
          h,
          p
        )), u.pendingRootTasks--, u.pendingRootTasks === 0 && sr(u);
      }
    } else {
      var M = u.trackedPostpones;
      if (b.status !== 4) {
        if (M !== null && p !== null)
          return dt(u, h, C), bc(u, M, i, p), b.fallbackAbortableTasks.forEach(function(I) {
            return Zi(I, u, h);
          }), b.fallbackAbortableTasks.clear(), Bn(u, b, i.row, p);
        b.status = 4, p = dt(u, h, C), b.status = 4, b.errorDigest = p, mc(u, b), b.parentFlushed && u.clientRenderedBoundaries.push(b);
      }
      b.pendingTasks--, p = b.row, p !== null && --p.pendingTasks === 0 && el(u, p), b.fallbackAbortableTasks.forEach(function(I) {
        return Zi(I, u, h);
      }), b.fallbackAbortableTasks.clear();
    }
    i = i.row, i !== null && --i.pendingTasks === 0 && el(u, i), u.allPendingTasks--, u.allPendingTasks === 0 && Br(u);
  }
  function Vi(i, u) {
    try {
      var h = i.renderState, b = h.onHeaders;
      if (b) {
        var p = h.headers;
        if (p) {
          h.headers = null;
          var C = p.preconnects;
          if (p.fontPreloads && (C && (C += ", "), C += p.fontPreloads), p.highImagePreloads && (C && (C += ", "), C += p.highImagePreloads), !u) {
            var M = h.styles.values(), I = M.next();
            e: for (; 0 < p.remainingCapacity && !I.done; I = M.next())
              for (var L = I.value.sheets.values(), X = L.next(); 0 < p.remainingCapacity && !X.done; X = L.next()) {
                var W = X.value, te = W.props, me = te.href, Te = W.props, Ve = du(Te.href, "style", {
                  crossOrigin: Te.crossOrigin,
                  integrity: Te.integrity,
                  nonce: Te.nonce,
                  type: Te.type,
                  fetchPriority: Te.fetchPriority,
                  referrerPolicy: Te.referrerPolicy,
                  media: Te.media
                });
                if (0 <= (p.remainingCapacity -= Ve.length + 2))
                  h.resets.style[me] = Cn, C && (C += ", "), C += Ve, h.resets.style[me] = typeof te.crossOrigin == "string" || typeof te.integrity == "string" ? [te.crossOrigin, te.integrity] : Cn;
                else break e;
              }
          }
          b(C ? { Link: C } : {});
        }
      }
    } catch (Me) {
      dt(i, Me, {});
    }
  }
  function sr(i) {
    i.trackedPostpones === null && Vi(i, !0), i.trackedPostpones === null && ta(i), i.onShellError = ae, i = i.onShellReady, i();
  }
  function Br(i) {
    Vi(
      i,
      i.trackedPostpones === null ? !0 : i.completedRootSegment === null || i.completedRootSegment.status !== 5
    ), ta(i), i = i.onAllReady, i();
  }
  function Hr(i, u) {
    if (u.chunks.length === 0 && u.children.length === 1 && u.children[0].boundary === null && u.children[0].id === -1) {
      var h = u.children[0];
      h.id = u.id, h.parentFlushed = !0, h.status !== 1 && h.status !== 3 && h.status !== 4 || Hr(i, h);
    } else i.completedSegments.push(u);
  }
  function El(i, u, h) {
    if (ut !== null) {
      h = h.chunks;
      for (var b = 0, p = 0; p < h.length; p++)
        b += h[p].byteLength;
      u === null ? i.byteSize += b : u.byteSize += b;
    }
  }
  function Bn(i, u, h, b) {
    if (h !== null && (--h.pendingTasks === 0 ? el(i, h) : h.together && yu(i, h)), i.allPendingTasks--, u === null) {
      if (b !== null && b.parentFlushed) {
        if (i.completedRootSegment !== null)
          throw Error(f(389));
        i.completedRootSegment = b;
      }
      i.pendingRootTasks--, i.pendingRootTasks === 0 && sr(i);
    } else if (u.pendingTasks--, u.status !== 4)
      if (u.pendingTasks === 0) {
        if (u.status === 0 && (u.status = 1), b !== null && b.parentFlushed && (b.status === 1 || b.status === 3) && Hr(u, b), u.parentFlushed && i.completedBoundaries.push(u), u.status === 1)
          h = u.row, h !== null && di(h.hoistables, u.contentState), Kl(i, u) || (u.fallbackAbortableTasks.forEach(pu, i), u.fallbackAbortableTasks.clear(), h !== null && --h.pendingTasks === 0 && el(i, h)), i.pendingRootTasks === 0 && i.trackedPostpones === null && u.contentPreamble !== null && ta(i);
        else if (u.status === 5 && (u = u.row, u !== null)) {
          if (i.trackedPostpones !== null) {
            h = i.trackedPostpones;
            var p = u.next;
            if (p !== null && (b = p.boundaries, b !== null))
              for (p.boundaries = null, p = 0; p < b.length; p++) {
                var C = b[p];
                mu(i, h, C), Bn(i, C, null, null);
              }
          }
          --u.pendingTasks === 0 && el(i, u);
        }
      } else
        b === null || !b.parentFlushed || b.status !== 1 && b.status !== 3 || (Hr(u, b), u.completedSegments.length === 1 && u.parentFlushed && i.partialBoundaries.push(u)), u = u.row, u !== null && u.together && yu(i, u);
    i.allPendingTasks === 0 && Br(i);
  }
  function Tc(i) {
    if (i.status !== 14 && i.status !== 13) {
      var u = Aa, h = nl.H;
      nl.H = gu;
      var b = nl.A;
      nl.A = Vn;
      var p = Jt;
      Jt = i;
      var C = zr;
      zr = i.resumableState;
      try {
        var M = i.pingedTasks, I;
        for (I = 0; I < M.length; I++) {
          var L = M[I], X = i, W = L.blockedSegment;
          if (W === null) {
            var te = X;
            if (L.replay.pendingTasks !== 0) {
              m(L.context);
              try {
                if (typeof L.replay.slots == "number" ? Ja(
                  te,
                  L,
                  L.replay.slots,
                  L.node,
                  L.childIndex
                ) : _a(te, L), L.replay.pendingTasks === 1 && 0 < L.replay.nodes.length)
                  throw Error(f(488));
                L.replay.pendingTasks--, L.abortSet.delete(L), Bn(
                  te,
                  L.blockedBoundary,
                  L.row,
                  null
                );
              } catch (Un) {
                $n();
                var me = Un === ve ? Ze() : Un;
                if (typeof me == "object" && me !== null && typeof me.then == "function") {
                  var Te = L.ping;
                  me.then(Te, Te), L.thenableState = Un === ve ? Sn() : null;
                } else {
                  L.replay.pendingTasks--, L.abortSet.delete(L);
                  var Ve = Qn(L.componentStack);
                  X = void 0;
                  var Me = te, nt = L.blockedBoundary, ht = te.status === 12 ? te.fatalError : me, Ae = L.replay.nodes, Je = L.replay.slots;
                  X = dt(
                    Me,
                    ht,
                    Ve
                  ), Na(
                    Me,
                    nt,
                    Ae,
                    Je,
                    ht,
                    X
                  ), te.pendingRootTasks--, te.pendingRootTasks === 0 && sr(te), te.allPendingTasks--, te.allPendingTasks === 0 && Br(te);
                }
              } finally {
              }
            }
          } else if (te = void 0, Me = W, Me.status === 0) {
            Me.status = 6, m(L.context);
            var gt = Me.children.length, Al = Me.chunks.length;
            try {
              _a(X, L), Me.lastPushedText && Me.textEmbedded && Me.chunks.push(bn), L.abortSet.delete(L), Me.status = 1, El(X, L.blockedBoundary, Me), Bn(
                X,
                L.blockedBoundary,
                L.row,
                Me
              );
            } catch (Un) {
              $n(), Me.children.length = gt, Me.chunks.length = Al;
              var Ue = Un === ve ? Ze() : X.status === 12 ? X.fatalError : Un;
              if (X.status === 12 && X.trackedPostpones !== null) {
                var dn = X.trackedPostpones, Kt = Qn(L.componentStack);
                L.abortSet.delete(L), dt(X, Ue, Kt), bc(X, dn, L, Me), Bn(
                  X,
                  L.blockedBoundary,
                  L.row,
                  Me
                );
              } else if (typeof Ue == "object" && Ue !== null && typeof Ue.then == "function") {
                Me.status = 0, L.thenableState = Un === ve ? Sn() : null;
                var Hn = L.ping;
                Ue.then(Hn, Hn);
              } else {
                var Gl = Qn(L.componentStack);
                L.abortSet.delete(L), Me.status = 4;
                var hn = L.blockedBoundary, zt = L.row;
                if (zt !== null && --zt.pendingTasks === 0 && el(X, zt), X.allPendingTasks--, te = dt(
                  X,
                  Ue,
                  Gl
                ), hn === null) vi(X, Ue);
                else if (hn.pendingTasks--, hn.status !== 4) {
                  hn.status = 4, hn.errorDigest = te, mc(X, hn);
                  var ma = hn.row;
                  ma !== null && --ma.pendingTasks === 0 && el(X, ma), hn.parentFlushed && X.clientRenderedBoundaries.push(hn), X.pendingRootTasks === 0 && X.trackedPostpones === null && hn.contentPreamble !== null && ta(X);
                }
                X.allPendingTasks === 0 && Br(X);
              }
            } finally {
            }
          }
        }
        M.splice(0, I), i.destination !== null && fr(i, i.destination);
      } catch (Un) {
        dt(i, Un, {}), vi(i, Un);
      } finally {
        zr = C, nl.H = h, nl.A = b, h === gu && m(u), Jt = p;
      }
    }
  }
  function yi(i, u, h) {
    u.preambleChildren.length && h.push(u.preambleChildren);
    for (var b = !1, p = 0; p < u.children.length; p++)
      b = Qi(
        i,
        u.children[p],
        h
      ) || b;
    return b;
  }
  function Qi(i, u, h) {
    var b = u.boundary;
    if (b === null)
      return yi(
        i,
        u,
        h
      );
    var p = b.contentPreamble, C = b.fallbackPreamble;
    if (p === null || C === null) return !1;
    switch (b.status) {
      case 1:
        if (Pu(i.renderState, p), i.byteSize += b.byteSize, u = b.completedSegments[0], !u) throw Error(f(391));
        return yi(
          i,
          u,
          h
        );
      case 5:
        if (i.trackedPostpones !== null) return !0;
      case 4:
        if (u.status === 1)
          return Pu(i.renderState, C), yi(
            i,
            u,
            h
          );
      default:
        return !0;
    }
  }
  function ta(i) {
    if (i.completedRootSegment && i.completedPreambleSegments === null) {
      var u = [], h = i.byteSize, b = Qi(
        i,
        i.completedRootSegment,
        u
      ), p = i.renderState.preamble;
      b === !1 || p.headChunks && p.bodyChunks ? i.completedPreambleSegments = u : i.byteSize = h;
    }
  }
  function ja(i, u, h, b) {
    switch (h.parentFlushed = !0, h.status) {
      case 0:
        h.id = i.nextSegmentId++;
      case 5:
        return b = h.id, h.lastPushedText = !1, h.textEmbedded = !1, i = i.renderState, U(u, to), U(u, i.placeholderPrefix), i = re(b.toString(16)), U(u, i), Q(u, Fo);
      case 1:
        h.status = 2;
        var p = !0, C = h.chunks, M = 0;
        h = h.children;
        for (var I = 0; I < h.length; I++) {
          for (p = h[I]; M < p.index; M++)
            U(u, C[M]);
          p = bi(i, u, p, b);
        }
        for (; M < C.length - 1; M++)
          U(u, C[M]);
        return M < C.length && (p = Q(u, C[M])), p;
      case 3:
        return !0;
      default:
        throw Error(f(390));
    }
  }
  var na = 0;
  function bi(i, u, h, b) {
    var p = h.boundary;
    if (p === null)
      return ja(i, u, h, b);
    if (p.parentFlushed = !0, p.status === 4) {
      var C = p.row;
      C !== null && --C.pendingTasks === 0 && el(i, C), p = p.errorDigest, Q(u, ml), U(u, Ku), p && (U(u, wr), U(u, re(Ye(p))), U(
        u,
        ga
      )), Q(u, lo), ja(i, u, h, b);
    } else if (p.status !== 1)
      p.status === 0 && (p.rootSegmentID = i.nextSegmentId++), 0 < p.completedSegments.length && i.partialBoundaries.push(p), lr(
        u,
        i.renderState,
        p.rootSegmentID
      ), b && di(b, p.fallbackState), ja(i, u, h, b);
    else if (!sl && Kl(i, p) && (na + p.byteSize > i.progressiveChunkSize || hu(p.contentState)))
      p.rootSegmentID = i.nextSegmentId++, i.completedBoundaries.push(p), lr(
        u,
        i.renderState,
        p.rootSegmentID
      ), ja(i, u, h, b);
    else {
      if (na += p.byteSize, b && di(b, p.contentState), h = p.row, h !== null && Kl(i, p) && --h.pendingTasks === 0 && el(i, h), Q(u, Yo), h = p.completedSegments, h.length !== 1) throw Error(f(391));
      bi(i, u, h[0], b);
    }
    return Q(u, Jl);
  }
  function qa(i, u, h, b) {
    return ec(
      u,
      i.renderState,
      h.parentFormatContext,
      h.id
    ), bi(i, u, h, b), Or(u, h.parentFormatContext);
  }
  function mi(i, u, h) {
    na = h.byteSize;
    for (var b = h.completedSegments, p = 0; p < b.length; p++)
      pc(
        i,
        u,
        h,
        b[p]
      );
    b.length = 0, b = h.row, b !== null && Kl(i, h) && --b.pendingTasks === 0 && el(i, b), Li(
      u,
      h.contentState,
      i.renderState
    ), b = i.resumableState, i = i.renderState, p = h.rootSegmentID, h = h.contentState;
    var C = i.stylesToHoist;
    return i.stylesToHoist = !1, U(u, i.startInlineScript), U(u, _t), C ? ((b.instructions & 4) === 0 && (b.instructions |= 4, U(u, Cr)), (b.instructions & 2) === 0 && (b.instructions |= 2, U(u, ao)), (b.instructions & 8) === 0 ? (b.instructions |= 8, U(u, Xs)) : U(u, Io)) : ((b.instructions & 2) === 0 && (b.instructions |= 2, U(u, ao)), U(u, nc)), b = re(p.toString(16)), U(u, i.boundaryPrefix), U(u, b), U(u, lc), U(u, i.segmentPrefix), U(u, b), C ? (U(u, Is), Dn(u, h)) : U(u, io), h = Q(u, ro), nu(u, i) && h;
  }
  function pc(i, u, h, b) {
    if (b.status === 2) return !0;
    var p = h.contentState, C = b.id;
    if (C === -1) {
      if ((b.id = h.rootSegmentID) === -1)
        throw Error(f(392));
      return qa(i, u, b, p);
    }
    return C === h.rootSegmentID ? qa(i, u, b, p) : (qa(i, u, b, p), h = i.resumableState, i = i.renderState, U(u, i.startInlineScript), U(u, _t), (h.instructions & 1) === 0 ? (h.instructions |= 1, U(u, tc)) : U(u, Xo), U(u, i.segmentPrefix), C = re(C.toString(16)), U(u, C), U(u, Ys), U(u, i.placeholderPrefix), U(u, C), u = Q(u, Gs), u);
  }
  var sl = !1;
  function fr(i, u) {
    Ne = new Uint8Array(2048), lt = 0;
    try {
      if (!(0 < i.pendingRootTasks)) {
        var h, b = i.completedRootSegment;
        if (b !== null) {
          if (b.status === 5) return;
          var p = i.completedPreambleSegments;
          if (p === null) return;
          na = i.byteSize;
          var C = i.resumableState, M = i.renderState, I = M.preamble, L = I.htmlChunks, X = I.headChunks, W;
          if (L) {
            for (W = 0; W < L.length; W++)
              U(u, L[W]);
            if (X)
              for (W = 0; W < X.length; W++)
                U(u, X[W]);
            else
              U(u, Tn("head")), U(u, _t);
          } else if (X)
            for (W = 0; W < X.length; W++)
              U(u, X[W]);
          var te = M.charsetChunks;
          for (W = 0; W < te.length; W++)
            U(u, te[W]);
          te.length = 0, M.preconnects.forEach(Ot, u), M.preconnects.clear();
          var me = M.viewportChunks;
          for (W = 0; W < me.length; W++)
            U(u, me[W]);
          me.length = 0, M.fontPreloads.forEach(Ot, u), M.fontPreloads.clear(), M.highImagePreloads.forEach(Ot, u), M.highImagePreloads.clear(), ca = M, M.styles.forEach(cc, u), ca = null;
          var Te = M.importMapChunks;
          for (W = 0; W < Te.length; W++)
            U(u, Te[W]);
          Te.length = 0, M.bootstrapScripts.forEach(Ot, u), M.scripts.forEach(Ot, u), M.scripts.clear(), M.bulkPreloads.forEach(Ot, u), M.bulkPreloads.clear(), L || X || (C.instructions |= 32);
          var Ve = M.hoistableChunks;
          for (W = 0; W < Ve.length; W++)
            U(u, Ve[W]);
          for (C = Ve.length = 0; C < p.length; C++) {
            var Me = p[C];
            for (M = 0; M < Me.length; M++)
              bi(i, u, Me[M], null);
          }
          var nt = i.renderState.preamble, ht = nt.headChunks;
          (nt.htmlChunks || ht) && U(u, Ga("head"));
          var Ae = nt.bodyChunks;
          if (Ae)
            for (p = 0; p < Ae.length; p++)
              U(u, Ae[p]);
          bi(i, u, b, null), i.completedRootSegment = null;
          var Je = i.renderState;
          if (i.allPendingTasks !== 0 || i.clientRenderedBoundaries.length !== 0 || i.completedBoundaries.length !== 0 || i.trackedPostpones !== null && (i.trackedPostpones.rootNodes.length !== 0 || i.trackedPostpones.rootSlots !== null)) {
            var gt = i.resumableState;
            if ((gt.instructions & 64) === 0) {
              if (gt.instructions |= 64, U(u, Je.startInlineScript), (gt.instructions & 32) === 0) {
                gt.instructions |= 32;
                var Al = "_" + gt.idPrefix + "R_";
                U(u, cu), U(
                  u,
                  re(Ye(Al))
                ), U(u, kt);
              }
              U(u, _t), U(u, Pl), Q(u, Ge);
            }
          }
          nu(u, Je);
        }
        var Ue = i.renderState;
        b = 0;
        var dn = Ue.viewportChunks;
        for (b = 0; b < dn.length; b++)
          U(u, dn[b]);
        dn.length = 0, Ue.preconnects.forEach(Ot, u), Ue.preconnects.clear(), Ue.fontPreloads.forEach(Ot, u), Ue.fontPreloads.clear(), Ue.highImagePreloads.forEach(
          Ot,
          u
        ), Ue.highImagePreloads.clear(), Ue.styles.forEach(fo, u), Ue.scripts.forEach(Ot, u), Ue.scripts.clear(), Ue.bulkPreloads.forEach(Ot, u), Ue.bulkPreloads.clear();
        var Kt = Ue.hoistableChunks;
        for (b = 0; b < Kt.length; b++)
          U(u, Kt[b]);
        Kt.length = 0;
        var Hn = i.clientRenderedBoundaries;
        for (h = 0; h < Hn.length; h++) {
          var Gl = Hn[h];
          Ue = u;
          var hn = i.resumableState, zt = i.renderState, ma = Gl.rootSegmentID, Un = Gl.errorDigest;
          U(
            Ue,
            zt.startInlineScript
          ), U(Ue, _t), (hn.instructions & 4) === 0 ? (hn.instructions |= 4, U(Ue, uo)) : U(Ue, ac), U(Ue, zt.boundaryPrefix), U(Ue, re(ma.toString(16))), U(Ue, Zo), Un && (U(
            Ue,
            zi
          ), U(
            Ue,
            re(
              Qs(Un || "")
            )
          ));
          var la = Q(
            Ue,
            Zs
          );
          if (!la) {
            i.destination = null, h++, Hn.splice(0, h);
            return;
          }
        }
        Hn.splice(0, h);
        var Fr = i.completedBoundaries;
        for (h = 0; h < Fr.length; h++)
          if (!mi(i, u, Fr[h])) {
            i.destination = null, h++, Fr.splice(0, h);
            return;
          }
        Fr.splice(0, h), Se(u), Ne = new Uint8Array(2048), lt = 0, sl = !0;
        var xu = i.partialBoundaries;
        for (h = 0; h < xu.length; h++) {
          var pi = xu[h];
          e: {
            Hn = i, Gl = u, na = pi.byteSize;
            var dr = pi.completedSegments;
            for (la = 0; la < dr.length; la++)
              if (!pc(
                Hn,
                Gl,
                pi,
                dr[la]
              )) {
                la++, dr.splice(0, la);
                var Eu = !1;
                break e;
              }
            dr.splice(0, la);
            var gn = pi.row;
            gn !== null && gn.together && pi.pendingTasks === 1 && (gn.pendingTasks === 1 ? go(
              Hn,
              gn,
              gn.hoistables
            ) : gn.pendingTasks--), Eu = Li(
              Gl,
              pi.contentState,
              Hn.renderState
            );
          }
          if (!Eu) {
            i.destination = null, h++, xu.splice(0, h);
            return;
          }
        }
        xu.splice(0, h), sl = !1;
        var Qt = i.completedBoundaries;
        for (h = 0; h < Qt.length; h++)
          if (!mi(i, u, Qt[h])) {
            i.destination = null, h++, Qt.splice(0, h);
            return;
          }
        Qt.splice(0, h);
      }
    } finally {
      sl = !1, i.allPendingTasks === 0 && i.clientRenderedBoundaries.length === 0 && i.completedBoundaries.length === 0 ? (i.flushScheduled = !1, h = i.resumableState, h.hasBody && U(u, Ga("body")), h.hasHtml && U(u, Ga("html")), Se(u), i.status = 14, u.close(), i.destination = null) : Se(u);
    }
  }
  function Ti(i) {
    i.flushScheduled = i.destination !== null, Ee(function() {
      return Tc(i);
    }), Ht(function() {
      i.status === 10 && (i.status = 11), i.trackedPostpones === null && Vi(i, i.pendingRootTasks === 0);
    });
  }
  function fl(i) {
    i.flushScheduled === !1 && i.pingedTasks.length === 0 && i.destination !== null && (i.flushScheduled = !0, Ht(function() {
      var u = i.destination;
      u ? fr(i, u) : i.flushScheduled = !1;
    }));
  }
  function wl(i, u) {
    if (i.status === 13)
      i.status = 14, qe(u, i.fatalError);
    else if (i.status !== 14 && i.destination === null) {
      i.destination = u;
      try {
        fr(i, u);
      } catch (h) {
        dt(i, h, {}), vi(i, h);
      }
    }
  }
  function dl(i, u) {
    (i.status === 11 || i.status === 10) && (i.status = 12);
    try {
      var h = i.abortableTasks;
      if (0 < h.size) {
        var b = u === void 0 ? Error(f(432)) : typeof u == "object" && u !== null && typeof u.then == "function" ? Error(f(530)) : u;
        i.fatalError = b, h.forEach(function(p) {
          return Zi(p, i, b);
        }), h.clear();
      }
      i.destination !== null && fr(i, i.destination);
    } catch (p) {
      dt(i, p, {}), vi(i, p);
    }
  }
  function Ur(i, u, h) {
    if (u === null) h.rootNodes.push(i);
    else {
      var b = h.workingMap, p = b.get(u);
      p === void 0 && (p = [u[1], u[2], [], null], b.set(u, p), Ur(p, u[0], h)), p[2].push(i);
    }
  }
  function Su(i) {
    var u = i.trackedPostpones;
    if (u === null || u.rootNodes.length === 0 && u.rootSlots === null)
      return i.trackedPostpones = null;
    if (i.completedRootSegment === null || i.completedRootSegment.status !== 5 && i.completedPreambleSegments !== null) {
      var h = i.nextSegmentId, b = u.rootSlots, p = i.resumableState;
      p.bootstrapScriptContent = void 0, p.bootstrapScripts = void 0, p.bootstrapModules = void 0;
    } else {
      h = 0, b = -1, p = i.resumableState;
      var C = i.renderState;
      p.nextFormID = 0, p.hasBody = !1, p.hasHtml = !1, p.unknownResources = { font: C.resets.font }, p.dnsResources = C.resets.dns, p.connectResources = C.resets.connect, p.imageResources = C.resets.image, p.styleResources = C.resets.style, p.scriptResources = {}, p.moduleUnknownResources = {}, p.moduleScriptResources = {}, p.instructions = 0;
    }
    return {
      nextSegmentId: h,
      rootFormatContext: i.rootFormatContext,
      progressiveChunkSize: i.progressiveChunkSize,
      resumableState: i.resumableState,
      replayNodes: u.rootNodes,
      replaySlots: b
    };
  }
  function $a() {
    var i = a.version;
    if (i !== "19.2.6")
      throw Error(
        f(
          527,
          i,
          "19.2.6"
        )
      );
  }
  return $a(), $a(), Co.prerender = function(i, u) {
    return new Promise(function(h, b) {
      var p = u ? u.onHeaders : void 0, C;
      p && (C = function(W) {
        p(new Headers(W));
      });
      var M = zl(
        u ? u.identifierPrefix : void 0,
        u ? u.unstable_externalRuntimeSrc : void 0,
        u ? u.bootstrapScriptContent : void 0,
        u ? u.bootstrapScripts : void 0,
        u ? u.bootstrapModules : void 0
      ), I = or(
        i,
        M,
        vn(
          M,
          void 0,
          u ? u.unstable_externalRuntimeSrc : void 0,
          u ? u.importMap : void 0,
          C,
          u ? u.maxHeadersLength : void 0
        ),
        Ha(u ? u.namespaceURI : void 0),
        u ? u.progressiveChunkSize : void 0,
        u ? u.onError : void 0,
        function() {
          var W = new ReadableStream(
            {
              type: "bytes",
              pull: function(te) {
                wl(I, te);
              },
              cancel: function(te) {
                I.destination = null, dl(I, te);
              }
            },
            { highWaterMark: 0 }
          );
          W = { postponed: Su(I), prelude: W }, h(W);
        },
        void 0,
        void 0,
        b,
        u ? u.onPostpone : void 0
      );
      if (u && u.signal) {
        var L = u.signal;
        if (L.aborted) dl(I, L.reason);
        else {
          var X = function() {
            dl(I, L.reason), L.removeEventListener("abort", X);
          };
          L.addEventListener("abort", X);
        }
      }
      Ti(I);
    });
  }, Co.renderToReadableStream = function(i, u) {
    return new Promise(function(h, b) {
      var p, C, M = new Promise(function(Te, Ve) {
        C = Te, p = Ve;
      }), I = u ? u.onHeaders : void 0, L;
      I && (L = function(Te) {
        I(new Headers(Te));
      });
      var X = zl(
        u ? u.identifierPrefix : void 0,
        u ? u.unstable_externalRuntimeSrc : void 0,
        u ? u.bootstrapScriptContent : void 0,
        u ? u.bootstrapScripts : void 0,
        u ? u.bootstrapModules : void 0
      ), W = ba(
        i,
        X,
        vn(
          X,
          u ? u.nonce : void 0,
          u ? u.unstable_externalRuntimeSrc : void 0,
          u ? u.importMap : void 0,
          L,
          u ? u.maxHeadersLength : void 0
        ),
        Ha(u ? u.namespaceURI : void 0),
        u ? u.progressiveChunkSize : void 0,
        u ? u.onError : void 0,
        C,
        function() {
          var Te = new ReadableStream(
            {
              type: "bytes",
              pull: function(Ve) {
                wl(W, Ve);
              },
              cancel: function(Ve) {
                W.destination = null, dl(W, Ve);
              }
            },
            { highWaterMark: 0 }
          );
          Te.allReady = M, h(Te);
        },
        function(Te) {
          M.catch(function() {
          }), b(Te);
        },
        p,
        u ? u.onPostpone : void 0,
        u ? u.formState : void 0
      );
      if (u && u.signal) {
        var te = u.signal;
        if (te.aborted) dl(W, te.reason);
        else {
          var me = function() {
            dl(W, te.reason), te.removeEventListener("abort", me);
          };
          te.addEventListener("abort", me);
        }
      }
      Ti(W);
    });
  }, Co.resume = function(i, u, h) {
    return new Promise(function(b, p) {
      var C, M, I = new Promise(function(te, me) {
        M = te, C = me;
      }), L = jl(
        i,
        u,
        vn(
          u.resumableState,
          h ? h.nonce : void 0,
          void 0,
          void 0,
          void 0,
          void 0
        ),
        h ? h.onError : void 0,
        M,
        function() {
          var te = new ReadableStream(
            {
              type: "bytes",
              pull: function(me) {
                wl(L, me);
              },
              cancel: function(me) {
                L.destination = null, dl(L, me);
              }
            },
            { highWaterMark: 0 }
          );
          te.allReady = I, b(te);
        },
        function(te) {
          I.catch(function() {
          }), p(te);
        },
        C,
        h ? h.onPostpone : void 0
      );
      if (h && h.signal) {
        var X = h.signal;
        if (X.aborted) dl(L, X.reason);
        else {
          var W = function() {
            dl(L, X.reason), X.removeEventListener("abort", W);
          };
          X.addEventListener("abort", W);
        }
      }
      Ti(L);
    });
  }, Co.resumeAndPrerender = function(i, u, h) {
    return new Promise(function(b, p) {
      var C = vu(
        i,
        u,
        vn(
          u.resumableState,
          void 0,
          void 0,
          void 0,
          void 0,
          void 0
        ),
        h ? h.onError : void 0,
        function() {
          var L = new ReadableStream(
            {
              type: "bytes",
              pull: function(X) {
                wl(C, X);
              },
              cancel: function(X) {
                C.destination = null, dl(C, X);
              }
            },
            { highWaterMark: 0 }
          );
          L = { postponed: Su(C), prelude: L }, b(L);
        },
        void 0,
        void 0,
        p,
        h ? h.onPostpone : void 0
      );
      if (h && h.signal) {
        var M = h.signal;
        if (M.aborted) dl(C, M.reason);
        else {
          var I = function() {
            dl(C, M.reason), M.removeEventListener("abort", I);
          };
          M.addEventListener("abort", I);
        }
      }
      Ti(C);
    });
  }, Co.version = "19.2.6", Co;
}
var gb;
function vT() {
  if (gb) return Oo;
  gb = 1;
  var a, o;
  return a = hT(), o = gT(), Oo.version = a.version, Oo.renderToString = a.renderToString, Oo.renderToStaticMarkup = a.renderToStaticMarkup, Oo.renderToReadableStream = o.renderToReadableStream, Oo.resume = o.resume, Oo;
}
vT();
const yT = "staticMarkup";
function Uo() {
  const o = th().indexOf(yT) > -1 ? !0 : void 0;
  return {
    isBootstrap: o,
    isReact: o ? void 0 : !0
  };
}
const yl = ({ gaData: a, prefix: o = "", children: f }) => {
  const { isReact: v } = Uo(), { onClick: y, ...T } = f.props;
  if (v)
    return Gt.cloneElement(f, {
      ...T,
      onClick: (_) => (a && a.event && a.action && am(a), y ? y(_) : !0)
    });
  let w = "";
  ["input", "header", "header-input"].includes(o) && (w = `-${o}`);
  const O = {
    [`data-ga${w}`]: a.text,
    [`data-ga${w}-name`]: a.name,
    [`data-ga${w}-event`]: a.event,
    [`data-ga${w}-action`]: a.action,
    [`data-ga${w}-type`]: a.type,
    [`data-ga${w}-region`]: a.region,
    [`data-ga${w}-section`]: a.section,
    [`data-ga${w}-component`]: a.component
  };
  return Gt.cloneElement(f, {
    ...T,
    onClick: y,
    ...O
  });
}, um = ({
  id: a,
  parentId: o,
  /** @type {AccordionCard} */
  item: f,
  openCard: v,
  onClick: y,
  gaData: T,
  ref: w
}) => {
  var z, H, Z, Y, ce, le;
  const O = a === v, _ = O ? "open" : "close";
  return /* @__PURE__ */ A.jsxs(
    "div",
    {
      ref: w,
      className: Rt("accordion-item", "mt-3", {
        [`accordion-item-${f.color}`]: f.color,
        "accordion-header-icon": (z = f.content) == null ? void 0 : z.icon
      }),
      children: [
        /* @__PURE__ */ A.jsx("div", { className: "accordion-header", children: /* @__PURE__ */ A.jsx("h4", { children: /* @__PURE__ */ A.jsx(
          yl,
          {
            gaData: {
              ...T,
              action: _,
              text: f.content.header
            },
            children: /* @__PURE__ */ A.jsxs(
              "button",
              {
                "data-testid": "accordion-opener",
                className: Rt({ collapsed: !O }),
                "data-bs-toggle": "collapse",
                href: `#card-body-${a}`,
                type: "button",
                "aria-expanded": O,
                "aria-controls": `card-body-${a}`,
                onClick: (K) => y(K, a),
                children: [
                  (H = f.content) != null && H.icon ? /* @__PURE__ */ A.jsxs("span", { className: "accordion-icon", children: [
                    /* @__PURE__ */ A.jsx(
                      "i",
                      {
                        className: `${(Z = f.content.icon) == null ? void 0 : Z[0]} fa-${(Y = f.content.icon) == null ? void 0 : Y[1]} me-2`
                      }
                    ),
                    f.content.header
                  ] }) : (ce = f.content) == null ? void 0 : ce.header,
                  /* @__PURE__ */ A.jsx("i", { className: "fas fa-chevron-up" })
                ]
              }
            )
          }
        ) }) }),
        ((le = f.content) == null ? void 0 : le.body) && /* @__PURE__ */ A.jsx(
          "div",
          {
            "data-bs-parent": `#${o}`,
            id: `card-body-${a}`,
            className: Rt("collapse", { show: O }),
            children: /* @__PURE__ */ A.jsx(
              "div",
              {
                className: "accordion-body",
                dangerouslySetInnerHTML: ka(f.content.body)
              }
            )
          }
        )
      ]
    }
  );
};
um.propTypes = {
  id: E.number,
  // @ts-ignore a technical type mismatch between PropTypes definition and your TypeScript
  item: rm,
  parentId: E.string,
  openCard: E.number,
  onClick: E.func,
  gaData: E.object
};
const bT = {
  event: "collapse",
  name: "onclick",
  type: "click",
  region: "main content"
}, cm = ({ cards: a, openedCard: o }) => {
  const [f, v] = ua(o), y = `accordion-${th()}`, T = Do(
    /** @type { HTMLDivElement[]} */
    []
  ), w = (O, _) => {
    if (O.preventDefault(), f !== _) {
      const z = T.current[f - 1], H = z == null ? void 0 : z.lastElementChild;
      oT(H), v(_);
    } else
      v(null);
  };
  return /* @__PURE__ */ A.jsx("div", { className: "accordion", id: y, children: a == null ? void 0 : a.map(
    (O, _) => O.content.body && O.content.header && /* @__PURE__ */ A.jsx(
      um,
      {
        ref: (z) => {
          T.current[_] = z;
        },
        id: _ + 1,
        parentId: y,
        item: O,
        openCard: f,
        onClick: w,
        gaData: bT
      },
      _ + 1
    )
  ) });
};
cm.propTypes = {
  /**
   * Cards to show in the accordion component
   */
  cards: E.arrayOf(rm).isRequired,
  /**
   * Opened card based on rendered card position
   */
  openedCard: E.number
};
const vb = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, $c = ({
  label: a = "",
  cardTitle: o = "",
  gaData: f,
  ariaLabel: v,
  block: y,
  color: T = "gray",
  disabled: w,
  element: O = "button",
  href: _,
  icon: z,
  innerRef: H,
  onClick: Z,
  size: Y = "default",
  variant: ce,
  classes: le,
  target: K = "_self",
  ...he
}) => {
  if (ce) {
    const ze = {
      borderless: "borderless",
      outline: "outline",
      filled: "filled"
    }, ke = Rt("btn", ze[ce], {
      [`btn-${ze[ce]}-${T}`]: !0,
      "btn-medium": Y === "medium",
      "btn-small": Y === "small",
      "btn-large": Y === "large" || Y === "default",
      disabled: w
    });
    let pe = O;
    return _ && O === "button" && (pe = "a"), /* @__PURE__ */ A.jsx(
      yl,
      {
        gaData: {
          ...vb,
          section: o,
          ...f,
          text: a
        },
        children: /* @__PURE__ */ A.jsxs(
          pe,
          {
            type: pe === "button" && Z ? "button" : void 0,
            ...he,
            className: Rt(le) || ke,
            href: _,
            ref: H,
            onClick: Z,
            "aria-label": v,
            target: pe === "a" ? K : null,
            disabled: w,
            children: [
              z && /* @__PURE__ */ A.jsx("i", { className: `${z == null ? void 0 : z[0]} fa-${z == null ? void 0 : z[1]} me-1` }),
              a
            ]
          }
        )
      }
    );
  }
  const ye = Rt("btn", {
    [`btn-${T}`]: !0,
    "btn-md": Y === "small",
    "btn-sm": Y === "xsmall",
    "btn-block": y,
    disabled: w
  });
  let de = O;
  return _ && O === "button" && (de = "a"), /* @__PURE__ */ A.jsx(
    yl,
    {
      gaData: {
        ...vb,
        section: o,
        // @deprecated - remove at some point
        ...f,
        text: a
      },
      children: /* @__PURE__ */ A.jsxs(
        de,
        {
          type: de === "button" && Z ? "button" : void 0,
          ...he,
          className: Rt(le) || ye,
          href: _,
          ref: H,
          onClick: Z,
          "aria-label": v,
          target: de === "a" ? K : null,
          children: [
            z && /* @__PURE__ */ A.jsx("i", { className: `${z == null ? void 0 : z[0]} fa-${z == null ? void 0 : z[1]} me-1` }),
            a
          ]
        }
      )
    }
  );
};
$c.propTypes = {
  /**
   * Button label
   */
  label: E.string,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: E.string,
  /**
   * Google Analytics event data
   */
  gaData: qg,
  /**
    ARIA label for accessibility
  */
  ariaLabel: E.string,
  /**
    Render button as a block-button?
  */
  block: E.bool,
  /**
    Button background color
  */
  color: E.oneOf(["gold", "maroon", "gray", "dark"]),
  /**
    Disable the button?
  */
  disabled: E.bool,
  /**
    Pass in a Component to override default button element.
    For example: react-router Link
  */
  element: E.oneOfType([
    E.func,
    E.string,
    E.shape({ $$typeof: E.symbol, render: E.func }),
    E.arrayOf(
      E.oneOfType([
        E.func,
        E.string,
        E.shape({ $$typeof: E.symbol, render: E.func })
      ])
    )
  ]),
  /**
    Link target url; will cause button to be rendered as `<a>` link
  */
  href: E.string,
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: E.arrayOf(E.string),
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: E.oneOfType([
    E.object,
    E.func,
    E.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: E.func,
  /**
    Button size. Legacy sizes (default, small, xsmall) or new sizes (large, medium, small) when used with variant prop.
  */
  size: E.oneOf(["default", "small", "xsmall", "large", "medium"]),
  /**
    Button style variant (borderless, outline, filled). When provided, uses new UDS button styles.
  */
  variant: E.oneOf(["borderless", "outline", "filled"]),
  /**
    Classes to add to button
  */
  classes: E.arrayOf(E.string),
  /**
   Link target type
   */
  target: E.oneOf(["_blank", "_self", "_top", "_parent"])
};
function mT(a) {
  var o = /* @__PURE__ */ Object.create(null);
  return function(f) {
    return o[f] === void 0 && (o[f] = a(f)), o[f];
  };
}
var TT = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, pT = /* @__PURE__ */ mT(
  function(a) {
    return TT.test(a) || a.charCodeAt(0) === 111 && a.charCodeAt(1) === 110 && a.charCodeAt(2) < 91;
  }
  /* Z+1 */
), wn = "-ms-", Xf = "-moz-", Yt = "-webkit-", om = "comm", nh = "rule", $g = "decl", ST = "@import", xT = "@namespace", sm = "@keyframes", ET = "@layer", fm = Math.abs, ev = String.fromCharCode, Mg = Object.assign;
function wT(a, o) {
  return Rl(a, 0) ^ 45 ? (((o << 2 ^ Rl(a, 0)) << 2 ^ Rl(a, 1)) << 2 ^ Rl(a, 2)) << 2 ^ Rl(a, 3) : 0;
}
function dm(a) {
  return a.trim();
}
function Gu(a, o) {
  return (a = o.exec(a)) ? a[0] : a;
}
function ct(a, o, f) {
  return a.replace(o, f);
}
function Fd(a, o, f) {
  return a.indexOf(o, f);
}
function Rl(a, o) {
  return a.charCodeAt(o) | 0;
}
function ko(a, o, f) {
  return a.slice(o, f);
}
function Sr(a) {
  return a.length;
}
function hm(a) {
  return a.length;
}
function Yf(a, o) {
  return o.push(a), a;
}
function AT(a, o) {
  return a.map(o).join("");
}
function yb(a, o) {
  return a.filter(function(f) {
    return !Gu(f, o);
  });
}
var lh = 1, ks = 1, gm = 0, qi = 0, gl = 0, Us = "";
function ah(a, o, f, v, y, T, w, O) {
  return { value: a, root: o, parent: f, type: v, props: y, children: T, line: lh, column: ks, length: w, return: "", siblings: O };
}
function jc(a, o) {
  return Mg(ah("", null, null, "", null, null, 0, a.siblings), a, { length: -a.length }, o);
}
function Ms(a) {
  for (; a.root; )
    a = jc(a.root, { children: [a] });
  Yf(a, a.siblings);
}
function OT() {
  return gl;
}
function CT() {
  return gl = qi > 0 ? Rl(Us, --qi) : 0, ks--, gl === 10 && (ks = 1, lh--), gl;
}
function xr() {
  return gl = qi < gm ? Rl(Us, qi++) : 0, ks++, gl === 10 && (ks = 1, lh++), gl;
}
function qc() {
  return Rl(Us, qi);
}
function Yd() {
  return qi;
}
function ih(a, o) {
  return ko(Us, a, o);
}
function Vf(a) {
  switch (a) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function RT(a) {
  return lh = ks = 1, gm = Sr(Us = a), qi = 0, [];
}
function _T(a) {
  return Us = "", a;
}
function bg(a) {
  return dm(ih(qi - 1, zg(a === 91 ? a + 2 : a === 40 ? a + 1 : a)));
}
function NT(a) {
  for (; (gl = qc()) && gl < 33; )
    xr();
  return Vf(a) > 2 || Vf(gl) > 3 ? "" : " ";
}
function MT(a, o) {
  for (; --o && xr() && !(gl < 48 || gl > 102 || gl > 57 && gl < 65 || gl > 70 && gl < 97); )
    ;
  return ih(a, Yd() + (o < 6 && qc() == 32 && xr() == 32));
}
function zg(a) {
  for (; xr(); )
    switch (gl) {
      // ] ) " '
      case a:
        return qi;
      // " '
      case 34:
      case 39:
        a !== 34 && a !== 39 && zg(gl);
        break;
      // (
      case 40:
        a === 41 && zg(a);
        break;
      // \
      case 92:
        xr();
        break;
    }
  return qi;
}
function zT(a, o) {
  for (; xr() && a + gl !== 57; )
    if (a + gl === 84 && qc() === 47)
      break;
  return "/*" + ih(o, qi - 1) + "*" + ev(a === 47 ? a : xr());
}
function DT(a) {
  for (; !Vf(qc()); )
    xr();
  return ih(a, qi);
}
function kT(a) {
  return _T(Gd("", null, null, null, [""], a = RT(a), 0, [0], a));
}
function Gd(a, o, f, v, y, T, w, O, _) {
  for (var z = 0, H = 0, Z = w, Y = 0, ce = 0, le = 0, K = 1, he = 1, ye = 1, de = 0, ze = "", ke = y, pe = T, xe = v, we = ze; he; )
    switch (le = de, de = xr()) {
      // (
      case 40:
        if (le != 108 && Rl(we, Z - 1) == 58) {
          Fd(we += ct(bg(de), "&", "&\f"), "&\f", fm(z ? O[z - 1] : 0)) != -1 && (ye = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        we += bg(de);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        we += NT(le);
        break;
      // \
      case 92:
        we += MT(Yd() - 1, 7);
        continue;
      // /
      case 47:
        switch (qc()) {
          case 42:
          case 47:
            Yf(LT(zT(xr(), Yd()), o, f, _), _), (Vf(le || 1) == 5 || Vf(qc() || 1) == 5) && Sr(we) && ko(we, -1, void 0) !== " " && (we += " ");
            break;
          default:
            we += "/";
        }
        break;
      // {
      case 123 * K:
        O[z++] = Sr(we) * ye;
      // } ; \0
      case 125 * K:
      case 59:
      case 0:
        switch (de) {
          // \0 }
          case 0:
          case 125:
            he = 0;
          // ;
          case 59 + H:
            ye == -1 && (we = ct(we, /\f/g, "")), ce > 0 && (Sr(we) - Z || K === 0 && le === 47) && Yf(ce > 32 ? mb(we + ";", v, f, Z - 1, _) : mb(ct(we, " ", "") + ";", v, f, Z - 2, _), _);
            break;
          // @ ;
          case 59:
            we += ";";
          // { rule/at-rule
          default:
            if (Yf(xe = bb(we, o, f, z, H, y, O, ze, ke = [], pe = [], Z, T), T), de === 123)
              if (H === 0)
                Gd(we, o, xe, xe, ke, T, Z, O, pe);
              else {
                switch (Y) {
                  // c(ontainer)
                  case 99:
                    if (Rl(we, 3) === 110) break;
                  // l(ayer)
                  case 108:
                    if (Rl(we, 2) === 97) break;
                  default:
                    H = 0;
                  // d(ocument) m(edia) s(upports)
                  case 100:
                  case 109:
                  case 115:
                }
                H ? Gd(a, xe, xe, v && Yf(bb(a, xe, xe, 0, 0, y, O, ze, y, ke = [], Z, pe), pe), y, pe, Z, O, v ? ke : pe) : Gd(we, xe, xe, xe, [""], pe, 0, O, pe);
              }
        }
        z = H = ce = 0, K = ye = 1, ze = we = "", Z = w;
        break;
      // :
      case 58:
        Z = 1 + Sr(we), ce = le;
      default:
        if (K < 1) {
          if (de == 123)
            --K;
          else if (de == 125 && K++ == 0 && CT() == 125)
            continue;
        }
        switch (we += ev(de), de * K) {
          // &
          case 38:
            ye = H > 0 ? 1 : (we += "\f", -1);
            break;
          // ,
          case 44:
            O[z++] = (Sr(we) - 1) * ye, ye = 1;
            break;
          // @
          case 64:
            qc() === 45 && (we += bg(xr())), Y = qc(), H = Z = Sr(ze = we += DT(Yd())), de++;
            break;
          // -
          case 45:
            le === 45 && Sr(we) == 2 && (K = 0);
        }
    }
  return T;
}
function bb(a, o, f, v, y, T, w, O, _, z, H, Z) {
  for (var Y = y - 1, ce = y === 0 ? T : [""], le = hm(ce), K = 0, he = 0, ye = 0; K < v; ++K)
    for (var de = 0, ze = ko(a, Y + 1, Y = fm(he = w[K])), ke = a; de < le; ++de)
      (ke = dm(he > 0 ? ce[de] + " " + ze : ct(ze, /&\f/g, ce[de]))) && (_[ye++] = ke);
  return ah(a, o, f, y === 0 ? nh : O, _, z, H, Z);
}
function LT(a, o, f, v) {
  return ah(a, o, f, om, ev(OT()), ko(a, 2, -2), 0, v);
}
function mb(a, o, f, v, y) {
  return ah(a, o, f, $g, ko(a, 0, v), ko(a, v + 1, -1), v, y);
}
function vm(a, o, f) {
  switch (wT(a, o)) {
    // color-adjust
    case 5103:
      return Yt + "print-" + a + a;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
      return Yt + a + a;
    // mask-composite
    case 4855:
      return Yt + a.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + a;
    // tab-size
    case 4789:
      return Xf + a + a;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Yt + a + Xf + a + wn + a + a;
    // writing-mode
    case 5936:
      switch (Rl(a, o + 11)) {
        // vertical-l(r)
        case 114:
          return Yt + a + wn + ct(a, /[svh]\w+-[tblr]{2}/, "tb") + a;
        // vertical-r(l)
        case 108:
          return Yt + a + wn + ct(a, /[svh]\w+-[tblr]{2}/, "tb-rl") + a;
        // horizontal(-)tb
        case 45:
          return Yt + a + wn + ct(a, /[svh]\w+-[tblr]{2}/, "lr") + a;
      }
    // flex, flex-direction, scroll-snap-type, writing-mode
    case 6828:
    case 4268:
    case 2903:
      return Yt + a + wn + a + a;
    // order
    case 6165:
      return Yt + a + wn + "flex-" + a + a;
    // align-items
    case 5187:
      return Yt + a + ct(a, /(\w+).+(:[^]+)/, Yt + "box-$1$2" + wn + "flex-$1$2") + a;
    // align-self
    case 5443:
      return Yt + a + wn + "flex-item-" + ct(a, /flex-|-self/g, "") + (Gu(a, /flex-|baseline/) ? "" : wn + "grid-row-" + ct(a, /flex-|-self/g, "")) + a;
    // align-content
    case 4675:
      return Yt + a + wn + "flex-line-pack" + ct(a, /align-content|flex-|-self/g, "") + a;
    // flex-shrink
    case 5548:
      return Yt + a + wn + ct(a, "shrink", "negative") + a;
    // flex-basis
    case 5292:
      return Yt + a + wn + ct(a, "basis", "preferred-size") + a;
    // flex-grow
    case 6060:
      return Yt + "box-" + ct(a, "-grow", "") + Yt + a + wn + ct(a, "grow", "positive") + a;
    // transition
    case 4554:
      return Yt + ct(a, /([^-])(transform)/g, "$1" + Yt + "$2") + a;
    // cursor
    case 6187:
      return ct(ct(ct(a, /(zoom-|grab)/, Yt + "$1"), /(image-set)/, Yt + "$1"), a, "") + a;
    // background, background-image
    case 5495:
    case 3959:
      return ct(a, /(image-set\([^]*)/, Yt + "$1$`$1");
    // justify-content
    case 4968:
      return ct(ct(a, /(.+:)(flex-)?(.*)/, Yt + "box-pack:$3" + wn + "flex-pack:$3"), /space-between/, "justify") + Yt + a + a;
    // justify-self
    case 4200:
      if (!Gu(a, /flex-|baseline/)) return wn + "grid-column-align" + ko(a, o) + a;
      break;
    // grid-template-(columns|rows)
    case 2592:
    case 3360:
      return wn + ct(a, "template-", "") + a;
    // grid-(row|column)-start
    case 4384:
    case 3616:
      return f && f.some(function(v, y) {
        return o = y, Gu(v.props, /grid-\w+-end/);
      }) ? ~Fd(a + (f = f[o].value), "span", 0) ? a : wn + ct(a, "-start", "") + a + wn + "grid-row-span:" + (~Fd(f, "span", 0) ? Gu(f, /\d+/) : +Gu(f, /\d+/) - +Gu(a, /\d+/)) + ";" : wn + ct(a, "-start", "") + a;
    // grid-(row|column)-end
    case 4896:
    case 4128:
      return f && f.some(function(v) {
        return Gu(v.props, /grid-\w+-start/);
      }) ? a : wn + ct(ct(a, "-end", "-span"), "span ", "") + a;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return ct(a, /(.+)-inline(.+)/, Yt + "$1$2") + a;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Sr(a) - 1 - o > 6)
        switch (Rl(a, o + 1)) {
          // (m)ax-content, (m)in-content
          case 109:
            if (Rl(a, o + 4) !== 45)
              break;
          // (f)ill-available, (f)it-content
          case 102:
            return ct(a, /(.+:)(.+)-([^]+)/, "$1" + Yt + "$2-$3$1" + Xf + (Rl(a, o + 3) == 108 ? "$3" : "$2-$3")) + a;
          // (s)tretch
          case 115:
            return ~Fd(a, "stretch", 0) ? vm(ct(a, "stretch", "fill-available"), o, f) + a : a;
        }
      break;
    // grid-(column|row)
    case 5152:
    case 5920:
      return ct(a, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(v, y, T, w, O, _, z) {
        return wn + y + ":" + T + z + (w ? wn + y + "-span:" + (O ? _ : +_ - +T) + z : "") + a;
      });
    // position: sticky
    case 4949:
      if (Rl(a, o + 6) === 121)
        return ct(a, ":", ":" + Yt) + a;
      break;
    // display: (flex|inline-flex|grid|inline-grid)
    case 6444:
      switch (Rl(a, Rl(a, 14) === 45 ? 18 : 11)) {
        // (inline-)?fle(x)
        case 120:
          return ct(a, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + Yt + (Rl(a, 14) === 45 ? "inline-" : "") + "box$3$1" + Yt + "$2$3$1" + wn + "$2box$3") + a;
        // (inline-)?gri(d)
        case 100:
          return ct(a, ":", ":" + wn) + a;
      }
      break;
    // scroll-margin, scroll-margin-(top|right|bottom|left)
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return ct(a, "scroll-", "scroll-snap-") + a;
  }
  return a;
}
function Kd(a, o) {
  for (var f = "", v = 0; v < a.length; v++)
    f += o(a[v], v, a, o) || "";
  return f;
}
function BT(a, o, f, v) {
  switch (a.type) {
    case ET:
      if (a.children.length) break;
    case ST:
    case xT:
    case $g:
      return a.return = a.return || a.value;
    case om:
      return "";
    case sm:
      return a.return = a.value + "{" + Kd(a.children, v) + "}";
    case nh:
      if (!Sr(a.value = a.props.join(","))) return "";
  }
  return Sr(f = Kd(a.children, v)) ? a.return = a.value + "{" + f + "}" : "";
}
function HT(a) {
  var o = hm(a);
  return function(f, v, y, T) {
    for (var w = "", O = 0; O < o; O++)
      w += a[O](f, v, y, T) || "";
    return w;
  };
}
function UT(a) {
  return function(o) {
    o.root || (o = o.return) && a(o);
  };
}
function FT(a, o, f, v) {
  if (a.length > -1 && !a.return)
    switch (a.type) {
      case $g:
        a.return = vm(a.value, a.length, f);
        return;
      case sm:
        return Kd([jc(a, { value: ct(a.value, "@", "@" + Yt) })], v);
      case nh:
        if (a.length)
          return AT(f = a.props, function(y) {
            switch (Gu(y, v = /(::plac\w+|:read-\w+)/)) {
              // :read-(only|write)
              case ":read-only":
              case ":read-write":
                Ms(jc(a, { props: [ct(y, /:(read-\w+)/, ":" + Xf + "$1")] })), Ms(jc(a, { props: [y] })), Mg(a, { props: yb(f, v) });
                break;
              // :placeholder
              case "::placeholder":
                Ms(jc(a, { props: [ct(y, /:(plac\w+)/, ":" + Yt + "input-$1")] })), Ms(jc(a, { props: [ct(y, /:(plac\w+)/, ":" + Xf + "$1")] })), Ms(jc(a, { props: [ct(y, /:(plac\w+)/, wn + "input-$1")] })), Ms(jc(a, { props: [y] })), Mg(a, { props: yb(f, v) });
                break;
            }
            return "";
          });
    }
}
var nn = { env: { NODE_ENV: "production" } }, mg, Tg;
const Lo = typeof nn < "u" && nn.env !== void 0 && (nn.env.REACT_APP_SC_ATTR || nn.env.SC_ATTR) || "data-styled", ym = "active", bm = "data-styled-version", rh = "6.4.2", tv = `/*!sc*/
`, If = typeof window < "u" && typeof document < "u";
function Tb(a) {
  if (typeof nn < "u" && nn.env !== void 0) {
    const o = nn.env[a];
    if (o !== void 0 && o !== "") return o !== "false";
  }
}
const YT = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : (Tg = (mg = Tb("REACT_APP_SC_DISABLE_SPEEDY")) !== null && mg !== void 0 ? mg : Tb("SC_DISABLE_SPEEDY")) !== null && Tg !== void 0 ? Tg : typeof nn < "u" && nn.env !== void 0 && nn.env.NODE_ENV !== "production"), GT = "sc-keyframes-", XT = nn.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?

`, 18: `Accessing \`useTheme\` hook outside of a \`<ThemeProvider>\` element.

\`\`\`jsx
import { useTheme } from 'styled-components';
export function StyledCompoent({ children }) {
  const theme = useTheme();
  return <div style={{ width: theme.sizes.full }}>{children}</div>;
}

import { StyledComponent } from './StyledComponent';
import { theme } from './theme';
export function App() {
  return (
    <ThemeProvider theme={theme}>
      <StyledComponent />
    </ThemeProvider>
  );
}
\`\`\`

If you need access to the theme in an uncertain composition scenario, \`React.useContext(ThemeContext)\` will not emit an error if there is no \`ThemeProvider\` ancestor.
` } : {};
function Wf(a, ...o) {
  return nn.env.NODE_ENV === "production" ? new Error(`An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#${a} for more information.${o.length > 0 ? ` Args: ${o.join(", ")}` : ""}`) : new Error((function(...f) {
    let v = f[0];
    const y = [];
    for (let T = 1, w = f.length; T < w; T += 1) y.push(f[T]);
    return y.forEach((T) => {
      v = v.replace(/%[a-z]/, T);
    }), v;
  })(XT[a], ...o).trim());
}
const IT = 1 << 30;
let Xd = /* @__PURE__ */ new Map(), jd = /* @__PURE__ */ new Map(), Id = 1;
const Dd = (a) => {
  if (Xd.has(a)) return Xd.get(a);
  for (; jd.has(Id); ) Id++;
  const o = Id++;
  if (nn.env.NODE_ENV !== "production" && ((0 | o) < 0 || o > IT)) throw Wf(16, `${o}`);
  return Xd.set(a, o), jd.set(o, a), o;
}, ZT = (a) => jd.get(a), VT = (a, o) => {
  Id = o + 1, Xd.set(a, o), jd.set(o, a);
}, pb = /invalid hook call/i, kd = /* @__PURE__ */ new Set(), QT = (a, o) => {
  if (nn.env.NODE_ENV !== "production") {
    const f = `The component ${a}${o ? ` with the id of "${o}"` : ""} has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.
See https://styled-components.com/docs/basics#define-styled-components-outside-of-the-render-method for more info.
`, v = console.error;
    try {
      let y = !0;
      console.error = (T, ...w) => {
        pb.test(T) ? (y = !1, kd.delete(f)) : v(T, ...w);
      }, typeof Gt.useState == "function" && Gt.useState(null), y && !kd.has(f) && (console.warn(f), kd.add(f));
    } catch (y) {
      pb.test(y.message) && kd.delete(f);
    } finally {
      console.error = v;
    }
  }
}, nv = Object.freeze([]), Ls = Object.freeze({});
function WT(a, o, f = Ls) {
  return a.theme !== f.theme && a.theme || o || f.theme;
}
const PT = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, JT = /(^-|-$)/g;
function mm(a) {
  return a.replace(PT, "-").replace(JT, "");
}
const KT = /(a)(d)/gi, Sb = (a) => String.fromCharCode(a + (a > 25 ? 39 : 97));
function Tm(a) {
  let o, f = "";
  for (o = Math.abs(a); o > 52; o = o / 52 | 0) f = Sb(o % 52) + f;
  return (Sb(o % 52) + f).replace(KT, "$1-$2");
}
const Dg = 5381, Mo = (a, o) => {
  let f = o.length;
  for (; f; ) a = 33 * a ^ o.charCodeAt(--f);
  return a;
}, pm = (a) => Mo(Dg, a);
function jT(a) {
  return Tm(pm(a) >>> 0);
}
function lv(a) {
  return nn.env.NODE_ENV !== "production" && typeof a == "string" && a || a.displayName || a.name || "Component";
}
function Zd(a) {
  return typeof a == "string" && (nn.env.NODE_ENV === "production" || a.charAt(0) === a.charAt(0).toLowerCase());
}
function qT(a) {
  return Zd(a) ? `styled.${a}` : `Styled(${lv(a)})`;
}
const Sm = Symbol.for("react.memo"), $T = Symbol.for("react.forward_ref"), ep = { contextType: !0, defaultProps: !0, displayName: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, propTypes: !0, type: !0 }, tp = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, xm = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, np = { [$T]: { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, [Sm]: xm };
function xb(a) {
  return ("type" in (o = a) && o.type.$$typeof) === Sm ? xm : "$$typeof" in a ? np[a.$$typeof] : ep;
  var o;
}
const lp = Object.defineProperty, ap = Object.getOwnPropertyNames, ip = Object.getOwnPropertySymbols, rp = Object.getOwnPropertyDescriptor, up = Object.getPrototypeOf, cp = Object.prototype;
function Em(a, o, f) {
  if (typeof o != "string") {
    const v = up(o);
    v && v !== cp && Em(a, v, f);
    const y = ap(o).concat(ip(o)), T = xb(a), w = xb(o);
    for (let O = 0; O < y.length; ++O) {
      const _ = y[O];
      if (!(_ in tp || f && f[_] || w && _ in w || T && _ in T)) {
        const z = rp(o, _);
        try {
          lp(a, _, z);
        } catch {
        }
      }
    }
  }
  return a;
}
function uh(a) {
  return typeof a == "function";
}
const op = Symbol.for("react.forward_ref");
function wm(a) {
  return a != null && (typeof a == "object" || typeof a == "function") && a.$$typeof === op && "styledComponentId" in a;
}
function Gf(a, o) {
  return a && o ? a + " " + o : a || o || "";
}
function Eb(a, o) {
  return a.join("");
}
function Bo(a) {
  return a !== null && typeof a == "object" && a.constructor.name === Object.name && !("props" in a && a.$$typeof);
}
function kg(a, o, f = !1) {
  if (!f && !Bo(a) && !Array.isArray(a)) return o;
  if (Array.isArray(o)) for (let v = 0; v < o.length; v++) a[v] = kg(a[v], o[v]);
  else if (Bo(o)) for (const v in o) a[v] = kg(a[v], o[v]);
  return a;
}
function Am(a, o) {
  Object.defineProperty(a, "toString", { value: o });
}
const sp = class {
  constructor(a) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = a, this._cGroup = 0, this._cIndex = 0;
  }
  indexOfGroup(a) {
    if (a === this._cGroup) return this._cIndex;
    let o = this._cIndex;
    if (a > this._cGroup) for (let f = this._cGroup; f < a; f++) o += this.groupSizes[f];
    else for (let f = this._cGroup - 1; f >= a; f--) o -= this.groupSizes[f];
    return this._cGroup = a, this._cIndex = o, o;
  }
  insertRules(a, o) {
    if (a >= this.groupSizes.length) {
      const y = this.groupSizes, T = y.length;
      let w = T;
      for (; a >= w; ) if (w <<= 1, w < 0) throw Wf(16, `${a}`);
      this.groupSizes = new Uint32Array(w), this.groupSizes.set(y), this.length = w;
      for (let O = T; O < w; O++) this.groupSizes[O] = 0;
    }
    let f = this.indexOfGroup(a + 1), v = 0;
    for (let y = 0, T = o.length; y < T; y++) this.tag.insertRule(f, o[y]) && (this.groupSizes[a]++, f++, v++);
    v > 0 && this._cGroup > a && (this._cIndex += v);
  }
  clearGroup(a) {
    if (a < this.length) {
      const o = this.groupSizes[a], f = this.indexOfGroup(a), v = f + o;
      this.groupSizes[a] = 0;
      for (let y = f; y < v; y++) this.tag.deleteRule(f);
      o > 0 && this._cGroup > a && (this._cIndex -= o);
    }
  }
  getGroup(a) {
    let o = "";
    if (a >= this.length || this.groupSizes[a] === 0) return o;
    const f = this.groupSizes[a], v = this.indexOfGroup(a), y = v + f;
    for (let T = v; T < y; T++) o += this.tag.getRule(T) + tv;
    return o;
  }
}, fp = `style[${Lo}][${bm}="${rh}"]`, dp = new RegExp(`^${Lo}\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)`), wb = (a) => typeof ShadowRoot < "u" && a instanceof ShadowRoot || "host" in a && a.nodeType === 11, Lg = (a) => {
  if (!a) return document;
  if (wb(a)) return a;
  if ("getRootNode" in a) {
    const o = a.getRootNode();
    if (wb(o)) return o;
  }
  return document;
}, hp = (a, o, f) => {
  const v = f.split(",");
  let y;
  for (let T = 0, w = v.length; T < w; T++) (y = v[T]) && a.registerName(o, y);
}, gp = (a, o) => {
  var f;
  const v = ((f = o.textContent) !== null && f !== void 0 ? f : "").split(tv), y = [];
  for (let T = 0, w = v.length; T < w; T++) {
    const O = v[T].trim();
    if (!O) continue;
    const _ = O.match(dp);
    if (_) {
      const z = 0 | parseInt(_[1], 10), H = _[2];
      z !== 0 && (VT(H, z), hp(a, H, _[3]), a.getTag().insertRules(z, y)), y.length = 0;
    } else y.push(O);
  }
}, pg = (a) => {
  const o = Lg(a.options.target).querySelectorAll(fp);
  for (let f = 0, v = o.length; f < v; f++) {
    const y = o[f];
    y && y.getAttribute(Lo) !== ym && (gp(a, y), y.parentNode && y.parentNode.removeChild(y));
  }
};
let Hf = !1;
function vp() {
  if (Hf !== !1) return Hf;
  if (typeof document < "u") {
    const a = document.head.querySelector('meta[property="csp-nonce"]');
    if (a) return Hf = a.nonce || a.getAttribute("content") || void 0;
    const o = document.head.querySelector('meta[name="sc-nonce"]');
    if (o) return Hf = o.getAttribute("content") || void 0;
  }
  return Hf = typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}
const Om = (a, o) => {
  const f = document.head, v = a || f, y = document.createElement("style"), T = ((_) => {
    const z = Array.from(_.querySelectorAll(`style[${Lo}]`));
    return z[z.length - 1];
  })(v), w = T !== void 0 ? T.nextSibling : null;
  y.setAttribute(Lo, ym), y.setAttribute(bm, rh);
  const O = o || vp();
  return O && y.setAttribute("nonce", O), v.insertBefore(y, w), y;
}, yp = class {
  constructor(a, o) {
    this.element = Om(a, o), this.element.appendChild(document.createTextNode("")), this.sheet = ((f) => {
      var v;
      if (f.sheet) return f.sheet;
      const y = (v = f.getRootNode().styleSheets) !== null && v !== void 0 ? v : document.styleSheets;
      for (let T = 0, w = y.length; T < w; T++) {
        const O = y[T];
        if (O.ownerNode === f) return O;
      }
      throw Wf(17);
    })(this.element), this.length = 0;
  }
  insertRule(a, o) {
    try {
      return this.sheet.insertRule(o, a), this.length++, !0;
    } catch {
      return !1;
    }
  }
  deleteRule(a) {
    this.sheet.deleteRule(a), this.length--;
  }
  getRule(a) {
    const o = this.sheet.cssRules[a];
    return o && o.cssText ? o.cssText : "";
  }
}, bp = class {
  constructor(a, o) {
    this.element = Om(a, o), this.nodes = this.element.childNodes, this.length = 0;
  }
  insertRule(a, o) {
    if (a <= this.length && a >= 0) {
      const f = document.createTextNode(o);
      return this.element.insertBefore(f, this.nodes[a] || null), this.length++, !0;
    }
    return !1;
  }
  deleteRule(a) {
    this.element.removeChild(this.nodes[a]), this.length--;
  }
  getRule(a) {
    return a < this.length ? this.nodes[a].textContent : "";
  }
};
let Ab = If;
const mp = { isServer: !If, useCSSOMInjection: !YT };
class ch {
  static registerId(o) {
    return Dd(o);
  }
  constructor(o = Ls, f = {}, v) {
    this.options = Object.assign(Object.assign({}, mp), o), this.gs = f, this.keyframeIds = /* @__PURE__ */ new Set(), this.names = new Map(v), this.server = !!o.isServer, !this.server && If && Ab && (Ab = !1, pg(this)), Am(this, () => ((y) => {
      const T = y.getTag(), { length: w } = T;
      let O = "";
      for (let _ = 0; _ < w; _++) {
        const z = ZT(_);
        if (z === void 0) continue;
        const H = y.names.get(z);
        if (H === void 0 || !H.size) continue;
        const Z = T.getGroup(_);
        if (Z.length === 0) continue;
        const Y = Lo + ".g" + _ + '[id="' + z + '"]';
        let ce = "";
        for (const le of H) le.length > 0 && (ce += le + ",");
        O += Z + Y + '{content:"' + ce + '"}' + tv;
      }
      return O;
    })(this));
  }
  rehydrate() {
    !this.server && If && pg(this);
  }
  reconstructWithOptions(o, f = !0) {
    const v = new ch(Object.assign(Object.assign({}, this.options), o), this.gs, f && this.names || void 0);
    return v.keyframeIds = new Set(this.keyframeIds), !this.server && If && o.target !== this.options.target && Lg(this.options.target) !== Lg(o.target) && pg(v), v;
  }
  allocateGSInstance(o) {
    return this.gs[o] = (this.gs[o] || 0) + 1;
  }
  getTag() {
    return this.tag || (this.tag = (o = (({ useCSSOMInjection: f, target: v, nonce: y }) => f ? new yp(v, y) : new bp(v, y))(this.options), new sp(o)));
    var o;
  }
  hasNameForId(o, f) {
    var v, y;
    return (y = (v = this.names.get(o)) === null || v === void 0 ? void 0 : v.has(f)) !== null && y !== void 0 && y;
  }
  registerName(o, f) {
    Dd(o), o.startsWith(GT) && this.keyframeIds.add(o);
    const v = this.names.get(o);
    v ? v.add(f) : this.names.set(o, /* @__PURE__ */ new Set([f]));
  }
  insertRules(o, f, v) {
    this.registerName(o, f), this.getTag().insertRules(Dd(o), v);
  }
  clearNames(o) {
    this.names.has(o) && this.names.get(o).clear();
  }
  clearRules(o) {
    this.getTag().clearGroup(Dd(o)), this.clearNames(o);
  }
  clearTag() {
    this.tag = void 0;
  }
}
const Cm = /* @__PURE__ */ new WeakSet(), Tp = { animationIterationCount: 1, aspectRatio: 1, borderImageOutset: 1, borderImageSlice: 1, borderImageWidth: 1, columnCount: 1, columns: 1, flex: 1, flexGrow: 1, flexShrink: 1, gridRow: 1, gridRowEnd: 1, gridRowSpan: 1, gridRowStart: 1, gridColumn: 1, gridColumnEnd: 1, gridColumnSpan: 1, gridColumnStart: 1, fontWeight: 1, lineHeight: 1, opacity: 1, order: 1, orphans: 1, scale: 1, tabSize: 1, widows: 1, zIndex: 1, zoom: 1, WebkitLineClamp: 1, fillOpacity: 1, floodOpacity: 1, stopOpacity: 1, strokeDasharray: 1, strokeDashoffset: 1, strokeMiterlimit: 1, strokeOpacity: 1, strokeWidth: 1 };
function pp(a, o) {
  return o == null || typeof o == "boolean" || o === "" ? "" : typeof o != "number" || o === 0 || a in Tp || a.startsWith("--") ? String(o).trim() : o + "px";
}
const No = 47;
function Ob(a) {
  if (a.charCodeAt(0) === 45 && a.charCodeAt(1) === 45) return a;
  let o = "";
  for (let f = 0; f < a.length; f++) {
    const v = a.charCodeAt(f);
    o += v >= 65 && v <= 90 ? "-" + String.fromCharCode(v + 32) : a[f];
  }
  return o.startsWith("ms-") ? "-" + o : o;
}
const Sp = Symbol.for("sc-keyframes");
function Bg(a) {
  return typeof a == "object" && a !== null && Sp in a;
}
function Rm(a) {
  return uh(a) && !(a.prototype && a.prototype.isReactComponent);
}
const _m = (a) => a == null || a === !1 || a === "", xp = Symbol.for("react.client.reference");
function Cb(a) {
  return a.$$typeof === xp;
}
function Rb(a) {
  const o = a.$$id, f = (o && o.includes("#") ? o.split("#").pop() : o) || a.name || "unknown";
  console.warn(`Interpolating a client component (${f}) as a selector is not supported in server components. The component selector pattern requires access to the component's internal class name, which is not available across the server/client boundary. Use a plain CSS class selector instead.`);
}
function Nm(a, o) {
  for (const f in a) {
    const v = a[f];
    a.hasOwnProperty(f) && !_m(v) && (Array.isArray(v) && Cm.has(v) || uh(v) ? o.push(Ob(f) + ":", v, ";") : Bo(v) ? (o.push(f + " {"), Nm(v, o), o.push("}")) : o.push(Ob(f) + ": " + pp(f, v) + ";"));
  }
}
function zo(a, o, f, v, y = []) {
  if (_m(a)) return y;
  const T = typeof a;
  if (T === "string") return y.push(a), y;
  if (T === "function") {
    if (Cb(a)) return nn.env.NODE_ENV !== "production" && Rb(a), y;
    if (Rm(a) && o) {
      const w = a(o);
      return nn.env.NODE_ENV === "production" || typeof w != "object" || Array.isArray(w) || Bg(w) || Bo(w) || w === null || console.error(`${lv(a)} is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.`), zo(w, o, f, v, y);
    }
    return y.push(a), y;
  }
  if (Array.isArray(a)) {
    for (let w = 0; w < a.length; w++) zo(a[w], o, f, v, y);
    return y;
  }
  return wm(a) ? (y.push(`.${a.styledComponentId}`), y) : Bg(a) ? (f ? (a.inject(f, v), y.push(a.getName(v))) : y.push(a), y) : Cb(a) ? (nn.env.NODE_ENV !== "production" && Rb(a), y) : Bo(a) ? a.toString !== Object.prototype.toString ? (y.push(a.toString()), y) : (Nm(a, y), y) : (y.push(a.toString()), y);
}
const Ep = pm(rh);
class wp {
  constructor(o, f, v) {
    this.rules = o, this.componentId = f, this.baseHash = Mo(Ep, f), this.baseStyle = v, ch.registerId(f);
  }
  generateAndInjectStyles(o, f, v) {
    let y = this.baseStyle ? this.baseStyle.generateAndInjectStyles(o, f, v) : "";
    {
      let T = "";
      for (let w = 0; w < this.rules.length; w++) {
        const O = this.rules[w];
        if (typeof O == "string") T += O;
        else if (O) if (Rm(O)) {
          const _ = O(o);
          typeof _ == "string" ? T += _ : _ != null && _ !== !1 && (nn.env.NODE_ENV === "production" || typeof _ != "object" || Array.isArray(_) || Bg(_) || Bo(_) || console.error(`${lv(O)} is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.`), T += Eb(zo(_, o, f, v)));
        } else T += Eb(zo(O, o, f, v));
      }
      if (T) {
        this.dynamicNameCache || (this.dynamicNameCache = /* @__PURE__ */ new Map());
        const w = v.hash ? v.hash + T : T;
        let O = this.dynamicNameCache.get(w);
        if (!O) {
          if (O = Tm(Mo(Mo(this.baseHash, v.hash), T) >>> 0), this.dynamicNameCache.size >= 200) {
            const _ = this.dynamicNameCache.keys().next().value;
            _ !== void 0 && this.dynamicNameCache.delete(_);
          }
          this.dynamicNameCache.set(w, O);
        }
        if (!f.hasNameForId(this.componentId, O)) {
          const _ = v(T, "." + O, void 0, this.componentId);
          f.insertRules(this.componentId, O, _);
        }
        y = Gf(y, O);
      }
    }
    return y;
  }
}
const Ap = /&/g;
function Mm(a, o) {
  let f = 0;
  for (; --o >= 0 && a.charCodeAt(o) === 92; ) f++;
  return !(1 & ~f);
}
function Sg(a) {
  const o = a.length;
  let f = "", v = 0, y = 0, T = 0, w = !1, O = !1;
  for (let _ = 0; _ < o; _++) {
    const z = a.charCodeAt(_);
    if (T !== 0 || w || z !== No || a.charCodeAt(_ + 1) !== 42) if (w) z === 42 && a.charCodeAt(_ + 1) === No && (w = !1, _++);
    else if (z !== 34 && z !== 39 || Mm(a, _)) {
      if (T === 0) if (z === 123) y++;
      else if (z === 125) {
        if (y--, y < 0) {
          O = !0;
          let H = _ + 1;
          for (; H < o; ) {
            const Z = a.charCodeAt(H);
            if (Z === 59 || Z === 10) break;
            H++;
          }
          H < o && a.charCodeAt(H) === 59 && H++, y = 0, _ = H - 1, v = H;
          continue;
        }
        y === 0 && (f += a.substring(v, _ + 1), v = _ + 1);
      } else z === 59 && y === 0 && (f += a.substring(v, _ + 1), v = _ + 1);
    } else T === 0 ? T = z : T === z && (T = 0);
    else w = !0, _++;
  }
  return O || y !== 0 || T !== 0 ? (v < o && y === 0 && T === 0 && (f += a.substring(v)), f) : a;
}
function zm(a, o) {
  const f = o + " ", v = "," + f;
  for (let y = 0; y < a.length; y++) {
    const T = a[y];
    if (T.type === "rule") {
      T.value = (f + T.value).replaceAll(",", v);
      const w = T.props, O = [];
      for (let _ = 0; _ < w.length; _++) O[_] = f + w[_];
      T.props = O;
    }
    Array.isArray(T.children) && T.type !== "@keyframes" && zm(T.children, o);
  }
  return a;
}
function Op({ options: a = Ls, plugins: o = nv } = Ls) {
  let f, v, y;
  const T = (Y, ce, le) => le.startsWith(v) && le.endsWith(v) && le.replaceAll(v, "").length > 0 ? `.${f}` : Y, w = o.slice();
  w.push((Y) => {
    Y.type === nh && Y.value.includes("&") && (y || (y = new RegExp(`\\${v}\\b`, "g")), Y.props[0] = Y.props[0].replace(Ap, v).replace(y, T));
  }), a.prefix && w.push(FT), w.push(BT);
  let O = [];
  const _ = HT(w.concat(UT((Y) => O.push(Y)))), z = (Y, ce = "", le = "", K = "&") => {
    f = K, v = ce, y = void 0;
    const he = (function(de) {
      const ze = de.indexOf("//") !== -1, ke = de.indexOf("}") !== -1;
      if (!ze && !ke) return de;
      if (!ze) return Sg(de);
      const pe = de.length;
      let xe = "", we = 0, Ce = 0, Le = 0, Ht = 0, Et = 0, Xt = !1;
      for (; Ce < pe; ) {
        const Ee = de.charCodeAt(Ce);
        if (Ee !== 34 && Ee !== 39 || Mm(de, Ce)) if (Le === 0) if (Ee === No && Ce + 1 < pe && de.charCodeAt(Ce + 1) === 42) {
          for (Ce += 2; Ce + 1 < pe && (de.charCodeAt(Ce) !== 42 || de.charCodeAt(Ce + 1) !== No); ) Ce++;
          Ce += 2;
        } else if (Ee !== 40) if (Ee !== 41) if (Ht > 0) Ce++;
        else if (Ee === 42 && Ce + 1 < pe && de.charCodeAt(Ce + 1) === No) xe += de.substring(we, Ce), Ce += 2, we = Ce, Xt = !0;
        else if (Ee === No && Ce + 1 < pe && de.charCodeAt(Ce + 1) === No) {
          for (xe += de.substring(we, Ce); Ce < pe && de.charCodeAt(Ce) !== 10; ) Ce++;
          we = Ce, Xt = !0;
        } else Ee === 123 ? Et++ : Ee === 125 && Et--, Ce++;
        else Ht > 0 && Ht--, Ce++;
        else Ht++, Ce++;
        else Ce++;
        else Le === 0 ? Le = Ee : Le === Ee && (Le = 0), Ce++;
      }
      return Xt ? (we < pe && (xe += de.substring(we)), Et === 0 ? xe : Sg(xe)) : Et === 0 ? de : Sg(de);
    })(Y);
    let ye = kT(le || ce ? le + " " + ce + " { " + he + " }" : he);
    return a.namespace && (ye = zm(ye, a.namespace)), O = [], Kd(ye, _), O;
  }, H = a;
  let Z = Dg;
  for (let Y = 0; Y < o.length; Y++) o[Y].name || Wf(15), Z = Mo(Z, o[Y].name);
  return H != null && H.namespace && (Z = Mo(Z, H.namespace)), H != null && H.prefix && (Z = Mo(Z, "p")), z.hash = Z !== Dg ? Z.toString() : "", z;
}
const Cp = new ch(), Rp = Op(), Dm = Gt.createContext({ shouldForwardProp: void 0, styleSheet: Cp, stylis: Rp, stylisPlugins: void 0 });
Dm.Consumer;
function _p() {
  return Gt.useContext(Dm);
}
const km = Gt.createContext(void 0);
km.Consumer;
const _b = Object.prototype.hasOwnProperty, xg = {};
function Np(a, o) {
  const f = typeof a != "string" ? "sc" : mm(a);
  xg[f] = (xg[f] || 0) + 1;
  const v = f + "-" + jT(rh + f + xg[f]);
  return o ? o + "-" + v : v;
}
let Eg;
function Mp(a, o, f) {
  const v = wm(a), y = a, T = !Zd(a), { attrs: w = nv, componentId: O = Np(o.displayName, o.parentComponentId), displayName: _ = qT(a) } = o, z = o.displayName && o.componentId ? mm(o.displayName) + "-" + o.componentId : o.componentId || O, H = v && y.attrs ? y.attrs.concat(w).filter(Boolean) : w;
  let { shouldForwardProp: Z } = o;
  if (v && y.shouldForwardProp) {
    const K = y.shouldForwardProp;
    if (o.shouldForwardProp) {
      const he = o.shouldForwardProp;
      Z = (ye, de) => K(ye, de) && he(ye, de);
    } else Z = K;
  }
  const Y = new wp(f, z, v ? y.componentStyle : void 0);
  function ce(K, he) {
    return (function(ye, de, ze) {
      const { attrs: ke, componentStyle: pe, defaultProps: xe, foldedComponentIds: we, styledComponentId: Ce, target: Le } = ye, Ht = Gt.useContext(km), Et = _p(), Xt = ye.shouldForwardProp || Et.shouldForwardProp;
      nn.env.NODE_ENV !== "production" && Gt.useDebugValue && Gt.useDebugValue(Ce);
      const Ee = WT(de, Ht, xe) || Ls;
      let Ne, lt;
      {
        const et = Gt.useRef(null), re = et.current;
        if (re !== null && re[1] === Ee && re[2] === Et.styleSheet && re[3] === Et.stylis && re[7] === pe && (function(j, ut, qe) {
          const be = j, Oe = ut;
          let $e = 0;
          for (const Wt in Oe) if (_b.call(Oe, Wt) && ($e++, be[Wt] !== Oe[Wt])) return !1;
          return $e === qe;
        })(re[0], de, re[4])) Ne = re[5], lt = re[6];
        else {
          Ne = (function(ut, qe, be) {
            const Oe = Object.assign(Object.assign({}, qe), { className: void 0, theme: be }), $e = ut.length > 1;
            for (let Wt = 0; Wt < ut.length; Wt++) {
              const bt = ut[Wt], Gn = uh(bt) ? bt($e ? Object.assign({}, Oe) : Oe) : bt;
              for (const An in Gn) An === "className" ? Oe.className = Gf(Oe.className, Gn[An]) : An === "style" ? Oe.style = Object.assign(Object.assign({}, Oe.style), Gn[An]) : An in qe && qe[An] === void 0 || (Oe[An] = Gn[An]);
            }
            return "className" in qe && typeof qe.className == "string" && (Oe.className = Gf(Oe.className, qe.className)), Oe;
          })(ke, de, Ee), lt = (function(ut, qe, be, Oe) {
            const $e = ut.generateAndInjectStyles(qe, be, Oe);
            return nn.env.NODE_ENV !== "production" && Gt.useDebugValue && Gt.useDebugValue($e), $e;
          })(pe, Ne, Et.styleSheet, Et.stylis);
          let j = 0;
          for (const ut in de) _b.call(de, ut) && j++;
          et.current = [de, Ee, Et.styleSheet, Et.stylis, j, Ne, lt, pe];
        }
      }
      nn.env.NODE_ENV !== "production" && ye.warnTooManyClasses && ye.warnTooManyClasses(lt);
      const U = Ne.as || Le, Q = (function(et, re, j, ut) {
        const qe = {};
        for (const be in et) et[be] === void 0 || be[0] === "$" || be === "as" || be === "theme" && et.theme === j || (be === "forwardedAs" ? qe.as = et.forwardedAs : ut && !ut(be, re) || (qe[be] = et[be], ut || nn.env.NODE_ENV !== "development" || pT(be) || (Eg || (Eg = /* @__PURE__ */ new Set())).has(be) || !Zd(re) || re.includes("-") || (Eg.add(be), console.warn(`styled-components: it looks like an unknown prop "${be}" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via \`<StyleSheetManager shouldForwardProp={...}>\` (connect an API like \`@emotion/is-prop-valid\`) or consider using transient props (\`$\` prefix for automatic filtering.)`))));
        return qe;
      })(Ne, U, Ee, Xt);
      let Se = Gf(we, Ce);
      return lt && (Se += " " + lt), Ne.className && (Se += " " + Ne.className), Q[Zd(U) && U.includes("-") ? "class" : "className"] = Se, ze && (Q.ref = ze), m1(U, Q);
    })(le, K, he);
  }
  ce.displayName = _;
  let le = Gt.forwardRef(ce);
  return le.attrs = H, le.componentStyle = Y, le.displayName = _, le.shouldForwardProp = Z, le.foldedComponentIds = v ? Gf(y.foldedComponentIds, y.styledComponentId) : "", le.styledComponentId = z, le.target = v ? y.target : a, Object.defineProperty(le, "defaultProps", { get() {
    return this._foldedDefaultProps;
  }, set(K) {
    this._foldedDefaultProps = v ? (function(he, ...ye) {
      for (const de of ye) kg(he, de, !0);
      return he;
    })({}, y.defaultProps, K) : K;
  } }), nn.env.NODE_ENV !== "production" && (QT(_, z), le.warnTooManyClasses = /* @__PURE__ */ ((K, he) => {
    let ye = {}, de = !1;
    return (ze) => {
      !de && (ye[ze] = !0, Object.keys(ye).length >= 200) && (console.warn(`Over 200 classes were generated for component ${K}${he ? ` with the id of "${he}"` : ""}.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), de = !0, ye = {});
    };
  })(_, z)), Am(le, () => `.${le.styledComponentId}`), T && Em(le, a, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), le;
}
var zp = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "blockquote", "body", "button", "br", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "menu", "meter", "nav", "object", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "slot", "small", "span", "strong", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "switch", "symbol", "text", "textPath", "tspan", "use"]);
function Nb(a, o) {
  const f = [a[0]];
  for (let v = 0, y = o.length; v < y; v += 1) f.push(o[v], a[v + 1]);
  return f;
}
const Mb = (a) => (Cm.add(a), a);
function Dp(a, ...o) {
  if (uh(a) || Bo(a)) return Mb(zo(Nb(nv, [a, ...o])));
  const f = a;
  return o.length === 0 && f.length === 1 && typeof f[0] == "string" ? zo(f) : Mb(zo(Nb(f, o)));
}
function Hg(a, o, f = Ls) {
  if (!o) throw Wf(1, o);
  const v = (y, ...T) => a(o, f, Dp(y, ...T));
  return v.attrs = (y) => Hg(a, o, Object.assign(Object.assign({}, f), { attrs: Array.prototype.concat(f.attrs, y).filter(Boolean) })), v.withConfig = (y) => Hg(a, o, Object.assign(Object.assign({}, f), y)), v;
}
const Lm = (a) => Hg(Mp, a), $r = Lm;
zp.forEach((a) => {
  $r[a] = Lm(a);
});
nn.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://styled-components.com/docs/basics#react-native`);
const Ld = `__sc-${Lo}__`;
nn.env.NODE_ENV !== "production" && nn.env.NODE_ENV !== "test" && typeof window < "u" && (window[Ld] || (window[Ld] = 0), window[Ld] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://styled-components.com/docs/faqs#why-am-i-getting-a-warning-about-several-instances-of-module-on-the-page for more info.`), window[Ld] += 1);
const kp = $r.div`
  &.sticky {
    position: fixed;
    top: var(--uds-anchor-menu-top, 0px);
    left: 0;
    width: 100%;
  }
  .mobile-menu-toggler {
    background-color: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    text-align: inherit;
    i {
      transition: all 0.3s;
    }
  }
  .show-menu i {
    transform: rotate(-180deg);
  }
  .nav-link {
    border: none;
    background-color: #ffffff;
    i {
      width: 2rem !important;
      text-align: center !important;
    }
  }
`, Vd = "On This Page", Lp = {
  event: "collapse",
  name: "onclick",
  type: "click",
  text: Vd
}, Bm = ({
  items: a,
  firstElementId: o,
  focusFirstFocusableElement: f = !1
}) => {
  const { isReact: v, isBootstrap: y } = Uo(), T = Do(null), w = N1("(max-width: 991px)"), [O, _] = ua({
    hasHeader: !1,
    hasAltMenuSpacing: !1,
    containerClass: "container-xl",
    activeContainer: "",
    showMenu: !1,
    sticky: !1
  }), z = () => document.getElementById("asu-header") || document.getElementById("headerContainer") || document.getElementById("asuHeader"), H = () => {
    const pe = z();
    return Math.max((pe == null ? void 0 : pe.getBoundingClientRect().bottom) || 0, 0);
  }, Z = () => {
    var Et;
    const pe = {}, xe = window.scrollY, we = H(), Ce = (Et = document.getElementById(o)) == null ? void 0 : Et.getBoundingClientRect().top, Le = 103;
    Ce >= 0 && (pe.sticky = !1, pe.activeContainer = ""), xe > T.current.getBoundingClientRect().top && (pe.sticky = !0);
    const Ht = O.hasHeader ? we + Le : Le;
    a == null || a.forEach(({ targetIdName: Xt }) => {
      const Ee = document.getElementById(Xt), Ne = (Ee == null ? void 0 : Ee.getBoundingClientRect().top) - Ht, lt = (Ee == null ? void 0 : Ee.getBoundingClientRect().bottom) - Ht;
      Ne < 0 && lt > 0 && (pe.activeContainer = Xt);
    }), _((Xt) => ({
      ...Xt,
      ...pe
    }));
  }, Y = () => {
    _g(Z, 150), Ng(Z, 150);
  }, ce = () => !!z(), le = () => !!document.getElementById(
    "degreeDetailPageContainer"
  );
  function K(pe = null) {
    if (pe === null) return O.containerClass;
    const xe = Object.values(pe.classList).filter(
      (we) => [
        "container-sm",
        "container-md",
        "container",
        "container-lg",
        "container-xl",
        "container-fluid"
      ].includes(we)
    );
    return xe.length > 0 ? xe.join(" ") : K(pe.parentElement);
  }
  Da(() => {
    const pe = document.getElementById(o) || null, xe = {
      hasHeader: ce(),
      hasAltMenuSpacing: le(),
      containerClass: K(pe)
    };
    _((we) => ({
      ...we,
      ...xe
    }));
  }, []), Da(() => (window == null || window.addEventListener("scroll", Y), () => window.removeEventListener("scroll", Y)), [O.hasHeader]);
  const he = (pe) => {
    var Ht, Et;
    const xe = H(), we = window.scrollY - (O.hasHeader ? xe + 100 : 100), Ce = w ? 410 : 90;
    let Le = ((Ht = document.getElementById(pe)) == null ? void 0 : Ht.getBoundingClientRect().top) + we;
    T.current.classList.contains("sticky") || (Le -= Ce), f && ((Et = cT(`#${pe}`)) == null || Et.focus()), window.scrollTo({ top: Le, behavior: "smooth" });
  }, ye = () => {
    _((pe) => ({
      ...pe,
      showMenu: !pe.showMenu
    }));
  }, de = O.hasHeader ? H() : 0, ze = y ? "div" : kp, ke = y ? {} : {
    // @ts-ignore
    requiresAltMenuSpacing: O.hasAltMenuSpacing
  };
  return (a == null ? void 0 : a.length) > 0 && /* @__PURE__ */ A.jsx(
    ze,
    {
      ...ke,
      ref: T,
      id: "uds-anchor-menu",
      className: Rt(
        "uds-anchor-menu",
        "uds-anchor-menu-expanded-lg",
        "mb-4",
        {
          sticky: O.sticky,
          "with-header": O.hasHeader
        }
      ),
      style: (
        /** @type {React.CSSProperties} */
        {
          ...O.showMenu ? { borderBottom: 0 } : {},
          "--uds-anchor-menu-top": `${de}px`
        }
      ),
      children: /* @__PURE__ */ A.jsxs("div", { className: `${O.containerClass} uds-anchor-menu-wrapper`, children: [
        /* @__PURE__ */ A.jsx("h2", { children: w ? /* @__PURE__ */ A.jsx(
          yl,
          {
            gaData: {
              ...Lp,
              action: O.showMenu ? "close" : "open"
            },
            children: /* @__PURE__ */ A.jsxs(
              "button",
              {
                className: Rt("mobile-menu-toggler", {
                  "show-menu": O.showMenu
                }),
                type: "button",
                onClick: ye,
                "data-bs-toggle": "collapse",
                "data-bs-target": "#collapseAnchorMenu",
                "aria-controls": "collapseAnchorMenu",
                "aria-expanded": O.showMenu,
                children: [
                  Vd,
                  ":",
                  /* @__PURE__ */ A.jsx("i", { className: "fas fa-chevron-down" })
                ]
              }
            )
          }
        ) : /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
          Vd,
          ":"
        ] }) }),
        /* @__PURE__ */ A.jsx(
          "div",
          {
            "data-testid": "anchor-menu-container",
            id: "collapseAnchorMenu",
            className: Rt("card", "card-body", "collapse", {
              show: O.showMenu
            }),
            children: /* @__PURE__ */ A.jsx(
              "nav",
              {
                "data-testid": "anchor-menu",
                className: "nav",
                "aria-label": Vd,
                children: a == null ? void 0 : a.map((pe) => (
                  // Use this package button
                  // @ts-ignore
                  /* @__PURE__ */ A.jsx(
                    $c,
                    {
                      "data-testid": `anchor-item-${pe.targetIdName}`,
                      classes: Rt("nav-link", {
                        active: O.activeContainer === pe.targetIdName
                      }).split(" "),
                      ariaLabel: pe.text,
                      label: pe.text,
                      icon: pe.icon,
                      onClick: v && (() => he(pe.targetIdName)),
                      href: y && `#${pe.targetIdName}`
                    },
                    pe.targetIdName
                  )
                ))
              }
            )
          }
        )
      ] })
    }
  );
};
Bm.propTypes = {
  /**
   * Anchor menu items
   */
  items: E.arrayOf(
    E.shape({
      text: E.string.isRequired,
      targetIdName: E.string.isRequired,
      icon: E.arrayOf(E.string)
    })
  ).isRequired,
  /**
   * First next sibling element of the anchor menu
   */
  firstElementId: E.string.isRequired,
  /**
   * If true it focus the first focusable element into the section
   * If false it focus the next menu item into the nav bar
   */
  focusFirstFocusableElement: E.bool
};
var Ug = function() {
  return Ug = Object.assign || function(a) {
    for (var o, f = 1, v = arguments.length; f < v; f++) {
      o = arguments[f];
      for (var y in o) Object.prototype.hasOwnProperty.call(o, y) && (a[y] = o[y]);
    }
    return a;
  }, Ug.apply(this, arguments);
}, Bp = function(a, o) {
  var f = {};
  for (var v in a) Object.prototype.hasOwnProperty.call(a, v) && o.indexOf(v) < 0 && (f[v] = a[v]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var y = 0, v = Object.getOwnPropertySymbols(a); y < v.length; y++)
      o.indexOf(v[y]) < 0 && Object.prototype.propertyIsEnumerable.call(a, v[y]) && (f[v[y]] = a[v[y]]);
  return f;
};
function oh(a) {
  var o = function(f) {
    var v = f.bgStyle, y = f.borderRadius, T = f.iconFillColor, w = f.round, O = f.size, _ = Bp(f, ["bgStyle", "borderRadius", "iconFillColor", "round", "size"]);
    return Gt.createElement(
      "svg",
      Ug({ viewBox: "0 0 64 64", width: O, height: O }, _),
      w ? Gt.createElement("circle", { cx: "32", cy: "32", r: "31", fill: a.color, style: v }) : Gt.createElement("rect", { width: "64", height: "64", rx: y, ry: y, fill: a.color, style: v }),
      Gt.createElement("path", { d: a.path, fill: T })
    );
  };
  return o.defaultProps = {
    bgStyle: {},
    borderRadius: 0,
    iconFillColor: "white",
    size: 64
  }, o;
}
var Hp = oh({
  color: "#7f7f7f",
  path: "M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z"
});
function sh(a) {
  var o = Object.entries(a).filter(function(f) {
    var v = f[1];
    return v != null;
  }).map(function(f) {
    var v = f[0], y = f[1];
    return "".concat(encodeURIComponent(v), "=").concat(encodeURIComponent(String(y)));
  });
  return o.length > 0 ? "?".concat(o.join("&")) : "";
}
var Up = /* @__PURE__ */ (function() {
  var a = function(o, f) {
    return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, y) {
      v.__proto__ = y;
    } || function(v, y) {
      for (var T in y) Object.prototype.hasOwnProperty.call(y, T) && (v[T] = y[T]);
    }, a(o, f);
  };
  return function(o, f) {
    if (typeof f != "function" && f !== null)
      throw new TypeError("Class extends value " + String(f) + " is not a constructor or null");
    a(o, f);
    function v() {
      this.constructor = o;
    }
    o.prototype = f === null ? Object.create(f) : (v.prototype = f.prototype, new v());
  };
})(), Xu = function() {
  return Xu = Object.assign || function(a) {
    for (var o, f = 1, v = arguments.length; f < v; f++) {
      o = arguments[f];
      for (var y in o) Object.prototype.hasOwnProperty.call(o, y) && (a[y] = o[y]);
    }
    return a;
  }, Xu.apply(this, arguments);
}, Fp = function(a, o, f, v) {
  function y(T) {
    return T instanceof f ? T : new f(function(w) {
      w(T);
    });
  }
  return new (f || (f = Promise))(function(T, w) {
    function O(H) {
      try {
        z(v.next(H));
      } catch (Z) {
        w(Z);
      }
    }
    function _(H) {
      try {
        z(v.throw(H));
      } catch (Z) {
        w(Z);
      }
    }
    function z(H) {
      H.done ? T(H.value) : y(H.value).then(O, _);
    }
    z((v = v.apply(a, o || [])).next());
  });
}, Yp = function(a, o) {
  var f = { label: 0, sent: function() {
    if (T[0] & 1) throw T[1];
    return T[1];
  }, trys: [], ops: [] }, v, y, T, w;
  return w = { next: O(0), throw: O(1), return: O(2) }, typeof Symbol == "function" && (w[Symbol.iterator] = function() {
    return this;
  }), w;
  function O(z) {
    return function(H) {
      return _([z, H]);
    };
  }
  function _(z) {
    if (v) throw new TypeError("Generator is already executing.");
    for (; f; ) try {
      if (v = 1, y && (T = z[0] & 2 ? y.return : z[0] ? y.throw || ((T = y.return) && T.call(y), 0) : y.next) && !(T = T.call(y, z[1])).done) return T;
      switch (y = 0, T && (z = [z[0] & 2, T.value]), z[0]) {
        case 0:
        case 1:
          T = z;
          break;
        case 4:
          return f.label++, { value: z[1], done: !1 };
        case 5:
          f.label++, y = z[1], z = [0];
          continue;
        case 7:
          z = f.ops.pop(), f.trys.pop();
          continue;
        default:
          if (T = f.trys, !(T = T.length > 0 && T[T.length - 1]) && (z[0] === 6 || z[0] === 2)) {
            f = 0;
            continue;
          }
          if (z[0] === 3 && (!T || z[1] > T[0] && z[1] < T[3])) {
            f.label = z[1];
            break;
          }
          if (z[0] === 6 && f.label < T[1]) {
            f.label = T[1], T = z;
            break;
          }
          if (T && f.label < T[2]) {
            f.label = T[2], f.ops.push(z);
            break;
          }
          T[2] && f.ops.pop(), f.trys.pop();
          continue;
      }
      z = o.call(a, f);
    } catch (H) {
      z = [6, H], y = 0;
    } finally {
      v = T = 0;
    }
    if (z[0] & 5) throw z[1];
    return { value: z[0] ? z[1] : void 0, done: !0 };
  }
}, Hm = function(a, o) {
  var f = {};
  for (var v in a) Object.prototype.hasOwnProperty.call(a, v) && o.indexOf(v) < 0 && (f[v] = a[v]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var y = 0, v = Object.getOwnPropertySymbols(a); y < v.length; y++)
      o.indexOf(v[y]) < 0 && Object.prototype.propertyIsEnumerable.call(a, v[y]) && (f[v[y]] = a[v[y]]);
  return f;
}, Gp = function(a) {
  return !!a && (typeof a == "object" || typeof a == "function") && typeof a.then == "function";
}, Xp = function(a, o) {
  return {
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - a / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - o / 2
  };
}, Ip = function(a, o) {
  return {
    top: (window.screen.height - o) / 2,
    left: (window.screen.width - a) / 2
  };
};
function Zp(a, o, f) {
  var v = o.height, y = o.width, T = Hm(o, ["height", "width"]), w = Xu({ height: v, width: y, location: "no", toolbar: "no", status: "no", directories: "no", menubar: "no", scrollbars: "yes", resizable: "no", centerscreen: "yes", chrome: "yes" }, T), O = window.open(a, "", Object.keys(w).map(function(z) {
    return "".concat(z, "=").concat(w[z]);
  }).join(", "));
  if (f)
    var _ = window.setInterval(function() {
      try {
        (O === null || O.closed) && (window.clearInterval(_), f(O));
      } catch (z) {
        console.error(z);
      }
    }, 1e3);
  return O;
}
var Vp = (
  /** @class */
  (function(a) {
    Up(o, a);
    function o() {
      var f = a !== null && a.apply(this, arguments) || this;
      return f.openShareDialog = function(v) {
        var y = f.props, T = y.onShareWindowClose, w = y.windowHeight, O = w === void 0 ? 400 : w, _ = y.windowPosition, z = _ === void 0 ? "windowCenter" : _, H = y.windowWidth, Z = H === void 0 ? 550 : H, Y = Xu({ height: O, width: Z }, z === "windowCenter" ? Xp(Z, O) : Ip(Z, O));
        Zp(v, Y, T);
      }, f.handleClick = function(v) {
        return Fp(f, void 0, void 0, function() {
          var y, T, w, O, _, z, H, Z, Y, ce;
          return Yp(this, function(le) {
            switch (le.label) {
              case 0:
                return y = this.props, T = y.beforeOnClick, w = y.disabled, O = y.networkLink, _ = y.onClick, z = y.url, H = y.openShareDialogOnClick, Z = y.opts, Y = O(z, Z), w ? [
                  2
                  /*return*/
                ] : (v.preventDefault(), T ? (ce = T(), Gp(ce) ? [4, ce] : [3, 2]) : [3, 2]);
              case 1:
                le.sent(), le.label = 2;
              case 2:
                return H && this.openShareDialog(Y), _ && _(v, Y), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, f;
    }
    return o.prototype.render = function() {
      var f = this.props;
      f.beforeOnClick;
      var v = f.children, y = f.className, T = f.disabled, w = f.disabledStyle, O = f.forwardedRef;
      f.networkLink;
      var _ = f.networkName;
      f.onShareWindowClose, f.openShareDialogOnClick, f.opts;
      var z = f.resetButtonStyle, H = f.style;
      f.url, f.windowHeight, f.windowPosition, f.windowWidth;
      var Z = Hm(f, ["beforeOnClick", "children", "className", "disabled", "disabledStyle", "forwardedRef", "networkLink", "networkName", "onShareWindowClose", "openShareDialogOnClick", "opts", "resetButtonStyle", "style", "url", "windowHeight", "windowPosition", "windowWidth"]), Y = Rt("react-share__ShareButton", {
        "react-share__ShareButton--disabled": !!T,
        disabled: !!T
      }, y), ce = Xu(Xu(z ? { backgroundColor: "transparent", border: "none", padding: 0, font: "inherit", color: "inherit", cursor: "pointer" } : {}, H), T && w);
      return Gt.createElement("button", Xu({}, Z, { "aria-label": Z["aria-label"] || _, className: Y, onClick: this.handleClick, ref: O, style: ce }), v);
    }, o.defaultProps = {
      disabledStyle: { opacity: 0.6 },
      openShareDialogOnClick: !0,
      resetButtonStyle: !0
    }, o;
  })(T1)
), qd = function() {
  return qd = Object.assign || function(a) {
    for (var o, f = 1, v = arguments.length; f < v; f++) {
      o = arguments[f];
      for (var y in o) Object.prototype.hasOwnProperty.call(o, y) && (a[y] = o[y]);
    }
    return a;
  }, qd.apply(this, arguments);
};
function fh(a, o, f, v) {
  function y(T, w) {
    var O = f(T), _ = qd({}, T), z = Object.keys(O);
    return z.forEach(function(H) {
      delete _[H];
    }), Gt.createElement(Vp, qd({}, v, _, { forwardedRef: w, networkName: a, networkLink: o, opts: f(T) }));
  }
  return y.displayName = "ShareButton-".concat(a), p1(y);
}
function Qp(a, o) {
  var f = o.subject, v = o.body, y = o.separator;
  return "mailto:" + sh({ subject: f, body: v ? v + y + a : a });
}
var Wp = fh("email", Qp, function(a) {
  return {
    subject: a.subject,
    body: a.body,
    separator: a.separator || " "
  };
}, {
  openShareDialogOnClick: !1,
  onClick: function(a, o) {
    window.location.href = o;
  }
}), zb = oh({
  color: "#3b5998",
  path: "M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z"
}), Pp = /* @__PURE__ */ (function() {
  var a = function(o, f) {
    return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, y) {
      v.__proto__ = y;
    } || function(v, y) {
      for (var T in y) Object.prototype.hasOwnProperty.call(y, T) && (v[T] = y[T]);
    }, a(o, f);
  };
  return function(o, f) {
    if (typeof f != "function" && f !== null)
      throw new TypeError("Class extends value " + String(f) + " is not a constructor or null");
    a(o, f);
    function v() {
      this.constructor = o;
    }
    o.prototype = f === null ? Object.create(f) : (v.prototype = f.prototype, new v());
  };
})(), Jp = (
  /** @class */
  (function(a) {
    Pp(o, a);
    function o(f) {
      var v = a.call(this, f) || this;
      return v.name = "AssertionError", v;
    }
    return o;
  })(Error)
);
function Zf(a, o) {
  if (!a)
    throw new Jp(o);
}
function Kp(a, o) {
  var f = o.quote, v = o.hashtag;
  return Zf(a, "facebook.url"), "https://www.facebook.com/sharer/sharer.php" + sh({
    u: a,
    quote: f,
    hashtag: v
  });
}
var Db = fh("facebook", Kp, function(a) {
  return {
    quote: a.quote,
    hashtag: a.hashtag
  };
}, {
  windowWidth: 550,
  windowHeight: 400
}), kb = oh({
  color: "#007fb1",
  path: "M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z"
});
function jp(a, o) {
  var f = o.title, v = o.summary, y = o.source;
  return Zf(a, "linkedin.url"), "https://linkedin.com/shareArticle" + sh({ url: a, mini: "true", title: f, summary: v, source: y });
}
var Lb = fh("linkedin", jp, function(a) {
  var o = a.title, f = a.summary, v = a.source;
  return { title: o, summary: f, source: v };
}, {
  windowWidth: 750,
  windowHeight: 600
}), Bb = oh({
  color: "#00aced",
  path: "M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z"
});
function qp(a, o) {
  var f = o.title, v = o.via, y = o.hashtags, T = y === void 0 ? [] : y, w = o.related, O = w === void 0 ? [] : w;
  return Zf(a, "twitter.url"), Zf(Array.isArray(T), "twitter.hashtags is not an array"), Zf(Array.isArray(O), "twitter.related is not an array"), "https://twitter.com/share" + sh({
    url: a,
    text: f,
    via: v,
    hashtags: T.length > 0 ? T.join(",") : void 0,
    related: O.length > 0 ? O.join(",") : void 0
  });
}
var Hb = fh("twitter", qp, function(a) {
  return {
    hashtags: a.hashtags,
    title: a.title,
    via: a.via,
    related: a.related
  };
}, {
  windowWidth: 550,
  windowHeight: 400
});
function Fg(a) {
  "@babel/helpers - typeof";
  return Fg = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, Fg(a);
}
var $p;
function Yg() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $p;
  return o ? a.split(" ").map(function(f) {
    return o[f] || f;
  }).join(" ") : a;
}
var eS = (typeof window > "u" ? "undefined" : Fg(window)) === "object" && window.Element || function() {
};
function tS(a, o, f) {
  if (!(a[o] instanceof eS))
    return new Error("Invalid prop `" + o + "` supplied to `" + f + "`. Expected prop to be an instance of Element. Validation failed.");
}
E.oneOfType([E.string, E.func, tS, E.shape({
  current: E.any
})]);
var Gg = E.oneOfType([E.func, E.string, E.shape({
  $$typeof: E.symbol,
  render: E.func
}), E.arrayOf(E.oneOfType([E.func, E.string, E.shape({
  $$typeof: E.symbol,
  render: E.func
})]))]), nS = ["className", "listClassName", "cssModule", "children", "tag", "listTag", "aria-label"];
function Xg() {
  return Xg = Object.assign ? Object.assign.bind() : function(a) {
    for (var o = 1; o < arguments.length; o++) {
      var f = arguments[o];
      for (var v in f)
        Object.prototype.hasOwnProperty.call(f, v) && (a[v] = f[v]);
    }
    return a;
  }, Xg.apply(this, arguments);
}
function lS(a, o) {
  if (a == null) return {};
  var f = aS(a, o), v, y;
  if (Object.getOwnPropertySymbols) {
    var T = Object.getOwnPropertySymbols(a);
    for (y = 0; y < T.length; y++)
      v = T[y], !(o.indexOf(v) >= 0) && Object.prototype.propertyIsEnumerable.call(a, v) && (f[v] = a[v]);
  }
  return f;
}
function aS(a, o) {
  if (a == null) return {};
  var f = {}, v = Object.keys(a), y, T;
  for (T = 0; T < v.length; T++)
    y = v[T], !(o.indexOf(y) >= 0) && (f[y] = a[y]);
  return f;
}
var iS = {
  /** Aria label */
  "aria-label": E.string,
  /** Pass children so this component can wrap them */
  children: E.node,
  /** Add custom class */
  className: E.string,
  /** Change existing className with a new className */
  cssModule: E.object,
  /** Add custom class to list tag */
  listClassName: E.string,
  /** Set a custom element for list tag */
  listTag: Gg,
  /** Set a custom element for this component */
  tag: Gg
};
function Um(a) {
  var o = a.className, f = a.listClassName, v = a.cssModule, y = a.children, T = a.tag, w = T === void 0 ? "nav" : T, O = a.listTag, _ = O === void 0 ? "ol" : O, z = a["aria-label"], H = z === void 0 ? "breadcrumb" : z, Z = lS(a, nS), Y = Yg(Rt(o), v), ce = Yg(Rt("breadcrumb", f), v);
  return /* @__PURE__ */ Gt.createElement(w, Xg({}, Z, {
    className: Y,
    "aria-label": H
  }), /* @__PURE__ */ Gt.createElement(_, {
    className: ce
  }, y));
}
Um.propTypes = iS;
var rS = ["className", "cssModule", "active", "tag"];
function Ig() {
  return Ig = Object.assign ? Object.assign.bind() : function(a) {
    for (var o = 1; o < arguments.length; o++) {
      var f = arguments[o];
      for (var v in f)
        Object.prototype.hasOwnProperty.call(f, v) && (a[v] = f[v]);
    }
    return a;
  }, Ig.apply(this, arguments);
}
function uS(a, o) {
  if (a == null) return {};
  var f = cS(a, o), v, y;
  if (Object.getOwnPropertySymbols) {
    var T = Object.getOwnPropertySymbols(a);
    for (y = 0; y < T.length; y++)
      v = T[y], !(o.indexOf(v) >= 0) && Object.prototype.propertyIsEnumerable.call(a, v) && (f[v] = a[v]);
  }
  return f;
}
function cS(a, o) {
  if (a == null) return {};
  var f = {}, v = Object.keys(a), y, T;
  for (T = 0; T < v.length; T++)
    y = v[T], !(o.indexOf(y) >= 0) && (f[y] = a[y]);
  return f;
}
var oS = {
  /** Adds a visual "active" state to a Breadcrumb Item */
  active: E.bool,
  /** Add custom class to the element */
  className: E.string,
  /** Change existing className with a new className */
  cssModule: E.object,
  /** Set a custom element for this component */
  tag: Gg
};
function Zg(a) {
  var o = a.className, f = a.cssModule, v = a.active, y = a.tag, T = y === void 0 ? "li" : y, w = uS(a, rS), O = Yg(Rt(o, v ? "active" : !1, "breadcrumb-item"), f);
  return /* @__PURE__ */ Gt.createElement(T, Ig({}, w, {
    className: O,
    "aria-current": v ? "page" : void 0
  }));
}
Zg.propTypes = oS;
const sS = $r.div`
  &.news-container h2 {
    font-size: 48px;
  }

  &.event-container h2 {
    font-size: 40px;
  }

  &.news-container img,
  &.event-container img {
    width: 100%;
    max-width: fit-content;
  }

  &.wrapper-container h4 {
    margin-top: 0;
  }

  &.wrapper-container {
    max-width: 1300px;
    margin: 0 auto;
    padding: 0 10%;
  }

  &.event-container.wrapper-container {
    max-width: 1500px;
  }

  &.news-container {
    background: #fff;
  }

  ol.breadcrumb {
    padding: 0;
    margin: 0;
  }

  ol.breadcrumb > li {
    margin-bottom: 0;
  }

  .article-social-media {
    margin-bottom: 24px;
  }

  .react-share__ShareButton {
    margin-right: 12px;
  }

  i.news-date {
    display: inline-block;
    margin-bottom: 24px;
  }

  .highlight-gold {
    box-shadow:
      -0.15em 0 0 #ffc627,
      0.15em 0 0 #ffc627;
    background: #ffc627;
  }

  .author {
    display: inline-block;
    margin-top: 30px;
    margin-left: -7px;
    padding: 0 6px;
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
  }

  .icon-bg {
    display: inline-block;
    position: relative;
    padding: 1px 3.5px;
    background-color: maroon;
    margin-right: 4px;
    border-radius: 4px;
    color: white;
    font-size: 0.65rem;
  }

  .uds-button {
    margin-top: 17px;
    padding: 0;
  }

  .author-title {
    max-width: 250px;
    margin-top: 10px;
    margin-bottom: 11px;
    font-size: 16px;
  }

  .author-contact {
    margin-top: 4px;
    font-size: 14px;
    font-weight: 500;
  }

  ol.breadcrumb a {
    text-decoration: none;
  }

  i.fa-calendar,
  i.fa-map-marker-alt {
    font-size: 1.17rem;
    margin-right: 8px;
  }

  .event-author {
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
  }

  .event-author-title {
    margin-top: 4px;
  }

  .event-author-info {
    margin-top: 24px;
  }
`, fS = $r.div`
  border-top: 1px solid black;
  h4 {
    margin-top: 0;
  }
  .react-share__ShareButton {
    margin-right: 24px;
  }
`, Fm = ({
  type: a = "news",
  articleUrl: o,
  publicationDate: f,
  title: v,
  body: y,
  authorEmail: T,
  authorName: w,
  authorPhone: O,
  authorTitle: _,
  breadcrumbs: z,
  calendarUrl: H,
  eventLocation: Z,
  eventTime: Y,
  headerImageUrl: ce,
  registrationUrl: le,
  zoomUrl: K
}) => {
  const he = Rt("col", "col-12", {
    "col-lg-8": a === "event" && (le || K || H)
  }), ye = () => le ? /* @__PURE__ */ A.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ A.jsx($c, { color: "maroon", href: le, label: "Register" }) }) : /* @__PURE__ */ A.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ A.jsx($c, { color: "maroon", href: K, label: "Attend on Zoom" }) }), de = () => /* @__PURE__ */ A.jsx("div", { className: "row pb-2", "data-testid": "author-info", children: /* @__PURE__ */ A.jsxs("div", { className: "col col-12", children: [
    /* @__PURE__ */ A.jsx("div", { className: "author highlight-gold", children: w }),
    _ && /* @__PURE__ */ A.jsx("div", { className: "author-title", children: _ }),
    T && /* @__PURE__ */ A.jsxs("div", { className: "author-contact", children: [
      /* @__PURE__ */ A.jsx("span", { className: "icon-bg", children: /* @__PURE__ */ A.jsx("i", { className: "fas fa-envelope" }) }),
      /* @__PURE__ */ A.jsx("a", { href: `mailto: ${T}`, children: T })
    ] }),
    O && /* @__PURE__ */ A.jsxs("div", { className: "author-contact", children: [
      /* @__PURE__ */ A.jsx("span", { className: "icon-bg", children: /* @__PURE__ */ A.jsx("i", { className: "fas fa-phone" }) }),
      /* @__PURE__ */ A.jsx("a", { href: `tel: ${O}`, children: O })
    ] })
  ] }) }), ze = () => /* @__PURE__ */ A.jsxs(
    fS,
    {
      className: "row row-spaced mt-3 pt-6 pb-2 event-info",
      "data-testid": "event-info",
      children: [
        /* @__PURE__ */ A.jsxs("div", { className: "col col-lg-4 col-md-6 col-12", children: [
          /* @__PURE__ */ A.jsx("h4", { children: "For more information contact:" }),
          /* @__PURE__ */ A.jsx("div", { className: "event-author", children: w }),
          /* @__PURE__ */ A.jsx("div", { className: "event-author-title", children: _ }),
          (T || O) && /* @__PURE__ */ A.jsxs("div", { className: "event-author-info", children: [
            T && /* @__PURE__ */ A.jsx("div", { children: /* @__PURE__ */ A.jsx("a", { href: `mailto: ${T}`, children: T }) }),
            O && /* @__PURE__ */ A.jsx("div", { children: /* @__PURE__ */ A.jsx("a", { href: `tel: ${O}`, children: O }) })
          ] })
        ] }),
        /* @__PURE__ */ A.jsxs("div", { className: "col col-lg-4 col-md-6 col-12", children: [
          /* @__PURE__ */ A.jsx("h4", { children: "Share this event:" }),
          /* @__PURE__ */ A.jsxs("div", { className: "article-social-media", children: [
            /* @__PURE__ */ A.jsx(Db, { url: o, quote: v, children: /* @__PURE__ */ A.jsx(
              zb,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" },
                iconFillColor: "white"
              }
            ) }),
            /* @__PURE__ */ A.jsx(Hb, { url: o, quote: v, children: /* @__PURE__ */ A.jsx(
              Bb,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" },
                iconFillColor: "white"
              }
            ) }),
            /* @__PURE__ */ A.jsx(Wp, { url: T, quote: v, children: /* @__PURE__ */ A.jsx(
              Hp,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" },
                iconFillColor: "white"
              }
            ) }),
            /* @__PURE__ */ A.jsx(Lb, { url: o, quote: v, children: /* @__PURE__ */ A.jsx(
              kb,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" },
                iconFillColor: "white"
              }
            ) })
          ] })
        ] })
      ]
    }
  ), ke = () => /* @__PURE__ */ A.jsxs("div", { className: "col col-12 col-lg-4 col-md-6", children: [
    /* @__PURE__ */ A.jsxs("h4", { children: [
      /* @__PURE__ */ A.jsx("i", { className: "fas fa-map-marker-alt" }),
      "Location:"
    ] }),
    /* @__PURE__ */ A.jsx("div", { dangerouslySetInnerHTML: ka(Z) }),
    le && K && /* @__PURE__ */ A.jsx("a", { href: K, children: "Attend on Zoom" })
  ] }), pe = (xe) => /* @__PURE__ */ A.jsx(
    Zg,
    {
      active: xe.active,
      tag: "li",
      className: "breadcrumb-item",
      children: /* @__PURE__ */ A.jsx(Zg, { tag: "a", href: xe.url, children: xe.title })
    },
    xe.title
  );
  return /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
    ce && a !== "event" && /* @__PURE__ */ A.jsx(
      "div",
      {
        "data-testid": "uds-hero",
        className: "uds-hero uds-hero-md",
        style: {
          // @ts-ignore
          "--color1": "#19191900",
          "--color2": "#191919c9",
          // moved colors to variable because hex color in linear-gradient breaks react
          backgroundImage: `linear-gradient(180deg, var(--color1) 0%, var(--color2) 100%), url(${ce})`
        }
      }
    ),
    /* @__PURE__ */ A.jsxs(sS, { className: `container ${a}-container wrapper-container`, children: [
      z && /* @__PURE__ */ A.jsx("div", { className: "row pt-4", "data-testid": "breadcrumbs", children: /* @__PURE__ */ A.jsx("div", { className: "col col-12", children: /* @__PURE__ */ A.jsx(Um, { listClassName: "breadcrumb", children: z.map((xe) => pe(xe)) }) }) }),
      /* @__PURE__ */ A.jsxs("div", { className: "row pb-2 pt-3", children: [
        /* @__PURE__ */ A.jsx("div", { className: he, children: /* @__PURE__ */ A.jsx("h2", { "data-testid": "title", children: v }) }),
        a === "event" && /* @__PURE__ */ A.jsxs("div", { className: "col col-lg-4 col-xs-12", children: [
          (le || K) && ye(),
          H && /* @__PURE__ */ A.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ A.jsx(
            $c,
            {
              color: "gray",
              size: "small",
              href: H,
              label: "Add to calendar"
            }
          ) })
        ] })
      ] }),
      a === "event" ? /* @__PURE__ */ A.jsxs("div", { className: "row row-spaced pt-3 mb-2", children: [
        Y && /* @__PURE__ */ A.jsxs("div", { className: "col col-lg-4 col-md-6 col-sm-12", children: [
          /* @__PURE__ */ A.jsxs("h4", { children: [
            /* @__PURE__ */ A.jsx("i", { className: "far fa-calendar" }),
            "Date and time:"
          ] }),
          /* @__PURE__ */ A.jsx(
            "div",
            {
              dangerouslySetInnerHTML: ka(Y)
            }
          )
        ] }),
        (le && K || Z) && ke()
      ] }) : /* @__PURE__ */ A.jsx("div", { className: "row row-spaced pt-2", children: /* @__PURE__ */ A.jsxs("div", { className: "col col-12", children: [
        /* @__PURE__ */ A.jsxs("div", { className: "article-social-media", children: [
          /* @__PURE__ */ A.jsx(Db, { url: o, quote: v, children: /* @__PURE__ */ A.jsx(
            zb,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" },
              iconFillColor: "white"
            }
          ) }),
          /* @__PURE__ */ A.jsx(Hb, { url: o, quote: v, children: /* @__PURE__ */ A.jsx(
            Bb,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" },
              iconFillColor: "white"
            }
          ) }),
          /* @__PURE__ */ A.jsx(Lb, { url: o, quote: v, children: /* @__PURE__ */ A.jsx(
            kb,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" },
              iconFillColor: "white"
            }
          ) })
        ] }),
        f && /* @__PURE__ */ A.jsx("i", { className: "news-date", children: f })
      ] }) }),
      /* @__PURE__ */ A.jsx("div", { className: "row", children: /* @__PURE__ */ A.jsx(
        "div",
        {
          className: "col col-12",
          dangerouslySetInnerHTML: ka(y),
          "data-testid": "body"
        }
      ) }),
      a === "news" && de(),
      a === "event" && ze()
    ] })
  ] });
};
Fm.propTypes = {
  /**
   * Type of article
   */
  type: E.oneOf(["event", "news"]),
  /**
   * This is the relative or absolute url to the full-page article
   */
  articleUrl: E.string.isRequired,
  /**
   * Date for the article
   */
  publicationDate: E.string.isRequired,
  /**
   * Title
   */
  title: E.string.isRequired,
  /**
   * Body content for the article
   */
  body: E.string.isRequired,
  /**
   * Article author email
   */
  authorEmail: E.string,
  /**
   * Article author full name
   */
  authorName: E.string.isRequired,
  /**
   * Article author phone number
   */
  authorPhone: E.string,
  /**
   * Article author title
   */
  authorTitle: E.string,
  /**
   * Breadcrumbs array
   */
  breadcrumbs: E.arrayOf(
    E.shape({
      title: E.string,
      url: E.string,
      active: E.bool
    })
  ),
  /**
   * URL for an "add to calendar" button
   */
  calendarUrl: E.string,
  /**
   * Article image
   */
  headerImageUrl: E.string,
  /**
   * Event location
   */
  eventLocation: E.string,
  /**
   * Event time
   */
  eventTime: E.string,
  /**
   * URL for a registation button
   */
  registrationUrl: E.string,
  /**
   * URL for a Zoom button
   */
  zoomUrl: E.string
};
const dS = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, av = ({
  color: a = "gray",
  icon: o = void 0,
  innerRef: f = void 0,
  onClick: v = void 0,
  size: y = "small",
  cardTitle: T = "",
  className: w,
  gaData: O,
  ..._
}) => {
  const z = () => {
    v == null || v();
  };
  return /* @__PURE__ */ A.jsx(
    yl,
    {
      gaData: {
        ...dS,
        section: T,
        // @deprecated - remove at some point
        ...O,
        text: `${o == null ? void 0 : o[1]} icon`
      },
      children: /* @__PURE__ */ A.jsx(
        "button",
        {
          type: "button",
          className: `btn btn-circle btn-circle-alt-${a} ${y === "large" && "btn-circle-large"} ${w}`,
          ref: f,
          "aria-label": "Close",
          onClick: z,
          ..._,
          children: /* @__PURE__ */ A.jsx("i", { className: `${o == null ? void 0 : o[0]} fa-${o == null ? void 0 : o[1]}` })
        }
      )
    }
  );
};
av.propTypes = {
  /**
    Color the button based on the background color
  */
  color: E.oneOf(["white", "gray", "black"]),
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: E.arrayOf(E.string),
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: E.oneOfType([
    E.object,
    E.func,
    E.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: E.func,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: E.string,
  /**
   * Google Analytics event data
   */
  gaData: qg,
  /**
    Button size
  */
  size: E.oneOf(["large", "small"]),
  className: E.string
};
const hS = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, iv = ({
  label: a = "",
  cardTitle: o = "",
  gaData: f,
  ariaLabel: v,
  color: y = "gray",
  disabled: T,
  element: w = "button",
  innerRef: O,
  href: _,
  onClick: z,
  ...H
}) => {
  const Z = Rt("btn", "btn-tag", {
    "btn-tag-alt-white": y === "white",
    "btn-tag-alt-gray": y === "gray",
    "btn-tag-alt-dark": y === "dark",
    disabled: T
  });
  let Y = w;
  return _ && w === "button" && (Y = "a"), /* @__PURE__ */ A.jsx(
    yl,
    {
      gaData: {
        ...hS,
        section: o,
        // @deprecated - remove at some point
        ...f,
        text: a
      },
      children: /* @__PURE__ */ A.jsx(
        Y,
        {
          type: Y === "button" && z ? "button" : void 0,
          ...H,
          className: Z,
          href: _,
          ref: O,
          onClick: z,
          "aria-label": v,
          children: a
        }
      )
    }
  );
};
iv.propTypes = {
  /**
    Button tag label
  */
  label: E.string,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: E.string,
  /**
   * Google Analytics event data
   */
  gaData: qg,
  /**
    ARIA label for accessibility
  */
  ariaLabel: E.string,
  /**
    Button background color
  */
  color: E.oneOf(["white", "gray", "dark"]),
  /**
    Disable the button?
  */
  disabled: E.bool,
  /**
    Pass in a Component to override default button element.
    For example: react-router Link
  */
  element: E.oneOfType([
    E.func,
    E.string,
    E.shape({ $$typeof: E.symbol, render: E.func }),
    E.arrayOf(
      E.oneOfType([
        E.func,
        E.string,
        E.shape({ $$typeof: E.symbol, render: E.func })
      ])
    )
  ]),
  /**
    Link target url; will cause button to be rendered as `<a>` link
  */
  href: E.string,
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: E.oneOfType([
    E.object,
    E.func,
    E.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: E.func
};
const Ho = ({
  src: a,
  alt: o,
  cssClasses: f,
  loading: v = "lazy",
  decoding: y = "async",
  dataTestId: T,
  fetchPriority: w = "auto",
  width: O,
  height: _,
  cardLink: z,
  title: H,
  caption: Z,
  captionTitle: Y,
  border: ce,
  dropShadow: le
}) => {
  const K = {
    src: a,
    alt: o,
    loading: v,
    decoding: y,
    fetchpriority: w,
    // React attribute bug workaround
    ...(f == null ? void 0 : f.length) > 0 && { className: Ud(f) },
    ...T && { "data-testid": T },
    ...O && { width: O },
    ..._ && { height: _ }
  }, he = Rt("uds-img", {
    borderless: !ce,
    "uds-img-drop-shadow": le
  }), ye = (ze) => {
    const ke = ze ? `${K.className} ${ze}` : K.className;
    return z ? /* @__PURE__ */ A.jsxs("a", { href: z, children: [
      /* @__PURE__ */ A.jsx("img", { ...K, className: ke }),
      /* @__PURE__ */ A.jsx("span", { className: "visually-hidden", children: H })
    ] }) : /* @__PURE__ */ A.jsx("img", { ...K, className: ke });
  }, de = () => /* @__PURE__ */ A.jsx("div", { className: he, children: /* @__PURE__ */ A.jsxs("figure", { className: "figure uds-figure", children: [
    ye(),
    Z && /* @__PURE__ */ A.jsxs("figcaption", { className: "figure-caption uds-figure-caption", children: [
      Y && /* @__PURE__ */ A.jsx("h3", { children: Y }),
      /* @__PURE__ */ A.jsx(
        "span",
        {
          className: "uds-caption-text",
          dangerouslySetInnerHTML: ka(Z)
        }
      )
    ] })
  ] }) });
  return /* @__PURE__ */ A.jsx(A.Fragment, { children: Z ? de() : ye(he) });
};
Ho.propTypes = {
  /**
   * Image source (We keep the same name as in the whole project)
   */
  src: E.string.isRequired,
  /**
   * Image alt text
   */
  alt: E.string.isRequired,
  /**
   * Array classes for the image
   */
  cssClasses: E.arrayOf(E.string),
  /**
   * Image loading mode
   */
  loading: E.oneOf(["lazy", "eager"]),
  /**
   * Image decoding mode
   */
  decoding: E.oneOf(["sync", "async", "auto"]),
  /**
   * Image fetch priority mode
   */
  fetchPriority: E.oneOf(["auto", "high", "low"]),
  /**
   * Width of the image
   */
  width: E.string,
  /**
   * Height of the image
   */
  height: E.string,
  dataTestId: E.string,
  cardLink: E.string,
  title: E.string,
  caption: E.string,
  captionTitle: E.string,
  border: E.bool,
  dropShadow: E.bool
};
const gS = $r.div`
  &.cards-components a + &.cards-components a {
    margin-left: 5px;
  }
  .card-button {
    column-gap: 1rem;
  }
  .card-button .btn {
    margin: 0;
  }
`, vS = (a) => /^[A-Z0-9._+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(a), yS = (a) => !a.startsWith("https://") && !a.startsWith("http://") && vS(a) ? `mailto:${a}` : a, Ub = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Ym = (a) => a === "event" || a === "news", Iu = ({
  type: a = "default",
  width: o = "100%",
  horizontal: f = !1,
  image: v,
  imageAltText: y,
  title: T,
  icon: w,
  body: O,
  eventFormat: _ = "stack",
  eventLocation: z,
  eventTime: H,
  buttons: Z,
  linkLabel: Y,
  linkUrl: ce,
  tags: le,
  showBorders: K = !0,
  cardLink: he
}) => /* @__PURE__ */ A.jsx(
  Gm,
  {
    type: a,
    width: o,
    horizontal: f,
    image: v,
    imageAltText: y,
    title: T,
    icon: w,
    body: O,
    eventFormat: _,
    eventLocation: z,
    eventTime: H,
    buttons: Z,
    linkLabel: Y,
    linkUrl: ce,
    tags: le,
    showBorders: K,
    cardLink: he
  }
);
Iu.propTypes = {
  /**
   * Type of card
   */
  type: E.oneOf(["default", "degree", "event", "news", "story"]),
  /**
   * Width of card
   */
  width: E.oneOf(["25%", "50%", "75%", "100%"]),
  /**
   * Enable horizontal mode
   */
  horizontal: E.bool,
  /**
   * Card title
   */
  title: E.string.isRequired,
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: E.arrayOf(E.string),
  /**
   * Card body content
   */
  body: E.string,
  /**
   * Event info format
   */
  eventFormat: E.oneOf(["stack", "inline"]),
  /**
   * Location
   */
  eventLocation: E.string,
  /**
   * Event start time
   */
  eventTime: E.string,
  /**
   * Card header image
   */
  image: E.string,
  /**
   * Card header image alt text
   */
  imageAltText: E.string,
  /**
   * Buttons
   */
  buttons: E.arrayOf(
    E.shape({
      ariaLabel: E.string,
      color: E.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: E.arrayOf(E.string),
      href: E.string,
      label: E.string,
      onClick: E.func,
      size: E.oneOf(["default", "small", "xsmall"]),
      target: E.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: E.string,
  linkUrl: E.string,
  /**
   * Tags
   */
  tags: E.arrayOf(
    E.shape({
      ariaLabel: E.string,
      color: E.oneOf(["white", "gray", "dark"]),
      href: E.string,
      label: E.string,
      onClick: E.func
    })
  ),
  /**
   * Remove card borders
   */
  showBorders: E.bool,
  /**
   * Card link
   */
  cardLink: E.string
};
const Gm = ({
  type: a = "default",
  width: o = "100%",
  horizontal: f = !1,
  image: v = "",
  imageAltText: y = "",
  title: T,
  icon: w = void 0,
  body: O = "",
  eventFormat: _ = "stack",
  eventLocation: z = "",
  eventTime: H = "",
  buttons: Z = void 0,
  linkLabel: Y = void 0,
  linkUrl: ce = void 0,
  tags: le = void 0,
  showBorders: K = !0,
  cardLink: he
}) => {
  const ye = Rt("card", "cards-components", {
    "card-degree": a === "degree",
    "card-event": a === "event",
    "card-story": a === "story",
    "card-news": a === "news",
    [`w-${o.replace("%", "")}`]: o !== "100%",
    "card-horizontal": f,
    borderless: !K
  }), de = typeof v == "string" && v.length > 0, ze = !Ym(a);
  return /* @__PURE__ */ A.jsxs(gS, { className: ye, "data-testid": "card-container", children: [
    de && /* @__PURE__ */ A.jsx(
      Ho,
      {
        src: v,
        alt: y,
        dataTestId: "card-image",
        cssClasses: ["card-img-top"],
        title: T,
        cardLink: ze ? he : void 0
      }
    ),
    !v && w && /* @__PURE__ */ A.jsx(
      "i",
      {
        className: `${w == null ? void 0 : w[0]} fa-${w == null ? void 0 : w[1]} fa-2x card-icon-top`,
        "data-testid": "card-icon"
      }
    ),
    /* @__PURE__ */ A.jsx("div", { className: f ? "card-content-wrapper" : void 0, children: /* @__PURE__ */ A.jsx(
      Xm,
      {
        type: a,
        body: O,
        eventFormat: _,
        eventLocation: z,
        eventTime: H,
        title: T,
        buttons: Z,
        linkLabel: Y,
        linkUrl: ce,
        tags: le,
        cardLink: he
      }
    ) })
  ] });
};
Gm.propTypes = {
  type: E.oneOf(["default", "degree", "event", "news", "story"]),
  width: E.oneOf(["25%", "50%", "75%", "100%"]),
  horizontal: E.bool,
  title: E.string.isRequired,
  icon: E.arrayOf(E.string),
  // React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  body: E.string,
  eventFormat: E.oneOf(["stack", "inline"]),
  eventLocation: E.string,
  eventTime: E.string,
  image: E.string,
  imageAltText: E.string,
  buttons: E.arrayOf(
    E.shape({
      ariaLabel: E.string,
      color: E.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: E.arrayOf(E.string),
      href: E.string,
      label: E.string,
      onClick: E.func,
      size: E.oneOf(["default", "small", "xsmall"]),
      target: E.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: E.string,
  linkUrl: E.string,
  tags: E.arrayOf(
    E.shape({
      ariaLabel: E.string,
      color: E.oneOf(["white", "gray", "dark"]),
      href: E.string,
      label: E.string,
      onClick: E.func
    })
  ),
  showBorders: E.bool,
  cardLink: E.string
};
const Xm = ({
  type: a = "default",
  body: o = "",
  eventFormat: f = "stack",
  eventLocation: v = "",
  eventTime: y = "",
  title: T,
  buttons: w = void 0,
  linkLabel: O = void 0,
  linkUrl: _ = void 0,
  tags: z = void 0,
  cardLink: H
}) => {
  const Z = Ym(a), Y = H && !Z, ce = Z && H, le = a === "event" && (y || v);
  return /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
    T && /* @__PURE__ */ A.jsx("div", { className: "card-header", "data-testid": "card-title", children: /* @__PURE__ */ A.jsx("h3", { className: "card-title", children: Y ? /* @__PURE__ */ A.jsx("a", { href: H, children: T }) : T }) }),
    o && /* @__PURE__ */ A.jsx("div", { className: "card-body", "data-testid": "card-body", children: /* @__PURE__ */ A.jsx("div", { dangerouslySetInnerHTML: ka(o) }) }),
    le && /* @__PURE__ */ A.jsx(
      Im,
      {
        eventFormat: f,
        eventTime: y,
        eventLocation: v
      }
    ),
    ce ? /* @__PURE__ */ A.jsx("div", { className: "card-link", "data-testid": "card-link", children: /* @__PURE__ */ A.jsx(
      yl,
      {
        gaData: {
          ...Ub,
          text: T
        },
        children: /* @__PURE__ */ A.jsx("a", { href: H, className: "card-arrow-link", "aria-label": T, children: /* @__PURE__ */ A.jsx("i", { className: "fas fa-arrow-right", "aria-hidden": "true" }) })
      }
    ) }) : /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
      w && /* @__PURE__ */ A.jsx("div", { className: "card-buttons", children: w.map((K) => /* @__PURE__ */ A.jsx(
        "div",
        {
          className: "card-button",
          "data-testid": "card-button",
          children: /* @__PURE__ */ A.jsx(
            $c,
            {
              ariaLabel: K.ariaLabel,
              color: K.color,
              icon: K.icon,
              href: K.href,
              label: K.label,
              onClick: K.onClick,
              size: K.size,
              target: K.target,
              cardTitle: T
            }
          )
        },
        `${K.label}-${K.href}`
      )) }),
      _ && O && /* @__PURE__ */ A.jsx("div", { className: "card-link", "data-testid": "card-link", children: /* @__PURE__ */ A.jsx(
        yl,
        {
          gaData: {
            ...Ub,
            section: T,
            text: O
          },
          children: /* @__PURE__ */ A.jsx("a", { href: yS(_), children: O })
        }
      ) })
    ] }),
    z && /* @__PURE__ */ A.jsx("div", { className: "card-tags", "data-testid": "card-tags", children: z.map((K) => (
      // @ts-ignore
      /* @__PURE__ */ A.jsx(
        iv,
        {
          ariaLabel: K.ariaLabel,
          color: K.color,
          href: K.href,
          label: K.label,
          onClick: K.onClick,
          cardTitle: T
        },
        `${K.label}-${K.href}`
      )
    )) })
  ] });
};
Xm.propTypes = {
  type: E.oneOf(["default", "degree", "event", "news", "story"]),
  body: E.string,
  eventFormat: E.oneOf(["stack", "inline"]),
  eventLocation: E.string,
  eventTime: E.string,
  title: E.string.isRequired,
  buttons: E.arrayOf(
    E.shape({
      ariaLabel: E.string,
      color: E.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: E.arrayOf(E.string),
      href: E.string,
      label: E.string,
      onClick: E.func,
      size: E.oneOf(["default", "small", "xsmall"]),
      target: E.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: E.string,
  linkUrl: E.string,
  tags: E.arrayOf(
    E.shape({
      ariaLabel: E.string,
      color: E.oneOf(["white", "gray", "dark"]),
      href: E.string,
      label: E.string,
      onClick: E.func
    })
  ),
  cardLink: E.string
};
const Im = ({
  eventFormat: a = "stack",
  eventLocation: o = "",
  eventTime: f = ""
}) => a === "inline" ? /* @__PURE__ */ A.jsxs("div", { className: "card-event-details", children: [
  f && /* @__PURE__ */ A.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ A.jsx("div", { children: /* @__PURE__ */ A.jsx("i", { className: "far fa-calendar" }) }),
    /* @__PURE__ */ A.jsx("div", { dangerouslySetInnerHTML: ka(f) })
  ] }),
  o && /* @__PURE__ */ A.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ A.jsx("div", { children: /* @__PURE__ */ A.jsx("i", { className: "fas fa-map-marker-alt" }) }),
    /* @__PURE__ */ A.jsx(
      "div",
      {
        dangerouslySetInnerHTML: ka(o)
      }
    )
  ] })
] }) : /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
  f && /* @__PURE__ */ A.jsx("div", { className: "card-event-details", children: /* @__PURE__ */ A.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ A.jsx("div", { children: /* @__PURE__ */ A.jsx("i", { className: "far fa-calendar" }) }),
    /* @__PURE__ */ A.jsx("div", { dangerouslySetInnerHTML: ka(f) })
  ] }) }),
  o && /* @__PURE__ */ A.jsx("div", { className: "card-event-details", children: /* @__PURE__ */ A.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ A.jsx("div", { children: /* @__PURE__ */ A.jsx("i", { className: "fas fa-map-marker-alt" }) }),
    /* @__PURE__ */ A.jsx("span", { children: /* @__PURE__ */ A.jsx(
      "div",
      {
        dangerouslySetInnerHTML: ka(o)
      }
    ) })
  ] }) })
] });
Im.propTypes = {
  eventFormat: E.oneOf(["stack", "inline"]),
  eventLocation: E.string,
  eventTime: E.string
};
const Fb = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Yb = {
  OPEN: "open",
  CLOSE: "close"
}, bS = {
  SMALL: "small"
}, Zm = (a) => a === bS.SMALL, Vm = ({ imageSize: a, body: o, heading: f, readMoreLink: v }) => {
  const [y, T] = ua(!1), w = th(), { isReact: O, isBootstrap: _ } = Uo(), z = `info-layer-${w}`, H = Zm(a), Z = (Y) => {
    (Y.type === "click" || Y.key === "Enter" || Y.key === " ") && T(!y);
  };
  return /* @__PURE__ */ A.jsx(
    "div",
    {
      className: Rt("info-layer", { show: y }),
      "data-testid": "info-layer",
      id: z,
      children: /* @__PURE__ */ A.jsxs("div", { className: "content", children: [
        /* @__PURE__ */ A.jsxs(
          "div",
          {
            className: Rt("header", {
              closed: H && !y
            }),
            children: [
              H && /* @__PURE__ */ A.jsx("p", { dangerouslySetInnerHTML: ka(o) }),
              /* @__PURE__ */ A.jsx(
                yl,
                {
                  gaData: {
                    ...Fb,
                    text: "Expand ranking",
                    // TODO: for bootstrap can we use aria-expanded value of the button to populate the "action" field
                    action: y ? Yb.OPEN : Yb.CLOSE,
                    section: f
                  },
                  children: /* @__PURE__ */ A.jsxs(
                    "button",
                    {
                      "data-bs-toggle": _ && "collapse",
                      "data-bs-target": _ && `#${z}`,
                      onClick: O && Z,
                      className: Rt("btn-expand", {
                        btn: H
                      }),
                      type: "button",
                      "aria-expanded": y,
                      "aria-controls": z,
                      children: [
                        H ? /* @__PURE__ */ A.jsx("span", { className: "visually-hidden", children: f }) : /* @__PURE__ */ A.jsx("h4", { children: f }),
                        /* @__PURE__ */ A.jsx("i", { className: "fas fa-chevron-up" })
                      ]
                    }
                  )
                }
              )
            ]
          }
        ),
        !H && /* @__PURE__ */ A.jsx("p", { dangerouslySetInnerHTML: ka(o) }),
        v && /* @__PURE__ */ A.jsx(
          yl,
          {
            gaData: {
              ...Fb,
              section: f,
              text: "read more"
            },
            children: /* @__PURE__ */ A.jsxs("a", { href: v, className: "read-more", children: [
              "Read more ",
              /* @__PURE__ */ A.jsx("span", { className: "visually-hidden", children: f }),
              /* @__PURE__ */ A.jsx(
                "span",
                {
                  className: "fas icon-small fa-arrow-right",
                  "aria-hidden": "true"
                }
              )
            ] })
          }
        )
      ] })
    }
  );
};
Vm.propTypes = {
  imageSize: E.oneOf(["small", "large"]),
  body: E.string.isRequired,
  heading: E.string.isRequired,
  readMoreLink: E.string
};
const rv = ({
  imageSize: a = "large",
  image: o,
  imageAlt: f,
  heading: v,
  body: y,
  readMoreLink: T = "",
  citation: w
}) => {
  const O = Zm(a);
  return /* @__PURE__ */ A.jsxs(
    "div",
    {
      className: Rt("card-ranking", {
        "large-image": !O,
        "small-image": O
      }),
      children: [
        O ? /* @__PURE__ */ A.jsx("div", { className: "image-wrapper", children: /* @__PURE__ */ A.jsx(Ho, { src: o, alt: f, fetchPriority: "high" }) }) : /* @__PURE__ */ A.jsx(Ho, { src: o, alt: f, fetchPriority: "high" }),
        O && /* @__PURE__ */ A.jsxs("div", { className: "citation", children: [
          /* @__PURE__ */ A.jsx("h4", { children: v }),
          /* @__PURE__ */ A.jsxs("p", { children: [
            "— ",
            w
          ] })
        ] }),
        /* @__PURE__ */ A.jsx(
          Vm,
          {
            imageSize: a,
            body: y,
            heading: v,
            readMoreLink: T
          }
        )
      ]
    }
  );
};
rv.propTypes = {
  /**
   * Size of ranking card
   */
  imageSize: E.oneOf(["small", "large"]).isRequired,
  /**
   * Ranking card image
   */
  image: E.string.isRequired,
  /**
   * Card header image alt text
   */
  imageAlt: E.string.isRequired,
  /**
   * Ranking card heading
   */
  heading: E.string.isRequired,
  /**
   * Ranking card body content
   */
  body: E.string.isRequired,
  /**
   * Link for read more
   */
  readMoreLink: E.string,
  /**
   * Ranking card citation content (Required for small size only)
   */
  citation: E.string
};
const mS = {
  1: "col-12",
  2: "col-12 col-md-6",
  3: "col-12 col-md-6 col-lg-4",
  4: "col-12 col-md-6 col-lg-4 col-xl-3"
}, Qm = ({ cards: a, cardType: o = "card", columns: f }) => {
  if (!a || a.length === 0)
    return null;
  let v;
  switch (o) {
    case "ranking":
      v = rv;
      break;
    case "image":
      v = Ho;
      break;
    default:
      v = Iu;
      break;
  }
  const y = mS[f] || "col-12 col-md-auto";
  return /* @__PURE__ */ A.jsx("div", { className: "row", "data-testid": "card-arrangement", children: a.map((T, w) => /* @__PURE__ */ A.jsx(
    "div",
    {
      "data-testid": "uds-card-arrangement-content-container",
      className: `${T.horizontal ? "col-12 col-md-6" : y} mb-4`,
      children: /* @__PURE__ */ A.jsx(v, { ...T })
    },
    w
  )) });
};
Qm.propTypes = {
  /**
   * Array of card objects to render. Each object should contain props for the
   * Card or RankingCard component. Cards will wrap naturally based on their
   * intrinsic min/max widths.
   */
  cards: E.arrayOf(E.object).isRequired,
  /**
   * Type of card to render - either "card" (default), "ranking", or "image"
   */
  cardType: E.oneOf(["card", "ranking", "image"]),
  /**
   * Number of columns to display.
   */
  columns: E.oneOf([1, 2, 3, 4, "1", "2", "3", "4"])
};
const TS = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Wm = ({
  backgroundImage: a,
  icon: o,
  title: f,
  highlightText: v,
  description: y,
  button: T
}) => {
  const w = () => {
    if (!o) return null;
    let O = "";
    return Array.isArray(o) ? O = o.join(" ") : O = o.includes(" ") ? o : `fas fa-${o}`, /* @__PURE__ */ A.jsx("i", { className: O, "aria-hidden": "true" });
  };
  return /* @__PURE__ */ A.jsxs("div", { className: "content-spotlight", children: [
    /* @__PURE__ */ A.jsx("div", { className: "content-spotlight-image-container", children: /* @__PURE__ */ A.jsxs("div", { className: "content-spotlight-image-wrapper", children: [
      /* @__PURE__ */ A.jsx("div", { className: "content-spotlight-overlay" }),
      /* @__PURE__ */ A.jsx(
        "img",
        {
          src: a,
          alt: "",
          "aria-hidden": "true",
          className: "content-spotlight-image"
        }
      )
    ] }) }),
    /* @__PURE__ */ A.jsxs("div", { className: "content-spotlight-content", children: [
      o && /* @__PURE__ */ A.jsx("div", { className: "content-spotlight-icon", children: w() }),
      /* @__PURE__ */ A.jsxs("h2", { className: "content-spotlight-title", children: [
        f,
        v && /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
          f && v && /* @__PURE__ */ A.jsx("br", {}),
          /* @__PURE__ */ A.jsx("span", { className: "highlight", children: v })
        ] })
      ] }),
      y && /* @__PURE__ */ A.jsx(
        "p",
        {
          className: "content-spotlight-description",
          dangerouslySetInnerHTML: ka(y)
        }
      ),
      T && /* @__PURE__ */ A.jsx(
        yl,
        {
          gaData: {
            ...TS,
            text: T.label,
            component: "ContentSpotlight"
          },
          children: /* @__PURE__ */ A.jsx(
            "a",
            {
              href: T.href,
              className: `btn ${T.color ? `btn-${T.color}` : "btn-gold"}`,
              children: T.label
            }
          )
        }
      )
    ] })
  ] });
};
Wm.propTypes = {
  backgroundImage: E.string.isRequired,
  icon: E.oneOfType([
    E.string,
    E.arrayOf(E.string)
  ]),
  title: E.node.isRequired,
  highlightText: E.string,
  description: E.string,
  button: E.shape({
    label: E.string.isRequired,
    href: E.string.isRequired,
    color: E.string
  })
};
var pS = /* @__PURE__ */ ((a) => (a.COPY = "copy", a))(pS || {});
const SS = ({ type: a }) => a == "copy" ? /* @__PURE__ */ A.jsx("hr", { className: "copy-divider" }) : /* @__PURE__ */ A.jsx("hr", {}), xS = $r.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    margin: 3px;
    border: 3px solid #1b1b1b;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #1b1b1b transparent transparent transparent;
  }
  div:nth-child(1) {
    animation-delay: -0.45s;
  }
  div:nth-child(2) {
    animation-delay: -0.3s;
  }
  div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`, ES = () => /* @__PURE__ */ A.jsxs(xS, { children: [
  /* @__PURE__ */ A.jsx("div", {}),
  /* @__PURE__ */ A.jsx("div", {}),
  /* @__PURE__ */ A.jsx("div", {}),
  /* @__PURE__ */ A.jsx("div", {})
] }), wS = $r.section``, AS = S1(null), OS = ({
  defaultProps: a,
  dataSource: o,
  noFeedText: f,
  renderHeader: v,
  renderBody: y,
  dataTransformer: T,
  dataFilter: w,
  maxItems: O
}) => {
  const [{ data: _, loading: z, error: H }, Z] = _1(), [Y, ce] = ua([]), le = { ...a.dataSource, ...o };
  return Da(() => {
    Z(le == null ? void 0 : le.url);
  }, [le == null ? void 0 : le.url]), Da(() => {
    const K = _ == null ? void 0 : _.nodes.map(T), he = K == null ? void 0 : K.filter(
      (ye) => w(ye, o == null ? void 0 : o.filters)
    );
    ce(O ? he == null ? void 0 : he.slice(0, O) : he);
  }, [_]), // Init the context to be used on its childrens
  /* @__PURE__ */ A.jsx(AS.Provider, { value: { feeds: Y }, children: /* @__PURE__ */ A.jsxs(wS, { children: [
    v,
    H ? /* @__PURE__ */ A.jsx("span", { children: "Error, try again!" }) : /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
      z && !(Y != null && Y.length) && /* @__PURE__ */ A.jsx("div", { className: "text-center mt-4", children: /* @__PURE__ */ A.jsx(ES, {}) }),
      Y != null && Y.length ? y : !z && /* @__PURE__ */ A.jsx("p", { className: "text-center", children: f })
    ] })
  ] }) });
};
OS.propTypes = {
  renderHeader: E.element,
  renderBody: E.element,
  maxItems: E.number,
  dataTransformer: E.func,
  dataFilter: E.func,
  noFeedText: E.string
};
const Pm = E.shape({
  color: E.oneOf(["white", "dark"]),
  text: E.string
}), Jm = E.shape({
  color: E.oneOf(["gold", "maroon", "gray", "dark"]),
  text: E.string
}), oE = E.shape({
  color: E.oneOf(["gold", "maroon", "gray", "dark"]),
  text: E.string,
  size: E.string
}), CS = E.shape({
  url: E.string,
  filters: E.string
}), RS = E.shape({
  header: Pm,
  ctaButton: Jm,
  dataSource: CS,
  maxItems: E.number
}), _S = $r.div`
  @media screen and (min-width: 768px) {
    & {
      display: inline-flex;
      justify-content: flex-end;
    }
  }
`, NS = ({
  defaultProps: a,
  header: o,
  ctaButton: f
}) => {
  const v = { ...a.header, ...o }, y = { ...a.ctaButton, ...f }, T = v.tag || "h2", w = T !== "h2", O = `text-${v.color} ${w ? "h2" : ""}`.trim();
  return /* @__PURE__ */ A.jsxs(
    "div",
    {
      className: "row justify-content-between align-items-center pb-6",
      "data-testid": "feed-header",
      children: [
        /* @__PURE__ */ A.jsx("div", { className: "col-sm-12 col-md-9", children: /* @__PURE__ */ A.jsx(T, { className: O, children: v.text }) }),
        /* @__PURE__ */ A.jsx(_S, { className: "col-sm-12 col-md-3", children: /* @__PURE__ */ A.jsx(
          yl,
          {
            gaData: {
              event: "link",
              action: "click",
              name: "onclick",
              type: "internal link",
              region: "main content",
              section: v.text,
              text: y.text
            },
            children: /* @__PURE__ */ A.jsx("a", { className: `btn btn-${y.color}`, href: y.url, children: y.text })
          }
        ) })
      ]
    }
  );
};
NS.propTypes = {
  defaultProps: RS,
  header: Pm,
  ctaButton: Jm
};
const MS = ({ children: a }) => /* @__PURE__ */ A.jsx("div", { className: "row", "data-testid": "feed-body", children: /* @__PURE__ */ A.jsx("div", { className: "col", children: a }) });
MS.propTypes = {
  children: E.element
};
const zS = $r.img`
  width: 100%;
`;
function DS({ image: a, title: o, contents: f }) {
  return console.log({ image: a, title: o, contents: f }), /* @__PURE__ */ A.jsx("div", { children: "TODO: to be implemented" });
}
function kS({
  image: a,
  subTitle: o,
  title: f,
  contents: v,
  contentsColor: y
}) {
  const T = {
    small: "uds-hero-sm",
    medium: "uds-hero-md",
    large: "uds-hero-lg",
    undefined: ""
  }, w = {
    gold: "highlight-gold",
    black: "highlight-black",
    white: "highlight-white",
    none: "text-white",
    undefined: ""
  }, O = {
    black: "text-dark",
    white: "text-white",
    undefined: ""
  };
  return /* @__PURE__ */ A.jsxs(
    "div",
    {
      className: Rt("uds-hero", {
        [T[a == null ? void 0 : a.size]]: a == null ? void 0 : a.size
      }),
      children: [
        /* @__PURE__ */ A.jsx("div", { className: "hero-overlay" }),
        /* @__PURE__ */ A.jsx(
          zS,
          {
            className: "hero",
            src: a == null ? void 0 : a.url,
            alt: a == null ? void 0 : a.altText,
            "data-testid": "hero-image"
          }
        ),
        o && /* @__PURE__ */ A.jsx("div", { role: "doc-subtitle", "data-testid": "hero-subtitle", children: /* @__PURE__ */ A.jsx(
          "span",
          {
            className: Rt({
              [O[o.color]]: o.color,
              [w[o.highlightColor]]: o.highlightColor
            }),
            children: o.text
          }
        ) }),
        f && /* @__PURE__ */ A.jsx("h1", { style: { maxWidth: f.maxWidth || "" }, "data-testid": "hero-title", children: /* @__PURE__ */ A.jsx(
          "span",
          {
            className: Rt({
              [O[f.color]]: f.color,
              [w[f.highlightColor]]: f.highlightColor
            }),
            children: f.text
          }
        ) }),
        v && /* @__PURE__ */ A.jsx(
          "div",
          {
            "data-testid": "hero-content",
            className: Rt("content", {
              [O[y]]: y
            }),
            children: v.map((_, z) => /* @__PURE__ */ A.jsx("p", { children: _.text }, `content-${z}`))
          }
        )
      ]
    }
  );
}
const Km = (a) => {
  const o = a.type || "heading-hero";
  return {
    "heading-hero": () => kS(a),
    "story-hero": () => DS(a),
    undefined: () => (console.error(
      `the type '${o}' is not supported by the 'Hero' component.`
    ), null)
  }[o]();
};
Km.propTypes = {
  type: E.oneOf(["heading-hero", "story-hero"]),
  image: dT,
  title: yg,
  subTitle: yg,
  contents: E.arrayOf(yg),
  contentsColor: E.string
};
const LS = ({
  title: a = "Highly ranked",
  description: o = "",
  ctaText: f = "",
  ctaUrl: v = "",
  ctaButtonColor: y = "dark",
  rankings: T = []
}) => /* @__PURE__ */ A.jsx("section", { className: "highly-ranked-section", children: /* @__PURE__ */ A.jsxs("div", { className: "container", children: [
  /* @__PURE__ */ A.jsx("div", { className: "row", children: /* @__PURE__ */ A.jsxs("div", { className: "col-12 col-lg-8", children: [
    a && /* @__PURE__ */ A.jsx("h2", { className: "highly-ranked-title", children: /* @__PURE__ */ A.jsx("span", { className: "highlight-gold", children: a }) }),
    o && /* @__PURE__ */ A.jsx(
      "p",
      {
        className: "highly-ranked-description",
        dangerouslySetInnerHTML: ka(o)
      }
    ),
    f && v && /* @__PURE__ */ A.jsx("div", { className: "highly-ranked-cta", children: /* @__PURE__ */ A.jsx(
      $c,
      {
        label: f,
        href: v,
        color: y,
        size: "small",
        classes: []
      }
    ) })
  ] }) }),
  /* @__PURE__ */ A.jsx("div", { className: "row highly-ranked-grid", children: T.map((w, O) => /* @__PURE__ */ A.jsx("div", { className: "col-12 col-lg-6 mb-4", children: /* @__PURE__ */ A.jsxs("div", { className: "highly-ranked-card", children: [
    /* @__PURE__ */ A.jsx("div", { className: "ranking-value-container", children: /* @__PURE__ */ A.jsxs("h3", { className: "ranking-value", children: [
      /* @__PURE__ */ A.jsx(
        "span",
        {
          className: `ranking-value-main${w.headingLevel ? ` ${w.headingLevel}` : " h1"}`,
          children: w.value
        }
      ),
      w.title && /* @__PURE__ */ A.jsx("span", { className: "ranking-value-subsection", children: w.title })
    ] }) }),
    w.description && /* @__PURE__ */ A.jsx("div", { className: "ranking-content", children: /* @__PURE__ */ A.jsx(
      "p",
      {
        className: "ranking-description",
        dangerouslySetInnerHTML: ka(
          w.description
        )
      }
    ) })
  ] }) }, O)) })
] }) }), pr = ({
  dataId: a,
  isClickeable: o = !1,
  disabled: f = !1,
  pageLinkIcon: v = !1,
  selectedPage: y = !1,
  onClick: T = () => {
  },
  ellipses: w,
  ariaLabel: O,
  children: _,
  ariaDisabled: z
}) => /* @__PURE__ */ A.jsx(
  "li",
  {
    className: Rt("page-item", {
      disabled: f,
      active: y,
      elipses: w
    }),
    children: o ? /* @__PURE__ */ A.jsxs(
      "button",
      {
        type: "button",
        "aria-label": O,
        className: Rt("page-link", {
          "page-link-icon": v
        }),
        onClick: T,
        "data-testid": a ? `pagination-${a}` : "page-link",
        "data-id": a,
        "aria-current": y ? "page" : null,
        "aria-disabled": z,
        children: [
          _,
          y && /* @__PURE__ */ A.jsx("span", { className: "visually-hidden", children: "(current)" })
        ]
      }
    ) : /* @__PURE__ */ A.jsx("span", { className: "page-link", "data-testid": "page-link", children: _ })
  }
);
pr.propTypes = {
  isClickeable: E.bool,
  disabled: E.bool,
  pageLinkIcon: E.bool,
  selectedPage: E.bool,
  dataId: E.string,
  onClick: E.func,
  children: E.node,
  ellipses: E.bool,
  ariaLabel: E.string,
  ariaDisabled: E.bool
};
const BS = {
  event: "select",
  action: "click",
  name: "onclick",
  type: "pagination",
  region: "main content"
}, jm = ({
  type: a,
  background: o,
  currentPage: f = 1,
  totalPages: v = 10,
  onChange: y
}) => {
  const [T, w] = ua(null);
  Da(() => {
    w(f);
  }, [f]);
  const O = (H) => {
    am({ ...BS, text: `page ${H}` });
  }, _ = (H, Z) => {
    const ce = {
      first: 1,
      prev: T === 1 ? 1 : T - 1,
      next: T === v ? v : T + 1,
      last: v
    }[Z] ?? Z;
    w(ce), O(ce), y == null || y(H, ce);
  }, z = () => {
    if (v < 5)
      return /* @__PURE__ */ A.jsx(A.Fragment, { children: Array.from({ length: v }, (he, ye) => {
        const de = ye + 1;
        return /* @__PURE__ */ A.jsx(
          pr,
          {
            ariaLabel: `Page ${de} of ${v}`,
            isClickeable: !0,
            selectedPage: T === de,
            onClick: (ze) => _(ze, de),
            children: de
          },
          de
        );
      }) });
    const H = 2, Z = Py(
      T === v - 1,
      1,
      T === v ? 2 : 1
    ), Y = Py(
      T === 1,
      2,
      1
    ), ce = ob(
      T - Z,
      T,
      v
    ), le = ob(
      T,
      T + 1 + Y,
      v
    ), K = [...ce, ...le];
    return /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
      K[0] !== 1 && /* @__PURE__ */ A.jsx(
        pr,
        {
          ariaLabel: `Page 1 of ${v}`,
          isClickeable: !0,
          selectedPage: T === 1,
          onClick: (he) => _(he, "first"),
          children: "1"
        }
      ),
      T > v - H && /* @__PURE__ */ A.jsx(
        pr,
        {
          isClickeable: !0,
          ariaLabel: `Page 2 of ${v}`,
          selectedPage: T === 2,
          onClick: (he) => _(he, 2),
          children: "2"
        }
      ),
      K[0] > 2 && /* @__PURE__ */ A.jsx(pr, { ellipses: !0, children: "..." }),
      K.map((he) => /* @__PURE__ */ A.jsx(
        pr,
        {
          ariaLabel: `Page ${he} of ${v}`,
          isClickeable: !0,
          selectedPage: T === he,
          onClick: (ye) => _(ye, he),
          children: he
        },
        he
      )),
      K[K.length - 1] < v - 1 && /* @__PURE__ */ A.jsx(pr, { ellipses: !0, children: "..." }),
      T < H + 1 && /* @__PURE__ */ A.jsx(
        pr,
        {
          isClickeable: !0,
          ariaLabel: `Page ${v - 1} of ${v}`,
          selectedPage: T === v - 1,
          onClick: (he) => _(he, v - 1),
          children: v - 1
        }
      ),
      K[K.length - 1] !== v && /* @__PURE__ */ A.jsx(
        pr,
        {
          isClickeable: !0,
          ariaLabel: `Page ${v} of ${v}`,
          selectedPage: T === v,
          onClick: (he) => _(he, "last"),
          children: v
        }
      )
    ] });
  };
  return /* @__PURE__ */ A.jsx("nav", { "aria-label": "Pagination", "data-testid": "pagination", children: /* @__PURE__ */ A.jsxs(
    "ul",
    {
      className: Rt(
        "pagination",
        "justify-content-center",
        "pt-2",
        "pb-2",
        {
          border: a === "bordered",
          "uds-bg-gray1": o === "gray1",
          "uds-bg-gray": o === "gray2",
          "uds-bg-dark": o === "gray7"
        }
      ),
      children: [
        /* @__PURE__ */ A.jsx(
          pr,
          {
            dataId: "prev",
            isClickeable: !0,
            disabled: T === 1,
            pageLinkIcon: !0,
            onClick: (H) => _(H, "prev"),
            ariaDisabled: T === 1,
            ariaLabel: "Previous Page"
          }
        ),
        z(),
        /* @__PURE__ */ A.jsx(
          pr,
          {
            dataId: "next",
            isClickeable: !0,
            ariaDisabled: T === v,
            disabled: T === v,
            pageLinkIcon: !0,
            onClick: (H) => _(H, "next"),
            ariaLabel: "Next Page"
          }
        )
      ]
    }
  ) });
};
jm.propTypes = {
  /**
   * Type of pagination
   */
  type: E.oneOf(["default", "bordered"]).isRequired,
  /**
   * Background of pagination
   */
  background: E.oneOf(["white", "gray1", "gray2", "gray7"]).isRequired,
  /**
   * Current page
   */
  currentPage: E.number,
  /**
   * Total number of pages
   */
  totalPages: E.number,
  /**
   * Callback fired when the page is changed
   */
  onChange: E.func.isRequired
};
var HS = /* @__PURE__ */ ((a) => (a.WARNING = "warning", a.INFO = "info", a.SUCCESS = "success", a.ERROR = "error", a))(HS || {});
const US = ({
  type: a,
  dismissable: o,
  children: f
}) => {
  var z, H, Z;
  const { isBootstrap: v, isReact: y } = Uo(), [T, w] = ua(!0), O = () => w(!1), _ = {
    warning: {
      iconTitle: "Warning",
      iconName: "bell",
      alertClass: "warning"
    },
    info: {
      iconTitle: "Information",
      iconName: "info-circle",
      alertClass: "info"
    },
    success: {
      iconTitle: "Success",
      iconName: "check-circle",
      alertClass: "success"
    },
    error: {
      iconTitle: "Error",
      iconName: "exclamation-triangle",
      alertClass: "danger"
    }
  };
  return T && /* @__PURE__ */ A.jsxs(
    "div",
    {
      className: Rt("alert", {
        "alert-dismissable": o,
        [`alert-${(z = _[a]) == null ? void 0 : z.alertClass}`]: a
      }),
      role: "alert",
      children: [
        /* @__PURE__ */ A.jsx("div", { className: "alert-icon", children: /* @__PURE__ */ A.jsx(
          "span",
          {
            title: (H = _[a]) == null ? void 0 : H.iconTitle,
            className: `fa fa-icon fa-${(Z = _[a]) == null ? void 0 : Z.iconName}`
          }
        ) }),
        /* @__PURE__ */ A.jsx("div", { className: "alert-content", children: f }),
        o && /* @__PURE__ */ A.jsx("div", { className: "alert-close", children: /* @__PURE__ */ A.jsx(
          av,
          {
            icon: ["fas", "times"],
            onClick: y && O,
            "data-bs-dismiss": v && "alert"
          }
        ) })
      ]
    }
  );
}, FS = $r.div`
  button {
    padding: 16px 0;
    border: none;
    outline: none;
  }
`, qm = ({ gaData: a, hidePrev: o, hideNext: f, slideNav: v }) => {
  const { isReact: y, isBootstrap: T } = Uo();
  return /* @__PURE__ */ A.jsxs(FS, { children: [
    (!o || T) && /* @__PURE__ */ A.jsx(yl, { gaData: { ...a, text: "left chevron" }, children: /* @__PURE__ */ A.jsxs(
      "button",
      {
        className: "scroll-control-prev",
        type: "button",
        onClick: y && (() => v(-1)),
        tabIndex: -1,
        children: [
          /* @__PURE__ */ A.jsx("span", { className: "carousel-control-prev-icon", "aria-hidden": "true" }),
          /* @__PURE__ */ A.jsx("span", { className: "visually-hidden", children: "Previous" })
        ]
      }
    ) }),
    (!f || T) && /* @__PURE__ */ A.jsx(yl, { gaData: { ...a, text: "right chevron" }, children: /* @__PURE__ */ A.jsxs(
      "button",
      {
        className: "scroll-control-next",
        type: "button",
        onClick: y && (() => v(1)),
        tabIndex: -1,
        children: [
          /* @__PURE__ */ A.jsx("span", { className: "carousel-control-next-icon", "aria-hidden": "true" }),
          /* @__PURE__ */ A.jsx("span", { className: "visually-hidden", children: "Next" })
        ]
      }
    ) })
  ] });
};
qm.propTypes = {
  gaData: E.object,
  hidePrev: E.bool,
  hideNext: E.bool,
  slideNav: E.func.isRequired
};
const $m = function(o) {
  const {
    id: f,
    selected: v,
    title: y,
    selectTab: T,
    leftKeyPressed: w,
    rightKeyPressed: O,
    icon: _,
    gaData: z,
    ref: H
  } = o, { isReact: Z, isBootstrap: Y } = Uo(), ce = Do(null);
  x1(H, () => ({
    focus() {
      ce.current.focus();
    },
    scrollIntoView() {
      var ye, de, ze, ke, pe, xe, we;
      const K = ((ye = ce.current) == null ? void 0 : ye.offsetWidth) / 2 + ce.current.offsetLeft, he = ((ze = (de = ce.current) == null ? void 0 : de.offsetParent) == null ? void 0 : ze.scrollLeft) + ((pe = (ke = ce.current) == null ? void 0 : ke.offsetParent) == null ? void 0 : pe.offsetWidth) / 2;
      (we = (xe = ce.current) == null ? void 0 : xe.offsetParent) == null || we.scrollBy({
        left: K - he
      });
    }
  }), []);
  const le = (K) => {
    K.keyCode === 37 ? (K.preventDefault(), w()) : K.keyCode === 39 && (K.preventDefault(), O());
  };
  return /* @__PURE__ */ A.jsx(yl, { gaData: { ...z, text: y }, children: /* @__PURE__ */ A.jsxs(
    "a",
    {
      ref: ce,
      className: `nav-item nav-link ${v ? "active" : ""}`,
      id: f,
      href: `#nav-${f}`,
      role: "tab",
      "aria-controls": `nav-${f}`,
      "aria-selected": v,
      "data-bs-toggle": Y && "tab",
      onClick: Z && ((K) => T(K, f, y)),
      onKeyDown: Z && le,
      tabIndex: v ? "" : "-1",
      children: [
        y,
        " ",
        _ && /* @__PURE__ */ A.jsx("i", { className: `${_ == null ? void 0 : _[0]} fa-${_ == null ? void 0 : _[1]} me-1` })
      ]
    }
  ) });
};
$m.propTypes = {
  gaData: E.object,
  id: E.string.isRequired,
  selected: E.bool.isRequired,
  title: E.string.isRequired,
  selectTab: E.func.isRequired,
  leftKeyPressed: E.func.isRequired,
  rightKeyPressed: E.func.isRequired,
  icon: E.arrayOf(E.string)
};
function YS() {
  const a = Do({}), o = Ds(
    (f) => (v) => {
      a.current[f] = v;
    },
    []
  );
  return [a, o];
}
const GS = ({ id: a, bgColor: o, selected: f, children: v }) => {
  const { isBootstrap: y } = Uo();
  return f || y ? /* @__PURE__ */ A.jsx(
    "div",
    {
      className: `tab-pane fade show ${f ? "show active" : ""} ${o === "bg-dark" ? "text-white" : ""}`,
      id: `nav-${a}`,
      role: "tabpanel",
      "aria-labelledby": `nav-${a}-tab`,
      children: v
    }
  ) : null;
};
GS.propTypes = {
  id: E.string.isRequired,
  bgColor: E.string,
  selected: E.bool,
  children: E.oneOfType([E.array, E.element])
};
const e0 = ({
  initialTab: a = "",
  children: o,
  bgColor: f = "",
  onTabChange: v = (y) => {
  }
}) => {
  var Et, Xt;
  const y = Gt.Children.toArray(o), T = Do(!1), [w, O] = ua(
    a && a !== "null" ? a : ((Xt = (Et = y[0]) == null ? void 0 : Et.props) == null ? void 0 : Xt.id) || ""
  ), _ = Do(null), [z, H] = YS(), [Z, Y] = ua(0), [ce, le] = ua(), K = Ds(() => {
    var Ee, Ne;
    le(
      ((Ee = _.current) == null ? void 0 : Ee.scrollWidth) - ((Ne = _.current) == null ? void 0 : Ne.offsetWidth)
    );
  }, []), he = Ds(() => {
    var Ee;
    Y((Ee = _.current) == null ? void 0 : Ee.scrollLeft);
  }, []), ye = Ds(() => {
    _g(he, 150), Ng(he, 150);
  }, [he]), de = Ds(() => {
    _g(K, 150), Ng(K, 150);
  }, [K]);
  if (Da(() => {
    const Ee = _.current;
    return Ee && (Ee.addEventListener("scroll", ye), he()), () => {
      Ee && Ee.removeEventListener("scroll", ye);
    };
  }, [ce, ye, he]), Da(() => (window.addEventListener("resize", de), K(), () => {
    window.removeEventListener("resize", de);
  }), [de, K]), Da(() => {
    z.current[w] && z.current[w].scrollIntoView();
  }, [w, z]), Da(() => {
    T.current && a && a !== "null" && w !== a && O(a);
  }, [a, w]), Da(() => {
    T.current = !0;
  }, []), y.length === 0)
    return null;
  const ze = (Ee) => {
    var Ne;
    v(Ee), (Ne = z.current[Ee]) == null || Ne.focus(), O(Ee);
  }, ke = {
    event: "select",
    action: "click",
    name: "onclick",
    type: "carousel",
    region: "main content",
    text: ""
  }, pe = {
    event: "link",
    action: "click",
    name: "onclick",
    type: "internal link",
    text: ""
  }, xe = y.map((Ee) => Gt.cloneElement(Ee, {
    bgColor: f,
    selected: w === Ee.props.id
  })), we = (Ee) => {
    const Ne = _.current, lt = Ne.scrollWidth - Ne.clientWidth;
    let Q = Ne.scrollLeft + 200 * Ee;
    Q = Math.max(0, Math.min(lt, Q)), Ne.scrollTo({
      left: Q,
      behavior: "smooth"
    });
  }, Ce = (Ee, Ne, lt) => {
    Ee.preventDefault(), ze(Ne);
  }, Le = (Ee = !0) => {
    const Ne = y.length, lt = Ee ? 1 : -1, U = y.findIndex((Se) => Se.props.id === w), Q = y[(Ne + U + lt) % Ne].props.id;
    ze(Q);
  };
  let Ht = "uds-tabbed-panels";
  return f === "bg-dark" && (Ht += " uds-tabbed-panels-dark"), /* @__PURE__ */ A.jsxs("div", { className: f, children: [
    /* @__PURE__ */ A.jsxs("nav", { className: Ht, children: [
      /* @__PURE__ */ A.jsx("div", { className: "nav nav-tabs", role: "tablist", ref: _, children: y.map((Ee, Ne) => /* @__PURE__ */ A.jsx(
        $m,
        {
          ref: H(Ee.props.id),
          id: Ee.props.id,
          title: Ee.props.title,
          selected: w === Ee.props.id,
          gaData: pe,
          selectTab: Ce,
          leftKeyPressed: () => Le(!1),
          rightKeyPressed: () => Le(),
          icon: Ee.props.icon,
          index: Ne
        },
        Ee.props.id
      )) }),
      /* @__PURE__ */ A.jsx(
        qm,
        {
          hidePrev: Z <= 0,
          hideNext: Z >= ce,
          gaData: ke,
          slideNav: we
        }
      )
    ] }),
    /* @__PURE__ */ A.jsx(
      "div",
      {
        className: "tab-content",
        tabIndex: 0,
        role: "tabpanel",
        id: "nav-tabContent",
        children: xe
      }
    )
  ] });
};
e0.propTypes = {
  initialTab: E.string,
  children: E.arrayOf(E.element).isRequired,
  bgColor: E.string,
  onTabChange: E.func
};
const uv = ({ imageSource: a, imageAltText: o, quote: f, itemStyle: v = {} }) => {
  var y, T;
  return /* @__PURE__ */ A.jsxs(
    "div",
    {
      className: `uds-blockquote uds-testimonial ${a ? "with-image" : ""} ${Ud(v.containerCssClass)}`,
      children: [
        a && /* @__PURE__ */ A.jsx(
          Ho,
          {
            src: a,
            alt: o,
            dataTestId: "testimonial-image",
            fetchPriority: "high"
          }
        ),
        /* @__PURE__ */ A.jsx("svg", { role: "presentation", viewBox: "0 0 302.87 245.82", children: /* @__PURE__ */ A.jsx("path", { d: "M113.61,245.82H0V164.56q0-49.34,8.69-77.83T40.84,35.58Q64.29,12.95,100.67,0l22.24,46.9q-34,11.33-48.72,31.54T58.63,132.21h55Zm180,0H180V164.56q0-49.74,8.7-78T221,35.58Q244.65,12.95,280.63,0l22.24,46.9q-34,11.33-48.72,31.54t-15.57,53.77h55Z" }) }),
        /* @__PURE__ */ A.jsxs("blockquote", { style: { paddingLeft: 0 }, children: [
          f.title && /* @__PURE__ */ A.jsx("h3", { className: "text-center", "data-testid": "testimonial-title", children: /* @__PURE__ */ A.jsx("span", { className: Ud(v.titleCssClass), children: f.title }) }),
          f.content && /* @__PURE__ */ A.jsx(
            "p",
            {
              className: Ud(v.contentCssClass),
              "data-testid": "testimonial-content",
              children: f.content
            }
          ),
          (!!((y = f.cite) != null && y.name) || !!((T = f.cite) != null && T.description)) && /* @__PURE__ */ A.jsxs("div", { className: "citation", "data-testid": "testimonial-citation", children: [
            /* @__PURE__ */ A.jsx("cite", { className: "name", children: f.cite.name }),
            f.cite && /* @__PURE__ */ A.jsx("cite", { className: "description", children: f.cite.description })
          ] })
        ] })
      ]
    }
  );
};
uv.propTypes = {
  quote: E.shape({
    title: E.string,
    content: E.string,
    cite: E.shape({
      name: E.string,
      description: E.string
    })
  }).isRequired,
  imageSource: E.string,
  imageAltText: E.string,
  itemStyle: E.shape({
    containerCssClass: E.arrayOf(E.string),
    titleCssClass: E.arrayOf(E.string),
    contentCssClass: E.arrayOf(E.string)
  })
};
const XS = (a) => /* @__PURE__ */ A.jsx("button", { className: "uds-tooltip uds-tooltip-gray", ...a, children: /* @__PURE__ */ A.jsxs("span", { className: "fa-stack", "aria-hidden": "true", children: [
  /* @__PURE__ */ A.jsx("i", { className: "fas fa-circle fa-stack-2x" }),
  /* @__PURE__ */ A.jsx("i", { className: "fas fa-info fa-stack-1x" })
] }) }), IS = ({
  title: a,
  content: o,
  triggerElement: f,
  children: v,
  iconLabel: y
}) => {
  const T = "tooltip-" + th(), w = () => y || (a ? `Show tooltip: ${a}` : o && typeof o == "string" ? `Show tooltip: ${o.length > 50 ? o.substring(0, 47) + "..." : o}` : "Show more information");
  let O = v || f || /* @__PURE__ */ A.jsx(XS, { "aria-label": w() });
  return typeof O == "string" && (O = /* @__PURE__ */ A.jsx("button", { type: "button", children: O })), /* @__PURE__ */ A.jsxs("span", { className: "uds-tooltip-container", children: [
    Gt.cloneElement(O, {
      "aria-describedby": T,
      tabIndex: 0
    }),
    /* @__PURE__ */ A.jsxs("div", { role: "tooltip", className: "uds-tooltip-description", id: T, children: [
      a && /* @__PURE__ */ A.jsx("span", { className: "uds-tooltip-heading", children: a }),
      o
    ] })
  ] });
}, ZS = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content",
  text: "play button"
}, VS = ({
  url: a = "",
  vttUrl: o,
  caption: f,
  title: v = "",
  className: y,
  controls: T = !0
}) => {
  const w = Do(null);
  return /* @__PURE__ */ A.jsxs(
    "div",
    {
      className: Rt(`uds-video-container ${y}`, {
        "uds-video-with-caption": f
      }),
      children: [
        /* @__PURE__ */ A.jsx("div", { className: "uds-video-player", children: /* @__PURE__ */ A.jsx(yl, { gaData: { ...ZS, section: v }, children: /* @__PURE__ */ A.jsxs(
          "video",
          {
            ref: w,
            title: v,
            playsInline: !0,
            controls: T || !0,
            children: [
              /* @__PURE__ */ A.jsx("source", { src: a }),
              /* @__PURE__ */ A.jsx(
                "track",
                {
                  src: o,
                  kind: "captions",
                  srcLang: "en",
                  label: "english_captions"
                }
              )
            ]
          }
        ) }) }),
        f && /* @__PURE__ */ A.jsx("figure", { "data-testid": "video-caption", children: /* @__PURE__ */ A.jsx("figcaption", { children: f }) })
      ]
    }
  );
}, QS = ({ title: a = "", caption: o, url: f = "", className: v }) => /* @__PURE__ */ A.jsxs(
  "div",
  {
    className: Rt(`uds-video-container ${v}`, {
      "uds-video-with-caption": o
    }),
    children: [
      /* @__PURE__ */ A.jsx("div", { className: "uds-video-player youtube-video", children: /* @__PURE__ */ A.jsx("iframe", { title: a, src: f }) }),
      o && /* @__PURE__ */ A.jsx("figure", { "data-testid": "video-caption", children: /* @__PURE__ */ A.jsx("figcaption", { children: o }) })
    ]
  }
), t0 = (a) => {
  const {
    type: o = "video",
    url: f = "",
    vttUrl: v,
    title: y = "",
    caption: T,
    className: w,
    controls: O = !0
  } = a;
  return o === "youtube" ? QS({ url: f, title: y, caption: T, className: w }) : VS({
    url: f,
    vttUrl: v,
    title: y,
    caption: T,
    className: w,
    controls: O
  });
};
t0.propTypes = {
  type: E.oneOf(["video", "youtube"]),
  url: E.string,
  vttUrl: E.string,
  title: E.string,
  className: E.string,
  caption: E.string,
  controls: E.bool
};
const WS = {
  event: "select",
  action: "click",
  name: "onclick",
  region: "main content",
  type: "pagination",
  text: "owl dot"
}, cv = ({ children: a }) => /* @__PURE__ */ A.jsx(
  "div",
  {
    role: "group",
    className: "glide__bullets",
    "data-glide-el": "controls[nav]",
    "data-testid": "bullets-container",
    onClick: (o) => o.stopPropagation(),
    onKeyDown: (o) => o.stopPropagation(),
    children: a
  }
);
cv.propTypes = {
  children: E.oneOfType([
    E.element,
    E.arrayOf(E.element)
  ]).isRequired
};
const n0 = ({ buttonCount: a }) => {
  const o = [];
  for (let f = 0; f < a; f += 1)
    o.push(
      /* @__PURE__ */ A.jsx(yl, { gaData: WS, children: /* @__PURE__ */ A.jsx(
        "button",
        {
          type: "button",
          className: "glide__bullet",
          "data-glide-dir": `=${f}`,
          "aria-label": `Slide view ${f + 1}`
        }
      ) }, `bullet-${f}`)
    );
  return /* @__PURE__ */ A.jsx(cv, { children: o });
};
n0.propTypes = {
  buttonCount: E.number.isRequired
};
const l0 = ({ imageItems: a, onItemClick: o = () => null }) => {
  const f = (y, T) => {
    const { ariaSelected: w } = y.currentTarget.dataset;
    y.currentTarget.dataset.ariaSelected = String(!w), y.stopPropagation(), o(T);
  }, v = a.map((y, T) => /* @__PURE__ */ A.jsx(
    "button",
    {
      type: "button",
      role: "option",
      className: "bullet-image-container",
      "data-glide-dir": `=${T}`,
      "aria-label": `Slide view ${T + 1}`,
      "aria-selected": "false",
      onClick: (w) => f(w, T),
      onKeyDown: (w) => f(w, T),
      children: /* @__PURE__ */ A.jsx(
        "img",
        {
          src: y,
          alt: `Slide ${T + 1}`,
          className: "glide__bullet bullet-image",
          loading: "lazy",
          decoding: "async",
          fetchpriority: "low"
        }
      )
    },
    `bullet-${T}`
  ));
  return /* @__PURE__ */ A.jsx(cv, { children: v });
};
l0.propTypes = {
  imageItems: E.arrayOf(E.string).isRequired,
  onItemClick: E.func
};
const ov = ({ onClick: a = () => null }) => /* @__PURE__ */ A.jsx(
  "button",
  {
    type: "button",
    className: "glide__arrow glide__arrow--next",
    "data-glide-dir": ">",
    "aria-label": "Next slide",
    onClick: a,
    children: /* @__PURE__ */ A.jsx("i", { className: "fas fa-chevron-right arrow-icon" })
  }
);
ov.propTypes = {
  onClick: E.func
};
const sv = ({ onClick: a = () => null }) => /* @__PURE__ */ A.jsx(
  "button",
  {
    type: "button",
    className: "glide__arrow glide__arrow--prev",
    "data-glide-dir": "<",
    "aria-label": "Previous slide",
    onClick: a,
    children: /* @__PURE__ */ A.jsx("span", { className: "fas fa-chevron-left arrow-icon" })
  }
);
sv.propTypes = {
  onClick: E.func
};
const Gb = {
  event: "select",
  action: "click",
  name: "onclick",
  region: "main content",
  type: "carousel"
}, fv = ({ children: a = null }) => /* @__PURE__ */ A.jsx(
  "div",
  {
    className: "glide__arrows",
    "data-glide-el": "controls",
    "data-testid": "arrows-container",
    children: a
  }
);
fv.propTypes = {
  children: E.arrayOf(E.element)
};
const a0 = ({ onClick: a = () => null, children: o = null }) => /* @__PURE__ */ A.jsxs(fv, { children: [
  /* @__PURE__ */ A.jsx(yl, { gaData: { ...Gb, text: "left chevron" }, children: /* @__PURE__ */ A.jsx(sv, { onClick: a }) }),
  o,
  /* @__PURE__ */ A.jsx(yl, { gaData: { ...Gb, text: "right chevron" }, children: /* @__PURE__ */ A.jsx(ov, { onClick: a }) })
] });
a0.propTypes = {
  children: E.element,
  onClick: E.func
};
const i0 = ({ carouselItems: a }) => {
  const o = a.map((f) => /* @__PURE__ */ A.jsx("li", { className: "glide__slide slider", children: f.item }, f.id.toString()));
  return /* @__PURE__ */ A.jsx("ul", { className: "glide__slides", children: o });
};
i0.propTypes = {
  carouselItems: E.arrayOf(E.object)
};
function Xb(a, o) {
  var f = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var v = Object.getOwnPropertySymbols(a);
    o && (v = v.filter(function(y) {
      return Object.getOwnPropertyDescriptor(a, y).enumerable;
    })), f.push.apply(f, v);
  }
  return f;
}
function Ib(a) {
  for (var o = 1; o < arguments.length; o++) {
    var f = arguments[o] != null ? arguments[o] : {};
    o % 2 ? Xb(Object(f), !0).forEach(function(v) {
      JS(a, v, f[v]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(f)) : Xb(Object(f)).forEach(function(v) {
      Object.defineProperty(a, v, Object.getOwnPropertyDescriptor(f, v));
    });
  }
  return a;
}
function Qd(a) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Qd = function(o) {
    return typeof o;
  } : Qd = function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, Qd(a);
}
function dh(a, o) {
  if (!(a instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function PS(a, o) {
  for (var f = 0; f < o.length; f++) {
    var v = o[f];
    v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(a, v.key, v);
  }
}
function hh(a, o, f) {
  return o && PS(a.prototype, o), a;
}
function JS(a, o, f) {
  return o in a ? Object.defineProperty(a, o, {
    value: f,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[o] = f, a;
}
function KS(a, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function");
  a.prototype = Object.create(o && o.prototype, {
    constructor: {
      value: a,
      writable: !0,
      configurable: !0
    }
  }), o && Vg(a, o);
}
function Bs(a) {
  return Bs = Object.setPrototypeOf ? Object.getPrototypeOf : function(f) {
    return f.__proto__ || Object.getPrototypeOf(f);
  }, Bs(a);
}
function Vg(a, o) {
  return Vg = Object.setPrototypeOf || function(v, y) {
    return v.__proto__ = y, v;
  }, Vg(a, o);
}
function jS() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function qS(a) {
  if (a === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}
function $S(a, o) {
  if (o && (typeof o == "object" || typeof o == "function"))
    return o;
  if (o !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return qS(a);
}
function ex(a) {
  var o = jS();
  return function() {
    var v = Bs(a), y;
    if (o) {
      var T = Bs(this).constructor;
      y = Reflect.construct(v, arguments, T);
    } else
      y = v.apply(this, arguments);
    return $S(this, y);
  };
}
function tx(a, o) {
  for (; !Object.prototype.hasOwnProperty.call(a, o) && (a = Bs(a), a !== null); )
    ;
  return a;
}
function Wd() {
  return typeof Reflect < "u" && Reflect.get ? Wd = Reflect.get : Wd = function(o, f, v) {
    var y = tx(o, f);
    if (y) {
      var T = Object.getOwnPropertyDescriptor(y, f);
      return T.get ? T.get.call(arguments.length < 3 ? o : v) : T.value;
    }
  }, Wd.apply(this, arguments);
}
var nx = {
  /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */
  type: "slider",
  /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */
  startAt: 0,
  /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */
  perView: 1,
  /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */
  focusAt: 0,
  /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */
  gap: 10,
  /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */
  autoplay: !1,
  /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */
  hoverpause: !0,
  /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */
  keyboard: !0,
  /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */
  bound: !1,
  /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */
  swipeThreshold: 80,
  /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */
  dragThreshold: 120,
  /**
   * A number of slides moved on single swipe.
   *
   * Available types:
   * `` - Moves slider by one slide per swipe
   * `|` - Moves slider between views per swipe (number of slides defined in `perView` options)
   *
   * @type {String}
   */
  perSwipe: "",
  /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */
  touchRatio: 0.5,
  /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */
  touchAngle: 45,
  /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */
  animationDuration: 400,
  /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */
  rewind: !0,
  /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */
  rewindDuration: 800,
  /**
   * Easing function for the animation.
   *
   * @type {String}
   */
  animationTimingFunc: "cubic-bezier(.165, .840, .440, 1)",
  /**
   * Wait for the animation to finish until the next user input can be processed
   *
   * @type {boolean}
   */
  waitForTransition: !0,
  /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */
  throttle: 10,
  /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */
  direction: "ltr",
  /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */
  peek: 0,
  /**
   * Defines how many clones of current viewport will be generated.
   *
   * @type {Number}
   */
  cloningRatio: 1,
  /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */
  breakpoints: {},
  /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */
  classes: {
    swipeable: "glide--swipeable",
    dragging: "glide--dragging",
    direction: {
      ltr: "glide--ltr",
      rtl: "glide--rtl"
    },
    type: {
      slider: "glide--slider",
      carousel: "glide--carousel"
    },
    slide: {
      clone: "glide__slide--clone",
      active: "glide__slide--active"
    },
    arrow: {
      disabled: "glide__arrow--disabled"
    },
    nav: {
      active: "glide__bullet--active"
    }
  }
};
function Zu(a) {
  console.error("[Glide warn]: ".concat(a));
}
function ra(a) {
  return parseInt(a);
}
function lx(a) {
  return parseFloat(a);
}
function Qg(a) {
  return typeof a == "string";
}
function Hs(a) {
  var o = Qd(a);
  return o === "function" || o === "object" && !!a;
}
function $d(a) {
  return typeof a == "function";
}
function r0(a) {
  return typeof a > "u";
}
function Wg(a) {
  return a.constructor === Array;
}
function ax(a, o, f) {
  var v = {};
  for (var y in o)
    $d(o[y]) ? v[y] = o[y](a, v, f) : Zu("Extension must be a function");
  for (var T in v)
    $d(v[T].mount) && v[T].mount();
  return v;
}
function Mn(a, o, f) {
  Object.defineProperty(a, o, f);
}
function ix(a) {
  return Object.keys(a).sort().reduce(function(o, f) {
    return o[f] = a[f], o[f], o;
  }, {});
}
function Pg(a, o) {
  var f = Object.assign({}, a, o);
  if (o.hasOwnProperty("classes")) {
    f.classes = Object.assign({}, a.classes, o.classes);
    var v = ["direction", "type", "slide", "arrow", "nav"];
    v.forEach(function(y) {
      o.classes.hasOwnProperty(y) && (f.classes[y] = Ib(Ib({}, a.classes[y]), o.classes[y]));
    });
  }
  return o.hasOwnProperty("breakpoints") && (f.breakpoints = Object.assign({}, a.breakpoints, o.breakpoints)), f;
}
var rx = /* @__PURE__ */ (function() {
  function a() {
    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    dh(this, a), this.events = o, this.hop = o.hasOwnProperty;
  }
  return hh(a, [{
    key: "on",
    value: function(f, v) {
      if (Wg(f)) {
        for (var y = 0; y < f.length; y++)
          this.on(f[y], v);
        return;
      }
      this.hop.call(this.events, f) || (this.events[f] = []);
      var T = this.events[f].push(v) - 1;
      return {
        remove: function() {
          delete this.events[f][T];
        }
      };
    }
    /**
     * Runs registered handlers for specified event.
     *
     * @param {String|Array} event
     * @param {Object=} context
     */
  }, {
    key: "emit",
    value: function(f, v) {
      if (Wg(f)) {
        for (var y = 0; y < f.length; y++)
          this.emit(f[y], v);
        return;
      }
      this.hop.call(this.events, f) && this.events[f].forEach(function(T) {
        T(v || {});
      });
    }
  }]), a;
})(), ux = /* @__PURE__ */ (function() {
  function a(o) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    dh(this, a), this._c = {}, this._t = [], this._e = new rx(), this.disabled = !1, this.selector = o, this.settings = Pg(nx, f), this.index = this.settings.startAt;
  }
  return hh(a, [{
    key: "mount",
    value: function() {
      var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return this._e.emit("mount.before"), Hs(f) ? this._c = ax(this, f, this._e) : Zu("You need to provide a object on `mount()`"), this._e.emit("mount.after"), this;
    }
    /**
     * Collects an instance `translate` transformers.
     *
     * @param  {Array} transformers Collection of transformers.
     * @return {Void}
     */
  }, {
    key: "mutate",
    value: function() {
      var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      return Wg(f) ? this._t = f : Zu("You need to provide a array on `mutate()`"), this;
    }
    /**
     * Updates glide with specified settings.
     *
     * @param {Object} settings
     * @return {Glide}
     */
  }, {
    key: "update",
    value: function() {
      var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return this.settings = Pg(this.settings, f), f.hasOwnProperty("startAt") && (this.index = f.startAt), this._e.emit("update"), this;
    }
    /**
     * Change slide with specified pattern. A pattern must be in the special format:
     * `>` - Move one forward
     * `<` - Move one backward
     * `={i}` - Go to {i} zero-based slide (eq. '=1', will go to second slide)
     * `>>` - Rewinds to end (last slide)
     * `<<` - Rewinds to start (first slide)
     * `|>` - Move one viewport forward
     * `|<` - Move one viewport backward
     *
     * @param {String} pattern
     * @return {Glide}
     */
  }, {
    key: "go",
    value: function(f) {
      return this._c.Run.make(f), this;
    }
    /**
     * Move track by specified distance.
     *
     * @param {String} distance
     * @return {Glide}
     */
  }, {
    key: "move",
    value: function(f) {
      return this._c.Transition.disable(), this._c.Move.make(f), this;
    }
    /**
     * Destroy instance and revert all changes done by this._c.
     *
     * @return {Glide}
     */
  }, {
    key: "destroy",
    value: function() {
      return this._e.emit("destroy"), this;
    }
    /**
     * Start instance autoplaying.
     *
     * @param {Boolean|Number} interval Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Glide}
     */
  }, {
    key: "play",
    value: function() {
      var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      return f && (this.settings.autoplay = f), this._e.emit("play"), this;
    }
    /**
     * Stop instance autoplaying.
     *
     * @return {Glide}
     */
  }, {
    key: "pause",
    value: function() {
      return this._e.emit("pause"), this;
    }
    /**
     * Sets glide into a idle status.
     *
     * @return {Glide}
     */
  }, {
    key: "disable",
    value: function() {
      return this.disabled = !0, this;
    }
    /**
     * Sets glide into a active status.
     *
     * @return {Glide}
     */
  }, {
    key: "enable",
    value: function() {
      return this.disabled = !1, this;
    }
    /**
     * Adds cuutom event listener with handler.
     *
     * @param  {String|Array} event
     * @param  {Function} handler
     * @return {Glide}
     */
  }, {
    key: "on",
    value: function(f, v) {
      return this._e.on(f, v), this;
    }
    /**
     * Checks if glide is a precised type.
     *
     * @param  {String} name
     * @return {Boolean}
     */
  }, {
    key: "isType",
    value: function(f) {
      return this.settings.type === f;
    }
    /**
     * Gets value of the core options.
     *
     * @return {Object}
     */
  }, {
    key: "settings",
    get: function() {
      return this._o;
    },
    set: function(f) {
      Hs(f) ? this._o = f : Zu("Options must be an `object` instance.");
    }
    /**
     * Gets current index of the slider.
     *
     * @return {Object}
     */
  }, {
    key: "index",
    get: function() {
      return this._i;
    },
    set: function(f) {
      this._i = ra(f);
    }
    /**
     * Gets type name of the slider.
     *
     * @return {String}
     */
  }, {
    key: "type",
    get: function() {
      return this.settings.type;
    }
    /**
     * Gets value of the idle status.
     *
     * @return {Boolean}
     */
  }, {
    key: "disabled",
    get: function() {
      return this._d;
    },
    set: function(f) {
      this._d = !!f;
    }
  }]), a;
})();
function cx(a, o, f) {
  var v = {
    /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */
    mount: function() {
      this._o = !1;
    },
    /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */
    make: function(z) {
      var H = this;
      a.disabled || (!a.settings.waitForTransition || a.disable(), this.move = z, f.emit("run.before", this.move), this.calculate(), f.emit("run", this.move), o.Transition.after(function() {
        H.isStart() && f.emit("run.start", H.move), H.isEnd() && f.emit("run.end", H.move), H.isOffset() && (H._o = !1, f.emit("run.offset", H.move)), f.emit("run.after", H.move), a.enable();
      }));
    },
    /**
     * Calculates current index based on defined move.
     *
     * @return {Number|Undefined}
     */
    calculate: function() {
      var z = this.move, H = this.length, Z = z.steps, Y = z.direction, ce = 1;
      if (Y === "=") {
        if (a.settings.bound && ra(Z) > H) {
          a.index = H;
          return;
        }
        a.index = Z;
        return;
      }
      if (Y === ">" && Z === ">") {
        a.index = H;
        return;
      }
      if (Y === "<" && Z === "<") {
        a.index = 0;
        return;
      }
      if (Y === "|" && (ce = a.settings.perView || 1), Y === ">" || Y === "|" && Z === ">") {
        var le = y(ce);
        le > H && (this._o = !0), a.index = T(le, ce);
        return;
      }
      if (Y === "<" || Y === "|" && Z === "<") {
        var K = w(ce);
        K < 0 && (this._o = !0), a.index = O(K, ce);
        return;
      }
      Zu("Invalid direction pattern [".concat(Y).concat(Z, "] has been used"));
    },
    /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */
    isStart: function() {
      return a.index <= 0;
    },
    /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */
    isEnd: function() {
      return a.index >= this.length;
    },
    /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */
    isOffset: function() {
      var z = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
      return z ? this._o ? z === "|>" ? this.move.direction === "|" && this.move.steps === ">" : z === "|<" ? this.move.direction === "|" && this.move.steps === "<" : this.move.direction === z : !1 : this._o;
    },
    /**
     * Checks if bound mode is active
     *
     * @return {Boolean}
     */
    isBound: function() {
      return a.isType("slider") && a.settings.focusAt !== "center" && a.settings.bound;
    }
  };
  function y(_) {
    var z = a.index;
    return a.isType("carousel") ? z + _ : z + (_ - z % _);
  }
  function T(_, z) {
    var H = v.length;
    return _ <= H ? _ : a.isType("carousel") ? _ - (H + 1) : a.settings.rewind ? v.isBound() && !v.isEnd() ? H : 0 : v.isBound() ? H : Math.floor(H / z) * z;
  }
  function w(_) {
    var z = a.index;
    if (a.isType("carousel"))
      return z - _;
    var H = Math.ceil(z / _);
    return (H - 1) * _;
  }
  function O(_, z) {
    var H = v.length;
    return _ >= 0 ? _ : a.isType("carousel") ? _ + (H + 1) : a.settings.rewind ? v.isBound() && v.isStart() ? H : Math.floor(H / z) * z : 0;
  }
  return Mn(v, "move", {
    /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */
    get: function() {
      return this._m;
    },
    /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */
    set: function(z) {
      var H = z.substr(1);
      this._m = {
        direction: z.substr(0, 1),
        steps: H ? ra(H) ? ra(H) : H : 0
      };
    }
  }), Mn(v, "length", {
    /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */
    get: function() {
      var z = a.settings, H = o.Html.slides.length;
      return this.isBound() ? H - 1 - (ra(z.perView) - 1) + ra(z.focusAt) : H - 1;
    }
  }), Mn(v, "offset", {
    /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */
    get: function() {
      return this._o;
    }
  }), v;
}
function Zb() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function gh(a, o) {
  var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, v, y, T, w, O = 0, _ = function() {
    O = f.leading === !1 ? 0 : Zb(), v = null, w = a.apply(y, T), v || (y = T = null);
  }, z = function() {
    var Z = Zb();
    !O && f.leading === !1 && (O = Z);
    var Y = o - (Z - O);
    return y = this, T = arguments, Y <= 0 || Y > o ? (v && (clearTimeout(v), v = null), O = Z, w = a.apply(y, T), v || (y = T = null)) : !v && f.trailing !== !1 && (v = setTimeout(_, Y)), w;
  };
  return z.cancel = function() {
    clearTimeout(v), O = 0, v = y = T = null;
  }, z;
}
var Bd = {
  ltr: ["marginLeft", "marginRight"],
  rtl: ["marginRight", "marginLeft"]
};
function ox(a, o, f) {
  var v = {
    /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */
    apply: function(T) {
      for (var w = 0, O = T.length; w < O; w++) {
        var _ = T[w].style, z = o.Direction.value;
        w !== 0 ? _[Bd[z][0]] = "".concat(this.value / 2, "px") : _[Bd[z][0]] = "", w !== T.length - 1 ? _[Bd[z][1]] = "".concat(this.value / 2, "px") : _[Bd[z][1]] = "";
      }
    },
    /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */
    remove: function(T) {
      for (var w = 0, O = T.length; w < O; w++) {
        var _ = T[w].style;
        _.marginLeft = "", _.marginRight = "";
      }
    }
  };
  return Mn(v, "value", {
    /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */
    get: function() {
      return ra(a.settings.gap);
    }
  }), Mn(v, "grow", {
    /**
     * Gets additional dimensions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */
    get: function() {
      return v.value * o.Sizes.length;
    }
  }), Mn(v, "reductor", {
    /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */
    get: function() {
      var T = a.settings.perView;
      return v.value * (T - 1) / T;
    }
  }), f.on(["build.after", "update"], gh(function() {
    v.apply(o.Html.wrapper.children);
  }, 30)), f.on("destroy", function() {
    v.remove(o.Html.wrapper.children);
  }), v;
}
function u0(a) {
  if (a && a.parentNode) {
    for (var o = a.parentNode.firstChild, f = []; o; o = o.nextSibling)
      o.nodeType === 1 && o !== a && f.push(o);
    return f;
  }
  return [];
}
function Jg(a) {
  return Array.prototype.slice.call(a);
}
var sx = '[data-glide-el="track"]';
function fx(a, o, f) {
  var v = {
    /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */
    mount: function() {
      this.root = a.selector, this.track = this.root.querySelector(sx), this.collectSlides();
    },
    /**
     * Collect slides
     */
    collectSlides: function() {
      this.slides = Jg(this.wrapper.children).filter(function(T) {
        return !T.classList.contains(a.settings.classes.slide.clone);
      });
    }
  };
  return Mn(v, "root", {
    /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */
    get: function() {
      return v._r;
    },
    /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */
    set: function(T) {
      Qg(T) && (T = document.querySelector(T)), T !== null ? v._r = T : Zu("Root element must be a existing Html node");
    }
  }), Mn(v, "track", {
    /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */
    get: function() {
      return v._t;
    },
    /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */
    set: function(T) {
      v._t = T;
    }
  }), Mn(v, "wrapper", {
    /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */
    get: function() {
      return v.track.children[0];
    }
  }), f.on("update", function() {
    v.collectSlides();
  }), v;
}
function dx(a, o, f) {
  var v = {
    /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */
    mount: function() {
      this.value = a.settings.peek;
    }
  };
  return Mn(v, "value", {
    /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */
    get: function() {
      return v._v;
    },
    /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */
    set: function(T) {
      Hs(T) ? (T.before = ra(T.before), T.after = ra(T.after)) : T = ra(T), v._v = T;
    }
  }), Mn(v, "reductor", {
    /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */
    get: function() {
      var T = v.value, w = a.settings.perView;
      return Hs(T) ? T.before / w + T.after / w : T * 2 / w;
    }
  }), f.on(["resize", "update"], function() {
    v.mount();
  }), v;
}
function hx(a, o, f) {
  var v = {
    /**
     * Constructs move component.
     *
     * @returns {Void}
     */
    mount: function() {
      this._o = 0;
    },
    /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */
    make: function() {
      var T = this, w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.offset = w, f.emit("move", {
        movement: this.value
      }), o.Transition.after(function() {
        f.emit("move.after", {
          movement: T.value
        });
      });
    }
  };
  return Mn(v, "offset", {
    /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    get: function() {
      return v._o;
    },
    /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    set: function(T) {
      v._o = r0(T) ? 0 : ra(T);
    }
  }), Mn(v, "translate", {
    /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */
    get: function() {
      return o.Sizes.slideWidth * a.index;
    }
  }), Mn(v, "value", {
    /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */
    get: function() {
      var T = this.offset, w = this.translate;
      return o.Direction.is("rtl") ? w + T : w - T;
    }
  }), f.on(["build.before", "run"], function() {
    v.make();
  }), v;
}
function gx(a, o, f) {
  var v = {
    /**
     * Setups dimensions of slides.
     *
     * @return {Void}
     */
    setupSlides: function() {
      for (var T = "".concat(this.slideWidth, "px"), w = o.Html.slides, O = 0; O < w.length; O++)
        w[O].style.width = T;
    },
    /**
     * Setups dimensions of slides wrapper.
     *
     * @return {Void}
     */
    setupWrapper: function() {
      o.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
    },
    /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */
    remove: function() {
      for (var T = o.Html.slides, w = 0; w < T.length; w++)
        T[w].style.width = "";
      o.Html.wrapper.style.width = "";
    }
  };
  return Mn(v, "length", {
    /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */
    get: function() {
      return o.Html.slides.length;
    }
  }), Mn(v, "width", {
    /**
     * Gets width value of the slider (visible area).
     *
     * @return {Number}
     */
    get: function() {
      return o.Html.track.offsetWidth;
    }
  }), Mn(v, "wrapperSize", {
    /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */
    get: function() {
      return v.slideWidth * v.length + o.Gaps.grow + o.Clones.grow;
    }
  }), Mn(v, "slideWidth", {
    /**
     * Gets width value of a single slide.
     *
     * @return {Number}
     */
    get: function() {
      return v.width / a.settings.perView - o.Peek.reductor - o.Gaps.reductor;
    }
  }), f.on(["build.before", "resize", "update"], function() {
    v.setupSlides(), v.setupWrapper();
  }), f.on("destroy", function() {
    v.remove();
  }), v;
}
function vx(a, o, f) {
  var v = {
    /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */
    mount: function() {
      f.emit("build.before"), this.typeClass(), this.activeClass(), f.emit("build.after");
    },
    /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */
    typeClass: function() {
      o.Html.root.classList.add(a.settings.classes.type[a.settings.type]);
    },
    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    activeClass: function() {
      var T = a.settings.classes, w = o.Html.slides[a.index];
      w && (w.classList.add(T.slide.active), u0(w).forEach(function(O) {
        O.classList.remove(T.slide.active);
      }));
    },
    /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */
    removeClasses: function() {
      var T = a.settings.classes, w = T.type, O = T.slide;
      o.Html.root.classList.remove(w[a.settings.type]), o.Html.slides.forEach(function(_) {
        _.classList.remove(O.active);
      });
    }
  };
  return f.on(["destroy", "update"], function() {
    v.removeClasses();
  }), f.on(["resize", "update"], function() {
    v.mount();
  }), f.on("move.after", function() {
    v.activeClass();
  }), v;
}
function yx(a, o, f) {
  var v = {
    /**
     * Create pattern map and collect slides to be cloned.
     */
    mount: function() {
      this.items = [], a.isType("carousel") && (this.items = this.collect());
    },
    /**
     * Collect clones with pattern.
     *
     * @return {[]}
     */
    collect: function() {
      var T = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], w = o.Html.slides, O = a.settings, _ = O.perView, z = O.classes, H = O.cloningRatio;
      if (w.length > 0)
        for (var Z = +!!a.settings.peek, Y = _ + Z + Math.round(_ / 2), ce = w.slice(0, Y).reverse(), le = w.slice(Y * -1), K = 0; K < Math.max(H, Math.floor(_ / w.length)); K++) {
          for (var he = 0; he < ce.length; he++) {
            var ye = ce[he].cloneNode(!0);
            ye.classList.add(z.slide.clone), T.push(ye);
          }
          for (var de = 0; de < le.length; de++) {
            var ze = le[de].cloneNode(!0);
            ze.classList.add(z.slide.clone), T.unshift(ze);
          }
        }
      return T;
    },
    /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */
    append: function() {
      for (var T = this.items, w = o.Html, O = w.wrapper, _ = w.slides, z = Math.floor(T.length / 2), H = T.slice(0, z).reverse(), Z = T.slice(z * -1).reverse(), Y = "".concat(o.Sizes.slideWidth, "px"), ce = 0; ce < Z.length; ce++)
        O.appendChild(Z[ce]);
      for (var le = 0; le < H.length; le++)
        O.insertBefore(H[le], _[0]);
      for (var K = 0; K < T.length; K++)
        T[K].style.width = Y;
    },
    /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */
    remove: function() {
      for (var T = this.items, w = 0; w < T.length; w++)
        o.Html.wrapper.removeChild(T[w]);
    }
  };
  return Mn(v, "grow", {
    /**
     * Gets additional dimensions value caused by clones.
     *
     * @return {Number}
     */
    get: function() {
      return (o.Sizes.slideWidth + o.Gaps.value) * v.items.length;
    }
  }), f.on("update", function() {
    v.remove(), v.mount(), v.append();
  }), f.on("build.before", function() {
    a.isType("carousel") && v.append();
  }), f.on("destroy", function() {
    v.remove();
  }), v;
}
var eo = /* @__PURE__ */ (function() {
  function a() {
    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    dh(this, a), this.listeners = o;
  }
  return hh(a, [{
    key: "on",
    value: function(f, v, y) {
      var T = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
      Qg(f) && (f = [f]);
      for (var w = 0; w < f.length; w++)
        this.listeners[f[w]] = y, v.addEventListener(f[w], this.listeners[f[w]], T);
    }
    /**
     * Removes event listeners from arrows HTML elements.
     *
     * @param  {String|Array} events
     * @param  {Element|Window|Document} el
     * @param  {Boolean|Object} capture
     * @return {Void}
     */
  }, {
    key: "off",
    value: function(f, v) {
      var y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
      Qg(f) && (f = [f]);
      for (var T = 0; T < f.length; T++)
        v.removeEventListener(f[T], this.listeners[f[T]], y);
    }
    /**
     * Destroy collected listeners.
     *
     * @returns {Void}
     */
  }, {
    key: "destroy",
    value: function() {
      delete this.listeners;
    }
  }]), a;
})();
function bx(a, o, f) {
  var v = new eo(), y = {
    /**
     * Initializes window bindings.
     */
    mount: function() {
      this.bind();
    },
    /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */
    bind: function() {
      v.on("resize", window, gh(function() {
        f.emit("resize");
      }, a.settings.throttle));
    },
    /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */
    unbind: function() {
      v.off("resize", window);
    }
  };
  return f.on("destroy", function() {
    y.unbind(), v.destroy();
  }), y;
}
var mx = ["ltr", "rtl"], Tx = {
  ">": "<",
  "<": ">",
  "=": "="
};
function px(a, o, f) {
  var v = {
    /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */
    mount: function() {
      this.value = a.settings.direction;
    },
    /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */
    resolve: function(T) {
      var w = T.slice(0, 1);
      return this.is("rtl") ? T.split(w).join(Tx[w]) : T;
    },
    /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */
    is: function(T) {
      return this.value === T;
    },
    /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */
    addClass: function() {
      o.Html.root.classList.add(a.settings.classes.direction[this.value]);
    },
    /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */
    removeClass: function() {
      o.Html.root.classList.remove(a.settings.classes.direction[this.value]);
    }
  };
  return Mn(v, "value", {
    /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */
    get: function() {
      return v._v;
    },
    /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */
    set: function(T) {
      mx.indexOf(T) > -1 ? v._v = T : Zu("Direction value must be `ltr` or `rtl`");
    }
  }), f.on(["destroy", "update"], function() {
    v.removeClass();
  }), f.on("update", function() {
    v.mount();
  }), f.on(["build.before", "update"], function() {
    v.addClass();
  }), v;
}
function Sx(a, o) {
  return {
    /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(v) {
      return o.Direction.is("rtl") ? -v : v;
    }
  };
}
function xx(a, o) {
  return {
    /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(v) {
      var y = Math.floor(v / o.Sizes.slideWidth);
      return v + o.Gaps.value * y;
    }
  };
}
function Ex(a, o) {
  return {
    /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(v) {
      return v + o.Clones.grow / 2;
    }
  };
}
function wx(a, o) {
  return {
    /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(v) {
      if (a.settings.focusAt >= 0) {
        var y = o.Peek.value;
        return Hs(y) ? v - y.before : v - y;
      }
      return v;
    }
  };
}
function Ax(a, o) {
  return {
    /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(v) {
      var y = o.Gaps.value, T = o.Sizes.width, w = a.settings.focusAt, O = o.Sizes.slideWidth;
      return w === "center" ? v - (T / 2 - O / 2) : v - O * w - y * w;
    }
  };
}
function Ox(a, o, f) {
  var v = [xx, Ex, wx, Ax].concat(a._t, [Sx]);
  return {
    /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    mutate: function(T) {
      for (var w = 0; w < v.length; w++) {
        var O = v[w];
        $d(O) && $d(O().modify) ? T = O(a, o, f).modify(T) : Zu("Transformer should be a function that returns an object with `modify()` method");
      }
      return T;
    }
  };
}
function Cx(a, o, f) {
  var v = {
    /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */
    set: function(T) {
      var w = Ox(a, o).mutate(T), O = "translate3d(".concat(-1 * w, "px, 0px, 0px)");
      o.Html.wrapper.style.mozTransform = O, o.Html.wrapper.style.webkitTransform = O, o.Html.wrapper.style.transform = O;
    },
    /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */
    remove: function() {
      o.Html.wrapper.style.transform = "";
    },
    /**
     * @return {number}
     */
    getStartIndex: function() {
      var T = o.Sizes.length, w = a.index, O = a.settings.perView;
      return o.Run.isOffset(">") || o.Run.isOffset("|>") ? T + (w - O) : (w + O) % T;
    },
    /**
     * @return {number}
     */
    getTravelDistance: function() {
      var T = o.Sizes.slideWidth * a.settings.perView;
      return o.Run.isOffset(">") || o.Run.isOffset("|>") ? T * -1 : T;
    }
  };
  return f.on("move", function(y) {
    if (!a.isType("carousel") || !o.Run.isOffset())
      return v.set(y.movement);
    o.Transition.after(function() {
      f.emit("translate.jump"), v.set(o.Sizes.slideWidth * a.index);
    });
    var T = o.Sizes.slideWidth * o.Translate.getStartIndex();
    return v.set(T - o.Translate.getTravelDistance());
  }), f.on("destroy", function() {
    v.remove();
  }), v;
}
function Rx(a, o, f) {
  var v = !1, y = {
    /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */
    compose: function(w) {
      var O = a.settings;
      return v ? "".concat(w, " 0ms ").concat(O.animationTimingFunc) : "".concat(w, " ").concat(this.duration, "ms ").concat(O.animationTimingFunc);
    },
    /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */
    set: function() {
      var w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
      o.Html.wrapper.style.transition = this.compose(w);
    },
    /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */
    remove: function() {
      o.Html.wrapper.style.transition = "";
    },
    /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */
    after: function(w) {
      setTimeout(function() {
        w();
      }, this.duration);
    },
    /**
     * Enable transition.
     *
     * @return {Void}
     */
    enable: function() {
      v = !1, this.set();
    },
    /**
     * Disable transition.
     *
     * @return {Void}
     */
    disable: function() {
      v = !0, this.set();
    }
  };
  return Mn(y, "duration", {
    /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */
    get: function() {
      var w = a.settings;
      return a.isType("slider") && o.Run.offset ? w.rewindDuration : w.animationDuration;
    }
  }), f.on("move", function() {
    y.set();
  }), f.on(["build.before", "resize", "translate.jump"], function() {
    y.disable();
  }), f.on("run", function() {
    y.enable();
  }), f.on("destroy", function() {
    y.remove();
  }), y;
}
var c0 = !1;
try {
  var Vb = Object.defineProperty({}, "passive", {
    get: function() {
      c0 = !0;
    }
  });
  window.addEventListener("testPassive", null, Vb), window.removeEventListener("testPassive", null, Vb);
} catch {
}
var Kg = c0, Hd = ["touchstart", "mousedown"], Qb = ["touchmove", "mousemove"], Wb = ["touchend", "touchcancel", "mouseup", "mouseleave"], Pb = ["mousedown", "mousemove", "mouseup", "mouseleave"];
function _x(a, o, f) {
  var v = new eo(), y = 0, T = 0, w = 0, O = !1, _ = Kg ? {
    passive: !0
  } : !1, z = {
    /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */
    mount: function() {
      this.bindSwipeStart();
    },
    /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */
    start: function(Z) {
      if (!O && !a.disabled) {
        this.disable();
        var Y = this.touches(Z);
        y = null, T = ra(Y.pageX), w = ra(Y.pageY), this.bindSwipeMove(), this.bindSwipeEnd(), f.emit("swipe.start");
      }
    },
    /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */
    move: function(Z) {
      if (!a.disabled) {
        var Y = a.settings, ce = Y.touchAngle, le = Y.touchRatio, K = Y.classes, he = this.touches(Z), ye = ra(he.pageX) - T, de = ra(he.pageY) - w, ze = Math.abs(ye << 2), ke = Math.abs(de << 2), pe = Math.sqrt(ze + ke), xe = Math.sqrt(ke);
        if (y = Math.asin(xe / pe), y * 180 / Math.PI < ce)
          Z.stopPropagation(), o.Move.make(ye * lx(le)), o.Html.root.classList.add(K.dragging), f.emit("swipe.move");
        else
          return !1;
      }
    },
    /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */
    end: function(Z) {
      if (!a.disabled) {
        var Y = a.settings, ce = Y.perSwipe, le = Y.touchAngle, K = Y.classes, he = this.touches(Z), ye = this.threshold(Z), de = he.pageX - T, ze = y * 180 / Math.PI;
        this.enable(), de > ye && ze < le ? o.Run.make(o.Direction.resolve("".concat(ce, "<"))) : de < -ye && ze < le ? o.Run.make(o.Direction.resolve("".concat(ce, ">"))) : o.Move.make(), o.Html.root.classList.remove(K.dragging), this.unbindSwipeMove(), this.unbindSwipeEnd(), f.emit("swipe.end");
      }
    },
    /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */
    bindSwipeStart: function() {
      var Z = this, Y = a.settings, ce = Y.swipeThreshold, le = Y.dragThreshold;
      ce && v.on(Hd[0], o.Html.wrapper, function(K) {
        Z.start(K);
      }, _), le && v.on(Hd[1], o.Html.wrapper, function(K) {
        Z.start(K);
      }, _);
    },
    /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */
    unbindSwipeStart: function() {
      v.off(Hd[0], o.Html.wrapper, _), v.off(Hd[1], o.Html.wrapper, _);
    },
    /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */
    bindSwipeMove: function() {
      var Z = this;
      v.on(Qb, o.Html.wrapper, gh(function(Y) {
        Z.move(Y);
      }, a.settings.throttle), _);
    },
    /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */
    unbindSwipeMove: function() {
      v.off(Qb, o.Html.wrapper, _);
    },
    /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */
    bindSwipeEnd: function() {
      var Z = this;
      v.on(Wb, o.Html.wrapper, function(Y) {
        Z.end(Y);
      });
    },
    /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */
    unbindSwipeEnd: function() {
      v.off(Wb, o.Html.wrapper);
    },
    /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */
    touches: function(Z) {
      return Pb.indexOf(Z.type) > -1 ? Z : Z.touches[0] || Z.changedTouches[0];
    },
    /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */
    threshold: function(Z) {
      var Y = a.settings;
      return Pb.indexOf(Z.type) > -1 ? Y.dragThreshold : Y.swipeThreshold;
    },
    /**
     * Enables swipe event.
     *
     * @return {self}
     */
    enable: function() {
      return O = !1, o.Transition.enable(), this;
    },
    /**
     * Disables swipe event.
     *
     * @return {self}
     */
    disable: function() {
      return O = !0, o.Transition.disable(), this;
    }
  };
  return f.on("build.after", function() {
    o.Html.root.classList.add(a.settings.classes.swipeable);
  }), f.on("destroy", function() {
    z.unbindSwipeStart(), z.unbindSwipeMove(), z.unbindSwipeEnd(), v.destroy();
  }), z;
}
function Nx(a, o, f) {
  var v = new eo(), y = {
    /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */
    mount: function() {
      this.bind();
    },
    /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */
    bind: function() {
      v.on("dragstart", o.Html.wrapper, this.dragstart);
    },
    /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */
    unbind: function() {
      v.off("dragstart", o.Html.wrapper);
    },
    /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */
    dragstart: function(w) {
      w.preventDefault();
    }
  };
  return f.on("destroy", function() {
    y.unbind(), v.destroy();
  }), y;
}
function Mx(a, o, f) {
  var v = new eo(), y = !1, T = !1, w = {
    /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */
    mount: function() {
      this._a = o.Html.wrapper.querySelectorAll("a"), this.bind();
    },
    /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */
    bind: function() {
      v.on("click", o.Html.wrapper, this.click);
    },
    /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */
    unbind: function() {
      v.off("click", o.Html.wrapper);
    },
    /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */
    click: function(_) {
      T && (_.stopPropagation(), _.preventDefault());
    },
    /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */
    detach: function() {
      if (T = !0, !y) {
        for (var _ = 0; _ < this.items.length; _++)
          this.items[_].draggable = !1;
        y = !0;
      }
      return this;
    },
    /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */
    attach: function() {
      if (T = !1, y) {
        for (var _ = 0; _ < this.items.length; _++)
          this.items[_].draggable = !0;
        y = !1;
      }
      return this;
    }
  };
  return Mn(w, "items", {
    /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function() {
      return w._a;
    }
  }), f.on("swipe.move", function() {
    w.detach();
  }), f.on("swipe.end", function() {
    o.Transition.after(function() {
      w.attach();
    });
  }), f.on("destroy", function() {
    w.attach(), w.unbind(), v.destroy();
  }), w;
}
var zx = '[data-glide-el="controls[nav]"]', dv = '[data-glide-el^="controls"]', Dx = "".concat(dv, ' [data-glide-dir*="<"]'), kx = "".concat(dv, ' [data-glide-dir*=">"]');
function Lx(a, o, f) {
  var v = new eo(), y = Kg ? {
    passive: !0
  } : !1, T = {
    /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */
    mount: function() {
      this._n = o.Html.root.querySelectorAll(zx), this._c = o.Html.root.querySelectorAll(dv), this._arrowControls = {
        previous: o.Html.root.querySelectorAll(Dx),
        next: o.Html.root.querySelectorAll(kx)
      }, this.addBindings();
    },
    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    setActive: function() {
      for (var O = 0; O < this._n.length; O++)
        this.addClass(this._n[O].children);
    },
    /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */
    removeActive: function() {
      for (var O = 0; O < this._n.length; O++)
        this.removeClass(this._n[O].children);
    },
    /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    addClass: function(O) {
      var _ = a.settings, z = O[a.index];
      z && (z.classList.add(_.classes.nav.active), u0(z).forEach(function(H) {
        H.classList.remove(_.classes.nav.active);
      }));
    },
    /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    removeClass: function(O) {
      var _ = O[a.index];
      _ == null || _.classList.remove(a.settings.classes.nav.active);
    },
    /**
     * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
     */
    setArrowState: function() {
      if (!a.settings.rewind) {
        var O = T._arrowControls.next, _ = T._arrowControls.previous;
        this.resetArrowState(O, _), a.index === 0 && this.disableArrow(_), a.index === o.Run.length && this.disableArrow(O);
      }
    },
    /**
     * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
     *
     * @param {NodeList[]} lists
     */
    resetArrowState: function() {
      for (var O = a.settings, _ = arguments.length, z = new Array(_), H = 0; H < _; H++)
        z[H] = arguments[H];
      z.forEach(function(Z) {
        Jg(Z).forEach(function(Y) {
          Y.classList.remove(O.classes.arrow.disabled);
        });
      });
    },
    /**
     * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
     *
     * @param {NodeList[]} lists
     */
    disableArrow: function() {
      for (var O = a.settings, _ = arguments.length, z = new Array(_), H = 0; H < _; H++)
        z[H] = arguments[H];
      z.forEach(function(Z) {
        Jg(Z).forEach(function(Y) {
          Y.classList.add(O.classes.arrow.disabled);
        });
      });
    },
    /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */
    addBindings: function() {
      for (var O = 0; O < this._c.length; O++)
        this.bind(this._c[O].children);
    },
    /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */
    removeBindings: function() {
      for (var O = 0; O < this._c.length; O++)
        this.unbind(this._c[O].children);
    },
    /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    bind: function(O) {
      for (var _ = 0; _ < O.length; _++)
        v.on("click", O[_], this.click), v.on("touchstart", O[_], this.click, y);
    },
    /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    unbind: function(O) {
      for (var _ = 0; _ < O.length; _++)
        v.off(["click", "touchstart"], O[_]);
    },
    /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in direction given via the
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {void}
     */
    click: function(O) {
      !Kg && O.type === "touchstart" && O.preventDefault();
      var _ = O.currentTarget.getAttribute("data-glide-dir");
      o.Run.make(o.Direction.resolve(_));
    }
  };
  return Mn(T, "items", {
    /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function() {
      return T._c;
    }
  }), f.on(["mount.after", "move.after"], function() {
    T.setActive();
  }), f.on(["mount.after", "run"], function() {
    T.setArrowState();
  }), f.on("destroy", function() {
    T.removeBindings(), T.removeActive(), v.destroy();
  }), T;
}
function Bx(a, o, f) {
  var v = new eo(), y = {
    /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */
    mount: function() {
      a.settings.keyboard && this.bind();
    },
    /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */
    bind: function() {
      v.on("keyup", document, this.press);
    },
    /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */
    unbind: function() {
      v.off("keyup", document);
    },
    /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */
    press: function(w) {
      var O = a.settings.perSwipe, _ = {
        ArrowRight: ">",
        ArrowLeft: "<"
      };
      ["ArrowRight", "ArrowLeft"].includes(w.code) && o.Run.make(o.Direction.resolve("".concat(O).concat(_[w.code])));
    }
  };
  return f.on(["destroy", "update"], function() {
    y.unbind();
  }), f.on("update", function() {
    y.mount();
  }), f.on("destroy", function() {
    v.destroy();
  }), y;
}
function Hx(a, o, f) {
  var v = new eo(), y = {
    /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */
    mount: function() {
      this.enable(), this.start(), a.settings.hoverpause && this.bind();
    },
    /**
     * Enables autoplaying
     *
     * @returns {Void}
     */
    enable: function() {
      this._e = !0;
    },
    /**
     * Disables autoplaying.
     *
     * @returns {Void}
     */
    disable: function() {
      this._e = !1;
    },
    /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */
    start: function() {
      var w = this;
      this._e && (this.enable(), a.settings.autoplay && r0(this._i) && (this._i = setInterval(function() {
        w.stop(), o.Run.make(">"), w.start(), f.emit("autoplay");
      }, this.time)));
    },
    /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */
    stop: function() {
      this._i = clearInterval(this._i);
    },
    /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */
    bind: function() {
      var w = this;
      v.on("mouseover", o.Html.root, function() {
        w._e && w.stop();
      }), v.on("mouseout", o.Html.root, function() {
        w._e && w.start();
      });
    },
    /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */
    unbind: function() {
      v.off(["mouseover", "mouseout"], o.Html.root);
    }
  };
  return Mn(y, "time", {
    /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */
    get: function() {
      var w = o.Html.slides[a.index].getAttribute("data-glide-autoplay");
      return ra(w || a.settings.autoplay);
    }
  }), f.on(["destroy", "update"], function() {
    y.unbind();
  }), f.on(["run.before", "swipe.start", "update"], function() {
    y.stop();
  }), f.on(["pause", "destroy"], function() {
    y.disable(), y.stop();
  }), f.on(["run.after", "swipe.end"], function() {
    y.start();
  }), f.on(["play"], function() {
    y.enable(), y.start();
  }), f.on("update", function() {
    y.mount();
  }), f.on("destroy", function() {
    v.destroy();
  }), y;
}
function Jb(a) {
  return Hs(a) ? ix(a) : (Zu("Breakpoints option must be an object"), {});
}
function Ux(a, o, f) {
  var v = new eo(), y = a.settings, T = Jb(y.breakpoints), w = Object.assign({}, y), O = {
    /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */
    match: function(z) {
      if (typeof window.matchMedia < "u") {
        for (var H in z)
          if (z.hasOwnProperty(H) && window.matchMedia("(max-width: ".concat(H, "px)")).matches)
            return z[H];
      }
      return w;
    }
  };
  return Object.assign(y, O.match(T)), v.on("resize", window, gh(function() {
    a.settings = Pg(y, O.match(T));
  }, a.settings.throttle)), f.on("update", function() {
    T = Jb(T), w = Object.assign({}, y);
  }), f.on("destroy", function() {
    v.off("resize", window);
  }), O;
}
var Fx = {
  // Required
  Html: fx,
  Translate: Cx,
  Transition: Rx,
  Direction: px,
  Peek: dx,
  Sizes: gx,
  Gaps: ox,
  Move: hx,
  Clones: yx,
  Resize: bx,
  Build: vx,
  Run: cx,
  // Optional
  Swipe: _x,
  Images: Nx,
  Anchors: Mx,
  Controls: Lx,
  Keyboard: Bx,
  Autoplay: Hx,
  Breakpoints: Ux
}, Yx = /* @__PURE__ */ (function(a) {
  KS(f, a);
  var o = ex(f);
  function f() {
    return dh(this, f), o.apply(this, arguments);
  }
  return hh(f, [{
    key: "mount",
    value: function() {
      var y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return Wd(Bs(f.prototype), "mount", this).call(this, Object.assign({}, Fx, y));
    }
  }]), f;
})(ux);
function Gx(a) {
  let o, f, v;
  switch (a) {
    case 3:
      o = 1, f = 2, v = 3;
      break;
    case 2:
      o = 1, f = 2, v = 2;
      break;
    case 1:
    default:
      o = 1, f = 1, v = 1;
  }
  return {
    perViewSm: o,
    perViewMd: f,
    perViewLg: v
  };
}
function Xx(a = 1, o, f = !0, v) {
  const { perViewSm: y, perViewMd: T, perViewLg: w } = Gx(a), O = f ? 24 : 0, _ = f ? { before: 48, after: 48 } : 0, z = f ? { before: 124, after: 124 } : 0;
  return {
    type: "slider",
    // No wrap-around.
    focusAt: 0,
    bound: !0,
    // Only if type slider with focusAt 0
    rewind: !1,
    // Only if type slider
    gap: O,
    // Space between slides... may be impacted by viewport size.
    // `keyboard` Left/Right arrow key support for slides - true is default.
    // Is not fully Accessible, on keydown allcarousels move simultaneously
    // A custome keyboard handler is implemented
    keyboard: !1,
    startAt: 0,
    swipeThreshold: 80,
    // Distance required for swipe to change slide.
    dragThreshold: v ? 120 : !1,
    // Distance for mouse drag to change slide.
    perTouch: 1,
    // Number of slides that can be moved per each swipe/drag.
    perView: w,
    // Can be overwritten at breakpoints
    peek: z,
    // Can be overwritten at breakpoints
    // if isFullWidth = true, then we have only 1 image per view which takes the full width.
    // no need for breakpoints
    breakpoints: o ? null : {
      576: {
        // BS4 sm
        perView: y,
        peek: _
      },
      768: {
        // BS4 md
        perView: T,
        peek: _
      },
      992: {
        // BS4 lg
        perView: w,
        peek: _
      },
      1260: {
        // BS4 xl
        perView: w,
        peek: _
      },
      1400: {
        perView: w,
        peek: z
      },
      1920: {
        perView: w,
        peek: z
      }
    }
  };
}
function Ix(a, o, f) {
  const v = a.querySelector(".glide__arrow--prev"), y = a.querySelector(".glide__arrow--next"), T = a.querySelector(".glide__track"), w = a.querySelector(
    ".image-navigator-images"
  );
  if (!(v || y)) return;
  const O = ["slider-start", "slider-mid", "slider-end"], _ = "glide__arrow--disabled";
  T == null || T.classList.remove(...O), w == null || w.classList.remove(...O), o === 0 ? (T == null || T.classList.add("slider-start"), w == null || w.classList.add("slider-start"), v == null || v.classList.add(_), v == null || v.setAttribute("aria-disabled", "true"), y == null || y.classList.remove(_), y == null || y.setAttribute("aria-disabled", "false")) : o >= f - 1 ? (T == null || T.classList.add("slider-end"), w == null || w.classList.add("slider-end"), v == null || v.classList.remove(_), v == null || v.setAttribute("aria-disabled", "false"), y == null || y.classList.add(_), y == null || y.setAttribute("aria-disabled", "true")) : (T == null || T.classList.add("slider-mid"), w == null || w.classList.add("slider-mid"), v == null || v.classList.remove(_), y == null || y.classList.remove(_), v == null || v.setAttribute("aria-disabled", "false"), y == null || y.setAttribute("aria-disabled", "false"));
}
function Zx(a, o, f) {
  const v = a.querySelectorAll(".glide__slide"), y = o, T = Math.min(
    v.length - 1,
    o + f - 1
  );
  v.forEach((w, O) => {
    O < y || O > T ? (w.setAttribute("aria-hidden", "true"), w.setAttribute("tabindex", "-1"), w.setAttribute("inert", "")) : (w.setAttribute("aria-hidden", "false"), w.removeAttribute("tabindex"), w.removeAttribute("inert"));
  });
}
function Vx({
  instanceName: a,
  perView: o,
  buttonCount: f,
  isFullWidth: v = !1,
  onItemClick: y,
  hasPeek: T = !0,
  isDraggable: w
}) {
  const O = Xx(o, v, T, w), _ = new Yx(`#${a}`, O);
  let z = document.querySelector(`#${a}`);
  return z.addEventListener("keyup", (H) => {
    const Z = H;
    Z.keyCode === 39 ? _.go(">") : Z.keyCode === 37 ? _.go("<") : Z.keyCode === 13 && _.go(document.activeElement.dataset.glideDir);
  }), _.on("build.before", () => {
    z = document.querySelector(`#${a}`), z && z.classList.add("slider-start");
  }), _.on("move", () => {
    if (z = document.querySelector(`#${a}`), !z) return;
    const H = _.index;
    Zx(z, H, o);
    const Z = z.querySelector(".navigation-slider"), Y = z.querySelector(".image-navigator-images");
    if (Z && Y) {
      const ce = Z.querySelectorAll(
        ".bullet-image-container"
      ), le = Z.clientWidth, K = 82, he = ce[H], ye = Y.getBoundingClientRect().x, de = Z.getBoundingClientRect().x - ye, ze = he.getBoundingClientRect().x - ye, ke = he.getBoundingClientRect().x + he.getBoundingClientRect().width - ye;
      if (H === 0 || ze <= 0 + K)
        Z.style.left = `${de - ze + K}px`;
      else if (ke >= le - K) {
        const pe = ke - le;
        Z.style.left = `${de - pe - K}px`;
      }
    }
    Ix(z, H, f), z.setAttribute("data-current-index", H), y && y(H);
  }), _.mount(), _;
}
function Qx(a, o) {
  let f;
  const v = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0
  );
  return f = a, v >= 992 && (o >= 2 && (f = a - 1), o >= 3 && (f = a - 2)), f;
}
const Pf = ({
  perView: a = 1,
  width: o,
  maxWidth: f,
  carouselItems: v,
  cssClass: y = "",
  CustomNavComponent: T,
  role: w,
  ariaLabelledBy: O,
  isFullWidth: _,
  removeSideBackground: z = !1,
  hasNavButtons: H = !0,
  hasPositionIndicators: Z = !0,
  imageAutoSize: Y = !0,
  onItemClick: ce = () => null,
  hasPeek: le = !0,
  isDraggable: K = !0,
  hasShadow: he = !0
}) => {
  const ye = `glide-${Math.ceil(Math.random() * 1e4)}`, de = Qx(v.length, a);
  return Da(() => {
    Vx({
      instanceName: ye,
      perView: a,
      buttonCount: de,
      isFullWidth: _,
      onItemClick: ce,
      hasPeek: le,
      isDraggable: K
    });
  }, [
    ye,
    a,
    de,
    _,
    ce,
    le,
    K
  ]), /* @__PURE__ */ A.jsxs(
    "div",
    {
      role: w,
      "aria-labelledby": O,
      className: `glide ${y}`,
      id: ye,
      style: { width: o, maxWidth: f },
      "data-remove-side-background": z,
      "data-image-auto-size": Y,
      "data-has-shadow": he,
      children: [
        /* @__PURE__ */ A.jsx("div", { className: "glide__track", "data-glide-el": "track", children: /* @__PURE__ */ A.jsx(i0, { carouselItems: v }) }),
        T ? (
          // @ts-ignore
          /* @__PURE__ */ A.jsx(T, { instanceName: ye })
        ) : /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
          Z && /* @__PURE__ */ A.jsx(n0, { buttonCount: de }),
          H && /* @__PURE__ */ A.jsx(a0, {})
        ] })
      ]
    }
  );
};
Pf.propTypes = {
  perView: E.number,
  width: E.string,
  maxWidth: E.string,
  carouselItems: E.arrayOf(E.object).isRequired,
  cssClass: E.string,
  CustomNavComponent: E.func,
  role: E.string,
  ariaLabelledBy: E.string,
  onItemClick: E.func,
  isFullWidth: E.bool,
  removeSideBackground: E.bool,
  hasNavButtons: E.bool,
  hasPositionIndicators: E.bool,
  imageAutoSize: E.bool,
  hasPeek: E.bool,
  isDraggable: E.bool,
  hasShadow: E.bool
};
const Wx = ({
  id: a,
  imageSource: o,
  imageAltText: f,
  title: v,
  content: y,
  eventLocation: T,
  eventTime: w,
  buttons: O,
  linkLabel: _,
  linkUrl: z,
  tags: H
}, Z, Y, ce) => {
  var le, K;
  return {
    // @ts-ignore
    id: a,
    item: /* @__PURE__ */ A.jsx(
      Iu,
      {
        type: Z,
        horizontal: Y,
        image: o,
        imageAltText: f,
        title: v,
        body: y,
        eventFormat: ce,
        eventLocation: T,
        eventTime: w,
        buttons: O,
        linkLabel: _,
        linkUrl: z || ((le = O == null ? void 0 : O[0]) == null ? void 0 : le.href),
        tags: H,
        cardLink: z || ((K = O == null ? void 0 : O[0]) == null ? void 0 : K.href)
      }
    )
  };
}, o0 = ({
  perView: a = 0,
  cardItems: o = [],
  cardType: f = "default",
  cardEventFormat: v = "stack",
  cardHorizontal: y = !1,
  width: T = void 0,
  maxWidth: w = void 0,
  imageAutoSize: O = !0
}) => {
  const _ = parseInt(`${a}`, 10), [z, H] = ua(_), Z = 1024, Y = 768;
  Da(() => {
    const K = () => {
      const he = window.innerWidth;
      let ye;
      switch (_) {
        case 3:
          he > Z ? ye = 3 : he > Y ? ye = 2 : ye = 1;
          break;
        case 2:
          ye = he < Y ? 1 : 2;
          break;
        default:
          ye = 1;
          break;
      }
      H(ye);
    };
    return K(), window.addEventListener("resize", K), () => window.removeEventListener("resize", K);
  }, [_]);
  const ce = o.map(
    (K) => Wx(K, f, y, v)
  ), le = o.length > z;
  return /* @__PURE__ */ A.jsx(
    Pf,
    {
      perView: +z,
      maxWidth: w,
      width: T,
      carouselItems: ce,
      cssClass: "aligned-carousel",
      imageAutoSize: O,
      removeSideBackground: o.length <= z,
      hasPositionIndicators: le,
      hasNavButtons: le,
      isDraggable: le,
      hasShadow: !0
    }
  );
};
o0.propTypes = {
  perView: E.string.isRequired,
  cardItems: E.arrayOf(
    E.shape({
      title: E.string.isRequired,
      content: E.string,
      eventLocation: E.string,
      eventTime: E.string,
      image: E.string,
      imageAltText: E.string,
      buttons: Iu.propTypes.buttons,
      linkLabel: E.string,
      linkUrl: E.string,
      tags: Iu.propTypes.tags
    })
  ).isRequired,
  cardType: Iu.propTypes.type,
  cardEventFormat: Iu.propTypes.eventFormat,
  cardHorizontal: Iu.propTypes.horizontal,
  width: E.string,
  maxWidth: E.string,
  imageAutoSize: E.bool
};
const Px = ({ id: a, imageSource: o, imageAltText: f, title: v, content: y }) => ({
  // @ts-ignore
  id: a,
  item: /* @__PURE__ */ A.jsx("div", { className: "uds-img", children: /* @__PURE__ */ A.jsxs("figure", { className: "figure uds-figure", children: [
    /* @__PURE__ */ A.jsx(
      "img",
      {
        src: o,
        className: "uds-img figure-img img-fluid",
        alt: f,
        loading: "lazy",
        decoding: "async"
      }
    ),
    (v || y) && /* @__PURE__ */ A.jsx(
      "figcaption",
      {
        className: "figure-caption uds-figure-caption",
        "data-testid": "image-content-container",
        children: /* @__PURE__ */ A.jsx("div", { className: "uds-caption-text", children: v ? /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
          /* @__PURE__ */ A.jsx("h2", { children: v }),
          /* @__PURE__ */ A.jsx("div", { dangerouslySetInnerHTML: { __html: y } })
        ] }) : /* @__PURE__ */ A.jsx("div", { dangerouslySetInnerHTML: { __html: y } }) })
      }
    )
  ] }) })
}), s0 = ({
  perView: a = 0,
  imageItems: o = [],
  width: f = void 0,
  maxWidth: v = void 0,
  imageAutoSize: y = !0
}) => {
  if (!o || o.length === 0)
    return null;
  const T = parseInt(`${a}`, 10), w = o.map(Px) || [], O = o.length > T;
  return /* @__PURE__ */ A.jsx(
    Pf,
    {
      perView: +T,
      maxWidth: v,
      width: f,
      cssClass: "image-carousel aligned-carousel",
      carouselItems: w,
      imageAutoSize: y,
      removeSideBackground: o.length <= T,
      hasPositionIndicators: O,
      hasNavButtons: O,
      isDraggable: O,
      hasShadow: !0
    }
  );
};
s0.propTypes = {
  perView: E.number.isRequired,
  imageItems: E.arrayOf(E.object).isRequired,
  width: E.string,
  maxWidth: E.string,
  imageAutoSize: E.bool
};
const Jx = (a, o) => {
  if (!a)
    return 0;
  const f = (a.match(/<br/g) || []).length, v = o / 6;
  return (parseInt(`${a.length / v}`, 10) + f) * 20;
}, eh = {
  imageItems: E.arrayOf(
    E.shape({
      id: E.number,
      imageSource: E.string,
      thumbnailSource: E.string,
      imageAltText: E.string,
      content: E.oneOfType([E.string, E.element])
    })
  ),
  hasContent: E.bool
}, Kx = ({ id: a, imageSource: o, imageAltText: f }) => ({
  // @ts-ignore
  id: a,
  item: /* @__PURE__ */ A.jsx("div", { className: "uds-img", children: /* @__PURE__ */ A.jsx(
    "img",
    {
      src: o,
      className: "uds-img figure-img img-fluid",
      alt: f,
      loading: "lazy",
      decoding: "async"
    }
  ) })
}), f0 = ({ instanceName: a, imageItems: o, hasContent: f }) => {
  var H, Z;
  const v = "data-current-index", [y, T] = ua(((H = o == null ? void 0 : o[0]) == null ? void 0 : H.title) || ""), [w, O] = ua(((Z = o == null ? void 0 : o[0]) == null ? void 0 : Z.content) || ""), _ = Ds(
    (Y) => {
      const ce = o == null ? void 0 : o[Y];
      ce && (T(ce.title), O(ce.content));
    },
    [o]
  );
  if (Da(() => {
    if (!o || o.length === 0)
      return;
    const Y = document.querySelector(
      ".image-gallery figcaption .uds-caption-text div"
    );
    if (Y) {
      const he = parseInt(
        window.getComputedStyle(Y, null).getPropertyValue("width").split("px")[0],
        10
      ), ye = o.reduce((de, ze) => {
        const ke = Jx(ze.content, he);
        return ke > de ? ke : de;
      }, 0);
      Y.style.height = `${ye}px`;
    }
    const ce = document.querySelector(`#${a}`);
    if (!ce)
      return;
    function le(he) {
      for (const ye of he)
        if (ye && ye.attributeName === v) {
          const de = ce.getAttribute(v);
          de !== null && _(+de);
          return;
        }
    }
    const K = new MutationObserver(le);
    return K.observe(ce, {
      attributes: !0
    }), () => {
      K.disconnect();
    };
  }, [a, o, _]), !o || o.length === 0)
    return null;
  const z = o.map((Y) => Y.imageSource);
  return /* @__PURE__ */ A.jsxs("div", { className: "image-gallery-action-area", "data-has-content": f, children: [
    /* @__PURE__ */ A.jsx("div", { className: "image-navigator", children: /* @__PURE__ */ A.jsxs(fv, { children: [
      /* @__PURE__ */ A.jsx(sv, {}),
      /* @__PURE__ */ A.jsx("div", { className: "image-navigator-images", children: /* @__PURE__ */ A.jsx("div", { className: "navigation-slider", children: /* @__PURE__ */ A.jsx(
        l0,
        {
          imageItems: z,
          onItemClick: (Y) => _(Y)
        }
      ) }) }),
      /* @__PURE__ */ A.jsx(ov, {})
    ] }) }),
    f && (y || w) ? /* @__PURE__ */ A.jsx(
      "figcaption",
      {
        id: "caption",
        className: "figure-caption uds-figure-caption",
        "data-testid": "image-gallery-content-container",
        children: /* @__PURE__ */ A.jsxs("div", { className: "uds-caption-text", children: [
          y ? /* @__PURE__ */ A.jsx("h2", { children: y }) : null,
          /* @__PURE__ */ A.jsx("div", { dangerouslySetInnerHTML: { __html: w } })
        ] })
      }
    ) : null
  ] });
};
f0.propTypes = {
  instanceName: E.string,
  imageItems: eh.imageItems,
  hasContent: eh.hasContent
};
const d0 = ({
  width: a,
  maxWidth: o,
  imageItems: f = [],
  hasContent: v = !1,
  imageAutoSize: y = !0
}) => {
  const T = f.map(Kx), w = f.length > 1;
  return /* @__PURE__ */ A.jsx(
    Pf,
    {
      perView: 1,
      maxWidth: o,
      width: a,
      carouselItems: T,
      cssClass: "image-gallery",
      role: "figure",
      ariaLabelledBy: v ? "caption" : null,
      isFullWidth: !0,
      imageAutoSize: y,
      hasPeek: !1,
      CustomNavComponent: ({ instanceName: O }) => /* @__PURE__ */ A.jsx(
        f0,
        {
          instanceName: O,
          hasContent: v,
          imageItems: f
        }
      ),
      removeSideBackground: f.length <= 1,
      hasPositionIndicators: w,
      hasNavButtons: w,
      isDraggable: w,
      hasShadow: !0
    }
  );
};
d0.propTypes = {
  imageItems: eh.imageItems.isRequired,
  hasContent: eh.hasContent,
  width: E.string,
  maxWidth: E.string,
  imageAutoSize: E.bool
};
const jx = ({ id: a, imageSource: o, imageAltText: f, quote: v }, y = {}) => ({
  // @ts-ignore
  id: a,
  item: /* @__PURE__ */ A.jsx(
    uv,
    {
      imageSource: o,
      imageAltText: f,
      quote: v,
      itemStyle: y
    }
  )
}), h0 = ({
  width: a,
  maxWidth: o,
  testimonialItems: f = [],
  itemStyle: v = {},
  hasNavButtons: y = !1,
  hasPositionIndicators: T = !1,
  imageAutoSize: w = !0
}) => {
  const O = f.map(
    (_) => jx(_, v)
  );
  return /* @__PURE__ */ A.jsx(
    Pf,
    {
      perView: 1,
      maxWidth: o,
      width: a,
      carouselItems: O,
      isFullWidth: !0,
      removeSideBackground: !0,
      hasNavButtons: y,
      hasPositionIndicators: T,
      imageAutoSize: w,
      hasPeek: !1,
      hasShadow: !1
    }
  );
};
h0.propTypes = {
  testimonialItems: E.arrayOf(
    E.shape({
      title: E.string,
      content: E.string,
      cite: E.shape({
        name: E.string,
        description: E.string
      })
    })
  ).isRequired,
  itemStyle: E.shape({
    containerCssClass: E.arrayOf(E.string),
    titleCssClass: E.arrayOf(E.string),
    contentCssClass: E.arrayOf(E.string)
  }),
  width: E.string,
  maxWidth: E.string,
  imageAutoSize: E.bool,
  hasNavButtons: E.bool,
  hasPositionIndicators: E.bool
};
var qr = /* @__PURE__ */ ((a) => (a.UNORDERED = "unordered", a.ORDERED = "ordered", a.ICON = "icon", a.STEP = "step", a.DISPLAY = "display", a))(qr || {}), Pd = /* @__PURE__ */ ((a) => (a.UL = "ul", a.OL = "ol", a))(Pd || {}), _o = /* @__PURE__ */ ((a) => (a.NONE = "none", a.LIGHT = "light", a.MEDIUM = "medium", a.DARK = "dark", a))(_o || {}), Jd = /* @__PURE__ */ ((a) => (a.DEFAULT = "default", a.PRIMARY = "primary", a.SECONDARY = "secondary", a))(Jd || {});
const g0 = (a) => {
  switch (a) {
    case Pd.OL:
    case qr.ORDERED:
    case qr.STEP:
      return Pd.OL;
    default:
      return Pd.UL;
  }
}, v0 = ({
  listType: a,
  content: o,
  icon: f,
  nestedType: v,
  nestedItems: y
}) => {
  const [T, ...w] = Array.isArray(o) ? o : [o];
  let O = null;
  if (y != null && y.length) {
    const _ = v || a, z = g0(_);
    O = /* @__PURE__ */ A.jsx(z, { children: y.map((H, Z) => /* @__PURE__ */ A.jsx(v0, { listType: _, ...H }, Z)) });
  }
  return /* @__PURE__ */ A.jsxs("li", { children: [
    f && /* @__PURE__ */ A.jsx("span", { className: `fa-li ${f == null ? void 0 : f[0]} fa-${f == null ? void 0 : f[1]}` }),
    T,
    " ",
    w.map((_, z) => [/* @__PURE__ */ A.jsx("br", {}, `br-${z}`), /* @__PURE__ */ A.jsx("span", { children: _ }, z)]),
    O
  ] });
}, qx = ({
  listType: a = qr.UNORDERED,
  backgroundColor: o = _o.NONE,
  listItemStyleColor: f = Jd.DEFAULT,
  items: v
}) => {
  const y = g0(a);
  let T = "maroon", w = "maroon";
  o === _o.DARK && (T = "gold", w = "gold"), a === qr.STEP && (T = "uds-steplist-maroon", w = "uds-steplist-gold", o === _o.DARK && (T = "uds-steplist-gold"));
  const O = Rt({
    "uds-list": a === qr.UNORDERED || a === qr.ORDERED,
    "uds-list fa-ul": a === qr.ICON,
    "uds-list uds-steplist": a === qr.STEP,
    "uds-list uds-display-list": a === qr.DISPLAY,
    "light-smokemode": o === _o.LIGHT,
    smokemode: o === _o.MEDIUM,
    darkmode: o === _o.DARK,
    [`${T}`]: f === Jd.PRIMARY,
    // Intentional space ` ${secondaryColor}` for when primary and secondary colors are the same
    [` ${w}`]: f === Jd.SECONDARY
  });
  return /* @__PURE__ */ A.jsx(y, { className: O || null, children: v.map((_, z) => /* @__PURE__ */ A.jsx(v0, { listType: a, ..._ }, z)) });
}, $x = {
  none: "",
  gold: "text-gold",
  white: "text-white"
}, eE = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, tE = ({
  gridLinkItems: a,
  numColumns: o,
  textColor: f,
  children: v
}) => /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
  /* @__PURE__ */ A.jsx(
    "div",
    {
      className: [
        "uds-grid-links",
        o,
        $x[f]
      ].join(" "),
      children: a && a.map((y) => /* @__PURE__ */ A.jsx(
        yl,
        {
          gaData: {
            ...eE,
            text: y.label,
            section: `grid links ${y.label}`
          },
          children: /* @__PURE__ */ A.jsxs("a", { href: y.href, children: [
            /* @__PURE__ */ A.jsx("span", { className: `fa fa-fw ${y.icon}` }),
            y.label
          ] })
        },
        y.label + y.href
      ))
    }
  ),
  /* @__PURE__ */ A.jsx("div", { children: v })
] });
var wg = { exports: {} }, Uf = {}, Ag = { exports: {} }, Og = {};
var Kb;
function nE() {
  return Kb || (Kb = 1, (function(a) {
    function o(U, Q) {
      var Se = U.length;
      U.push(Q);
      e: for (; 0 < Se; ) {
        var et = Se - 1 >>> 1, re = U[et];
        if (0 < y(re, Q))
          U[et] = Q, U[Se] = re, Se = et;
        else break e;
      }
    }
    function f(U) {
      return U.length === 0 ? null : U[0];
    }
    function v(U) {
      if (U.length === 0) return null;
      var Q = U[0], Se = U.pop();
      if (Se !== Q) {
        U[0] = Se;
        e: for (var et = 0, re = U.length, j = re >>> 1; et < j; ) {
          var ut = 2 * (et + 1) - 1, qe = U[ut], be = ut + 1, Oe = U[be];
          if (0 > y(qe, Se))
            be < re && 0 > y(Oe, qe) ? (U[et] = Oe, U[be] = Se, et = be) : (U[et] = qe, U[ut] = Se, et = ut);
          else if (be < re && 0 > y(Oe, Se))
            U[et] = Oe, U[be] = Se, et = be;
          else break e;
        }
      }
      return Q;
    }
    function y(U, Q) {
      var Se = U.sortIndex - Q.sortIndex;
      return Se !== 0 ? Se : U.id - Q.id;
    }
    if (a.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var T = performance;
      a.unstable_now = function() {
        return T.now();
      };
    } else {
      var w = Date, O = w.now();
      a.unstable_now = function() {
        return w.now() - O;
      };
    }
    var _ = [], z = [], H = 1, Z = null, Y = 3, ce = !1, le = !1, K = !1, he = !1, ye = typeof setTimeout == "function" ? setTimeout : null, de = typeof clearTimeout == "function" ? clearTimeout : null, ze = typeof setImmediate < "u" ? setImmediate : null;
    function ke(U) {
      for (var Q = f(z); Q !== null; ) {
        if (Q.callback === null) v(z);
        else if (Q.startTime <= U)
          v(z), Q.sortIndex = Q.expirationTime, o(_, Q);
        else break;
        Q = f(z);
      }
    }
    function pe(U) {
      if (K = !1, ke(U), !le)
        if (f(_) !== null)
          le = !0, xe || (xe = !0, Xt());
        else {
          var Q = f(z);
          Q !== null && lt(pe, Q.startTime - U);
        }
    }
    var xe = !1, we = -1, Ce = 5, Le = -1;
    function Ht() {
      return he ? !0 : !(a.unstable_now() - Le < Ce);
    }
    function Et() {
      if (he = !1, xe) {
        var U = a.unstable_now();
        Le = U;
        var Q = !0;
        try {
          e: {
            le = !1, K && (K = !1, de(we), we = -1), ce = !0;
            var Se = Y;
            try {
              t: {
                for (ke(U), Z = f(_); Z !== null && !(Z.expirationTime > U && Ht()); ) {
                  var et = Z.callback;
                  if (typeof et == "function") {
                    Z.callback = null, Y = Z.priorityLevel;
                    var re = et(
                      Z.expirationTime <= U
                    );
                    if (U = a.unstable_now(), typeof re == "function") {
                      Z.callback = re, ke(U), Q = !0;
                      break t;
                    }
                    Z === f(_) && v(_), ke(U);
                  } else v(_);
                  Z = f(_);
                }
                if (Z !== null) Q = !0;
                else {
                  var j = f(z);
                  j !== null && lt(
                    pe,
                    j.startTime - U
                  ), Q = !1;
                }
              }
              break e;
            } finally {
              Z = null, Y = Se, ce = !1;
            }
            Q = void 0;
          }
        } finally {
          Q ? Xt() : xe = !1;
        }
      }
    }
    var Xt;
    if (typeof ze == "function")
      Xt = function() {
        ze(Et);
      };
    else if (typeof MessageChannel < "u") {
      var Ee = new MessageChannel(), Ne = Ee.port2;
      Ee.port1.onmessage = Et, Xt = function() {
        Ne.postMessage(null);
      };
    } else
      Xt = function() {
        ye(Et, 0);
      };
    function lt(U, Q) {
      we = ye(function() {
        U(a.unstable_now());
      }, Q);
    }
    a.unstable_IdlePriority = 5, a.unstable_ImmediatePriority = 1, a.unstable_LowPriority = 4, a.unstable_NormalPriority = 3, a.unstable_Profiling = null, a.unstable_UserBlockingPriority = 2, a.unstable_cancelCallback = function(U) {
      U.callback = null;
    }, a.unstable_forceFrameRate = function(U) {
      0 > U || 125 < U ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : Ce = 0 < U ? Math.floor(1e3 / U) : 5;
    }, a.unstable_getCurrentPriorityLevel = function() {
      return Y;
    }, a.unstable_next = function(U) {
      switch (Y) {
        case 1:
        case 2:
        case 3:
          var Q = 3;
          break;
        default:
          Q = Y;
      }
      var Se = Y;
      Y = Q;
      try {
        return U();
      } finally {
        Y = Se;
      }
    }, a.unstable_requestPaint = function() {
      he = !0;
    }, a.unstable_runWithPriority = function(U, Q) {
      switch (U) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          U = 3;
      }
      var Se = Y;
      Y = U;
      try {
        return Q();
      } finally {
        Y = Se;
      }
    }, a.unstable_scheduleCallback = function(U, Q, Se) {
      var et = a.unstable_now();
      switch (typeof Se == "object" && Se !== null ? (Se = Se.delay, Se = typeof Se == "number" && 0 < Se ? et + Se : et) : Se = et, U) {
        case 1:
          var re = -1;
          break;
        case 2:
          re = 250;
          break;
        case 5:
          re = 1073741823;
          break;
        case 4:
          re = 1e4;
          break;
        default:
          re = 5e3;
      }
      return re = Se + re, U = {
        id: H++,
        callback: Q,
        priorityLevel: U,
        startTime: Se,
        expirationTime: re,
        sortIndex: -1
      }, Se > et ? (U.sortIndex = Se, o(z, U), f(_) === null && U === f(z) && (K ? (de(we), we = -1) : K = !0, lt(pe, Se - et))) : (U.sortIndex = re, o(_, U), le || ce || (le = !0, xe || (xe = !0, Xt()))), U;
    }, a.unstable_shouldYield = Ht, a.unstable_wrapCallback = function(U) {
      var Q = Y;
      return function() {
        var Se = Y;
        Y = Q;
        try {
          return U.apply(this, arguments);
        } finally {
          Y = Se;
        }
      };
    };
  })(Og)), Og;
}
var jb;
function lE() {
  return jb || (jb = 1, Ag.exports = nE()), Ag.exports;
}
var qb;
function aE() {
  if (qb) return Uf;
  qb = 1;
  var a = { env: { NODE_ENV: "production" } };
  var o = lE(), f = Gt, v = jg;
  function y(e) {
    var t = "https://react.dev/errors/" + e;
    if (1 < arguments.length) {
      t += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var n = 2; n < arguments.length; n++)
        t += "&args[]=" + encodeURIComponent(arguments[n]);
    }
    return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function T(e) {
    return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
  }
  function w(e) {
    var t = e, n = e;
    if (e.alternate) for (; t.return; ) t = t.return;
    else {
      e = t;
      do
        t = e, (t.flags & 4098) !== 0 && (n = t.return), e = t.return;
      while (e);
    }
    return t.tag === 3 ? n : null;
  }
  function O(e) {
    if (e.tag === 13) {
      var t = e.memoizedState;
      if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
    }
    return null;
  }
  function _(e) {
    if (e.tag === 31) {
      var t = e.memoizedState;
      if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
    }
    return null;
  }
  function z(e) {
    if (w(e) !== e)
      throw Error(y(188));
  }
  function H(e) {
    var t = e.alternate;
    if (!t) {
      if (t = w(e), t === null) throw Error(y(188));
      return t !== e ? null : e;
    }
    for (var n = e, l = t; ; ) {
      var s = n.return;
      if (s === null) break;
      var d = s.alternate;
      if (d === null) {
        if (l = s.return, l !== null) {
          n = l;
          continue;
        }
        break;
      }
      if (s.child === d.child) {
        for (d = s.child; d; ) {
          if (d === n) return z(s), e;
          if (d === l) return z(s), t;
          d = d.sibling;
        }
        throw Error(y(188));
      }
      if (n.return !== l.return) n = s, l = d;
      else {
        for (var S = !1, R = s.child; R; ) {
          if (R === n) {
            S = !0, n = s, l = d;
            break;
          }
          if (R === l) {
            S = !0, l = s, n = d;
            break;
          }
          R = R.sibling;
        }
        if (!S) {
          for (R = d.child; R; ) {
            if (R === n) {
              S = !0, n = d, l = s;
              break;
            }
            if (R === l) {
              S = !0, l = d, n = s;
              break;
            }
            R = R.sibling;
          }
          if (!S) throw Error(y(189));
        }
      }
      if (n.alternate !== l) throw Error(y(190));
    }
    if (n.tag !== 3) throw Error(y(188));
    return n.stateNode.current === n ? e : t;
  }
  function Z(e) {
    var t = e.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return e;
    for (e = e.child; e !== null; ) {
      if (t = Z(e), t !== null) return t;
      e = e.sibling;
    }
    return null;
  }
  var Y = Object.assign, ce = Symbol.for("react.element"), le = Symbol.for("react.transitional.element"), K = Symbol.for("react.portal"), he = Symbol.for("react.fragment"), ye = Symbol.for("react.strict_mode"), de = Symbol.for("react.profiler"), ze = Symbol.for("react.consumer"), ke = Symbol.for("react.context"), pe = Symbol.for("react.forward_ref"), xe = Symbol.for("react.suspense"), we = Symbol.for("react.suspense_list"), Ce = Symbol.for("react.memo"), Le = Symbol.for("react.lazy"), Ht = Symbol.for("react.activity"), Et = Symbol.for("react.memo_cache_sentinel"), Xt = Symbol.iterator;
  function Ee(e) {
    return e === null || typeof e != "object" ? null : (e = Xt && e[Xt] || e["@@iterator"], typeof e == "function" ? e : null);
  }
  var Ne = Symbol.for("react.client.reference");
  function lt(e) {
    if (e == null) return null;
    if (typeof e == "function")
      return e.$$typeof === Ne ? null : e.displayName || e.name || null;
    if (typeof e == "string") return e;
    switch (e) {
      case he:
        return "Fragment";
      case de:
        return "Profiler";
      case ye:
        return "StrictMode";
      case xe:
        return "Suspense";
      case we:
        return "SuspenseList";
      case Ht:
        return "Activity";
    }
    if (typeof e == "object")
      switch (e.$$typeof) {
        case K:
          return "Portal";
        case ke:
          return e.displayName || "Context";
        case ze:
          return (e._context.displayName || "Context") + ".Consumer";
        case pe:
          var t = e.render;
          return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
        case Ce:
          return t = e.displayName || null, t !== null ? t : lt(e.type) || "Memo";
        case Le:
          t = e._payload, e = e._init;
          try {
            return lt(e(t));
          } catch {
          }
      }
    return null;
  }
  var U = Array.isArray, Q = f.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Se = v.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, et = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, re = [], j = -1;
  function ut(e) {
    return { current: e };
  }
  function qe(e) {
    0 > j || (e.current = re[j], re[j] = null, j--);
  }
  function be(e, t) {
    j++, re[j] = e.current, e.current = t;
  }
  var Oe = ut(null), $e = ut(null), Wt = ut(null), bt = ut(null);
  function Gn(e, t) {
    switch (be(Wt, t), be($e, e), be(Oe, null), t.nodeType) {
      case 9:
      case 11:
        e = (e = t.documentElement) && (e = e.namespaceURI) ? dy(e) : 0;
        break;
      default:
        if (e = t.tagName, t = t.namespaceURI)
          t = dy(t), e = hy(t, e);
        else
          switch (e) {
            case "svg":
              e = 1;
              break;
            case "math":
              e = 2;
              break;
            default:
              e = 0;
          }
    }
    qe(Oe), be(Oe, e);
  }
  function An() {
    qe(Oe), qe($e), qe(Wt);
  }
  function Dt(e) {
    e.memoizedState !== null && be(bt, e);
    var t = Oe.current, n = hy(t, e.type);
    t !== n && (be($e, e), be(Oe, n));
  }
  function wi(e) {
    $e.current === e && (qe(Oe), qe($e)), bt.current === e && (qe(bt), Nf._currentValue = et);
  }
  var Ye, $i;
  function Il(e) {
    if (Ye === void 0)
      try {
        throw Error();
      } catch (n) {
        var t = n.stack.trim().match(/\n( *(at )?)/);
        Ye = t && t[1] || "", $i = -1 < n.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < n.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + Ye + e + $i;
  }
  var Zl = !1;
  function _l(e, t) {
    if (!e || Zl) return "";
    Zl = !0;
    var n = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var l = {
        DetermineComponentFrameRoot: function() {
          try {
            if (t) {
              var fe = function() {
                throw Error();
              };
              if (Object.defineProperty(fe.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(fe, []);
                } catch (ne) {
                  var q = ne;
                }
                Reflect.construct(e, [], fe);
              } else {
                try {
                  fe.call();
                } catch (ne) {
                  q = ne;
                }
                e.call(fe.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (ne) {
                q = ne;
              }
              (fe = e()) && typeof fe.catch == "function" && fe.catch(function() {
              });
            }
          } catch (ne) {
            if (ne && q && typeof ne.stack == "string")
              return [ne.stack, q.stack];
          }
          return [null, null];
        }
      };
      l.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var s = Object.getOwnPropertyDescriptor(
        l.DetermineComponentFrameRoot,
        "name"
      );
      s && s.configurable && Object.defineProperty(
        l.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var d = l.DetermineComponentFrameRoot(), S = d[0], R = d[1];
      if (S && R) {
        var B = S.split(`
`), J = R.split(`
`);
        for (s = l = 0; l < B.length && !B[l].includes("DetermineComponentFrameRoot"); )
          l++;
        for (; s < J.length && !J[s].includes(
          "DetermineComponentFrameRoot"
        ); )
          s++;
        if (l === B.length || s === J.length)
          for (l = B.length - 1, s = J.length - 1; 1 <= l && 0 <= s && B[l] !== J[s]; )
            s--;
        for (; 1 <= l && 0 <= s; l--, s--)
          if (B[l] !== J[s]) {
            if (l !== 1 || s !== 1)
              do
                if (l--, s--, 0 > s || B[l] !== J[s]) {
                  var ie = `
` + B[l].replace(" at new ", " at ");
                  return e.displayName && ie.includes("<anonymous>") && (ie = ie.replace("<anonymous>", e.displayName)), ie;
                }
              while (1 <= l && 0 <= s);
            break;
          }
      }
    } finally {
      Zl = !1, Error.prepareStackTrace = n;
    }
    return (n = e ? e.displayName || e.name : "") ? Il(n) : "";
  }
  function nl(e, t) {
    switch (e.tag) {
      case 26:
      case 27:
      case 5:
        return Il(e.type);
      case 16:
        return Il("Lazy");
      case 13:
        return e.child !== t && t !== null ? Il("Suspense Fallback") : Il("Suspense");
      case 19:
        return Il("SuspenseList");
      case 0:
      case 15:
        return _l(e.type, !1);
      case 11:
        return _l(e.type.render, !1);
      case 1:
        return _l(e.type, !0);
      case 31:
        return Il("Activity");
      default:
        return "";
    }
  }
  function rn(e) {
    try {
      var t = "", n = null;
      do
        t += nl(e, n), n = e, e = e.return;
      while (e);
      return t;
    } catch (l) {
      return `
Error generating stack: ` + l.message + `
` + l.stack;
    }
  }
  var Ai = Object.prototype.hasOwnProperty, On = o.unstable_scheduleCallback, Cn = o.unstable_cancelCallback, ca = o.unstable_shouldYield, eu = o.unstable_requestPaint, Ge = o.unstable_now, ll = o.unstable_getCurrentPriorityLevel, Er = o.unstable_ImmediatePriority, Ba = o.unstable_UserBlockingPriority, Ut = o.unstable_NormalPriority, Nl = o.unstable_LowPriority, Oi = o.unstable_IdlePriority, ri = o.log, er = o.unstable_setDisableYieldValue, Ml = null, Xn = null;
  function al(e) {
    if (typeof ri == "function" && er(e), Xn && typeof Xn.setStrictMode == "function")
      try {
        Xn.setStrictMode(Ml, e);
      } catch {
      }
  }
  var vn = Math.clz32 ? Math.clz32 : yn, zl = Math.log, wt = Math.LN2;
  function yn(e) {
    return e >>>= 0, e === 0 ? 32 : 31 - (zl(e) / wt | 0) | 0;
  }
  var Ha = 256, Vl = 262144, Ua = 4194304;
  function Dl(e) {
    var t = e & 42;
    if (t !== 0) return t;
    switch (e & -e) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return e & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return e & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return e & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return e;
    }
  }
  function Fa(e, t, n) {
    var l = e.pendingLanes;
    if (l === 0) return 0;
    var s = 0, d = e.suspendedLanes, S = e.pingedLanes;
    e = e.warmLanes;
    var R = l & 134217727;
    return R !== 0 ? (l = R & ~d, l !== 0 ? s = Dl(l) : (S &= R, S !== 0 ? s = Dl(S) : n || (n = R & ~e, n !== 0 && (s = Dl(n))))) : (R = l & ~d, R !== 0 ? s = Dl(R) : S !== 0 ? s = Dl(S) : n || (n = l & ~e, n !== 0 && (s = Dl(n)))), s === 0 ? 0 : t !== 0 && t !== s && (t & d) === 0 && (d = s & -s, n = t & -t, d >= n || d === 32 && (n & 4194048) !== 0) ? t : s;
  }
  function bn(e, t) {
    return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0;
  }
  function Vu(e, t) {
    switch (e) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return t + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function tu() {
    var e = Ua;
    return Ua <<= 1, (Ua & 62914560) === 0 && (Ua = 4194304), e;
  }
  function ln(e) {
    for (var t = [], n = 0; 31 > n; n++) t.push(e);
    return t;
  }
  function Ql(e, t) {
    e.pendingLanes |= t, t !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
  }
  function tr(e, t, n, l, s, d) {
    var S = e.pendingLanes;
    e.pendingLanes = n, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= n, e.entangledLanes &= n, e.errorRecoveryDisabledLanes &= n, e.shellSuspendCounter = 0;
    var R = e.entanglements, B = e.expirationTimes, J = e.hiddenUpdates;
    for (n = S & ~n; 0 < n; ) {
      var ie = 31 - vn(n), fe = 1 << ie;
      R[ie] = 0, B[ie] = -1;
      var q = J[ie];
      if (q !== null)
        for (J[ie] = null, ie = 0; ie < q.length; ie++) {
          var ne = q[ie];
          ne !== null && (ne.lane &= -536870913);
        }
      n &= ~fe;
    }
    l !== 0 && ui(e, l, 0), d !== 0 && s === 0 && e.tag !== 0 && (e.suspendedLanes |= d & ~(S & ~t));
  }
  function ui(e, t, n) {
    e.pendingLanes |= t, e.suspendedLanes &= ~t;
    var l = 31 - vn(t);
    e.entangledLanes |= t, e.entanglements[l] = e.entanglements[l] | 1073741824 | n & 261930;
  }
  function un(e, t) {
    var n = e.entangledLanes |= t;
    for (e = e.entanglements; n; ) {
      var l = 31 - vn(n), s = 1 << l;
      s & t | e[l] & t && (e[l] |= t), n &= ~s;
    }
  }
  function il(e, t) {
    var n = t & -t;
    return n = (n & 42) !== 0 ? 1 : kt(n), (n & (e.suspendedLanes | t)) !== 0 ? 0 : n;
  }
  function kt(e) {
    switch (e) {
      case 2:
        e = 1;
        break;
      case 8:
        e = 4;
        break;
      case 32:
        e = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        e = 128;
        break;
      case 268435456:
        e = 134217728;
        break;
      default:
        e = 0;
    }
    return e;
  }
  function Ci(e) {
    return e &= -e, 2 < e ? 8 < e ? (e & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function It() {
    var e = Se.p;
    return e !== 0 ? e : (e = window.event, e === void 0 ? 32 : By(e.type));
  }
  function mt(e, t) {
    var n = Se.p;
    try {
      return Se.p = e, t();
    } finally {
      Se.p = n;
    }
  }
  var oa = Math.random().toString(36).slice(2), mn = "__reactFiber$" + oa, zn = "__reactProps$" + oa, Ta = "__reactContainer$" + oa, sa = "__reactEvents$" + oa, fa = "__reactListeners$" + oa, Tt = "__reactHandles$" + oa, _t = "__reactResources$" + oa, pa = "__reactMarker$" + oa;
  function In(e) {
    delete e[mn], delete e[zn], delete e[sa], delete e[fa], delete e[Tt];
  }
  function ci(e) {
    var t = e[mn];
    if (t) return t;
    for (var n = e.parentNode; n; ) {
      if (t = n[Ta] || n[mn]) {
        if (n = t.alternate, t.child !== null || n !== null && n.child !== null)
          for (e = py(e); e !== null; ) {
            if (n = e[mn]) return n;
            e = py(e);
          }
        return t;
      }
      e = n, n = e.parentNode;
    }
    return null;
  }
  function da(e) {
    if (e = e[mn] || e[Ta]) {
      var t = e.tag;
      if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3)
        return e;
    }
    return null;
  }
  function Sa(e) {
    var t = e.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
    throw Error(y(33));
  }
  function Re(e) {
    var t = e[_t];
    return t || (t = e[_t] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), t;
  }
  function k(e) {
    e[pa] = !0;
  }
  var ue = /* @__PURE__ */ new Set(), ge = {};
  function Fe(e, t) {
    At(e, t), At(e + "Capture", t);
  }
  function At(e, t) {
    for (ge[e] = t, e = 0; e < t.length; e++)
      ue.add(t[e]);
  }
  var Nt = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), Rn = {}, xa = {};
  function Ea(e) {
    return Ai.call(xa, e) ? !0 : Ai.call(Rn, e) ? !1 : Nt.test(e) ? xa[e] = !0 : (Rn[e] = !0, !1);
  }
  function Wl(e, t, n) {
    if (Ea(t))
      if (n === null) e.removeAttribute(t);
      else {
        switch (typeof n) {
          case "undefined":
          case "function":
          case "symbol":
            e.removeAttribute(t);
            return;
          case "boolean":
            var l = t.toLowerCase().slice(0, 5);
            if (l !== "data-" && l !== "aria-") {
              e.removeAttribute(t);
              return;
            }
        }
        e.setAttribute(t, "" + n);
      }
  }
  function Zt(e, t, n) {
    if (n === null) e.removeAttribute(t);
    else {
      switch (typeof n) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          e.removeAttribute(t);
          return;
      }
      e.setAttribute(t, "" + n);
    }
  }
  function bl(e, t, n, l) {
    if (l === null) e.removeAttribute(n);
    else {
      switch (typeof l) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          e.removeAttribute(n);
          return;
      }
      e.setAttributeNS(t, n, "" + l);
    }
  }
  function cn(e) {
    switch (typeof e) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return e;
      case "object":
        return e;
      default:
        return "";
    }
  }
  function Qu(e) {
    var t = e.type;
    return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
  }
  function Fs(e, t, n) {
    var l = Object.getOwnPropertyDescriptor(
      e.constructor.prototype,
      t
    );
    if (!e.hasOwnProperty(t) && typeof l < "u" && typeof l.get == "function" && typeof l.set == "function") {
      var s = l.get, d = l.set;
      return Object.defineProperty(e, t, {
        configurable: !0,
        get: function() {
          return s.call(this);
        },
        set: function(S) {
          n = "" + S, d.call(this, S);
        }
      }), Object.defineProperty(e, t, {
        enumerable: l.enumerable
      }), {
        getValue: function() {
          return n;
        },
        setValue: function(S) {
          n = "" + S;
        },
        stopTracking: function() {
          e._valueTracker = null, delete e[t];
        }
      };
    }
  }
  function nr(e) {
    if (!e._valueTracker) {
      var t = Qu(e) ? "checked" : "value";
      e._valueTracker = Fs(
        e,
        t,
        "" + e[t]
      );
    }
  }
  function Tn(e) {
    if (!e) return !1;
    var t = e._valueTracker;
    if (!t) return !0;
    var n = t.getValue(), l = "";
    return e && (l = Qu(e) ? e.checked ? "true" : "false" : e.value), e = l, e !== n ? (t.setValue(e), !0) : !1;
  }
  function Ya(e) {
    if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u") return null;
    try {
      return e.activeElement || e.body;
    } catch {
      return e.body;
    }
  }
  var Wu = /[\n"\\]/g;
  function kl(e) {
    return e.replace(
      Wu,
      function(t) {
        return "\\" + t.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function Ga(e, t, n, l, s, d, S, R) {
    e.name = "", S != null && typeof S != "function" && typeof S != "symbol" && typeof S != "boolean" ? e.type = S : e.removeAttribute("type"), t != null ? S === "number" ? (t === 0 && e.value === "" || e.value != t) && (e.value = "" + cn(t)) : e.value !== "" + cn(t) && (e.value = "" + cn(t)) : S !== "submit" && S !== "reset" || e.removeAttribute("value"), t != null ? nu(e, S, cn(t)) : n != null ? nu(e, S, cn(n)) : l != null && e.removeAttribute("value"), s == null && d != null && (e.defaultChecked = !!d), s != null && (e.checked = s && typeof s != "function" && typeof s != "symbol"), R != null && typeof R != "function" && typeof R != "symbol" && typeof R != "boolean" ? e.name = "" + cn(R) : e.removeAttribute("name");
  }
  function Pu(e, t, n, l, s, d, S, R) {
    if (d != null && typeof d != "function" && typeof d != "symbol" && typeof d != "boolean" && (e.type = d), t != null || n != null) {
      if (!(d !== "submit" && d !== "reset" || t != null)) {
        nr(e);
        return;
      }
      n = n != null ? "" + cn(n) : "", t = t != null ? "" + cn(t) : n, R || t === e.value || (e.value = t), e.defaultValue = t;
    }
    l = l ?? s, l = typeof l != "function" && typeof l != "symbol" && !!l, e.checked = R ? e.checked : !!l, e.defaultChecked = !!l, S != null && typeof S != "function" && typeof S != "symbol" && typeof S != "boolean" && (e.name = S), nr(e);
  }
  function nu(e, t, n) {
    t === "number" && Ya(e.ownerDocument) === e || e.defaultValue === "" + n || (e.defaultValue = "" + n);
  }
  function Pl(e, t, n, l) {
    if (e = e.options, t) {
      t = {};
      for (var s = 0; s < n.length; s++)
        t["$" + n[s]] = !0;
      for (n = 0; n < e.length; n++)
        s = t.hasOwnProperty("$" + e[n].value), e[n].selected !== s && (e[n].selected = s), s && l && (e[n].defaultSelected = !0);
    } else {
      for (n = "" + cn(n), t = null, s = 0; s < e.length; s++) {
        if (e[s].value === n) {
          e[s].selected = !0, l && (e[s].defaultSelected = !0);
          return;
        }
        t !== null || e[s].disabled || (t = e[s]);
      }
      t !== null && (t.selected = !0);
    }
  }
  function to(e, t, n) {
    if (t != null && (t = "" + cn(t), t !== e.value && (e.value = t), n == null)) {
      e.defaultValue !== t && (e.defaultValue = t);
      return;
    }
    e.defaultValue = n != null ? "" + cn(n) : "";
  }
  function Fo(e, t, n, l) {
    if (t == null) {
      if (l != null) {
        if (n != null) throw Error(y(92));
        if (U(l)) {
          if (1 < l.length) throw Error(y(93));
          l = l[0];
        }
        n = l;
      }
      n == null && (n = ""), t = n;
    }
    n = cn(t), e.defaultValue = n, l = e.textContent, l === n && l !== "" && l !== null && (e.value = l), nr(e);
  }
  function ha(e, t) {
    if (t) {
      var n = e.firstChild;
      if (n && n === e.lastChild && n.nodeType === 3) {
        n.nodeValue = t;
        return;
      }
    }
    e.textContent = t;
  }
  var Ju = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function Yo(e, t, n) {
    var l = t.indexOf("--") === 0;
    n == null || typeof n == "boolean" || n === "" ? l ? e.setProperty(t, "") : t === "float" ? e.cssFloat = "" : e[t] = "" : l ? e.setProperty(t, n) : typeof n != "number" || n === 0 || Ju.has(t) ? t === "float" ? e.cssFloat = n : e[t] = ("" + n).trim() : e[t] = n + "px";
  }
  function Go(e, t, n) {
    if (t != null && typeof t != "object")
      throw Error(y(62));
    if (e = e.style, n != null) {
      for (var l in n)
        !n.hasOwnProperty(l) || t != null && t.hasOwnProperty(l) || (l.indexOf("--") === 0 ? e.setProperty(l, "") : l === "float" ? e.cssFloat = "" : e[l] = "");
      for (var s in t)
        l = t[s], t.hasOwnProperty(s) && n[s] !== l && Yo(e, s, l);
    } else
      for (var d in t)
        t.hasOwnProperty(d) && Yo(e, d, t[d]);
  }
  function no(e) {
    if (e.indexOf("-") === -1) return !1;
    switch (e) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var ml = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), Jl = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function Ku(e) {
    return Jl.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
  }
  function ga() {
  }
  var wr = null;
  function lo(e) {
    return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
  }
  var lr = null, Ll = null;
  function ju(e) {
    var t = da(e);
    if (t && (e = t.stateNode)) {
      var n = e[zn] || null;
      e: switch (e = t.stateNode, t.type) {
        case "input":
          if (Ga(
            e,
            n.value,
            n.defaultValue,
            n.defaultValue,
            n.checked,
            n.defaultChecked,
            n.type,
            n.name
          ), t = n.name, n.type === "radio" && t != null) {
            for (n = e; n.parentNode; ) n = n.parentNode;
            for (n = n.querySelectorAll(
              'input[name="' + kl(
                "" + t
              ) + '"][type="radio"]'
            ), t = 0; t < n.length; t++) {
              var l = n[t];
              if (l !== e && l.form === e.form) {
                var s = l[zn] || null;
                if (!s) throw Error(y(90));
                Ga(
                  l,
                  s.value,
                  s.defaultValue,
                  s.defaultValue,
                  s.checked,
                  s.defaultChecked,
                  s.type,
                  s.name
                );
              }
            }
            for (t = 0; t < n.length; t++)
              l = n[t], l.form === e.form && Tn(l);
          }
          break e;
        case "textarea":
          to(e, n.value, n.defaultValue);
          break e;
        case "select":
          t = n.value, t != null && Pl(e, !!n.multiple, t, !1);
      }
    }
  }
  var lu = !1;
  function qu(e, t, n) {
    if (lu) return e(t, n);
    lu = !0;
    try {
      var l = e(t);
      return l;
    } finally {
      if (lu = !1, (lr !== null || Ll !== null) && (cd(), lr && (t = lr, e = Ll, Ll = lr = null, ju(t), e)))
        for (t = 0; t < e.length; t++) ju(e[t]);
    }
  }
  function Ri(e, t) {
    var n = e.stateNode;
    if (n === null) return null;
    var l = n[zn] || null;
    if (l === null) return null;
    n = l[t];
    e: switch (t) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (l = !l.disabled) || (e = e.type, l = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !l;
        break e;
      default:
        e = !1;
    }
    if (e) return null;
    if (n && typeof n != "function")
      throw Error(
        y(231, t, typeof n)
      );
    return n;
  }
  var ot = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), ar = !1;
  if (ot)
    try {
      var _i = {};
      Object.defineProperty(_i, "passive", {
        get: function() {
          ar = !0;
        }
      }), window.addEventListener("test", _i, _i), window.removeEventListener("test", _i, _i);
    } catch {
      ar = !1;
    }
  var va = null, ir = null, Ni = null;
  function au() {
    if (Ni) return Ni;
    var e, t = ir, n = t.length, l, s = "value" in va ? va.value : va.textContent, d = s.length;
    for (e = 0; e < n && t[e] === s[e]; e++) ;
    var S = n - e;
    for (l = 1; l <= S && t[n - l] === s[d - l]; l++) ;
    return Ni = s.slice(e, 1 < l ? 1 - l : void 0);
  }
  function oi(e) {
    var t = e.keyCode;
    return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
  }
  function wa() {
    return !0;
  }
  function iu() {
    return !1;
  }
  function on(e) {
    function t(n, l, s, d, S) {
      this._reactName = n, this._targetInst = s, this.type = l, this.nativeEvent = d, this.target = S, this.currentTarget = null;
      for (var R in e)
        e.hasOwnProperty(R) && (n = e[R], this[R] = n ? n(d) : d[R]);
      return this.isDefaultPrevented = (d.defaultPrevented != null ? d.defaultPrevented : d.returnValue === !1) ? wa : iu, this.isPropagationStopped = iu, this;
    }
    return Y(t.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var n = this.nativeEvent;
        n && (n.preventDefault ? n.preventDefault() : typeof n.returnValue != "unknown" && (n.returnValue = !1), this.isDefaultPrevented = wa);
      },
      stopPropagation: function() {
        var n = this.nativeEvent;
        n && (n.stopPropagation ? n.stopPropagation() : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0), this.isPropagationStopped = wa);
      },
      persist: function() {
      },
      isPersistent: wa
    }), t;
  }
  var Mi = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(e) {
      return e.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, Ar = on(Mi), Xa = Y({}, Mi, { view: 0, detail: 0 }), ru = on(Xa), $u, ec, Or, tc = Y({}, Xa, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zi,
    button: 0,
    buttons: 0,
    relatedTarget: function(e) {
      return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
    },
    movementX: function(e) {
      return "movementX" in e ? e.movementX : (e !== Or && (Or && e.type === "mousemove" ? ($u = e.screenX - Or.screenX, ec = e.screenY - Or.screenY) : ec = $u = 0, Or = e), $u);
    },
    movementY: function(e) {
      return "movementY" in e ? e.movementY : ec;
    }
  }), Xo = on(tc), Ys = Y({}, tc, { dataTransfer: 0 }), Gs = on(Ys), ao = Y({}, Xa, { relatedTarget: 0 }), nc = on(ao), Xs = Y({}, Mi, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), Io = on(Xs), lc = Y({}, Mi, {
    clipboardData: function(e) {
      return "clipboardData" in e ? e.clipboardData : window.clipboardData;
    }
  }), Is = on(lc), io = Y({}, Mi, { data: 0 }), ro = on(io), Cr = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, uo = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, ac = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function Zo(e) {
    var t = this.nativeEvent;
    return t.getModifierState ? t.getModifierState(e) : (e = ac[e]) ? !!t[e] : !1;
  }
  function zi() {
    return Zo;
  }
  var Zs = Y({}, Xa, {
    key: function(e) {
      if (e.key) {
        var t = Cr[e.key] || e.key;
        if (t !== "Unidentified") return t;
      }
      return e.type === "keypress" ? (e = oi(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? uo[e.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zi,
    charCode: function(e) {
      return e.type === "keypress" ? oi(e) : 0;
    },
    keyCode: function(e) {
      return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
    },
    which: function(e) {
      return e.type === "keypress" ? oi(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
    }
  }), Vs = on(Zs), Qs = Y({}, tc, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), Zn = on(Qs), Rr = Y({}, Xa, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zi
  }), co = on(Rr), ic = Y({}, Mi, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), Vo = on(ic), rr = Y({}, tc, {
    deltaX: function(e) {
      return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
    },
    deltaY: function(e) {
      return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Di = on(rr), uu = Y({}, Mi, {
    newState: 0,
    oldState: 0
  }), ki = on(uu), rl = [9, 13, 27, 32], Li = ot && "CompositionEvent" in window, Ot = null;
  ot && "documentMode" in document && (Ot = document.documentMode);
  var Ia = ot && "TextEvent" in window && !Ot, rc = ot && (!Li || Ot && 8 < Ot && 11 >= Ot), _r = " ", oo = !1;
  function uc(e, t) {
    switch (e) {
      case "keyup":
        return rl.indexOf(t.keyCode) !== -1;
      case "keydown":
        return t.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function so(e) {
    return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
  }
  var si = !1;
  function cc(e, t) {
    switch (e) {
      case "compositionend":
        return so(t);
      case "keypress":
        return t.which !== 32 ? null : (oo = !0, _r);
      case "textInput":
        return e = t.data, e === _r && oo ? null : e;
      default:
        return null;
    }
  }
  function ya(e, t) {
    if (si)
      return e === "compositionend" || !Li && uc(e, t) ? (e = au(), Ni = ir = va = null, si = !1, e) : null;
    switch (e) {
      case "paste":
        return null;
      case "keypress":
        if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
          if (t.char && 1 < t.char.length)
            return t.char;
          if (t.which) return String.fromCharCode(t.which);
        }
        return null;
      case "compositionend":
        return rc && t.locale !== "ko" ? null : t.data;
      default:
        return null;
    }
  }
  var fo = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function cu(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return t === "input" ? !!fo[e.type] : t === "textarea";
  }
  function Nr(e, t, n, l) {
    lr ? Ll ? Ll.push(l) : Ll = [l] : lr = l, t = vd(t, "onChange"), 0 < t.length && (n = new Ar(
      "onChange",
      "change",
      null,
      n,
      l
    ), e.push({ event: n, listeners: t }));
  }
  var Bi = null, Hi = null;
  function oc(e) {
    ry(e, 0);
  }
  function ur(e) {
    var t = Sa(e);
    if (Tn(t)) return e;
  }
  function Dn(e, t) {
    if (e === "change") return t;
  }
  var Qo = !1;
  if (ot) {
    var fi;
    if (ot) {
      var ou = "oninput" in document;
      if (!ou) {
        var sc = document.createElement("div");
        sc.setAttribute("oninput", "return;"), ou = typeof sc.oninput == "function";
      }
      fi = ou;
    } else fi = !1;
    Qo = fi && (!document.documentMode || 9 < document.documentMode);
  }
  function fc() {
    Bi && (Bi.detachEvent("onpropertychange", su), Hi = Bi = null);
  }
  function su(e) {
    if (e.propertyName === "value" && ur(Hi)) {
      var t = [];
      Nr(
        t,
        Hi,
        e,
        lo(e)
      ), qu(oc, t);
    }
  }
  function fu(e, t, n) {
    e === "focusin" ? (fc(), Bi = t, Hi = n, Bi.attachEvent("onpropertychange", su)) : e === "focusout" && fc();
  }
  function Ui(e) {
    if (e === "selectionchange" || e === "keyup" || e === "keydown")
      return ur(Hi);
  }
  function Wo(e, t) {
    if (e === "click") return ur(t);
  }
  function cr(e, t) {
    if (e === "input" || e === "change")
      return ur(t);
  }
  function du(e, t) {
    return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
  }
  var kn = typeof Object.is == "function" ? Object.is : du;
  function Za(e, t) {
    if (kn(e, t)) return !0;
    if (typeof e != "object" || e === null || typeof t != "object" || t === null)
      return !1;
    var n = Object.keys(e), l = Object.keys(t);
    if (n.length !== l.length) return !1;
    for (l = 0; l < n.length; l++) {
      var s = n[l];
      if (!Ai.call(t, s) || !kn(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  function Fi(e) {
    for (; e && e.firstChild; ) e = e.firstChild;
    return e;
  }
  function Yi(e, t) {
    var n = Fi(e);
    e = 0;
    for (var l; n; ) {
      if (n.nodeType === 3) {
        if (l = e + n.textContent.length, e <= t && l >= t)
          return { node: n, offset: t - e };
        e = l;
      }
      e: {
        for (; n; ) {
          if (n.nextSibling) {
            n = n.nextSibling;
            break e;
          }
          n = n.parentNode;
        }
        n = void 0;
      }
      n = Fi(n);
    }
  }
  function dc(e, t) {
    return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? dc(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
  }
  function ho(e) {
    e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
    for (var t = Ya(e.document); t instanceof e.HTMLIFrameElement; ) {
      try {
        var n = typeof t.contentWindow.location.href == "string";
      } catch {
        n = !1;
      }
      if (n) e = t.contentWindow;
      else break;
      t = Ya(e.document);
    }
    return t;
  }
  function di(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
  }
  var hu = ot && "documentMode" in document && 11 >= document.documentMode, hi = null, gi = null, Gi = null, hc = !1;
  function Aa(e, t, n) {
    var l = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
    hc || hi == null || hi !== Ya(l) || (l = hi, "selectionStart" in l && di(l) ? l = { start: l.selectionStart, end: l.selectionEnd } : (l = (l.ownerDocument && l.ownerDocument.defaultView || window).getSelection(), l = {
      anchorNode: l.anchorNode,
      anchorOffset: l.anchorOffset,
      focusNode: l.focusNode,
      focusOffset: l.focusOffset
    }), Gi && Za(Gi, l) || (Gi = l, l = vd(gi, "onSelect"), 0 < l.length && (t = new Ar(
      "onSelect",
      "select",
      null,
      t,
      n
    ), e.push({ event: t, listeners: l }), t.target = hi)));
  }
  function Va(e, t) {
    var n = {};
    return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
  }
  var Xi = {
    animationend: Va("Animation", "AnimationEnd"),
    animationiteration: Va("Animation", "AnimationIteration"),
    animationstart: Va("Animation", "AnimationStart"),
    transitionrun: Va("Transition", "TransitionRun"),
    transitionstart: Va("Transition", "TransitionStart"),
    transitioncancel: Va("Transition", "TransitionCancel"),
    transitionend: Va("Transition", "TransitionEnd")
  }, r = {}, c = {};
  ot && (c = document.createElement("div").style, "AnimationEvent" in window || (delete Xi.animationend.animation, delete Xi.animationiteration.animation, delete Xi.animationstart.animation), "TransitionEvent" in window || delete Xi.transitionend.transition);
  function g(e) {
    if (r[e]) return r[e];
    if (!Xi[e]) return e;
    var t = Xi[e], n;
    for (n in t)
      if (t.hasOwnProperty(n) && n in c)
        return r[e] = t[n];
    return e;
  }
  var m = g("animationend"), x = g("animationiteration"), N = g("animationstart"), D = g("transitionrun"), $ = g("transitionstart"), F = g("transitioncancel"), ee = g("transitionend"), se = /* @__PURE__ */ new Map(), ae = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  ae.push("scrollEnd");
  function ve(e, t) {
    se.set(e, t), Fe(t, [e]);
  }
  var Be = typeof reportError == "function" ? reportError : function(e) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var t = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof e == "object" && e !== null && typeof e.message == "string" ? String(e.message) : String(e),
        error: e
      });
      if (!window.dispatchEvent(t)) return;
    } else if (typeof a == "object" && typeof a.emit == "function") {
      a.emit("uncaughtException", e);
      return;
    }
    console.error(e);
  }, Ie = [], Ze = 0, Ke = 0;
  function Qe() {
    for (var e = Ze, t = Ke = Ze = 0; t < e; ) {
      var n = Ie[t];
      Ie[t++] = null;
      var l = Ie[t];
      Ie[t++] = null;
      var s = Ie[t];
      Ie[t++] = null;
      var d = Ie[t];
      if (Ie[t++] = null, l !== null && s !== null) {
        var S = l.pending;
        S === null ? s.next = s : (s.next = S.next, S.next = s), l.pending = s;
      }
      d !== 0 && st(n, s, d);
    }
  }
  function je(e, t, n, l) {
    Ie[Ze++] = e, Ie[Ze++] = t, Ie[Ze++] = n, Ie[Ze++] = l, Ke |= l, e.lanes |= l, e = e.alternate, e !== null && (e.lanes |= l);
  }
  function Vt(e, t, n, l) {
    return je(e, t, n, l), ft(e);
  }
  function Mt(e, t) {
    return je(e, null, null, t), ft(e);
  }
  function st(e, t, n) {
    e.lanes |= n;
    var l = e.alternate;
    l !== null && (l.lanes |= n);
    for (var s = !1, d = e.return; d !== null; )
      d.childLanes |= n, l = d.alternate, l !== null && (l.childLanes |= n), d.tag === 22 && (e = d.stateNode, e === null || e._visibility & 1 || (s = !0)), e = d, d = d.return;
    return e.tag === 3 ? (d = e.stateNode, s && t !== null && (s = 31 - vn(n), e = d.hiddenUpdates, l = e[s], l === null ? e[s] = [t] : l.push(t), t.lane = n | 536870912), d) : null;
  }
  function ft(e) {
    if (50 < Ef)
      throw Ef = 0, _h = null, Error(y(185));
    for (var t = e.return; t !== null; )
      e = t, t = e.return;
    return e.tag === 3 ? e.stateNode : null;
  }
  var tt = {};
  function Bl(e, t, n, l) {
    this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = l, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function We(e, t, n, l) {
    return new Bl(e, t, n, l);
  }
  function Tl(e) {
    return e = e.prototype, !(!e || !e.isReactComponent);
  }
  function at(e, t) {
    var n = e.alternate;
    return n === null ? (n = We(
      e.tag,
      t,
      e.key,
      e.mode
    ), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 65011712, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n.refCleanup = e.refCleanup, n;
  }
  function pn(e, t) {
    e.flags &= 65011714;
    var n = e.alternate;
    return n === null ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = n.childLanes, e.lanes = n.lanes, e.child = n.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = n.memoizedProps, e.memoizedState = n.memoizedState, e.updateQueue = n.updateQueue, e.type = n.type, t = n.dependencies, e.dependencies = t === null ? null : {
      lanes: t.lanes,
      firstContext: t.firstContext
    }), e;
  }
  function sn(e, t, n, l, s, d) {
    var S = 0;
    if (l = e, typeof e == "function") Tl(e) && (S = 1);
    else if (typeof e == "string")
      S = r1(
        e,
        n,
        Oe.current
      ) ? 26 : e === "html" || e === "head" || e === "body" ? 27 : 5;
    else
      e: switch (e) {
        case Ht:
          return e = We(31, n, t, s), e.elementType = Ht, e.lanes = d, e;
        case he:
          return Ct(n.children, s, d, t);
        case ye:
          S = 8, s |= 24;
          break;
        case de:
          return e = We(12, n, t, s | 2), e.elementType = de, e.lanes = d, e;
        case xe:
          return e = We(13, n, t, s), e.elementType = xe, e.lanes = d, e;
        case we:
          return e = We(19, n, t, s), e.elementType = we, e.lanes = d, e;
        default:
          if (typeof e == "object" && e !== null)
            switch (e.$$typeof) {
              case ke:
                S = 10;
                break e;
              case ze:
                S = 9;
                break e;
              case pe:
                S = 11;
                break e;
              case Ce:
                S = 14;
                break e;
              case Le:
                S = 16, l = null;
                break e;
            }
          S = 29, n = Error(
            y(130, e === null ? "null" : typeof e, "")
          ), l = null;
      }
    return t = We(S, n, t, s), t.elementType = e, t.type = l, t.lanes = d, t;
  }
  function Ct(e, t, n, l) {
    return e = We(7, e, l, t), e.lanes = n, e;
  }
  function jn(e, t, n) {
    return e = We(6, e, null, t), e.lanes = n, e;
  }
  function Ii(e) {
    var t = We(18, null, null, 0);
    return t.stateNode = e, t;
  }
  function pl(e, t, n) {
    return t = We(
      4,
      e.children !== null ? e.children : [],
      e.key,
      t
    ), t.lanes = n, t.stateNode = {
      containerInfo: e.containerInfo,
      pendingChildren: null,
      implementation: e.implementation
    }, t;
  }
  var Mr = /* @__PURE__ */ new WeakMap();
  function qn(e, t) {
    if (typeof e == "object" && e !== null) {
      var n = Mr.get(e);
      return n !== void 0 ? n : (t = {
        value: e,
        source: t,
        stack: rn(t)
      }, Mr.set(e, t), t);
    }
    return {
      value: e,
      source: t,
      stack: rn(t)
    };
  }
  var Sn = [], $n = 0, Hl = null, Sl = 0, _n = [], Ln = 0, Pt = null, ul = 1, Ul = "";
  function Oa(e, t) {
    Sn[$n++] = Sl, Sn[$n++] = Hl, Hl = e, Sl = t;
  }
  function gc(e, t, n) {
    _n[Ln++] = ul, _n[Ln++] = Ul, _n[Ln++] = Pt, Pt = e;
    var l = ul;
    e = Ul;
    var s = 32 - vn(l) - 1;
    l &= ~(1 << s), n += 1;
    var d = 32 - vn(t) + s;
    if (30 < d) {
      var S = s - s % 5;
      d = (l & (1 << S) - 1).toString(32), l >>= S, s -= S, ul = 1 << 32 - vn(t) + s | n << s | l, Ul = d + e;
    } else
      ul = 1 << d | n << s | l, Ul = e;
  }
  function vc(e) {
    e.return !== null && (Oa(e, 1), gc(e, 1, 0));
  }
  function gu(e) {
    for (; e === Hl; )
      Hl = Sn[--$n], Sn[$n] = null, Sl = Sn[--$n], Sn[$n] = null;
    for (; e === Pt; )
      Pt = _n[--Ln], _n[Ln] = null, Ul = _n[--Ln], _n[Ln] = null, ul = _n[--Ln], _n[Ln] = null;
  }
  function zr(e, t) {
    _n[Ln++] = ul, _n[Ln++] = Ul, _n[Ln++] = Pt, ul = t.id, Ul = t.overflow, Pt = e;
  }
  var Vn = null, xt = null, Pe = !1, Fl = null, xl = !1, Qa = Error(y(519));
  function Wa(e) {
    var t = Error(
      y(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    throw jl(qn(t, e)), Qa;
  }
  function Kl(e) {
    var t = e.stateNode, n = e.type, l = e.memoizedProps;
    switch (t[mn] = e, t[zn] = l, n) {
      case "dialog":
        yt("cancel", t), yt("close", t);
        break;
      case "iframe":
      case "object":
      case "embed":
        yt("load", t);
        break;
      case "video":
      case "audio":
        for (n = 0; n < Af.length; n++)
          yt(Af[n], t);
        break;
      case "source":
        yt("error", t);
        break;
      case "img":
      case "image":
      case "link":
        yt("error", t), yt("load", t);
        break;
      case "details":
        yt("toggle", t);
        break;
      case "input":
        yt("invalid", t), Pu(
          t,
          l.value,
          l.defaultValue,
          l.checked,
          l.defaultChecked,
          l.type,
          l.name,
          !0
        );
        break;
      case "select":
        yt("invalid", t);
        break;
      case "textarea":
        yt("invalid", t), Fo(t, l.value, l.defaultValue, l.children);
    }
    n = l.children, typeof n != "string" && typeof n != "number" && typeof n != "bigint" || t.textContent === "" + n || l.suppressHydrationWarning === !0 || sy(t.textContent, n) ? (l.popover != null && (yt("beforetoggle", t), yt("toggle", t)), l.onScroll != null && yt("scroll", t), l.onScrollEnd != null && yt("scrollend", t), l.onClick != null && (t.onclick = ga), t = !0) : t = !1, t || Wa(e, !0);
  }
  function Dr(e) {
    for (Vn = e.return; Vn; )
      switch (Vn.tag) {
        case 5:
        case 31:
        case 13:
          xl = !1;
          return;
        case 27:
        case 3:
          xl = !0;
          return;
        default:
          Vn = Vn.return;
      }
  }
  function Ca(e) {
    if (e !== Vn) return !1;
    if (!Pe) return Dr(e), Pe = !0, !1;
    var t = e.tag, n;
    if ((n = t !== 3 && t !== 27) && ((n = t === 5) && (n = e.type, n = !(n !== "form" && n !== "button") || Zh(e.type, e.memoizedProps)), n = !n), n && xt && Wa(e), Dr(e), t === 13) {
      if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(y(317));
      xt = Ty(e);
    } else if (t === 31) {
      if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(y(317));
      xt = Ty(e);
    } else
      t === 27 ? (t = xt, Vc(e.type) ? (e = Jh, Jh = null, xt = e) : xt = t) : xt = Vn ? Ji(e.stateNode.nextSibling) : null;
    return !0;
  }
  function ba() {
    xt = Vn = null, Pe = !1;
  }
  function or() {
    var e = Fl;
    return e !== null && (li === null ? li = e : li.push.apply(
      li,
      e
    ), Fl = null), e;
  }
  function jl(e) {
    Fl === null ? Fl = [e] : Fl.push(e);
  }
  var vu = ut(null), Jt = null, cl = null;
  function ql(e, t, n) {
    be(vu, t._currentValue), t._currentValue = n;
  }
  function ol(e) {
    e._currentValue = vu.current, qe(vu);
  }
  function kr(e, t, n) {
    for (; e !== null; ) {
      var l = e.alternate;
      if ((e.childLanes & t) !== t ? (e.childLanes |= t, l !== null && (l.childLanes |= t)) : l !== null && (l.childLanes & t) !== t && (l.childLanes |= t), e === n) break;
      e = e.return;
    }
  }
  function Yl(e, t, n, l) {
    var s = e.child;
    for (s !== null && (s.return = e); s !== null; ) {
      var d = s.dependencies;
      if (d !== null) {
        var S = s.child;
        d = d.firstContext;
        e: for (; d !== null; ) {
          var R = d;
          d = s;
          for (var B = 0; B < t.length; B++)
            if (R.context === t[B]) {
              d.lanes |= n, R = d.alternate, R !== null && (R.lanes |= n), kr(
                d.return,
                n,
                e
              ), l || (S = null);
              break e;
            }
          d = R.next;
        }
      } else if (s.tag === 18) {
        if (S = s.return, S === null) throw Error(y(341));
        S.lanes |= n, d = S.alternate, d !== null && (d.lanes |= n), kr(S, n, e), S = null;
      } else S = s.child;
      if (S !== null) S.return = s;
      else
        for (S = s; S !== null; ) {
          if (S === e) {
            S = null;
            break;
          }
          if (s = S.sibling, s !== null) {
            s.return = S.return, S = s;
            break;
          }
          S = S.return;
        }
      s = S;
    }
  }
  function $l(e, t, n, l) {
    e = null;
    for (var s = t, d = !1; s !== null; ) {
      if (!d) {
        if ((s.flags & 524288) !== 0) d = !0;
        else if ((s.flags & 262144) !== 0) break;
      }
      if (s.tag === 10) {
        var S = s.alternate;
        if (S === null) throw Error(y(387));
        if (S = S.memoizedProps, S !== null) {
          var R = s.type;
          kn(s.pendingProps.value, S.value) || (e !== null ? e.push(R) : e = [R]);
        }
      } else if (s === bt.current) {
        if (S = s.alternate, S === null) throw Error(y(387));
        S.memoizedState.memoizedState !== s.memoizedState.memoizedState && (e !== null ? e.push(Nf) : e = [Nf]);
      }
      s = s.return;
    }
    e !== null && Yl(
      t,
      e,
      n,
      l
    ), t.flags |= 262144;
  }
  function Pa(e) {
    for (e = e.firstContext; e !== null; ) {
      if (!kn(
        e.context._currentValue,
        e.memoizedValue
      ))
        return !0;
      e = e.next;
    }
    return !1;
  }
  function Qn(e) {
    Jt = e, cl = null, e = e.dependencies, e !== null && (e.firstContext = null);
  }
  function dt(e) {
    return el(Jt, e);
  }
  function vi(e, t) {
    return Jt === null && Qn(e), el(e, t);
  }
  function el(e, t) {
    var n = t._currentValue;
    if (t = { context: t, memoizedValue: n, next: null }, cl === null) {
      if (e === null) throw Error(y(308));
      cl = t, e.dependencies = { lanes: 0, firstContext: t }, e.flags |= 524288;
    } else cl = cl.next = t;
    return n;
  }
  var go = typeof AbortController < "u" ? AbortController : function() {
    var e = [], t = this.signal = {
      aborted: !1,
      addEventListener: function(n, l) {
        e.push(l);
      }
    };
    this.abort = function() {
      t.aborted = !0, e.forEach(function(n) {
        return n();
      });
    };
  }, yu = o.unstable_scheduleCallback, bu = o.unstable_NormalPriority, xn = {
    $$typeof: ke,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function yc() {
    return {
      controller: new go(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function ea(e) {
    e.refCount--, e.refCount === 0 && yu(bu, function() {
      e.controller.abort();
    });
  }
  var Ra = null, Ja = 0, fn = 0, _a = null;
  function Lr(e, t) {
    if (Ra === null) {
      var n = Ra = [];
      Ja = 0, fn = Lh(), _a = {
        status: "pending",
        value: void 0,
        then: function(l) {
          n.push(l);
        }
      };
    }
    return Ja++, t.then(mu, mu), t;
  }
  function mu() {
    if (--Ja === 0 && Ra !== null) {
      _a !== null && (_a.status = "fulfilled");
      var e = Ra;
      Ra = null, fn = 0, _a = null;
      for (var t = 0; t < e.length; t++) (0, e[t])();
    }
  }
  function bc(e, t) {
    var n = [], l = {
      status: "pending",
      value: null,
      reason: null,
      then: function(s) {
        n.push(s);
      }
    };
    return e.then(
      function() {
        l.status = "fulfilled", l.value = t;
        for (var s = 0; s < n.length; s++) (0, n[s])(t);
      },
      function(s) {
        for (l.status = "rejected", l.reason = s, s = 0; s < n.length; s++)
          (0, n[s])(void 0);
      }
    ), l;
  }
  var mc = Q.S;
  Q.S = function(e, t) {
    kv = Ge(), typeof t == "object" && t !== null && typeof t.then == "function" && Lr(e, t), mc !== null && mc(e, t);
  };
  var Ka = ut(null);
  function Tu() {
    var e = Ka.current;
    return e !== null ? e : an.pooledCache;
  }
  function $t(e, t) {
    t === null ? be(Ka, Ka.current) : be(Ka, t.pool);
  }
  function pu() {
    var e = Tu();
    return e === null ? null : { parent: xn._currentValue, pool: e };
  }
  var Na = Error(y(460)), Zi = Error(y(474)), Vi = Error(y(542)), sr = { then: function() {
  } };
  function Br(e) {
    return e = e.status, e === "fulfilled" || e === "rejected";
  }
  function Hr(e, t, n) {
    switch (n = e[n], n === void 0 ? e.push(t) : n !== t && (t.then(ga, ga), t = n), t.status) {
      case "fulfilled":
        return t.value;
      case "rejected":
        throw e = t.reason, yi(e), e;
      default:
        if (typeof t.status == "string") t.then(ga, ga);
        else {
          if (e = an, e !== null && 100 < e.shellSuspendCounter)
            throw Error(y(482));
          e = t, e.status = "pending", e.then(
            function(l) {
              if (t.status === "pending") {
                var s = t;
                s.status = "fulfilled", s.value = l;
              }
            },
            function(l) {
              if (t.status === "pending") {
                var s = t;
                s.status = "rejected", s.reason = l;
              }
            }
          );
        }
        switch (t.status) {
          case "fulfilled":
            return t.value;
          case "rejected":
            throw e = t.reason, yi(e), e;
        }
        throw Bn = t, Na;
    }
  }
  function El(e) {
    try {
      var t = e._init;
      return t(e._payload);
    } catch (n) {
      throw n !== null && typeof n == "object" && typeof n.then == "function" ? (Bn = n, Na) : n;
    }
  }
  var Bn = null;
  function Tc() {
    if (Bn === null) throw Error(y(459));
    var e = Bn;
    return Bn = null, e;
  }
  function yi(e) {
    if (e === Na || e === Vi)
      throw Error(y(483));
  }
  var Qi = null, ta = 0;
  function ja(e) {
    var t = ta;
    return ta += 1, Qi === null && (Qi = []), Hr(Qi, e, t);
  }
  function na(e, t) {
    t = t.props.ref, e.ref = t !== void 0 ? t : null;
  }
  function bi(e, t) {
    throw t.$$typeof === ce ? Error(y(525)) : (e = Object.prototype.toString.call(t), Error(
      y(
        31,
        e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e
      )
    ));
  }
  function qa(e) {
    function t(V, G) {
      if (e) {
        var P = V.deletions;
        P === null ? (V.deletions = [G], V.flags |= 16) : P.push(G);
      }
    }
    function n(V, G) {
      if (!e) return null;
      for (; G !== null; )
        t(V, G), G = G.sibling;
      return null;
    }
    function l(V) {
      for (var G = /* @__PURE__ */ new Map(); V !== null; )
        V.key !== null ? G.set(V.key, V) : G.set(V.index, V), V = V.sibling;
      return G;
    }
    function s(V, G) {
      return V = at(V, G), V.index = 0, V.sibling = null, V;
    }
    function d(V, G, P) {
      return V.index = P, e ? (P = V.alternate, P !== null ? (P = P.index, P < G ? (V.flags |= 67108866, G) : P) : (V.flags |= 67108866, G)) : (V.flags |= 1048576, G);
    }
    function S(V) {
      return e && V.alternate === null && (V.flags |= 67108866), V;
    }
    function R(V, G, P, oe) {
      return G === null || G.tag !== 6 ? (G = jn(P, V.mode, oe), G.return = V, G) : (G = s(G, P), G.return = V, G);
    }
    function B(V, G, P, oe) {
      var He = P.type;
      return He === he ? ie(
        V,
        G,
        P.props.children,
        oe,
        P.key
      ) : G !== null && (G.elementType === He || typeof He == "object" && He !== null && He.$$typeof === Le && El(He) === G.type) ? (G = s(G, P.props), na(G, P), G.return = V, G) : (G = sn(
        P.type,
        P.key,
        P.props,
        null,
        V.mode,
        oe
      ), na(G, P), G.return = V, G);
    }
    function J(V, G, P, oe) {
      return G === null || G.tag !== 4 || G.stateNode.containerInfo !== P.containerInfo || G.stateNode.implementation !== P.implementation ? (G = pl(P, V.mode, oe), G.return = V, G) : (G = s(G, P.children || []), G.return = V, G);
    }
    function ie(V, G, P, oe, He) {
      return G === null || G.tag !== 7 ? (G = Ct(
        P,
        V.mode,
        oe,
        He
      ), G.return = V, G) : (G = s(G, P), G.return = V, G);
    }
    function fe(V, G, P) {
      if (typeof G == "string" && G !== "" || typeof G == "number" || typeof G == "bigint")
        return G = jn(
          "" + G,
          V.mode,
          P
        ), G.return = V, G;
      if (typeof G == "object" && G !== null) {
        switch (G.$$typeof) {
          case le:
            return P = sn(
              G.type,
              G.key,
              G.props,
              null,
              V.mode,
              P
            ), na(P, G), P.return = V, P;
          case K:
            return G = pl(
              G,
              V.mode,
              P
            ), G.return = V, G;
          case Le:
            return G = El(G), fe(V, G, P);
        }
        if (U(G) || Ee(G))
          return G = Ct(
            G,
            V.mode,
            P,
            null
          ), G.return = V, G;
        if (typeof G.then == "function")
          return fe(V, ja(G), P);
        if (G.$$typeof === ke)
          return fe(
            V,
            vi(V, G),
            P
          );
        bi(V, G);
      }
      return null;
    }
    function q(V, G, P, oe) {
      var He = G !== null ? G.key : null;
      if (typeof P == "string" && P !== "" || typeof P == "number" || typeof P == "bigint")
        return He !== null ? null : R(V, G, "" + P, oe);
      if (typeof P == "object" && P !== null) {
        switch (P.$$typeof) {
          case le:
            return P.key === He ? B(V, G, P, oe) : null;
          case K:
            return P.key === He ? J(V, G, P, oe) : null;
          case Le:
            return P = El(P), q(V, G, P, oe);
        }
        if (U(P) || Ee(P))
          return He !== null ? null : ie(V, G, P, oe, null);
        if (typeof P.then == "function")
          return q(
            V,
            G,
            ja(P),
            oe
          );
        if (P.$$typeof === ke)
          return q(
            V,
            G,
            vi(V, P),
            oe
          );
        bi(V, P);
      }
      return null;
    }
    function ne(V, G, P, oe, He) {
      if (typeof oe == "string" && oe !== "" || typeof oe == "number" || typeof oe == "bigint")
        return V = V.get(P) || null, R(G, V, "" + oe, He);
      if (typeof oe == "object" && oe !== null) {
        switch (oe.$$typeof) {
          case le:
            return V = V.get(
              oe.key === null ? P : oe.key
            ) || null, B(G, V, oe, He);
          case K:
            return V = V.get(
              oe.key === null ? P : oe.key
            ) || null, J(G, V, oe, He);
          case Le:
            return oe = El(oe), ne(
              V,
              G,
              P,
              oe,
              He
            );
        }
        if (U(oe) || Ee(oe))
          return V = V.get(P) || null, ie(G, V, oe, He, null);
        if (typeof oe.then == "function")
          return ne(
            V,
            G,
            P,
            ja(oe),
            He
          );
        if (oe.$$typeof === ke)
          return ne(
            V,
            G,
            P,
            vi(G, oe),
            He
          );
        bi(G, oe);
      }
      return null;
    }
    function _e(V, G, P, oe) {
      for (var He = null, Lt = null, De = G, it = G = 0, St = null; De !== null && it < P.length; it++) {
        De.index > it ? (St = De, De = null) : St = De.sibling;
        var Bt = q(
          V,
          De,
          P[it],
          oe
        );
        if (Bt === null) {
          De === null && (De = St);
          break;
        }
        e && De && Bt.alternate === null && t(V, De), G = d(Bt, G, it), Lt === null ? He = Bt : Lt.sibling = Bt, Lt = Bt, De = St;
      }
      if (it === P.length)
        return n(V, De), Pe && Oa(V, it), He;
      if (De === null) {
        for (; it < P.length; it++)
          De = fe(V, P[it], oe), De !== null && (G = d(
            De,
            G,
            it
          ), Lt === null ? He = De : Lt.sibling = De, Lt = De);
        return Pe && Oa(V, it), He;
      }
      for (De = l(De); it < P.length; it++)
        St = ne(
          De,
          V,
          it,
          P[it],
          oe
        ), St !== null && (e && St.alternate !== null && De.delete(
          St.key === null ? it : St.key
        ), G = d(
          St,
          G,
          it
        ), Lt === null ? He = St : Lt.sibling = St, Lt = St);
      return e && De.forEach(function(Kc) {
        return t(V, Kc);
      }), Pe && Oa(V, it), He;
    }
    function Xe(V, G, P, oe) {
      if (P == null) throw Error(y(151));
      for (var He = null, Lt = null, De = G, it = G = 0, St = null, Bt = P.next(); De !== null && !Bt.done; it++, Bt = P.next()) {
        De.index > it ? (St = De, De = null) : St = De.sibling;
        var Kc = q(V, De, Bt.value, oe);
        if (Kc === null) {
          De === null && (De = St);
          break;
        }
        e && De && Kc.alternate === null && t(V, De), G = d(Kc, G, it), Lt === null ? He = Kc : Lt.sibling = Kc, Lt = Kc, De = St;
      }
      if (Bt.done)
        return n(V, De), Pe && Oa(V, it), He;
      if (De === null) {
        for (; !Bt.done; it++, Bt = P.next())
          Bt = fe(V, Bt.value, oe), Bt !== null && (G = d(Bt, G, it), Lt === null ? He = Bt : Lt.sibling = Bt, Lt = Bt);
        return Pe && Oa(V, it), He;
      }
      for (De = l(De); !Bt.done; it++, Bt = P.next())
        Bt = ne(De, V, it, Bt.value, oe), Bt !== null && (e && Bt.alternate !== null && De.delete(Bt.key === null ? it : Bt.key), G = d(Bt, G, it), Lt === null ? He = Bt : Lt.sibling = Bt, Lt = Bt);
      return e && De.forEach(function(b1) {
        return t(V, b1);
      }), Pe && Oa(V, it), He;
    }
    function tn(V, G, P, oe) {
      if (typeof P == "object" && P !== null && P.type === he && P.key === null && (P = P.props.children), typeof P == "object" && P !== null) {
        switch (P.$$typeof) {
          case le:
            e: {
              for (var He = P.key; G !== null; ) {
                if (G.key === He) {
                  if (He = P.type, He === he) {
                    if (G.tag === 7) {
                      n(
                        V,
                        G.sibling
                      ), oe = s(
                        G,
                        P.props.children
                      ), oe.return = V, V = oe;
                      break e;
                    }
                  } else if (G.elementType === He || typeof He == "object" && He !== null && He.$$typeof === Le && El(He) === G.type) {
                    n(
                      V,
                      G.sibling
                    ), oe = s(G, P.props), na(oe, P), oe.return = V, V = oe;
                    break e;
                  }
                  n(V, G);
                  break;
                } else t(V, G);
                G = G.sibling;
              }
              P.type === he ? (oe = Ct(
                P.props.children,
                V.mode,
                oe,
                P.key
              ), oe.return = V, V = oe) : (oe = sn(
                P.type,
                P.key,
                P.props,
                null,
                V.mode,
                oe
              ), na(oe, P), oe.return = V, V = oe);
            }
            return S(V);
          case K:
            e: {
              for (He = P.key; G !== null; ) {
                if (G.key === He)
                  if (G.tag === 4 && G.stateNode.containerInfo === P.containerInfo && G.stateNode.implementation === P.implementation) {
                    n(
                      V,
                      G.sibling
                    ), oe = s(G, P.children || []), oe.return = V, V = oe;
                    break e;
                  } else {
                    n(V, G);
                    break;
                  }
                else t(V, G);
                G = G.sibling;
              }
              oe = pl(P, V.mode, oe), oe.return = V, V = oe;
            }
            return S(V);
          case Le:
            return P = El(P), tn(
              V,
              G,
              P,
              oe
            );
        }
        if (U(P))
          return _e(
            V,
            G,
            P,
            oe
          );
        if (Ee(P)) {
          if (He = Ee(P), typeof He != "function") throw Error(y(150));
          return P = He.call(P), Xe(
            V,
            G,
            P,
            oe
          );
        }
        if (typeof P.then == "function")
          return tn(
            V,
            G,
            ja(P),
            oe
          );
        if (P.$$typeof === ke)
          return tn(
            V,
            G,
            vi(V, P),
            oe
          );
        bi(V, P);
      }
      return typeof P == "string" && P !== "" || typeof P == "number" || typeof P == "bigint" ? (P = "" + P, G !== null && G.tag === 6 ? (n(V, G.sibling), oe = s(G, P), oe.return = V, V = oe) : (n(V, G), oe = jn(P, V.mode, oe), oe.return = V, V = oe), S(V)) : n(V, G);
    }
    return function(V, G, P, oe) {
      try {
        ta = 0;
        var He = tn(
          V,
          G,
          P,
          oe
        );
        return Qi = null, He;
      } catch (De) {
        if (De === Na || De === Vi) throw De;
        var Lt = We(29, De, null, V.mode);
        return Lt.lanes = oe, Lt.return = V, Lt;
      } finally {
      }
    };
  }
  var mi = qa(!0), pc = qa(!1), sl = !1;
  function fr(e) {
    e.updateQueue = {
      baseState: e.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function Ti(e, t) {
    e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
      baseState: e.baseState,
      firstBaseUpdate: e.firstBaseUpdate,
      lastBaseUpdate: e.lastBaseUpdate,
      shared: e.shared,
      callbacks: null
    });
  }
  function fl(e) {
    return { lane: e, tag: 0, payload: null, callback: null, next: null };
  }
  function wl(e, t, n) {
    var l = e.updateQueue;
    if (l === null) return null;
    if (l = l.shared, (Ft & 2) !== 0) {
      var s = l.pending;
      return s === null ? t.next = t : (t.next = s.next, s.next = t), l.pending = t, t = ft(e), st(e, null, n), t;
    }
    return je(e, l, t, n), ft(e);
  }
  function dl(e, t, n) {
    if (t = t.updateQueue, t !== null && (t = t.shared, (n & 4194048) !== 0)) {
      var l = t.lanes;
      l &= e.pendingLanes, n |= l, t.lanes = n, un(e, n);
    }
  }
  function Ur(e, t) {
    var n = e.updateQueue, l = e.alternate;
    if (l !== null && (l = l.updateQueue, n === l)) {
      var s = null, d = null;
      if (n = n.firstBaseUpdate, n !== null) {
        do {
          var S = {
            lane: n.lane,
            tag: n.tag,
            payload: n.payload,
            callback: null,
            next: null
          };
          d === null ? s = d = S : d = d.next = S, n = n.next;
        } while (n !== null);
        d === null ? s = d = t : d = d.next = t;
      } else s = d = t;
      n = {
        baseState: l.baseState,
        firstBaseUpdate: s,
        lastBaseUpdate: d,
        shared: l.shared,
        callbacks: l.callbacks
      }, e.updateQueue = n;
      return;
    }
    e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
  }
  var Su = !1;
  function $a() {
    if (Su) {
      var e = _a;
      if (e !== null) throw e;
    }
  }
  function i(e, t, n, l) {
    Su = !1;
    var s = e.updateQueue;
    sl = !1;
    var d = s.firstBaseUpdate, S = s.lastBaseUpdate, R = s.shared.pending;
    if (R !== null) {
      s.shared.pending = null;
      var B = R, J = B.next;
      B.next = null, S === null ? d = J : S.next = J, S = B;
      var ie = e.alternate;
      ie !== null && (ie = ie.updateQueue, R = ie.lastBaseUpdate, R !== S && (R === null ? ie.firstBaseUpdate = J : R.next = J, ie.lastBaseUpdate = B));
    }
    if (d !== null) {
      var fe = s.baseState;
      S = 0, ie = J = B = null, R = d;
      do {
        var q = R.lane & -536870913, ne = q !== R.lane;
        if (ne ? (pt & q) === q : (l & q) === q) {
          q !== 0 && q === fn && (Su = !0), ie !== null && (ie = ie.next = {
            lane: 0,
            tag: R.tag,
            payload: R.payload,
            callback: null,
            next: null
          });
          e: {
            var _e = e, Xe = R;
            q = t;
            var tn = n;
            switch (Xe.tag) {
              case 1:
                if (_e = Xe.payload, typeof _e == "function") {
                  fe = _e.call(tn, fe, q);
                  break e;
                }
                fe = _e;
                break e;
              case 3:
                _e.flags = _e.flags & -65537 | 128;
              case 0:
                if (_e = Xe.payload, q = typeof _e == "function" ? _e.call(tn, fe, q) : _e, q == null) break e;
                fe = Y({}, fe, q);
                break e;
              case 2:
                sl = !0;
            }
          }
          q = R.callback, q !== null && (e.flags |= 64, ne && (e.flags |= 8192), ne = s.callbacks, ne === null ? s.callbacks = [q] : ne.push(q));
        } else
          ne = {
            lane: q,
            tag: R.tag,
            payload: R.payload,
            callback: R.callback,
            next: null
          }, ie === null ? (J = ie = ne, B = fe) : ie = ie.next = ne, S |= q;
        if (R = R.next, R === null) {
          if (R = s.shared.pending, R === null)
            break;
          ne = R, R = ne.next, ne.next = null, s.lastBaseUpdate = ne, s.shared.pending = null;
        }
      } while (!0);
      ie === null && (B = fe), s.baseState = B, s.firstBaseUpdate = J, s.lastBaseUpdate = ie, d === null && (s.shared.lanes = 0), Yc |= S, e.lanes = S, e.memoizedState = fe;
    }
  }
  function u(e, t) {
    if (typeof e != "function")
      throw Error(y(191, e));
    e.call(t);
  }
  function h(e, t) {
    var n = e.callbacks;
    if (n !== null)
      for (e.callbacks = null, e = 0; e < n.length; e++)
        u(n[e], t);
  }
  var b = ut(null), p = ut(0);
  function C(e, t) {
    e = Uu, be(p, e), be(b, t), Uu = e | t.baseLanes;
  }
  function M() {
    be(p, Uu), be(b, b.current);
  }
  function I() {
    Uu = p.current, qe(b), qe(p);
  }
  var L = ut(null), X = null;
  function W(e) {
    var t = e.alternate;
    be(Me, Me.current & 1), be(L, e), X === null && (t === null || b.current !== null || t.memoizedState !== null) && (X = e);
  }
  function te(e) {
    be(Me, Me.current), be(L, e), X === null && (X = e);
  }
  function me(e) {
    e.tag === 22 ? (be(Me, Me.current), be(L, e), X === null && (X = e)) : Te();
  }
  function Te() {
    be(Me, Me.current), be(L, L.current);
  }
  function Ve(e) {
    qe(L), X === e && (X = null), qe(Me);
  }
  var Me = ut(0);
  function nt(e) {
    for (var t = e; t !== null; ) {
      if (t.tag === 13) {
        var n = t.memoizedState;
        if (n !== null && (n = n.dehydrated, n === null || Wh(n) || Ph(n)))
          return t;
      } else if (t.tag === 19 && (t.memoizedProps.revealOrder === "forwards" || t.memoizedProps.revealOrder === "backwards" || t.memoizedProps.revealOrder === "unstable_legacy-backwards" || t.memoizedProps.revealOrder === "together")) {
        if ((t.flags & 128) !== 0) return t;
      } else if (t.child !== null) {
        t.child.return = t, t = t.child;
        continue;
      }
      if (t === e) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === e) return null;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
    return null;
  }
  var ht = 0, Ae = null, Je = null, gt = null, Al = !1, Ue = !1, dn = !1, Kt = 0, Hn = 0, Gl = null, hn = 0;
  function zt() {
    throw Error(y(321));
  }
  function ma(e, t) {
    if (t === null) return !1;
    for (var n = 0; n < t.length && n < e.length; n++)
      if (!kn(e[n], t[n])) return !1;
    return !0;
  }
  function Un(e, t, n, l, s, d) {
    return ht = d, Ae = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, Q.H = e === null || e.memoizedState === null ? _u : of, dn = !1, d = n(l, s), dn = !1, Ue && (d = Fr(
      t,
      n,
      l,
      s
    )), la(e), d;
  }
  function la(e) {
    Q.H = Vr;
    var t = Je !== null && Je.next !== null;
    if (ht = 0, gt = Je = Ae = null, Al = !1, Hn = 0, Gl = null, t) throw Error(y(300));
    e === null || Fn || (e = e.dependencies, e !== null && Pa(e) && (Fn = !0));
  }
  function Fr(e, t, n, l) {
    Ae = e;
    var s = 0;
    do {
      if (Ue && (Gl = null), Hn = 0, Ue = !1, 25 <= s) throw Error(y(301));
      if (s += 1, gt = Je = null, e.updateQueue != null) {
        var d = e.updateQueue;
        d.lastEffect = null, d.events = null, d.stores = null, d.memoCache != null && (d.memoCache.index = 0);
      }
      Q.H = Nu, d = t(n, l);
    } while (Ue);
    return d;
  }
  function xu() {
    var e = Q.H, t = e.useState()[0];
    return t = typeof t.then == "function" ? wu(t) : t, e = e.useState()[0], (Je !== null ? Je.memoizedState : null) !== e && (Ae.flags |= 1024), t;
  }
  function pi() {
    var e = Kt !== 0;
    return Kt = 0, e;
  }
  function dr(e, t, n) {
    t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~n;
  }
  function Eu(e) {
    if (Al) {
      for (e = e.memoizedState; e !== null; ) {
        var t = e.queue;
        t !== null && (t.pending = null), e = e.next;
      }
      Al = !1;
    }
    ht = 0, gt = Je = Ae = null, Ue = !1, Hn = Kt = 0, Gl = null;
  }
  function gn() {
    var e = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return gt === null ? Ae.memoizedState = gt = e : gt = gt.next = e, gt;
  }
  function Qt() {
    if (Je === null) {
      var e = Ae.alternate;
      e = e !== null ? e.memoizedState : null;
    } else e = Je.next;
    var t = gt === null ? Ae.memoizedState : gt.next;
    if (t !== null)
      gt = t, Je = e;
    else {
      if (e === null)
        throw Ae.alternate === null ? Error(y(467)) : Error(y(310));
      Je = e, e = {
        memoizedState: Je.memoizedState,
        baseState: Je.baseState,
        baseQueue: Je.baseQueue,
        queue: Je.queue,
        next: null
      }, gt === null ? Ae.memoizedState = gt = e : gt = gt.next = e;
    }
    return gt;
  }
  function Sc() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function wu(e) {
    var t = Hn;
    return Hn += 1, Gl === null && (Gl = []), e = Hr(Gl, e, t), t = Ae, (gt === null ? t.memoizedState : gt.next) === null && (t = t.alternate, Q.H = t === null || t.memoizedState === null ? _u : of), e;
  }
  function Yr(e) {
    if (e !== null && typeof e == "object") {
      if (typeof e.then == "function") return wu(e);
      if (e.$$typeof === ke) return dt(e);
    }
    throw Error(y(438, String(e)));
  }
  function Ma(e) {
    var t = null, n = Ae.updateQueue;
    if (n !== null && (t = n.memoCache), t == null) {
      var l = Ae.alternate;
      l !== null && (l = l.updateQueue, l !== null && (l = l.memoCache, l != null && (t = {
        data: l.data.map(function(s) {
          return s.slice();
        }),
        index: 0
      })));
    }
    if (t == null && (t = { data: [], index: 0 }), n === null && (n = Sc(), Ae.updateQueue = n), n.memoCache = t, n = t.data[t.index], n === void 0)
      for (n = t.data[t.index] = Array(e), l = 0; l < e; l++)
        n[l] = Et;
    return t.index++, n;
  }
  function Wi(e, t) {
    return typeof t == "function" ? t(e) : t;
  }
  function Gr(e) {
    var t = Qt();
    return Po(t, Je, e);
  }
  function Po(e, t, n) {
    var l = e.queue;
    if (l === null) throw Error(y(311));
    l.lastRenderedReducer = n;
    var s = e.baseQueue, d = l.pending;
    if (d !== null) {
      if (s !== null) {
        var S = s.next;
        s.next = d.next, d.next = S;
      }
      t.baseQueue = s = d, l.pending = null;
    }
    if (d = e.baseState, s === null) e.memoizedState = d;
    else {
      t = s.next;
      var R = S = null, B = null, J = t, ie = !1;
      do {
        var fe = J.lane & -536870913;
        if (fe !== J.lane ? (pt & fe) === fe : (ht & fe) === fe) {
          var q = J.revertLane;
          if (q === 0)
            B !== null && (B = B.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: J.action,
              hasEagerState: J.hasEagerState,
              eagerState: J.eagerState,
              next: null
            }), fe === fn && (ie = !0);
          else if ((ht & q) === q) {
            J = J.next, q === fn && (ie = !0);
            continue;
          } else
            fe = {
              lane: 0,
              revertLane: J.revertLane,
              gesture: null,
              action: J.action,
              hasEagerState: J.hasEagerState,
              eagerState: J.eagerState,
              next: null
            }, B === null ? (R = B = fe, S = d) : B = B.next = fe, Ae.lanes |= q, Yc |= q;
          fe = J.action, dn && n(d, fe), d = J.hasEagerState ? J.eagerState : n(d, fe);
        } else
          q = {
            lane: fe,
            revertLane: J.revertLane,
            gesture: J.gesture,
            action: J.action,
            hasEagerState: J.hasEagerState,
            eagerState: J.eagerState,
            next: null
          }, B === null ? (R = B = q, S = d) : B = B.next = q, Ae.lanes |= fe, Yc |= fe;
        J = J.next;
      } while (J !== null && J !== t);
      if (B === null ? S = d : B.next = R, !kn(d, e.memoizedState) && (Fn = !0, ie && (n = _a, n !== null)))
        throw n;
      e.memoizedState = d, e.baseState = S, e.baseQueue = B, l.lastRenderedState = d;
    }
    return s === null && (l.lanes = 0), [e.memoizedState, l.dispatch];
  }
  function Jo(e) {
    var t = Qt(), n = t.queue;
    if (n === null) throw Error(y(311));
    n.lastRenderedReducer = e;
    var l = n.dispatch, s = n.pending, d = t.memoizedState;
    if (s !== null) {
      n.pending = null;
      var S = s = s.next;
      do
        d = e(d, S.action), S = S.next;
      while (S !== s);
      kn(d, t.memoizedState) || (Fn = !0), t.memoizedState = d, t.baseQueue === null && (t.baseState = d), n.lastRenderedState = d;
    }
    return [d, l];
  }
  function Ws(e, t, n) {
    var l = Ae, s = Qt(), d = Pe;
    if (d) {
      if (n === void 0) throw Error(y(407));
      n = n();
    } else n = t();
    var S = !kn(
      (Je || s).memoizedState,
      n
    );
    if (S && (s.memoizedState = n, Fn = !0), s = s.queue, Cu(Ks.bind(null, l, s, e), [
      e
    ]), s.getSnapshot !== t || S || gt !== null && gt.memoizedState.tag & 1) {
      if (l.flags |= 2048, gr(
        9,
        { destroy: void 0 },
        Js.bind(
          null,
          l,
          s,
          n,
          t
        ),
        null
      ), an === null) throw Error(y(349));
      d || (ht & 127) !== 0 || Ps(l, t, n);
    }
    return n;
  }
  function Ps(e, t, n) {
    e.flags |= 16384, e = { getSnapshot: t, value: n }, t = Ae.updateQueue, t === null ? (t = Sc(), Ae.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
  }
  function Js(e, t, n, l) {
    t.value = n, t.getSnapshot = l, xc(t) && Pi(e);
  }
  function Ks(e, t, n) {
    return n(function() {
      xc(t) && Pi(e);
    });
  }
  function xc(e) {
    var t = e.getSnapshot;
    e = e.value;
    try {
      var n = t();
      return !kn(e, n);
    } catch {
      return !0;
    }
  }
  function Pi(e) {
    var t = Mt(e, 2);
    t !== null && ai(t, e, 2);
  }
  function Ko(e) {
    var t = gn();
    if (typeof e == "function") {
      var n = e;
      if (e = n(), dn) {
        al(!0);
        try {
          n();
        } finally {
          al(!1);
        }
      }
    }
    return t.memoizedState = t.baseState = e, t.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Wi,
      lastRenderedState: e
    }, t;
  }
  function js(e, t, n, l) {
    return e.baseState = n, Po(
      e,
      Je,
      typeof l == "function" ? l : Wi
    );
  }
  function vo(e, t, n, l, s) {
    if (mo(e)) throw Error(y(485));
    if (e = t.action, e !== null) {
      var d = {
        payload: s,
        action: e,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(S) {
          d.listeners.push(S);
        }
      };
      Q.T !== null ? n(!0) : d.isTransition = !1, l(d), n = t.pending, n === null ? (d.next = t.pending = d, qs(t, d)) : (d.next = n.next, t.pending = n.next = d);
    }
  }
  function qs(e, t) {
    var n = t.action, l = t.payload, s = e.state;
    if (t.isTransition) {
      var d = Q.T, S = {};
      Q.T = S;
      try {
        var R = n(s, l), B = Q.S;
        B !== null && B(S, R), Xr(e, t, R);
      } catch (J) {
        Au(e, t, J);
      } finally {
        d !== null && S.types !== null && (d.types = S.types), Q.T = d;
      }
    } else
      try {
        d = n(s, l), Xr(e, t, d);
      } catch (J) {
        Au(e, t, J);
      }
  }
  function Xr(e, t, n) {
    n !== null && typeof n == "object" && typeof n.then == "function" ? n.then(
      function(l) {
        Ec(e, t, l);
      },
      function(l) {
        return Au(e, t, l);
      }
    ) : Ec(e, t, n);
  }
  function Ec(e, t, n) {
    t.status = "fulfilled", t.value = n, wc(t), e.state = n, t = e.pending, t !== null && (n = t.next, n === t ? e.pending = null : (n = n.next, t.next = n, qs(e, n)));
  }
  function Au(e, t, n) {
    var l = e.pending;
    if (e.pending = null, l !== null) {
      l = l.next;
      do
        t.status = "rejected", t.reason = n, wc(t), t = t.next;
      while (t !== l);
    }
    e.action = null;
  }
  function wc(e) {
    e = e.listeners;
    for (var t = 0; t < e.length; t++) (0, e[t])();
  }
  function Ac(e, t) {
    return t;
  }
  function hr(e, t) {
    if (Pe) {
      var n = an.formState;
      if (n !== null) {
        e: {
          var l = Ae;
          if (Pe) {
            if (xt) {
              t: {
                for (var s = xt, d = xl; s.nodeType !== 8; ) {
                  if (!d) {
                    s = null;
                    break t;
                  }
                  if (s = Ji(
                    s.nextSibling
                  ), s === null) {
                    s = null;
                    break t;
                  }
                }
                d = s.data, s = d === "F!" || d === "F" ? s : null;
              }
              if (s) {
                xt = Ji(
                  s.nextSibling
                ), l = s.data === "F!";
                break e;
              }
            }
            Wa(l);
          }
          l = !1;
        }
        l && (t = n[0]);
      }
    }
    return n = gn(), n.memoizedState = n.baseState = t, l = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Ac,
      lastRenderedState: t
    }, n.queue = l, n = uf.bind(
      null,
      Ae,
      l
    ), l.dispatch = n, l = Ko(!1), d = bo.bind(
      null,
      Ae,
      !1,
      l.queue
    ), l = gn(), s = {
      state: t,
      dispatch: null,
      action: e,
      pending: null
    }, l.queue = s, n = vo.bind(
      null,
      Ae,
      s,
      d,
      n
    ), s.dispatch = n, l.memoizedState = e, [t, n, !1];
  }
  function jo(e) {
    var t = Qt();
    return qo(t, Je, e);
  }
  function qo(e, t, n) {
    if (t = Po(
      e,
      t,
      Ac
    )[0], e = Gr(Wi)[0], typeof t == "object" && t !== null && typeof t.then == "function")
      try {
        var l = wu(t);
      } catch (S) {
        throw S === Na ? Vi : S;
      }
    else l = t;
    t = Qt();
    var s = t.queue, d = s.dispatch;
    return n !== t.memoizedState && (Ae.flags |= 2048, gr(
      9,
      { destroy: void 0 },
      Ou.bind(null, s, n),
      null
    )), [l, d, e];
  }
  function Ou(e, t) {
    e.action = t;
  }
  function $s(e) {
    var t = Qt(), n = Je;
    if (n !== null)
      return qo(t, n, e);
    Qt(), t = t.memoizedState, n = Qt();
    var l = n.queue.dispatch;
    return n.memoizedState = e, [t, l, !1];
  }
  function gr(e, t, n, l) {
    return e = { tag: e, create: n, deps: l, inst: t, next: null }, t = Ae.updateQueue, t === null && (t = Sc(), Ae.updateQueue = t), n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (l = n.next, n.next = e, e.next = l, t.lastEffect = e), e;
  }
  function ef() {
    return Qt().memoizedState;
  }
  function Ir(e, t, n, l) {
    var s = gn();
    Ae.flags |= e, s.memoizedState = gr(
      1 | t,
      { destroy: void 0 },
      n,
      l === void 0 ? null : l
    );
  }
  function yo(e, t, n, l) {
    var s = Qt();
    l = l === void 0 ? null : l;
    var d = s.memoizedState.inst;
    Je !== null && l !== null && ma(l, Je.memoizedState.deps) ? s.memoizedState = gr(t, d, n, l) : (Ae.flags |= e, s.memoizedState = gr(
      1 | t,
      d,
      n,
      l
    ));
  }
  function Oc(e, t) {
    Ir(8390656, 8, e, t);
  }
  function Cu(e, t) {
    yo(2048, 8, e, t);
  }
  function Jf(e) {
    Ae.flags |= 4;
    var t = Ae.updateQueue;
    if (t === null)
      t = Sc(), Ae.updateQueue = t, t.events = [e];
    else {
      var n = t.events;
      n === null ? t.events = [e] : n.push(e);
    }
  }
  function tf(e) {
    var t = Qt().memoizedState;
    return Jf({ ref: t, nextImpl: e }), function() {
      if ((Ft & 2) !== 0) throw Error(y(440));
      return t.impl.apply(void 0, arguments);
    };
  }
  function Kf(e, t) {
    return yo(4, 2, e, t);
  }
  function jf(e, t) {
    return yo(4, 4, e, t);
  }
  function $o(e, t) {
    if (typeof t == "function") {
      e = e();
      var n = t(e);
      return function() {
        typeof n == "function" ? n() : t(null);
      };
    }
    if (t != null)
      return e = e(), t.current = e, function() {
        t.current = null;
      };
  }
  function qf(e, t, n) {
    n = n != null ? n.concat([e]) : null, yo(4, 4, $o.bind(null, t, e), n);
  }
  function nf() {
  }
  function $f(e, t) {
    var n = Qt();
    t = t === void 0 ? null : t;
    var l = n.memoizedState;
    return t !== null && ma(t, l[1]) ? l[0] : (n.memoizedState = [e, t], e);
  }
  function vr(e, t) {
    var n = Qt();
    t = t === void 0 ? null : t;
    var l = n.memoizedState;
    if (t !== null && ma(t, l[1]))
      return l[0];
    if (l = e(), dn) {
      al(!0);
      try {
        e();
      } finally {
        al(!1);
      }
    }
    return n.memoizedState = [l, t], l;
  }
  function Cc(e, t, n) {
    return n === void 0 || (ht & 1073741824) !== 0 && (pt & 261930) === 0 ? e.memoizedState = t : (e.memoizedState = n, e = Bv(), Ae.lanes |= e, Yc |= e, n);
  }
  function Rc(e, t, n, l) {
    return kn(n, t) ? n : b.current !== null ? (e = Cc(e, n, l), kn(e, t) || (Fn = !0), e) : (ht & 42) === 0 || (ht & 1073741824) !== 0 && (pt & 261930) === 0 ? (Fn = !0, e.memoizedState = n) : (e = Bv(), Ae.lanes |= e, Yc |= e, t);
  }
  function Ru(e, t, n, l, s) {
    var d = Se.p;
    Se.p = d !== 0 && 8 > d ? d : 8;
    var S = Q.T, R = {};
    Q.T = R, bo(e, !1, t, n);
    try {
      var B = s(), J = Q.S;
      if (J !== null && J(R, B), B !== null && typeof B == "object" && typeof B.then == "function") {
        var ie = bc(
          B,
          l
        );
        Zr(
          e,
          t,
          ie,
          Ei(e)
        );
      } else
        Zr(
          e,
          t,
          l,
          Ei(e)
        );
    } catch (fe) {
      Zr(
        e,
        t,
        { then: function() {
        }, status: "rejected", reason: fe },
        Ei()
      );
    } finally {
      Se.p = d, S !== null && R.types !== null && (S.types = R.types), Q.T = S;
    }
  }
  function es() {
  }
  function _c(e, t, n, l) {
    if (e.tag !== 5) throw Error(y(476));
    var s = ts(e).queue;
    Ru(
      e,
      s,
      t,
      et,
      n === null ? es : function() {
        return lf(e), n(l);
      }
    );
  }
  function ts(e) {
    var t = e.memoizedState;
    if (t !== null) return t;
    t = {
      memoizedState: et,
      baseState: et,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Wi,
        lastRenderedState: et
      },
      next: null
    };
    var n = {};
    return t.next = {
      memoizedState: n,
      baseState: n,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Wi,
        lastRenderedState: n
      },
      next: null
    }, e.memoizedState = t, e = e.alternate, e !== null && (e.memoizedState = t), t;
  }
  function lf(e) {
    var t = ts(e);
    t.next === null && (t = e.alternate.memoizedState), Zr(
      e,
      t.next.queue,
      {},
      Ei()
    );
  }
  function af() {
    return dt(Nf);
  }
  function ns() {
    return Qt().memoizedState;
  }
  function rf() {
    return Qt().memoizedState;
  }
  function ls(e) {
    for (var t = e.return; t !== null; ) {
      switch (t.tag) {
        case 24:
        case 3:
          var n = Ei();
          e = fl(n);
          var l = wl(t, e, n);
          l !== null && (ai(l, t, n), dl(l, t, n)), t = { cache: yc() }, e.payload = t;
          return;
      }
      t = t.return;
    }
  }
  function as(e, t, n) {
    var l = Ei();
    n = {
      lane: l,
      revertLane: 0,
      gesture: null,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, mo(e) ? cf(t, n) : (n = Vt(e, t, n, l), n !== null && (ai(n, e, l), ed(n, t, l)));
  }
  function uf(e, t, n) {
    var l = Ei();
    Zr(e, t, n, l);
  }
  function Zr(e, t, n, l) {
    var s = {
      lane: l,
      revertLane: 0,
      gesture: null,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (mo(e)) cf(t, s);
    else {
      var d = e.alternate;
      if (e.lanes === 0 && (d === null || d.lanes === 0) && (d = t.lastRenderedReducer, d !== null))
        try {
          var S = t.lastRenderedState, R = d(S, n);
          if (s.hasEagerState = !0, s.eagerState = R, kn(R, S))
            return je(e, t, s, 0), an === null && Qe(), !1;
        } catch {
        } finally {
        }
      if (n = Vt(e, t, s, l), n !== null)
        return ai(n, e, l), ed(n, t, l), !0;
    }
    return !1;
  }
  function bo(e, t, n, l) {
    if (l = {
      lane: 2,
      revertLane: Lh(),
      gesture: null,
      action: l,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, mo(e)) {
      if (t) throw Error(y(479));
    } else
      t = Vt(
        e,
        n,
        l,
        2
      ), t !== null && ai(t, e, 2);
  }
  function mo(e) {
    var t = e.alternate;
    return e === Ae || t !== null && t === Ae;
  }
  function cf(e, t) {
    Ue = Al = !0;
    var n = e.pending;
    n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
  }
  function ed(e, t, n) {
    if ((n & 4194048) !== 0) {
      var l = t.lanes;
      l &= e.pendingLanes, n |= l, t.lanes = n, un(e, n);
    }
  }
  var Vr = {
    readContext: dt,
    use: Yr,
    useCallback: zt,
    useContext: zt,
    useEffect: zt,
    useImperativeHandle: zt,
    useLayoutEffect: zt,
    useInsertionEffect: zt,
    useMemo: zt,
    useReducer: zt,
    useRef: zt,
    useState: zt,
    useDebugValue: zt,
    useDeferredValue: zt,
    useTransition: zt,
    useSyncExternalStore: zt,
    useId: zt,
    useHostTransitionStatus: zt,
    useFormState: zt,
    useActionState: zt,
    useOptimistic: zt,
    useMemoCache: zt,
    useCacheRefresh: zt
  };
  Vr.useEffectEvent = zt;
  var _u = {
    readContext: dt,
    use: Yr,
    useCallback: function(e, t) {
      return gn().memoizedState = [
        e,
        t === void 0 ? null : t
      ], e;
    },
    useContext: dt,
    useEffect: Oc,
    useImperativeHandle: function(e, t, n) {
      n = n != null ? n.concat([e]) : null, Ir(
        4194308,
        4,
        $o.bind(null, t, e),
        n
      );
    },
    useLayoutEffect: function(e, t) {
      return Ir(4194308, 4, e, t);
    },
    useInsertionEffect: function(e, t) {
      Ir(4, 2, e, t);
    },
    useMemo: function(e, t) {
      var n = gn();
      t = t === void 0 ? null : t;
      var l = e();
      if (dn) {
        al(!0);
        try {
          e();
        } finally {
          al(!1);
        }
      }
      return n.memoizedState = [l, t], l;
    },
    useReducer: function(e, t, n) {
      var l = gn();
      if (n !== void 0) {
        var s = n(t);
        if (dn) {
          al(!0);
          try {
            n(t);
          } finally {
            al(!1);
          }
        }
      } else s = t;
      return l.memoizedState = l.baseState = s, e = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: s
      }, l.queue = e, e = e.dispatch = as.bind(
        null,
        Ae,
        e
      ), [l.memoizedState, e];
    },
    useRef: function(e) {
      var t = gn();
      return e = { current: e }, t.memoizedState = e;
    },
    useState: function(e) {
      e = Ko(e);
      var t = e.queue, n = uf.bind(null, Ae, t);
      return t.dispatch = n, [e.memoizedState, n];
    },
    useDebugValue: nf,
    useDeferredValue: function(e, t) {
      var n = gn();
      return Cc(n, e, t);
    },
    useTransition: function() {
      var e = Ko(!1);
      return e = Ru.bind(
        null,
        Ae,
        e.queue,
        !0,
        !1
      ), gn().memoizedState = e, [!1, e];
    },
    useSyncExternalStore: function(e, t, n) {
      var l = Ae, s = gn();
      if (Pe) {
        if (n === void 0)
          throw Error(y(407));
        n = n();
      } else {
        if (n = t(), an === null)
          throw Error(y(349));
        (pt & 127) !== 0 || Ps(l, t, n);
      }
      s.memoizedState = n;
      var d = { value: n, getSnapshot: t };
      return s.queue = d, Oc(Ks.bind(null, l, d, e), [
        e
      ]), l.flags |= 2048, gr(
        9,
        { destroy: void 0 },
        Js.bind(
          null,
          l,
          d,
          n,
          t
        ),
        null
      ), n;
    },
    useId: function() {
      var e = gn(), t = an.identifierPrefix;
      if (Pe) {
        var n = Ul, l = ul;
        n = (l & ~(1 << 32 - vn(l) - 1)).toString(32) + n, t = "_" + t + "R_" + n, n = Kt++, 0 < n && (t += "H" + n.toString(32)), t += "_";
      } else
        n = hn++, t = "_" + t + "r_" + n.toString(32) + "_";
      return e.memoizedState = t;
    },
    useHostTransitionStatus: af,
    useFormState: hr,
    useActionState: hr,
    useOptimistic: function(e) {
      var t = gn();
      t.memoizedState = t.baseState = e;
      var n = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return t.queue = n, t = bo.bind(
        null,
        Ae,
        !0,
        n
      ), n.dispatch = t, [e, t];
    },
    useMemoCache: Ma,
    useCacheRefresh: function() {
      return gn().memoizedState = ls.bind(
        null,
        Ae
      );
    },
    useEffectEvent: function(e) {
      var t = gn(), n = { impl: e };
      return t.memoizedState = n, function() {
        if ((Ft & 2) !== 0)
          throw Error(y(440));
        return n.impl.apply(void 0, arguments);
      };
    }
  }, of = {
    readContext: dt,
    use: Yr,
    useCallback: $f,
    useContext: dt,
    useEffect: Cu,
    useImperativeHandle: qf,
    useInsertionEffect: Kf,
    useLayoutEffect: jf,
    useMemo: vr,
    useReducer: Gr,
    useRef: ef,
    useState: function() {
      return Gr(Wi);
    },
    useDebugValue: nf,
    useDeferredValue: function(e, t) {
      var n = Qt();
      return Rc(
        n,
        Je.memoizedState,
        e,
        t
      );
    },
    useTransition: function() {
      var e = Gr(Wi)[0], t = Qt().memoizedState;
      return [
        typeof e == "boolean" ? e : wu(e),
        t
      ];
    },
    useSyncExternalStore: Ws,
    useId: ns,
    useHostTransitionStatus: af,
    useFormState: jo,
    useActionState: jo,
    useOptimistic: function(e, t) {
      var n = Qt();
      return js(n, Je, e, t);
    },
    useMemoCache: Ma,
    useCacheRefresh: rf
  };
  of.useEffectEvent = tf;
  var Nu = {
    readContext: dt,
    use: Yr,
    useCallback: $f,
    useContext: dt,
    useEffect: Cu,
    useImperativeHandle: qf,
    useInsertionEffect: Kf,
    useLayoutEffect: jf,
    useMemo: vr,
    useReducer: Jo,
    useRef: ef,
    useState: function() {
      return Jo(Wi);
    },
    useDebugValue: nf,
    useDeferredValue: function(e, t) {
      var n = Qt();
      return Je === null ? Cc(n, e, t) : Rc(
        n,
        Je.memoizedState,
        e,
        t
      );
    },
    useTransition: function() {
      var e = Jo(Wi)[0], t = Qt().memoizedState;
      return [
        typeof e == "boolean" ? e : wu(e),
        t
      ];
    },
    useSyncExternalStore: Ws,
    useId: ns,
    useHostTransitionStatus: af,
    useFormState: $s,
    useActionState: $s,
    useOptimistic: function(e, t) {
      var n = Qt();
      return Je !== null ? js(n, Je, e, t) : (n.baseState = e, [e, n.queue.dispatch]);
    },
    useMemoCache: Ma,
    useCacheRefresh: rf
  };
  Nu.useEffectEvent = tf;
  function is(e, t, n, l) {
    t = e.memoizedState, n = n(l, t), n = n == null ? t : Y({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
  }
  var Mu = {
    enqueueSetState: function(e, t, n) {
      e = e._reactInternals;
      var l = Ei(), s = fl(l);
      s.payload = t, n != null && (s.callback = n), t = wl(e, s, l), t !== null && (ai(t, e, l), dl(t, e, l));
    },
    enqueueReplaceState: function(e, t, n) {
      e = e._reactInternals;
      var l = Ei(), s = fl(l);
      s.tag = 1, s.payload = t, n != null && (s.callback = n), t = wl(e, s, l), t !== null && (ai(t, e, l), dl(t, e, l));
    },
    enqueueForceUpdate: function(e, t) {
      e = e._reactInternals;
      var n = Ei(), l = fl(n);
      l.tag = 2, t != null && (l.callback = t), t = wl(e, l, n), t !== null && (ai(t, e, n), dl(t, e, n));
    }
  };
  function To(e, t, n, l, s, d, S) {
    return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(l, d, S) : t.prototype && t.prototype.isPureReactComponent ? !Za(n, l) || !Za(s, d) : !0;
  }
  function Nc(e, t, n, l) {
    e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, l), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, l), t.state !== e && Mu.enqueueReplaceState(t, t.state, null);
  }
  function Qr(e, t) {
    var n = t;
    if ("ref" in t) {
      n = {};
      for (var l in t)
        l !== "ref" && (n[l] = t[l]);
    }
    if (e = e.defaultProps) {
      n === t && (n = Y({}, n));
      for (var s in e)
        n[s] === void 0 && (n[s] = e[s]);
    }
    return n;
  }
  function Wr(e) {
    Be(e);
  }
  function sf(e) {
    console.error(e);
  }
  function ff(e) {
    Be(e);
  }
  function yr(e, t) {
    try {
      var n = e.onUncaughtError;
      n(t.value, { componentStack: t.stack });
    } catch (l) {
      setTimeout(function() {
        throw l;
      });
    }
  }
  function df(e, t, n) {
    try {
      var l = e.onCaughtError;
      l(n.value, {
        componentStack: n.stack,
        errorBoundary: t.tag === 1 ? t.stateNode : null
      });
    } catch (s) {
      setTimeout(function() {
        throw s;
      });
    }
  }
  function Mc(e, t, n) {
    return n = fl(n), n.tag = 3, n.payload = { element: null }, n.callback = function() {
      yr(e, t);
    }, n;
  }
  function rs(e) {
    return e = fl(e), e.tag = 3, e;
  }
  function zc(e, t, n, l) {
    var s = n.type.getDerivedStateFromError;
    if (typeof s == "function") {
      var d = l.value;
      e.payload = function() {
        return s(d);
      }, e.callback = function() {
        df(t, n, l);
      };
    }
    var S = n.stateNode;
    S !== null && typeof S.componentDidCatch == "function" && (e.callback = function() {
      df(t, n, l), typeof s != "function" && (Gc === null ? Gc = /* @__PURE__ */ new Set([this]) : Gc.add(this));
      var R = l.stack;
      this.componentDidCatch(l.value, {
        componentStack: R !== null ? R : ""
      });
    });
  }
  function yh(e, t, n, l, s) {
    if (n.flags |= 32768, l !== null && typeof l == "object" && typeof l.then == "function") {
      if (t = n.alternate, t !== null && $l(
        t,
        n,
        s,
        !0
      ), n = L.current, n !== null) {
        switch (n.tag) {
          case 31:
          case 13:
            return X === null ? od() : n.alternate === null && Pn === 0 && (Pn = 3), n.flags &= -257, n.flags |= 65536, n.lanes = s, l === sr ? n.flags |= 16384 : (t = n.updateQueue, t === null ? n.updateQueue = /* @__PURE__ */ new Set([l]) : t.add(l), zh(e, l, s)), !1;
          case 22:
            return n.flags |= 65536, l === sr ? n.flags |= 16384 : (t = n.updateQueue, t === null ? (t = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([l])
            }, n.updateQueue = t) : (n = t.retryQueue, n === null ? t.retryQueue = /* @__PURE__ */ new Set([l]) : n.add(l)), zh(e, l, s)), !1;
        }
        throw Error(y(435, n.tag));
      }
      return zh(e, l, s), od(), !1;
    }
    if (Pe)
      return t = L.current, t !== null ? ((t.flags & 65536) === 0 && (t.flags |= 256), t.flags |= 65536, t.lanes = s, l !== Qa && (e = Error(y(422), { cause: l }), jl(qn(e, n)))) : (l !== Qa && (t = Error(y(423), {
        cause: l
      }), jl(
        qn(t, n)
      )), e = e.current.alternate, e.flags |= 65536, s &= -s, e.lanes |= s, l = qn(l, n), s = Mc(
        e.stateNode,
        l,
        s
      ), Ur(e, s), Pn !== 4 && (Pn = 2)), !1;
    var d = Error(y(520), { cause: l });
    if (d = qn(d, n), xf === null ? xf = [d] : xf.push(d), Pn !== 4 && (Pn = 2), t === null) return !0;
    l = qn(l, n), n = t;
    do {
      switch (n.tag) {
        case 3:
          return n.flags |= 65536, e = s & -s, n.lanes |= e, e = Mc(n.stateNode, l, e), Ur(n, e), !1;
        case 1:
          if (t = n.type, d = n.stateNode, (n.flags & 128) === 0 && (typeof t.getDerivedStateFromError == "function" || d !== null && typeof d.componentDidCatch == "function" && (Gc === null || !Gc.has(d))))
            return n.flags |= 65536, s &= -s, n.lanes |= s, s = rs(s), zc(
              s,
              e,
              n,
              l
            ), Ur(n, s), !1;
      }
      n = n.return;
    } while (n !== null);
    return !1;
  }
  var hf = Error(y(461)), Fn = !1;
  function Yn(e, t, n, l) {
    t.child = e === null ? pc(t, null, n, l) : mi(
      t,
      e.child,
      n,
      l
    );
  }
  function Dc(e, t, n, l, s) {
    n = n.render;
    var d = t.ref;
    if ("ref" in l) {
      var S = {};
      for (var R in l)
        R !== "ref" && (S[R] = l[R]);
    } else S = l;
    return Qn(t), l = Un(
      e,
      t,
      n,
      S,
      d,
      s
    ), R = pi(), e !== null && !Fn ? (dr(e, t, s), tl(e, t, s)) : (Pe && R && vc(t), t.flags |= 1, Yn(e, t, l, s), t.child);
  }
  function kc(e, t, n, l, s) {
    if (e === null) {
      var d = n.type;
      return typeof d == "function" && !Tl(d) && d.defaultProps === void 0 && n.compare === null ? (t.tag = 15, t.type = d, po(
        e,
        t,
        d,
        l,
        s
      )) : (e = sn(
        n.type,
        null,
        l,
        t,
        t.mode,
        s
      ), e.ref = t.ref, e.return = t, t.child = e);
    }
    if (d = e.child, !gs(e, s)) {
      var S = d.memoizedProps;
      if (n = n.compare, n = n !== null ? n : Za, n(S, l) && e.ref === t.ref)
        return tl(e, t, s);
    }
    return t.flags |= 1, e = at(d, l), e.ref = t.ref, e.return = t, t.child = e;
  }
  function po(e, t, n, l, s) {
    if (e !== null) {
      var d = e.memoizedProps;
      if (Za(d, l) && e.ref === t.ref)
        if (Fn = !1, t.pendingProps = l = d, gs(e, s))
          (e.flags & 131072) !== 0 && (Fn = !0);
        else
          return t.lanes = e.lanes, tl(e, t, s);
    }
    return br(
      e,
      t,
      n,
      l,
      s
    );
  }
  function Pr(e, t, n, l) {
    var s = l.children, d = e !== null ? e.memoizedState : null;
    if (e === null && t.stateNode === null && (t.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), l.mode === "hidden") {
      if ((t.flags & 128) !== 0) {
        if (d = d !== null ? d.baseLanes | n : n, e !== null) {
          for (l = t.child = e.child, s = 0; l !== null; )
            s = s | l.lanes | l.childLanes, l = l.sibling;
          l = s & ~d;
        } else l = 0, t.child = null;
        return Ol(
          e,
          t,
          d,
          n,
          l
        );
      }
      if ((n & 536870912) !== 0)
        t.memoizedState = { baseLanes: 0, cachePool: null }, e !== null && $t(
          t,
          d !== null ? d.cachePool : null
        ), d !== null ? C(t, d) : M(), me(t);
      else
        return l = t.lanes = 536870912, Ol(
          e,
          t,
          d !== null ? d.baseLanes | n : n,
          n,
          l
        );
    } else
      d !== null ? ($t(t, d.cachePool), C(t, d), Te(), t.memoizedState = null) : (e !== null && $t(t, null), M(), Te());
    return Yn(e, t, s, n), t.child;
  }
  function So(e, t) {
    return e !== null && e.tag === 22 || t.stateNode !== null || (t.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), t.sibling;
  }
  function Ol(e, t, n, l, s) {
    var d = Tu();
    return d = d === null ? null : { parent: xn._currentValue, pool: d }, t.memoizedState = {
      baseLanes: n,
      cachePool: d
    }, e !== null && $t(t, null), M(), me(t), e !== null && $l(e, t, l, !0), t.childLanes = s, null;
  }
  function Wn(e, t) {
    return t = Hc(
      { mode: t.mode, children: t.children },
      e.mode
    ), t.ref = e.ref, e.child = t, t.return = e, t;
  }
  function gf(e, t, n) {
    return mi(t, e.child, null, n), e = Wn(t, t.pendingProps), e.flags |= 2, Ve(t), t.memoizedState = null, e;
  }
  function Lc(e, t, n) {
    var l = t.pendingProps, s = (t.flags & 128) !== 0;
    if (t.flags &= -129, e === null) {
      if (Pe) {
        if (l.mode === "hidden")
          return e = Wn(t, l), t.lanes = 536870912, So(null, e);
        if (te(t), (e = xt) ? (e = my(
          e,
          xl
        ), e = e !== null && e.data === "&" ? e : null, e !== null && (t.memoizedState = {
          dehydrated: e,
          treeContext: Pt !== null ? { id: ul, overflow: Ul } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, n = Ii(e), n.return = t, t.child = n, Vn = t, xt = null)) : e = null, e === null) throw Wa(t);
        return t.lanes = 536870912, null;
      }
      return Wn(t, l);
    }
    var d = e.memoizedState;
    if (d !== null) {
      var S = d.dehydrated;
      if (te(t), s)
        if (t.flags & 256)
          t.flags &= -257, t = gf(
            e,
            t,
            n
          );
        else if (t.memoizedState !== null)
          t.child = e.child, t.flags |= 128, t = null;
        else throw Error(y(558));
      else if (Fn || $l(e, t, n, !1), s = (n & e.childLanes) !== 0, Fn || s) {
        if (l = an, l !== null && (S = il(l, n), S !== 0 && S !== d.retryLane))
          throw d.retryLane = S, Mt(e, S), ai(l, e, S), hf;
        od(), t = gf(
          e,
          t,
          n
        );
      } else
        e = d.treeContext, xt = Ji(S.nextSibling), Vn = t, Pe = !0, Fl = null, xl = !1, e !== null && zr(t, e), t = Wn(t, l), t.flags |= 4096;
      return t;
    }
    return e = at(e.child, {
      mode: l.mode,
      children: l.children
    }), e.ref = t.ref, t.child = e, e.return = t, e;
  }
  function Bc(e, t) {
    var n = t.ref;
    if (n === null)
      e !== null && e.ref !== null && (t.flags |= 4194816);
    else {
      if (typeof n != "function" && typeof n != "object")
        throw Error(y(284));
      (e === null || e.ref !== n) && (t.flags |= 4194816);
    }
  }
  function br(e, t, n, l, s) {
    return Qn(t), n = Un(
      e,
      t,
      n,
      l,
      void 0,
      s
    ), l = pi(), e !== null && !Fn ? (dr(e, t, s), tl(e, t, s)) : (Pe && l && vc(t), t.flags |= 1, Yn(e, t, n, s), t.child);
  }
  function us(e, t, n, l, s, d) {
    return Qn(t), t.updateQueue = null, n = Fr(
      t,
      l,
      n,
      s
    ), la(e), l = pi(), e !== null && !Fn ? (dr(e, t, d), tl(e, t, d)) : (Pe && l && vc(t), t.flags |= 1, Yn(e, t, n, d), t.child);
  }
  function vf(e, t, n, l, s) {
    if (Qn(t), t.stateNode === null) {
      var d = tt, S = n.contextType;
      typeof S == "object" && S !== null && (d = dt(S)), d = new n(l, d), t.memoizedState = d.state !== null && d.state !== void 0 ? d.state : null, d.updater = Mu, t.stateNode = d, d._reactInternals = t, d = t.stateNode, d.props = l, d.state = t.memoizedState, d.refs = {}, fr(t), S = n.contextType, d.context = typeof S == "object" && S !== null ? dt(S) : tt, d.state = t.memoizedState, S = n.getDerivedStateFromProps, typeof S == "function" && (is(
        t,
        n,
        S,
        l
      ), d.state = t.memoizedState), typeof n.getDerivedStateFromProps == "function" || typeof d.getSnapshotBeforeUpdate == "function" || typeof d.UNSAFE_componentWillMount != "function" && typeof d.componentWillMount != "function" || (S = d.state, typeof d.componentWillMount == "function" && d.componentWillMount(), typeof d.UNSAFE_componentWillMount == "function" && d.UNSAFE_componentWillMount(), S !== d.state && Mu.enqueueReplaceState(d, d.state, null), i(t, l, d, s), $a(), d.state = t.memoizedState), typeof d.componentDidMount == "function" && (t.flags |= 4194308), l = !0;
    } else if (e === null) {
      d = t.stateNode;
      var R = t.memoizedProps, B = Qr(n, R);
      d.props = B;
      var J = d.context, ie = n.contextType;
      S = tt, typeof ie == "object" && ie !== null && (S = dt(ie));
      var fe = n.getDerivedStateFromProps;
      ie = typeof fe == "function" || typeof d.getSnapshotBeforeUpdate == "function", R = t.pendingProps !== R, ie || typeof d.UNSAFE_componentWillReceiveProps != "function" && typeof d.componentWillReceiveProps != "function" || (R || J !== S) && Nc(
        t,
        d,
        l,
        S
      ), sl = !1;
      var q = t.memoizedState;
      d.state = q, i(t, l, d, s), $a(), J = t.memoizedState, R || q !== J || sl ? (typeof fe == "function" && (is(
        t,
        n,
        fe,
        l
      ), J = t.memoizedState), (B = sl || To(
        t,
        n,
        B,
        l,
        q,
        J,
        S
      )) ? (ie || typeof d.UNSAFE_componentWillMount != "function" && typeof d.componentWillMount != "function" || (typeof d.componentWillMount == "function" && d.componentWillMount(), typeof d.UNSAFE_componentWillMount == "function" && d.UNSAFE_componentWillMount()), typeof d.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof d.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = l, t.memoizedState = J), d.props = l, d.state = J, d.context = S, l = B) : (typeof d.componentDidMount == "function" && (t.flags |= 4194308), l = !1);
    } else {
      d = t.stateNode, Ti(e, t), S = t.memoizedProps, ie = Qr(n, S), d.props = ie, fe = t.pendingProps, q = d.context, J = n.contextType, B = tt, typeof J == "object" && J !== null && (B = dt(J)), R = n.getDerivedStateFromProps, (J = typeof R == "function" || typeof d.getSnapshotBeforeUpdate == "function") || typeof d.UNSAFE_componentWillReceiveProps != "function" && typeof d.componentWillReceiveProps != "function" || (S !== fe || q !== B) && Nc(
        t,
        d,
        l,
        B
      ), sl = !1, q = t.memoizedState, d.state = q, i(t, l, d, s), $a();
      var ne = t.memoizedState;
      S !== fe || q !== ne || sl || e !== null && e.dependencies !== null && Pa(e.dependencies) ? (typeof R == "function" && (is(
        t,
        n,
        R,
        l
      ), ne = t.memoizedState), (ie = sl || To(
        t,
        n,
        ie,
        l,
        q,
        ne,
        B
      ) || e !== null && e.dependencies !== null && Pa(e.dependencies)) ? (J || typeof d.UNSAFE_componentWillUpdate != "function" && typeof d.componentWillUpdate != "function" || (typeof d.componentWillUpdate == "function" && d.componentWillUpdate(l, ne, B), typeof d.UNSAFE_componentWillUpdate == "function" && d.UNSAFE_componentWillUpdate(
        l,
        ne,
        B
      )), typeof d.componentDidUpdate == "function" && (t.flags |= 4), typeof d.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof d.componentDidUpdate != "function" || S === e.memoizedProps && q === e.memoizedState || (t.flags |= 4), typeof d.getSnapshotBeforeUpdate != "function" || S === e.memoizedProps && q === e.memoizedState || (t.flags |= 1024), t.memoizedProps = l, t.memoizedState = ne), d.props = l, d.state = ne, d.context = B, l = ie) : (typeof d.componentDidUpdate != "function" || S === e.memoizedProps && q === e.memoizedState || (t.flags |= 4), typeof d.getSnapshotBeforeUpdate != "function" || S === e.memoizedProps && q === e.memoizedState || (t.flags |= 1024), l = !1);
    }
    return d = l, Bc(e, t), l = (t.flags & 128) !== 0, d || l ? (d = t.stateNode, n = l && typeof n.getDerivedStateFromError != "function" ? null : d.render(), t.flags |= 1, e !== null && l ? (t.child = mi(
      t,
      e.child,
      null,
      s
    ), t.child = mi(
      t,
      null,
      n,
      s
    )) : Yn(e, t, n, s), t.memoizedState = d.state, e = t.child) : e = tl(
      e,
      t,
      s
    ), e;
  }
  function Jr(e, t, n, l) {
    return ba(), t.flags |= 256, Yn(e, t, n, l), t.child;
  }
  var xo = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function Eo(e) {
    return { baseLanes: e, cachePool: pu() };
  }
  function cs(e, t, n) {
    return e = e !== null ? e.childLanes & ~n : 0, t && (e |= xi), e;
  }
  function os(e, t, n) {
    var l = t.pendingProps, s = !1, d = (t.flags & 128) !== 0, S;
    if ((S = d) || (S = e !== null && e.memoizedState === null ? !1 : (Me.current & 2) !== 0), S && (s = !0, t.flags &= -129), S = (t.flags & 32) !== 0, t.flags &= -33, e === null) {
      if (Pe) {
        if (s ? W(t) : Te(), (e = xt) ? (e = my(
          e,
          xl
        ), e = e !== null && e.data !== "&" ? e : null, e !== null && (t.memoizedState = {
          dehydrated: e,
          treeContext: Pt !== null ? { id: ul, overflow: Ul } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, n = Ii(e), n.return = t, t.child = n, Vn = t, xt = null)) : e = null, e === null) throw Wa(t);
        return Ph(e) ? t.lanes = 32 : t.lanes = 536870912, null;
      }
      var R = l.children;
      return l = l.fallback, s ? (Te(), s = t.mode, R = Hc(
        { mode: "hidden", children: R },
        s
      ), l = Ct(
        l,
        s,
        n,
        null
      ), R.return = t, l.return = t, R.sibling = l, t.child = R, l = t.child, l.memoizedState = Eo(n), l.childLanes = cs(
        e,
        S,
        n
      ), t.memoizedState = xo, So(null, l)) : (W(t), ss(t, R));
    }
    var B = e.memoizedState;
    if (B !== null && (R = B.dehydrated, R !== null)) {
      if (d)
        t.flags & 256 ? (W(t), t.flags &= -257, t = fs(
          e,
          t,
          n
        )) : t.memoizedState !== null ? (Te(), t.child = e.child, t.flags |= 128, t = null) : (Te(), R = l.fallback, s = t.mode, l = Hc(
          { mode: "visible", children: l.children },
          s
        ), R = Ct(
          R,
          s,
          n,
          null
        ), R.flags |= 2, l.return = t, R.return = t, l.sibling = R, t.child = l, mi(
          t,
          e.child,
          null,
          n
        ), l = t.child, l.memoizedState = Eo(n), l.childLanes = cs(
          e,
          S,
          n
        ), t.memoizedState = xo, t = So(null, l));
      else if (W(t), Ph(R)) {
        if (S = R.nextSibling && R.nextSibling.dataset, S) var J = S.dgst;
        S = J, l = Error(y(419)), l.stack = "", l.digest = S, jl({ value: l, source: null, stack: null }), t = fs(
          e,
          t,
          n
        );
      } else if (Fn || $l(e, t, n, !1), S = (n & e.childLanes) !== 0, Fn || S) {
        if (S = an, S !== null && (l = il(S, n), l !== 0 && l !== B.retryLane))
          throw B.retryLane = l, Mt(e, l), ai(S, e, l), hf;
        Wh(R) || od(), t = fs(
          e,
          t,
          n
        );
      } else
        Wh(R) ? (t.flags |= 192, t.child = e.child, t = null) : (e = B.treeContext, xt = Ji(
          R.nextSibling
        ), Vn = t, Pe = !0, Fl = null, xl = !1, e !== null && zr(t, e), t = ss(
          t,
          l.children
        ), t.flags |= 4096);
      return t;
    }
    return s ? (Te(), R = l.fallback, s = t.mode, B = e.child, J = B.sibling, l = at(B, {
      mode: "hidden",
      children: l.children
    }), l.subtreeFlags = B.subtreeFlags & 65011712, J !== null ? R = at(
      J,
      R
    ) : (R = Ct(
      R,
      s,
      n,
      null
    ), R.flags |= 2), R.return = t, l.return = t, l.sibling = R, t.child = l, So(null, l), l = t.child, R = e.child.memoizedState, R === null ? R = Eo(n) : (s = R.cachePool, s !== null ? (B = xn._currentValue, s = s.parent !== B ? { parent: B, pool: B } : s) : s = pu(), R = {
      baseLanes: R.baseLanes | n,
      cachePool: s
    }), l.memoizedState = R, l.childLanes = cs(
      e,
      S,
      n
    ), t.memoizedState = xo, So(e.child, l)) : (W(t), n = e.child, e = n.sibling, n = at(n, {
      mode: "visible",
      children: l.children
    }), n.return = t, n.sibling = null, e !== null && (S = t.deletions, S === null ? (t.deletions = [e], t.flags |= 16) : S.push(e)), t.child = n, t.memoizedState = null, n);
  }
  function ss(e, t) {
    return t = Hc(
      { mode: "visible", children: t },
      e.mode
    ), t.return = e, e.child = t;
  }
  function Hc(e, t) {
    return e = We(22, e, null, t), e.lanes = 0, e;
  }
  function fs(e, t, n) {
    return mi(t, e.child, null, n), e = ss(
      t,
      t.pendingProps.children
    ), e.flags |= 2, t.memoizedState = null, e;
  }
  function ds(e, t, n) {
    e.lanes |= t;
    var l = e.alternate;
    l !== null && (l.lanes |= t), kr(e.return, t, n);
  }
  function hs(e, t, n, l, s, d) {
    var S = e.memoizedState;
    S === null ? e.memoizedState = {
      isBackwards: t,
      rendering: null,
      renderingStartTime: 0,
      last: l,
      tail: n,
      tailMode: s,
      treeForkCount: d
    } : (S.isBackwards = t, S.rendering = null, S.renderingStartTime = 0, S.last = l, S.tail = n, S.tailMode = s, S.treeForkCount = d);
  }
  function zu(e, t, n) {
    var l = t.pendingProps, s = l.revealOrder, d = l.tail;
    l = l.children;
    var S = Me.current, R = (S & 2) !== 0;
    if (R ? (S = S & 1 | 2, t.flags |= 128) : S &= 1, be(Me, S), Yn(e, t, l, n), l = Pe ? Sl : 0, !R && e !== null && (e.flags & 128) !== 0)
      e: for (e = t.child; e !== null; ) {
        if (e.tag === 13)
          e.memoizedState !== null && ds(e, n, t);
        else if (e.tag === 19)
          ds(e, n, t);
        else if (e.child !== null) {
          e.child.return = e, e = e.child;
          continue;
        }
        if (e === t) break e;
        for (; e.sibling === null; ) {
          if (e.return === null || e.return === t)
            break e;
          e = e.return;
        }
        e.sibling.return = e.return, e = e.sibling;
      }
    switch (s) {
      case "forwards":
        for (n = t.child, s = null; n !== null; )
          e = n.alternate, e !== null && nt(e) === null && (s = n), n = n.sibling;
        n = s, n === null ? (s = t.child, t.child = null) : (s = n.sibling, n.sibling = null), hs(
          t,
          !1,
          s,
          n,
          d,
          l
        );
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (n = null, s = t.child, t.child = null; s !== null; ) {
          if (e = s.alternate, e !== null && nt(e) === null) {
            t.child = s;
            break;
          }
          e = s.sibling, s.sibling = n, n = s, s = e;
        }
        hs(
          t,
          !0,
          n,
          null,
          d,
          l
        );
        break;
      case "together":
        hs(
          t,
          !1,
          null,
          null,
          void 0,
          l
        );
        break;
      default:
        t.memoizedState = null;
    }
    return t.child;
  }
  function tl(e, t, n) {
    if (e !== null && (t.dependencies = e.dependencies), Yc |= t.lanes, (n & t.childLanes) === 0)
      if (e !== null) {
        if ($l(
          e,
          t,
          n,
          !1
        ), (n & t.childLanes) === 0)
          return null;
      } else return null;
    if (e !== null && t.child !== e.child)
      throw Error(y(153));
    if (t.child !== null) {
      for (e = t.child, n = at(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null; )
        e = e.sibling, n = n.sibling = at(e, e.pendingProps), n.return = t;
      n.sibling = null;
    }
    return t.child;
  }
  function gs(e, t) {
    return (e.lanes & t) !== 0 ? !0 : (e = e.dependencies, !!(e !== null && Pa(e)));
  }
  function b0(e, t, n) {
    switch (t.tag) {
      case 3:
        Gn(t, t.stateNode.containerInfo), ql(t, xn, e.memoizedState.cache), ba();
        break;
      case 27:
      case 5:
        Dt(t);
        break;
      case 4:
        Gn(t, t.stateNode.containerInfo);
        break;
      case 10:
        ql(
          t,
          t.type,
          t.memoizedProps.value
        );
        break;
      case 31:
        if (t.memoizedState !== null)
          return t.flags |= 128, te(t), null;
        break;
      case 13:
        var l = t.memoizedState;
        if (l !== null)
          return l.dehydrated !== null ? (W(t), t.flags |= 128, null) : (n & t.child.childLanes) !== 0 ? os(e, t, n) : (W(t), e = tl(
            e,
            t,
            n
          ), e !== null ? e.sibling : null);
        W(t);
        break;
      case 19:
        var s = (e.flags & 128) !== 0;
        if (l = (n & t.childLanes) !== 0, l || ($l(
          e,
          t,
          n,
          !1
        ), l = (n & t.childLanes) !== 0), s) {
          if (l)
            return zu(
              e,
              t,
              n
            );
          t.flags |= 128;
        }
        if (s = t.memoizedState, s !== null && (s.rendering = null, s.tail = null, s.lastEffect = null), be(Me, Me.current), l) break;
        return null;
      case 22:
        return t.lanes = 0, Pr(
          e,
          t,
          n,
          t.pendingProps
        );
      case 24:
        ql(t, xn, e.memoizedState.cache);
    }
    return tl(e, t, n);
  }
  function hv(e, t, n) {
    if (e !== null)
      if (e.memoizedProps !== t.pendingProps)
        Fn = !0;
      else {
        if (!gs(e, n) && (t.flags & 128) === 0)
          return Fn = !1, b0(
            e,
            t,
            n
          );
        Fn = (e.flags & 131072) !== 0;
      }
    else
      Fn = !1, Pe && (t.flags & 1048576) !== 0 && gc(t, Sl, t.index);
    switch (t.lanes = 0, t.tag) {
      case 16:
        e: {
          var l = t.pendingProps;
          if (e = El(t.elementType), t.type = e, typeof e == "function")
            Tl(e) ? (l = Qr(e, l), t.tag = 1, t = vf(
              null,
              t,
              e,
              l,
              n
            )) : (t.tag = 0, t = br(
              null,
              t,
              e,
              l,
              n
            ));
          else {
            if (e != null) {
              var s = e.$$typeof;
              if (s === pe) {
                t.tag = 11, t = Dc(
                  null,
                  t,
                  e,
                  l,
                  n
                );
                break e;
              } else if (s === Ce) {
                t.tag = 14, t = kc(
                  null,
                  t,
                  e,
                  l,
                  n
                );
                break e;
              }
            }
            throw t = lt(e) || e, Error(y(306, t, ""));
          }
        }
        return t;
      case 0:
        return br(
          e,
          t,
          t.type,
          t.pendingProps,
          n
        );
      case 1:
        return l = t.type, s = Qr(
          l,
          t.pendingProps
        ), vf(
          e,
          t,
          l,
          s,
          n
        );
      case 3:
        e: {
          if (Gn(
            t,
            t.stateNode.containerInfo
          ), e === null) throw Error(y(387));
          l = t.pendingProps;
          var d = t.memoizedState;
          s = d.element, Ti(e, t), i(t, l, null, n);
          var S = t.memoizedState;
          if (l = S.cache, ql(t, xn, l), l !== d.cache && Yl(
            t,
            [xn],
            n,
            !0
          ), $a(), l = S.element, d.isDehydrated)
            if (d = {
              element: l,
              isDehydrated: !1,
              cache: S.cache
            }, t.updateQueue.baseState = d, t.memoizedState = d, t.flags & 256) {
              t = Jr(
                e,
                t,
                l,
                n
              );
              break e;
            } else if (l !== s) {
              s = qn(
                Error(y(424)),
                t
              ), jl(s), t = Jr(
                e,
                t,
                l,
                n
              );
              break e;
            } else {
              switch (e = t.stateNode.containerInfo, e.nodeType) {
                case 9:
                  e = e.body;
                  break;
                default:
                  e = e.nodeName === "HTML" ? e.ownerDocument.body : e;
              }
              for (xt = Ji(e.firstChild), Vn = t, Pe = !0, Fl = null, xl = !0, n = pc(
                t,
                null,
                l,
                n
              ), t.child = n; n; )
                n.flags = n.flags & -3 | 4096, n = n.sibling;
            }
          else {
            if (ba(), l === s) {
              t = tl(
                e,
                t,
                n
              );
              break e;
            }
            Yn(e, t, l, n);
          }
          t = t.child;
        }
        return t;
      case 26:
        return Bc(e, t), e === null ? (n = wy(
          t.type,
          null,
          t.pendingProps,
          null
        )) ? t.memoizedState = n : Pe || (n = t.type, e = t.pendingProps, l = yd(
          Wt.current
        ).createElement(n), l[mn] = t, l[zn] = e, aa(l, n, e), k(l), t.stateNode = l) : t.memoizedState = wy(
          t.type,
          e.memoizedProps,
          t.pendingProps,
          e.memoizedState
        ), null;
      case 27:
        return Dt(t), e === null && Pe && (l = t.stateNode = Sy(
          t.type,
          t.pendingProps,
          Wt.current
        ), Vn = t, xl = !0, s = xt, Vc(t.type) ? (Jh = s, xt = Ji(l.firstChild)) : xt = s), Yn(
          e,
          t,
          t.pendingProps.children,
          n
        ), Bc(e, t), e === null && (t.flags |= 4194304), t.child;
      case 5:
        return e === null && Pe && ((s = l = xt) && (l = W0(
          l,
          t.type,
          t.pendingProps,
          xl
        ), l !== null ? (t.stateNode = l, Vn = t, xt = Ji(l.firstChild), xl = !1, s = !0) : s = !1), s || Wa(t)), Dt(t), s = t.type, d = t.pendingProps, S = e !== null ? e.memoizedProps : null, l = d.children, Zh(s, d) ? l = null : S !== null && Zh(s, S) && (t.flags |= 32), t.memoizedState !== null && (s = Un(
          e,
          t,
          xu,
          null,
          null,
          n
        ), Nf._currentValue = s), Bc(e, t), Yn(e, t, l, n), t.child;
      case 6:
        return e === null && Pe && ((e = n = xt) && (n = P0(
          n,
          t.pendingProps,
          xl
        ), n !== null ? (t.stateNode = n, Vn = t, xt = null, e = !0) : e = !1), e || Wa(t)), null;
      case 13:
        return os(e, t, n);
      case 4:
        return Gn(
          t,
          t.stateNode.containerInfo
        ), l = t.pendingProps, e === null ? t.child = mi(
          t,
          null,
          l,
          n
        ) : Yn(e, t, l, n), t.child;
      case 11:
        return Dc(
          e,
          t,
          t.type,
          t.pendingProps,
          n
        );
      case 7:
        return Yn(
          e,
          t,
          t.pendingProps,
          n
        ), t.child;
      case 8:
        return Yn(
          e,
          t,
          t.pendingProps.children,
          n
        ), t.child;
      case 12:
        return Yn(
          e,
          t,
          t.pendingProps.children,
          n
        ), t.child;
      case 10:
        return l = t.pendingProps, ql(t, t.type, l.value), Yn(e, t, l.children, n), t.child;
      case 9:
        return s = t.type._context, l = t.pendingProps.children, Qn(t), s = dt(s), l = l(s), t.flags |= 1, Yn(e, t, l, n), t.child;
      case 14:
        return kc(
          e,
          t,
          t.type,
          t.pendingProps,
          n
        );
      case 15:
        return po(
          e,
          t,
          t.type,
          t.pendingProps,
          n
        );
      case 19:
        return zu(e, t, n);
      case 31:
        return Lc(e, t, n);
      case 22:
        return Pr(
          e,
          t,
          n,
          t.pendingProps
        );
      case 24:
        return Qn(t), l = dt(xn), e === null ? (s = Tu(), s === null && (s = an, d = yc(), s.pooledCache = d, d.refCount++, d !== null && (s.pooledCacheLanes |= n), s = d), t.memoizedState = { parent: l, cache: s }, fr(t), ql(t, xn, s)) : ((e.lanes & n) !== 0 && (Ti(e, t), i(t, null, null, n), $a()), s = e.memoizedState, d = t.memoizedState, s.parent !== l ? (s = { parent: l, cache: l }, t.memoizedState = s, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = s), ql(t, xn, l)) : (l = d.cache, ql(t, xn, l), l !== s.cache && Yl(
          t,
          [xn],
          n,
          !0
        ))), Yn(
          e,
          t,
          t.pendingProps.children,
          n
        ), t.child;
      case 29:
        throw t.pendingProps;
    }
    throw Error(y(156, t.tag));
  }
  function Du(e) {
    e.flags |= 4;
  }
  function bh(e, t, n, l, s) {
    if ((t = (e.mode & 32) !== 0) && (t = !1), t) {
      if (e.flags |= 16777216, (s & 335544128) === s)
        if (e.stateNode.complete) e.flags |= 8192;
        else if (Yv()) e.flags |= 8192;
        else
          throw Bn = sr, Zi;
    } else e.flags &= -16777217;
  }
  function gv(e, t) {
    if (t.type !== "stylesheet" || (t.state.loading & 4) !== 0)
      e.flags &= -16777217;
    else if (e.flags |= 16777216, !_y(t))
      if (Yv()) e.flags |= 8192;
      else
        throw Bn = sr, Zi;
  }
  function td(e, t) {
    t !== null && (e.flags |= 4), e.flags & 16384 && (t = e.tag !== 22 ? tu() : 536870912, e.lanes |= t, ms |= t);
  }
  function yf(e, t) {
    if (!Pe)
      switch (e.tailMode) {
        case "hidden":
          t = e.tail;
          for (var n = null; t !== null; )
            t.alternate !== null && (n = t), t = t.sibling;
          n === null ? e.tail = null : n.sibling = null;
          break;
        case "collapsed":
          n = e.tail;
          for (var l = null; n !== null; )
            n.alternate !== null && (l = n), n = n.sibling;
          l === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : l.sibling = null;
      }
  }
  function En(e) {
    var t = e.alternate !== null && e.alternate.child === e.child, n = 0, l = 0;
    if (t)
      for (var s = e.child; s !== null; )
        n |= s.lanes | s.childLanes, l |= s.subtreeFlags & 65011712, l |= s.flags & 65011712, s.return = e, s = s.sibling;
    else
      for (s = e.child; s !== null; )
        n |= s.lanes | s.childLanes, l |= s.subtreeFlags, l |= s.flags, s.return = e, s = s.sibling;
    return e.subtreeFlags |= l, e.childLanes = n, t;
  }
  function m0(e, t, n) {
    var l = t.pendingProps;
    switch (gu(t), t.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return En(t), null;
      case 1:
        return En(t), null;
      case 3:
        return n = t.stateNode, l = null, e !== null && (l = e.memoizedState.cache), t.memoizedState.cache !== l && (t.flags |= 2048), ol(xn), An(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), (e === null || e.child === null) && (Ca(t) ? Du(t) : e === null || e.memoizedState.isDehydrated && (t.flags & 256) === 0 || (t.flags |= 1024, or())), En(t), null;
      case 26:
        var s = t.type, d = t.memoizedState;
        return e === null ? (Du(t), d !== null ? (En(t), gv(t, d)) : (En(t), bh(
          t,
          s,
          null,
          l,
          n
        ))) : d ? d !== e.memoizedState ? (Du(t), En(t), gv(t, d)) : (En(t), t.flags &= -16777217) : (e = e.memoizedProps, e !== l && Du(t), En(t), bh(
          t,
          s,
          e,
          l,
          n
        )), null;
      case 27:
        if (wi(t), n = Wt.current, s = t.type, e !== null && t.stateNode != null)
          e.memoizedProps !== l && Du(t);
        else {
          if (!l) {
            if (t.stateNode === null)
              throw Error(y(166));
            return En(t), null;
          }
          e = Oe.current, Ca(t) ? Kl(t) : (e = Sy(s, l, n), t.stateNode = e, Du(t));
        }
        return En(t), null;
      case 5:
        if (wi(t), s = t.type, e !== null && t.stateNode != null)
          e.memoizedProps !== l && Du(t);
        else {
          if (!l) {
            if (t.stateNode === null)
              throw Error(y(166));
            return En(t), null;
          }
          if (d = Oe.current, Ca(t))
            Kl(t);
          else {
            var S = yd(
              Wt.current
            );
            switch (d) {
              case 1:
                d = S.createElementNS(
                  "http://www.w3.org/2000/svg",
                  s
                );
                break;
              case 2:
                d = S.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  s
                );
                break;
              default:
                switch (s) {
                  case "svg":
                    d = S.createElementNS(
                      "http://www.w3.org/2000/svg",
                      s
                    );
                    break;
                  case "math":
                    d = S.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      s
                    );
                    break;
                  case "script":
                    d = S.createElement("div"), d.innerHTML = "<script><\/script>", d = d.removeChild(
                      d.firstChild
                    );
                    break;
                  case "select":
                    d = typeof l.is == "string" ? S.createElement("select", {
                      is: l.is
                    }) : S.createElement("select"), l.multiple ? d.multiple = !0 : l.size && (d.size = l.size);
                    break;
                  default:
                    d = typeof l.is == "string" ? S.createElement(s, { is: l.is }) : S.createElement(s);
                }
            }
            d[mn] = t, d[zn] = l;
            e: for (S = t.child; S !== null; ) {
              if (S.tag === 5 || S.tag === 6)
                d.appendChild(S.stateNode);
              else if (S.tag !== 4 && S.tag !== 27 && S.child !== null) {
                S.child.return = S, S = S.child;
                continue;
              }
              if (S === t) break e;
              for (; S.sibling === null; ) {
                if (S.return === null || S.return === t)
                  break e;
                S = S.return;
              }
              S.sibling.return = S.return, S = S.sibling;
            }
            t.stateNode = d;
            e: switch (aa(d, s, l), s) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                l = !!l.autoFocus;
                break e;
              case "img":
                l = !0;
                break e;
              default:
                l = !1;
            }
            l && Du(t);
          }
        }
        return En(t), bh(
          t,
          t.type,
          e === null ? null : e.memoizedProps,
          t.pendingProps,
          n
        ), null;
      case 6:
        if (e && t.stateNode != null)
          e.memoizedProps !== l && Du(t);
        else {
          if (typeof l != "string" && t.stateNode === null)
            throw Error(y(166));
          if (e = Wt.current, Ca(t)) {
            if (e = t.stateNode, n = t.memoizedProps, l = null, s = Vn, s !== null)
              switch (s.tag) {
                case 27:
                case 5:
                  l = s.memoizedProps;
              }
            e[mn] = t, e = !!(e.nodeValue === n || l !== null && l.suppressHydrationWarning === !0 || sy(e.nodeValue, n)), e || Wa(t, !0);
          } else
            e = yd(e).createTextNode(
              l
            ), e[mn] = t, t.stateNode = e;
        }
        return En(t), null;
      case 31:
        if (n = t.memoizedState, e === null || e.memoizedState !== null) {
          if (l = Ca(t), n !== null) {
            if (e === null) {
              if (!l) throw Error(y(318));
              if (e = t.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(y(557));
              e[mn] = t;
            } else
              ba(), (t.flags & 128) === 0 && (t.memoizedState = null), t.flags |= 4;
            En(t), e = !1;
          } else
            n = or(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = n), e = !0;
          if (!e)
            return t.flags & 256 ? (Ve(t), t) : (Ve(t), null);
          if ((t.flags & 128) !== 0)
            throw Error(y(558));
        }
        return En(t), null;
      case 13:
        if (l = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
          if (s = Ca(t), l !== null && l.dehydrated !== null) {
            if (e === null) {
              if (!s) throw Error(y(318));
              if (s = t.memoizedState, s = s !== null ? s.dehydrated : null, !s) throw Error(y(317));
              s[mn] = t;
            } else
              ba(), (t.flags & 128) === 0 && (t.memoizedState = null), t.flags |= 4;
            En(t), s = !1;
          } else
            s = or(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = s), s = !0;
          if (!s)
            return t.flags & 256 ? (Ve(t), t) : (Ve(t), null);
        }
        return Ve(t), (t.flags & 128) !== 0 ? (t.lanes = n, t) : (n = l !== null, e = e !== null && e.memoizedState !== null, n && (l = t.child, s = null, l.alternate !== null && l.alternate.memoizedState !== null && l.alternate.memoizedState.cachePool !== null && (s = l.alternate.memoizedState.cachePool.pool), d = null, l.memoizedState !== null && l.memoizedState.cachePool !== null && (d = l.memoizedState.cachePool.pool), d !== s && (l.flags |= 2048)), n !== e && n && (t.child.flags |= 8192), td(t, t.updateQueue), En(t), null);
      case 4:
        return An(), e === null && Fh(t.stateNode.containerInfo), En(t), null;
      case 10:
        return ol(t.type), En(t), null;
      case 19:
        if (qe(Me), l = t.memoizedState, l === null) return En(t), null;
        if (s = (t.flags & 128) !== 0, d = l.rendering, d === null)
          if (s) yf(l, !1);
          else {
            if (Pn !== 0 || e !== null && (e.flags & 128) !== 0)
              for (e = t.child; e !== null; ) {
                if (d = nt(e), d !== null) {
                  for (t.flags |= 128, yf(l, !1), e = d.updateQueue, t.updateQueue = e, td(t, e), t.subtreeFlags = 0, e = n, n = t.child; n !== null; )
                    pn(n, e), n = n.sibling;
                  return be(
                    Me,
                    Me.current & 1 | 2
                  ), Pe && Oa(t, l.treeForkCount), t.child;
                }
                e = e.sibling;
              }
            l.tail !== null && Ge() > rd && (t.flags |= 128, s = !0, yf(l, !1), t.lanes = 4194304);
          }
        else {
          if (!s)
            if (e = nt(d), e !== null) {
              if (t.flags |= 128, s = !0, e = e.updateQueue, t.updateQueue = e, td(t, e), yf(l, !0), l.tail === null && l.tailMode === "hidden" && !d.alternate && !Pe)
                return En(t), null;
            } else
              2 * Ge() - l.renderingStartTime > rd && n !== 536870912 && (t.flags |= 128, s = !0, yf(l, !1), t.lanes = 4194304);
          l.isBackwards ? (d.sibling = t.child, t.child = d) : (e = l.last, e !== null ? e.sibling = d : t.child = d, l.last = d);
        }
        return l.tail !== null ? (e = l.tail, l.rendering = e, l.tail = e.sibling, l.renderingStartTime = Ge(), e.sibling = null, n = Me.current, be(
          Me,
          s ? n & 1 | 2 : n & 1
        ), Pe && Oa(t, l.treeForkCount), e) : (En(t), null);
      case 22:
      case 23:
        return Ve(t), I(), l = t.memoizedState !== null, e !== null ? e.memoizedState !== null !== l && (t.flags |= 8192) : l && (t.flags |= 8192), l ? (n & 536870912) !== 0 && (t.flags & 128) === 0 && (En(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : En(t), n = t.updateQueue, n !== null && td(t, n.retryQueue), n = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), l = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (l = t.memoizedState.cachePool.pool), l !== n && (t.flags |= 2048), e !== null && qe(Ka), null;
      case 24:
        return n = null, e !== null && (n = e.memoizedState.cache), t.memoizedState.cache !== n && (t.flags |= 2048), ol(xn), En(t), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(y(156, t.tag));
  }
  function T0(e, t) {
    switch (gu(t), t.tag) {
      case 1:
        return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
      case 3:
        return ol(xn), An(), e = t.flags, (e & 65536) !== 0 && (e & 128) === 0 ? (t.flags = e & -65537 | 128, t) : null;
      case 26:
      case 27:
      case 5:
        return wi(t), null;
      case 31:
        if (t.memoizedState !== null) {
          if (Ve(t), t.alternate === null)
            throw Error(y(340));
          ba();
        }
        return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
      case 13:
        if (Ve(t), e = t.memoizedState, e !== null && e.dehydrated !== null) {
          if (t.alternate === null)
            throw Error(y(340));
          ba();
        }
        return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
      case 19:
        return qe(Me), null;
      case 4:
        return An(), null;
      case 10:
        return ol(t.type), null;
      case 22:
      case 23:
        return Ve(t), I(), e !== null && qe(Ka), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
      case 24:
        return ol(xn), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function vv(e, t) {
    switch (gu(t), t.tag) {
      case 3:
        ol(xn), An();
        break;
      case 26:
      case 27:
      case 5:
        wi(t);
        break;
      case 4:
        An();
        break;
      case 31:
        t.memoizedState !== null && Ve(t);
        break;
      case 13:
        Ve(t);
        break;
      case 19:
        qe(Me);
        break;
      case 10:
        ol(t.type);
        break;
      case 22:
      case 23:
        Ve(t), I(), e !== null && qe(Ka);
        break;
      case 24:
        ol(xn);
    }
  }
  function bf(e, t) {
    try {
      var n = t.updateQueue, l = n !== null ? n.lastEffect : null;
      if (l !== null) {
        var s = l.next;
        n = s;
        do {
          if ((n.tag & e) === e) {
            l = void 0;
            var d = n.create, S = n.inst;
            l = d(), S.destroy = l;
          }
          n = n.next;
        } while (n !== s);
      }
    } catch (R) {
      qt(t, t.return, R);
    }
  }
  function Uc(e, t, n) {
    try {
      var l = t.updateQueue, s = l !== null ? l.lastEffect : null;
      if (s !== null) {
        var d = s.next;
        l = d;
        do {
          if ((l.tag & e) === e) {
            var S = l.inst, R = S.destroy;
            if (R !== void 0) {
              S.destroy = void 0, s = t;
              var B = n, J = R;
              try {
                J();
              } catch (ie) {
                qt(
                  s,
                  B,
                  ie
                );
              }
            }
          }
          l = l.next;
        } while (l !== d);
      }
    } catch (ie) {
      qt(t, t.return, ie);
    }
  }
  function yv(e) {
    var t = e.updateQueue;
    if (t !== null) {
      var n = e.stateNode;
      try {
        h(t, n);
      } catch (l) {
        qt(e, e.return, l);
      }
    }
  }
  function bv(e, t, n) {
    n.props = Qr(
      e.type,
      e.memoizedProps
    ), n.state = e.memoizedState;
    try {
      n.componentWillUnmount();
    } catch (l) {
      qt(e, t, l);
    }
  }
  function mf(e, t) {
    try {
      var n = e.ref;
      if (n !== null) {
        switch (e.tag) {
          case 26:
          case 27:
          case 5:
            var l = e.stateNode;
            break;
          case 30:
            l = e.stateNode;
            break;
          default:
            l = e.stateNode;
        }
        typeof n == "function" ? e.refCleanup = n(l) : n.current = l;
      }
    } catch (s) {
      qt(e, t, s);
    }
  }
  function Kr(e, t) {
    var n = e.ref, l = e.refCleanup;
    if (n !== null)
      if (typeof l == "function")
        try {
          l();
        } catch (s) {
          qt(e, t, s);
        } finally {
          e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null);
        }
      else if (typeof n == "function")
        try {
          n(null);
        } catch (s) {
          qt(e, t, s);
        }
      else n.current = null;
  }
  function mv(e) {
    var t = e.type, n = e.memoizedProps, l = e.stateNode;
    try {
      e: switch (t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          n.autoFocus && l.focus();
          break e;
        case "img":
          n.src ? l.src = n.src : n.srcSet && (l.srcset = n.srcSet);
      }
    } catch (s) {
      qt(e, e.return, s);
    }
  }
  function mh(e, t, n) {
    try {
      var l = e.stateNode;
      G0(l, e.type, n, t), l[zn] = t;
    } catch (s) {
      qt(e, e.return, s);
    }
  }
  function Tv(e) {
    return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && Vc(e.type) || e.tag === 4;
  }
  function Th(e) {
    e: for (; ; ) {
      for (; e.sibling === null; ) {
        if (e.return === null || Tv(e.return)) return null;
        e = e.return;
      }
      for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
        if (e.tag === 27 && Vc(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue e;
        e.child.return = e, e = e.child;
      }
      if (!(e.flags & 2)) return e.stateNode;
    }
  }
  function ph(e, t, n) {
    var l = e.tag;
    if (l === 5 || l === 6)
      e = e.stateNode, t ? (n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n).insertBefore(e, t) : (t = n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n, t.appendChild(e), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = ga));
    else if (l !== 4 && (l === 27 && Vc(e.type) && (n = e.stateNode, t = null), e = e.child, e !== null))
      for (ph(e, t, n), e = e.sibling; e !== null; )
        ph(e, t, n), e = e.sibling;
  }
  function nd(e, t, n) {
    var l = e.tag;
    if (l === 5 || l === 6)
      e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
    else if (l !== 4 && (l === 27 && Vc(e.type) && (n = e.stateNode), e = e.child, e !== null))
      for (nd(e, t, n), e = e.sibling; e !== null; )
        nd(e, t, n), e = e.sibling;
  }
  function pv(e) {
    var t = e.stateNode, n = e.memoizedProps;
    try {
      for (var l = e.type, s = t.attributes; s.length; )
        t.removeAttributeNode(s[0]);
      aa(t, l, n), t[mn] = e, t[zn] = n;
    } catch (d) {
      qt(e, e.return, d);
    }
  }
  var ku = !1, hl = !1, Sh = !1, Sv = typeof WeakSet == "function" ? WeakSet : Set, Xl = null;
  function p0(e, t) {
    if (e = e.containerInfo, Xh = Ed, e = ho(e), di(e)) {
      if ("selectionStart" in e)
        var n = {
          start: e.selectionStart,
          end: e.selectionEnd
        };
      else
        e: {
          n = (n = e.ownerDocument) && n.defaultView || window;
          var l = n.getSelection && n.getSelection();
          if (l && l.rangeCount !== 0) {
            n = l.anchorNode;
            var s = l.anchorOffset, d = l.focusNode;
            l = l.focusOffset;
            try {
              n.nodeType, d.nodeType;
            } catch {
              n = null;
              break e;
            }
            var S = 0, R = -1, B = -1, J = 0, ie = 0, fe = e, q = null;
            t: for (; ; ) {
              for (var ne; fe !== n || s !== 0 && fe.nodeType !== 3 || (R = S + s), fe !== d || l !== 0 && fe.nodeType !== 3 || (B = S + l), fe.nodeType === 3 && (S += fe.nodeValue.length), (ne = fe.firstChild) !== null; )
                q = fe, fe = ne;
              for (; ; ) {
                if (fe === e) break t;
                if (q === n && ++J === s && (R = S), q === d && ++ie === l && (B = S), (ne = fe.nextSibling) !== null) break;
                fe = q, q = fe.parentNode;
              }
              fe = ne;
            }
            n = R === -1 || B === -1 ? null : { start: R, end: B };
          } else n = null;
        }
      n = n || { start: 0, end: 0 };
    } else n = null;
    for (Ih = { focusedElem: e, selectionRange: n }, Ed = !1, Xl = t; Xl !== null; )
      if (t = Xl, e = t.child, (t.subtreeFlags & 1028) !== 0 && e !== null)
        e.return = t, Xl = e;
      else
        for (; Xl !== null; ) {
          switch (t = Xl, d = t.alternate, e = t.flags, t.tag) {
            case 0:
              if ((e & 4) !== 0 && (e = t.updateQueue, e = e !== null ? e.events : null, e !== null))
                for (n = 0; n < e.length; n++)
                  s = e[n], s.ref.impl = s.nextImpl;
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((e & 1024) !== 0 && d !== null) {
                e = void 0, n = t, s = d.memoizedProps, d = d.memoizedState, l = n.stateNode;
                try {
                  var _e = Qr(
                    n.type,
                    s
                  );
                  e = l.getSnapshotBeforeUpdate(
                    _e,
                    d
                  ), l.__reactInternalSnapshotBeforeUpdate = e;
                } catch (Xe) {
                  qt(
                    n,
                    n.return,
                    Xe
                  );
                }
              }
              break;
            case 3:
              if ((e & 1024) !== 0) {
                if (e = t.stateNode.containerInfo, n = e.nodeType, n === 9)
                  Qh(e);
                else if (n === 1)
                  switch (e.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      Qh(e);
                      break;
                    default:
                      e.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((e & 1024) !== 0) throw Error(y(163));
          }
          if (e = t.sibling, e !== null) {
            e.return = t.return, Xl = e;
            break;
          }
          Xl = t.return;
        }
  }
  function xv(e, t, n) {
    var l = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 15:
        Bu(e, n), l & 4 && bf(5, n);
        break;
      case 1:
        if (Bu(e, n), l & 4)
          if (e = n.stateNode, t === null)
            try {
              e.componentDidMount();
            } catch (S) {
              qt(n, n.return, S);
            }
          else {
            var s = Qr(
              n.type,
              t.memoizedProps
            );
            t = t.memoizedState;
            try {
              e.componentDidUpdate(
                s,
                t,
                e.__reactInternalSnapshotBeforeUpdate
              );
            } catch (S) {
              qt(
                n,
                n.return,
                S
              );
            }
          }
        l & 64 && yv(n), l & 512 && mf(n, n.return);
        break;
      case 3:
        if (Bu(e, n), l & 64 && (e = n.updateQueue, e !== null)) {
          if (t = null, n.child !== null)
            switch (n.child.tag) {
              case 27:
              case 5:
                t = n.child.stateNode;
                break;
              case 1:
                t = n.child.stateNode;
            }
          try {
            h(e, t);
          } catch (S) {
            qt(n, n.return, S);
          }
        }
        break;
      case 27:
        t === null && l & 4 && pv(n);
      case 26:
      case 5:
        Bu(e, n), t === null && l & 4 && mv(n), l & 512 && mf(n, n.return);
        break;
      case 12:
        Bu(e, n);
        break;
      case 31:
        Bu(e, n), l & 4 && Av(e, n);
        break;
      case 13:
        Bu(e, n), l & 4 && Ov(e, n), l & 64 && (e = n.memoizedState, e !== null && (e = e.dehydrated, e !== null && (n = _0.bind(
          null,
          n
        ), J0(e, n))));
        break;
      case 22:
        if (l = n.memoizedState !== null || ku, !l) {
          t = t !== null && t.memoizedState !== null || hl, s = ku;
          var d = hl;
          ku = l, (hl = t) && !d ? Hu(
            e,
            n,
            (n.subtreeFlags & 8772) !== 0
          ) : Bu(e, n), ku = s, hl = d;
        }
        break;
      case 30:
        break;
      default:
        Bu(e, n);
    }
  }
  function Ev(e) {
    var t = e.alternate;
    t !== null && (e.alternate = null, Ev(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && In(t)), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
  }
  var Nn = null, ei = !1;
  function Lu(e, t, n) {
    for (n = n.child; n !== null; )
      wv(e, t, n), n = n.sibling;
  }
  function wv(e, t, n) {
    if (Xn && typeof Xn.onCommitFiberUnmount == "function")
      try {
        Xn.onCommitFiberUnmount(Ml, n);
      } catch {
      }
    switch (n.tag) {
      case 26:
        hl || Kr(n, t), Lu(
          e,
          t,
          n
        ), n.memoizedState ? n.memoizedState.count-- : n.stateNode && (n = n.stateNode, n.parentNode.removeChild(n));
        break;
      case 27:
        hl || Kr(n, t);
        var l = Nn, s = ei;
        Vc(n.type) && (Nn = n.stateNode, ei = !1), Lu(
          e,
          t,
          n
        ), Cf(n.stateNode), Nn = l, ei = s;
        break;
      case 5:
        hl || Kr(n, t);
      case 6:
        if (l = Nn, s = ei, Nn = null, Lu(
          e,
          t,
          n
        ), Nn = l, ei = s, Nn !== null)
          if (ei)
            try {
              (Nn.nodeType === 9 ? Nn.body : Nn.nodeName === "HTML" ? Nn.ownerDocument.body : Nn).removeChild(n.stateNode);
            } catch (d) {
              qt(
                n,
                t,
                d
              );
            }
          else
            try {
              Nn.removeChild(n.stateNode);
            } catch (d) {
              qt(
                n,
                t,
                d
              );
            }
        break;
      case 18:
        Nn !== null && (ei ? (e = Nn, yy(
          e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e,
          n.stateNode
        ), Os(e)) : yy(Nn, n.stateNode));
        break;
      case 4:
        l = Nn, s = ei, Nn = n.stateNode.containerInfo, ei = !0, Lu(
          e,
          t,
          n
        ), Nn = l, ei = s;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        Uc(2, n, t), hl || Uc(4, n, t), Lu(
          e,
          t,
          n
        );
        break;
      case 1:
        hl || (Kr(n, t), l = n.stateNode, typeof l.componentWillUnmount == "function" && bv(
          n,
          t,
          l
        )), Lu(
          e,
          t,
          n
        );
        break;
      case 21:
        Lu(
          e,
          t,
          n
        );
        break;
      case 22:
        hl = (l = hl) || n.memoizedState !== null, Lu(
          e,
          t,
          n
        ), hl = l;
        break;
      default:
        Lu(
          e,
          t,
          n
        );
    }
  }
  function Av(e, t) {
    if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null))) {
      e = e.dehydrated;
      try {
        Os(e);
      } catch (n) {
        qt(t, t.return, n);
      }
    }
  }
  function Ov(e, t) {
    if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null))))
      try {
        Os(e);
      } catch (n) {
        qt(t, t.return, n);
      }
  }
  function S0(e) {
    switch (e.tag) {
      case 31:
      case 13:
      case 19:
        var t = e.stateNode;
        return t === null && (t = e.stateNode = new Sv()), t;
      case 22:
        return e = e.stateNode, t = e._retryCache, t === null && (t = e._retryCache = new Sv()), t;
      default:
        throw Error(y(435, e.tag));
    }
  }
  function ld(e, t) {
    var n = S0(e);
    t.forEach(function(l) {
      if (!n.has(l)) {
        n.add(l);
        var s = N0.bind(null, e, l);
        l.then(s, s);
      }
    });
  }
  function ti(e, t) {
    var n = t.deletions;
    if (n !== null)
      for (var l = 0; l < n.length; l++) {
        var s = n[l], d = e, S = t, R = S;
        e: for (; R !== null; ) {
          switch (R.tag) {
            case 27:
              if (Vc(R.type)) {
                Nn = R.stateNode, ei = !1;
                break e;
              }
              break;
            case 5:
              Nn = R.stateNode, ei = !1;
              break e;
            case 3:
            case 4:
              Nn = R.stateNode.containerInfo, ei = !0;
              break e;
          }
          R = R.return;
        }
        if (Nn === null) throw Error(y(160));
        wv(d, S, s), Nn = null, ei = !1, d = s.alternate, d !== null && (d.return = null), s.return = null;
      }
    if (t.subtreeFlags & 13886)
      for (t = t.child; t !== null; )
        Cv(t, e), t = t.sibling;
  }
  var mr = null;
  function Cv(e, t) {
    var n = e.alternate, l = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        ti(t, e), ni(e), l & 4 && (Uc(3, e, e.return), bf(3, e), Uc(5, e, e.return));
        break;
      case 1:
        ti(t, e), ni(e), l & 512 && (hl || n === null || Kr(n, n.return)), l & 64 && ku && (e = e.updateQueue, e !== null && (l = e.callbacks, l !== null && (n = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = n === null ? l : n.concat(l))));
        break;
      case 26:
        var s = mr;
        if (ti(t, e), ni(e), l & 512 && (hl || n === null || Kr(n, n.return)), l & 4) {
          var d = n !== null ? n.memoizedState : null;
          if (l = e.memoizedState, n === null)
            if (l === null)
              if (e.stateNode === null) {
                e: {
                  l = e.type, n = e.memoizedProps, s = s.ownerDocument || s;
                  t: switch (l) {
                    case "title":
                      d = s.getElementsByTagName("title")[0], (!d || d[pa] || d[mn] || d.namespaceURI === "http://www.w3.org/2000/svg" || d.hasAttribute("itemprop")) && (d = s.createElement(l), s.head.insertBefore(
                        d,
                        s.querySelector("head > title")
                      )), aa(d, l, n), d[mn] = e, k(d), l = d;
                      break e;
                    case "link":
                      var S = Cy(
                        "link",
                        "href",
                        s
                      ).get(l + (n.href || ""));
                      if (S) {
                        for (var R = 0; R < S.length; R++)
                          if (d = S[R], d.getAttribute("href") === (n.href == null || n.href === "" ? null : n.href) && d.getAttribute("rel") === (n.rel == null ? null : n.rel) && d.getAttribute("title") === (n.title == null ? null : n.title) && d.getAttribute("crossorigin") === (n.crossOrigin == null ? null : n.crossOrigin)) {
                            S.splice(R, 1);
                            break t;
                          }
                      }
                      d = s.createElement(l), aa(d, l, n), s.head.appendChild(d);
                      break;
                    case "meta":
                      if (S = Cy(
                        "meta",
                        "content",
                        s
                      ).get(l + (n.content || ""))) {
                        for (R = 0; R < S.length; R++)
                          if (d = S[R], d.getAttribute("content") === (n.content == null ? null : "" + n.content) && d.getAttribute("name") === (n.name == null ? null : n.name) && d.getAttribute("property") === (n.property == null ? null : n.property) && d.getAttribute("http-equiv") === (n.httpEquiv == null ? null : n.httpEquiv) && d.getAttribute("charset") === (n.charSet == null ? null : n.charSet)) {
                            S.splice(R, 1);
                            break t;
                          }
                      }
                      d = s.createElement(l), aa(d, l, n), s.head.appendChild(d);
                      break;
                    default:
                      throw Error(y(468, l));
                  }
                  d[mn] = e, k(d), l = d;
                }
                e.stateNode = l;
              } else
                Ry(
                  s,
                  e.type,
                  e.stateNode
                );
            else
              e.stateNode = Oy(
                s,
                l,
                e.memoizedProps
              );
          else
            d !== l ? (d === null ? n.stateNode !== null && (n = n.stateNode, n.parentNode.removeChild(n)) : d.count--, l === null ? Ry(
              s,
              e.type,
              e.stateNode
            ) : Oy(
              s,
              l,
              e.memoizedProps
            )) : l === null && e.stateNode !== null && mh(
              e,
              e.memoizedProps,
              n.memoizedProps
            );
        }
        break;
      case 27:
        ti(t, e), ni(e), l & 512 && (hl || n === null || Kr(n, n.return)), n !== null && l & 4 && mh(
          e,
          e.memoizedProps,
          n.memoizedProps
        );
        break;
      case 5:
        if (ti(t, e), ni(e), l & 512 && (hl || n === null || Kr(n, n.return)), e.flags & 32) {
          s = e.stateNode;
          try {
            ha(s, "");
          } catch (_e) {
            qt(e, e.return, _e);
          }
        }
        l & 4 && e.stateNode != null && (s = e.memoizedProps, mh(
          e,
          s,
          n !== null ? n.memoizedProps : s
        )), l & 1024 && (Sh = !0);
        break;
      case 6:
        if (ti(t, e), ni(e), l & 4) {
          if (e.stateNode === null)
            throw Error(y(162));
          l = e.memoizedProps, n = e.stateNode;
          try {
            n.nodeValue = l;
          } catch (_e) {
            qt(e, e.return, _e);
          }
        }
        break;
      case 3:
        if (Td = null, s = mr, mr = bd(t.containerInfo), ti(t, e), mr = s, ni(e), l & 4 && n !== null && n.memoizedState.isDehydrated)
          try {
            Os(t.containerInfo);
          } catch (_e) {
            qt(e, e.return, _e);
          }
        Sh && (Sh = !1, Rv(e));
        break;
      case 4:
        l = mr, mr = bd(
          e.stateNode.containerInfo
        ), ti(t, e), ni(e), mr = l;
        break;
      case 12:
        ti(t, e), ni(e);
        break;
      case 31:
        ti(t, e), ni(e), l & 4 && (l = e.updateQueue, l !== null && (e.updateQueue = null, ld(e, l)));
        break;
      case 13:
        ti(t, e), ni(e), e.child.flags & 8192 && e.memoizedState !== null != (n !== null && n.memoizedState !== null) && (id = Ge()), l & 4 && (l = e.updateQueue, l !== null && (e.updateQueue = null, ld(e, l)));
        break;
      case 22:
        s = e.memoizedState !== null;
        var B = n !== null && n.memoizedState !== null, J = ku, ie = hl;
        if (ku = J || s, hl = ie || B, ti(t, e), hl = ie, ku = J, ni(e), l & 8192)
          e: for (t = e.stateNode, t._visibility = s ? t._visibility & -2 : t._visibility | 1, s && (n === null || B || ku || hl || wo(e)), n = null, t = e; ; ) {
            if (t.tag === 5 || t.tag === 26) {
              if (n === null) {
                B = n = t;
                try {
                  if (d = B.stateNode, s)
                    S = d.style, typeof S.setProperty == "function" ? S.setProperty("display", "none", "important") : S.display = "none";
                  else {
                    R = B.stateNode;
                    var fe = B.memoizedProps.style, q = fe != null && fe.hasOwnProperty("display") ? fe.display : null;
                    R.style.display = q == null || typeof q == "boolean" ? "" : ("" + q).trim();
                  }
                } catch (_e) {
                  qt(B, B.return, _e);
                }
              }
            } else if (t.tag === 6) {
              if (n === null) {
                B = t;
                try {
                  B.stateNode.nodeValue = s ? "" : B.memoizedProps;
                } catch (_e) {
                  qt(B, B.return, _e);
                }
              }
            } else if (t.tag === 18) {
              if (n === null) {
                B = t;
                try {
                  var ne = B.stateNode;
                  s ? by(ne, !0) : by(B.stateNode, !1);
                } catch (_e) {
                  qt(B, B.return, _e);
                }
              }
            } else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === e) && t.child !== null) {
              t.child.return = t, t = t.child;
              continue;
            }
            if (t === e) break e;
            for (; t.sibling === null; ) {
              if (t.return === null || t.return === e) break e;
              n === t && (n = null), t = t.return;
            }
            n === t && (n = null), t.sibling.return = t.return, t = t.sibling;
          }
        l & 4 && (l = e.updateQueue, l !== null && (n = l.retryQueue, n !== null && (l.retryQueue = null, ld(e, n))));
        break;
      case 19:
        ti(t, e), ni(e), l & 4 && (l = e.updateQueue, l !== null && (e.updateQueue = null, ld(e, l)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        ti(t, e), ni(e);
    }
  }
  function ni(e) {
    var t = e.flags;
    if (t & 2) {
      try {
        for (var n, l = e.return; l !== null; ) {
          if (Tv(l)) {
            n = l;
            break;
          }
          l = l.return;
        }
        if (n == null) throw Error(y(160));
        switch (n.tag) {
          case 27:
            var s = n.stateNode, d = Th(e);
            nd(e, d, s);
            break;
          case 5:
            var S = n.stateNode;
            n.flags & 32 && (ha(S, ""), n.flags &= -33);
            var R = Th(e);
            nd(e, R, S);
            break;
          case 3:
          case 4:
            var B = n.stateNode.containerInfo, J = Th(e);
            ph(
              e,
              J,
              B
            );
            break;
          default:
            throw Error(y(161));
        }
      } catch (ie) {
        qt(e, e.return, ie);
      }
      e.flags &= -3;
    }
    t & 4096 && (e.flags &= -4097);
  }
  function Rv(e) {
    if (e.subtreeFlags & 1024)
      for (e = e.child; e !== null; ) {
        var t = e;
        Rv(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), e = e.sibling;
      }
  }
  function Bu(e, t) {
    if (t.subtreeFlags & 8772)
      for (t = t.child; t !== null; )
        xv(e, t.alternate, t), t = t.sibling;
  }
  function wo(e) {
    for (e = e.child; e !== null; ) {
      var t = e;
      switch (t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Uc(4, t, t.return), wo(t);
          break;
        case 1:
          Kr(t, t.return);
          var n = t.stateNode;
          typeof n.componentWillUnmount == "function" && bv(
            t,
            t.return,
            n
          ), wo(t);
          break;
        case 27:
          Cf(t.stateNode);
        case 26:
        case 5:
          Kr(t, t.return), wo(t);
          break;
        case 22:
          t.memoizedState === null && wo(t);
          break;
        case 30:
          wo(t);
          break;
        default:
          wo(t);
      }
      e = e.sibling;
    }
  }
  function Hu(e, t, n) {
    for (n = n && (t.subtreeFlags & 8772) !== 0, t = t.child; t !== null; ) {
      var l = t.alternate, s = e, d = t, S = d.flags;
      switch (d.tag) {
        case 0:
        case 11:
        case 15:
          Hu(
            s,
            d,
            n
          ), bf(4, d);
          break;
        case 1:
          if (Hu(
            s,
            d,
            n
          ), l = d, s = l.stateNode, typeof s.componentDidMount == "function")
            try {
              s.componentDidMount();
            } catch (J) {
              qt(l, l.return, J);
            }
          if (l = d, s = l.updateQueue, s !== null) {
            var R = l.stateNode;
            try {
              var B = s.shared.hiddenCallbacks;
              if (B !== null)
                for (s.shared.hiddenCallbacks = null, s = 0; s < B.length; s++)
                  u(B[s], R);
            } catch (J) {
              qt(l, l.return, J);
            }
          }
          n && S & 64 && yv(d), mf(d, d.return);
          break;
        case 27:
          pv(d);
        case 26:
        case 5:
          Hu(
            s,
            d,
            n
          ), n && l === null && S & 4 && mv(d), mf(d, d.return);
          break;
        case 12:
          Hu(
            s,
            d,
            n
          );
          break;
        case 31:
          Hu(
            s,
            d,
            n
          ), n && S & 4 && Av(s, d);
          break;
        case 13:
          Hu(
            s,
            d,
            n
          ), n && S & 4 && Ov(s, d);
          break;
        case 22:
          d.memoizedState === null && Hu(
            s,
            d,
            n
          ), mf(d, d.return);
          break;
        case 30:
          break;
        default:
          Hu(
            s,
            d,
            n
          );
      }
      t = t.sibling;
    }
  }
  function xh(e, t) {
    var n = null;
    e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), e = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), e !== n && (e != null && e.refCount++, n != null && ea(n));
  }
  function Eh(e, t) {
    e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && ea(e));
  }
  function Tr(e, t, n, l) {
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; )
        _v(
          e,
          t,
          n,
          l
        ), t = t.sibling;
  }
  function _v(e, t, n, l) {
    var s = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        Tr(
          e,
          t,
          n,
          l
        ), s & 2048 && bf(9, t);
        break;
      case 1:
        Tr(
          e,
          t,
          n,
          l
        );
        break;
      case 3:
        Tr(
          e,
          t,
          n,
          l
        ), s & 2048 && (e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && ea(e)));
        break;
      case 12:
        if (s & 2048) {
          Tr(
            e,
            t,
            n,
            l
          ), e = t.stateNode;
          try {
            var d = t.memoizedProps, S = d.id, R = d.onPostCommit;
            typeof R == "function" && R(
              S,
              t.alternate === null ? "mount" : "update",
              e.passiveEffectDuration,
              -0
            );
          } catch (B) {
            qt(t, t.return, B);
          }
        } else
          Tr(
            e,
            t,
            n,
            l
          );
        break;
      case 31:
        Tr(
          e,
          t,
          n,
          l
        );
        break;
      case 13:
        Tr(
          e,
          t,
          n,
          l
        );
        break;
      case 23:
        break;
      case 22:
        d = t.stateNode, S = t.alternate, t.memoizedState !== null ? d._visibility & 2 ? Tr(
          e,
          t,
          n,
          l
        ) : Tf(e, t) : d._visibility & 2 ? Tr(
          e,
          t,
          n,
          l
        ) : (d._visibility |= 2, vs(
          e,
          t,
          n,
          l,
          (t.subtreeFlags & 10256) !== 0 || !1
        )), s & 2048 && xh(S, t);
        break;
      case 24:
        Tr(
          e,
          t,
          n,
          l
        ), s & 2048 && Eh(t.alternate, t);
        break;
      default:
        Tr(
          e,
          t,
          n,
          l
        );
    }
  }
  function vs(e, t, n, l, s) {
    for (s = s && ((t.subtreeFlags & 10256) !== 0 || !1), t = t.child; t !== null; ) {
      var d = e, S = t, R = n, B = l, J = S.flags;
      switch (S.tag) {
        case 0:
        case 11:
        case 15:
          vs(
            d,
            S,
            R,
            B,
            s
          ), bf(8, S);
          break;
        case 23:
          break;
        case 22:
          var ie = S.stateNode;
          S.memoizedState !== null ? ie._visibility & 2 ? vs(
            d,
            S,
            R,
            B,
            s
          ) : Tf(
            d,
            S
          ) : (ie._visibility |= 2, vs(
            d,
            S,
            R,
            B,
            s
          )), s && J & 2048 && xh(
            S.alternate,
            S
          );
          break;
        case 24:
          vs(
            d,
            S,
            R,
            B,
            s
          ), s && J & 2048 && Eh(S.alternate, S);
          break;
        default:
          vs(
            d,
            S,
            R,
            B,
            s
          );
      }
      t = t.sibling;
    }
  }
  function Tf(e, t) {
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; ) {
        var n = e, l = t, s = l.flags;
        switch (l.tag) {
          case 22:
            Tf(n, l), s & 2048 && xh(
              l.alternate,
              l
            );
            break;
          case 24:
            Tf(n, l), s & 2048 && Eh(l.alternate, l);
            break;
          default:
            Tf(n, l);
        }
        t = t.sibling;
      }
  }
  var pf = 8192;
  function ys(e, t, n) {
    if (e.subtreeFlags & pf)
      for (e = e.child; e !== null; )
        Nv(
          e,
          t,
          n
        ), e = e.sibling;
  }
  function Nv(e, t, n) {
    switch (e.tag) {
      case 26:
        ys(
          e,
          t,
          n
        ), e.flags & pf && e.memoizedState !== null && u1(
          n,
          mr,
          e.memoizedState,
          e.memoizedProps
        );
        break;
      case 5:
        ys(
          e,
          t,
          n
        );
        break;
      case 3:
      case 4:
        var l = mr;
        mr = bd(e.stateNode.containerInfo), ys(
          e,
          t,
          n
        ), mr = l;
        break;
      case 22:
        e.memoizedState === null && (l = e.alternate, l !== null && l.memoizedState !== null ? (l = pf, pf = 16777216, ys(
          e,
          t,
          n
        ), pf = l) : ys(
          e,
          t,
          n
        ));
        break;
      default:
        ys(
          e,
          t,
          n
        );
    }
  }
  function Mv(e) {
    var t = e.alternate;
    if (t !== null && (e = t.child, e !== null)) {
      t.child = null;
      do
        t = e.sibling, e.sibling = null, e = t;
      while (e !== null);
    }
  }
  function Sf(e) {
    var t = e.deletions;
    if ((e.flags & 16) !== 0) {
      if (t !== null)
        for (var n = 0; n < t.length; n++) {
          var l = t[n];
          Xl = l, Dv(
            l,
            e
          );
        }
      Mv(e);
    }
    if (e.subtreeFlags & 10256)
      for (e = e.child; e !== null; )
        zv(e), e = e.sibling;
  }
  function zv(e) {
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        Sf(e), e.flags & 2048 && Uc(9, e, e.return);
        break;
      case 3:
        Sf(e);
        break;
      case 12:
        Sf(e);
        break;
      case 22:
        var t = e.stateNode;
        e.memoizedState !== null && t._visibility & 2 && (e.return === null || e.return.tag !== 13) ? (t._visibility &= -3, ad(e)) : Sf(e);
        break;
      default:
        Sf(e);
    }
  }
  function ad(e) {
    var t = e.deletions;
    if ((e.flags & 16) !== 0) {
      if (t !== null)
        for (var n = 0; n < t.length; n++) {
          var l = t[n];
          Xl = l, Dv(
            l,
            e
          );
        }
      Mv(e);
    }
    for (e = e.child; e !== null; ) {
      switch (t = e, t.tag) {
        case 0:
        case 11:
        case 15:
          Uc(8, t, t.return), ad(t);
          break;
        case 22:
          n = t.stateNode, n._visibility & 2 && (n._visibility &= -3, ad(t));
          break;
        default:
          ad(t);
      }
      e = e.sibling;
    }
  }
  function Dv(e, t) {
    for (; Xl !== null; ) {
      var n = Xl;
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          Uc(8, n, t);
          break;
        case 23:
        case 22:
          if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
            var l = n.memoizedState.cachePool.pool;
            l != null && l.refCount++;
          }
          break;
        case 24:
          ea(n.memoizedState.cache);
      }
      if (l = n.child, l !== null) l.return = n, Xl = l;
      else
        e: for (n = e; Xl !== null; ) {
          l = Xl;
          var s = l.sibling, d = l.return;
          if (Ev(l), l === n) {
            Xl = null;
            break e;
          }
          if (s !== null) {
            s.return = d, Xl = s;
            break e;
          }
          Xl = d;
        }
    }
  }
  var x0 = {
    getCacheForType: function(e) {
      var t = dt(xn), n = t.data.get(e);
      return n === void 0 && (n = e(), t.data.set(e, n)), n;
    },
    cacheSignal: function() {
      return dt(xn).controller.signal;
    }
  }, E0 = typeof WeakMap == "function" ? WeakMap : Map, Ft = 0, an = null, vt = null, pt = 0, jt = 0, Si = null, Fc = !1, bs = !1, wh = !1, Uu = 0, Pn = 0, Yc = 0, Ao = 0, Ah = 0, xi = 0, ms = 0, xf = null, li = null, Oh = !1, id = 0, kv = 0, rd = 1 / 0, ud = null, Gc = null, Cl = 0, Xc = null, Ts = null, Fu = 0, Ch = 0, Rh = null, Lv = null, Ef = 0, _h = null;
  function Ei() {
    return (Ft & 2) !== 0 && pt !== 0 ? pt & -pt : Q.T !== null ? Lh() : It();
  }
  function Bv() {
    if (xi === 0)
      if ((pt & 536870912) === 0 || Pe) {
        var e = Vl;
        Vl <<= 1, (Vl & 3932160) === 0 && (Vl = 262144), xi = e;
      } else xi = 536870912;
    return e = L.current, e !== null && (e.flags |= 32), xi;
  }
  function ai(e, t, n) {
    (e === an && (jt === 2 || jt === 9) || e.cancelPendingCommit !== null) && (ps(e, 0), Ic(
      e,
      pt,
      xi,
      !1
    )), Ql(e, n), ((Ft & 2) === 0 || e !== an) && (e === an && ((Ft & 2) === 0 && (Ao |= n), Pn === 4 && Ic(
      e,
      pt,
      xi,
      !1
    )), jr(e));
  }
  function Hv(e, t, n) {
    if ((Ft & 6) !== 0) throw Error(y(327));
    var l = !n && (t & 127) === 0 && (t & e.expiredLanes) === 0 || bn(e, t), s = l ? O0(e, t) : Mh(e, t, !0), d = l;
    do {
      if (s === 0) {
        bs && !l && Ic(e, t, 0, !1);
        break;
      } else {
        if (n = e.current.alternate, d && !w0(n)) {
          s = Mh(e, t, !1), d = !1;
          continue;
        }
        if (s === 2) {
          if (d = t, e.errorRecoveryDisabledLanes & d)
            var S = 0;
          else
            S = e.pendingLanes & -536870913, S = S !== 0 ? S : S & 536870912 ? 536870912 : 0;
          if (S !== 0) {
            t = S;
            e: {
              var R = e;
              s = xf;
              var B = R.current.memoizedState.isDehydrated;
              if (B && (ps(R, S).flags |= 256), S = Mh(
                R,
                S,
                !1
              ), S !== 2) {
                if (wh && !B) {
                  R.errorRecoveryDisabledLanes |= d, Ao |= d, s = 4;
                  break e;
                }
                d = li, li = s, d !== null && (li === null ? li = d : li.push.apply(
                  li,
                  d
                ));
              }
              s = S;
            }
            if (d = !1, s !== 2) continue;
          }
        }
        if (s === 1) {
          ps(e, 0), Ic(e, t, 0, !0);
          break;
        }
        e: {
          switch (l = e, d = s, d) {
            case 0:
            case 1:
              throw Error(y(345));
            case 4:
              if ((t & 4194048) !== t) break;
            case 6:
              Ic(
                l,
                t,
                xi,
                !Fc
              );
              break e;
            case 2:
              li = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(y(329));
          }
          if ((t & 62914560) === t && (s = id + 300 - Ge(), 10 < s)) {
            if (Ic(
              l,
              t,
              xi,
              !Fc
            ), Fa(l, 0, !0) !== 0) break e;
            Fu = t, l.timeoutHandle = gy(
              Uv.bind(
                null,
                l,
                n,
                li,
                ud,
                Oh,
                t,
                xi,
                Ao,
                ms,
                Fc,
                d,
                "Throttled",
                -0,
                0
              ),
              s
            );
            break e;
          }
          Uv(
            l,
            n,
            li,
            ud,
            Oh,
            t,
            xi,
            Ao,
            ms,
            Fc,
            d,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    jr(e);
  }
  function Uv(e, t, n, l, s, d, S, R, B, J, ie, fe, q, ne) {
    if (e.timeoutHandle = -1, fe = t.subtreeFlags, fe & 8192 || (fe & 16785408) === 16785408) {
      fe = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: ga
      }, Nv(
        t,
        d,
        fe
      );
      var _e = (d & 62914560) === d ? id - Ge() : (d & 4194048) === d ? kv - Ge() : 0;
      if (_e = c1(
        fe,
        _e
      ), _e !== null) {
        Fu = d, e.cancelPendingCommit = _e(
          Qv.bind(
            null,
            e,
            t,
            d,
            n,
            l,
            s,
            S,
            R,
            B,
            ie,
            fe,
            null,
            q,
            ne
          )
        ), Ic(e, d, S, !J);
        return;
      }
    }
    Qv(
      e,
      t,
      d,
      n,
      l,
      s,
      S,
      R,
      B
    );
  }
  function w0(e) {
    for (var t = e; ; ) {
      var n = t.tag;
      if ((n === 0 || n === 11 || n === 15) && t.flags & 16384 && (n = t.updateQueue, n !== null && (n = n.stores, n !== null)))
        for (var l = 0; l < n.length; l++) {
          var s = n[l], d = s.getSnapshot;
          s = s.value;
          try {
            if (!kn(d(), s)) return !1;
          } catch {
            return !1;
          }
        }
      if (n = t.child, t.subtreeFlags & 16384 && n !== null)
        n.return = t, t = n;
      else {
        if (t === e) break;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e) return !0;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
    }
    return !0;
  }
  function Ic(e, t, n, l) {
    t &= ~Ah, t &= ~Ao, e.suspendedLanes |= t, e.pingedLanes &= ~t, l && (e.warmLanes |= t), l = e.expirationTimes;
    for (var s = t; 0 < s; ) {
      var d = 31 - vn(s), S = 1 << d;
      l[d] = -1, s &= ~S;
    }
    n !== 0 && ui(e, n, t);
  }
  function cd() {
    return (Ft & 6) === 0 ? (wf(0), !1) : !0;
  }
  function Nh() {
    if (vt !== null) {
      if (jt === 0)
        var e = vt.return;
      else
        e = vt, cl = Jt = null, Eu(e), Qi = null, ta = 0, e = vt;
      for (; e !== null; )
        vv(e.alternate, e), e = e.return;
      vt = null;
    }
  }
  function ps(e, t) {
    var n = e.timeoutHandle;
    n !== -1 && (e.timeoutHandle = -1, Z0(n)), n = e.cancelPendingCommit, n !== null && (e.cancelPendingCommit = null, n()), Fu = 0, Nh(), an = e, vt = n = at(e.current, null), pt = t, jt = 0, Si = null, Fc = !1, bs = bn(e, t), wh = !1, ms = xi = Ah = Ao = Yc = Pn = 0, li = xf = null, Oh = !1, (t & 8) !== 0 && (t |= t & 32);
    var l = e.entangledLanes;
    if (l !== 0)
      for (e = e.entanglements, l &= t; 0 < l; ) {
        var s = 31 - vn(l), d = 1 << s;
        t |= e[s], l &= ~d;
      }
    return Uu = t, Qe(), n;
  }
  function Fv(e, t) {
    Ae = null, Q.H = Vr, t === Na || t === Vi ? (t = Tc(), jt = 3) : t === Zi ? (t = Tc(), jt = 4) : jt = t === hf ? 8 : t !== null && typeof t == "object" && typeof t.then == "function" ? 6 : 1, Si = t, vt === null && (Pn = 1, yr(
      e,
      qn(t, e.current)
    ));
  }
  function Yv() {
    var e = L.current;
    return e === null ? !0 : (pt & 4194048) === pt ? X === null : (pt & 62914560) === pt || (pt & 536870912) !== 0 ? e === X : !1;
  }
  function Gv() {
    var e = Q.H;
    return Q.H = Vr, e === null ? Vr : e;
  }
  function Xv() {
    var e = Q.A;
    return Q.A = x0, e;
  }
  function od() {
    Pn = 4, Fc || (pt & 4194048) !== pt && L.current !== null || (bs = !0), (Yc & 134217727) === 0 && (Ao & 134217727) === 0 || an === null || Ic(
      an,
      pt,
      xi,
      !1
    );
  }
  function Mh(e, t, n) {
    var l = Ft;
    Ft |= 2;
    var s = Gv(), d = Xv();
    (an !== e || pt !== t) && (ud = null, ps(e, t)), t = !1;
    var S = Pn;
    e: do
      try {
        if (jt !== 0 && vt !== null) {
          var R = vt, B = Si;
          switch (jt) {
            case 8:
              Nh(), S = 6;
              break e;
            case 3:
            case 2:
            case 9:
            case 6:
              L.current === null && (t = !0);
              var J = jt;
              if (jt = 0, Si = null, Ss(e, R, B, J), n && bs) {
                S = 0;
                break e;
              }
              break;
            default:
              J = jt, jt = 0, Si = null, Ss(e, R, B, J);
          }
        }
        A0(), S = Pn;
        break;
      } catch (ie) {
        Fv(e, ie);
      }
    while (!0);
    return t && e.shellSuspendCounter++, cl = Jt = null, Ft = l, Q.H = s, Q.A = d, vt === null && (an = null, pt = 0, Qe()), S;
  }
  function A0() {
    for (; vt !== null; ) Iv(vt);
  }
  function O0(e, t) {
    var n = Ft;
    Ft |= 2;
    var l = Gv(), s = Xv();
    an !== e || pt !== t ? (ud = null, rd = Ge() + 500, ps(e, t)) : bs = bn(
      e,
      t
    );
    e: do
      try {
        if (jt !== 0 && vt !== null) {
          t = vt;
          var d = Si;
          t: switch (jt) {
            case 1:
              jt = 0, Si = null, Ss(e, t, d, 1);
              break;
            case 2:
            case 9:
              if (Br(d)) {
                jt = 0, Si = null, Zv(t);
                break;
              }
              t = function() {
                jt !== 2 && jt !== 9 || an !== e || (jt = 7), jr(e);
              }, d.then(t, t);
              break e;
            case 3:
              jt = 7;
              break e;
            case 4:
              jt = 5;
              break e;
            case 7:
              Br(d) ? (jt = 0, Si = null, Zv(t)) : (jt = 0, Si = null, Ss(e, t, d, 7));
              break;
            case 5:
              var S = null;
              switch (vt.tag) {
                case 26:
                  S = vt.memoizedState;
                case 5:
                case 27:
                  var R = vt;
                  if (S ? _y(S) : R.stateNode.complete) {
                    jt = 0, Si = null;
                    var B = R.sibling;
                    if (B !== null) vt = B;
                    else {
                      var J = R.return;
                      J !== null ? (vt = J, sd(J)) : vt = null;
                    }
                    break t;
                  }
              }
              jt = 0, Si = null, Ss(e, t, d, 5);
              break;
            case 6:
              jt = 0, Si = null, Ss(e, t, d, 6);
              break;
            case 8:
              Nh(), Pn = 6;
              break e;
            default:
              throw Error(y(462));
          }
        }
        C0();
        break;
      } catch (ie) {
        Fv(e, ie);
      }
    while (!0);
    return cl = Jt = null, Q.H = l, Q.A = s, Ft = n, vt !== null ? 0 : (an = null, pt = 0, Qe(), Pn);
  }
  function C0() {
    for (; vt !== null && !ca(); )
      Iv(vt);
  }
  function Iv(e) {
    var t = hv(e.alternate, e, Uu);
    e.memoizedProps = e.pendingProps, t === null ? sd(e) : vt = t;
  }
  function Zv(e) {
    var t = e, n = t.alternate;
    switch (t.tag) {
      case 15:
      case 0:
        t = us(
          n,
          t,
          t.pendingProps,
          t.type,
          void 0,
          pt
        );
        break;
      case 11:
        t = us(
          n,
          t,
          t.pendingProps,
          t.type.render,
          t.ref,
          pt
        );
        break;
      case 5:
        Eu(t);
      default:
        vv(n, t), t = vt = pn(t, Uu), t = hv(n, t, Uu);
    }
    e.memoizedProps = e.pendingProps, t === null ? sd(e) : vt = t;
  }
  function Ss(e, t, n, l) {
    cl = Jt = null, Eu(t), Qi = null, ta = 0;
    var s = t.return;
    try {
      if (yh(
        e,
        s,
        t,
        n,
        pt
      )) {
        Pn = 1, yr(
          e,
          qn(n, e.current)
        ), vt = null;
        return;
      }
    } catch (d) {
      if (s !== null) throw vt = s, d;
      Pn = 1, yr(
        e,
        qn(n, e.current)
      ), vt = null;
      return;
    }
    t.flags & 32768 ? (Pe || l === 1 ? e = !0 : bs || (pt & 536870912) !== 0 ? e = !1 : (Fc = e = !0, (l === 2 || l === 9 || l === 3 || l === 6) && (l = L.current, l !== null && l.tag === 13 && (l.flags |= 16384))), Vv(t, e)) : sd(t);
  }
  function sd(e) {
    var t = e;
    do {
      if ((t.flags & 32768) !== 0) {
        Vv(
          t,
          Fc
        );
        return;
      }
      e = t.return;
      var n = m0(
        t.alternate,
        t,
        Uu
      );
      if (n !== null) {
        vt = n;
        return;
      }
      if (t = t.sibling, t !== null) {
        vt = t;
        return;
      }
      vt = t = e;
    } while (t !== null);
    Pn === 0 && (Pn = 5);
  }
  function Vv(e, t) {
    do {
      var n = T0(e.alternate, e);
      if (n !== null) {
        n.flags &= 32767, vt = n;
        return;
      }
      if (n = e.return, n !== null && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !t && (e = e.sibling, e !== null)) {
        vt = e;
        return;
      }
      vt = e = n;
    } while (e !== null);
    Pn = 6, vt = null;
  }
  function Qv(e, t, n, l, s, d, S, R, B) {
    e.cancelPendingCommit = null;
    do
      fd();
    while (Cl !== 0);
    if ((Ft & 6) !== 0) throw Error(y(327));
    if (t !== null) {
      if (t === e.current) throw Error(y(177));
      if (d = t.lanes | t.childLanes, d |= Ke, tr(
        e,
        n,
        d,
        S,
        R,
        B
      ), e === an && (vt = an = null, pt = 0), Ts = t, Xc = e, Fu = n, Ch = d, Rh = s, Lv = l, (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0 ? (e.callbackNode = null, e.callbackPriority = 0, M0(Ut, function() {
        return jv(), null;
      })) : (e.callbackNode = null, e.callbackPriority = 0), l = (t.flags & 13878) !== 0, (t.subtreeFlags & 13878) !== 0 || l) {
        l = Q.T, Q.T = null, s = Se.p, Se.p = 2, S = Ft, Ft |= 4;
        try {
          p0(e, t, n);
        } finally {
          Ft = S, Se.p = s, Q.T = l;
        }
      }
      Cl = 1, Wv(), Pv(), Jv();
    }
  }
  function Wv() {
    if (Cl === 1) {
      Cl = 0;
      var e = Xc, t = Ts, n = (t.flags & 13878) !== 0;
      if ((t.subtreeFlags & 13878) !== 0 || n) {
        n = Q.T, Q.T = null;
        var l = Se.p;
        Se.p = 2;
        var s = Ft;
        Ft |= 4;
        try {
          Cv(t, e);
          var d = Ih, S = ho(e.containerInfo), R = d.focusedElem, B = d.selectionRange;
          if (S !== R && R && R.ownerDocument && dc(
            R.ownerDocument.documentElement,
            R
          )) {
            if (B !== null && di(R)) {
              var J = B.start, ie = B.end;
              if (ie === void 0 && (ie = J), "selectionStart" in R)
                R.selectionStart = J, R.selectionEnd = Math.min(
                  ie,
                  R.value.length
                );
              else {
                var fe = R.ownerDocument || document, q = fe && fe.defaultView || window;
                if (q.getSelection) {
                  var ne = q.getSelection(), _e = R.textContent.length, Xe = Math.min(B.start, _e), tn = B.end === void 0 ? Xe : Math.min(B.end, _e);
                  !ne.extend && Xe > tn && (S = tn, tn = Xe, Xe = S);
                  var V = Yi(
                    R,
                    Xe
                  ), G = Yi(
                    R,
                    tn
                  );
                  if (V && G && (ne.rangeCount !== 1 || ne.anchorNode !== V.node || ne.anchorOffset !== V.offset || ne.focusNode !== G.node || ne.focusOffset !== G.offset)) {
                    var P = fe.createRange();
                    P.setStart(V.node, V.offset), ne.removeAllRanges(), Xe > tn ? (ne.addRange(P), ne.extend(G.node, G.offset)) : (P.setEnd(G.node, G.offset), ne.addRange(P));
                  }
                }
              }
            }
            for (fe = [], ne = R; ne = ne.parentNode; )
              ne.nodeType === 1 && fe.push({
                element: ne,
                left: ne.scrollLeft,
                top: ne.scrollTop
              });
            for (typeof R.focus == "function" && R.focus(), R = 0; R < fe.length; R++) {
              var oe = fe[R];
              oe.element.scrollLeft = oe.left, oe.element.scrollTop = oe.top;
            }
          }
          Ed = !!Xh, Ih = Xh = null;
        } finally {
          Ft = s, Se.p = l, Q.T = n;
        }
      }
      e.current = t, Cl = 2;
    }
  }
  function Pv() {
    if (Cl === 2) {
      Cl = 0;
      var e = Xc, t = Ts, n = (t.flags & 8772) !== 0;
      if ((t.subtreeFlags & 8772) !== 0 || n) {
        n = Q.T, Q.T = null;
        var l = Se.p;
        Se.p = 2;
        var s = Ft;
        Ft |= 4;
        try {
          xv(e, t.alternate, t);
        } finally {
          Ft = s, Se.p = l, Q.T = n;
        }
      }
      Cl = 3;
    }
  }
  function Jv() {
    if (Cl === 4 || Cl === 3) {
      Cl = 0, eu();
      var e = Xc, t = Ts, n = Fu, l = Lv;
      (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0 ? Cl = 5 : (Cl = 0, Ts = Xc = null, Kv(e, e.pendingLanes));
      var s = e.pendingLanes;
      if (s === 0 && (Gc = null), Ci(n), t = t.stateNode, Xn && typeof Xn.onCommitFiberRoot == "function")
        try {
          Xn.onCommitFiberRoot(
            Ml,
            t,
            void 0,
            (t.current.flags & 128) === 128
          );
        } catch {
        }
      if (l !== null) {
        t = Q.T, s = Se.p, Se.p = 2, Q.T = null;
        try {
          for (var d = e.onRecoverableError, S = 0; S < l.length; S++) {
            var R = l[S];
            d(R.value, {
              componentStack: R.stack
            });
          }
        } finally {
          Q.T = t, Se.p = s;
        }
      }
      (Fu & 3) !== 0 && fd(), jr(e), s = e.pendingLanes, (n & 261930) !== 0 && (s & 42) !== 0 ? e === _h ? Ef++ : (Ef = 0, _h = e) : Ef = 0, wf(0);
    }
  }
  function Kv(e, t) {
    (e.pooledCacheLanes &= t) === 0 && (t = e.pooledCache, t != null && (e.pooledCache = null, ea(t)));
  }
  function fd() {
    return Wv(), Pv(), Jv(), jv();
  }
  function jv() {
    if (Cl !== 5) return !1;
    var e = Xc, t = Ch;
    Ch = 0;
    var n = Ci(Fu), l = Q.T, s = Se.p;
    try {
      Se.p = 32 > n ? 32 : n, Q.T = null, n = Rh, Rh = null;
      var d = Xc, S = Fu;
      if (Cl = 0, Ts = Xc = null, Fu = 0, (Ft & 6) !== 0) throw Error(y(331));
      var R = Ft;
      if (Ft |= 4, zv(d.current), _v(
        d,
        d.current,
        S,
        n
      ), Ft = R, wf(0, !1), Xn && typeof Xn.onPostCommitFiberRoot == "function")
        try {
          Xn.onPostCommitFiberRoot(Ml, d);
        } catch {
        }
      return !0;
    } finally {
      Se.p = s, Q.T = l, Kv(e, t);
    }
  }
  function qv(e, t, n) {
    t = qn(n, t), t = Mc(e.stateNode, t, 2), e = wl(e, t, 2), e !== null && (Ql(e, 2), jr(e));
  }
  function qt(e, t, n) {
    if (e.tag === 3)
      qv(e, e, n);
    else
      for (; t !== null; ) {
        if (t.tag === 3) {
          qv(
            t,
            e,
            n
          );
          break;
        } else if (t.tag === 1) {
          var l = t.stateNode;
          if (typeof t.type.getDerivedStateFromError == "function" || typeof l.componentDidCatch == "function" && (Gc === null || !Gc.has(l))) {
            e = qn(n, e), n = rs(2), l = wl(t, n, 2), l !== null && (zc(
              n,
              l,
              t,
              e
            ), Ql(l, 2), jr(l));
            break;
          }
        }
        t = t.return;
      }
  }
  function zh(e, t, n) {
    var l = e.pingCache;
    if (l === null) {
      l = e.pingCache = new E0();
      var s = /* @__PURE__ */ new Set();
      l.set(t, s);
    } else
      s = l.get(t), s === void 0 && (s = /* @__PURE__ */ new Set(), l.set(t, s));
    s.has(n) || (wh = !0, s.add(n), e = R0.bind(null, e, t, n), t.then(e, e));
  }
  function R0(e, t, n) {
    var l = e.pingCache;
    l !== null && l.delete(t), e.pingedLanes |= e.suspendedLanes & n, e.warmLanes &= ~n, an === e && (pt & n) === n && (Pn === 4 || Pn === 3 && (pt & 62914560) === pt && 300 > Ge() - id ? (Ft & 2) === 0 && ps(e, 0) : Ah |= n, ms === pt && (ms = 0)), jr(e);
  }
  function $v(e, t) {
    t === 0 && (t = tu()), e = Mt(e, t), e !== null && (Ql(e, t), jr(e));
  }
  function _0(e) {
    var t = e.memoizedState, n = 0;
    t !== null && (n = t.retryLane), $v(e, n);
  }
  function N0(e, t) {
    var n = 0;
    switch (e.tag) {
      case 31:
      case 13:
        var l = e.stateNode, s = e.memoizedState;
        s !== null && (n = s.retryLane);
        break;
      case 19:
        l = e.stateNode;
        break;
      case 22:
        l = e.stateNode._retryCache;
        break;
      default:
        throw Error(y(314));
    }
    l !== null && l.delete(t), $v(e, n);
  }
  function M0(e, t) {
    return On(e, t);
  }
  var dd = null, xs = null, Dh = !1, hd = !1, kh = !1, Zc = 0;
  function jr(e) {
    e !== xs && e.next === null && (xs === null ? dd = xs = e : xs = xs.next = e), hd = !0, Dh || (Dh = !0, D0());
  }
  function wf(e, t) {
    if (!kh && hd) {
      kh = !0;
      do
        for (var n = !1, l = dd; l !== null; ) {
          if (e !== 0) {
            var s = l.pendingLanes;
            if (s === 0) var d = 0;
            else {
              var S = l.suspendedLanes, R = l.pingedLanes;
              d = (1 << 31 - vn(42 | e) + 1) - 1, d &= s & ~(S & ~R), d = d & 201326741 ? d & 201326741 | 1 : d ? d | 2 : 0;
            }
            d !== 0 && (n = !0, ly(l, d));
          } else
            d = pt, d = Fa(
              l,
              l === an ? d : 0,
              l.cancelPendingCommit !== null || l.timeoutHandle !== -1
            ), (d & 3) === 0 || bn(l, d) || (n = !0, ly(l, d));
          l = l.next;
        }
      while (n);
      kh = !1;
    }
  }
  function z0() {
    ey();
  }
  function ey() {
    hd = Dh = !1;
    var e = 0;
    Zc !== 0 && I0() && (e = Zc);
    for (var t = Ge(), n = null, l = dd; l !== null; ) {
      var s = l.next, d = ty(l, t);
      d === 0 ? (l.next = null, n === null ? dd = s : n.next = s, s === null && (xs = n)) : (n = l, (e !== 0 || (d & 3) !== 0) && (hd = !0)), l = s;
    }
    Cl !== 0 && Cl !== 5 || wf(e), Zc !== 0 && (Zc = 0);
  }
  function ty(e, t) {
    for (var n = e.suspendedLanes, l = e.pingedLanes, s = e.expirationTimes, d = e.pendingLanes & -62914561; 0 < d; ) {
      var S = 31 - vn(d), R = 1 << S, B = s[S];
      B === -1 ? ((R & n) === 0 || (R & l) !== 0) && (s[S] = Vu(R, t)) : B <= t && (e.expiredLanes |= R), d &= ~R;
    }
    if (t = an, n = pt, n = Fa(
      e,
      e === t ? n : 0,
      e.cancelPendingCommit !== null || e.timeoutHandle !== -1
    ), l = e.callbackNode, n === 0 || e === t && (jt === 2 || jt === 9) || e.cancelPendingCommit !== null)
      return l !== null && l !== null && Cn(l), e.callbackNode = null, e.callbackPriority = 0;
    if ((n & 3) === 0 || bn(e, n)) {
      if (t = n & -n, t === e.callbackPriority) return t;
      switch (l !== null && Cn(l), Ci(n)) {
        case 2:
        case 8:
          n = Ba;
          break;
        case 32:
          n = Ut;
          break;
        case 268435456:
          n = Oi;
          break;
        default:
          n = Ut;
      }
      return l = ny.bind(null, e), n = On(n, l), e.callbackPriority = t, e.callbackNode = n, t;
    }
    return l !== null && l !== null && Cn(l), e.callbackPriority = 2, e.callbackNode = null, 2;
  }
  function ny(e, t) {
    if (Cl !== 0 && Cl !== 5)
      return e.callbackNode = null, e.callbackPriority = 0, null;
    var n = e.callbackNode;
    if (fd() && e.callbackNode !== n)
      return null;
    var l = pt;
    return l = Fa(
      e,
      e === an ? l : 0,
      e.cancelPendingCommit !== null || e.timeoutHandle !== -1
    ), l === 0 ? null : (Hv(e, l, t), ty(e, Ge()), e.callbackNode != null && e.callbackNode === n ? ny.bind(null, e) : null);
  }
  function ly(e, t) {
    if (fd()) return null;
    Hv(e, t, !0);
  }
  function D0() {
    V0(function() {
      (Ft & 6) !== 0 ? On(
        Er,
        z0
      ) : ey();
    });
  }
  function Lh() {
    if (Zc === 0) {
      var e = fn;
      e === 0 && (e = Ha, Ha <<= 1, (Ha & 261888) === 0 && (Ha = 256)), Zc = e;
    }
    return Zc;
  }
  function ay(e) {
    return e == null || typeof e == "symbol" || typeof e == "boolean" ? null : typeof e == "function" ? e : Ku("" + e);
  }
  function iy(e, t) {
    var n = t.ownerDocument.createElement("input");
    return n.name = t.name, n.value = t.value, e.id && n.setAttribute("form", e.id), t.parentNode.insertBefore(n, t), e = new FormData(e), n.parentNode.removeChild(n), e;
  }
  function k0(e, t, n, l, s) {
    if (t === "submit" && n && n.stateNode === s) {
      var d = ay(
        (s[zn] || null).action
      ), S = l.submitter;
      S && (t = (t = S[zn] || null) ? ay(t.formAction) : S.getAttribute("formAction"), t !== null && (d = t, S = null));
      var R = new Ar(
        "action",
        "action",
        null,
        l,
        s
      );
      e.push({
        event: R,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (l.defaultPrevented) {
                if (Zc !== 0) {
                  var B = S ? iy(s, S) : new FormData(s);
                  _c(
                    n,
                    {
                      pending: !0,
                      data: B,
                      method: s.method,
                      action: d
                    },
                    null,
                    B
                  );
                }
              } else
                typeof d == "function" && (R.preventDefault(), B = S ? iy(s, S) : new FormData(s), _c(
                  n,
                  {
                    pending: !0,
                    data: B,
                    method: s.method,
                    action: d
                  },
                  d,
                  B
                ));
            },
            currentTarget: s
          }
        ]
      });
    }
  }
  for (var Bh = 0; Bh < ae.length; Bh++) {
    var Hh = ae[Bh], L0 = Hh.toLowerCase(), B0 = Hh[0].toUpperCase() + Hh.slice(1);
    ve(
      L0,
      "on" + B0
    );
  }
  ve(m, "onAnimationEnd"), ve(x, "onAnimationIteration"), ve(N, "onAnimationStart"), ve("dblclick", "onDoubleClick"), ve("focusin", "onFocus"), ve("focusout", "onBlur"), ve(D, "onTransitionRun"), ve($, "onTransitionStart"), ve(F, "onTransitionCancel"), ve(ee, "onTransitionEnd"), At("onMouseEnter", ["mouseout", "mouseover"]), At("onMouseLeave", ["mouseout", "mouseover"]), At("onPointerEnter", ["pointerout", "pointerover"]), At("onPointerLeave", ["pointerout", "pointerover"]), Fe(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), Fe(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), Fe("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), Fe(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), Fe(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), Fe(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var Af = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), H0 = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(Af)
  );
  function ry(e, t) {
    t = (t & 4) !== 0;
    for (var n = 0; n < e.length; n++) {
      var l = e[n], s = l.event;
      l = l.listeners;
      e: {
        var d = void 0;
        if (t)
          for (var S = l.length - 1; 0 <= S; S--) {
            var R = l[S], B = R.instance, J = R.currentTarget;
            if (R = R.listener, B !== d && s.isPropagationStopped())
              break e;
            d = R, s.currentTarget = J;
            try {
              d(s);
            } catch (ie) {
              Be(ie);
            }
            s.currentTarget = null, d = B;
          }
        else
          for (S = 0; S < l.length; S++) {
            if (R = l[S], B = R.instance, J = R.currentTarget, R = R.listener, B !== d && s.isPropagationStopped())
              break e;
            d = R, s.currentTarget = J;
            try {
              d(s);
            } catch (ie) {
              Be(ie);
            }
            s.currentTarget = null, d = B;
          }
      }
    }
  }
  function yt(e, t) {
    var n = t[sa];
    n === void 0 && (n = t[sa] = /* @__PURE__ */ new Set());
    var l = e + "__bubble";
    n.has(l) || (uy(t, e, 2, !1), n.add(l));
  }
  function Uh(e, t, n) {
    var l = 0;
    t && (l |= 4), uy(
      n,
      e,
      l,
      t
    );
  }
  var gd = "_reactListening" + Math.random().toString(36).slice(2);
  function Fh(e) {
    if (!e[gd]) {
      e[gd] = !0, ue.forEach(function(n) {
        n !== "selectionchange" && (H0.has(n) || Uh(n, !1, e), Uh(n, !0, e));
      });
      var t = e.nodeType === 9 ? e : e.ownerDocument;
      t === null || t[gd] || (t[gd] = !0, Uh("selectionchange", !1, t));
    }
  }
  function uy(e, t, n, l) {
    switch (By(t)) {
      case 2:
        var s = f1;
        break;
      case 8:
        s = d1;
        break;
      default:
        s = eg;
    }
    n = s.bind(
      null,
      t,
      n,
      e
    ), s = void 0, !ar || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (s = !0), l ? s !== void 0 ? e.addEventListener(t, n, {
      capture: !0,
      passive: s
    }) : e.addEventListener(t, n, !0) : s !== void 0 ? e.addEventListener(t, n, {
      passive: s
    }) : e.addEventListener(t, n, !1);
  }
  function Yh(e, t, n, l, s) {
    var d = l;
    if ((t & 1) === 0 && (t & 2) === 0 && l !== null)
      e: for (; ; ) {
        if (l === null) return;
        var S = l.tag;
        if (S === 3 || S === 4) {
          var R = l.stateNode.containerInfo;
          if (R === s) break;
          if (S === 4)
            for (S = l.return; S !== null; ) {
              var B = S.tag;
              if ((B === 3 || B === 4) && S.stateNode.containerInfo === s)
                return;
              S = S.return;
            }
          for (; R !== null; ) {
            if (S = ci(R), S === null) return;
            if (B = S.tag, B === 5 || B === 6 || B === 26 || B === 27) {
              l = d = S;
              continue e;
            }
            R = R.parentNode;
          }
        }
        l = l.return;
      }
    qu(function() {
      var J = d, ie = lo(n), fe = [];
      e: {
        var q = se.get(e);
        if (q !== void 0) {
          var ne = Ar, _e = e;
          switch (e) {
            case "keypress":
              if (oi(n) === 0) break e;
            case "keydown":
            case "keyup":
              ne = Vs;
              break;
            case "focusin":
              _e = "focus", ne = nc;
              break;
            case "focusout":
              _e = "blur", ne = nc;
              break;
            case "beforeblur":
            case "afterblur":
              ne = nc;
              break;
            case "click":
              if (n.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              ne = Xo;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              ne = Gs;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              ne = co;
              break;
            case m:
            case x:
            case N:
              ne = Io;
              break;
            case ee:
              ne = Vo;
              break;
            case "scroll":
            case "scrollend":
              ne = ru;
              break;
            case "wheel":
              ne = Di;
              break;
            case "copy":
            case "cut":
            case "paste":
              ne = Is;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              ne = Zn;
              break;
            case "toggle":
            case "beforetoggle":
              ne = ki;
          }
          var Xe = (t & 4) !== 0, tn = !Xe && (e === "scroll" || e === "scrollend"), V = Xe ? q !== null ? q + "Capture" : null : q;
          Xe = [];
          for (var G = J, P; G !== null; ) {
            var oe = G;
            if (P = oe.stateNode, oe = oe.tag, oe !== 5 && oe !== 26 && oe !== 27 || P === null || V === null || (oe = Ri(G, V), oe != null && Xe.push(
              Of(G, oe, P)
            )), tn) break;
            G = G.return;
          }
          0 < Xe.length && (q = new ne(
            q,
            _e,
            null,
            n,
            ie
          ), fe.push({ event: q, listeners: Xe }));
        }
      }
      if ((t & 7) === 0) {
        e: {
          if (q = e === "mouseover" || e === "pointerover", ne = e === "mouseout" || e === "pointerout", q && n !== wr && (_e = n.relatedTarget || n.fromElement) && (ci(_e) || _e[Ta]))
            break e;
          if ((ne || q) && (q = ie.window === ie ? ie : (q = ie.ownerDocument) ? q.defaultView || q.parentWindow : window, ne ? (_e = n.relatedTarget || n.toElement, ne = J, _e = _e ? ci(_e) : null, _e !== null && (tn = w(_e), Xe = _e.tag, _e !== tn || Xe !== 5 && Xe !== 27 && Xe !== 6) && (_e = null)) : (ne = null, _e = J), ne !== _e)) {
            if (Xe = Xo, oe = "onMouseLeave", V = "onMouseEnter", G = "mouse", (e === "pointerout" || e === "pointerover") && (Xe = Zn, oe = "onPointerLeave", V = "onPointerEnter", G = "pointer"), tn = ne == null ? q : Sa(ne), P = _e == null ? q : Sa(_e), q = new Xe(
              oe,
              G + "leave",
              ne,
              n,
              ie
            ), q.target = tn, q.relatedTarget = P, oe = null, ci(ie) === J && (Xe = new Xe(
              V,
              G + "enter",
              _e,
              n,
              ie
            ), Xe.target = P, Xe.relatedTarget = tn, oe = Xe), tn = oe, ne && _e)
              t: {
                for (Xe = U0, V = ne, G = _e, P = 0, oe = V; oe; oe = Xe(oe))
                  P++;
                oe = 0;
                for (var He = G; He; He = Xe(He))
                  oe++;
                for (; 0 < P - oe; )
                  V = Xe(V), P--;
                for (; 0 < oe - P; )
                  G = Xe(G), oe--;
                for (; P--; ) {
                  if (V === G || G !== null && V === G.alternate) {
                    Xe = V;
                    break t;
                  }
                  V = Xe(V), G = Xe(G);
                }
                Xe = null;
              }
            else Xe = null;
            ne !== null && cy(
              fe,
              q,
              ne,
              Xe,
              !1
            ), _e !== null && tn !== null && cy(
              fe,
              tn,
              _e,
              Xe,
              !0
            );
          }
        }
        e: {
          if (q = J ? Sa(J) : window, ne = q.nodeName && q.nodeName.toLowerCase(), ne === "select" || ne === "input" && q.type === "file")
            var Lt = Dn;
          else if (cu(q))
            if (Qo)
              Lt = cr;
            else {
              Lt = Ui;
              var De = fu;
            }
          else
            ne = q.nodeName, !ne || ne.toLowerCase() !== "input" || q.type !== "checkbox" && q.type !== "radio" ? J && no(J.elementType) && (Lt = Dn) : Lt = Wo;
          if (Lt && (Lt = Lt(e, J))) {
            Nr(
              fe,
              Lt,
              n,
              ie
            );
            break e;
          }
          De && De(e, q, J), e === "focusout" && J && q.type === "number" && J.memoizedProps.value != null && nu(q, "number", q.value);
        }
        switch (De = J ? Sa(J) : window, e) {
          case "focusin":
            (cu(De) || De.contentEditable === "true") && (hi = De, gi = J, Gi = null);
            break;
          case "focusout":
            Gi = gi = hi = null;
            break;
          case "mousedown":
            hc = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            hc = !1, Aa(fe, n, ie);
            break;
          case "selectionchange":
            if (hu) break;
          case "keydown":
          case "keyup":
            Aa(fe, n, ie);
        }
        var it;
        if (Li)
          e: {
            switch (e) {
              case "compositionstart":
                var St = "onCompositionStart";
                break e;
              case "compositionend":
                St = "onCompositionEnd";
                break e;
              case "compositionupdate":
                St = "onCompositionUpdate";
                break e;
            }
            St = void 0;
          }
        else
          si ? uc(e, n) && (St = "onCompositionEnd") : e === "keydown" && n.keyCode === 229 && (St = "onCompositionStart");
        St && (rc && n.locale !== "ko" && (si || St !== "onCompositionStart" ? St === "onCompositionEnd" && si && (it = au()) : (va = ie, ir = "value" in va ? va.value : va.textContent, si = !0)), De = vd(J, St), 0 < De.length && (St = new ro(
          St,
          e,
          null,
          n,
          ie
        ), fe.push({ event: St, listeners: De }), it ? St.data = it : (it = so(n), it !== null && (St.data = it)))), (it = Ia ? cc(e, n) : ya(e, n)) && (St = vd(J, "onBeforeInput"), 0 < St.length && (De = new ro(
          "onBeforeInput",
          "beforeinput",
          null,
          n,
          ie
        ), fe.push({
          event: De,
          listeners: St
        }), De.data = it)), k0(
          fe,
          e,
          J,
          n,
          ie
        );
      }
      ry(fe, t);
    });
  }
  function Of(e, t, n) {
    return {
      instance: e,
      listener: t,
      currentTarget: n
    };
  }
  function vd(e, t) {
    for (var n = t + "Capture", l = []; e !== null; ) {
      var s = e, d = s.stateNode;
      if (s = s.tag, s !== 5 && s !== 26 && s !== 27 || d === null || (s = Ri(e, n), s != null && l.unshift(
        Of(e, s, d)
      ), s = Ri(e, t), s != null && l.push(
        Of(e, s, d)
      )), e.tag === 3) return l;
      e = e.return;
    }
    return [];
  }
  function U0(e) {
    if (e === null) return null;
    do
      e = e.return;
    while (e && e.tag !== 5 && e.tag !== 27);
    return e || null;
  }
  function cy(e, t, n, l, s) {
    for (var d = t._reactName, S = []; n !== null && n !== l; ) {
      var R = n, B = R.alternate, J = R.stateNode;
      if (R = R.tag, B !== null && B === l) break;
      R !== 5 && R !== 26 && R !== 27 || J === null || (B = J, s ? (J = Ri(n, d), J != null && S.unshift(
        Of(n, J, B)
      )) : s || (J = Ri(n, d), J != null && S.push(
        Of(n, J, B)
      ))), n = n.return;
    }
    S.length !== 0 && e.push({ event: t, listeners: S });
  }
  var F0 = /\r\n?/g, Y0 = /\u0000|\uFFFD/g;
  function oy(e) {
    return (typeof e == "string" ? e : "" + e).replace(F0, `
`).replace(Y0, "");
  }
  function sy(e, t) {
    return t = oy(t), oy(e) === t;
  }
  function en(e, t, n, l, s, d) {
    switch (n) {
      case "children":
        typeof l == "string" ? t === "body" || t === "textarea" && l === "" || ha(e, l) : (typeof l == "number" || typeof l == "bigint") && t !== "body" && ha(e, "" + l);
        break;
      case "className":
        Zt(e, "class", l);
        break;
      case "tabIndex":
        Zt(e, "tabindex", l);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Zt(e, n, l);
        break;
      case "style":
        Go(e, l, d);
        break;
      case "data":
        if (t !== "object") {
          Zt(e, "data", l);
          break;
        }
      case "src":
      case "href":
        if (l === "" && (t !== "a" || n !== "href")) {
          e.removeAttribute(n);
          break;
        }
        if (l == null || typeof l == "function" || typeof l == "symbol" || typeof l == "boolean") {
          e.removeAttribute(n);
          break;
        }
        l = Ku("" + l), e.setAttribute(n, l);
        break;
      case "action":
      case "formAction":
        if (typeof l == "function") {
          e.setAttribute(
            n,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof d == "function" && (n === "formAction" ? (t !== "input" && en(e, t, "name", s.name, s, null), en(
            e,
            t,
            "formEncType",
            s.formEncType,
            s,
            null
          ), en(
            e,
            t,
            "formMethod",
            s.formMethod,
            s,
            null
          ), en(
            e,
            t,
            "formTarget",
            s.formTarget,
            s,
            null
          )) : (en(e, t, "encType", s.encType, s, null), en(e, t, "method", s.method, s, null), en(e, t, "target", s.target, s, null)));
        if (l == null || typeof l == "symbol" || typeof l == "boolean") {
          e.removeAttribute(n);
          break;
        }
        l = Ku("" + l), e.setAttribute(n, l);
        break;
      case "onClick":
        l != null && (e.onclick = ga);
        break;
      case "onScroll":
        l != null && yt("scroll", e);
        break;
      case "onScrollEnd":
        l != null && yt("scrollend", e);
        break;
      case "dangerouslySetInnerHTML":
        if (l != null) {
          if (typeof l != "object" || !("__html" in l))
            throw Error(y(61));
          if (n = l.__html, n != null) {
            if (s.children != null) throw Error(y(60));
            e.innerHTML = n;
          }
        }
        break;
      case "multiple":
        e.multiple = l && typeof l != "function" && typeof l != "symbol";
        break;
      case "muted":
        e.muted = l && typeof l != "function" && typeof l != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (l == null || typeof l == "function" || typeof l == "boolean" || typeof l == "symbol") {
          e.removeAttribute("xlink:href");
          break;
        }
        n = Ku("" + l), e.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          n
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        l != null && typeof l != "function" && typeof l != "symbol" ? e.setAttribute(n, "" + l) : e.removeAttribute(n);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        l && typeof l != "function" && typeof l != "symbol" ? e.setAttribute(n, "") : e.removeAttribute(n);
        break;
      case "capture":
      case "download":
        l === !0 ? e.setAttribute(n, "") : l !== !1 && l != null && typeof l != "function" && typeof l != "symbol" ? e.setAttribute(n, l) : e.removeAttribute(n);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        l != null && typeof l != "function" && typeof l != "symbol" && !isNaN(l) && 1 <= l ? e.setAttribute(n, l) : e.removeAttribute(n);
        break;
      case "rowSpan":
      case "start":
        l == null || typeof l == "function" || typeof l == "symbol" || isNaN(l) ? e.removeAttribute(n) : e.setAttribute(n, l);
        break;
      case "popover":
        yt("beforetoggle", e), yt("toggle", e), Wl(e, "popover", l);
        break;
      case "xlinkActuate":
        bl(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          l
        );
        break;
      case "xlinkArcrole":
        bl(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          l
        );
        break;
      case "xlinkRole":
        bl(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          l
        );
        break;
      case "xlinkShow":
        bl(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          l
        );
        break;
      case "xlinkTitle":
        bl(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          l
        );
        break;
      case "xlinkType":
        bl(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          l
        );
        break;
      case "xmlBase":
        bl(
          e,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          l
        );
        break;
      case "xmlLang":
        bl(
          e,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          l
        );
        break;
      case "xmlSpace":
        bl(
          e,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          l
        );
        break;
      case "is":
        Wl(e, "is", l);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < n.length) || n[0] !== "o" && n[0] !== "O" || n[1] !== "n" && n[1] !== "N") && (n = ml.get(n) || n, Wl(e, n, l));
    }
  }
  function Gh(e, t, n, l, s, d) {
    switch (n) {
      case "style":
        Go(e, l, d);
        break;
      case "dangerouslySetInnerHTML":
        if (l != null) {
          if (typeof l != "object" || !("__html" in l))
            throw Error(y(61));
          if (n = l.__html, n != null) {
            if (s.children != null) throw Error(y(60));
            e.innerHTML = n;
          }
        }
        break;
      case "children":
        typeof l == "string" ? ha(e, l) : (typeof l == "number" || typeof l == "bigint") && ha(e, "" + l);
        break;
      case "onScroll":
        l != null && yt("scroll", e);
        break;
      case "onScrollEnd":
        l != null && yt("scrollend", e);
        break;
      case "onClick":
        l != null && (e.onclick = ga);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!ge.hasOwnProperty(n))
          e: {
            if (n[0] === "o" && n[1] === "n" && (s = n.endsWith("Capture"), t = n.slice(2, s ? n.length - 7 : void 0), d = e[zn] || null, d = d != null ? d[n] : null, typeof d == "function" && e.removeEventListener(t, d, s), typeof l == "function")) {
              typeof d != "function" && d !== null && (n in e ? e[n] = null : e.hasAttribute(n) && e.removeAttribute(n)), e.addEventListener(t, l, s);
              break e;
            }
            n in e ? e[n] = l : l === !0 ? e.setAttribute(n, "") : Wl(e, n, l);
          }
    }
  }
  function aa(e, t, n) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        yt("error", e), yt("load", e);
        var l = !1, s = !1, d;
        for (d in n)
          if (n.hasOwnProperty(d)) {
            var S = n[d];
            if (S != null)
              switch (d) {
                case "src":
                  l = !0;
                  break;
                case "srcSet":
                  s = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(y(137, t));
                default:
                  en(e, t, d, S, n, null);
              }
          }
        s && en(e, t, "srcSet", n.srcSet, n, null), l && en(e, t, "src", n.src, n, null);
        return;
      case "input":
        yt("invalid", e);
        var R = d = S = s = null, B = null, J = null;
        for (l in n)
          if (n.hasOwnProperty(l)) {
            var ie = n[l];
            if (ie != null)
              switch (l) {
                case "name":
                  s = ie;
                  break;
                case "type":
                  S = ie;
                  break;
                case "checked":
                  B = ie;
                  break;
                case "defaultChecked":
                  J = ie;
                  break;
                case "value":
                  d = ie;
                  break;
                case "defaultValue":
                  R = ie;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (ie != null)
                    throw Error(y(137, t));
                  break;
                default:
                  en(e, t, l, ie, n, null);
              }
          }
        Pu(
          e,
          d,
          R,
          B,
          J,
          S,
          s,
          !1
        );
        return;
      case "select":
        yt("invalid", e), l = S = d = null;
        for (s in n)
          if (n.hasOwnProperty(s) && (R = n[s], R != null))
            switch (s) {
              case "value":
                d = R;
                break;
              case "defaultValue":
                S = R;
                break;
              case "multiple":
                l = R;
              default:
                en(e, t, s, R, n, null);
            }
        t = d, n = S, e.multiple = !!l, t != null ? Pl(e, !!l, t, !1) : n != null && Pl(e, !!l, n, !0);
        return;
      case "textarea":
        yt("invalid", e), d = s = l = null;
        for (S in n)
          if (n.hasOwnProperty(S) && (R = n[S], R != null))
            switch (S) {
              case "value":
                l = R;
                break;
              case "defaultValue":
                s = R;
                break;
              case "children":
                d = R;
                break;
              case "dangerouslySetInnerHTML":
                if (R != null) throw Error(y(91));
                break;
              default:
                en(e, t, S, R, n, null);
            }
        Fo(e, l, s, d);
        return;
      case "option":
        for (B in n)
          if (n.hasOwnProperty(B) && (l = n[B], l != null))
            switch (B) {
              case "selected":
                e.selected = l && typeof l != "function" && typeof l != "symbol";
                break;
              default:
                en(e, t, B, l, n, null);
            }
        return;
      case "dialog":
        yt("beforetoggle", e), yt("toggle", e), yt("cancel", e), yt("close", e);
        break;
      case "iframe":
      case "object":
        yt("load", e);
        break;
      case "video":
      case "audio":
        for (l = 0; l < Af.length; l++)
          yt(Af[l], e);
        break;
      case "image":
        yt("error", e), yt("load", e);
        break;
      case "details":
        yt("toggle", e);
        break;
      case "embed":
      case "source":
      case "link":
        yt("error", e), yt("load", e);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (J in n)
          if (n.hasOwnProperty(J) && (l = n[J], l != null))
            switch (J) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(y(137, t));
              default:
                en(e, t, J, l, n, null);
            }
        return;
      default:
        if (no(t)) {
          for (ie in n)
            n.hasOwnProperty(ie) && (l = n[ie], l !== void 0 && Gh(
              e,
              t,
              ie,
              l,
              n,
              void 0
            ));
          return;
        }
    }
    for (R in n)
      n.hasOwnProperty(R) && (l = n[R], l != null && en(e, t, R, l, n, null));
  }
  function G0(e, t, n, l) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var s = null, d = null, S = null, R = null, B = null, J = null, ie = null;
        for (ne in n) {
          var fe = n[ne];
          if (n.hasOwnProperty(ne) && fe != null)
            switch (ne) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                B = fe;
              default:
                l.hasOwnProperty(ne) || en(e, t, ne, null, l, fe);
            }
        }
        for (var q in l) {
          var ne = l[q];
          if (fe = n[q], l.hasOwnProperty(q) && (ne != null || fe != null))
            switch (q) {
              case "type":
                d = ne;
                break;
              case "name":
                s = ne;
                break;
              case "checked":
                J = ne;
                break;
              case "defaultChecked":
                ie = ne;
                break;
              case "value":
                S = ne;
                break;
              case "defaultValue":
                R = ne;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (ne != null)
                  throw Error(y(137, t));
                break;
              default:
                ne !== fe && en(
                  e,
                  t,
                  q,
                  ne,
                  l,
                  fe
                );
            }
        }
        Ga(
          e,
          S,
          R,
          B,
          J,
          ie,
          d,
          s
        );
        return;
      case "select":
        ne = S = R = q = null;
        for (d in n)
          if (B = n[d], n.hasOwnProperty(d) && B != null)
            switch (d) {
              case "value":
                break;
              case "multiple":
                ne = B;
              default:
                l.hasOwnProperty(d) || en(
                  e,
                  t,
                  d,
                  null,
                  l,
                  B
                );
            }
        for (s in l)
          if (d = l[s], B = n[s], l.hasOwnProperty(s) && (d != null || B != null))
            switch (s) {
              case "value":
                q = d;
                break;
              case "defaultValue":
                R = d;
                break;
              case "multiple":
                S = d;
              default:
                d !== B && en(
                  e,
                  t,
                  s,
                  d,
                  l,
                  B
                );
            }
        t = R, n = S, l = ne, q != null ? Pl(e, !!n, q, !1) : !!l != !!n && (t != null ? Pl(e, !!n, t, !0) : Pl(e, !!n, n ? [] : "", !1));
        return;
      case "textarea":
        ne = q = null;
        for (R in n)
          if (s = n[R], n.hasOwnProperty(R) && s != null && !l.hasOwnProperty(R))
            switch (R) {
              case "value":
                break;
              case "children":
                break;
              default:
                en(e, t, R, null, l, s);
            }
        for (S in l)
          if (s = l[S], d = n[S], l.hasOwnProperty(S) && (s != null || d != null))
            switch (S) {
              case "value":
                q = s;
                break;
              case "defaultValue":
                ne = s;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (s != null) throw Error(y(91));
                break;
              default:
                s !== d && en(e, t, S, s, l, d);
            }
        to(e, q, ne);
        return;
      case "option":
        for (var _e in n)
          if (q = n[_e], n.hasOwnProperty(_e) && q != null && !l.hasOwnProperty(_e))
            switch (_e) {
              case "selected":
                e.selected = !1;
                break;
              default:
                en(
                  e,
                  t,
                  _e,
                  null,
                  l,
                  q
                );
            }
        for (B in l)
          if (q = l[B], ne = n[B], l.hasOwnProperty(B) && q !== ne && (q != null || ne != null))
            switch (B) {
              case "selected":
                e.selected = q && typeof q != "function" && typeof q != "symbol";
                break;
              default:
                en(
                  e,
                  t,
                  B,
                  q,
                  l,
                  ne
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var Xe in n)
          q = n[Xe], n.hasOwnProperty(Xe) && q != null && !l.hasOwnProperty(Xe) && en(e, t, Xe, null, l, q);
        for (J in l)
          if (q = l[J], ne = n[J], l.hasOwnProperty(J) && q !== ne && (q != null || ne != null))
            switch (J) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (q != null)
                  throw Error(y(137, t));
                break;
              default:
                en(
                  e,
                  t,
                  J,
                  q,
                  l,
                  ne
                );
            }
        return;
      default:
        if (no(t)) {
          for (var tn in n)
            q = n[tn], n.hasOwnProperty(tn) && q !== void 0 && !l.hasOwnProperty(tn) && Gh(
              e,
              t,
              tn,
              void 0,
              l,
              q
            );
          for (ie in l)
            q = l[ie], ne = n[ie], !l.hasOwnProperty(ie) || q === ne || q === void 0 && ne === void 0 || Gh(
              e,
              t,
              ie,
              q,
              l,
              ne
            );
          return;
        }
    }
    for (var V in n)
      q = n[V], n.hasOwnProperty(V) && q != null && !l.hasOwnProperty(V) && en(e, t, V, null, l, q);
    for (fe in l)
      q = l[fe], ne = n[fe], !l.hasOwnProperty(fe) || q === ne || q == null && ne == null || en(e, t, fe, q, l, ne);
  }
  function fy(e) {
    switch (e) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function X0() {
    if (typeof performance.getEntriesByType == "function") {
      for (var e = 0, t = 0, n = performance.getEntriesByType("resource"), l = 0; l < n.length; l++) {
        var s = n[l], d = s.transferSize, S = s.initiatorType, R = s.duration;
        if (d && R && fy(S)) {
          for (S = 0, R = s.responseEnd, l += 1; l < n.length; l++) {
            var B = n[l], J = B.startTime;
            if (J > R) break;
            var ie = B.transferSize, fe = B.initiatorType;
            ie && fy(fe) && (B = B.responseEnd, S += ie * (B < R ? 1 : (R - J) / (B - J)));
          }
          if (--l, t += 8 * (d + S) / (s.duration / 1e3), e++, 10 < e) break;
        }
      }
      if (0 < e) return t / e / 1e6;
    }
    return navigator.connection && (e = navigator.connection.downlink, typeof e == "number") ? e : 5;
  }
  var Xh = null, Ih = null;
  function yd(e) {
    return e.nodeType === 9 ? e : e.ownerDocument;
  }
  function dy(e) {
    switch (e) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function hy(e, t) {
    if (e === 0)
      switch (t) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return e === 1 && t === "foreignObject" ? 0 : e;
  }
  function Zh(e, t) {
    return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.children == "bigint" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
  }
  var Vh = null;
  function I0() {
    var e = window.event;
    return e && e.type === "popstate" ? e === Vh ? !1 : (Vh = e, !0) : (Vh = null, !1);
  }
  var gy = typeof setTimeout == "function" ? setTimeout : void 0, Z0 = typeof clearTimeout == "function" ? clearTimeout : void 0, vy = typeof Promise == "function" ? Promise : void 0, V0 = typeof queueMicrotask == "function" ? queueMicrotask : typeof vy < "u" ? function(e) {
    return vy.resolve(null).then(e).catch(Q0);
  } : gy;
  function Q0(e) {
    setTimeout(function() {
      throw e;
    });
  }
  function Vc(e) {
    return e === "head";
  }
  function yy(e, t) {
    var n = t, l = 0;
    do {
      var s = n.nextSibling;
      if (e.removeChild(n), s && s.nodeType === 8)
        if (n = s.data, n === "/$" || n === "/&") {
          if (l === 0) {
            e.removeChild(s), Os(t);
            return;
          }
          l--;
        } else if (n === "$" || n === "$?" || n === "$~" || n === "$!" || n === "&")
          l++;
        else if (n === "html")
          Cf(e.ownerDocument.documentElement);
        else if (n === "head") {
          n = e.ownerDocument.head, Cf(n);
          for (var d = n.firstChild; d; ) {
            var S = d.nextSibling, R = d.nodeName;
            d[pa] || R === "SCRIPT" || R === "STYLE" || R === "LINK" && d.rel.toLowerCase() === "stylesheet" || n.removeChild(d), d = S;
          }
        } else
          n === "body" && Cf(e.ownerDocument.body);
      n = s;
    } while (n);
    Os(t);
  }
  function by(e, t) {
    var n = e;
    e = 0;
    do {
      var l = n.nextSibling;
      if (n.nodeType === 1 ? t ? (n._stashedDisplay = n.style.display, n.style.display = "none") : (n.style.display = n._stashedDisplay || "", n.getAttribute("style") === "" && n.removeAttribute("style")) : n.nodeType === 3 && (t ? (n._stashedText = n.nodeValue, n.nodeValue = "") : n.nodeValue = n._stashedText || ""), l && l.nodeType === 8)
        if (n = l.data, n === "/$") {
          if (e === 0) break;
          e--;
        } else
          n !== "$" && n !== "$?" && n !== "$~" && n !== "$!" || e++;
      n = l;
    } while (n);
  }
  function Qh(e) {
    var t = e.firstChild;
    for (t && t.nodeType === 10 && (t = t.nextSibling); t; ) {
      var n = t;
      switch (t = t.nextSibling, n.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          Qh(n), In(n);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (n.rel.toLowerCase() === "stylesheet") continue;
      }
      e.removeChild(n);
    }
  }
  function W0(e, t, n, l) {
    for (; e.nodeType === 1; ) {
      var s = n;
      if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
        if (!l && (e.nodeName !== "INPUT" || e.type !== "hidden"))
          break;
      } else if (l) {
        if (!e[pa])
          switch (t) {
            case "meta":
              if (!e.hasAttribute("itemprop")) break;
              return e;
            case "link":
              if (d = e.getAttribute("rel"), d === "stylesheet" && e.hasAttribute("data-precedence"))
                break;
              if (d !== s.rel || e.getAttribute("href") !== (s.href == null || s.href === "" ? null : s.href) || e.getAttribute("crossorigin") !== (s.crossOrigin == null ? null : s.crossOrigin) || e.getAttribute("title") !== (s.title == null ? null : s.title))
                break;
              return e;
            case "style":
              if (e.hasAttribute("data-precedence")) break;
              return e;
            case "script":
              if (d = e.getAttribute("src"), (d !== (s.src == null ? null : s.src) || e.getAttribute("type") !== (s.type == null ? null : s.type) || e.getAttribute("crossorigin") !== (s.crossOrigin == null ? null : s.crossOrigin)) && d && e.hasAttribute("async") && !e.hasAttribute("itemprop"))
                break;
              return e;
            default:
              return e;
          }
      } else if (t === "input" && e.type === "hidden") {
        var d = s.name == null ? null : "" + s.name;
        if (s.type === "hidden" && e.getAttribute("name") === d)
          return e;
      } else return e;
      if (e = Ji(e.nextSibling), e === null) break;
    }
    return null;
  }
  function P0(e, t, n) {
    if (t === "") return null;
    for (; e.nodeType !== 3; )
      if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !n || (e = Ji(e.nextSibling), e === null)) return null;
    return e;
  }
  function my(e, t) {
    for (; e.nodeType !== 8; )
      if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !t || (e = Ji(e.nextSibling), e === null)) return null;
    return e;
  }
  function Wh(e) {
    return e.data === "$?" || e.data === "$~";
  }
  function Ph(e) {
    return e.data === "$!" || e.data === "$?" && e.ownerDocument.readyState !== "loading";
  }
  function J0(e, t) {
    var n = e.ownerDocument;
    if (e.data === "$~") e._reactRetry = t;
    else if (e.data !== "$?" || n.readyState !== "loading")
      t();
    else {
      var l = function() {
        t(), n.removeEventListener("DOMContentLoaded", l);
      };
      n.addEventListener("DOMContentLoaded", l), e._reactRetry = l;
    }
  }
  function Ji(e) {
    for (; e != null; e = e.nextSibling) {
      var t = e.nodeType;
      if (t === 1 || t === 3) break;
      if (t === 8) {
        if (t = e.data, t === "$" || t === "$!" || t === "$?" || t === "$~" || t === "&" || t === "F!" || t === "F")
          break;
        if (t === "/$" || t === "/&") return null;
      }
    }
    return e;
  }
  var Jh = null;
  function Ty(e) {
    e = e.nextSibling;
    for (var t = 0; e; ) {
      if (e.nodeType === 8) {
        var n = e.data;
        if (n === "/$" || n === "/&") {
          if (t === 0)
            return Ji(e.nextSibling);
          t--;
        } else
          n !== "$" && n !== "$!" && n !== "$?" && n !== "$~" && n !== "&" || t++;
      }
      e = e.nextSibling;
    }
    return null;
  }
  function py(e) {
    e = e.previousSibling;
    for (var t = 0; e; ) {
      if (e.nodeType === 8) {
        var n = e.data;
        if (n === "$" || n === "$!" || n === "$?" || n === "$~" || n === "&") {
          if (t === 0) return e;
          t--;
        } else n !== "/$" && n !== "/&" || t++;
      }
      e = e.previousSibling;
    }
    return null;
  }
  function Sy(e, t, n) {
    switch (t = yd(n), e) {
      case "html":
        if (e = t.documentElement, !e) throw Error(y(452));
        return e;
      case "head":
        if (e = t.head, !e) throw Error(y(453));
        return e;
      case "body":
        if (e = t.body, !e) throw Error(y(454));
        return e;
      default:
        throw Error(y(451));
    }
  }
  function Cf(e) {
    for (var t = e.attributes; t.length; )
      e.removeAttributeNode(t[0]);
    In(e);
  }
  var Ki = /* @__PURE__ */ new Map(), xy = /* @__PURE__ */ new Set();
  function bd(e) {
    return typeof e.getRootNode == "function" ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument;
  }
  var Yu = Se.d;
  Se.d = {
    f: K0,
    r: j0,
    D: q0,
    C: $0,
    L: e1,
    m: t1,
    X: l1,
    S: n1,
    M: a1
  };
  function K0() {
    var e = Yu.f(), t = cd();
    return e || t;
  }
  function j0(e) {
    var t = da(e);
    t !== null && t.tag === 5 && t.type === "form" ? lf(t) : Yu.r(e);
  }
  var Es = typeof document > "u" ? null : document;
  function Ey(e, t, n) {
    var l = Es;
    if (l && typeof t == "string" && t) {
      var s = kl(t);
      s = 'link[rel="' + e + '"][href="' + s + '"]', typeof n == "string" && (s += '[crossorigin="' + n + '"]'), xy.has(s) || (xy.add(s), e = { rel: e, crossOrigin: n, href: t }, l.querySelector(s) === null && (t = l.createElement("link"), aa(t, "link", e), k(t), l.head.appendChild(t)));
    }
  }
  function q0(e) {
    Yu.D(e), Ey("dns-prefetch", e, null);
  }
  function $0(e, t) {
    Yu.C(e, t), Ey("preconnect", e, t);
  }
  function e1(e, t, n) {
    Yu.L(e, t, n);
    var l = Es;
    if (l && e && t) {
      var s = 'link[rel="preload"][as="' + kl(t) + '"]';
      t === "image" && n && n.imageSrcSet ? (s += '[imagesrcset="' + kl(
        n.imageSrcSet
      ) + '"]', typeof n.imageSizes == "string" && (s += '[imagesizes="' + kl(
        n.imageSizes
      ) + '"]')) : s += '[href="' + kl(e) + '"]';
      var d = s;
      switch (t) {
        case "style":
          d = ws(e);
          break;
        case "script":
          d = As(e);
      }
      Ki.has(d) || (e = Y(
        {
          rel: "preload",
          href: t === "image" && n && n.imageSrcSet ? void 0 : e,
          as: t
        },
        n
      ), Ki.set(d, e), l.querySelector(s) !== null || t === "style" && l.querySelector(Rf(d)) || t === "script" && l.querySelector(_f(d)) || (t = l.createElement("link"), aa(t, "link", e), k(t), l.head.appendChild(t)));
    }
  }
  function t1(e, t) {
    Yu.m(e, t);
    var n = Es;
    if (n && e) {
      var l = t && typeof t.as == "string" ? t.as : "script", s = 'link[rel="modulepreload"][as="' + kl(l) + '"][href="' + kl(e) + '"]', d = s;
      switch (l) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          d = As(e);
      }
      if (!Ki.has(d) && (e = Y({ rel: "modulepreload", href: e }, t), Ki.set(d, e), n.querySelector(s) === null)) {
        switch (l) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (n.querySelector(_f(d)))
              return;
        }
        l = n.createElement("link"), aa(l, "link", e), k(l), n.head.appendChild(l);
      }
    }
  }
  function n1(e, t, n) {
    Yu.S(e, t, n);
    var l = Es;
    if (l && e) {
      var s = Re(l).hoistableStyles, d = ws(e);
      t = t || "default";
      var S = s.get(d);
      if (!S) {
        var R = { loading: 0, preload: null };
        if (S = l.querySelector(
          Rf(d)
        ))
          R.loading = 5;
        else {
          e = Y(
            { rel: "stylesheet", href: e, "data-precedence": t },
            n
          ), (n = Ki.get(d)) && Kh(e, n);
          var B = S = l.createElement("link");
          k(B), aa(B, "link", e), B._p = new Promise(function(J, ie) {
            B.onload = J, B.onerror = ie;
          }), B.addEventListener("load", function() {
            R.loading |= 1;
          }), B.addEventListener("error", function() {
            R.loading |= 2;
          }), R.loading |= 4, md(S, t, l);
        }
        S = {
          type: "stylesheet",
          instance: S,
          count: 1,
          state: R
        }, s.set(d, S);
      }
    }
  }
  function l1(e, t) {
    Yu.X(e, t);
    var n = Es;
    if (n && e) {
      var l = Re(n).hoistableScripts, s = As(e), d = l.get(s);
      d || (d = n.querySelector(_f(s)), d || (e = Y({ src: e, async: !0 }, t), (t = Ki.get(s)) && jh(e, t), d = n.createElement("script"), k(d), aa(d, "link", e), n.head.appendChild(d)), d = {
        type: "script",
        instance: d,
        count: 1,
        state: null
      }, l.set(s, d));
    }
  }
  function a1(e, t) {
    Yu.M(e, t);
    var n = Es;
    if (n && e) {
      var l = Re(n).hoistableScripts, s = As(e), d = l.get(s);
      d || (d = n.querySelector(_f(s)), d || (e = Y({ src: e, async: !0, type: "module" }, t), (t = Ki.get(s)) && jh(e, t), d = n.createElement("script"), k(d), aa(d, "link", e), n.head.appendChild(d)), d = {
        type: "script",
        instance: d,
        count: 1,
        state: null
      }, l.set(s, d));
    }
  }
  function wy(e, t, n, l) {
    var s = (s = Wt.current) ? bd(s) : null;
    if (!s) throw Error(y(446));
    switch (e) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof n.precedence == "string" && typeof n.href == "string" ? (t = ws(n.href), n = Re(
          s
        ).hoistableStyles, l = n.get(t), l || (l = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, n.set(t, l)), l) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (n.rel === "stylesheet" && typeof n.href == "string" && typeof n.precedence == "string") {
          e = ws(n.href);
          var d = Re(
            s
          ).hoistableStyles, S = d.get(e);
          if (S || (s = s.ownerDocument || s, S = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, d.set(e, S), (d = s.querySelector(
            Rf(e)
          )) && !d._p && (S.instance = d, S.state.loading = 5), Ki.has(e) || (n = {
            rel: "preload",
            as: "style",
            href: n.href,
            crossOrigin: n.crossOrigin,
            integrity: n.integrity,
            media: n.media,
            hrefLang: n.hrefLang,
            referrerPolicy: n.referrerPolicy
          }, Ki.set(e, n), d || i1(
            s,
            e,
            n,
            S.state
          ))), t && l === null)
            throw Error(y(528, ""));
          return S;
        }
        if (t && l !== null)
          throw Error(y(529, ""));
        return null;
      case "script":
        return t = n.async, n = n.src, typeof n == "string" && t && typeof t != "function" && typeof t != "symbol" ? (t = As(n), n = Re(
          s
        ).hoistableScripts, l = n.get(t), l || (l = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, n.set(t, l)), l) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(y(444, e));
    }
  }
  function ws(e) {
    return 'href="' + kl(e) + '"';
  }
  function Rf(e) {
    return 'link[rel="stylesheet"][' + e + "]";
  }
  function Ay(e) {
    return Y({}, e, {
      "data-precedence": e.precedence,
      precedence: null
    });
  }
  function i1(e, t, n, l) {
    e.querySelector('link[rel="preload"][as="style"][' + t + "]") ? l.loading = 1 : (t = e.createElement("link"), l.preload = t, t.addEventListener("load", function() {
      return l.loading |= 1;
    }), t.addEventListener("error", function() {
      return l.loading |= 2;
    }), aa(t, "link", n), k(t), e.head.appendChild(t));
  }
  function As(e) {
    return '[src="' + kl(e) + '"]';
  }
  function _f(e) {
    return "script[async]" + e;
  }
  function Oy(e, t, n) {
    if (t.count++, t.instance === null)
      switch (t.type) {
        case "style":
          var l = e.querySelector(
            'style[data-href~="' + kl(n.href) + '"]'
          );
          if (l)
            return t.instance = l, k(l), l;
          var s = Y({}, n, {
            "data-href": n.href,
            "data-precedence": n.precedence,
            href: null,
            precedence: null
          });
          return l = (e.ownerDocument || e).createElement(
            "style"
          ), k(l), aa(l, "style", s), md(l, n.precedence, e), t.instance = l;
        case "stylesheet":
          s = ws(n.href);
          var d = e.querySelector(
            Rf(s)
          );
          if (d)
            return t.state.loading |= 4, t.instance = d, k(d), d;
          l = Ay(n), (s = Ki.get(s)) && Kh(l, s), d = (e.ownerDocument || e).createElement("link"), k(d);
          var S = d;
          return S._p = new Promise(function(R, B) {
            S.onload = R, S.onerror = B;
          }), aa(d, "link", l), t.state.loading |= 4, md(d, n.precedence, e), t.instance = d;
        case "script":
          return d = As(n.src), (s = e.querySelector(
            _f(d)
          )) ? (t.instance = s, k(s), s) : (l = n, (s = Ki.get(d)) && (l = Y({}, n), jh(l, s)), e = e.ownerDocument || e, s = e.createElement("script"), k(s), aa(s, "link", l), e.head.appendChild(s), t.instance = s);
        case "void":
          return null;
        default:
          throw Error(y(443, t.type));
      }
    else
      t.type === "stylesheet" && (t.state.loading & 4) === 0 && (l = t.instance, t.state.loading |= 4, md(l, n.precedence, e));
    return t.instance;
  }
  function md(e, t, n) {
    for (var l = n.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), s = l.length ? l[l.length - 1] : null, d = s, S = 0; S < l.length; S++) {
      var R = l[S];
      if (R.dataset.precedence === t) d = R;
      else if (d !== s) break;
    }
    d ? d.parentNode.insertBefore(e, d.nextSibling) : (t = n.nodeType === 9 ? n.head : n, t.insertBefore(e, t.firstChild));
  }
  function Kh(e, t) {
    e.crossOrigin == null && (e.crossOrigin = t.crossOrigin), e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy), e.title == null && (e.title = t.title);
  }
  function jh(e, t) {
    e.crossOrigin == null && (e.crossOrigin = t.crossOrigin), e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy), e.integrity == null && (e.integrity = t.integrity);
  }
  var Td = null;
  function Cy(e, t, n) {
    if (Td === null) {
      var l = /* @__PURE__ */ new Map(), s = Td = /* @__PURE__ */ new Map();
      s.set(n, l);
    } else
      s = Td, l = s.get(n), l || (l = /* @__PURE__ */ new Map(), s.set(n, l));
    if (l.has(e)) return l;
    for (l.set(e, null), n = n.getElementsByTagName(e), s = 0; s < n.length; s++) {
      var d = n[s];
      if (!(d[pa] || d[mn] || e === "link" && d.getAttribute("rel") === "stylesheet") && d.namespaceURI !== "http://www.w3.org/2000/svg") {
        var S = d.getAttribute(t) || "";
        S = e + S;
        var R = l.get(S);
        R ? R.push(d) : l.set(S, [d]);
      }
    }
    return l;
  }
  function Ry(e, t, n) {
    e = e.ownerDocument || e, e.head.insertBefore(
      n,
      t === "title" ? e.querySelector("head > title") : null
    );
  }
  function r1(e, t, n) {
    if (n === 1 || t.itemProp != null) return !1;
    switch (e) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof t.precedence != "string" || typeof t.href != "string" || t.href === "")
          break;
        return !0;
      case "link":
        if (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" || t.onLoad || t.onError)
          break;
        switch (t.rel) {
          case "stylesheet":
            return e = t.disabled, typeof t.precedence == "string" && e == null;
          default:
            return !0;
        }
      case "script":
        if (t.async && typeof t.async != "function" && typeof t.async != "symbol" && !t.onLoad && !t.onError && t.src && typeof t.src == "string")
          return !0;
    }
    return !1;
  }
  function _y(e) {
    return !(e.type === "stylesheet" && (e.state.loading & 3) === 0);
  }
  function u1(e, t, n, l) {
    if (n.type === "stylesheet" && (typeof l.media != "string" || matchMedia(l.media).matches !== !1) && (n.state.loading & 4) === 0) {
      if (n.instance === null) {
        var s = ws(l.href), d = t.querySelector(
          Rf(s)
        );
        if (d) {
          t = d._p, t !== null && typeof t == "object" && typeof t.then == "function" && (e.count++, e = pd.bind(e), t.then(e, e)), n.state.loading |= 4, n.instance = d, k(d);
          return;
        }
        d = t.ownerDocument || t, l = Ay(l), (s = Ki.get(s)) && Kh(l, s), d = d.createElement("link"), k(d);
        var S = d;
        S._p = new Promise(function(R, B) {
          S.onload = R, S.onerror = B;
        }), aa(d, "link", l), n.instance = d;
      }
      e.stylesheets === null && (e.stylesheets = /* @__PURE__ */ new Map()), e.stylesheets.set(n, t), (t = n.state.preload) && (n.state.loading & 3) === 0 && (e.count++, n = pd.bind(e), t.addEventListener("load", n), t.addEventListener("error", n));
    }
  }
  var qh = 0;
  function c1(e, t) {
    return e.stylesheets && e.count === 0 && xd(e, e.stylesheets), 0 < e.count || 0 < e.imgCount ? function(n) {
      var l = setTimeout(function() {
        if (e.stylesheets && xd(e, e.stylesheets), e.unsuspend) {
          var d = e.unsuspend;
          e.unsuspend = null, d();
        }
      }, 6e4 + t);
      0 < e.imgBytes && qh === 0 && (qh = 62500 * X0());
      var s = setTimeout(
        function() {
          if (e.waitingForImages = !1, e.count === 0 && (e.stylesheets && xd(e, e.stylesheets), e.unsuspend)) {
            var d = e.unsuspend;
            e.unsuspend = null, d();
          }
        },
        (e.imgBytes > qh ? 50 : 800) + t
      );
      return e.unsuspend = n, function() {
        e.unsuspend = null, clearTimeout(l), clearTimeout(s);
      };
    } : null;
  }
  function pd() {
    if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
      if (this.stylesheets) xd(this, this.stylesheets);
      else if (this.unsuspend) {
        var e = this.unsuspend;
        this.unsuspend = null, e();
      }
    }
  }
  var Sd = null;
  function xd(e, t) {
    e.stylesheets = null, e.unsuspend !== null && (e.count++, Sd = /* @__PURE__ */ new Map(), t.forEach(o1, e), Sd = null, pd.call(e));
  }
  function o1(e, t) {
    if (!(t.state.loading & 4)) {
      var n = Sd.get(e);
      if (n) var l = n.get(null);
      else {
        n = /* @__PURE__ */ new Map(), Sd.set(e, n);
        for (var s = e.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), d = 0; d < s.length; d++) {
          var S = s[d];
          (S.nodeName === "LINK" || S.getAttribute("media") !== "not all") && (n.set(S.dataset.precedence, S), l = S);
        }
        l && n.set(null, l);
      }
      s = t.instance, S = s.getAttribute("data-precedence"), d = n.get(S) || l, d === l && n.set(null, s), n.set(S, s), this.count++, l = pd.bind(this), s.addEventListener("load", l), s.addEventListener("error", l), d ? d.parentNode.insertBefore(s, d.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(s, e.firstChild)), t.state.loading |= 4;
    }
  }
  var Nf = {
    $$typeof: ke,
    Provider: null,
    Consumer: null,
    _currentValue: et,
    _currentValue2: et,
    _threadCount: 0
  };
  function s1(e, t, n, l, s, d, S, R, B) {
    this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = ln(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = ln(0), this.hiddenUpdates = ln(null), this.identifierPrefix = l, this.onUncaughtError = s, this.onCaughtError = d, this.onRecoverableError = S, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = B, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function Ny(e, t, n, l, s, d, S, R, B, J, ie, fe) {
    return e = new s1(
      e,
      t,
      n,
      S,
      B,
      J,
      ie,
      fe,
      R
    ), t = 1, d === !0 && (t |= 24), d = We(3, null, null, t), e.current = d, d.stateNode = e, t = yc(), t.refCount++, e.pooledCache = t, t.refCount++, d.memoizedState = {
      element: l,
      isDehydrated: n,
      cache: t
    }, fr(d), e;
  }
  function My(e) {
    return e ? (e = tt, e) : tt;
  }
  function zy(e, t, n, l, s, d) {
    s = My(s), l.context === null ? l.context = s : l.pendingContext = s, l = fl(t), l.payload = { element: n }, d = d === void 0 ? null : d, d !== null && (l.callback = d), n = wl(e, l, t), n !== null && (ai(n, e, t), dl(n, e, t));
  }
  function Dy(e, t) {
    if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
      var n = e.retryLane;
      e.retryLane = n !== 0 && n < t ? n : t;
    }
  }
  function $h(e, t) {
    Dy(e, t), (e = e.alternate) && Dy(e, t);
  }
  function ky(e) {
    if (e.tag === 13 || e.tag === 31) {
      var t = Mt(e, 67108864);
      t !== null && ai(t, e, 67108864), $h(e, 67108864);
    }
  }
  function Ly(e) {
    if (e.tag === 13 || e.tag === 31) {
      var t = Ei();
      t = kt(t);
      var n = Mt(e, t);
      n !== null && ai(n, e, t), $h(e, t);
    }
  }
  var Ed = !0;
  function f1(e, t, n, l) {
    var s = Q.T;
    Q.T = null;
    var d = Se.p;
    try {
      Se.p = 2, eg(e, t, n, l);
    } finally {
      Se.p = d, Q.T = s;
    }
  }
  function d1(e, t, n, l) {
    var s = Q.T;
    Q.T = null;
    var d = Se.p;
    try {
      Se.p = 8, eg(e, t, n, l);
    } finally {
      Se.p = d, Q.T = s;
    }
  }
  function eg(e, t, n, l) {
    if (Ed) {
      var s = tg(l);
      if (s === null)
        Yh(
          e,
          t,
          l,
          wd,
          n
        ), Hy(e, l);
      else if (g1(
        s,
        e,
        t,
        n,
        l
      ))
        l.stopPropagation();
      else if (Hy(e, l), t & 4 && -1 < h1.indexOf(e)) {
        for (; s !== null; ) {
          var d = da(s);
          if (d !== null)
            switch (d.tag) {
              case 3:
                if (d = d.stateNode, d.current.memoizedState.isDehydrated) {
                  var S = Dl(d.pendingLanes);
                  if (S !== 0) {
                    var R = d;
                    for (R.pendingLanes |= 2, R.entangledLanes |= 2; S; ) {
                      var B = 1 << 31 - vn(S);
                      R.entanglements[1] |= B, S &= ~B;
                    }
                    jr(d), (Ft & 6) === 0 && (rd = Ge() + 500, wf(0));
                  }
                }
                break;
              case 31:
              case 13:
                R = Mt(d, 2), R !== null && ai(R, d, 2), cd(), $h(d, 2);
            }
          if (d = tg(l), d === null && Yh(
            e,
            t,
            l,
            wd,
            n
          ), d === s) break;
          s = d;
        }
        s !== null && l.stopPropagation();
      } else
        Yh(
          e,
          t,
          l,
          null,
          n
        );
    }
  }
  function tg(e) {
    return e = lo(e), ng(e);
  }
  var wd = null;
  function ng(e) {
    if (wd = null, e = ci(e), e !== null) {
      var t = w(e);
      if (t === null) e = null;
      else {
        var n = t.tag;
        if (n === 13) {
          if (e = O(t), e !== null) return e;
          e = null;
        } else if (n === 31) {
          if (e = _(t), e !== null) return e;
          e = null;
        } else if (n === 3) {
          if (t.stateNode.current.memoizedState.isDehydrated)
            return t.tag === 3 ? t.stateNode.containerInfo : null;
          e = null;
        } else t !== e && (e = null);
      }
    }
    return wd = e, null;
  }
  function By(e) {
    switch (e) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (ll()) {
          case Er:
            return 2;
          case Ba:
            return 8;
          case Ut:
          case Nl:
            return 32;
          case Oi:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var lg = !1, Qc = null, Wc = null, Pc = null, Mf = /* @__PURE__ */ new Map(), zf = /* @__PURE__ */ new Map(), Jc = [], h1 = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function Hy(e, t) {
    switch (e) {
      case "focusin":
      case "focusout":
        Qc = null;
        break;
      case "dragenter":
      case "dragleave":
        Wc = null;
        break;
      case "mouseover":
      case "mouseout":
        Pc = null;
        break;
      case "pointerover":
      case "pointerout":
        Mf.delete(t.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        zf.delete(t.pointerId);
    }
  }
  function Df(e, t, n, l, s, d) {
    return e === null || e.nativeEvent !== d ? (e = {
      blockedOn: t,
      domEventName: n,
      eventSystemFlags: l,
      nativeEvent: d,
      targetContainers: [s]
    }, t !== null && (t = da(t), t !== null && ky(t)), e) : (e.eventSystemFlags |= l, t = e.targetContainers, s !== null && t.indexOf(s) === -1 && t.push(s), e);
  }
  function g1(e, t, n, l, s) {
    switch (t) {
      case "focusin":
        return Qc = Df(
          Qc,
          e,
          t,
          n,
          l,
          s
        ), !0;
      case "dragenter":
        return Wc = Df(
          Wc,
          e,
          t,
          n,
          l,
          s
        ), !0;
      case "mouseover":
        return Pc = Df(
          Pc,
          e,
          t,
          n,
          l,
          s
        ), !0;
      case "pointerover":
        var d = s.pointerId;
        return Mf.set(
          d,
          Df(
            Mf.get(d) || null,
            e,
            t,
            n,
            l,
            s
          )
        ), !0;
      case "gotpointercapture":
        return d = s.pointerId, zf.set(
          d,
          Df(
            zf.get(d) || null,
            e,
            t,
            n,
            l,
            s
          )
        ), !0;
    }
    return !1;
  }
  function Uy(e) {
    var t = ci(e.target);
    if (t !== null) {
      var n = w(t);
      if (n !== null) {
        if (t = n.tag, t === 13) {
          if (t = O(n), t !== null) {
            e.blockedOn = t, mt(e.priority, function() {
              Ly(n);
            });
            return;
          }
        } else if (t === 31) {
          if (t = _(n), t !== null) {
            e.blockedOn = t, mt(e.priority, function() {
              Ly(n);
            });
            return;
          }
        } else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
          e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
          return;
        }
      }
    }
    e.blockedOn = null;
  }
  function Ad(e) {
    if (e.blockedOn !== null) return !1;
    for (var t = e.targetContainers; 0 < t.length; ) {
      var n = tg(e.nativeEvent);
      if (n === null) {
        n = e.nativeEvent;
        var l = new n.constructor(
          n.type,
          n
        );
        wr = l, n.target.dispatchEvent(l), wr = null;
      } else
        return t = da(n), t !== null && ky(t), e.blockedOn = n, !1;
      t.shift();
    }
    return !0;
  }
  function Fy(e, t, n) {
    Ad(e) && n.delete(t);
  }
  function v1() {
    lg = !1, Qc !== null && Ad(Qc) && (Qc = null), Wc !== null && Ad(Wc) && (Wc = null), Pc !== null && Ad(Pc) && (Pc = null), Mf.forEach(Fy), zf.forEach(Fy);
  }
  function Od(e, t) {
    e.blockedOn === t && (e.blockedOn = null, lg || (lg = !0, o.unstable_scheduleCallback(
      o.unstable_NormalPriority,
      v1
    )));
  }
  var Cd = null;
  function Yy(e) {
    Cd !== e && (Cd = e, o.unstable_scheduleCallback(
      o.unstable_NormalPriority,
      function() {
        Cd === e && (Cd = null);
        for (var t = 0; t < e.length; t += 3) {
          var n = e[t], l = e[t + 1], s = e[t + 2];
          if (typeof l != "function") {
            if (ng(l || n) === null)
              continue;
            break;
          }
          var d = da(n);
          d !== null && (e.splice(t, 3), t -= 3, _c(
            d,
            {
              pending: !0,
              data: s,
              method: n.method,
              action: l
            },
            l,
            s
          ));
        }
      }
    ));
  }
  function Os(e) {
    function t(B) {
      return Od(B, e);
    }
    Qc !== null && Od(Qc, e), Wc !== null && Od(Wc, e), Pc !== null && Od(Pc, e), Mf.forEach(t), zf.forEach(t);
    for (var n = 0; n < Jc.length; n++) {
      var l = Jc[n];
      l.blockedOn === e && (l.blockedOn = null);
    }
    for (; 0 < Jc.length && (n = Jc[0], n.blockedOn === null); )
      Uy(n), n.blockedOn === null && Jc.shift();
    if (n = (e.ownerDocument || e).$$reactFormReplay, n != null)
      for (l = 0; l < n.length; l += 3) {
        var s = n[l], d = n[l + 1], S = s[zn] || null;
        if (typeof d == "function")
          S || Yy(n);
        else if (S) {
          var R = null;
          if (d && d.hasAttribute("formAction")) {
            if (s = d, S = d[zn] || null)
              R = S.formAction;
            else if (ng(s) !== null) continue;
          } else R = S.action;
          typeof R == "function" ? n[l + 1] = R : (n.splice(l, 3), l -= 3), Yy(n);
        }
      }
  }
  function Gy() {
    function e(d) {
      d.canIntercept && d.info === "react-transition" && d.intercept({
        handler: function() {
          return new Promise(function(S) {
            return s = S;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function t() {
      s !== null && (s(), s = null), l || setTimeout(n, 20);
    }
    function n() {
      if (!l && !navigation.transition) {
        var d = navigation.currentEntry;
        d && d.url != null && navigation.navigate(d.url, {
          state: d.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if (typeof navigation == "object") {
      var l = !1, s = null;
      return navigation.addEventListener("navigate", e), navigation.addEventListener("navigatesuccess", t), navigation.addEventListener("navigateerror", t), setTimeout(n, 100), function() {
        l = !0, navigation.removeEventListener("navigate", e), navigation.removeEventListener("navigatesuccess", t), navigation.removeEventListener("navigateerror", t), s !== null && (s(), s = null);
      };
    }
  }
  function ag(e) {
    this._internalRoot = e;
  }
  Rd.prototype.render = ag.prototype.render = function(e) {
    var t = this._internalRoot;
    if (t === null) throw Error(y(409));
    var n = t.current, l = Ei();
    zy(n, l, e, t, null, null);
  }, Rd.prototype.unmount = ag.prototype.unmount = function() {
    var e = this._internalRoot;
    if (e !== null) {
      this._internalRoot = null;
      var t = e.containerInfo;
      zy(e.current, 2, null, e, null, null), cd(), t[Ta] = null;
    }
  };
  function Rd(e) {
    this._internalRoot = e;
  }
  Rd.prototype.unstable_scheduleHydration = function(e) {
    if (e) {
      var t = It();
      e = { blockedOn: null, target: e, priority: t };
      for (var n = 0; n < Jc.length && t !== 0 && t < Jc[n].priority; n++) ;
      Jc.splice(n, 0, e), n === 0 && Uy(e);
    }
  };
  var Xy = f.version;
  if (Xy !== "19.2.6")
    throw Error(
      y(
        527,
        Xy,
        "19.2.6"
      )
    );
  Se.findDOMNode = function(e) {
    var t = e._reactInternals;
    if (t === void 0)
      throw typeof e.render == "function" ? Error(y(188)) : (e = Object.keys(e).join(","), Error(y(268, e)));
    return e = H(t), e = e !== null ? Z(e) : null, e = e === null ? null : e.stateNode, e;
  };
  var y1 = {
    bundleType: 0,
    version: "19.2.6",
    rendererPackageName: "react-dom",
    currentDispatcherRef: Q,
    reconcilerVersion: "19.2.6"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var _d = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!_d.isDisabled && _d.supportsFiber)
      try {
        Ml = _d.inject(
          y1
        ), Xn = _d;
      } catch {
      }
  }
  return Uf.createRoot = function(e, t) {
    if (!T(e)) throw Error(y(299));
    var n = !1, l = "", s = Wr, d = sf, S = ff;
    return t != null && (t.unstable_strictMode === !0 && (n = !0), t.identifierPrefix !== void 0 && (l = t.identifierPrefix), t.onUncaughtError !== void 0 && (s = t.onUncaughtError), t.onCaughtError !== void 0 && (d = t.onCaughtError), t.onRecoverableError !== void 0 && (S = t.onRecoverableError)), t = Ny(
      e,
      1,
      !1,
      null,
      null,
      n,
      l,
      null,
      s,
      d,
      S,
      Gy
    ), e[Ta] = t.current, Fh(e), new ag(t);
  }, Uf.hydrateRoot = function(e, t, n) {
    if (!T(e)) throw Error(y(299));
    var l = !1, s = "", d = Wr, S = sf, R = ff, B = null;
    return n != null && (n.unstable_strictMode === !0 && (l = !0), n.identifierPrefix !== void 0 && (s = n.identifierPrefix), n.onUncaughtError !== void 0 && (d = n.onUncaughtError), n.onCaughtError !== void 0 && (S = n.onCaughtError), n.onRecoverableError !== void 0 && (R = n.onRecoverableError), n.formState !== void 0 && (B = n.formState)), t = Ny(
      e,
      1,
      !0,
      t,
      n ?? null,
      l,
      s,
      B,
      d,
      S,
      R,
      Gy
    ), t.context = My(null), n = t.current, l = Ei(), l = kt(l), s = fl(l), s.callback = null, wl(n, s, l), n = l, t.current.lanes = n, Ql(t, n), jr(t), e[Ta] = t.current, Fh(e), new Rd(t);
  }, Uf.version = "19.2.6", Uf;
}
var $b;
function iE() {
  if ($b) return wg.exports;
  $b = 1;
  function a() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(a);
      } catch (o) {
        console.error(o);
      }
  }
  return a(), wg.exports = aE(), wg.exports;
}
var y0 = iE();
const rE = (a, o, f) => {
  y0.createRoot(f).render(Gt.createElement(a, o));
}, vh = ({ typeCarousel: a, targetSelector: o, props: f }) => {
  const y = {
    card: o0,
    testimonial: h0,
    image: s0,
    "image-gallery": d0
  }[a];
  y && rE(y, f, document.querySelector(o));
}, sE = ({ targetSelector: a, props: o }) => vh({
  typeCarousel: "card",
  targetSelector: a,
  props: o
}), fE = ({ targetSelector: a, props: o }) => {
  vh({
    typeCarousel: "testimonial",
    targetSelector: a,
    props: o
  });
}, dE = ({ targetSelector: a, props: o }) => {
  vh({ typeCarousel: "image", targetSelector: a, props: o });
}, hE = ({ targetSelector: a, props: o }) => {
  vh({
    typeCarousel: "image-gallery",
    targetSelector: a,
    props: o
  });
}, Kn = (a, o, f) => {
  y0.createRoot(f).render(Gt.createElement(a, o));
}, gE = ({ targetSelector: a, props: o }) => Kn(cm, o, document.querySelector(a)), vE = ({ targetSelector: a, props: o }) => Kn(Bm, o, document.querySelector(a)), yE = ({ targetSelector: a, props: o }) => Kn(Fm, o, document.querySelector(a)), bE = ({ targetSelector: a, props: o }) => Kn($c, o, document.querySelector(a)), mE = ({ targetSelector: a, props: o }) => Kn(av, o, document.querySelector(a)), TE = ({ targetSelector: a, props: o }) => Kn(iv, o, document.querySelector(a)), pE = ({ targetSelector: a, props: o }) => Kn(Iu, o, document.querySelector(a)), SE = ({ targetSelector: a, props: o }) => Kn(Qm, o, document.querySelector(a)), xE = ({ targetSelector: a, props: o }) => Kn(Wm, o, document.querySelector(a)), EE = ({ targetSelector: a, props: o }) => Kn(tE, o, document.querySelector(a)), wE = ({ targetSelector: a, props: o }) => Kn(Km, o, document.querySelector(a)), AE = ({ targetSelector: a, props: o }) => Kn(Ho, o, document.querySelector(a)), OE = ({ targetSelector: a, props: o }) => Kn(jm, o, document.querySelector(a)), CE = ({ targetSelector: a, props: o }) => Kn(rv, o, document.querySelector(a)), RE = ({ targetSelector: a, props: o }) => Kn(e0, o, document.querySelector(a)), _E = ({ targetSelector: a, props: o }) => Kn(uv, o, document.querySelector(a)), NE = ({ targetSelector: a, props: o }) => Kn(t0, o, document.querySelector(a)), ME = ({ targetSelector: a, props: o }) => Kn(US, o, document.querySelector(a)), zE = ({ targetSelector: a, props: o }) => Kn(SS, o, document.querySelector(a)), DE = ({ targetSelector: a, props: o }) => Kn(IS, o, document.querySelector(a)), kE = ({ targetSelector: a, props: o }) => Kn(qx, o, document.querySelector(a)), LE = ({ targetSelector: a, props: o }) => Kn(LS, o, document.querySelector(a));
export {
  cm as Accordion,
  Bm as AnchorMenu,
  Fm as Article,
  $c as Button,
  av as ButtonIconOnly,
  iv as ButtonTag,
  Iu as Card,
  Qm as CardArrangement,
  o0 as CardCarousel,
  Wm as ContentSpotlight,
  SS as Divider,
  pS as DividerType,
  MS as FeedBody,
  OS as FeedContainerProvider,
  AS as FeedContext,
  NS as FeedHeader,
  tE as GridLinks,
  Km as Hero,
  LS as HighlyRanked,
  Ho as Image,
  s0 as ImageCarousel,
  d0 as ImageGalleryCarousel,
  qx as List,
  qm as NavControls,
  jm as Pagination,
  rv as RankingCard,
  US as SystemAlert,
  HS as SystemAlertType,
  GS as Tab,
  $m as TabHeader,
  e0 as TabbedPanels,
  uv as Testimonial,
  h0 as TestimonialCarousel,
  IS as Tooltip,
  t0 as Video,
  oE as feedCardButtonShape,
  RS as feedComponentShape,
  Jm as feedCtaButtonShape,
  CS as feedDataSourceShape,
  Pm as feedHeaderShape,
  gE as initAccordion,
  vE as initAnchorMenu,
  yE as initArticle,
  bE as initButton,
  mE as initButtonIconOnly,
  TE as initButtonTag,
  pE as initCard,
  SE as initCardArrangement,
  sE as initCardCarousel,
  xE as initContentSpotlight,
  zE as initDivider,
  EE as initGridLinks,
  wE as initHero,
  LE as initHighlyRanked,
  AE as initImage,
  dE as initImageCarousel,
  hE as initImageGalleryCarousel,
  kE as initList,
  OE as initPagination,
  CE as initRankingCard,
  ME as initSystemAlert,
  RE as initTabbedPanels,
  _E as initTestimonial,
  fE as initTestimonialCarousel,
  DE as initTooltip,
  NE as initVideo
};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*! @license DOMPurify 3.4.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.5/LICENSE */
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/**
 * @license React
 * react-dom-server-legacy.browser.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license React
 * react-dom-server.browser.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*!
 * Glide.js v3.7.1
 * (c) 2013-2024 Jędrzej Chałubek (https://github.com/jedrzejchalubek/)
 * Released under the MIT License.
 */
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function() {
                var css = `@charset "UTF-8";.glide{position:relative;width:100%;box-sizing:border-box}.glide *{box-sizing:inherit}.glide__track{overflow:hidden}.glide__slides{position:relative;width:100%;list-style:none;backface-visibility:hidden;transform-style:preserve-3d;touch-action:pan-Y;overflow:hidden;margin:0;padding:0;white-space:nowrap;display:flex;flex-wrap:nowrap;will-change:transform}.glide__slides--dragging{-webkit-user-select:none;user-select:none}.glide__slide{width:100%;height:100%;flex-shrink:0;white-space:normal;-webkit-user-select:none;user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent}.glide__slide a{-webkit-user-select:none;user-select:none;-webkit-user-drag:none;-moz-user-select:none;-ms-user-select:none}.glide__arrows,.glide__bullets{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.glide--rtl{direction:rtl}@media only screen and (min-width:1260px){.container .aligned-carousel{margin-left:-124px!important}}.glide{display:flex;flex-direction:column;gap:32px;position:relative}[data-image-auto-size=true] .glide__slides .glide__slide{height:auto;position:relative;display:inline-flex;justify-content:center}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img{display:flex;width:100%;max-width:100%}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img img{flex-grow:1;object-fit:cover}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img img.uds-img{max-width:100%}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img figure.uds-figure{display:flex;justify-content:space-between;flex-direction:column}.glide .glide__track{position:relative}.glide .glide__track .glide__slides{margin-bottom:0;touch-action:auto}.glide .glide__track .glide__slides .glide__slide .card{width:100%}@media only screen and (min-width:576px){.glide[data-has-shadow=true] .glide__track.slider-start:after{background:linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide[data-has-shadow=true] .glide__track.slider-mid:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px),linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide[data-has-shadow=true] .glide__track.slider-end:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}}.glide__arrows{z-index:2;align-self:center}.glide__arrows .glide__arrow{color:#191919;width:4rem;height:4rem;margin:0 .5rem;background-color:#e8e8e8;border:1px solid #d0d0d0;border-radius:50%;font-size:1.3rem;text-shadow:0 .25em .5em rgba(0,0,0,.1);opacity:1;cursor:pointer;transition:opacity .15s ease,border .3s ease-in-out;line-height:1}.glide__arrows .glide__arrow.glide__arrow--disabled{color:#e8e8e8;background-color:#fafafa;border:1px solid #e8e8e8;opacity:1}.glide__arrows .glide__arrow:focus{outline:none}.glide__arrows .glide__arrow:hover{border-color:#fff}.glide__arrows .glide__arrow--left{left:2em}.glide__arrows .glide__arrow--right{right:2em}.glide__arrows .glide__arrow--disabled{opacity:.33}.glide__bullets{z-index:2;list-style:none;max-width:100%;display:flex;justify-content:center}.glide__bullet{transition:all .3s ease-in-out;background-color:#d0d0d0;width:1rem;height:1rem;padding:0;border-radius:50%;border:2px solid transparent;cursor:pointer;line-height:0;margin:.375rem}.glide__bullet:focus{outline:none}.glide__bullet:hover,.glide__bullet:focus{border:1px solid #d0d0d0;background-color:#191919}.glide__bullet--active{background-color:#191919}.glide.aligned-carousel{width:1448px;margin:auto}.glide.image-gallery{gap:0;overflow:hidden}.glide.image-gallery .glide__track{border:1px solid #d0d0d0}.glide.image-gallery .glide__track:after{content:none}.glide.image-gallery .glide__track .glide__slides li.glide__slide{display:list-item}.glide.image-gallery .glide__track .glide__slides{margin-bottom:0;height:100%}.glide.image-gallery .glide__track .glide__slides .glide__slide>div.uds-img{height:100%}.glide.image-gallery .glide__track .glide__slides .glide__slide>div.uds-img img{object-fit:cover;border:none}.glide.image-gallery .image-gallery-action-area{border:1px solid #d0d0d0;border-top:0}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .image-navigator{border-bottom:1px solid #d0d0d0}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .uds-caption-text{padding:1rem 0;display:inline-block}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .uds-caption-text>div{height:auto!important}.glide.image-gallery figcaption{padding:0 .75rem;font-size:.75rem}.glide.image-gallery figcaption h2{font-size:1.5rem;line-height:1.75rem;letter-spacing:-.0525rem}.glide.image-gallery .image-navigator{position:relative}.glide.image-gallery .image-navigator .image-navigator-images{min-height:64px;padding-top:1rem;padding-bottom:1rem;width:100%;margin:auto;overflow:hidden}.glide.image-gallery .image-navigator .image-navigator-images.slider-start:after{background:linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images.slider-mid:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px),linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images.slider-end:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider{position:relative;left:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets{position:relative}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container{position:relative;margin:0 .5rem;height:48px;border:0;padding:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container:first-child{margin-left:16rem}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container .bullet-image{flex-basis:auto;width:88px;height:100%;border-radius:0;border:0;z-index:2;object-fit:cover;margin:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container:focus{box-shadow:0 0 0 2px #fff,0 0 0 4px #191919!important}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .glide__bullet--active{background-color:transparent;border:5px solid #ffc627}.glide.image-gallery .image-navigator .glide__arrows{width:100%;display:flex;justify-content:space-between;align-items:center}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow{width:2.5rem;height:2.5rem;display:flex;align-items:center;justify-content:center;z-index:3;position:absolute;background-color:#fff}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow:hover{border-color:#d0d0d0}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow .arrow-icon{font-size:1rem}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow.glide__arrow--prev{left:0}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow.glide__arrow--next{right:0}@media only screen and (max-width:576px){.glide{gap:21px}.glide:not(.glide.image-gallery) .glide__bullets{display:none}.glide.image-gallery{width:100%;margin:auto!important}.glide.image-gallery .image-navigator .image-navigator-images .glide__arrows .glide__arrow{display:none}}@media only screen and (max-width:1260px){.glide.aligned-carousel{width:100%}}.glide--swipeable{cursor:grab;cursor:-moz-grab;cursor:-webkit-grab}.glide--dragging{cursor:grabbing;cursor:-moz-grabbing;cursor:-webkit-grabbing}.glide[data-remove-side-background=true]:after,.glide[data-remove-side-background=true]:before{content:none}.glide button:focus,.glide a:focus,.glide input:focus,.glide textarea:focus,.glide select:focus{outline:none!important;box-shadow:0 0 0 2px #fff,0 0 0 4px #191919!important}.glide.image-gallery,.glide.image-carousel{margin:auto}.glide.image-gallery[role=figure],.glide.image-gallery figure.uds-figure,.glide.image-carousel[role=figure],.glide.image-carousel figure.uds-figure{margin:0}.glide.image-gallery[role=figure] figcaption *,.glide.image-gallery[role=figure] .uds-caption-text,.glide.image-gallery figure.uds-figure figcaption *,.glide.image-gallery figure.uds-figure .uds-caption-text,.glide.image-carousel[role=figure] figcaption *,.glide.image-carousel[role=figure] .uds-caption-text,.glide.image-carousel figure.uds-figure figcaption *,.glide.image-carousel figure.uds-figure .uds-caption-text{color:#191919;max-width:100%}
`;
                var style = document.createElement('style');
                style.type = 'text/css';
                if (style.styleSheet) {
                  style.styleSheet.cssText = css;
                } else {
                  style.appendChild(document.createTextNode(css));
                }
                document.head.appendChild(style);
              })();